var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
* @license Xpo Logistics v${_cBuilderVersion}
 * Copyright (c) 2017 Xpo Logistics, Inc. http://www.http://xpo-1.com/
 * License: MIT
 */
import { ApplicationRef, Attribute, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, ContentChild, ContentChildren, Directive, ElementRef, EventEmitter, Host, HostBinding, HostListener, Inject, Injectable, InjectionToken, Injector, Input, NgModule, NgZone, Optional, Output, Pipe, Renderer, Renderer2, Self, SkipSelf, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation, forwardRef, isDevMode } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute, NavigationEnd, RouteConfigLoadEnd, Router, RouterModule } from '@angular/router';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import { Subject } from 'rxjs/Subject';
import { CommonModule, Location } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/auditTime';
import { DOCUMENT, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import 'rxjs/add/observable/of';
import { auditTime } from 'rxjs/operator/auditTime';
import { _catch } from 'rxjs/operator/catch';
import { debounceTime } from 'rxjs/operator/debounceTime';
import { delay } from 'rxjs/operator/delay';
import { _do } from 'rxjs/operator/do';
import { filter } from 'rxjs/operator/filter';
import { _finally } from 'rxjs/operator/finally';
import { first } from 'rxjs/operator/first';
import { map } from 'rxjs/operator/map';
import { share } from 'rxjs/operator/share';
import { startWith } from 'rxjs/operator/startWith';
import { switchMap } from 'rxjs/operator/switchMap';
import { takeUntil } from 'rxjs/operator/takeUntil';
import { FormGroupDirective, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgControl, NgForm, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import { HttpModule } from '@angular/http';
import 'rxjs/add/operator/switchMap';
import { animate, state, style, transition, trigger } from '@angular/animations';
import 'rxjs/add/operator/distinctUntilChanged';
import { merge } from 'rxjs/observable/merge';
import 'rxjs/add/operator/startWith';
var XpoConfigService = (function () {
    function XpoConfigService() {
        this.xpoCfgSrc = new ReplaySubject(1);
        this.xpoConfigCryer$ = this.xpoCfgSrc.asObservable();
    }
    /**
     * @param {?} xpoCfg
     * @return {?}
     */
    XpoConfigService.prototype.setXpoConfig = function (xpoCfg) {
        this.xpoCfgSrc.next(xpoCfg);
    };
    return XpoConfigService;
}());
XpoConfigService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
XpoConfigService.ctorParameters = function () { return []; };
var XpoPermissionService = (function () {
    function XpoPermissionService() {
        this.permissionSrc = new BehaviorSubject([]);
        this.permissions = this.permissionSrc.asObservable();
    }
    /**
     * @param {?} permissions
     * @return {?}
     */
    XpoPermissionService.prototype.setPermissions = function (permissions) {
        this.permissionSrc.next(permissions);
    };
    return XpoPermissionService;
}());
XpoPermissionService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
XpoPermissionService.ctorParameters = function () { return []; };
/**
 * Module that captures anything that should be loaded and/or run for *all* Angular Material
 * components. This includes Bidi, compatibility mode, etc.
 *
 * This module should be imported to each top-level component module (e.g., XpoTabsModule).
 */
var XpoCommonModule = (function () {
    function XpoCommonModule() {
    }
    return XpoCommonModule;
}());
XpoCommonModule.decorators = [
    { type: NgModule, args: [{},] },
];
/**
 * @nocollapse
 */
XpoCommonModule.ctorParameters = function () { return []; };
/**
 * Shared directive to count lines inside a text area, such as a list item.
 * Line elements can be extracted with a \@ContentChildren(XpoLine) query, then
 * counted by checking the query list's length.
 */
var XpoLine = (function () {
    function XpoLine() {
    }
    return XpoLine;
}());
XpoLine.decorators = [
    { type: Directive, args: [{
                selector: '[xpo-line]',
                host: {
                    '[class.xpo-line]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoLine.ctorParameters = function () { return []; };
/**
 * Helper that takes a query list of lines and sets the correct class on the host.
 * \@docs-private
 */
var XpoLineSetter = (function () {
    /**
     * @param {?} _lines
     * @param {?} _renderer
     * @param {?} _element
     */
    function XpoLineSetter(_lines, _renderer, _element) {
        var _this = this;
        this._lines = _lines;
        this._renderer = _renderer;
        this._element = _element;
        this._setLineClass(this._lines.length);
        this._lines.changes.subscribe(function () {
            _this._setLineClass(_this._lines.length);
        });
    }
    /**
     * @param {?} count
     * @return {?}
     */
    XpoLineSetter.prototype._setLineClass = function (count) {
        this._resetClasses();
        if (count === 2 || count === 3) {
            this._setClass("xpo-" + count + "-line", true);
        }
        else if (count > 3) {
            this._setClass("xpo-multi-line", true);
        }
    };
    /**
     * @return {?}
     */
    XpoLineSetter.prototype._resetClasses = function () {
        this._setClass('xpo-2-line', false);
        this._setClass('xpo-3-line', false);
        this._setClass('xpo-multi-line', false);
    };
    /**
     * @param {?} className
     * @param {?} isAdd
     * @return {?}
     */
    XpoLineSetter.prototype._setClass = function (className, isAdd) {
        if (isAdd) {
            this._renderer.addClass(this._element.nativeElement, className);
        }
        else {
            this._renderer.removeClass(this._element.nativeElement, className);
        }
    };
    return XpoLineSetter;
}());
var XpoLineModule = (function () {
    function XpoLineModule() {
    }
    return XpoLineModule;
}());
XpoLineModule.decorators = [
    { type: NgModule, args: [{
                imports: [XpoCommonModule],
                exports: [XpoLine, XpoCommonModule],
                declarations: [XpoLine],
            },] },
];
/**
 * @nocollapse
 */
XpoLineModule.ctorParameters = function () { return []; };
/**
 * Menu Entry
 */
var XpoMenuEntry = (function () {
    /**
     * @param {?} path
     * @param {?} title
     * @param {?} permissions
     * @param {?} menus
     * @param {?} children
     * @param {?=} target
     */
    function XpoMenuEntry(path, title, permissions, menus, children, target) {
        this.path = path;
        this.title = title;
        this.permissions = permissions;
        this.menus = menus;
        this.children = children;
        this.target = target;
        // for the scenario where we lazy-load a single page
        // if I only have a single child and that child has the exact same route as me
        // and that child has no children, I must be that child
        if (children !== null && children.length === 1 && path === children[0].path) {
            this.children = [];
            this.menus = menus.concat(children[0].menus.filter(function (item) {
                return menus.indexOf(item) < 0;
            }));
            this.permissions = permissions.concat(children[0].permissions.filter(function (item) {
                return permissions.indexOf(item) < 0;
            }));
            this.title = title || children[0].title;
            this.target = target || children[0].target;
        }
    }
    Object.defineProperty(XpoMenuEntry.prototype, "loading", {
        /**
         * @return {?}
         */
        get: function () {
            return this.children === null;
        },
        enumerable: true,
        configurable: true
    });
    return XpoMenuEntry;
}());
var XpoMenuResolver = (function () {
    /**
     * @param {?} router
     */
    function XpoMenuResolver(router) {
        var _this = this;
        this.router = router;
        this.menuObject = [];
        this.menuObject = XpoMenuResolver.parseRouteConfig(this.router.config);
        this.menuSubject = new BehaviorSubject(this.menuObject);
        // TODO: Add unsubscribe
        this.subscriptions.push(router.events
            .filter(function (e) { return e instanceof RouteConfigLoadEnd; })
            .map(function (e) { return e.route; })
            .subscribe(function (r) { return _this.onRouteConfigLoaded(r); }));
    }
    /**
     * @param {?} route
     * @param {?=} parentPath
     * @return {?}
     */
    XpoMenuResolver.constructMenuEntry = function (route, parentPath) {
        if (parentPath === void 0) { parentPath = ''; }
        var /** @type {?} */ routeData = route.data || {};
        var /** @type {?} */ fullPath = parentPath + route.path;
        var /** @type {?} */ routesToParse;
        if (route.loadChildren) {
            // cast to any, so we can access the private member
            var /** @type {?} */ anyRoute = route;
            if (anyRoute['_loadedConfig']) {
                routesToParse = (anyRoute['_loadedConfig']['routes']);
            }
        }
        else {
            routesToParse = route.children || [];
        }
        var /** @type {?} */ children = routesToParse
            ? XpoMenuResolver.parseRouteConfig(routesToParse, fullPath + '/')
            : null;
        return new XpoMenuEntry(fullPath, routeData['title'] ? routeData['title'] : null, routeData['permissions'] ? routeData['permissions'] : [], routeData['menus'] ? routeData['menus'] : [], children);
    };
    /**
     * @param {?} config
     * @param {?=} parentPath
     * @return {?}
     */
    XpoMenuResolver.parseRouteConfig = function (config, parentPath) {
        if (parentPath === void 0) { parentPath = ''; }
        return config.map(function (r) { return XpoMenuResolver.constructMenuEntry(r, parentPath); });
    };
    Object.defineProperty(XpoMenuResolver.prototype, "menu", {
        /**
         * @return {?}
         */
        get: function () {
            return this.menuSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoMenuResolver.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (x) { return x.unsubscribe(); });
    };
    /**
     * @param {?} route
     * @return {?}
     */
    XpoMenuResolver.prototype.onRouteConfigLoaded = function (route) {
        var _this = this;
        // HACK: listen for lazy-loaded events, and load data
        // we need the setTimeout because RouteConfigLoadEnd loads before parsing
        // need to keep an eye on https://github.com/angular/angular/issues/16282
        Observable.interval(100)
            .first()
            .subscribe(function (r) {
            // TODO: figure out how to support multiple levels of lazy loaded routes
            for (var /** @type {?} */ i = 0; i < _this.menuObject.length; ++i) {
                if (_this.menuObject[i].path === route.path) {
                    var /** @type {?} */ m = XpoMenuResolver.constructMenuEntry(route);
                    _this.menuObject[i] = m;
                    break;
                }
            }
            _this.menuSubject.next(_this.menuObject);
        });
    };
    return XpoMenuResolver;
}());
var XpoMenuingModule = (function () {
    function XpoMenuingModule() {
    }
    return XpoMenuingModule;
}());
XpoMenuingModule.decorators = [
    { type: NgModule, args: [{
                imports: [RouterModule],
                exports: [],
                declarations: [],
            },] },
];
/**
 * @nocollapse
 */
XpoMenuingModule.ctorParameters = function () { return []; };
/**
 * Factory that creates a new MutationObserver and allows us to stub it out in unit tests.
 * \@docs-private
 */
var XpoMutationObserverFactory = (function () {
    function XpoMutationObserverFactory() {
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    XpoMutationObserverFactory.prototype.create = function (callback) {
        return new MutationObserver(callback);
    };
    return XpoMutationObserverFactory;
}());
XpoMutationObserverFactory.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
XpoMutationObserverFactory.ctorParameters = function () { return []; };
/**
 * Directive that triggers a callback whenever the content of
 * its associated element has changed.
 */
var ObserveContent = (function () {
    /**
     * @param {?} _mutationObserverFactory
     * @param {?} _elementRef
     */
    function ObserveContent(_mutationObserverFactory, _elementRef) {
        this._mutationObserverFactory = _mutationObserverFactory;
        this._elementRef = _elementRef;
        /**
         * Event emitted for each change in the element's content.
         */
        this.event = new EventEmitter();
        /**
         * Used for debouncing the emitted values to the observeContent event.
         */
        this._debouncer = new Subject();
    }
    /**
     * @return {?}
     */
    ObserveContent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (this.debounce > 0) {
            this._debouncer
                .debounceTime(this.debounce)
                .subscribe(function (mutations) { return _this.event.emit(mutations); });
        }
        else {
            this._debouncer.subscribe(function (mutations) { return _this.event.emit(mutations); });
        }
        this._observer = this._mutationObserverFactory.create(function (mutations) {
            _this._debouncer.next(mutations);
        });
        this._observer.observe(this._elementRef.nativeElement, {
            characterData: true,
            childList: true,
            subtree: true,
        });
    };
    /**
     * @return {?}
     */
    ObserveContent.prototype.ngOnDestroy = function () {
        if (this._observer) {
            this._observer.disconnect();
            this._debouncer.complete();
            this._debouncer = this._observer = null;
        }
    };
    return ObserveContent;
}());
ObserveContent.decorators = [
    { type: Directive, args: [{
                selector: '[cdkObserveContent]',
            },] },
];
/**
 * @nocollapse
 */
ObserveContent.ctorParameters = function () { return [
    { type: XpoMutationObserverFactory, },
    { type: ElementRef, },
]; };
ObserveContent.propDecorators = {
    'event': [{ type: Output, args: ['cdkObserveContent',] },],
    'debounce': [{ type: Input },],
};
var ObserveContentModule = (function () {
    function ObserveContentModule() {
    }
    return ObserveContentModule;
}());
ObserveContentModule.decorators = [
    { type: NgModule, args: [{
                exports: [ObserveContent],
                declarations: [ObserveContent],
                providers: [XpoMutationObserverFactory],
            },] },
];
/**
 * @nocollapse
 */
ObserveContentModule.ctorParameters = function () { return []; };
/**
 * Component that shows a simplified checkbox without including any kind of "real" checkbox.
 * Meant to be used when the checkbox is purely decorative and a large number of them will be
 * included, such as for the options in a multi-select. Uses no SVGs or complex animations.
 *
 * Note that this component will be completely invisible to screen-reader users. This is *not*
 * interchangeable with <xpo-checkbox> and should *not* be used if the user would directly interact
 * with the checkbox. The pseudo-checkbox should only be used as an implementation detail of
 * more complex components that appropriately handle selected / checked state.
 * \@docs-private
 */
var XpoPseudoCheckbox = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function XpoPseudoCheckbox(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /**
         * Display state of the checkbox.
         */
        this.state = 'unchecked';
        /**
         * Whether the checkbox is disabled.
         */
        this.disabled = false;
        this.color = 'accent';
    }
    Object.defineProperty(XpoPseudoCheckbox.prototype, "color", {
        /**
         * Color of the checkbox.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
                this._renderer.removeClass(nativeElement, "xpo-" + this.color);
                this._renderer.addClass(nativeElement, "xpo-" + value);
                this._color = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    return XpoPseudoCheckbox;
}());
XpoPseudoCheckbox.decorators = [
    { type: Component, args: [{ encapsulation: ViewEncapsulation.None,
                selector: 'xpo-pseudo-checkbox',
                styles: [".xpo-pseudo-checkbox{border-radius:2px;cursor:pointer;display:inline-block;vertical-align:middle;box-sizing:border-box;position:relative;transition:.xpo-pseudo-checkbox}.xpo-pseudo-checkbox ::after{position:absolute;opacity:0;content:''}.xpo-pseudo-checkbox.xpo-pseudo-checkbox-checked,.xpo-pseudo-checkbox.xpo-pseudo-checkbox-indeterminate{border:none}.xpo-pseudo-checkbox-disabled{cursor:default}.xpo-pseudo-checkbox-indeterminate::after{opacity:1}.xpo-pseudo-checkbox-checked::after{transform:rotate(-45deg);opacity:1} /*# sourceMappingURL=pseudo-checkbox.css.map */ "],
                template: '',
                host: {
                    '[class.xpo-pseudo-checkbox]': 'true',
                    '[class.xpo-pseudo-checkbox-indeterminate]': 'state === "indeterminate"',
                    '[class.xpo-pseudo-checkbox-checked]': 'state === "checked"',
                    '[class.xpo-pseudo-checkbox-disabled]': 'disabled',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoPseudoCheckbox.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
XpoPseudoCheckbox.propDecorators = {
    'state': [{ type: Input },],
    'disabled': [{ type: Input },],
    'color': [{ type: Input },],
};
var XpoSelectionModule = (function () {
    function XpoSelectionModule() {
    }
    return XpoSelectionModule;
}());
XpoSelectionModule.decorators = [
    { type: NgModule, args: [{
                exports: [XpoPseudoCheckbox],
                declarations: [XpoPseudoCheckbox],
            },] },
];
/**
 * @nocollapse
 */
XpoSelectionModule.ctorParameters = function () { return []; };
/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
/**
 * Mixin to augment a directive with a `disabled` property.
 * @template T
 * @param {?} base
 * @return {?}
 */
function mixinDisabled(base) {
    return (function (_super) {
        __extends(class_1, _super);
        /**
         * @param {...?} args
         */
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, args) || this;
            _this._disabled = false;
            return _this;
        }
        Object.defineProperty(class_1.prototype, "disabled", {
            /**
             * @return {?}
             */
            get: function () { return this._disabled; },
            /**
             * @param {?} value
             * @return {?}
             */
            set: function (value) { this._disabled = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
        return class_1;
    }(base));
}
/**
 * \@docs-private
 */
var XpoOptgroupBase = (function () {
    function XpoOptgroupBase() {
    }
    return XpoOptgroupBase;
}());
var _XpoOptgroupMixinBase = mixinDisabled(XpoOptgroupBase);
// Counter for unique group ids.
var _uniqueOptgroupIdCounter = 0;
/**
 * Component that is used to group instances of `xpo-option`.
 */
var XpoOptgroup = (function (_super) {
    __extends(XpoOptgroup, _super);
    function XpoOptgroup() {
        var _this = _super.apply(this, arguments) || this;
        /**
         * Unique id for the underlying label.
         */
        _this._labelId = "xpo-optgroup-label-" + _uniqueOptgroupIdCounter++;
        return _this;
    }
    return XpoOptgroup;
}(_XpoOptgroupMixinBase));
XpoOptgroup.decorators = [
    { type: Component, args: [{ selector: 'xpo-optgroup',
                template: "<label class=\"xpo-optgroup-label\" [id]=\"_labelId\">{{ label }}</label> <ng-content select=\"xpo-option\"></ng-content> ",
                inputs: ['disabled'],
                host: {
                    'class': 'xpo-optgroup',
                    'role': 'group',
                    '[class.xpo-optgroup-disabled]': 'disabled',
                    '[attr.aria-disabled]': 'disabled.toString()',
                    '[attr.aria-labelledby]': '_labelId',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoOptgroup.ctorParameters = function () { return []; };
XpoOptgroup.propDecorators = {
    'label': [{ type: Input },],
};
// Due to a bug in the ChromeDriver, Angular keyboard events are not triggered by `sendKeys`
// during E2E tests when using dot notation such as `(keydown.rightArrow)`. To get around this,
// we are temporarily using a single (keydown) handler.
// See: https://github.com/angular/angular/issues/9419
var UP_ARROW = 38;
var DOWN_ARROW = 40;
var RIGHT_ARROW = 39;
var LEFT_ARROW = 37;
var PAGE_UP = 33;
var PAGE_DOWN = 34;
var HOME = 36;
var END = 35;
var ENTER = 13;
var SPACE = 32;
var TAB = 9;
var ESCAPE = 27;
var BACKSPACE = 8;
var DELETE = 46;
/* tslint:disable */
/**
 * Option IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
var _uniqueIdCounter = 0;
/**
 * Event object emitted by XpoOption when selected or deselected.
 */
var XpoOptionSelectionChange = (function () {
    /**
     * @param {?} source
     * @param {?=} isUserInput
     */
    function XpoOptionSelectionChange(source, isUserInput) {
        if (isUserInput === void 0) { isUserInput = false; }
        this.source = source;
        this.isUserInput = isUserInput;
    }
    return XpoOptionSelectionChange;
}());
/**
 * Single option inside of a `<xpo-select>` element.
 */
var XpoOption = (function () {
    /**
     * @param {?} _element
     * @param {?} group
     */
    function XpoOption(_element, group) {
        this._element = _element;
        this.group = group;
        this._selected = false;
        this._active = false;
        /**
         * Whether the option is disabled.
         */
        this._disabled = false;
        this._id = "xpo-option-" + _uniqueIdCounter++;
        /**
         * Whether the wrapping component is in multiple selection mode.
         */
        this.multiple = false;
        /**
         * Event emitted when the option is selected or deselected.
         */
        this.onSelectionChange = new EventEmitter();
    }
    Object.defineProperty(XpoOption.prototype, "id", {
        /**
         * The unique ID of the option.
         * @return {?}
         */
        get: function () { return this._id; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoOption.prototype, "selected", {
        /**
         * Whether or not the option is currently selected.
         * @return {?}
         */
        get: function () { return this._selected; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoOption.prototype, "disabled", {
        /**
         * Whether the option is disabled.
         * @return {?}
         */
        get: function () { return (this.group && this.group.disabled) || this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoOption.prototype, "active", {
        /**
         * Whether or not the option is currently active and ready to be selected.
         * An active option displays styles as if it is focused, but the
         * focus is actually retained somewhere else. This comes in handy
         * for components like autocomplete where focus must remain on the input.
         * @return {?}
         */
        get: function () {
            return this._active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoOption.prototype, "viewValue", {
        /**
         * The displayed value of the option. It is necessary to show the selected option in the
         * select's trigger.
         * @return {?}
         */
        get: function () {
            // TODO(kara): Add input property alternative for node envs.
            return (this._getHostElement().textContent || '').trim();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects the option.
     * @return {?}
     */
    XpoOption.prototype.select = function () {
        this._selected = true;
        this._emitSelectionChangeEvent();
    };
    /**
     * Deselects the option.
     * @return {?}
     */
    XpoOption.prototype.deselect = function () {
        this._selected = false;
        this._emitSelectionChangeEvent();
    };
    /**
     * Sets focus onto this option.
     * @return {?}
     */
    XpoOption.prototype.focus = function () {
        this._getHostElement().focus();
    };
    /**
     * This method sets display styles on the option to make it appear
     * active. This is used by the ActiveDescendantKeyManager so key
     * events will display the proper options as active on arrow key events.
     * @return {?}
     */
    XpoOption.prototype.setActiveStyles = function () {
        this._active = true;
    };
    /**
     * This method removes display styles on the option that made it appear
     * active. This is used by the ActiveDescendantKeyManager so key
     * events will display the proper options as active on arrow key events.
     * @return {?}
     */
    XpoOption.prototype.setInactiveStyles = function () {
        this._active = false;
    };
    /**
     * Ensures the option is selected when activated from the keyboard.
     * @param {?} event
     * @return {?}
     */
    XpoOption.prototype._handleKeydown = function (event) {
        if (event.keyCode === ENTER || event.keyCode === SPACE) {
            this._selectViaInteraction();
            // Prevent the page from scrolling down and form submits.
            event.preventDefault();
        }
    };
    /**
     * Selects the option while indicating the selection came from the user. Used to
     * determine if the select's view -> model callback should be invoked.
     * @return {?}
     */
    XpoOption.prototype._selectViaInteraction = function () {
        if (!this.disabled) {
            this._selected = this.multiple ? !this._selected : true;
            this._emitSelectionChangeEvent(true);
        }
    };
    /**
     * Returns the correct tabindex for the option depending on disabled state.
     * @return {?}
     */
    XpoOption.prototype._getTabIndex = function () {
        return this.disabled ? '-1' : '0';
    };
    /**
     * Fetches the host DOM element.
     * @return {?}
     */
    XpoOption.prototype._getHostElement = function () {
        return this._element.nativeElement;
    };
    /**
     * Emits the selection change event.
     * @param {?=} isUserInput
     * @return {?}
     */
    XpoOption.prototype._emitSelectionChangeEvent = function (isUserInput) {
        if (isUserInput === void 0) { isUserInput = false; }
        this.onSelectionChange.emit(new XpoOptionSelectionChange(this, isUserInput));
    };
    return XpoOption;
}());
XpoOption.decorators = [
    { type: Component, args: [{ selector: 'xpo-option',
                host: {
                    'role': 'option',
                    '[attr.tabindex]': '_getTabIndex()',
                    '[class.xpo-selected]': 'selected',
                    '[class.xpo-option-multiple]': 'multiple',
                    '[class.xpo-active]': 'active',
                    '[id]': 'id',
                    '[attr.aria-selected]': 'selected.toString()',
                    '[attr.aria-disabled]': 'disabled.toString()',
                    '[class.xpo-option-disabled]': 'disabled',
                    '(click)': '_selectViaInteraction()',
                    '(keydown)': '_handleKeydown($event)',
                    'class': 'xpo-option',
                },
                template: "<span *ngIf=\"multiple\"> <xpo-pseudo-checkbox  class=\"xpo-option-pseudo-checkbox\"  [state]=\"selected ? 'checked' : ''\"  color=\"primary\"> </xpo-pseudo-checkbox> </span> <ng-content></ng-content>",
                styles: [":host{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;height:34px;padding:0 16px;line-height:34px;text-align:left;text-decoration:none;position:relative;outline:0;cursor:pointer;background-color:#fff;transition:background-color .15s}:host[disabled]{cursor:default}[dir=rtl] :host{text-align:right}:host .xpo-icon{margin-right:16px}[dir=rtl] :host .xpo-icon{margin-right:0;margin-left:16px}:host[aria-disabled=true]{cursor:default}.xpo-optgroup :host:not(.xpo-option-multiple){padding-left:32px}[dir=rtl] .xpo-optgroup :host:not(.xpo-option-multiple){padding-right:32px;padding-left:16px}:host.xpo-active,:host.xpo-selected,:host:focus,:host:hover{background-color:#eee}.xpo-option-pseudo-checkbox{margin-right:8px}[dir=rtl] .xpo-option-pseudo-checkbox{margin-right:0;margin-left:8px}:host-context(.xpo-external){font-size:1rem;border-top:1px solid #dfdfdf}:host-context(.xpo-external):first-child{border-top:none} /*# sourceMappingURL=option.css.map */ "],
            },] },
];
/**
 * @nocollapse
 */
XpoOption.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: XpoOptgroup, decorators: [{ type: Optional },] },
]; };
XpoOption.propDecorators = {
    'value': [{ type: Input },],
    'disabled': [{ type: Input },],
    'onSelectionChange': [{ type: Output },],
};
var XpoOptionModule = (function () {
    function XpoOptionModule() {
    }
    return XpoOptionModule;
}());
XpoOptionModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, XpoSelectionModule],
                exports: [XpoOption, XpoOptgroup],
                declarations: [XpoOption, XpoOptgroup],
            },] },
];
/**
 * @nocollapse
 */
XpoOptionModule.ctorParameters = function () { return []; };
/**
 * Throws an exception when attempting to attach a null portal to a host.
 * \@docs-private
 * @return {?}
 */
function throwNullPortalError() {
    throw new Error('Must provide a portal to attach');
}
/**
 * Throws an exception when attempting to attach a portal to a host that is already attached.
 * \@docs-private
 * @return {?}
 */
function throwPortalAlreadyAttachedError() {
    throw new Error('Host already has a portal attached');
}
/**
 * Throws an exception when attempting to attach a portal to an already-disposed host.
 * \@docs-private
 * @return {?}
 */
function throwPortalHostAlreadyDisposedError() {
    throw new Error('This PortalHost has already been disposed');
}
/**
 * Throws an exception when attempting to attach an unknown portal type.
 * \@docs-private
 * @return {?}
 */
function throwUnknownPortalTypeError() {
    throw new Error('Attempting to attach an unknown Portal type. BasePortalHost accepts either' +
        'a ComponentPortal or a TemplatePortal.');
}
/**
 * Throws an exception when attempting to attach a portal to a null host.
 * \@docs-private
 * @return {?}
 */
function throwNullPortalHostError() {
    throw new Error('Attempting to attach a portal to a null PortalHost');
}
/**
 * Throws an exception when attempting to detach a portal that is not attached.
 * \@docs-privatew
 * @return {?}
 */
function throwNoPortalAttachedError() {
    throw new Error('Attempting to detach a portal that is not attached to a host');
}
/**
 * A `Portal` is something that you want to render somewhere else.
 * It can be attach to / detached from a `PortalHost`.
 * @abstract
 */
var Portal = (function () {
    function Portal() {
    }
    /**
     * Attach this portal to a host.
     * @param {?} host
     * @return {?}
     */
    Portal.prototype.attach = function (host) {
        if (host == null) {
            throwNullPortalHostError();
        }
        if (host.hasAttached()) {
            throwPortalAlreadyAttachedError();
        }
        this._attachedHost = host;
        return (host.attach(this));
    };
    /**
     * Detach this portal from its host
     * @return {?}
     */
    Portal.prototype.detach = function () {
        var /** @type {?} */ host = this._attachedHost;
        if (host == null) {
            throwNoPortalAttachedError();
        }
        this._attachedHost = null;
        return host.detach();
    };
    Object.defineProperty(Portal.prototype, "isAttached", {
        /**
         * Whether this portal is attached to a host.
         * @return {?}
         */
        get: function () {
            return this._attachedHost != null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the PortalHost reference without performing `attach()`. This is used directly by
     * the PortalHost when it is performing an `attach()` or `detach()`.
     * @param {?} host
     * @return {?}
     */
    Portal.prototype.setAttachedHost = function (host) {
        this._attachedHost = host;
    };
    return Portal;
}());
/**
 * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
 */
var ComponentPortal = (function (_super) {
    __extends(ComponentPortal, _super);
    /**
     * @param {?} component
     * @param {?=} viewContainerRef
     * @param {?=} injector
     */
    function ComponentPortal(component, viewContainerRef, injector) {
        if (viewContainerRef === void 0) { viewContainerRef = null; }
        if (injector === void 0) { injector = null; }
        var _this = _super.call(this) || this;
        _this.component = component;
        _this.viewContainerRef = viewContainerRef;
        _this.injector = injector;
        return _this;
    }
    return ComponentPortal;
}(Portal));
/**
 * A `TemplatePortal` is a portal that represents some embedded template (TemplateRef).
 */
var TemplatePortal = (function (_super) {
    __extends(TemplatePortal, _super);
    /**
     * @param {?} template
     * @param {?} viewContainerRef
     */
    function TemplatePortal(template, viewContainerRef) {
        var _this = _super.call(this) || this;
        /**
         * Additional locals for the instantiated embedded view.
         * These locals can be seen as "exports" for the template, such as how ngFor has
         * index / event / odd.
         * See https://angular.io/docs/ts/latest/api/core/EmbeddedViewRef-class.html
         */
        _this.locals = new Map();
        _this.templateRef = template;
        _this.viewContainerRef = viewContainerRef;
        return _this;
    }
    Object.defineProperty(TemplatePortal.prototype, "origin", {
        /**
         * @return {?}
         */
        get: function () {
            return this.templateRef.elementRef;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} host
     * @param {?=} locals
     * @return {?}
     */
    TemplatePortal.prototype.attach = function (host, locals) {
        this.locals = locals == null ? new Map() : locals;
        return _super.prototype.attach.call(this, host);
    };
    /**
     * @return {?}
     */
    TemplatePortal.prototype.detach = function () {
        this.locals = new Map();
        return _super.prototype.detach.call(this);
    };
    return TemplatePortal;
}(Portal));
/**
 * Partial implementation of PortalHost that only deals with attaching either a
 * ComponentPortal or a TemplatePortal.
 * @abstract
 */
var BasePortalHost = (function () {
    function BasePortalHost() {
        /**
         * Whether this host has already been permanently disposed.
         */
        this._isDisposed = false;
    }
    /**
     * Whether this host has an attached portal.
     * @return {?}
     */
    BasePortalHost.prototype.hasAttached = function () {
        return !!this._attachedPortal;
    };
    /**
     * @param {?} portal
     * @return {?}
     */
    BasePortalHost.prototype.attach = function (portal) {
        if (!portal) {
            throwNullPortalError();
        }
        if (this.hasAttached()) {
            throwPortalAlreadyAttachedError();
        }
        if (this._isDisposed) {
            throwPortalHostAlreadyDisposedError();
        }
        if (portal instanceof ComponentPortal) {
            this._attachedPortal = portal;
            return this.attachComponentPortal(portal);
        }
        else if (portal instanceof TemplatePortal) {
            this._attachedPortal = portal;
            return this.attachTemplatePortal(portal);
        }
        throwUnknownPortalTypeError();
    };
    /**
     * @abstract
     * @template T
     * @param {?} portal
     * @return {?}
     */
    BasePortalHost.prototype.attachComponentPortal = function (portal) { };
    /**
     * @abstract
     * @param {?} portal
     * @return {?}
     */
    BasePortalHost.prototype.attachTemplatePortal = function (portal) { };
    /**
     * @return {?}
     */
    BasePortalHost.prototype.detach = function () {
        if (this._attachedPortal) {
            this._attachedPortal.setAttachedHost(null);
            this._attachedPortal = null;
        }
        this._invokeDisposeFn();
    };
    /**
     * @return {?}
     */
    BasePortalHost.prototype.dispose = function () {
        if (this.hasAttached()) {
            this.detach();
        }
        this._invokeDisposeFn();
        this._isDisposed = true;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BasePortalHost.prototype.setDisposeFn = function (fn) {
        this._disposeFn = fn;
    };
    /**
     * @return {?}
     */
    BasePortalHost.prototype._invokeDisposeFn = function () {
        if (this._disposeFn) {
            this._disposeFn();
            this._disposeFn = null;
        }
    };
    return BasePortalHost;
}());
/**
 * Directive version of a `TemplatePortal`. Because the directive *is* a TemplatePortal,
 * the directive instance itself can be attached to a host, enabling declarative use of portals.
 *
 * Usage:
 * <ng-template portal #greeting>
 *   <p> Hello {{name}} </p>
 * </ng-template>
 */
var TemplatePortalDirective = (function (_super) {
    __extends(TemplatePortalDirective, _super);
    /**
     * @param {?} templateRef
     * @param {?} viewContainerRef
     */
    function TemplatePortalDirective(templateRef, viewContainerRef) {
        return _super.call(this, templateRef, viewContainerRef) || this;
    }
    return TemplatePortalDirective;
}(TemplatePortal));
TemplatePortalDirective.decorators = [
    { type: Directive, args: [{
                selector: '[cdk-portal], [cdkPortal], [portal]',
                exportAs: 'cdkPortal',
            },] },
];
/**
 * @nocollapse
 */
TemplatePortalDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
    { type: ViewContainerRef, },
]; };
/**
 * Directive version of a PortalHost. Because the directive *is* a PortalHost, portals can be
 * directly attached to it, enabling declarative use.
 *
 * Usage:
 * <ng-template [cdkPortalHost]="greeting"></ng-template>
 */
var PortalHostDirective = (function (_super) {
    __extends(PortalHostDirective, _super);
    /**
     * @param {?} _componentFactoryResolver
     * @param {?} _viewContainerRef
     */
    function PortalHostDirective(_componentFactoryResolver, _viewContainerRef) {
        var _this = _super.call(this) || this;
        _this._componentFactoryResolver = _componentFactoryResolver;
        _this._viewContainerRef = _viewContainerRef;
        return _this;
    }
    Object.defineProperty(PortalHostDirective.prototype, "_deprecatedPortal", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.portal; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.portal = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortalHostDirective.prototype, "portal", {
        /**
         * Portal associated with the Portal host.
         * @return {?}
         */
        get: function () {
            return this._portal;
        },
        /**
         * @param {?} portal
         * @return {?}
         */
        set: function (portal) {
            if (this.hasAttached()) {
                _super.prototype.detach.call(this);
            }
            if (portal) {
                _super.prototype.attach.call(this, portal);
            }
            this._portal = portal;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PortalHostDirective.prototype.ngOnDestroy = function () {
        _super.prototype.dispose.call(this);
        this._portal = null;
    };
    /**
     * Attach the given ComponentPortal to this PortalHost using the ComponentFactoryResolver.
     *
     * @template T
     * @param {?} portal Portal to be attached to the portal host.
     * @return {?}
     */
    PortalHostDirective.prototype.attachComponentPortal = function (portal) {
        portal.setAttachedHost(this);
        // If the portal specifies an origin, use that as the logical location of the component
        // in the application tree. Otherwise use the location of this PortalHost.
        var /** @type {?} */ viewContainerRef = portal.viewContainerRef != null ?
            portal.viewContainerRef :
            this._viewContainerRef;
        var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
        var /** @type {?} */ ref = viewContainerRef.createComponent(componentFactory, viewContainerRef.length, portal.injector || viewContainerRef.parentInjector);
        _super.prototype.setDisposeFn.call(this, function () { return ref.destroy(); });
        this._portal = portal;
        return ref;
    };
    /**
     * Attach the given TemplatePortal to this PortlHost as an embedded View.
     * @param {?} portal Portal to be attached.
     * @return {?}
     */
    PortalHostDirective.prototype.attachTemplatePortal = function (portal) {
        var _this = this;
        portal.setAttachedHost(this);
        this._viewContainerRef.createEmbeddedView(portal.templateRef);
        _super.prototype.setDisposeFn.call(this, function () { return _this._viewContainerRef.clear(); });
        this._portal = portal;
        // TODO(jelbourn): return locals from view
        return new Map();
    };
    return PortalHostDirective;
}(BasePortalHost));
PortalHostDirective.decorators = [
    { type: Directive, args: [{
                selector: '[cdkPortalHost], [portalHost]',
                inputs: ['portal: cdkPortalHost'],
            },] },
];
/**
 * @nocollapse
 */
PortalHostDirective.ctorParameters = function () { return [
    { type: ComponentFactoryResolver, },
    { type: ViewContainerRef, },
]; };
PortalHostDirective.propDecorators = {
    '_deprecatedPortal': [{ type: Input, args: ['portalHost',] },],
};
var PortalModule = (function () {
    function PortalModule() {
    }
    return PortalModule;
}());
PortalModule.decorators = [
    { type: NgModule, args: [{
                exports: [TemplatePortalDirective, PortalHostDirective],
                declarations: [TemplatePortalDirective, PortalHostDirective],
            },] },
];
/**
 * @nocollapse
 */
PortalModule.ctorParameters = function () { return []; };
/**
 * A PortalHost for attaching portals to an arbitrary DOM element outside of the Angular
 * application context.
 *
 * This is the only part of the portal core that directly touches the DOM.
 */
var DomPortalHost = (function (_super) {
    __extends(DomPortalHost, _super);
    /**
     * @param {?} _hostDomElement
     * @param {?} _componentFactoryResolver
     * @param {?} _appRef
     * @param {?} _defaultInjector
     */
    function DomPortalHost(_hostDomElement, _componentFactoryResolver, _appRef, _defaultInjector) {
        var _this = _super.call(this) || this;
        _this._hostDomElement = _hostDomElement;
        _this._componentFactoryResolver = _componentFactoryResolver;
        _this._appRef = _appRef;
        _this._defaultInjector = _defaultInjector;
        return _this;
    }
    /**
     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
     * @template T
     * @param {?} portal Portal to be attached
     * @return {?}
     */
    DomPortalHost.prototype.attachComponentPortal = function (portal) {
        var _this = this;
        var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
        var /** @type {?} */ componentRef;
        // If the portal specifies a ViewContainerRef, we will use that as the attachment point
        // for the component (in terms of Angular's component tree, not rendering).
        // When the ViewContainerRef is missing, we use the factory to create the component directly
        // and then manually attach the view to the application.
        if (portal.viewContainerRef) {
            componentRef = portal.viewContainerRef.createComponent(componentFactory, portal.viewContainerRef.length, portal.injector || portal.viewContainerRef.parentInjector);
            this.setDisposeFn(function () { return componentRef.destroy(); });
        }
        else {
            componentRef = componentFactory.create(portal.injector || this._defaultInjector);
            this._appRef.attachView(componentRef.hostView);
            this.setDisposeFn(function () {
                _this._appRef.detachView(componentRef.hostView);
                componentRef.destroy();
            });
        }
        // At this point the component has been instantiated, so we move it to the location in the DOM
        // where we want it to be rendered.
        this._hostDomElement.appendChild(this._getComponentRootNode(componentRef));
        return componentRef;
    };
    /**
     * Attaches a template portal to the DOM as an embedded view.
     * @param {?} portal Portal to be attached.
     * @return {?}
     */
    DomPortalHost.prototype.attachTemplatePortal = function (portal) {
        var _this = this;
        var /** @type {?} */ viewContainer = portal.viewContainerRef;
        var /** @type {?} */ viewRef = viewContainer.createEmbeddedView(portal.templateRef);
        viewRef.detectChanges();
        // The method `createEmbeddedView` will add the view as a child of the viewContainer.
        // But for the DomPortalHost the view can be added everywhere in the DOM (e.g Overlay Container)
        // To move the view to the specified host element. We just re-append the existing root nodes.
        viewRef.rootNodes.forEach(function (rootNode) { return _this._hostDomElement.appendChild(rootNode); });
        this.setDisposeFn((function () {
            var /** @type {?} */ index = viewContainer.indexOf(viewRef);
            if (index !== -1) {
                viewContainer.remove(index);
            }
        }));
        // TODO(jelbourn): Return locals from view.
        return new Map();
    };
    /**
     * Clears out a portal from the DOM.
     * @return {?}
     */
    DomPortalHost.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        if (this._hostDomElement.parentNode != null) {
            this._hostDomElement.parentNode.removeChild(this._hostDomElement);
        }
    };
    /**
     * Gets the root HTMLElement for an instantiated component.
     * @param {?} componentRef
     * @return {?}
     */
    DomPortalHost.prototype._getComponentRootNode = function (componentRef) {
        return (((componentRef.hostView)).rootNodes[0]);
    };
    return DomPortalHost;
}(BasePortalHost));
/* tslint:disable */
/**
 * Scroll strategy that doesn't do anything.
 */
var NoopScrollStrategy = (function () {
    function NoopScrollStrategy() {
    }
    /**
     * @return {?}
     */
    NoopScrollStrategy.prototype.enable = function () { };
    /**
     * @return {?}
     */
    NoopScrollStrategy.prototype.disable = function () { };
    /**
     * @return {?}
     */
    NoopScrollStrategy.prototype.attach = function () { };
    return NoopScrollStrategy;
}());
/**
 * OverlayConfig captures the initial configuration used when opening an overlay.
 */
var OverlayConfig = (function () {
    /**
     * @param {?=} config
     */
    function OverlayConfig(config) {
        var _this = this;
        /**
         * Strategy to be used when handling scroll events while the overlay is open.
         */
        this.scrollStrategy = new NoopScrollStrategy();
        /**
         * Custom class to add to the overlay pane.
         */
        this.panelClass = '';
        /**
         * Whether the overlay has a backdrop.
         */
        this.hasBackdrop = false;
        /**
         * Custom class to add to the backdrop
         */
        this.backdropClass = 'cdk-overlay-dark-backdrop';
        /**
         * The direction of the text in the overlay panel.
         */
        this.direction = 'ltr';
        if (config) {
            Object.keys(config).forEach(function (key) { return _this[key] = config[key]; });
        }
    }
    return OverlayConfig;
}());
/**
 * The OverlayContainer is the container in which all overlays will load.
 * It should be provided in the root component to ensure it is properly shared.
 */
var OverlayContainer = (function () {
    function OverlayContainer() {
    }
    Object.defineProperty(OverlayContainer.prototype, "themeClass", {
        /**
         * Base theme to be applied to all overlay-based components.
         * @return {?}
         */
        get: function () { return this._themeClass; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._containerElement) {
                this._containerElement.classList.remove(this._themeClass);
                if (value) {
                    this._containerElement.classList.add(value);
                }
            }
            this._themeClass = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This method returns the overlay container element.  It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @return {?} the container element
     */
    OverlayContainer.prototype.getContainerElement = function () {
        if (!this._containerElement) {
            this._createContainer();
        }
        return this._containerElement;
    };
    /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     * @return {?}
     */
    OverlayContainer.prototype._createContainer = function () {
        var /** @type {?} */ container = document.createElement('div');
        container.classList.add('cdk-overlay-container');
        if (this._themeClass) {
            container.classList.add(this._themeClass);
        }
        document.body.appendChild(container);
        this._containerElement = container;
    };
    return OverlayContainer;
}());
OverlayContainer.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
OverlayContainer.ctorParameters = function () { return []; };
/**
 * @param {?} parentContainer
 * @return {?}
 */
function OVERLAY_CONTAINER_PROVIDER_FACTORY(parentContainer) {
    return parentContainer || new OverlayContainer();
}
var OVERLAY_CONTAINER_PROVIDER = {
    // If there is already an OverlayContainer available, use that. Otherwise, provide a new one.
    provide: OverlayContainer,
    deps: [[new Optional(), new SkipSelf(), OverlayContainer]],
    useFactory: OVERLAY_CONTAINER_PROVIDER_FACTORY,
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Reference to an overlay that has been created with the Overlay service.
 * Used to manipulate or dispose of said overlay.
 */
var OverlayRef = (function () {
    /**
     * @param {?} _portalHost
     * @param {?} _pane
     * @param {?} _config
     * @param {?} _ngZone
     */
    function OverlayRef(_portalHost, _pane, _config, _ngZone) {
        this._portalHost = _portalHost;
        this._pane = _pane;
        this._config = _config;
        this._ngZone = _ngZone;
        this._backdropElement = null;
        this._backdropClick = new Subject();
        this._attachments = new Subject();
        this._detachments = new Subject();
        if (_config.scrollStrategy) {
            _config.scrollStrategy.attach(this);
        }
    }
    Object.defineProperty(OverlayRef.prototype, "overlayElement", {
        /**
         * The overlay's HTML element
         * @return {?}
         */
        get: function () {
            return this._pane;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Attaches the overlay to a portal instance and adds the backdrop.
     * @param {?} portal Portal instance to which to attach the overlay.
     * @return {?} The portal attachment result.
     */
    OverlayRef.prototype.attach = function (portal) {
        var _this = this;
        var /** @type {?} */ attachResult = this._portalHost.attach(portal);
        if (this._config.positionStrategy) {
            this._config.positionStrategy.attach(this);
        }
        // Update the pane element with the given configuration.
        this._updateStackingOrder();
        this.updateSize();
        this.updateDirection();
        this.updatePosition();
        if (this._config.scrollStrategy) {
            this._config.scrollStrategy.enable();
        }
        // Enable pointer events for the overlay pane element.
        this._togglePointerEvents(true);
        if (this._config.hasBackdrop) {
            this._attachBackdrop();
        }
        if (this._config.panelClass) {
            // We can't do a spread here, because IE doesn't support setting multiple classes.
            if (Array.isArray(this._config.panelClass)) {
                this._config.panelClass.forEach(function (cls) { return _this._pane.classList.add(cls); });
            }
            else {
                this._pane.classList.add(this._config.panelClass);
            }
        }
        // Only emit the `attachments` event once all other setup is done.
        this._attachments.next();
        return attachResult;
    };
    /**
     * Detaches an overlay from a portal.
     * @return {?} The portal detachment result.
     */
    OverlayRef.prototype.detach = function () {
        this.detachBackdrop();
        // When the overlay is detached, the pane element should disable pointer events.
        // This is necessary because otherwise the pane element will cover the page and disable
        // pointer events therefore. Depends on the position strategy and the applied pane boundaries.
        this._togglePointerEvents(false);
        if (this._config.scrollStrategy) {
            this._config.scrollStrategy.disable();
        }
        var /** @type {?} */ detachmentResult = this._portalHost.detach();
        // Only emit after everything is detached.
        this._detachments.next();
        return detachmentResult;
    };
    /**
     * Cleans up the overlay from the DOM.
     * @return {?}
     */
    OverlayRef.prototype.dispose = function () {
        if (this._config.positionStrategy) {
            this._config.positionStrategy.dispose();
        }
        if (this._config.scrollStrategy) {
            this._config.scrollStrategy.disable();
        }
        this.detachBackdrop();
        this._portalHost.dispose();
        this._attachments.complete();
        this._backdropClick.complete();
        this._detachments.next();
        this._detachments.complete();
    };
    /**
     * Checks whether the overlay has been attached.
     * @return {?}
     */
    OverlayRef.prototype.hasAttached = function () {
        return this._portalHost.hasAttached();
    };
    /**
     * Returns an observable that emits when the backdrop has been clicked.
     * @return {?}
     */
    OverlayRef.prototype.backdropClick = function () {
        return this._backdropClick.asObservable();
    };
    /**
     * Returns an observable that emits when the overlay has been attached.
     * @return {?}
     */
    OverlayRef.prototype.attachments = function () {
        return this._attachments.asObservable();
    };
    /**
     * Returns an observable that emits when the overlay has been detached.
     * @return {?}
     */
    OverlayRef.prototype.detachments = function () {
        return this._detachments.asObservable();
    };
    /**
     * Gets the current config of the overlay.
     * @return {?}
     */
    OverlayRef.prototype.getConfig = function () {
        return this._config;
    };
    /**
     * Updates the position of the overlay based on the position strategy.
     * @return {?}
     */
    OverlayRef.prototype.updatePosition = function () {
        if (this._config.positionStrategy) {
            this._config.positionStrategy.apply();
        }
    };
    /**
     * Updates the text direction of the overlay panel.
     * @return {?}
     */
    OverlayRef.prototype.updateDirection = function () {
        this._pane.setAttribute('dir', /** @type {?} */ ((this._config.direction)));
    };
    /**
     * Updates the size of the overlay based on the overlay config.
     * @return {?}
     */
    OverlayRef.prototype.updateSize = function () {
        if (this._config.width || this._config.width === 0) {
            this._pane.style.width = formatCssUnit(this._config.width);
        }
        if (this._config.height || this._config.height === 0) {
            this._pane.style.height = formatCssUnit(this._config.height);
        }
        if (this._config.minWidth || this._config.minWidth === 0) {
            this._pane.style.minWidth = formatCssUnit(this._config.minWidth);
        }
        if (this._config.minHeight || this._config.minHeight === 0) {
            this._pane.style.minHeight = formatCssUnit(this._config.minHeight);
        }
        if (this._config.maxWidth || this._config.maxWidth === 0) {
            this._pane.style.maxWidth = formatCssUnit(this._config.maxWidth);
        }
        if (this._config.maxHeight || this._config.maxHeight === 0) {
            this._pane.style.maxHeight = formatCssUnit(this._config.maxHeight);
        }
    };
    /**
     * Toggles the pointer events for the overlay pane element.
     * @param {?} enablePointer
     * @return {?}
     */
    OverlayRef.prototype._togglePointerEvents = function (enablePointer) {
        this._pane.style.pointerEvents = enablePointer ? 'auto' : 'none';
    };
    /**
     * Attaches a backdrop for this overlay.
     * @return {?}
     */
    OverlayRef.prototype._attachBackdrop = function () {
        var _this = this;
        this._backdropElement = document.createElement('div');
        this._backdropElement.classList.add('cdk-overlay-backdrop');
        if (this._config.backdropClass) {
            this._backdropElement.classList.add(this._config.backdropClass);
        }
        // Insert the backdrop before the pane in the DOM order,
        // in order to handle stacked overlays properly.
        // HACK: fix for 1069 can't figure out how to fix this works properly in the material
        // library, do this to ensure the backdrop doesn't end up a child of a cdk-global-overlay-wrapper
        if (((((this._pane.parentElement)).classList)).contains('cdk-global-overlay-wrapper')) {
            this._pane.parentElement.parentElement.insertBefore(this._backdropElement, this._pane.parentElement);
        }
        else {
            ((this._pane.parentElement)).insertBefore(this._backdropElement, this._pane);
        }
        // Forward backdrop clicks such that the consumer of the overlay can perform whatever
        // action desired when such a click occurs (usually closing the overlay).
        this._backdropElement.addEventListener('click', function () { return _this._backdropClick.next(null); });
        // Add class to fade-in the backdrop after one frame.
        requestAnimationFrame(function () {
            if (_this._backdropElement) {
                _this._backdropElement.classList.add('cdk-overlay-backdrop-showing');
            }
        });
    };
    /**
     * Updates the stacking order of the element, moving it to the top if necessary.
     * This is required in cases where one overlay was detached, while another one,
     * that should be behind it, was destroyed. The next time both of them are opened,
     * the stacking will be wrong, because the detached element's pane will still be
     * in its original DOM position.
     * @return {?}
     */
    OverlayRef.prototype._updateStackingOrder = function () {
        if (this._pane.nextSibling) {
            ((this._pane.parentNode)).appendChild(this._pane);
        }
    };
    /**
     * Detaches the backdrop (if any) associated with the overlay.
     * @return {?}
     */
    OverlayRef.prototype.detachBackdrop = function () {
        var _this = this;
        var /** @type {?} */ backdropToDetach = this._backdropElement;
        if (backdropToDetach) {
            var /** @type {?} */ finishDetach_1 = function () {
                // It may not be attached to anything in certain cases (e.g. unit tests).
                if (backdropToDetach && backdropToDetach.parentNode) {
                    backdropToDetach.parentNode.removeChild(backdropToDetach);
                }
                // It is possible that a new portal has been attached to this overlay since we started
                // removing the backdrop. If that is the case, only clear the backdrop reference if it
                // is still the same instance that we started to remove.
                if (_this._backdropElement == backdropToDetach) {
                    _this._backdropElement = null;
                }
            };
            backdropToDetach.classList.remove('cdk-overlay-backdrop-showing');
            if (this._config.backdropClass) {
                backdropToDetach.classList.remove(this._config.backdropClass);
            }
            backdropToDetach.addEventListener('transitionend', finishDetach_1);
            // If the backdrop doesn't have a transition, the `transitionend` event won't fire.
            // In this case we make it unclickable and we try to remove it after a delay.
            backdropToDetach.style.pointerEvents = 'none';
            // Run this outside the Angular zone because there's nothing that Angular cares about.
            // If it were to run inside the Angular zone, every test that used Overlay would have to be
            // either async or fakeAsync.
            this._ngZone.runOutsideAngular(function () {
                setTimeout(finishDetach_1, 500);
            });
        }
    };
    return OverlayRef;
}());
/**
 * @param {?} value
 * @return {?}
 */
function formatCssUnit(value) {
    return typeof value === 'string' ? (value) : value + "px";
}
/** Horizontal dimension of a connection point on the perimeter of the origin or overlay element. */
/**
 * The points of the origin element and the overlay element to connect.
 */
var ConnectionPositionPair = (function () {
    /**
     * @param {?} origin
     * @param {?} overlay
     */
    function ConnectionPositionPair(origin, overlay) {
        this.originX = origin.originX;
        this.originY = origin.originY;
        this.overlayX = overlay.overlayX;
        this.overlayY = overlay.overlayY;
    }
    return ConnectionPositionPair;
}());
/**
 * Set of properties regarding the position of the origin and overlay relative to the viewport
 * with respect to the containing Scrollable elements.
 *
 * The overlay and origin are clipped if any part of their bounding client rectangle exceeds the
 * bounds of any one of the strategy's Scrollable's bounding client rectangle.
 *
 * The overlay and origin are outside view if there is no overlap between their bounding client
 * rectangle and any one of the strategy's Scrollable's bounding client rectangle.
 *
 *       -----------                    -----------
 *       | outside |                    | clipped |
 *       |  view   |              --------------------------
 *       |         |              |     |         |        |
 *       ----------               |     -----------        |
 *  --------------------------    |                        |
 *  |                        |    |      Scrollable        |
 *  |                        |    |                        |
 *  |                        |     --------------------------
 *  |      Scrollable        |
 *  |                        |
 *  --------------------------
 */
var ScrollableViewProperties = (function () {
    function ScrollableViewProperties() {
    }
    return ScrollableViewProperties;
}());
/**
 * The change event emitted by the strategy when a fallback position is used.
 */
var ConnectedOverlayPositionChange = (function () {
    /**
     * @param {?} connectionPair
     * @param {?} scrollableViewProperties
     */
    function ConnectedOverlayPositionChange(connectionPair, scrollableViewProperties) {
        this.connectionPair = connectionPair;
        this.scrollableViewProperties = scrollableViewProperties;
    }
    return ConnectedOverlayPositionChange;
}());
/**
 * @nocollapse
 */
ConnectedOverlayPositionChange.ctorParameters = function () { return [
    { type: ConnectionPositionPair, },
    { type: ScrollableViewProperties, decorators: [{ type: Optional },] },
]; };
/**
 * A strategy for positioning overlays. Using this strategy, an overlay is given an
 * implicit position relative some origin element. The relative position is defined in terms of
 * a point on the origin element that is connected to a point on the overlay element. For example,
 * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
 * of the overlay.
 */
var ConnectedPositionStrategy = (function () {
    /**
     * @param {?} _connectedTo
     * @param {?} _originPos
     * @param {?} _overlayPos
     * @param {?} _viewportRuler
     */
    function ConnectedPositionStrategy(_connectedTo, _originPos, _overlayPos, _viewportRuler) {
        this._connectedTo = _connectedTo;
        this._originPos = _originPos;
        this._overlayPos = _overlayPos;
        this._viewportRuler = _viewportRuler;
        this._dir = 'ltr';
        /**
         * The offset in pixels for the overlay connection point on the x-axis
         */
        this._offsetX = 0;
        /**
         * The offset in pixels for the overlay connection point on the y-axis
         */
        this._offsetY = 0;
        /**
         * The Scrollable containers used to check scrollable view properties on position change.
         */
        this.scrollables = [];
        /**
         * Ordered list of preferred positions, from most to least desirable.
         */
        this._preferredPositions = [];
        this._onPositionChange = new Subject();
        this._origin = this._connectedTo.nativeElement;
        this.withFallbackPosition(_originPos, _overlayPos);
    }
    Object.defineProperty(ConnectedPositionStrategy.prototype, "_isRtl", {
        /**
         * Whether the we're dealing with an RTL context
         * @return {?}
         */
        get: function () {
            return this._dir === 'rtl';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedPositionStrategy.prototype, "onPositionChange", {
        /**
         * Emits an event when the connection point changes.
         * @return {?}
         */
        get: function () {
            return this._onPositionChange.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedPositionStrategy.prototype, "positions", {
        /**
         * Ordered list of preferred positions, from most to least desirable.
         * @return {?}
         */
        get: function () {
            return this._preferredPositions;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} overlayRef
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.attach = function (overlayRef) {
        this._overlayRef = overlayRef;
        this._pane = overlayRef.overlayElement;
    };
    /**
     * To be used to for any cleanup after the element gets destroyed.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.dispose = function () { };
    /**
     * Updates the position of the overlay element, using whichever preferred position relative
     * to the origin fits on-screen.
     * \@docs-private
     *
     * @return {?} Resolves when the styles have been applied.
     */
    ConnectedPositionStrategy.prototype.apply = function () {
        // We need the bounding rects for the origin and the overlay to determine how to position
        // the overlay relative to the origin.
        var /** @type {?} */ element = this._pane;
        var /** @type {?} */ originRect = this._origin.getBoundingClientRect();
        var /** @type {?} */ overlayRect = element.getBoundingClientRect();
        // We use the viewport rect to determine whether a position would go off-screen.
        var /** @type {?} */ viewportRect = this._viewportRuler.getViewportRect();
        // Fallback point if none of the fallbacks fit into the viewport.
        var /** @type {?} */ fallbackPoint;
        var /** @type {?} */ fallbackPosition;
        // We want to place the overlay in the first of the preferred positions such that the
        // overlay fits on-screen.
        for (var _i = 0, _a = this._preferredPositions; _i < _a.length; _i++) {
            var pos = _a[_i];
            // Get the (x, y) point of connection on the origin, and then use that to get the
            // (top, left) coordinate for the overlay at `pos`.
            var /** @type {?} */ originPoint = this._getOriginConnectionPoint(originRect, pos);
            var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, viewportRect, pos);
            // If the overlay in the calculated position fits on-screen, put it there and we're done.
            if (overlayPoint.fitsInViewport) {
                this._setElementPosition(element, overlayRect, overlayPoint, pos);
                // Save the last connected position in case the position needs to be re-calculated.
                this._lastConnectedPosition = pos;
                return;
            }
            else if (!fallbackPoint || fallbackPoint.visibleArea < overlayPoint.visibleArea) {
                fallbackPoint = overlayPoint;
                fallbackPosition = pos;
            }
        }
        // If none of the preferred positions were in the viewport, take the one
        // with the largest visible area.
        this._setElementPosition(element, overlayRect, /** @type {?} */ ((fallbackPoint)), /** @type {?} */ ((fallbackPosition)));
    };
    /**
     * This re-aligns the overlay element with the trigger in its last calculated position,
     * even if a position higher in the "preferred positions" list would now fit. This
     * allows one to re-align the panel without changing the orientation of the panel.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.recalculateLastPosition = function () {
        var /** @type {?} */ originRect = this._origin.getBoundingClientRect();
        var /** @type {?} */ overlayRect = this._pane.getBoundingClientRect();
        var /** @type {?} */ viewportRect = this._viewportRuler.getViewportRect();
        var /** @type {?} */ lastPosition = this._lastConnectedPosition || this._preferredPositions[0];
        var /** @type {?} */ originPoint = this._getOriginConnectionPoint(originRect, lastPosition);
        var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, viewportRect, lastPosition);
        this._setElementPosition(this._pane, overlayRect, overlayPoint, lastPosition);
    };
    /**
     * Sets the list of Scrollable containers that host the origin element so that
     * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
     * Scrollable must be an ancestor element of the strategy's origin element.
     * @param {?} scrollables
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withScrollableContainers = function (scrollables) {
        this.scrollables = scrollables;
    };
    /**
     * Adds a new preferred fallback position.
     * @param {?} originPos
     * @param {?} overlayPos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withFallbackPosition = function (originPos, overlayPos) {
        this._preferredPositions.push(new ConnectionPositionPair(originPos, overlayPos));
        return this;
    };
    /**
     * Sets the layout direction so the overlay's position can be adjusted to match.
     * @param {?} dir New layout direction.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withDirection = function (dir) {
        this._dir = dir;
        return this;
    };
    /**
     * Sets an offset for the overlay's connection point on the x-axis
     * @param {?} offset New offset in the X axis.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withOffsetX = function (offset) {
        this._offsetX = offset;
        return this;
    };
    /**
     * Sets an offset for the overlay's connection point on the y-axis
     * @param {?} offset New offset in the Y axis.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withOffsetY = function (offset) {
        this._offsetY = offset;
        return this;
    };
    /**
     * Gets the horizontal (x) "start" dimension based on whether the overlay is in an RTL context.
     * @param {?} rect
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getStartX = function (rect) {
        return this._isRtl ? rect.right : rect.left;
    };
    /**
     * Gets the horizontal (x) "end" dimension based on whether the overlay is in an RTL context.
     * @param {?} rect
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getEndX = function (rect) {
        return this._isRtl ? rect.left : rect.right;
    };
    /**
     * Gets the (x, y) coordinate of a connection point on the origin based on a relative position.
     * @param {?} originRect
     * @param {?} pos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getOriginConnectionPoint = function (originRect, pos) {
        var /** @type {?} */ originStartX = this._getStartX(originRect);
        var /** @type {?} */ originEndX = this._getEndX(originRect);
        var /** @type {?} */ x;
        if (pos.originX == 'center') {
            x = originStartX + (originRect.width / 2);
        }
        else {
            x = pos.originX == 'start' ? originStartX : originEndX;
        }
        var /** @type {?} */ y;
        if (pos.originY == 'center') {
            y = originRect.top + (originRect.height / 2);
        }
        else {
            y = pos.originY == 'top' ? originRect.top : originRect.bottom;
        }
        return { x: x, y: y };
    };
    /**
     * Gets the (x, y) coordinate of the top-left corner of the overlay given a given position and
     * origin point to which the overlay should be connected, as well as how much of the element
     * would be inside the viewport at that position.
     * @param {?} originPoint
     * @param {?} overlayRect
     * @param {?} viewportRect
     * @param {?} pos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getOverlayPoint = function (originPoint, overlayRect, viewportRect, pos) {
        // Calculate the (overlayStartX, overlayStartY), the start of the potential overlay position
        // relative to the origin point.
        var /** @type {?} */ overlayStartX;
        if (pos.overlayX == 'center') {
            overlayStartX = -overlayRect.width / 2;
        }
        else if (pos.overlayX === 'start') {
            overlayStartX = this._isRtl ? -overlayRect.width : 0;
        }
        else {
            overlayStartX = this._isRtl ? 0 : -overlayRect.width;
        }
        var /** @type {?} */ overlayStartY;
        if (pos.overlayY == 'center') {
            overlayStartY = -overlayRect.height / 2;
        }
        else {
            overlayStartY = pos.overlayY == 'top' ? 0 : -overlayRect.height;
        }
        // The (x, y) coordinates of the overlay.
        var /** @type {?} */ x = originPoint.x + overlayStartX + this._offsetX;
        var /** @type {?} */ y = originPoint.y + overlayStartY + this._offsetY;
        // How much the overlay would overflow at this position, on each side.
        var /** @type {?} */ leftOverflow = 0 - x;
        var /** @type {?} */ rightOverflow = (x + overlayRect.width) - viewportRect.width;
        var /** @type {?} */ topOverflow = 0 - y;
        var /** @type {?} */ bottomOverflow = (y + overlayRect.height) - viewportRect.height;
        // Visible parts of the element on each axis.
        var /** @type {?} */ visibleWidth = this._subtractOverflows(overlayRect.width, leftOverflow, rightOverflow);
        var /** @type {?} */ visibleHeight = this._subtractOverflows(overlayRect.height, topOverflow, bottomOverflow);
        // The area of the element that's within the viewport.
        var /** @type {?} */ visibleArea = visibleWidth * visibleHeight;
        var /** @type {?} */ fitsInViewport = (overlayRect.width * overlayRect.height) === visibleArea;
        return { x: x, y: y, fitsInViewport: fitsInViewport, visibleArea: visibleArea };
    };
    /**
     * Gets the view properties of the trigger and overlay, including whether they are clipped
     * or completely outside the view of any of the strategy's scrollables.
     * @param {?} overlay
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.getScrollableViewProperties = function (overlay) {
        var _this = this;
        var /** @type {?} */ originBounds = this._getElementBounds(this._origin);
        var /** @type {?} */ overlayBounds = this._getElementBounds(overlay);
        var /** @type {?} */ scrollContainerBounds = this.scrollables.map(function (scrollable) {
            return _this._getElementBounds(scrollable.getElementRef().nativeElement);
        });
        return {
            isOriginClipped: this.isElementClipped(originBounds, scrollContainerBounds),
            isOriginOutsideView: this.isElementOutsideView(originBounds, scrollContainerBounds),
            isOverlayClipped: this.isElementClipped(overlayBounds, scrollContainerBounds),
            isOverlayOutsideView: this.isElementOutsideView(overlayBounds, scrollContainerBounds),
        };
    };
    /**
     * Whether the element is completely out of the view of any of the containers.
     * @param {?} elementBounds
     * @param {?} containersBounds
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.isElementOutsideView = function (elementBounds, containersBounds) {
        return containersBounds.some(function (containerBounds) {
            var /** @type {?} */ outsideAbove = elementBounds.bottom < containerBounds.top;
            var /** @type {?} */ outsideBelow = elementBounds.top > containerBounds.bottom;
            var /** @type {?} */ outsideLeft = elementBounds.right < containerBounds.left;
            var /** @type {?} */ outsideRight = elementBounds.left > containerBounds.right;
            return outsideAbove || outsideBelow || outsideLeft || outsideRight;
        });
    };
    /**
     * Whether the element is clipped by any of the containers.
     * @param {?} elementBounds
     * @param {?} containersBounds
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.isElementClipped = function (elementBounds, containersBounds) {
        return containersBounds.some(function (containerBounds) {
            var /** @type {?} */ clippedAbove = elementBounds.top < containerBounds.top;
            var /** @type {?} */ clippedBelow = elementBounds.bottom > containerBounds.bottom;
            var /** @type {?} */ clippedLeft = elementBounds.left < containerBounds.left;
            var /** @type {?} */ clippedRight = elementBounds.right > containerBounds.right;
            return clippedAbove || clippedBelow || clippedLeft || clippedRight;
        });
    };
    /**
     * Physically positions the overlay element to the given coordinate.
     * @param {?} element
     * @param {?} overlayRect
     * @param {?} overlayPoint
     * @param {?} pos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._setElementPosition = function (element, overlayRect, overlayPoint, pos) {
        // We want to set either `top` or `bottom` based on whether the overlay wants to appear above
        // or below the origin and the direction in which the element will expand.
        var /** @type {?} */ verticalStyleProperty = pos.overlayY === 'bottom' ? 'bottom' : 'top';
        // When using `bottom`, we adjust the y position such that it is the distance
        // from the bottom of the viewport rather than the top.
        var /** @type {?} */ y = verticalStyleProperty === 'top' ?
            overlayPoint.y :
            document.documentElement.clientHeight - (overlayPoint.y + overlayRect.height);
        // We want to set either `left` or `right` based on whether the overlay wants to appear "before"
        // or "after" the origin, which determines the direction in which the element will expand.
        // For the horizontal axis, the meaning of "before" and "after" change based on whether the
        // page is in RTL or LTR.
        var /** @type {?} */ horizontalStyleProperty;
        if (this._dir === 'rtl') {
            horizontalStyleProperty = pos.overlayX === 'end' ? 'left' : 'right';
        }
        else {
            horizontalStyleProperty = pos.overlayX === 'end' ? 'right' : 'left';
        }
        // When we're setting `right`, we adjust the x position such that it is the distance
        // from the right edge of the viewport rather than the left edge.
        var /** @type {?} */ x = horizontalStyleProperty === 'left' ?
            overlayPoint.x :
            document.documentElement.clientWidth - (overlayPoint.x + overlayRect.width);
        // Reset any existing styles. This is necessary in case the preferred position has
        // changed since the last `apply`.
        ['top', 'bottom', 'left', 'right'].forEach(function (p) { return element.style[p] = null; });
        element.style[verticalStyleProperty] = y + "px";
        element.style[horizontalStyleProperty] = x + "px";
    };
    /**
     * Returns the bounding positions of the provided element with respect to the viewport.
     * @param {?} element
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getElementBounds = function (element) {
        var /** @type {?} */ boundingClientRect = element.getBoundingClientRect();
        return {
            top: boundingClientRect.top,
            right: boundingClientRect.left + boundingClientRect.width,
            bottom: boundingClientRect.top + boundingClientRect.height,
            left: boundingClientRect.left,
        };
    };
    /**
     * Subtracts the amount that an element is overflowing on an axis from it's length.
     * @param {?} length
     * @param {...?} overflows
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._subtractOverflows = function (length) {
        var overflows = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            overflows[_i - 1] = arguments[_i];
        }
        return overflows.reduce(function (currentValue, currentOverflow) {
            return currentValue - Math.max(currentOverflow, 0);
        }, length);
    };
    return ConnectedPositionStrategy;
}());
/**
 * A strategy for positioning overlays. Using this strategy, an overlay is given an
 * explicit position relative to the browser's viewport. We use flexbox, instead of
 * transforms, in order to avoid issues with subpixel rendering which can cause the
 * element to become blurry.
 */
var GlobalPositionStrategy = (function () {
    function GlobalPositionStrategy() {
        this._cssPosition = 'static';
        this._topOffset = '';
        this._bottomOffset = '';
        this._leftOffset = '';
        this._rightOffset = '';
        this._alignItems = '';
        this._justifyContent = '';
        this._width = '';
        this._height = '';
    }
    /**
     * Sets the top position of the overlay. Clears any previously set vertical position.
     * @param {?} value New top offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.top = function (value) {
        this._bottomOffset = '';
        this._topOffset = value;
        this._alignItems = 'flex-start';
        return this;
    };
    /**
     * Sets the left position of the overlay. Clears any previously set horizontal position.
     * @param {?} value New left offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.left = function (value) {
        this._rightOffset = '';
        this._leftOffset = value;
        this._justifyContent = 'flex-start';
        return this;
    };
    /**
     * Sets the bottom position of the overlay. Clears any previously set vertical position.
     * @param {?} value New bottom offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.bottom = function (value) {
        this._topOffset = '';
        this._bottomOffset = value;
        this._alignItems = 'flex-end';
        return this;
    };
    /**
     * Sets the right position of the overlay. Clears any previously set horizontal position.
     * @param {?} value New right offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.right = function (value) {
        this._leftOffset = '';
        this._rightOffset = value;
        this._justifyContent = 'flex-end';
        return this;
    };
    /**
     * Sets the overlay width and clears any previously set width.
     * @param {?} value New width for the overlay
     * @return {?}
     */
    GlobalPositionStrategy.prototype.width = function (value) {
        this._width = value;
        // When the width is 100%, we should reset the `left` and the offset,
        // in order to ensure that the element is flush against the viewport edge.
        if (value === '100%') {
            this.left('0px');
        }
        return this;
    };
    /**
     * Sets the overlay height and clears any previously set height.
     * @param {?} value New height for the overlay
     * @return {?}
     */
    GlobalPositionStrategy.prototype.height = function (value) {
        this._height = value;
        // When the height is 100%, we should reset the `top` and the offset,
        // in order to ensure that the element is flush against the viewport edge.
        if (value === '100%') {
            this.top('0px');
        }
        return this;
    };
    /**
     * Centers the overlay horizontally with an optional offset.
     * Clears any previously set horizontal position.
     *
     * @param {?=} offset Overlay offset from the horizontal center.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.centerHorizontally = function (offset) {
        if (offset === void 0) { offset = ''; }
        this.left(offset);
        this._justifyContent = 'center';
        return this;
    };
    /**
     * Centers the overlay vertically with an optional offset.
     * Clears any previously set vertical position.
     *
     * @param {?=} offset Overlay offset from the vertical center.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.centerVertically = function (offset) {
        if (offset === void 0) { offset = ''; }
        this.top(offset);
        this._alignItems = 'center';
        return this;
    };
    /**
     * @param {?} overlayRef
     * @return {?}
     */
    GlobalPositionStrategy.prototype.attach = function (overlayRef) {
        this._overlayRef = overlayRef;
    };
    /**
     * Apply the position to the element.
     * \@docs-private
     *
     * @return {?} Resolved when the styles have been applied.
     */
    GlobalPositionStrategy.prototype.apply = function () {
        var /** @type {?} */ element = this._overlayRef.overlayElement;
        if (!this._wrapper && element.parentNode) {
            this._wrapper = document.createElement('div');
            this._wrapper.classList.add('cdk-global-overlay-wrapper');
            element.parentNode.insertBefore(this._wrapper, element);
            this._wrapper.appendChild(element);
        }
        var /** @type {?} */ styles = element.style;
        var /** @type {?} */ parentStyles = ((element.parentNode)).style;
        styles.position = this._cssPosition;
        styles.marginTop = this._topOffset;
        styles.marginLeft = this._leftOffset;
        styles.marginBottom = this._bottomOffset;
        styles.marginRight = this._rightOffset;
        styles.width = this._width;
        styles.height = this._height;
        parentStyles.justifyContent = this._justifyContent;
        parentStyles.alignItems = this._alignItems;
    };
    /**
     * Removes the wrapper element from the DOM.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.dispose = function () {
        if (this._wrapper && this._wrapper.parentNode) {
            this._wrapper.parentNode.removeChild(this._wrapper);
            this._wrapper = null;
        }
    };
    return GlobalPositionStrategy;
}());
// Whether the current platform supports the V8 Break Iterator. The V8 check
// is necessary to detect all Blink based browsers.
var hasV8BreakIterator = (typeof (Intl) !== 'undefined' && ((Intl)).v8BreakIterator);
/**
 * Service to detect the current platform by comparing the userAgent strings and
 * checking browser-specific global properties.
 * \@docs-private
 */
var Platform = (function () {
    function Platform() {
        this.isBrowser = typeof document === 'object' && !!document;
        /**
         * Layout Engines
         */
        this.EDGE = /(edge)/i.test(navigator.userAgent);
        this.TRIDENT = /(msie|trident)/i.test(navigator.userAgent);
        // EdgeHTML and Trident mock Blink specific things and need to be excluded from this check.
        this.BLINK = !!(((window)).chrome || hasV8BreakIterator) && !!CSS && !this.EDGE && !this.TRIDENT;
        // Webkit is part of the userAgent in EdgeHTML, Blink and Trident. Therefore we need to
        // ensure that Webkit runs standalone and is not used as another engine's base.
        this.WEBKIT = /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
        /**
         * Browsers and Platform Types
         */
        this.IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        // It's difficult to detect the plain Gecko engine, because most of the browsers identify
        // them self as Gecko-like browsers and modify the userAgent's according to that.
        // Since we only cover one explicit Firefox case, we can simply check for Firefox
        // instead of having an unstable check for Gecko.
        this.FIREFOX = /(firefox|minefield)/i.test(navigator.userAgent);
        // Trident on mobile adds the android platform to the userAgent to trick detections.
        this.ANDROID = /android/i.test(navigator.userAgent) && !this.TRIDENT;
    }
    return Platform;
}());
Platform.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Platform.ctorParameters = function () { return []; };
var supportedInputTypes;
/**
 * @return {?} The input types supported by this browser.
 */
function getSupportedInputTypes() {
    if (!supportedInputTypes) {
        var /** @type {?} */ featureTestInput_1 = document.createElement('input');
        supportedInputTypes = new Set([
            // `color` must come first. Chrome 56 shows a warning if we change the type to `color` after
            // first changing it to something else:
            // The specified value "" does not conform to the required format.
            // The format is "#rrggbb" where rr, gg, bb are two-digit hexadecimal numbers.
            'color',
            'button',
            'checkbox',
            'date',
            'datetime-local',
            'email',
            'file',
            'hidden',
            'image',
            'month',
            'number',
            'password',
            'radio',
            'range',
            'reset',
            'search',
            'submit',
            'tel',
            'text',
            'time',
            'url',
            'week',
        ].filter(function (value) {
            featureTestInput_1.setAttribute('type', value);
            return featureTestInput_1.type === value;
        }));
    }
    return supportedInputTypes;
}
var PlatformModule = (function () {
    function PlatformModule() {
    }
    return PlatformModule;
}());
PlatformModule.decorators = [
    { type: NgModule, args: [{
                providers: [Platform],
            },] },
];
/**
 * @nocollapse
 */
PlatformModule.ctorParameters = function () { return []; };
/* tslint:disable */
/**
 * Time in ms to throttle the scrolling events by default.
 */
var DEFAULT_SCROLL_TIME = 20;
/**
 * Service contained all registered Scrollable references and emits an event when any one of the
 * Scrollable references emit a scrolled event.
 */
var ScrollDispatcher = (function () {
    /**
     * @param {?} _ngZone
     * @param {?} _platform
     */
    function ScrollDispatcher(_ngZone, _platform) {
        this._ngZone = _ngZone;
        this._platform = _platform;
        /**
         * Subject for notifying that a registered scrollable reference element has been scrolled.
         */
        this._scrolled = new Subject();
        /**
         * Keeps track of the global `scroll` and `resize` subscriptions.
         */
        this._globalSubscription = null;
        /**
         * Keeps track of the amount of subscriptions to `scrolled`. Used for cleaning up afterwards.
         */
        this._scrolledCount = 0;
        /**
         * Map of all the scrollable references that are registered with the service and their
         * scroll event subscriptions.
         */
        this.scrollableReferences = new Map();
    }
    /**
     * Registers a Scrollable with the service and listens for its scrolled events. When the
     * scrollable is scrolled, the service emits the event in its scrolled observable.
     * @param {?} scrollable Scrollable instance to be registered.
     * @return {?}
     */
    ScrollDispatcher.prototype.register = function (scrollable) {
        var _this = this;
        var /** @type {?} */ scrollSubscription = scrollable.elementScrolled().subscribe(function () { return _this._notify(); });
        this.scrollableReferences.set(scrollable, scrollSubscription);
    };
    /**
     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
     * @param {?} scrollable Scrollable instance to be deregistered.
     * @return {?}
     */
    ScrollDispatcher.prototype.deregister = function (scrollable) {
        var /** @type {?} */ scrollableReference = this.scrollableReferences.get(scrollable);
        if (scrollableReference) {
            scrollableReference.unsubscribe();
            this.scrollableReferences.delete(scrollable);
        }
    };
    /**
     * Subscribes to an observable that emits an event whenever any of the registered Scrollable
     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
     * to override the default "throttle" time.
     * @param {?=} auditTimeInMs
     * @param {?=} callback
     * @return {?}
     */
    ScrollDispatcher.prototype.scrolled = function (auditTimeInMs, callback) {
        var _this = this;
        if (auditTimeInMs === void 0) { auditTimeInMs = DEFAULT_SCROLL_TIME; }
        // Scroll events can only happen on the browser, so do nothing if we're not on the browser.
        if (!this._platform.isBrowser) {
            return Subscription.EMPTY;
        }
        // In the case of a 0ms delay, use an observable without auditTime
        // since it does add a perceptible delay in processing overhead.
        var /** @type {?} */ observable = auditTimeInMs > 0 ?
            this._scrolled.asObservable().auditTime(auditTimeInMs) :
            this._scrolled.asObservable();
        this._scrolledCount++;
        if (!this._globalSubscription) {
            this._globalSubscription = this._ngZone.runOutsideAngular(function () {
                return Observable.merge(Observable.fromEvent(window.document, 'scroll'), Observable.fromEvent(window, 'resize')).subscribe(function () { return _this._notify(); });
            });
        }
        // Note that we need to do the subscribing from here, in order to be able to remove
        // the global event listeners once there are no more subscriptions.
        var /** @type {?} */ subscription = observable.subscribe(callback);
        subscription.add(function () {
            _this._scrolledCount--;
            if (_this._globalSubscription && !_this.scrollableReferences.size && !_this._scrolledCount) {
                _this._globalSubscription.unsubscribe();
                _this._globalSubscription = null;
            }
        });
        return subscription;
    };
    /**
     * Returns all registered Scrollables that contain the provided element.
     * @param {?} elementRef
     * @return {?}
     */
    ScrollDispatcher.prototype.getScrollContainers = function (elementRef) {
        var _this = this;
        var /** @type {?} */ scrollingContainers = [];
        this.scrollableReferences.forEach(function (subscription, scrollable) {
            if (_this.scrollableContainsElement(scrollable, elementRef)) {
                scrollingContainers.push(scrollable);
            }
        });
        return scrollingContainers;
    };
    /**
     * Returns true if the element is contained within the provided Scrollable.
     * @param {?} scrollable
     * @param {?} elementRef
     * @return {?}
     */
    ScrollDispatcher.prototype.scrollableContainsElement = function (scrollable, elementRef) {
        var /** @type {?} */ element = elementRef.nativeElement;
        var /** @type {?} */ scrollableElement = scrollable.getElementRef().nativeElement;
        // Traverse through the element parents until we reach null, checking if any of the elements
        // are the scrollable's element.
        do {
            if (element == scrollableElement) {
                return true;
            }
        } while (element = element.parentElement);
    };
    /**
     * Sends a notification that a scroll event has been fired.
     * @return {?}
     */
    ScrollDispatcher.prototype._notify = function () {
        this._scrolled.next();
    };
    return ScrollDispatcher;
}());
ScrollDispatcher.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ScrollDispatcher.ctorParameters = function () { return [
    { type: NgZone, },
    { type: Platform, },
]; };
/**
 * @param {?} parentDispatcher
 * @param {?} ngZone
 * @param {?} platform
 * @return {?}
 */
function SCROLL_DISPATCHER_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
    return parentDispatcher || new ScrollDispatcher(ngZone, platform);
}
var SCROLL_DISPATCHER_PROVIDER = {
    // If there is already a ScrollDispatcher available, use that. Otherwise, provide a new one.
    provide: ScrollDispatcher,
    deps: [[new Optional(), new SkipSelf(), ScrollDispatcher], NgZone, Platform],
    useFactory: SCROLL_DISPATCHER_PROVIDER_FACTORY
};
/**
 * Simple utility for getting the bounds of the browser viewport.
 * \@docs-private
 */
var ViewportRuler = (function () {
    /**
     * @param {?} scrollDispatcher
     */
    function ViewportRuler(scrollDispatcher) {
        var _this = this;
        // Subscribe to scroll and resize events and update the document rectangle on changes.
        scrollDispatcher.scrolled(null, function () { return _this._cacheViewportGeometry(); });
    }
    /**
     * Gets a ClientRect for the viewport's bounds.
     * @param {?=} documentRect
     * @return {?}
     */
    ViewportRuler.prototype.getViewportRect = function (documentRect) {
        if (documentRect === void 0) { documentRect = this._documentRect; }
        // Cache the document bounding rect so that we don't recompute it for multiple calls.
        if (!documentRect) {
            this._cacheViewportGeometry();
            documentRect = this._documentRect;
        }
        // Use the document element's bounding rect rather than the window scroll properties
        // (e.g. pageYOffset, scrollY) due to in issue in Chrome and IE where window scroll
        // properties and client coordinates (boundingClientRect, clientX/Y, etc.) are in different
        // conceptual viewports. Under most circumstances these viewports are equivalent, but they
        // can disagree when the page is pinch-zoomed (on devices that support touch).
        // See https://bugs.chromium.org/p/chromium/issues/detail?id=489206#c4
        // We use the documentElement instead of the body because, by default (without a css reset)
        // browsers typically give the document body an 8px margin, which is not included in
        // getBoundingClientRect().
        var /** @type {?} */ scrollPosition = this.getViewportScrollPosition(documentRect);
        var /** @type {?} */ height = window.innerHeight;
        var /** @type {?} */ width = window.innerWidth;
        return {
            top: scrollPosition.top,
            left: scrollPosition.left,
            bottom: scrollPosition.top + height,
            right: scrollPosition.left + width,
            height: height,
            width: width,
        };
    };
    /**
     * Gets the (top, left) scroll position of the viewport.
     * @param {?=} documentRect
     * @return {?}
     */
    ViewportRuler.prototype.getViewportScrollPosition = function (documentRect) {
        if (documentRect === void 0) { documentRect = this._documentRect; }
        // Cache the document bounding rect so that we don't recompute it for multiple calls.
        if (!documentRect) {
            this._cacheViewportGeometry();
            documentRect = this._documentRect;
        }
        // The top-left-corner of the viewport is determined by the scroll position of the document
        // body, normally just (scrollLeft, scrollTop). However, Chrome and Firefox disagree about
        // whether `document.body` or `document.documentElement` is the scrolled element, so reading
        // `scrollTop` and `scrollLeft` is inconsistent. However, using the bounding rect of
        // `document.documentElement` works consistently, where the `top` and `left` values will
        // equal negative the scroll position.
        var /** @type {?} */ top = -documentRect.top || document.body.scrollTop || window.scrollY ||
            document.documentElement.scrollTop || 0;
        var /** @type {?} */ left = -documentRect.left || document.body.scrollLeft || window.scrollX ||
            document.documentElement.scrollLeft || 0;
        return { top: top, left: left };
    };
    /**
     * Caches the latest client rectangle of the document element.
     * @return {?}
     */
    ViewportRuler.prototype._cacheViewportGeometry = function () {
        this._documentRect = document.documentElement.getBoundingClientRect();
    };
    return ViewportRuler;
}());
ViewportRuler.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ViewportRuler.ctorParameters = function () { return [
    { type: ScrollDispatcher, },
]; };
/**
 * @param {?} parentRuler
 * @param {?} scrollDispatcher
 * @return {?}
 */
function VIEWPORT_RULER_PROVIDER_FACTORY(parentRuler, scrollDispatcher) {
    return parentRuler || new ViewportRuler(scrollDispatcher);
}
var VIEWPORT_RULER_PROVIDER = {
    // If there is already a ViewportRuler available, use that. Otherwise, provide a new one.
    provide: ViewportRuler,
    deps: [[new Optional(), new SkipSelf(), ViewportRuler], ScrollDispatcher],
    useFactory: VIEWPORT_RULER_PROVIDER_FACTORY,
};
/**
 * Builder for overlay position strategy.
 */
var OverlayPositionBuilder = (function () {
    /**
     * @param {?} _viewportRuler
     */
    function OverlayPositionBuilder(_viewportRuler) {
        this._viewportRuler = _viewportRuler;
    }
    /**
     * Creates a global position strategy.
     * @return {?}
     */
    OverlayPositionBuilder.prototype.global = function () {
        return new GlobalPositionStrategy();
    };
    /**
     * Creates a relative position strategy.
     * @param {?} elementRef
     * @param {?} originPos
     * @param {?} overlayPos
     * @return {?}
     */
    OverlayPositionBuilder.prototype.connectedTo = function (elementRef, originPos, overlayPos) {
        return new ConnectedPositionStrategy(elementRef, originPos, overlayPos, this._viewportRuler);
    };
    return OverlayPositionBuilder;
}());
OverlayPositionBuilder.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
OverlayPositionBuilder.ctorParameters = function () { return [
    { type: ViewportRuler, },
]; };
/* tslint:disable */
/**
 * Sends an event when the directive's element is scrolled. Registers itself with the
 * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
 * can be listened to through the service.
 */
var Scrollable = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _scroll
     * @param {?} _ngZone
     * @param {?} _renderer
     */
    function Scrollable(_elementRef, _scroll, _ngZone, _renderer) {
        this._elementRef = _elementRef;
        this._scroll = _scroll;
        this._ngZone = _ngZone;
        this._renderer = _renderer;
        this._elementScrolled = new Subject();
    }
    /**
     * @return {?}
     */
    Scrollable.prototype.ngOnInit = function () {
        var _this = this;
        this._scrollListener = this._ngZone.runOutsideAngular(function () {
            return _this._renderer.listen(_this.getElementRef().nativeElement, 'scroll', function (event) {
                _this._elementScrolled.next(event);
            });
        });
        this._scroll.register(this);
    };
    /**
     * @return {?}
     */
    Scrollable.prototype.ngOnDestroy = function () {
        this._scroll.deregister(this);
        if (this._scrollListener) {
            this._scrollListener();
            this._scrollListener = null;
        }
    };
    /**
     * Returns observable that emits when a scroll event is fired on the host element.
     * @return {?}
     */
    Scrollable.prototype.elementScrolled = function () {
        return this._elementScrolled.asObservable();
    };
    /**
     * @return {?}
     */
    Scrollable.prototype.getElementRef = function () {
        return this._elementRef;
    };
    return Scrollable;
}());
Scrollable.decorators = [
    { type: Directive, args: [{
                selector: '[cdk-scrollable], [cdkScrollable]'
            },] },
];
/**
 * @nocollapse
 */
Scrollable.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: ScrollDispatcher, },
    { type: NgZone, },
    { type: Renderer2, },
]; };
/* tslint:disable */
/**
 * Strategy that will close the overlay as soon as the user starts scrolling.
 */
var CloseScrollStrategy = (function () {
    /**
     * @param {?} _scrollDispatcher
     */
    function CloseScrollStrategy(_scrollDispatcher) {
        this._scrollDispatcher = _scrollDispatcher;
        this._scrollSubscription = null;
    }
    /**
     * @param {?} overlayRef
     * @return {?}
     */
    CloseScrollStrategy.prototype.attach = function (overlayRef) {
        this._overlayRef = overlayRef;
    };
    /**
     * @return {?}
     */
    CloseScrollStrategy.prototype.enable = function () {
        var _this = this;
        if (!this._scrollSubscription) {
            this._scrollSubscription = this._scrollDispatcher.scrolled(null, function () {
                if (_this._overlayRef.hasAttached()) {
                    _this._overlayRef.detach();
                }
                _this.disable();
            });
        }
    };
    /**
     * @return {?}
     */
    CloseScrollStrategy.prototype.disable = function () {
        if (this._scrollSubscription) {
            this._scrollSubscription.unsubscribe();
            this._scrollSubscription = null;
        }
    };
    return CloseScrollStrategy;
}());
/* tslint:disable */
/**
 * Strategy that will prevent the user from scrolling while the overlay is visible.
 */
var BlockScrollStrategy = (function () {
    /**
     * @param {?} _viewportRuler
     */
    function BlockScrollStrategy(_viewportRuler) {
        this._viewportRuler = _viewportRuler;
        this._previousHTMLStyles = { top: null, left: null };
        this._isEnabled = false;
    }
    /**
     * @return {?}
     */
    BlockScrollStrategy.prototype.attach = function () { };
    /**
     * @return {?}
     */
    BlockScrollStrategy.prototype.enable = function () {
        if (this._canBeEnabled()) {
            var /** @type {?} */ root = document.documentElement;
            this._previousScrollPosition = this._viewportRuler.getViewportScrollPosition();
            // Cache the previous inline styles in case the user had set them.
            this._previousHTMLStyles.left = root.style.left;
            this._previousHTMLStyles.top = root.style.top;
            // Note: we're using the `html` node, instead of the `body`, because the `body` may
            // have the user agent margin, whereas the `html` is guaranteed not to have one.
            root.style.left = -this._previousScrollPosition.left + "px";
            root.style.top = -this._previousScrollPosition.top + "px";
            root.classList.add('cdk-global-scrollblock');
            this._isEnabled = true;
        }
    };
    /**
     * @return {?}
     */
    BlockScrollStrategy.prototype.disable = function () {
        if (this._isEnabled) {
            this._isEnabled = false;
            document.documentElement.style.left = this._previousHTMLStyles.left;
            document.documentElement.style.top = this._previousHTMLStyles.top;
            document.documentElement.classList.remove('cdk-global-scrollblock');
            window.scroll(this._previousScrollPosition.left, this._previousScrollPosition.top);
        }
    };
    /**
     * @return {?}
     */
    BlockScrollStrategy.prototype._canBeEnabled = function () {
        // Since the scroll strategies can't be singletons, we have to use a global CSS class
        // (`cdk-global-scrollblock`) to make sure that we don't try to disable global
        // scrolling multiple times.
        if (document.documentElement.classList.contains('cdk-global-scrollblock') || this._isEnabled) {
            return false;
        }
        var /** @type {?} */ body = document.body;
        var /** @type {?} */ viewport = this._viewportRuler.getViewportRect();
        return body.scrollHeight > viewport.height || body.scrollWidth > viewport.width;
    };
    return BlockScrollStrategy;
}());
/* tslint:disable */
/**
 * Returns an error to be thrown when attempting to attach an already-attached scroll strategy.
 * @return {?}
 */
function getXpoScrollStrategyAlreadyAttachedError() {
    return Error("Scroll strategy has already been attached.");
}
/* tslint:disable */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Strategy that will update the element position as the user is scrolling.
 */
var RepositionScrollStrategy = (function () {
    /**
     * @param {?} _scrollDispatcher
     * @param {?=} _config
     */
    function RepositionScrollStrategy(_scrollDispatcher, _config) {
        this._scrollDispatcher = _scrollDispatcher;
        this._config = _config;
        this._scrollSubscription = null;
    }
    /**
     * @param {?} overlayRef
     * @return {?}
     */
    RepositionScrollStrategy.prototype.attach = function (overlayRef) {
        if (this._overlayRef) {
            throw getXpoScrollStrategyAlreadyAttachedError();
        }
        this._overlayRef = overlayRef;
    };
    /**
     * @return {?}
     */
    RepositionScrollStrategy.prototype.enable = function () {
        var _this = this;
        if (!this._scrollSubscription) {
            var /** @type {?} */ throttle = this._config ? this._config.scrollThrottle : 0;
            this._scrollSubscription = this._scrollDispatcher.scrolled(throttle, function () {
                _this._overlayRef.updatePosition();
            });
        }
    };
    /**
     * @return {?}
     */
    RepositionScrollStrategy.prototype.disable = function () {
        if (this._scrollSubscription) {
            this._scrollSubscription.unsubscribe();
            this._scrollSubscription = null;
        }
    };
    return RepositionScrollStrategy;
}());
/* tslint:disable */
/**
 * Options for how an overlay will handle scrolling.
 *
 * Users can provide a custom value for `ScrollStrategyOptions` to replace the default
 * behaviors. This class primarily acts as a factory for ScrollStrategy instances.
 */
var ScrollStrategyOptions = (function () {
    /**
     * @param {?} _scrollDispatcher
     * @param {?} _viewportRuler
     */
    function ScrollStrategyOptions(_scrollDispatcher, _viewportRuler) {
        var _this = this;
        this._scrollDispatcher = _scrollDispatcher;
        this._viewportRuler = _viewportRuler;
        /**
         * Do nothing on scroll.
         */
        this.noop = function () { return new NoopScrollStrategy(); };
        /**
         * Close the overlay as soon as the user scrolls.
         */
        this.close = function () { return new CloseScrollStrategy(_this._scrollDispatcher); };
        /**
         * Block scrolling.
         */
        this.block = function () { return new BlockScrollStrategy(_this._viewportRuler); };
        /**
         * Update the overlay's position on scroll.
         * @param config Configuration to be used inside the scroll strategy.
         * Allows debouncing the reposition calls.
         */
        this.reposition = function (config) { return new RepositionScrollStrategy(_this._scrollDispatcher, config); };
    }
    return ScrollStrategyOptions;
}());
ScrollStrategyOptions.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ScrollStrategyOptions.ctorParameters = function () { return [
    { type: ScrollDispatcher, },
    { type: ViewportRuler, },
]; };
/* tslint:disable */
var ScrollDispatchModule = (function () {
    function ScrollDispatchModule() {
    }
    return ScrollDispatchModule;
}());
ScrollDispatchModule.decorators = [
    { type: NgModule, args: [{
                imports: [PlatformModule],
                exports: [Scrollable],
                declarations: [Scrollable],
                providers: [SCROLL_DISPATCHER_PROVIDER, ScrollStrategyOptions],
            },] },
];
/**
 * @nocollapse
 */
ScrollDispatchModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Next overlay unique ID.
 */
var nextUniqueId = 0;
/**
 * The default config for newly created overlays.
 */
var defaultConfig = new OverlayConfig();
/**
 * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
 * used as a low-level building building block for other components. Dialogs, tooltips, menus,
 * selects, etc. can all be built using overlays. The service should primarily be used by authors
 * of re-usable components rather than developers building end-user applications.
 *
 * An overlay *is* a PortalHost, so any kind of Portal can be loaded into one.
 */
var Overlay = (function () {
    /**
     * @param {?} scrollStrategies
     * @param {?} _overlayContainer
     * @param {?} _componentFactoryResolver
     * @param {?} _positionBuilder
     * @param {?} _appRef
     * @param {?} _injector
     * @param {?} _ngZone
     */
    function Overlay(scrollStrategies, _overlayContainer, _componentFactoryResolver, _positionBuilder, _appRef, _injector, _ngZone) {
        this.scrollStrategies = scrollStrategies;
        this._overlayContainer = _overlayContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._positionBuilder = _positionBuilder;
        this._appRef = _appRef;
        this._injector = _injector;
        this._ngZone = _ngZone;
    }
    /**
     * Creates an overlay.
     * @param {?=} config Config to apply to the overlay.
     * @return {?} Reference to the created overlay.
     */
    Overlay.prototype.create = function (config) {
        if (config === void 0) { config = defaultConfig; }
        var /** @type {?} */ pane = this._createPaneElement();
        var /** @type {?} */ portalHost = this._createPortalHost(pane);
        return new OverlayRef(portalHost, pane, config, this._ngZone);
    };
    /**
     * Returns a position builder that can be used, via fluent API,
     * to construct and configure a position strategy.
     * @return {?}
     */
    Overlay.prototype.position = function () {
        return this._positionBuilder;
    };
    /**
     * Creates the DOM element for an overlay and appends it to the overlay container.
     * @return {?} Newly-created pane element
     */
    Overlay.prototype._createPaneElement = function () {
        var /** @type {?} */ pane = document.createElement('div');
        pane.id = "cdk-overlay-" + nextUniqueId++;
        pane.classList.add('cdk-overlay-pane');
        this._overlayContainer.getContainerElement().appendChild(pane);
        return pane;
    };
    /**
     * Create a DomPortalHost into which the overlay content can be loaded.
     * @param {?} pane The DOM element to turn into a portal host.
     * @return {?} A portal host for the given DOM element.
     */
    Overlay.prototype._createPortalHost = function (pane) {
        return new DomPortalHost(pane, this._componentFactoryResolver, this._appRef, this._injector);
    };
    return Overlay;
}());
Overlay.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Overlay.ctorParameters = function () { return [
    { type: ScrollStrategyOptions, },
    { type: OverlayContainer, },
    { type: ComponentFactoryResolver, },
    { type: OverlayPositionBuilder, },
    { type: ApplicationRef, },
    { type: Injector, },
    { type: NgZone, },
]; };
/**
 * OverlayState is a bag of values for either the initial configuration or current state of an
 * overlay.
 */
var OverlayState = (function () {
    function OverlayState() {
        /**
         * Custom class to add to the overlay pane.
         */
        this.panelClass = '';
        /**
         * Whether the overlay has a backdrop.
         */
        this.hasBackdrop = false;
        /**
         * Custom class to add to the backdrop
         */
        this.backdropClass = 'cdk-overlay-dark-backdrop';
        /**
         * The direction of the text in the overlay panel.
         */
        this.direction = 'ltr';
        // TODO(jelbourn): configuration still to add
        // - focus trap
        // - disable pointer events
        // - z-index
    }
    return OverlayState;
}());
/**
 * Directive to listen for changes of direction of part of the DOM.
 *
 * Applications should use this directive instead of the native attribute so that Material
 * components can listen on changes of direction.
 */
var Dir = (function () {
    function Dir() {
        /**
         * Layout direction of the element.
         */
        this._dir = 'ltr';
        /**
         * Event emitted when the direction changes.
         */
        this.dirChange = new EventEmitter();
    }
    Object.defineProperty(Dir.prototype, "dir", {
        /**
         * \@docs-private
         * @return {?}
         */
        get: function () {
            return this._dir;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            var /** @type {?} */ old = this._dir;
            this._dir = v;
            if (old != this._dir) {
                this.dirChange.emit();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dir.prototype, "value", {
        /**
         * Current layout direction of the element.
         * @return {?}
         */
        get: function () { return this.dir; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.dir = v; },
        enumerable: true,
        configurable: true
    });
    return Dir;
}());
Dir.decorators = [
    { type: Directive, args: [{
                selector: '[dir]',
                // TODO(hansl): maybe `$implicit` isn't the best option here, but for now that's the best we got.
                exportAs: '$implicit',
            },] },
];
/**
 * @nocollapse
 */
Dir.ctorParameters = function () { return []; };
Dir.propDecorators = {
    '_dir': [{ type: Input, args: ['dir',] },],
    'dirChange': [{ type: Output },],
    'dir': [{ type: HostBinding, args: ['attr.dir',] },],
};
var RtlModule = (function () {
    function RtlModule() {
    }
    return RtlModule;
}());
RtlModule.decorators = [
    { type: NgModule, args: [{
                exports: [Dir],
                declarations: [Dir],
            },] },
];
/**
 * @nocollapse
 */
RtlModule.ctorParameters = function () { return []; };
/* tslint:disable */
/**
 * Default set of positions for the overlay. Follows the behavior of a dropdown.
 */
var defaultPositionList = [
    new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
    new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' }),
];
/**
 * Directive applied to an element to make it usable as an origin for an Overlay using a
 * ConnectedPositionStrategy.
 */
var OverlayOrigin = (function () {
    /**
     * @param {?} elementRef
     */
    function OverlayOrigin(elementRef) {
        this.elementRef = elementRef;
    }
    return OverlayOrigin;
}());
OverlayOrigin.decorators = [
    { type: Directive, args: [{
                selector: '[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]',
                exportAs: 'cdkOverlayOrigin',
            },] },
];
/**
 * @nocollapse
 */
OverlayOrigin.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
/**
 * Directive to facilitate declarative creation of an Overlay using a ConnectedPositionStrategy.
 */
var ConnectedOverlayDirective = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _renderer
     * @param {?} _scrollDispatcher
     * @param {?} templateRef
     * @param {?} viewContainerRef
     * @param {?} _dir
     */
    function ConnectedOverlayDirective(_overlay, _renderer, _scrollDispatcher, templateRef, viewContainerRef, _dir) {
        this._overlay = _overlay;
        this._renderer = _renderer;
        this._scrollDispatcher = _scrollDispatcher;
        this._dir = _dir;
        this._hasBackdrop = false;
        this._offsetX = 0;
        this._offsetY = 0;
        /**
         * Strategy to be used when handling scroll events while the overlay is open.
         */
        this.scrollStrategy = new RepositionScrollStrategy(this._scrollDispatcher);
        /**
         * Whether the overlay is open.
         */
        this.open = false;
        /**
         * Event emitted when the backdrop is clicked.
         */
        this.backdropClick = new EventEmitter();
        /**
         * Event emitted when the position has changed.
         */
        this.positionChange = new EventEmitter();
        /**
         * Event emitted when the overlay has been attached.
         */
        this.attach = new EventEmitter();
        /**
         * Event emitted when the overlay has been detached.
         */
        this.detach = new EventEmitter();
        this._templatePortal = new TemplatePortal(templateRef, viewContainerRef);
    }
    Object.defineProperty(ConnectedOverlayDirective.prototype, "offsetX", {
        /**
         * The offset in pixels for the overlay connection point on the x-axis
         * @return {?}
         */
        get: function () {
            return this._offsetX;
        },
        /**
         * @param {?} offsetX
         * @return {?}
         */
        set: function (offsetX) {
            this._offsetX = offsetX;
            if (this._position) {
                this._position.withOffsetX(offsetX);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "offsetY", {
        /**
         * The offset in pixels for the overlay connection point on the y-axis
         * @return {?}
         */
        get: function () {
            return this._offsetY;
        },
        /**
         * @param {?} offsetY
         * @return {?}
         */
        set: function (offsetY) {
            this._offsetY = offsetY;
            if (this._position) {
                this._position.withOffsetY(offsetY);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "hasBackdrop", {
        /**
         * Whether or not the overlay should attach a backdrop.
         * @return {?}
         */
        get: function () {
            return this._hasBackdrop;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._hasBackdrop = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "overlayRef", {
        /**
         * The associated overlay reference.
         * @return {?}
         */
        get: function () {
            return this._overlayRef;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "dir", {
        /**
         * The element's layout direction.
         * @return {?}
         */
        get: function () {
            return this._dir ? this._dir.value : 'ltr';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ConnectedOverlayDirective.prototype.ngOnDestroy = function () {
        this._destroyOverlay();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    ConnectedOverlayDirective.prototype.ngOnChanges = function (changes) {
        if (changes['open']) {
            this.open ? this._attachOverlay() : this._detachOverlay();
        }
    };
    /**
     * Creates an overlay
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._createOverlay = function () {
        if (!this.positions || !this.positions.length) {
            this.positions = defaultPositionList;
        }
        this._overlayRef = this._overlay.create(this._buildConfig());
    };
    /**
     * Builds the overlay config based on the directive's inputs
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._buildConfig = function () {
        var /** @type {?} */ overlayConfig = new OverlayState();
        if (this.width || this.width === 0) {
            overlayConfig.width = this.width;
        }
        if (this.height || this.height === 0) {
            overlayConfig.height = this.height;
        }
        if (this.minWidth || this.minWidth === 0) {
            overlayConfig.minWidth = this.minWidth;
        }
        if (this.minHeight || this.minHeight === 0) {
            overlayConfig.minHeight = this.minHeight;
        }
        overlayConfig.hasBackdrop = this.hasBackdrop;
        if (this.backdropClass) {
            overlayConfig.backdropClass = this.backdropClass;
        }
        this._position = (this._createPositionStrategy());
        overlayConfig.positionStrategy = this._position;
        overlayConfig.scrollStrategy = this.scrollStrategy;
        return overlayConfig;
    };
    /**
     * Returns the position strategy of the overlay to be set on the overlay config
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._createPositionStrategy = function () {
        var /** @type {?} */ pos = this.positions[0];
        var /** @type {?} */ originPoint = { originX: pos.originX, originY: pos.originY };
        var /** @type {?} */ overlayPoint = { overlayX: pos.overlayX, overlayY: pos.overlayY };
        var /** @type {?} */ strategy = this._overlay.position()
            .connectedTo(this.origin.elementRef, originPoint, overlayPoint)
            .withOffsetX(this.offsetX)
            .withOffsetY(this.offsetY);
        this._handlePositionChanges(strategy);
        return strategy;
    };
    /**
     * @param {?} strategy
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._handlePositionChanges = function (strategy) {
        var _this = this;
        for (var /** @type {?} */ i = 1; i < this.positions.length; i++) {
            strategy.withFallbackPosition({ originX: this.positions[i].originX, originY: this.positions[i].originY }, { overlayX: this.positions[i].overlayX, overlayY: this.positions[i].overlayY });
        }
        this._positionSubscription =
            strategy.onPositionChange.subscribe(function (pos) { return _this.positionChange.emit(pos); });
    };
    /**
     * Attaches the overlay and subscribes to backdrop clicks if backdrop exists
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._attachOverlay = function () {
        var _this = this;
        if (!this._overlayRef) {
            this._createOverlay();
        }
        this._position.withDirection(this.dir);
        this._overlayRef.getConfig().direction = this.dir;
        this._initEscapeListener();
        if (!this._overlayRef.hasAttached()) {
            this._overlayRef.attach(this._templatePortal);
            this.attach.emit();
        }
        if (this.hasBackdrop) {
            this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function () {
                _this.backdropClick.emit();
            });
        }
    };
    /**
     * Detaches the overlay and unsubscribes to backdrop clicks if backdrop exists
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._detachOverlay = function () {
        if (this._overlayRef) {
            this._overlayRef.detach();
            this.detach.emit();
        }
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
            this._backdropSubscription = null;
        }
        if (this._escapeListener) {
            this._escapeListener();
        }
    };
    /**
     * Destroys the overlay created by this directive.
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._destroyOverlay = function () {
        if (this._overlayRef) {
            this._overlayRef.dispose();
        }
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
        }
        if (this._positionSubscription) {
            this._positionSubscription.unsubscribe();
        }
        if (this._escapeListener) {
            this._escapeListener();
        }
    };
    /**
     * Sets the event listener that closes the overlay when pressing Escape.
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._initEscapeListener = function () {
        var _this = this;
        this._escapeListener = this._renderer.listen('document', 'keydown', function (event) {
            if (event.keyCode === ESCAPE) {
                _this._detachOverlay();
            }
        });
    };
    return ConnectedOverlayDirective;
}());
ConnectedOverlayDirective.decorators = [
    { type: Directive, args: [{
                selector: '[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]',
                exportAs: 'cdkConnectedOverlay'
            },] },
];
/**
 * @nocollapse
 */
ConnectedOverlayDirective.ctorParameters = function () { return [
    { type: Overlay, },
    { type: Renderer2, },
    { type: ScrollDispatcher, },
    { type: TemplateRef, },
    { type: ViewContainerRef, },
    { type: Dir, decorators: [{ type: Optional },] },
]; };
ConnectedOverlayDirective.propDecorators = {
    'origin': [{ type: Input },],
    'positions': [{ type: Input },],
    'offsetX': [{ type: Input },],
    'offsetY': [{ type: Input },],
    'width': [{ type: Input },],
    'height': [{ type: Input },],
    'minWidth': [{ type: Input },],
    'minHeight': [{ type: Input },],
    'backdropClass': [{ type: Input },],
    'scrollStrategy': [{ type: Input },],
    'open': [{ type: Input },],
    'hasBackdrop': [{ type: Input },],
    'backdropClick': [{ type: Output },],
    'positionChange': [{ type: Output },],
    'attach': [{ type: Output },],
    'detach': [{ type: Output },],
};
/**
 * The FullscreenOverlayContainer is the alternative to OverlayContainer
 * that supports correct displaying of overlay elements in Fullscreen mode
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullScreen
 * It should be provided in the root component that way:
 * providers: [
 *   {provide: OverlayContainer, useClass: FullscreenOverlayContainer}
 * ],
 */
var FullscreenOverlayContainer = (function (_super) {
    __extends(FullscreenOverlayContainer, _super);
    function FullscreenOverlayContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._createContainer = function () {
        var _this = this;
        _super.prototype._createContainer.call(this);
        this._adjustParentForFullscreenChange();
        this._addFullscreenChangeListener(function () { return _this._adjustParentForFullscreenChange(); });
    };
    /**
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._adjustParentForFullscreenChange = function () {
        if (!this._containerElement) {
            return;
        }
        var /** @type {?} */ fullscreenElement = this.getFullscreenElement();
        var /** @type {?} */ parent = fullscreenElement || document.body;
        parent.appendChild(this._containerElement);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._addFullscreenChangeListener = function (fn) {
        if (document.fullscreenEnabled) {
            document.addEventListener('fullscreenchange', fn);
        }
        else if (document.webkitFullscreenEnabled) {
            document.addEventListener('webkitfullscreenchange', fn);
        }
        else if (((document)).mozFullScreenEnabled) {
            document.addEventListener('mozfullscreenchange', fn);
        }
        else if (((document)).msFullscreenEnabled) {
            document.addEventListener('MSFullscreenChange', fn);
        }
    };
    /**
     * When the page is put into fullscreen mode, a specific element is specified.
     * Only that element and its children are visible when in fullscreen mode.
     * @return {?}
     */
    FullscreenOverlayContainer.prototype.getFullscreenElement = function () {
        return document.fullscreenElement ||
            document.webkitFullscreenElement ||
            ((document)).mozFullScreenElement ||
            ((document)).msFullscreenElement ||
            null;
    };
    return FullscreenOverlayContainer;
}(OverlayContainer));
FullscreenOverlayContainer.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
FullscreenOverlayContainer.ctorParameters = function () { return []; };
var OVERLAY_PROVIDERS = [
    Overlay,
    OverlayPositionBuilder,
    VIEWPORT_RULER_PROVIDER,
    OVERLAY_CONTAINER_PROVIDER,
];
var OverlayModule = (function () {
    function OverlayModule() {
    }
    return OverlayModule;
}());
OverlayModule.decorators = [
    { type: NgModule, args: [{
                imports: [PortalModule, ScrollDispatchModule],
                exports: [ConnectedOverlayDirective, OverlayOrigin, ScrollDispatchModule],
                declarations: [ConnectedOverlayDirective, OverlayOrigin],
                providers: [OVERLAY_PROVIDERS],
            },] },
];
/**
 * @nocollapse
 */
OverlayModule.ctorParameters = function () { return []; };
var RippleState = {};
RippleState.FADING_IN = 0;
RippleState.VISIBLE = 1;
RippleState.FADING_OUT = 2;
RippleState.HIDDEN = 3;
RippleState[RippleState.FADING_IN] = "FADING_IN";
RippleState[RippleState.VISIBLE] = "VISIBLE";
RippleState[RippleState.FADING_OUT] = "FADING_OUT";
RippleState[RippleState.HIDDEN] = "HIDDEN";
/**
 * Reference to a previously launched ripple element.
 */
var RippleRef = (function () {
    /**
     * @param {?} _renderer
     * @param {?} element
     * @param {?} config
     */
    function RippleRef(_renderer, element, config) {
        this._renderer = _renderer;
        this.element = element;
        this.config = config;
        /**
         * Current state of the ripple reference.
         */
        this.state = RippleState.HIDDEN;
    }
    /**
     * Fades out the ripple element.
     * @return {?}
     */
    RippleRef.prototype.fadeOut = function () {
        this._renderer.fadeOutRipple(this);
    };
    return RippleRef;
}());
/* tslint:disable */
/**
 * Fade-in duration for the ripples. Can be modified with the speedFactor option.
 */
var RIPPLE_FADE_IN_DURATION = 450;
/**
 * Fade-out duration for the ripples in milliseconds. This can't be modified by the speedFactor.
 */
var RIPPLE_FADE_OUT_DURATION = 400;
/**
 * Helper service that performs DOM manipulations. Not intended to be used outside this module.
 * The constructor takes a reference to the ripple directive's host element and a map of DOM
 * event handlers to be installed on the element that triggers ripple animations.
 * This will eventually become a custom renderer once Angular support exists.
 * \@docs-private
 */
var RippleRenderer = (function () {
    /**
     * @param {?} elementRef
     * @param {?} _ngZone
     * @param {?} _ruler
     * @param {?} platform
     */
    function RippleRenderer(elementRef, _ngZone, _ruler, platform) {
        this._ngZone = _ngZone;
        this._ruler = _ruler;
        /**
         * Whether the mouse is currently down or not.
         */
        this._isMousedown = false;
        /**
         * Events to be registered on the trigger element.
         */
        this._triggerEvents = new Map();
        /**
         * Set of currently active ripple references.
         */
        this._activeRipples = new Set();
        /**
         * Ripple config for all ripples created by events.
         */
        this.rippleConfig = {};
        /**
         * Whether mouse ripples should be created or not.
         */
        this.rippleDisabled = false;
        // Only do anything if we're on the browser.
        //if (platform.isBrowser) {
        this._containerElement = elementRef.nativeElement;
        // Specify events which need to be registered on the trigger.
        this._triggerEvents.set('mousedown', this.onMousedown.bind(this));
        this._triggerEvents.set('mouseup', this.onMouseup.bind(this));
        this._triggerEvents.set('mouseleave', this.onMouseLeave.bind(this));
        // By default use the host element as trigger element.
        this.setTriggerElement(this._containerElement);
        //  }
    }
    /**
     * Fades in a ripple at the given coordinates.
     * @param {?} pageX
     * @param {?} pageY
     * @param {?=} config
     * @return {?}
     */
    RippleRenderer.prototype.fadeInRipple = function (pageX, pageY, config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        var /** @type {?} */ containerRect = this._containerElement.getBoundingClientRect();
        if (config.centered) {
            pageX = containerRect.left + containerRect.width / 2;
            pageY = containerRect.top + containerRect.height / 2;
        }
        else {
            // Subtract scroll values from the coordinates because calculations below
            // are always relative to the viewport rectangle.
            var /** @type {?} */ scrollPosition = this._ruler.getViewportScrollPosition();
            pageX -= scrollPosition.left;
            pageY -= scrollPosition.top;
        }
        var /** @type {?} */ radius = config.radius || distanceToFurthestCorner(pageX, pageY, containerRect);
        var /** @type {?} */ duration = RIPPLE_FADE_IN_DURATION * (1 / (config.speedFactor || 1));
        var /** @type {?} */ offsetX = pageX - containerRect.left;
        var /** @type {?} */ offsetY = pageY - containerRect.top;
        var /** @type {?} */ ripple = document.createElement('div');
        ripple.classList.add('xpo-ripple-element');
        ripple.style.left = offsetX - radius + "px";
        ripple.style.top = offsetY - radius + "px";
        ripple.style.height = radius * 2 + "px";
        ripple.style.width = radius * 2 + "px";
        // If the color is not set, the default CSS color will be used.
        ripple.style.backgroundColor = config.color;
        ripple.style.transitionDuration = duration + "ms";
        this._containerElement.appendChild(ripple);
        // By default the browser does not recalculate the styles of dynamically created
        // ripple elements. This is critical because then the `scale` would not animate properly.
        enforceStyleRecalculation(ripple);
        ripple.style.transform = 'scale(1)';
        // Exposed reference to the ripple that will be returned.
        var /** @type {?} */ rippleRef = new RippleRef(this, ripple, config);
        rippleRef.state = RippleState.FADING_IN;
        // Add the ripple reference to the list of all active ripples.
        this._activeRipples.add(rippleRef);
        // Wait for the ripple element to be completely faded in.
        // Once it's faded in, the ripple can be hidden immediately if the mouse is released.
        this.runTimeoutOutsideZone(function () {
            rippleRef.state = RippleState.VISIBLE;
            if (!config.persistent && !_this._isMousedown) {
                rippleRef.fadeOut();
            }
        }, duration);
        return rippleRef;
    };
    /**
     * Fades out a ripple reference.
     * @param {?} rippleRef
     * @return {?}
     */
    RippleRenderer.prototype.fadeOutRipple = function (rippleRef) {
        // For ripples that are not active anymore, don't re-un the fade-out animation.
        if (!this._activeRipples.delete(rippleRef)) {
            return;
        }
        var /** @type {?} */ rippleEl = rippleRef.element;
        rippleEl.style.transitionDuration = RIPPLE_FADE_OUT_DURATION + "ms";
        rippleEl.style.opacity = '0';
        rippleRef.state = RippleState.FADING_OUT;
        // Once the ripple faded out, the ripple can be safely removed from the DOM.
        this.runTimeoutOutsideZone(function () {
            rippleRef.state = RippleState.HIDDEN;
            rippleEl.parentNode.removeChild(rippleEl);
        }, RIPPLE_FADE_OUT_DURATION);
    };
    /**
     * Fades out all currently active ripples.
     * @return {?}
     */
    RippleRenderer.prototype.fadeOutAll = function () {
        this._activeRipples.forEach(function (ripple) { return ripple.fadeOut(); });
    };
    /**
     * Sets the trigger element and registers the mouse events.
     * @param {?} element
     * @return {?}
     */
    RippleRenderer.prototype.setTriggerElement = function (element) {
        var _this = this;
        // Remove all previously register event listeners from the trigger element.
        if (this._triggerElement) {
            this._triggerEvents.forEach(function (fn, type) { return _this._triggerElement.removeEventListener(type, fn); });
        }
        if (element) {
            // If the element is not null, register all event listeners on the trigger element.
            this._ngZone.runOutsideAngular(function () {
                _this._triggerEvents.forEach(function (fn, type) { return element.addEventListener(type, fn); });
            });
        }
        this._triggerElement = element;
    };
    /**
     * Listener being called on mousedown event.
     * @param {?} event
     * @return {?}
     */
    RippleRenderer.prototype.onMousedown = function (event) {
        if (!this.rippleDisabled) {
            this._isMousedown = true;
            this.fadeInRipple(event.pageX, event.pageY, this.rippleConfig);
        }
    };
    /**
     * Listener being called on mouseup event.
     * @return {?}
     */
    RippleRenderer.prototype.onMouseup = function () {
        this._isMousedown = false;
        // Fade-out all ripples that are completely visible and not persistent.
        this._activeRipples.forEach(function (ripple) {
            if (!ripple.config.persistent && ripple.state === RippleState.VISIBLE) {
                ripple.fadeOut();
            }
        });
    };
    /**
     * Listener being called on mouseleave event.
     * @return {?}
     */
    RippleRenderer.prototype.onMouseLeave = function () {
        if (this._isMousedown) {
            this.onMouseup();
        }
    };
    /**
     * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
     * @param {?} fn
     * @param {?=} delay
     * @return {?}
     */
    RippleRenderer.prototype.runTimeoutOutsideZone = function (fn, delay$$1) {
        if (delay$$1 === void 0) { delay$$1 = 0; }
        this._ngZone.runOutsideAngular(function () { return setTimeout(fn, delay$$1); });
    };
    return RippleRenderer;
}());
/**
 * @param {?} element
 * @return {?}
 */
function enforceStyleRecalculation(element) {
    // Enforce a style recalculation by calling `getComputedStyle` and accessing any property.
    // Calling `getPropertyValue` is important to let optimizers know that this is not a noop.
    // See: https://gist.github.com/paulirish/5d52fb081b3570c81e3a
    window.getComputedStyle(element).getPropertyValue('opacity');
}
/**
 * Returns the distance from the point (x, y) to the furthest corner of a rectangle.
 * @param {?} x
 * @param {?} y
 * @param {?} rect
 * @return {?}
 */
function distanceToFurthestCorner(x, y, rect) {
    var /** @type {?} */ distX = Math.max(Math.abs(x - rect.left), Math.abs(x - rect.right));
    var /** @type {?} */ distY = Math.max(Math.abs(y - rect.top), Math.abs(y - rect.bottom));
    return Math.sqrt(distX * distX + distY * distY);
}
/**
 * Injection token that can be used to specify the global ripple options.
 */
var XPO_RIPPLE_GLOBAL_OPTIONS = new InjectionToken('xpo-ripple-global-options');
var XpoRipple = (function () {
    /**
     * @param {?} elementRef
     * @param {?} ngZone
     * @param {?} ruler
     * @param {?} platform
     * @param {?} globalOptions
     */
    function XpoRipple(elementRef, ngZone, ruler, platform, globalOptions) {
        /**
         * If set, the radius in pixels of foreground ripples when fully expanded. If unset, the radius
         * will be the distance from the center of the ripple to the furthest corner of the host element's
         * bounding rectangle.
         */
        this.radius = 0;
        /**
         * If set, the normal duration of ripple animations is divided by this value. For example,
         * setting it to 0.5 will cause the animations to take twice as long.
         * A changed speedFactor will not modify the fade-out duration of the ripples.
         */
        this.speedFactor = 1;
        this._rippleRenderer = new RippleRenderer(elementRef, ngZone, ruler, platform);
        this._globalOptions = globalOptions ? globalOptions : {};
        this._updateRippleRenderer();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    XpoRipple.prototype.ngOnChanges = function (changes) {
        if (changes['trigger'] && this.trigger) {
            this._rippleRenderer.setTriggerElement(this.trigger);
        }
        this._updateRippleRenderer();
    };
    /**
     * @return {?}
     */
    XpoRipple.prototype.ngOnDestroy = function () {
        // Set the trigger element to null to cleanup all listeners.
        this._rippleRenderer.setTriggerElement(null);
    };
    /**
     * Launches a manual ripple at the specified position.
     * @param {?} pageX
     * @param {?} pageY
     * @param {?=} config
     * @return {?}
     */
    XpoRipple.prototype.launch = function (pageX, pageY, config) {
        if (config === void 0) { config = this.rippleConfig; }
        return this._rippleRenderer.fadeInRipple(pageX, pageY, config);
    };
    /**
     * Fades out all currently showing ripple elements.
     * @return {?}
     */
    XpoRipple.prototype.fadeOutAll = function () {
        this._rippleRenderer.fadeOutAll();
    };
    Object.defineProperty(XpoRipple.prototype, "rippleConfig", {
        /**
         * Ripple configuration from the directive's input values.
         * @return {?}
         */
        get: function () {
            return {
                centered: this.centered,
                speedFactor: this.speedFactor * (this._globalOptions.baseSpeedFactor || 1),
                radius: this.radius,
                color: this.color,
            };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Updates the ripple renderer with the latest ripple configuration.
     * @return {?}
     */
    XpoRipple.prototype._updateRippleRenderer = function () {
        this._rippleRenderer.rippleDisabled = this._globalOptions.disabled || this.disabled;
        this._rippleRenderer.rippleConfig = this.rippleConfig;
    };
    return XpoRipple;
}());
XpoRipple.decorators = [
    { type: Directive, args: [{
                selector: '[xpo-ripple], [xpo-ripple], [xpoRipple], [matRipple]',
                exportAs: 'xpoRipple',
                host: {
                    'class': 'xpo-ripple',
                    '[class.xpo-ripple-unbounded]': 'unbounded',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoRipple.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: NgZone, },
    { type: ViewportRuler, },
    { type: Platform, },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [XPO_RIPPLE_GLOBAL_OPTIONS,] },] },
]; };
XpoRipple.propDecorators = {
    'trigger': [{ type: Input, args: ['xpoRippleTrigger',] },],
    'centered': [{ type: Input, args: ['xpoRippleCentered',] },],
    'disabled': [{ type: Input, args: ['xpoRippleDisabled',] },],
    'radius': [{ type: Input, args: ['xpoRippleRadius',] },],
    'speedFactor': [{ type: Input, args: ['xpoRippleSpeedFactor',] },],
    'color': [{ type: Input, args: ['xpoRippleColor',] },],
    'unbounded': [{ type: Input, args: ['xpoRippleUnbounded',] },],
};
var XpoRippleModule = (function () {
    function XpoRippleModule() {
    }
    return XpoRippleModule;
}());
XpoRippleModule.decorators = [
    { type: NgModule, args: [{
                imports: [XpoCommonModule, PlatformModule, ScrollDispatchModule],
                exports: [XpoRipple, XpoCommonModule],
                declarations: [XpoRipple],
                providers: [VIEWPORT_RULER_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
XpoRippleModule.ctorParameters = function () { return []; };
/**
 * Wrapper around Error that sets the error message.
 * \@docs-private
 */
var XpoError = (function (_super) {
    __extends(XpoError, _super);
    /**
     * @param {?} value
     */
    function XpoError(value) {
        var _this = _super.call(this) || this;
        _this.message = value;
        return _this;
    }
    return XpoError;
}(Error));
/**
 * @license
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Injection token used to inject the document into Directionality.
 * This is used so that the value can be faked in tests.
 *
 * We can't use the real document in tests because changing the real `dir` causes geometry-based
 * tests in Safari to fail.
 *
 * We also can't re-provide the DOCUMENT token from platform-brower because the unit tests
 * themselves use things like `querySelector` in test code.
 */
var DIR_DOCUMENT = new InjectionToken('md-dir-doc');
/**
 * The directionality (LTR / RTL) context for the application (or a subtree of it).
 * Exposes the current direction and a stream of direction changes.
 */
var Directionality = (function () {
    /**
     * @param {?=} _document
     */
    function Directionality(_document) {
        this.value = 'ltr';
        this.change = new EventEmitter();
        if (_document) {
            // TODO: handle 'auto' value -
            // We still need to account for dir="auto".
            // It looks like HTMLElemenet.dir is also "auto" when that's set to the attribute,
            // but getComputedStyle return either "ltr" or "rtl". avoiding getComputedStyle for now
            var bodyDir = _document.body ? _document.body.dir : null;
            var htmlDir = _document.documentElement ? _document.documentElement.dir : null;
            this.value = (bodyDir || htmlDir || 'ltr');
        }
    }
    return Directionality;
}());
Directionality.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Directionality.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DIR_DOCUMENT,] },] },
]; };
/**
 * @param {?} parentDirectionality
 * @param {?} _document
 * @return {?}
 */
function DIRECTIONALITY_PROVIDER_FACTORY(parentDirectionality, _document) {
    return parentDirectionality || new Directionality(_document);
}
var DIRECTIONALITY_PROVIDER = {
    // If there is already a Directionality available, use that. Otherwise, provide a new one.
    provide: Directionality,
    deps: [[new Optional(), new SkipSelf(), Directionality], [new Optional(), DOCUMENT]],
    useFactory: DIRECTIONALITY_PROVIDER_FACTORY,
};
/**
 * @license
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Directive to listen for changes of direction of part of the DOM.
 *
 * Would provide itself in case a component looks for the Directionality service
 */
var Dir$1 = (function () {
    function Dir$1() {
        /**
         * Layout direction of the element.
         */
        this._dir = 'ltr';
        /**
         * Whether the `value` has been set to its initial value.
         */
        this._isInitialized = false;
        /**
         * Event emitted when the direction changes.
         */
        this.change = new EventEmitter();
    }
    Object.defineProperty(Dir$1.prototype, "dir", {
        /**
         * \@docs-private
         * @return {?}
         */
        get: function () {
            return this._dir;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            var /** @type {?} */ old = this._dir;
            this._dir = v;
            if (old !== this._dir && this._isInitialized) {
                this.change.emit();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dir$1.prototype, "value", {
        /**
         * Current layout direction of the element.
         * @return {?}
         */
        get: function () { return this.dir; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.dir = v; },
        enumerable: true,
        configurable: true
    });
    /**
     * Initialize once default value has been set.
     * @return {?}
     */
    Dir$1.prototype.ngAfterContentInit = function () {
        this._isInitialized = true;
    };
    return Dir$1;
}());
Dir$1.decorators = [
    { type: Directive, args: [{
                selector: '[dir]',
                // TODO(hansl): maybe `$implicit` isn't the best option here, but for now that's the best we got.
                exportAs: '$implicit',
                providers: [
                    { provide: Directionality, useExisting: Dir$1 },
                ],
            },] },
];
/**
 * @nocollapse
 */
Dir$1.ctorParameters = function () { return []; };
Dir$1.propDecorators = {
    'change': [{ type: Output, args: ['dirChange',] },],
    'dir': [{ type: HostBinding, args: ['attr.dir',] }, { type: Input, args: ['dir',] },],
};
/* tslint:disable */
/**
 * @license
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var BidiModule = (function () {
    function BidiModule() {
    }
    return BidiModule;
}());
BidiModule.decorators = [
    { type: NgModule, args: [{
                exports: [Dir$1],
                declarations: [Dir$1],
                providers: [
                    { provide: DIR_DOCUMENT, useExisting: DOCUMENT },
                    Directionality,
                ]
            },] },
];
/**
 * @nocollapse
 */
BidiModule.ctorParameters = function () { return []; };
var GestureConfig = (function (_super) {
    __extends(GestureConfig, _super);
    function GestureConfig() {
        var _this = _super.call(this) || this;
        _this._hammer = typeof window !== 'undefined' ? ((window)).Hammer : null;
        /* List of new event names to add to the gesture support list */
        _this.events = _this._hammer ? [
            'longpress',
            'slide',
            'slidestart',
            'slideend',
            'slideright',
            'slideleft',
        ] : [];
        if (!_this._hammer && isDevMode()) {
            console.warn('Could not find HammerJS. Certain Angular Material ' +
                'components may not work correctly.');
        }
        return _this;
    }
    /**
     * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
     *
     * Our gesture names come from the Material Design gestures spec:
     * https://www.google.com/design/spec/patterns/gestures.html#gestures-touch-mechanics
     *
     * More information on default recognizers can be found in Hammer docs:
     * http://hammerjs.github.io/recognizer-pan/
     * http://hammerjs.github.io/recognizer-press/
     *
     * @param {?} element Element to which to assign the new HammerJS gestures.
     * @return {?} Newly-created HammerJS instance.
     */
    GestureConfig.prototype.buildHammer = function (element) {
        var /** @type {?} */ mc = new this._hammer(element);
        // Default Hammer Recognizers.
        var /** @type {?} */ pan = new this._hammer.Pan();
        var /** @type {?} */ swipe = new this._hammer.Swipe();
        var /** @type {?} */ press = new this._hammer.Press();
        // Notice that a HammerJS recognizer can only depend on one other recognizer once.
        // Otherwise the previous `recognizeWith` will be dropped.
        // TODO: Confirm threshold numbers with Material Design UX Team
        var /** @type {?} */ slide = this._createRecognizer(pan, { event: 'slide', threshold: 0 }, swipe);
        var /** @type {?} */ longpress = this._createRecognizer(press, { event: 'longpress', time: 500 });
        // Overwrite the default `pan` event to use the swipe event.
        pan.recognizeWith(swipe);
        // Add customized gestures to Hammer manager
        mc.add([swipe, press, pan, slide, longpress]);
        return (mc);
    };
    /**
     * Creates a new recognizer, without affecting the default recognizers of HammerJS
     * @param {?} base
     * @param {?} options
     * @param {...?} inheritances
     * @return {?}
     */
    GestureConfig.prototype._createRecognizer = function (base, options) {
        var inheritances = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            inheritances[_i - 2] = arguments[_i];
        }
        var /** @type {?} */ recognizer = new ((base.constructor))(options);
        inheritances.push(base);
        inheritances.forEach(function (item) { return recognizer.recognizeWith(item); });
        return recognizer;
    };
    return GestureConfig;
}(HammerGestureConfig));
GestureConfig.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
GestureConfig.ctorParameters = function () { return []; };
var LIVE_ANNOUNCER_ELEMENT_TOKEN = new InjectionToken('liveAnnouncerElement');
var LiveAnnouncer = (function () {
    /**
     * @param {?} elementToken
     * @param {?} platform
     */
    function LiveAnnouncer(elementToken, platform) {
        // Only do anything if we're on the browser platform.
        if (platform.isBrowser) {
            // We inject the live element as `any` because the constructor signature cannot reference
            // browser globals (HTMLElement) on non-browser environments, since having a class decorator
            // causes TypeScript to preserve the constructor signature types.
            this._liveElement = elementToken || this._createLiveElement();
        }
    }
    /**
     * Announces a message to screenreaders.
     * @param {?} message Message to be announced to the screenreader
     * @param {?=} politeness The politeness of the announcer element
     * @return {?}
     */
    LiveAnnouncer.prototype.announce = function (message, politeness) {
        var _this = this;
        if (politeness === void 0) { politeness = 'polite'; }
        this._liveElement.textContent = '';
        // TODO: ensure changing the politeness works on all environments we support.
        this._liveElement.setAttribute('aria-live', politeness);
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        setTimeout(function () { return _this._liveElement.textContent = message; }, 100);
    };
    /**
     * @return {?}
     */
    LiveAnnouncer.prototype.ngOnDestroy = function () {
        if (this._liveElement && this._liveElement.parentNode) {
            this._liveElement.parentNode.removeChild(this._liveElement);
        }
    };
    /**
     * @return {?}
     */
    LiveAnnouncer.prototype._createLiveElement = function () {
        var /** @type {?} */ liveEl = document.createElement('div');
        liveEl.classList.add('cdk-visually-hidden');
        liveEl.setAttribute('aria-atomic', 'true');
        liveEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(liveEl);
        return liveEl;
    };
    return LiveAnnouncer;
}());
LiveAnnouncer.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LiveAnnouncer.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [LIVE_ANNOUNCER_ELEMENT_TOKEN,] },] },
    { type: Platform, },
]; };
/**
 * \@docs-private
 * @param {?} parentDispatcher
 * @param {?} liveElement
 * @param {?} platform
 * @return {?}
 */
function LIVE_ANNOUNCER_PROVIDER_FACTORY(parentDispatcher, liveElement, platform) {
    return parentDispatcher || new LiveAnnouncer(liveElement, platform);
}
/**
 * \@docs-private
 */
var LIVE_ANNOUNCER_PROVIDER = {
    // If there is already a LiveAnnouncer available, use that. Otherwise, provide a new one.
    provide: LiveAnnouncer,
    deps: [
        [new Optional(), new SkipSelf(), LiveAnnouncer],
        [new Optional(), new Inject(LIVE_ANNOUNCER_ELEMENT_TOKEN)],
        Platform,
    ],
    useFactory: LIVE_ANNOUNCER_PROVIDER_FACTORY,
};
/**
 * Class to be used to power selecting one or more options from a list.
 * \@docs-private
 */
var SelectionModel = (function () {
    /**
     * @param {?=} _isMulti
     * @param {?=} initiallySelectedValues
     * @param {?=} _emitChanges
     */
    function SelectionModel(_isMulti, initiallySelectedValues, _emitChanges) {
        if (_isMulti === void 0) { _isMulti = false; }
        if (_emitChanges === void 0) { _emitChanges = true; }
        var _this = this;
        this._isMulti = _isMulti;
        this._emitChanges = _emitChanges;
        /**
         * Currently-selected values.
         */
        this._selection = new Set();
        /**
         * Keeps track of the deselected options that haven't been emitted by the change event.
         */
        this._deselectedToEmit = [];
        /**
         * Keeps track of the selected option that haven't been emitted by the change event.
         */
        this._selectedToEmit = [];
        /**
         * Event emitted when the value has changed.
         */
        this.onChange = this._emitChanges ? new Subject() : null;
        if (initiallySelectedValues) {
            if (_isMulti) {
                initiallySelectedValues.forEach(function (value) { return _this._markSelected(value); });
            }
            else {
                this._markSelected(initiallySelectedValues[0]);
            }
            // Clear the array in order to avoid firing the change event for preselected values.
            this._selectedToEmit.length = 0;
        }
    }
    Object.defineProperty(SelectionModel.prototype, "selected", {
        /**
         * Selected value(s).
         * @return {?}
         */
        get: function () {
            if (!this._selected) {
                this._selected = Array.from(this._selection.values());
            }
            return this._selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects a value or an array of values.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.select = function (value) {
        this._markSelected(value);
        this._emitChangeEvent();
    };
    /**
     * Deselects a value or an array of values.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.deselect = function (value) {
        this._unmarkSelected(value);
        this._emitChangeEvent();
    };
    /**
     * Toggles a value between selected and deselected.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.toggle = function (value) {
        this.isSelected(value) ? this.deselect(value) : this.select(value);
    };
    /**
     * Clears all of the selected values.
     * @return {?}
     */
    SelectionModel.prototype.clear = function () {
        this._unmarkAll();
        this._emitChangeEvent();
    };
    /**
     * Determines whether a value is selected.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.isSelected = function (value) {
        return this._selection.has(value);
    };
    /**
     * Determines whether the model does not have a value.
     * @return {?}
     */
    SelectionModel.prototype.isEmpty = function () {
        return this._selection.size === 0;
    };
    /**
     * Determines whether the model has a value.
     * @return {?}
     */
    SelectionModel.prototype.hasValue = function () {
        return !this.isEmpty();
    };
    /**
     * Sorts the selected values based on a predicate function.
     * @param {?=} predicate
     * @return {?}
     */
    SelectionModel.prototype.sort = function (predicate) {
        if (this._isMulti && this.selected) {
            this._selected.sort(predicate);
        }
    };
    /**
     * Emits a change event and clears the records of selected and deselected values.
     * @return {?}
     */
    SelectionModel.prototype._emitChangeEvent = function () {
        if (this._selectedToEmit.length || this._deselectedToEmit.length) {
            var /** @type {?} */ eventData = new SelectionChange(this._selectedToEmit, this._deselectedToEmit);
            this.onChange.next(eventData);
            this._deselectedToEmit = [];
            this._selectedToEmit = [];
        }
        this._selected = null;
    };
    /**
     * Selects a value.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype._markSelected = function (value) {
        if (!this.isSelected(value)) {
            if (!this._isMulti) {
                this._unmarkAll();
            }
            this._selection.add(value);
            if (this._emitChanges) {
                this._selectedToEmit.push(value);
            }
        }
    };
    /**
     * Deselects a value.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype._unmarkSelected = function (value) {
        if (this.isSelected(value)) {
            this._selection.delete(value);
            if (this._emitChanges) {
                this._deselectedToEmit.push(value);
            }
        }
    };
    /**
     * Clears out the selected values.
     * @return {?}
     */
    SelectionModel.prototype._unmarkAll = function () {
        var _this = this;
        if (!this.isEmpty()) {
            this._selection.forEach(function (value) { return _this._unmarkSelected(value); });
        }
    };
    return SelectionModel;
}());
/**
 * Describes an event emitted when the value of a XpoSelectionModel has changed.
 * \@docs-private
 */
var SelectionChange = (function () {
    /**
     * @param {?=} added
     * @param {?=} removed
     */
    function SelectionChange(added, removed) {
        this.added = added;
        this.removed = removed;
    }
    return SelectionChange;
}());
/**
 * Utility for checking the interactivity of an element, such as whether is is focusable or
 * tabbable.
 */
var InteractivityChecker = (function () {
    /**
     * @param {?} _platform
     */
    function InteractivityChecker(_platform) {
        this._platform = _platform;
    }
    /**
     * Gets whether an element is disabled.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is disabled.
     */
    InteractivityChecker.prototype.isDisabled = function (element) {
        // This does not capture some cases, such as a non-form control with a disabled attribute or
        // a form control inside of a disabled form, but should capture the most common cases.
        return element.hasAttribute('disabled');
    };
    /**
     * Gets whether an element is visible for the purposes of interactivity.
     *
     * This will capture states like `display: none` and `visibility: hidden`, but not things like
     * being clipped by an `overflow: hidden` parent or being outside the viewport.
     *
     * @param {?} element
     * @return {?} Whether the element is visible.
     */
    InteractivityChecker.prototype.isVisible = function (element) {
        return hasGeometry(element) && getComputedStyle(element).visibility === 'visible';
    };
    /**
     * Gets whether an element can be reached via Tab key.
     * Assumes that the element has already been checked with isFocusable.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is tabbable.
     */
    InteractivityChecker.prototype.isTabbable = function (element) {
        var /** @type {?} */ frameElement = (getWindow(element).frameElement);
        if (frameElement) {
            var /** @type {?} */ frameType = frameElement && frameElement.nodeName.toLowerCase();
            // Frame elements inherit their tabindex onto all child elements.
            if (getTabIndexValue(frameElement) === -1) {
                return false;
            }
            // Webkit and Blink consider anything inside of an <object> element as non-tabbable.
            if ((this._platform.BLINK || this._platform.WEBKIT) && frameType === 'object') {
                return false;
            }
            // Webkit and Blink disable tabbing to an element inside of an invisible frame.
            if ((this._platform.BLINK || this._platform.WEBKIT) && !this.isVisible(frameElement)) {
                return false;
            }
        }
        var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
        var /** @type {?} */ tabIndexValue = getTabIndexValue(element);
        if (element.hasAttribute('contenteditable')) {
            return tabIndexValue !== -1;
        }
        if (nodeName === 'iframe') {
            // The frames may be tabbable depending on content, but it's not possibly to reliably
            // investigate the content of the frames.
            return false;
        }
        if (nodeName === 'audio') {
            if (!element.hasAttribute('controls')) {
                // By default an <audio> element without the controls enabled is not tabbable.
                return false;
            }
            else if (this._platform.BLINK) {
                // In Blink <audio controls> elements are always tabbable.
                return true;
            }
        }
        if (nodeName === 'video') {
            if (!element.hasAttribute('controls') && this._platform.TRIDENT) {
                // In Trident a <video> element without the controls enabled is not tabbable.
                return false;
            }
            else if (this._platform.BLINK || this._platform.FIREFOX) {
                // In Chrome and Firefox <video controls> elements are always tabbable.
                return true;
            }
        }
        if (nodeName === 'object' && (this._platform.BLINK || this._platform.WEBKIT)) {
            // In all Blink and WebKit based browsers <object> elements are never tabbable.
            return false;
        }
        // In iOS the browser only considers some specific elements as tabbable.
        if (this._platform.WEBKIT && this._platform.IOS && !isPotentiallyTabbableIOS(element)) {
            return false;
        }
        return element.tabIndex >= 0;
    };
    /**
     * Gets whether an element can be focused by the user.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is focusable.
     */
    InteractivityChecker.prototype.isFocusable = function (element) {
        // Perform checks in order of left to most expensive.
        // Again, naive approach that does not capture many edge cases and browser quirks.
        return isPotentiallyFocusable(element) && !this.isDisabled(element) && this.isVisible(element);
    };
    return InteractivityChecker;
}());
InteractivityChecker.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
InteractivityChecker.ctorParameters = function () { return [
    { type: Platform, },
]; };
/**
 * Checks whether the specified element has any geometry / rectangles.
 * @param {?} element
 * @return {?}
 */
function hasGeometry(element) {
    // Use logic from jQuery to check for an invisible element.
    // See https://github.com/jquery/jquery/blob/V-2-0-0/src/css/hiddenVisibleSelectors.js#L12
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}
/**
 * Gets whether an element's
 * @param {?} element
 * @return {?}
 */
function isNativeFormElement(element) {
    var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
    return nodeName === 'input' ||
        nodeName === 'select' ||
        nodeName === 'button' ||
        nodeName === 'textarea';
}
/**
 * Gets whether an element is an <input type="hidden">.
 * @param {?} element
 * @return {?}
 */
function isHiddenInput(element) {
    return isInputElement(element) && element.type == 'hidden';
}
/**
 * Gets whether an element is an anchor that has an href attribute.
 * @param {?} element
 * @return {?}
 */
function isAnchorWithHref(element) {
    return isAnchorElement(element) && element.hasAttribute('href');
}
/**
 * Gets whether an element is an input element.
 * @param {?} element
 * @return {?}
 */
function isInputElement(element) {
    return element.nodeName.toLowerCase() == 'input';
}
/**
 * Gets whether an element is an anchor element.
 * @param {?} element
 * @return {?}
 */
function isAnchorElement(element) {
    return element.nodeName.toLowerCase() == 'a';
}
/**
 * Gets whether an element has a valid tabindex.
 * @param {?} element
 * @return {?}
 */
function hasValidTabIndex(element) {
    if (!element.hasAttribute('tabindex') || element.tabIndex === undefined) {
        return false;
    }
    var /** @type {?} */ tabIndex = element.getAttribute('tabindex');
    // IE11 parses tabindex="" as the value "-32768"
    if (tabIndex == '-32768') {
        return false;
    }
    return !!(tabIndex && !isNaN(parseInt(tabIndex, 10)));
}
/**
 * Returns the parsed tabindex from the element attributes instead of returning the
 * evaluated tabindex from the browsers defaults.
 * @param {?} element
 * @return {?}
 */
function getTabIndexValue(element) {
    if (!hasValidTabIndex(element)) {
        return null;
    }
    // See browser issue in Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
    var /** @type {?} */ tabIndex = parseInt(element.getAttribute('tabindex'), 10);
    return isNaN(tabIndex) ? -1 : tabIndex;
}
/**
 * Checks whether the specified element is potentially tabbable on iOS
 * @param {?} element
 * @return {?}
 */
function isPotentiallyTabbableIOS(element) {
    var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
    var /** @type {?} */ inputType = nodeName === 'input' && ((element)).type;
    return inputType === 'text'
        || inputType === 'password'
        || nodeName === 'select'
        || nodeName === 'textarea';
}
/**
 * Gets whether an element is potentially focusable without taking current visible/disabled state
 * into account.
 * @param {?} element
 * @return {?}
 */
function isPotentiallyFocusable(element) {
    // Inputs are potentially focusable *unless* they're type="hidden".
    if (isHiddenInput(element)) {
        return false;
    }
    return isNativeFormElement(element) ||
        isAnchorWithHref(element) ||
        element.hasAttribute('contenteditable') ||
        hasValidTabIndex(element);
}
/**
 * Gets the parent window of a DOM node with regards of being inside of an iframe.
 * @param {?} node
 * @return {?}
 */
function getWindow(node) {
    return node.ownerDocument.defaultView || window;
}
/* tslint:disable */
/**
 * Class that allows for trapping focus within a DOM element.
 *
 * NOTE: This class currently uses a very simple (naive) approach to focus trapping.
 * It assumes that the tab order is the same as DOM order, which is not necessarily true.
 * Things like tabIndex > 0, flex `order`, and shadow roots can cause to two to misalign.
 * This will be replaced with a more intelligent solution before the library is considered stable.
 */
var FocusTrap = (function () {
    /**
     * @param {?} _element
     * @param {?} _checker
     * @param {?} _ngZone
     * @param {?=} deferAnchors
     */
    function FocusTrap(_element, _checker, _ngZone, deferAnchors) {
        if (deferAnchors === void 0) { deferAnchors = false; }
        this._element = _element;
        this._checker = _checker;
        this._ngZone = _ngZone;
        this._enabled = true;
        if (!deferAnchors) {
            this.attachAnchors();
        }
    }
    Object.defineProperty(FocusTrap.prototype, "enabled", {
        /**
         * Whether the focus trap is active.
         * @return {?}
         */
        get: function () { return this._enabled; },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this._enabled = val;
            if (this._startAnchor && this._endAnchor) {
                this._startAnchor.tabIndex = this._endAnchor.tabIndex = this._enabled ? 0 : -1;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Destroys the focus trap by cleaning up the anchors.
     * @return {?}
     */
    FocusTrap.prototype.destroy = function () {
        if (this._startAnchor && this._startAnchor.parentNode) {
            this._startAnchor.parentNode.removeChild(this._startAnchor);
        }
        if (this._endAnchor && this._endAnchor.parentNode) {
            this._endAnchor.parentNode.removeChild(this._endAnchor);
        }
        this._startAnchor = this._endAnchor = null;
    };
    /**
     * Inserts the anchors into the DOM. This is usually done automatically
     * in the constructor, but can be deferred for cases like directives with `*ngIf`.
     * @return {?}
     */
    FocusTrap.prototype.attachAnchors = function () {
        var _this = this;
        if (!this._startAnchor) {
            this._startAnchor = this._createAnchor();
        }
        if (!this._endAnchor) {
            this._endAnchor = this._createAnchor();
        }
        this._ngZone.runOutsideAngular(function () {
            _this._startAnchor.addEventListener('focus', function () { return _this.focusLastTabbableElement(); });
            _this._endAnchor.addEventListener('focus', function () { return _this.focusFirstTabbableElement(); });
            _this._element.parentNode.insertBefore(_this._startAnchor, _this._element);
            _this._element.parentNode.insertBefore(_this._endAnchor, _this._element.nextSibling);
        });
    };
    /**
     * @return {?}
     */
    FocusTrap.prototype.focusInitialElementWhenReady = function () {
        var _this = this;
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () { return _this.focusInitialElement(); });
    };
    /**
     * Waits for microtask queue to empty, then focuses
     * the first tabbable element within the focus trap region.
     * @return {?}
     */
    FocusTrap.prototype.focusFirstTabbableElementWhenReady = function () {
        var _this = this;
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () { return _this.focusFirstTabbableElement(); });
    };
    /**
     * Waits for microtask queue to empty, then focuses
     * the last tabbable element within the focus trap region.
     * @return {?}
     */
    FocusTrap.prototype.focusLastTabbableElementWhenReady = function () {
        var _this = this;
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () { return _this.focusLastTabbableElement(); });
    };
    /**
     * Get the specified boundary element of the trapped region.
     * @param {?} bound The boundary to get (start or end of trapped region).
     * @return {?} The boundary element.
     */
    FocusTrap.prototype._getRegionBoundary = function (bound) {
        var /** @type {?} */ markers = Array.prototype.slice.call(this._element.querySelectorAll("[cdk-focus-region-" + bound + "]")).concat(Array.prototype.slice.call(this._element.querySelectorAll("[cdk-focus-" + bound + "]")));
        markers.forEach(function (el) {
            if (el.hasAttribute("cdk-focus-" + bound)) {
                console.warn("Found use of deprecated attribute 'cdk-focus-" + bound + "'," +
                    (" use 'cdk-focus-region-" + bound + "' instead."), el);
            }
        });
        if (bound == 'start') {
            return markers.length ? markers[0] : this._getFirstTabbableElement(this._element);
        }
        return markers.length ?
            markers[markers.length - 1] : this._getLastTabbableElement(this._element);
    };
    /**
     * Focuses the element that should be focused when the focus trap is initialized.
     * @return {?}
     */
    FocusTrap.prototype.focusInitialElement = function () {
        var /** @type {?} */ redirectToElement = (this._element.querySelector('[cdk-focus-initial]'));
        if (redirectToElement) {
            redirectToElement.focus();
        }
        else {
            this.focusFirstTabbableElement();
        }
    };
    /**
     * Focuses the first tabbable element within the focus trap region.
     * @return {?}
     */
    FocusTrap.prototype.focusFirstTabbableElement = function () {
        var /** @type {?} */ redirectToElement = this._getRegionBoundary('start');
        if (redirectToElement) {
            redirectToElement.focus();
        }
    };
    /**
     * Focuses the last tabbable element within the focus trap region.
     * @return {?}
     */
    FocusTrap.prototype.focusLastTabbableElement = function () {
        var /** @type {?} */ redirectToElement = this._getRegionBoundary('end');
        if (redirectToElement) {
            redirectToElement.focus();
        }
    };
    /**
     * Get the first tabbable element from a DOM subtree (inclusive).
     * @param {?} root
     * @return {?}
     */
    FocusTrap.prototype._getFirstTabbableElement = function (root) {
        if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
            return root;
        }
        // Iterate in DOM order. Note that IE doesn't have `children` for SVG so we fall
        // back to `childNodes` which includes text nodes, comments etc.
        var /** @type {?} */ children = root.children || root.childNodes;
        for (var /** @type {?} */ i = 0; i < children.length; i++) {
            var /** @type {?} */ tabbableChild = children[i].nodeType === Node.ELEMENT_NODE ?
                this._getFirstTabbableElement(/** @type {?} */ (children[i])) :
                null;
            if (tabbableChild) {
                return tabbableChild;
            }
        }
        return null;
    };
    /**
     * Get the last tabbable element from a DOM subtree (inclusive).
     * @param {?} root
     * @return {?}
     */
    FocusTrap.prototype._getLastTabbableElement = function (root) {
        if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
            return root;
        }
        // Iterate in reverse DOM order.
        var /** @type {?} */ children = root.children || root.childNodes;
        for (var /** @type {?} */ i = children.length - 1; i >= 0; i--) {
            var /** @type {?} */ tabbableChild = children[i].nodeType === Node.ELEMENT_NODE ?
                this._getLastTabbableElement(/** @type {?} */ (children[i])) :
                null;
            if (tabbableChild) {
                return tabbableChild;
            }
        }
        return null;
    };
    /**
     * Creates an anchor element.
     * @return {?}
     */
    FocusTrap.prototype._createAnchor = function () {
        var /** @type {?} */ anchor = document.createElement('div');
        anchor.tabIndex = this._enabled ? 0 : -1;
        anchor.classList.add('cdk-visually-hidden');
        anchor.classList.add('cdk-focus-trap-anchor');
        return anchor;
    };
    return FocusTrap;
}());
/**
 * Factory that allows easy instantiation of focus traps.
 */
var FocusTrapFactory = (function () {
    /**
     * @param {?} _checker
     * @param {?} _ngZone
     */
    function FocusTrapFactory(_checker, _ngZone) {
        this._checker = _checker;
        this._ngZone = _ngZone;
    }
    /**
     * @param {?} element
     * @param {?=} deferAnchors
     * @return {?}
     */
    FocusTrapFactory.prototype.create = function (element, deferAnchors) {
        if (deferAnchors === void 0) { deferAnchors = false; }
        return new FocusTrap(element, this._checker, this._ngZone, deferAnchors);
    };
    return FocusTrapFactory;
}());
FocusTrapFactory.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
FocusTrapFactory.ctorParameters = function () { return [
    { type: InteractivityChecker, },
    { type: NgZone, },
]; };
/**
 * Directive for trapping focus within a region.
 * @deprecated
 */
var FocusTrapDeprecatedDirective = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _focusTrapFactory
     */
    function FocusTrapDeprecatedDirective(_elementRef, _focusTrapFactory) {
        this._elementRef = _elementRef;
        this._focusTrapFactory = _focusTrapFactory;
        this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
    }
    Object.defineProperty(FocusTrapDeprecatedDirective.prototype, "disabled", {
        /**
         * Whether the focus trap is active.
         * @return {?}
         */
        get: function () { return !this.focusTrap.enabled; },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this.focusTrap.enabled = !coerceBooleanProperty(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FocusTrapDeprecatedDirective.prototype.ngOnDestroy = function () {
        this.focusTrap.destroy();
    };
    /**
     * @return {?}
     */
    FocusTrapDeprecatedDirective.prototype.ngAfterContentInit = function () {
        this.focusTrap.attachAnchors();
    };
    return FocusTrapDeprecatedDirective;
}());
FocusTrapDeprecatedDirective.decorators = [
    { type: Directive, args: [{
                selector: 'cdk-focus-trap',
            },] },
];
/**
 * @nocollapse
 */
FocusTrapDeprecatedDirective.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: FocusTrapFactory, },
]; };
FocusTrapDeprecatedDirective.propDecorators = {
    'disabled': [{ type: Input },],
};
/**
 * Directive for trapping focus within a region.
 */
var FocusTrapDirective = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _focusTrapFactory
     */
    function FocusTrapDirective(_elementRef, _focusTrapFactory) {
        this._elementRef = _elementRef;
        this._focusTrapFactory = _focusTrapFactory;
        this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
    }
    Object.defineProperty(FocusTrapDirective.prototype, "enabled", {
        /**
         * Whether the focus trap is active.
         * @return {?}
         */
        get: function () { return this.focusTrap.enabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.focusTrap.enabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FocusTrapDirective.prototype.ngOnDestroy = function () {
        this.focusTrap.destroy();
    };
    /**
     * @return {?}
     */
    FocusTrapDirective.prototype.ngAfterContentInit = function () {
        this.focusTrap.attachAnchors();
    };
    return FocusTrapDirective;
}());
FocusTrapDirective.decorators = [
    { type: Directive, args: [{
                selector: '[cdkTrapFocus]',
                exportAs: 'cdkTrapFocus',
            },] },
];
/**
 * @nocollapse
 */
FocusTrapDirective.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: FocusTrapFactory, },
]; };
FocusTrapDirective.propDecorators = {
    'enabled': [{ type: Input, args: ['cdkTrapFocus',] },],
};
/**
 * Screenreaders will often fire fake mousedown events when a focusable element
 * is activated using the keyboard. We can typically distinguish between these faked
 * mousedown events and real mousedown events using the "buttons" property. While
 * real mousedowns will indicate the mouse button that was pressed (e.g. "1" for
 * the left mouse button), faked mousedowns will usually set the property value to 0.
 * @param {?} event
 * @return {?}
 */
function isFakeMousedownFromScreenReader(event) {
    return event.buttons === 0;
}
/**
 * IDs are deliminated by an empty space, as per the spec.
 */
var ID_DELIMINATOR = ' ';
/**
 * Adds the given ID to the specified ARIA attribute on an element.
 * Used for attributes such as aria-labelledby, aria-owns, etc.
 * @param {?} el
 * @param {?} attr
 * @param {?} id
 * @return {?}
 */
function addAriaReferencedId(el, attr, id) {
    var /** @type {?} */ ids = getAriaReferenceIds(el, attr);
    if (ids.some(function (existingId) { return existingId.trim() == id.trim(); })) {
        return;
    }
    ids.push(id.trim());
    el.setAttribute(attr, ids.join(ID_DELIMINATOR));
}
/**
 * Removes the given ID from the specified ARIA attribute on an element.
 * Used for attributes such as aria-labelledby, aria-owns, etc.
 * @param {?} el
 * @param {?} attr
 * @param {?} id
 * @return {?}
 */
function removeAriaReferencedId(el, attr, id) {
    var /** @type {?} */ ids = getAriaReferenceIds(el, attr);
    var /** @type {?} */ filteredIds = ids.filter(function (val) { return val != id.trim(); });
    el.setAttribute(attr, filteredIds.join(ID_DELIMINATOR));
}
/**
 * Gets the list of IDs referenced by the given ARIA attribute on an element.
 * Used for attributes such as aria-labelledby, aria-owns, etc.
 * @param {?} el
 * @param {?} attr
 * @return {?}
 */
function getAriaReferenceIds(el, attr) {
    // Get string array of all individual ids (whitespace deliminated) in the attribute value
    return (el.getAttribute(attr) || '').match(/\S+/g) || [];
}
/**
 * ID used for the body container where all messages are appended.
 */
var MESSAGES_CONTAINER_ID = 'cdk-describedby-message-container';
/**
 * ID prefix used for each created message element.
 */
var CDK_DESCRIBEDBY_ID_PREFIX = 'cdk-describedby-message';
/**
 * Attribute given to each host element that is described by a message element.
 */
var CDK_DESCRIBEDBY_HOST_ATTRIBUTE = 'cdk-describedby-host';
/**
 * Global incremental identifier for each registered message element.
 */
var nextId = 0;
/**
 * Global map of all registered message elements that have been placed into the document.
 */
var messageRegistry = new Map();
/**
 * Container for all registered messages.
 */
var messagesContainer = null;
/**
 * Utility that creates visually hidden elements with a message content. Useful for elements that
 * want to use aria-describedby to further describe themselves without adding additional visual
 * content.
 * \@docs-private
 */
var AriaDescriber = (function () {
    /**
     * @param {?} _platform
     */
    function AriaDescriber(_platform) {
        this._platform = _platform;
    }
    /**
     * Adds to the host element an aria-describedby reference to a hidden element that contains
     * the message. If the same message has already been registered, then it will reuse the created
     * message element.
     * @param {?} hostElement
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype.describe = function (hostElement, message) {
        if (!this._platform.isBrowser || !message.trim()) {
            return;
        }
        if (!messageRegistry.has(message)) {
            createMessageElement(message);
        }
        if (!isElementDescribedByMessage(hostElement, message)) {
            addMessageReference(hostElement, message);
        }
    };
    /**
     * Removes the host element's aria-describedby reference to the message element.
     * @param {?} hostElement
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype.removeDescription = function (hostElement, message) {
        if (!this._platform.isBrowser || !message.trim()) {
            return;
        }
        if (isElementDescribedByMessage(hostElement, message)) {
            removeMessageReference(hostElement, message);
        }
        var /** @type {?} */ registeredMessage = messageRegistry.get(message);
        if (registeredMessage && registeredMessage.referenceCount === 0) {
            deleteMessageElement(message);
        }
        if (messagesContainer && messagesContainer.childNodes.length === 0) {
            deleteMessagesContainer();
        }
    };
    /**
     * Unregisters all created message elements and removes the message container.
     * @return {?}
     */
    AriaDescriber.prototype.ngOnDestroy = function () {
        if (!this._platform.isBrowser) {
            return;
        }
        var /** @type {?} */ describedElements = document.querySelectorAll("[" + CDK_DESCRIBEDBY_HOST_ATTRIBUTE + "]");
        for (var /** @type {?} */ i = 0; i < describedElements.length; i++) {
            removeCdkDescribedByReferenceIds(describedElements[i]);
            describedElements[i].removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
        }
        if (messagesContainer) {
            deleteMessagesContainer();
        }
        messageRegistry.clear();
    };
    return AriaDescriber;
}());
AriaDescriber.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
AriaDescriber.ctorParameters = function () { return [
    { type: Platform, },
]; };
/**
 * Creates a new element in the visually hidden message container element with the message
 * as its content and adds it to the message registry.
 * @param {?} message
 * @return {?}
 */
function createMessageElement(message) {
    var /** @type {?} */ messageElement = document.createElement('div');
    messageElement.setAttribute('id', CDK_DESCRIBEDBY_ID_PREFIX + "-" + nextId++);
    messageElement.appendChild(/** @type {?} */ ((document.createTextNode(message))));
    if (!messagesContainer) {
        createMessagesContainer();
    } /** @type {?} */
    ((messagesContainer)).appendChild(messageElement);
    messageRegistry.set(message, { messageElement: messageElement, referenceCount: 0 });
}
/**
 * Deletes the message element from the global messages container.
 * @param {?} message
 * @return {?}
 */
function deleteMessageElement(message) {
    var /** @type {?} */ registeredMessage = messageRegistry.get(message);
    var /** @type {?} */ messageElement = registeredMessage && registeredMessage.messageElement;
    if (messagesContainer && messageElement) {
        messagesContainer.removeChild(messageElement);
    }
    messageRegistry.delete(message);
}
/**
 * Creates the global container for all aria-describedby messages.
 * @return {?}
 */
function createMessagesContainer() {
    messagesContainer = document.createElement('div');
    messagesContainer.setAttribute('id', MESSAGES_CONTAINER_ID);
    messagesContainer.setAttribute('aria-hidden', 'true');
    messagesContainer.style.display = 'none';
    document.body.appendChild(messagesContainer);
}
/**
 * Deletes the global messages container.
 * @return {?}
 */
function deleteMessagesContainer() {
    document.body.removeChild(/** @type {?} */ ((messagesContainer)));
    messagesContainer = null;
}
/**
 * Removes all cdk-describedby messages that are hosted through the element.
 * @param {?} element
 * @return {?}
 */
function removeCdkDescribedByReferenceIds(element) {
    // Remove all aria-describedby reference IDs that are prefixed by CDK_DESCRIBEDBY_ID_PREFIX
    var /** @type {?} */ originalReferenceIds = getAriaReferenceIds(element, 'aria-describedby')
        .filter(function (id) { return id.indexOf(CDK_DESCRIBEDBY_ID_PREFIX) != 0; });
    element.setAttribute('aria-describedby', originalReferenceIds.join(' '));
}
/**
 * Adds a message reference to the element using aria-describedby and increments the registered
 * message's reference count.
 * @param {?} element
 * @param {?} message
 * @return {?}
 */
function addMessageReference(element, message) {
    var /** @type {?} */ registeredMessage = ((messageRegistry.get(message)));
    // Add the aria-describedby reference and set the describedby_host attribute to mark the element.
    addAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
    element.setAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE, '');
    registeredMessage.referenceCount++;
}
/**
 * Removes a message reference from the element using aria-describedby and decrements the registered
 * message's reference count.
 * @param {?} element
 * @param {?} message
 * @return {?}
 */
function removeMessageReference(element, message) {
    var /** @type {?} */ registeredMessage = ((messageRegistry.get(message)));
    registeredMessage.referenceCount--;
    removeAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
    element.removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
}
/**
 * Returns true if the element has been described by the provided message ID.
 * @param {?} element
 * @param {?} message
 * @return {?}
 */
function isElementDescribedByMessage(element, message) {
    var /** @type {?} */ referenceIds = getAriaReferenceIds(element, 'aria-describedby');
    var /** @type {?} */ registeredMessage = messageRegistry.get(message);
    var /** @type {?} */ messageId = registeredMessage && registeredMessage.messageElement.id;
    return !!messageId && referenceIds.indexOf(messageId) != -1;
}
/**
 * \@docs-private
 * @param {?} parentDispatcher
 * @param {?} platform
 * @return {?}
 */
function ARIA_DESCRIBER_PROVIDER_FACTORY(parentDispatcher, platform) {
    return parentDispatcher || new AriaDescriber(platform);
}
/**
 * \@docs-private
 */
var ARIA_DESCRIBER_PROVIDER = {
    // If there is already an AriaDescriber available, use that. Otherwise, provide a new one.
    provide: AriaDescriber,
    deps: [
        [new Optional(), new SkipSelf(), AriaDescriber],
        Platform,
    ],
    useFactory: ARIA_DESCRIBER_PROVIDER_FACTORY,
};
var A11yModule = (function () {
    function A11yModule() {
    }
    return A11yModule;
}());
A11yModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, PlatformModule],
                declarations: [FocusTrapDirective, FocusTrapDeprecatedDirective],
                exports: [FocusTrapDirective, FocusTrapDeprecatedDirective],
                providers: [InteractivityChecker, FocusTrapFactory, LIVE_ANNOUNCER_PROVIDER, AriaDescriber, ARIA_DESCRIBER_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
A11yModule.ctorParameters = function () { return []; };
/**
 * Class to coordinate unique selection based on name.
 * Intended to be consumed as an Angular service.
 * This service is needed because native radio change events are only fired on the item currently
 * being selected, and we still need to uncheck the previous selection.
 *
 * This service does not *store* any IDs and names because they may change at any time, so it is
 * less error-prone if they are simply passed through when the events occur.
 */
var UniqueSelectionDispatcher = (function () {
    function UniqueSelectionDispatcher() {
        this._listeners = [];
    }
    /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.notify = function (id, name) {
        for (var _i = 0, _a = this._listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(id, name);
        }
    };
    /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.listen = function (listener) {
        this._listeners.push(listener);
    };
    return UniqueSelectionDispatcher;
}());
UniqueSelectionDispatcher.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
UniqueSelectionDispatcher.ctorParameters = function () { return []; };
/**
 * @param {?} parentDispatcher
 * @return {?}
 */
function UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY(parentDispatcher) {
    return parentDispatcher || new UniqueSelectionDispatcher();
}
var UNIQUE_SELECTION_DISPATCHER_PROVIDER = {
    // If there is already a dispatcher available, use that. Otherwise, provide a new one.
    provide: UniqueSelectionDispatcher,
    deps: [[new Optional(), new SkipSelf(), UniqueSelectionDispatcher]],
    useFactory: UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY,
};
// This is the value used by AngularJS Material. Through trial and error (on iPhone 6S) they found
// that a value of around 650ms seems appropriate.
var TOUCH_BUFFER_MS = 650;
/**
 * Monitors mouse and keyboard events to determine the cause of focus events.
 */
var FocusOriginMonitor = (function () {
    /**
     * @param {?} _ngZone
     * @param {?} _platform
     */
    function FocusOriginMonitor(_ngZone, _platform) {
        var _this = this;
        this._ngZone = _ngZone;
        this._platform = _platform;
        /**
         * The focus origin that the next focus event is a result of.
         */
        this._origin = null;
        /**
         * Whether the window has just been focused.
         */
        this._windowFocused = false;
        /**
         * Weak map of elements being monitored to their info.
         */
        this._elementInfo = new WeakMap();
        this._ngZone.runOutsideAngular(function () { return _this._registerDocumentEvents(); });
    }
    /**
     * Monitors focus on an element and applies appropriate CSS classes.
     * @param {?} element The element to monitor
     * @param {?} renderer The renderer to use to apply CSS classes to the element.
     * @param {?} checkChildren Whether to count the element as focused when its children are focused.
     * @return {?} An observable that emits when the focus state of the element changes.
     *     When the element is blurred, null will be emitted.
     */
    FocusOriginMonitor.prototype.monitor = function (element, renderer, checkChildren) {
        var _this = this;
        // Do nothing if we're not on the browser platform.
        // if (!this._platform.isBrowser) {
        //   return Observable.of();
        // }
        // Check if we're already monitoring this element.
        if (this._elementInfo.has(element)) {
            var /** @type {?} */ info_1 = this._elementInfo.get(element);
            info_1.checkChildren = checkChildren;
            return info_1.subject.asObservable();
        }
        // Create monitored element info.
        var /** @type {?} */ info = {
            unlisten: null,
            checkChildren: checkChildren,
            renderer: renderer,
            subject: new Subject(),
        };
        this._elementInfo.set(element, info);
        // Start listening. We need to listen in capture phase since focus events don't bubble.
        var /** @type {?} */ focusListener = function (event) { return _this._onFocus(event, element); };
        var /** @type {?} */ blurListener = function (event) { return _this._onBlur(event, element); };
        this._ngZone.runOutsideAngular(function () {
            element.addEventListener('focus', focusListener, true);
            element.addEventListener('blur', blurListener, true);
        });
        // Create an unlisten function for later.
        info.unlisten = function () {
            element.removeEventListener('focus', focusListener, true);
            element.removeEventListener('blur', blurListener, true);
        };
        return info.subject.asObservable();
    };
    /**
     * Stops monitoring an element and removes all focus classes.
     * @param {?} element The element to stop monitoring.
     * @return {?}
     */
    FocusOriginMonitor.prototype.stopMonitoring = function (element) {
        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
        if (elementInfo) {
            elementInfo.unlisten();
            elementInfo.subject.complete();
            this._setClasses(element, null);
            this._elementInfo.delete(element);
        }
    };
    /**
     * Focuses the element via the specified focus origin.
     * @param {?} element The element to focus.
     * @param {?} renderer The renderer to use to invoke the focus method on the element.
     * @param {?} origin The focus origin.
     * @return {?}
     */
    FocusOriginMonitor.prototype.focusVia = function (element, renderer, origin) {
        this._setOriginForCurrentEventQueue(origin);
        element.focus();
    };
    /**
     * Register necessary event listeners on the document and window.
     * @return {?}
     */
    FocusOriginMonitor.prototype._registerDocumentEvents = function () {
        var _this = this;
        // Do nothing if we're not on the browser platform.
        // if (!this._platform.isBrowser) {
        //   return;
        //  }
        // Note: we listen to events in the capture phase so we can detect them even if the user stops
        // propagation.
        // On keydown record the origin and clear any touch event that may be in progress.
        document.addEventListener('keydown', function () {
            _this._lastTouchTarget = null;
            _this._setOriginForCurrentEventQueue('keyboard');
        }, true);
        // On mousedown record the origin only if there is not touch target, since a mousedown can
        // happen as a result of a touch event.
        document.addEventListener('mousedown', function () {
            if (!_this._lastTouchTarget) {
                _this._setOriginForCurrentEventQueue('mouse');
            }
        }, true);
        // When the touchstart event fires the focus event is not yet in the event queue. This means
        // we can't rely on the trick used above (setting timeout of 0ms). Instead we wait 650ms to
        // see if a focus happens.
        document.addEventListener('touchstart', function (event) {
            if (_this._touchTimeout != null) {
                clearTimeout(_this._touchTimeout);
            }
            _this._lastTouchTarget = event.target;
            _this._touchTimeout = setTimeout(function () { return _this._lastTouchTarget = null; }, TOUCH_BUFFER_MS);
        }, true);
        // Make a note of when the window regains focus, so we can restore the origin info for the
        // focused element.
        window.addEventListener('focus', function () {
            _this._windowFocused = true;
            setTimeout(function () { return _this._windowFocused = false; }, 0);
        });
    };
    /**
     * Sets the focus classes on the element based on the given focus origin.
     * @param {?} element The element to update the classes on.
     * @param {?} origin The focus origin.
     * @return {?}
     */
    FocusOriginMonitor.prototype._setClasses = function (element, origin) {
        var /** @type {?} */ renderer = this._elementInfo.get(element).renderer;
        var /** @type {?} */ toggleClass = function (className, shouldSet) {
            shouldSet ? renderer.addClass(element, className) : renderer.removeClass(element, className);
        };
        toggleClass('cdk-focused', !!origin);
        toggleClass('cdk-touch-focused', origin === 'touch');
        toggleClass('cdk-keyboard-focused', origin === 'keyboard');
        toggleClass('cdk-mouse-focused', origin === 'mouse');
        toggleClass('cdk-program-focused', origin === 'program');
    };
    /**
     * Sets the origin and schedules an async function to clear it at the end of the event queue.
     * @param {?} origin The origin to set.
     * @return {?}
     */
    FocusOriginMonitor.prototype._setOriginForCurrentEventQueue = function (origin) {
        var _this = this;
        this._origin = origin;
        setTimeout(function () { return _this._origin = null; }, 0);
    };
    /**
     * Checks whether the given focus event was caused by a touchstart event.
     * @param {?} event The focus event to check.
     * @return {?} Whether the event was caused by a touch.
     */
    FocusOriginMonitor.prototype._wasCausedByTouch = function (event) {
        // Note(mmalerba): This implementation is not quite perfect, there is a small edge case.
        // Consider the following dom structure:
        //
        // <div #parent tabindex="0" cdkFocusClasses>
        //   <div #child (click)="#parent.focus()"></div>
        // </div>
        //
        // If the user touches the #child element and the #parent is programmatically focused as a
        // result, this code will still consider it to have been caused by the touch event and will
        // apply the cdk-touch-focused class rather than the cdk-program-focused class. This is a
        // relatively small edge-case that can be worked around by using
        // focusVia(parentEl, renderer,  'program') to focus the parent element.
        //
        // If we decide that we absolutely must handle this case correctly, we can do so by listening
        // for the first focus event after the touchstart, and then the first blur event after that
        // focus event. When that blur event fires we know that whatever follows is not a result of the
        // touchstart.
        var /** @type {?} */ focusTarget = event.target;
        return this._lastTouchTarget instanceof Node && focusTarget instanceof Node &&
            (focusTarget === this._lastTouchTarget || focusTarget.contains(this._lastTouchTarget));
    };
    /**
     * Handles focus events on a registered element.
     * @param {?} event The focus event.
     * @param {?} element The monitored element.
     * @return {?}
     */
    FocusOriginMonitor.prototype._onFocus = function (event, element) {
        // NOTE(mmalerba): We currently set the classes based on the focus origin of the most recent
        // focus event affecting the monitored element. If we want to use the origin of the first event
        // instead we should check for the cdk-focused class here and return if the element already has
        // it. (This only matters for elements that have includesChildren = true).
        // If we are not counting child-element-focus as focused, make sure that the event target is the
        // monitored element itself.
        if (!this._elementInfo.get(element).checkChildren && element !== event.target) {
            return;
        }
        // If we couldn't detect a cause for the focus event, it's due to one of three reasons:
        // 1) The window has just regained focus, in which case we want to restore the focused state of
        //    the element from before the window blurred.
        // 2) It was caused by a touch event, in which case we mark the origin as 'touch'.
        // 3) The element was programmatically focused, in which case we should mark the origin as
        //    'program'.
        if (!this._origin) {
            if (this._windowFocused && this._lastFocusOrigin) {
                this._origin = this._lastFocusOrigin;
            }
            else if (this._wasCausedByTouch(event)) {
                this._origin = 'touch';
            }
            else {
                this._origin = 'program';
            }
        }
        this._setClasses(element, this._origin);
        this._elementInfo.get(element).subject.next(this._origin);
        this._lastFocusOrigin = this._origin;
        this._origin = null;
    };
    /**
     * Handles blur events on a registered element.
     * @param {?} event The blur event.
     * @param {?} element The monitored element.
     * @return {?}
     */
    FocusOriginMonitor.prototype._onBlur = function (event, element) {
        // If we are counting child-element-focus as focused, make sure that we aren't just blurring in
        // order to focus another child of the monitored element.
        if (this._elementInfo.get(element).checkChildren && event.relatedTarget instanceof Node &&
            element.contains(event.relatedTarget)) {
            return;
        }
        this._setClasses(element, null);
        this._elementInfo.get(element).subject.next(null);
    };
    return FocusOriginMonitor;
}());
FocusOriginMonitor.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
FocusOriginMonitor.ctorParameters = function () { return [
    { type: NgZone, },
    { type: Platform, },
]; };
/**
 * Directive that determines how a particular element was focused (via keyboard, mouse, touch, or
 * programmatically) and adds corresponding classes to the element.
 *
 * There are two variants of this directive:
 * 1) cdkMonitorElementFocus: does not consider an element to be focused if one of its children is
 *    focused.
 * 2) cdkMonitorSubtreeFocus: considers an element focused if it or any of its children are focused.
 */
var CdkMonitorFocus = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _focusOriginMonitor
     * @param {?} renderer
     */
    function CdkMonitorFocus(_elementRef, _focusOriginMonitor, renderer) {
        var _this = this;
        this._elementRef = _elementRef;
        this._focusOriginMonitor = _focusOriginMonitor;
        this.cdkFocusChange = new EventEmitter();
        this._focusOriginMonitor.monitor(this._elementRef.nativeElement, renderer, this._elementRef.nativeElement.hasAttribute('cdkMonitorSubtreeFocus'))
            .subscribe(function (origin) { return _this.cdkFocusChange.emit(origin); });
    }
    /**
     * @return {?}
     */
    CdkMonitorFocus.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._elementRef.nativeElement);
    };
    return CdkMonitorFocus;
}());
CdkMonitorFocus.decorators = [
    { type: Directive, args: [{
                selector: '[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]',
            },] },
];
/**
 * @nocollapse
 */
CdkMonitorFocus.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: FocusOriginMonitor, },
    { type: Renderer2, },
]; };
CdkMonitorFocus.propDecorators = {
    'cdkFocusChange': [{ type: Output },],
};
/**
 * @param {?} parentDispatcher
 * @param {?} ngZone
 * @param {?} platform
 * @return {?}
 */
function FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
    return parentDispatcher || new FocusOriginMonitor(ngZone, platform);
}
var FOCUS_ORIGIN_MONITOR_PROVIDER = {
    // If there is already a FocusOriginMonitor available, use that. Otherwise, provide a new one.
    provide: FocusOriginMonitor,
    deps: [[new Optional(), new SkipSelf(), FocusOriginMonitor], NgZone, Platform],
    useFactory: FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY,
};
/**
 * Applies a CSS transform to an element, including browser-prefixed properties.
 * @param {?} element
 * @param {?} transformValue
 * @return {?}
 */
function applyCssTransform(element, transformValue) {
    // It's important to trim the result, because the browser will ignore the set operation
    // if the string contains only whitespace.
    var /** @type {?} */ value = transformValue.trim();
    element.style.transform = value;
    element.style.webkitTransform = value;
}
var StyleModule = (function () {
    function StyleModule() {
    }
    return StyleModule;
}());
StyleModule.decorators = [
    { type: NgModule, args: [{
                imports: [PlatformModule],
                declarations: [CdkMonitorFocus],
                exports: [CdkMonitorFocus],
                providers: [FOCUS_ORIGIN_MONITOR_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
StyleModule.ctorParameters = function () { return []; };
/**
 * \@docs-private
 */
var AnimationCurves = (function () {
    function AnimationCurves() {
    }
    return AnimationCurves;
}());
AnimationCurves.STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
AnimationCurves.DECELERATION_CURVE = 'cubic-bezier(0.0,0.0,0.2,1)';
AnimationCurves.ACCELERATION_CURVE = 'cubic-bezier(0.4,0.0,1,1)';
AnimationCurves.SHARP_CURVE = 'cubic-bezier(0.4,0.0,0.6,1)';
/**
 * \@docs-private
 */
var AnimationDurations = (function () {
    function AnimationDurations() {
    }
    return AnimationDurations;
}());
AnimationDurations.COMPLEX = '375ms';
AnimationDurations.ENTERING = '225ms';
AnimationDurations.EXITING = '195ms';
/**
 * Coerces a data-bound value (typically a string) to a number.
 * @param {?} value
 * @param {?=} fallbackValue
 * @return {?}
 */
function coerceNumberProperty(value, fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = 0; }
    // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
    // and other non-number values as NaN, where Number just uses 0) but it considers the string
    // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
    return isNaN(parseFloat(/** @type {?} */ (value))) || isNaN(Number(value)) ? fallbackValue : Number(value);
}
/**
 * Adapts type `D` to be usable as a date by cdk-based components that work with dates.
 * @abstract
 */
var DateAdapter = (function () {
    function DateAdapter() {
    }
    /**
     * Gets the year component of the given date.
     * @abstract
     * @param {?} date The date to extract the year from.
     * @return {?} The year component.
     */
    DateAdapter.prototype.getYear = function (date) { };
    /**
     * Gets the month component of the given date.
     * @abstract
     * @param {?} date The date to extract the month from.
     * @return {?} The month component (0-indexed, 0 = January).
     */
    DateAdapter.prototype.getMonth = function (date) { };
    /**
     * Gets the date of the month component of the given date.
     * @abstract
     * @param {?} date The date to extract the date of the month from.
     * @return {?} The month component (1-indexed, 1 = first of month).
     */
    DateAdapter.prototype.getDate = function (date) { };
    /**
     * Gets the day of the week component of the given date.
     * @abstract
     * @param {?} date The date to extract the day of the week from.
     * @return {?} The month component (0-indexed, 0 = Sunday).
     */
    DateAdapter.prototype.getDayOfWeek = function (date) { };
    /**
     * Gets a list of names for the months.
     * @abstract
     * @param {?} style The naming style (e.g. long = 'January', short = 'Jan', narrow = 'J').
     * @return {?} An ordered list of all month names, starting with January.
     */
    DateAdapter.prototype.getMonthNames = function (style$$1) { };
    /**
     * Gets a list of names for the dates of the month.
     * @abstract
     * @return {?} An ordered list of all date of the month names, starting with '1'.
     */
    DateAdapter.prototype.getDateNames = function () { };
    /**
     * Gets a list of names for the days of the week.
     * @abstract
     * @param {?} style The naming style (e.g. long = 'Sunday', short = 'Sun', narrow = 'S').
     * @return {?} An ordered list of all weekday names, starting with Sunday.
     */
    DateAdapter.prototype.getDayOfWeekNames = function (style$$1) { };
    /**
     * Gets the name for the year of the given date.
     * @abstract
     * @param {?} date The date to get the year name for.
     * @return {?} The name of the given year (e.g. '2017').
     */
    DateAdapter.prototype.getYearName = function (date) { };
    /**
     * Gets the first day of the week.
     * @abstract
     * @return {?} The first day of the week (0-indexed, 0 = Sunday).
     */
    DateAdapter.prototype.getFirstDayOfWeek = function () { };
    /**
     * Gets the number of days in the month of the given date.
     * @abstract
     * @param {?} date The date whose month should be checked.
     * @return {?} The number of days in the month of the given date.
     */
    DateAdapter.prototype.getNumDaysInMonth = function (date) { };
    /**
     * Clones the given date.
     * @abstract
     * @param {?} date The date to clone
     * @return {?} A new date equal to the given date.
     */
    DateAdapter.prototype.clone = function (date) { };
    /**
     * Creates a date with the given year, month, and date. Does not allow over/under-flow of the
     * month and date.
     * @abstract
     * @param {?} year The full year of the date. (e.g. 89 means the year 89, not the year 1989).
     * @param {?} month The month of the date (0-indexed, 0 = January). Must be an integer 0 - 11.
     * @param {?} date The date of month of the date. Must be an integer 1 - length of the given month.
     * @return {?} The new date, or null if invalid.
     */
    DateAdapter.prototype.createDate = function (year, month, date) { };
    /**
     * Gets today's date.
     * @abstract
     * @return {?} Today's date.
     */
    DateAdapter.prototype.today = function () { };
    /**
     * Parses a date from a value.
     * @abstract
     * @param {?} value The value to parse.
     * @param {?} parseFormat The expected format of the value being parsed
     *     (type is implementation-dependent).
     * @return {?} The parsed date, or null if date could not be parsed.
     */
    DateAdapter.prototype.parse = function (value, parseFormat) { };
    /**
     * Formats a date as a string.
     * @abstract
     * @param {?} date The value to parse.
     * @param {?} displayFormat The format to use to display the date as a string.
     * @return {?} The parsed date, or null if date could not be parsed.
     */
    DateAdapter.prototype.format = function (date, displayFormat) { };
    /**
     * Adds the given number of years to the date. Years are counted as if flipping 12 pages on the
     * calendar for each year and then finding the closest date in the new month. For example when
     * adding 1 year to Feb 29, 2016, the resulting date will be Feb 28, 2017.
     * @abstract
     * @param {?} date The date to add years to.
     * @param {?} years The number of years to add (may be negative).
     * @return {?} A new date equal to the given one with the specified number of years added.
     */
    DateAdapter.prototype.addCalendarYears = function (date, years) { };
    /**
     * Adds the given number of months to the date. Months are counted as if flipping a page on the
     * calendar for each month and then finding the closest date in the new month. For example when
     * adding 1 month to Jan 31, 2017, the resulting date will be Feb 28, 2017.
     * @abstract
     * @param {?} date The date to add months to.
     * @param {?} months The number of months to add (may be negative).
     * @return {?} A new date equal to the given one with the specified number of months added.
     */
    DateAdapter.prototype.addCalendarMonths = function (date, months) { };
    /**
     * Adds the given number of days to the date. Days are counted as if moving one cell on the
     * calendar for each day.
     * @abstract
     * @param {?} date The date to add days to.
     * @param {?} days The number of days to add (may be negative).
     * @return {?} A new date equal to the given one with the specified number of days added.
     */
    DateAdapter.prototype.addCalendarDays = function (date, days) { };
    /**
     * Gets the RFC 3339 compatible date string (https://tools.ietf.org/html/rfc3339)  for the given
     * date.
     * @abstract
     * @param {?} date The date to get the ISO date string for.
     * @return {?} The ISO date string date string.
     */
    DateAdapter.prototype.getISODateString = function (date) { };
    /**
     * Sets the locale used for all dates.
     * @param {?} locale The new locale.
     * @return {?}
     */
    DateAdapter.prototype.setLocale = function (locale) {
        this.locale = locale;
    };
    /**
     * Compares two dates.
     * @param {?} first The first date to compare.
     * @param {?} second The second date to compare.
     * @return {?} 0 if the dates are equal, a number less than 0 if the first date is earlier,
     *     a number greater than 0 if the first date is later.
     */
    DateAdapter.prototype.compareDate = function (first$$1, second) {
        return this.getYear(first$$1) - this.getYear(second) ||
            this.getMonth(first$$1) - this.getMonth(second) ||
            this.getDate(first$$1) - this.getDate(second);
    };
    /**
     * Checks if two dates are equal.
     * @param {?} first The first date to check.
     * @param {?} second The second date to check.
     *     Null dates are considered equal to other null dates.
     * @return {?}
     */
    DateAdapter.prototype.sameDate = function (first$$1, second) {
        return first$$1 && second ? !this.compareDate(first$$1, second) : first$$1 == second;
    };
    /**
     * Clamp the given date between min and max dates.
     * @param {?} date The date to clamp.
     * @param {?=} min The minimum value to allow. If null or omitted no min is enforced.
     * @param {?=} max The maximum value to allow. If null or omitted no max is enforced.
     * @return {?} `min` if `date` is less than `min`, `max` if date is greater than `max`,
     *     otherwise `date`.
     */
    DateAdapter.prototype.clampDate = function (date, min, max) {
        if (min && this.compareDate(date, min) < 0) {
            return min;
        }
        if (max && this.compareDate(date, max) > 0) {
            return max;
        }
        return date;
    };
    return DateAdapter;
}());
var XPO_DATE_FORMATS = new InjectionToken('xpo-date-formats');
/**
 * Whether the browser supports the Intl API.
 */
var SUPPORTS_INTL_API = typeof Intl != 'undefined';
/**
 * The default month names to use if Intl API is not available.
 */
var DEFAULT_MONTH_NAMES = {
    long: [
        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
        'October', 'November', 'December',
    ],
    short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
};
/**
 * The default date names to use if Intl API is not available.
 */
var DEFAULT_DATE_NAMES = range(31, function (i) { return String(i + 1); });
/**
 * The default day of the week names to use if Intl API is not available.
 */
var DEFAULT_DAY_OF_WEEK_NAMES = {
    long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
};
/**
 * Creates an array and fills it with values.
 * @template T
 * @param {?} length
 * @param {?} valueFunction
 * @return {?}
 */
function range(length, valueFunction) {
    return Array.apply(null, Array(length)).map(function (v, i) { return valueFunction(i); });
}
/**
 * Adapts the native JS Date for use with cdk-based components that work with dates.
 */
var NativeDateAdapter = (function (_super) {
    __extends(NativeDateAdapter, _super);
    function NativeDateAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.getYear = function (date) {
        return date.getFullYear();
    };
    /**
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.getMonth = function (date) {
        return date.getMonth();
    };
    /**
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.getDate = function (date) {
        return date.getDate();
    };
    /**
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.getDayOfWeek = function (date) {
        return date.getDay();
    };
    /**
     * @param {?} style
     * @return {?}
     */
    NativeDateAdapter.prototype.getMonthNames = function (style$$1) {
        var _this = this;
        if (SUPPORTS_INTL_API) {
            var /** @type {?} */ dtf_1 = new Intl.DateTimeFormat(this.locale, { month: style$$1 });
            return range(12, function (i) { return _this._stripDirectionalityCharacters(dtf_1.format(new Date(2017, i, 1))); });
        }
        return DEFAULT_MONTH_NAMES[style$$1];
    };
    /**
     * @return {?}
     */
    NativeDateAdapter.prototype.getDateNames = function () {
        var _this = this;
        if (SUPPORTS_INTL_API) {
            var /** @type {?} */ dtf_2 = new Intl.DateTimeFormat(this.locale, { day: 'numeric' });
            return range(31, function (i) { return _this._stripDirectionalityCharacters(dtf_2.format(new Date(2017, 0, i + 1))); });
        }
        return DEFAULT_DATE_NAMES;
    };
    /**
     * @param {?} style
     * @return {?}
     */
    NativeDateAdapter.prototype.getDayOfWeekNames = function (style$$1) {
        var _this = this;
        if (SUPPORTS_INTL_API) {
            var /** @type {?} */ dtf_3 = new Intl.DateTimeFormat(this.locale, { weekday: style$$1 });
            return range(7, function (i) { return _this._stripDirectionalityCharacters(dtf_3.format(new Date(2017, 0, i + 1))); });
        }
        return DEFAULT_DAY_OF_WEEK_NAMES[style$$1];
    };
    /**
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.getYearName = function (date) {
        if (SUPPORTS_INTL_API) {
            var /** @type {?} */ dtf = new Intl.DateTimeFormat(this.locale, { year: 'numeric' });
            return this._stripDirectionalityCharacters(dtf.format(date));
        }
        return String(this.getYear(date));
    };
    /**
     * @return {?}
     */
    NativeDateAdapter.prototype.getFirstDayOfWeek = function () {
        // We can't tell using native JS Date what the first day of the week is, we default to Sunday.
        return 0;
    };
    /**
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.getNumDaysInMonth = function (date) {
        return this.getDate(this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + 1, 0));
    };
    /**
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.clone = function (date) {
        return this.createDate(this.getYear(date), this.getMonth(date), this.getDate(date));
    };
    /**
     * @param {?} year
     * @param {?} month
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.createDate = function (year, month, date) {
        // Check for invalid month and date (except upper bound on date which we have to check after
        // creating the Date).
        if (month < 0 || month > 11 || date < 1) {
            return null;
        }
        var /** @type {?} */ result = this._createDateWithOverflow(year, month, date);
        // Check that the date wasn't above the upper bound for the month, causing the month to
        // overflow.
        if (result.getMonth() != month) {
            return null;
        }
        return result;
    };
    /**
     * @return {?}
     */
    NativeDateAdapter.prototype.today = function () {
        return new Date();
    };
    /**
     * @param {?} value
     * @param {?} parseFormat
     * @return {?}
     */
    NativeDateAdapter.prototype.parse = function (value, parseFormat) {
        // We have no way using the native JS Date to set the parse format or locale, so we ignore these
        // parameters.
        var /** @type {?} */ timestamp = typeof value == 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    };
    /**
     * @param {?} date
     * @param {?} displayFormat
     * @return {?}
     */
    NativeDateAdapter.prototype.format = function (date, displayFormat) {
        if (SUPPORTS_INTL_API) {
            var /** @type {?} */ dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
            return this._stripDirectionalityCharacters(dtf.format(date));
        }
        return this._stripDirectionalityCharacters(date.toDateString());
    };
    /**
     * @param {?} date
     * @param {?} years
     * @return {?}
     */
    NativeDateAdapter.prototype.addCalendarYears = function (date, years) {
        return this.addCalendarMonths(date, years * 12);
    };
    /**
     * @param {?} date
     * @param {?} months
     * @return {?}
     */
    NativeDateAdapter.prototype.addCalendarMonths = function (date, months) {
        var /** @type {?} */ newDate = this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + months, this.getDate(date));
        // It's possible to wind up in the wrong month if the original month has more days than the new
        // month. In this case we want to go to the last day of the desired month.
        // Note: the additional + 12 % 12 ensures we end up with a positive number, since JS % doesn't
        // guarantee this.
        if (this.getMonth(newDate) != ((this.getMonth(date) + months) % 12 + 12) % 12) {
            newDate = this._createDateWithOverflow(this.getYear(newDate), this.getMonth(newDate), 0);
        }
        return newDate;
    };
    /**
     * @param {?} date
     * @param {?} days
     * @return {?}
     */
    NativeDateAdapter.prototype.addCalendarDays = function (date, days) {
        return this._createDateWithOverflow(this.getYear(date), this.getMonth(date), this.getDate(date) + days);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype.getISODateString = function (date) {
        return [
            date.getUTCFullYear(),
            this._2digit(date.getUTCMonth() + 1),
            this._2digit(date.getUTCDate()),
        ].join('-');
    };
    /**
     * Creates a date but allows the month and date to overflow.
     * @param {?} year
     * @param {?} month
     * @param {?} date
     * @return {?}
     */
    NativeDateAdapter.prototype._createDateWithOverflow = function (year, month, date) {
        var /** @type {?} */ result = new Date(year, month, date);
        // We need to correct for the fact that JS native Date treats years in range [0, 99] as
        // abbreviations for 19xx.
        if (year >= 0 && year < 100) {
            result.setFullYear(this.getYear(result) - 1900);
        }
        return result;
    };
    /**
     * Pads a number to make it two digits.
     * @param {?} n The number to pad.
     * @return {?} The padded number.
     */
    NativeDateAdapter.prototype._2digit = function (n) {
        return ('00' + n).slice(-2);
    };
    /**
     * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
     * other browsers do not. We remove them to make output consistent and because they interfere with
     * date parsing.
     * @param {?} s The string to strip direction characters from.
     * @return {?} The stripped string.
     */
    NativeDateAdapter.prototype._stripDirectionalityCharacters = function (s) {
        return s.replace(/[\u200e\u200f]/g, '');
    };
    return NativeDateAdapter;
}(DateAdapter));
var XPO_NATIVE_DATE_FORMATS = {
    parse: {
        dateInput: null,
    },
    display: {
        dateInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};
var NativeDateModule = (function () {
    function NativeDateModule() {
    }
    return NativeDateModule;
}());
NativeDateModule.decorators = [
    { type: NgModule, args: [{
                providers: [{ provide: DateAdapter, useClass: NativeDateAdapter }],
            },] },
];
/**
 * @nocollapse
 */
NativeDateModule.ctorParameters = function () { return []; };
var XpoNativeDateModule = (function () {
    function XpoNativeDateModule() {
    }
    return XpoNativeDateModule;
}());
XpoNativeDateModule.decorators = [
    { type: NgModule, args: [{
                imports: [NativeDateModule],
                providers: [{ provide: XPO_DATE_FORMATS, useValue: XPO_NATIVE_DATE_FORMATS }],
            },] },
];
/**
 * @nocollapse
 */
XpoNativeDateModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Utility class used to chain RxJS operators.
 *
 * This class is the concrete implementation, but the type used by the user when chaining
 * is StrictRxChain. The strict chain enforces types on the operators to the same level as
 * the prototype-added equivalents.
 *
 * \@docs-private
 */
var RxChain = (function () {
    /**
     * @param {?} _context
     */
    function RxChain(_context) {
        this._context = _context;
    }
    /**
     * Starts a new chain and specifies the initial `this` value.
     * @template T
     * @param {?} context Initial `this` value for the chain.
     * @return {?}
     */
    RxChain.from = function (context) {
        return new RxChain(context);
    };
    /**
     * Invokes an RxJS operator as a part of the chain.
     * @param {?} operator Operator to be invoked.
     * @param {...?} args Arguments to be passed to the operator.
     * @return {?}
     */
    RxChain.prototype.call = function (operator) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this._context = operator.call.apply(operator, [this._context].concat(args));
        return this;
    };
    /**
     * Subscribes to the result of the chain.
     * @param {?} fn Callback to be invoked when the result emits a value.
     * @return {?}
     */
    RxChain.prototype.subscribe = function (fn) {
        return this._context.subscribe(fn);
    };
    /**
     * Returns the result of the chain.
     * @return {?}
     */
    RxChain.prototype.result = function () {
        return this._context;
    };
    return RxChain;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FinallyBrand = (function () {
    function FinallyBrand() {
    }
    return FinallyBrand;
}());
var CatchBrand = (function () {
    function CatchBrand() {
    }
    return CatchBrand;
}());
var DoBrand = (function () {
    function DoBrand() {
    }
    return DoBrand;
}());
var MapBrand = (function () {
    function MapBrand() {
    }
    return MapBrand;
}());
var FilterBrand = (function () {
    function FilterBrand() {
    }
    return FilterBrand;
}());
var ShareBrand = (function () {
    function ShareBrand() {
    }
    return ShareBrand;
}());
var FirstBrand = (function () {
    function FirstBrand() {
    }
    return FirstBrand;
}());
var SwitchMapBrand = (function () {
    function SwitchMapBrand() {
    }
    return SwitchMapBrand;
}());
var StartWithBrand = (function () {
    function StartWithBrand() {
    }
    return StartWithBrand;
}());
var DebounceTimeBrand = (function () {
    function DebounceTimeBrand() {
    }
    return DebounceTimeBrand;
}());
var AuditTimeBrand = (function () {
    function AuditTimeBrand() {
    }
    return AuditTimeBrand;
}());
var TakeUntilBrand = (function () {
    function TakeUntilBrand() {
    }
    return TakeUntilBrand;
}());
var DelayBrand = (function () {
    function DelayBrand() {
    }
    return DelayBrand;
}());
// We add `Function` to the type intersection to make this nomically different from
// `finallyOperatorType` while still being structurally the same. Without this, TypeScript tries to
// reduce `typeof _finallyOperator & FinallyBrand` to `finallyOperatorType<T>` and then fails
// because `T` isn't known.
var finallyOperator = (_finally);
var catchOperator = (_catch);
var doOperator = (_do);
var map$1 = (map);
var filter$1 = (filter);
var share$1 = (share);
var first$1 = (first);
var switchMap$1 = (switchMap);
var startWith$1 = (startWith);
var debounceTime$1 = (debounceTime);
var auditTime$1 = (auditTime);
var takeUntil$1 = (takeUntil);
var delay$1 = (delay);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XpoCoreModule = (function () {
    function XpoCoreModule() {
    }
    return XpoCoreModule;
}());
XpoCoreModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    XpoLineModule,
                    RtlModule,
                    XpoRippleModule,
                    ObserveContentModule,
                    PortalModule,
                    OverlayModule,
                    XpoMenuingModule,
                    XpoOptionModule,
                    XpoSelectionModule,
                ],
                exports: [
                    XpoLineModule,
                    RtlModule,
                    XpoRippleModule,
                    ObserveContentModule,
                    PortalModule,
                    OverlayModule,
                    XpoOptionModule,
                    XpoSelectionModule,
                ],
                providers: [XpoConfigService, XpoPermissionService],
            },] },
];
/**
 * @nocollapse
 */
XpoCoreModule.ctorParameters = function () { return []; };
/**
 * Xpo common action bar
 */
var XpoActionBar = (function () {
    function XpoActionBar() {
    }
    Object.defineProperty(XpoActionBar.prototype, "helper", {
        /**
         * The action bar helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoActionBar;
}());
XpoActionBar.decorators = [
    { type: Component, args: [{ selector: 'xpo-actionbar',
                host: {},
                template: "<span *ngIf=\"helperObj\"> {{ helperObj.value }} </span> <ng-content></ng-content>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0} /*# sourceMappingURL=actionbar.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoActionBar.ctorParameters = function () { return []; };
XpoActionBar.propDecorators = {
    'helper': [{ type: Input },],
};
var XpoActionBarColumn = (function () {
    function XpoActionBarColumn() {
    }
    return XpoActionBarColumn;
}());
XpoActionBarColumn.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-actionbar-col',
            },] },
];
/**
 * @nocollapse
 */
XpoActionBarColumn.ctorParameters = function () { return []; };
/**
 * XpoActionBarRowDirective
 */
var XpoActionBarRow = (function () {
    function XpoActionBarRow() {
    }
    Object.defineProperty(XpoActionBarRow.prototype, "light", {
        /**
         * @return {?}
         */
        get: function () { return this._light; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._light = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    return XpoActionBarRow;
}());
XpoActionBarRow.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-actionbar-row',
                host: {
                    '[class.xpo-actionbar-row--light]': 'light',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoActionBarRow.ctorParameters = function () { return []; };
XpoActionBarRow.propDecorators = {
    'light': [{ type: Input },],
};
var XpoActionBarModule = (function () {
    function XpoActionBarModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoActionBarModule.forRoot = function () {
        return {
            ngModule: XpoActionBarModule,
        };
    };
    return XpoActionBarModule;
}());
XpoActionBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoActionBar, XpoActionBarRow, XpoActionBarColumn],
                declarations: [XpoActionBar, XpoActionBarRow, XpoActionBarColumn],
            },] },
];
/**
 * @nocollapse
 */
XpoActionBarModule.ctorParameters = function () { return []; };
/** This is the import of the global xpo configuration service */
/**
 * <xpo-example> component displays example content.  This is an example component used as a template for other components.
 */
var XPOExample = (function () {
    /**
     * This is the constructor which injects the service and subscribed to
     * the config cryer to set information when it is changed
     *
     * @param {?} xpoCfgService
     */
    function XPOExample(xpoCfgService) {
        var _this = this;
        this.xpoCfgService = xpoCfgService;
        xpoCfgService.xpoConfigCryer$.subscribe(function (xpoCfg) { return _this.tmpCfg = xpoCfg; });
    }
    Object.defineProperty(XPOExample.prototype, "helper", {
        /**
         * The example helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XPOExample;
}());
XPOExample.decorators = [
    { type: Component, args: [{ selector: 'xpo-example',
                host: {},
                template: "<span *ngIf=\"helperObj\"> {{ helperObj.value }} </span> <ng-content></ng-content> <br> <h4>Variable from the XPO Config</h4> Layout: {{ tmpCfg.layout }}<br><br>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}.card-header{height:50px;font-size:1.1667rem;line-height:50px;background-color:#d50000}.card-header /deep/ .header__title{margin:0;line-height:50px}:host{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12);display:inline-block;background-color:#fafafa}:host>>>.example-header{border-bottom:1px solid #333}:host-context(.xpo-internal)>>>.example-header{height:25px;font-size:1rem;line-height:25px;background-color:#eee}:host-context(.xpo-internal)>>>.example-header /deep/ .header__title{margin:0;line-height:25px}:host-context(.xpo-external)>>>.example-header{height:50px;font-size:1.1667rem;line-height:50px;background-color:#d50000}:host-context(.xpo-external)>>>.example-header /deep/ .header__title{margin:0;line-height:50px}:host-context(.xpo-external)>>>.small{font-size:.91667rem}:host-context(.xpo-external)>>>.large{font-size:1.1667rem}:host-context(.xpo-external)>>>.xlarge{font-size:1.8333rem}@media (min-width:600px){:host-context(.xpo-external)>>>.xlarge{font-size:2.571rem}} /*# sourceMappingURL=example.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XPOExample.ctorParameters = function () { return [
    { type: XpoConfigService, },
]; };
XPOExample.propDecorators = {
    'helper': [{ type: Input },],
};
var XpoExampleModule = (function () {
    function XpoExampleModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoExampleModule.forRoot = function () {
        return {
            ngModule: XpoExampleModule,
        };
    };
    return XpoExampleModule;
}());
XpoExampleModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XPOExample],
                declarations: [XPOExample],
            },] },
];
/**
 * @nocollapse
 */
XpoExampleModule.ctorParameters = function () { return []; };
var BreadCrumbService = (function () {
    function BreadCrumbService() {
        this.appCrumbs = [{}];
    }
    /**
     * @return {?}
     */
    BreadCrumbService.prototype.getCrumbs = function () {
        return this.appCrumbs;
    };
    /**
     * @param {?} v
     * @return {?}
     */
    BreadCrumbService.prototype.setCrumbs = function (v) {
        this.appCrumbs = v;
    };
    return BreadCrumbService;
}());
BreadCrumbService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
BreadCrumbService.ctorParameters = function () { return []; };
/**
 * <xpo-breadcrumb> displays breadcrumb links to navigate to parent pages.
 */
var XpoBreadCrumb = (function () {
    function XpoBreadCrumb() {
    }
    Object.defineProperty(XpoBreadCrumb.prototype, "source", {
        /**
         * Source of data that the bread crumbs are built from.
         * @return {?}
         */
        get: function () { return this.breadCrumb; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.breadCrumb = value; },
        enumerable: true,
        configurable: true
    });
    return XpoBreadCrumb;
}());
XpoBreadCrumb.decorators = [
    { type: Component, args: [{ selector: 'xpo-breadcrumb',
                host: {},
                template: "<ng-content></ng-content> <!--Bread Crumb Bar--> <div class=\"breadcrumbbar\"> <ul> <li *ngFor=\"let bc of this.breadCrumb.breadcrumb\"> <a routerLink=\"{{bc.link}}\">{{bc.name}}</a> </li> </ul> </div>",
                styles: [":host{display:flex;color:#fff}:host .breadcrumbbar{display:flex;width:100%;min-height:3em;padding-right:1em;padding-left:1em;background-color:#c00}:host /deep/ ul{display:flex;align-items:center;padding-right:1em;padding-left:1em;list-style-type:none}:host /deep/ li{padding-right:.5em}:host /deep/ a{font-weight:500;color:#fff;text-decoration:none;text-transform:uppercase}:host /deep/ a:after{display:inline-flex;align-self:center;padding-left:.5em;content:\"/\"}:host /deep/ li:first-of-type a{font-weight:500}:host /deep/ li:last-of-type a{font-weight:600}:host /deep/ li:last-of-type a:after{display:inline-flex;padding-left:0;content:\" \"}@media (max-width:30em){:host /deep/ li a{display:none}:host /deep/ li:nth-last-child(2) a{display:inline-flex}:host /deep/ li:last-of-type a{display:inline-flex}} /*# sourceMappingURL=breadcrumb.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoBreadCrumb.ctorParameters = function () { return []; };
XpoBreadCrumb.propDecorators = {
    'source': [{ type: Input },],
};
var XpoBreadCrumbModule = (function () {
    function XpoBreadCrumbModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoBreadCrumbModule.forRoot = function () {
        return {
            ngModule: XpoBreadCrumbModule,
            providers: [BreadCrumbService],
        };
    };
    return XpoBreadCrumbModule;
}());
XpoBreadCrumbModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, RouterModule],
                exports: [XpoBreadCrumb],
                declarations: [XpoBreadCrumb],
            },] },
];
/**
 * @nocollapse
 */
XpoBreadCrumbModule.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the xpo- CSS styling to this selector.
 * \@docs-private
 */
var XpoButtonCssMatStyler = (function () {
    function XpoButtonCssMatStyler() {
    }
    return XpoButtonCssMatStyler;
}());
XpoButtonCssMatStyler.decorators = [
    { type: Directive, args: [{
                selector: 'button[xpo-btn], a[xpo-btn]',
            },] },
];
/**
 * @nocollapse
 */
XpoButtonCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the xpo- CSS styling to this selector.
 * \@docs-private
 */
var XpoRaisedButtonCssMatStyler = (function () {
    function XpoRaisedButtonCssMatStyler() {
    }
    return XpoRaisedButtonCssMatStyler;
}());
XpoRaisedButtonCssMatStyler.decorators = [
    { type: Directive, args: [{
                selector: 'button[xpo-raised-btn]' +
                    'a[xpo-raised-btn]',
                host: { class: 'xpo-raised-button' },
            },] },
];
/**
 * @nocollapse
 */
XpoRaisedButtonCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the xpo- CSS styling to this selector.
 * \@docs-private
 */
var XpoIconButtonCssMatStyler = (function () {
    function XpoIconButtonCssMatStyler() {
    }
    return XpoIconButtonCssMatStyler;
}());
XpoIconButtonCssMatStyler.decorators = [
    { type: Directive, args: [{
                selector: 'button[xpo-icon-btn], a[xpo-icon-btn]',
                host: { class: 'xpo-icon-button' },
            },] },
];
/**
 * @nocollapse
 */
XpoIconButtonCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the xpo- CSS styling to this selector.
 * \@docs-private
 */
var XpoFabCssMatStyler = (function () {
    function XpoFabCssMatStyler() {
    }
    return XpoFabCssMatStyler;
}());
XpoFabCssMatStyler.decorators = [
    { type: Directive, args: [{
                selector: 'button[xpo-fab], a[xpo-fab]',
                host: { class: 'xpo-fab' },
            },] },
];
/**
 * @nocollapse
 */
XpoFabCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the xpo- CSS styling to this selector.
 * \@docs-private
 */
var XpoMiniFabCssMatStyler = (function () {
    function XpoMiniFabCssMatStyler() {
    }
    return XpoMiniFabCssMatStyler;
}());
XpoMiniFabCssMatStyler.decorators = [
    { type: Directive, args: [{
                selector: 'button[xpo-mini-fab], a[xpo-mini-fab]',
                host: { class: 'xpo-mini-fab' },
            },] },
];
/**
 * @nocollapse
 */
XpoMiniFabCssMatStyler.ctorParameters = function () { return []; };
var XpoButtonBase = (function () {
    function XpoButtonBase() {
    }
    return XpoButtonBase;
}());
var _XpoButtonMixinBase = mixinDisabled(XpoButtonBase);
/**
 * Material design button.
 */
var XpoButton = (function (_super) {
    __extends(XpoButton, _super);
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _platform
     * @param {?} _focusOriginMonitor
     */
    function XpoButton(_elementRef, _renderer, _platform, _focusOriginMonitor) {
        var _this = _super.call(this) || this;
        _this._elementRef = _elementRef;
        _this._renderer = _renderer;
        _this._platform = _platform;
        _this._focusOriginMonitor = _focusOriginMonitor;
        /**
         * Whether the button is round.
         */
        _this._isRoundButton = _this._hasAttributeWithPrefix('fab', 'mini-fab');
        /**
         * Whether the button is icon button.
         */
        _this._isIconButton = _this._hasAttributeWithPrefix('icon-button');
        _this._focusOriginMonitor.monitor(_this._elementRef.nativeElement, _this._renderer, true);
        return _this;
    }
    /**
     * @return {?}
     */
    XpoButton.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._elementRef.nativeElement);
    };
    Object.defineProperty(XpoButton.prototype, "color", {
        /**
         * The color of the button. Can be `primary`, `accent`, or `warn`.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._updateColor(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newColor
     * @return {?}
     */
    XpoButton.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    XpoButton.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            if (isAdd) {
                this._renderer.addClass(this._getHostElement(), "xpo-" + color);
            }
            else {
                this._renderer.removeClass(this._getHostElement(), "xpo-" + color);
            }
        }
    };
    /**
     * Focuses the button.
     * @return {?}
     */
    XpoButton.prototype.focus = function () {
        this._getHostElement().focus();
    };
    /**
     * @return {?}
     */
    XpoButton.prototype._getHostElement = function () {
        return this._elementRef.nativeElement;
    };
    /**
     * Gets whether the button has one of the given attributes
     * with either a 'xpo-' prefix.
     * @param {...?} unprefixedAttributeNames
     * @return {?}
     */
    XpoButton.prototype._hasAttributeWithPrefix = function () {
        var _this = this;
        var unprefixedAttributeNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            unprefixedAttributeNames[_i] = arguments[_i];
        }
        // If not on the browser, say that there are none of the attributes present.
        // Since these only affect how the ripple displays (and ripples only happen on the client),
        // detecting these attributes isn't necessary when not on the browser.
        // if (!this._platform.isBrowser) {
        //  return false;
        // }
        return unprefixedAttributeNames.some(function (suffix) {
            var /** @type {?} */ el = _this._getHostElement();
            return el.hasAttribute('xpo-' + suffix);
        });
    };
    return XpoButton;
}(_XpoButtonMixinBase));
XpoButton.decorators = [
    { type: Component, args: [{ selector: 'button[xpo-btn], button[xpo-raised-btn], button[xpo-icon-btn],' +
                    'button[xpo-fab], button[xpo-mini-fab],',
                host: {
                    '[disabled]': 'disabled || null',
                },
                template: "<span class=\"xpo-btn-wrapper\"> <ng-content></ng-content> </span> <!-- <div class=\"xpo-button-focus-overlay\"></div> -->",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{cursor:pointer;font-family:Roboto,Helvetica,Arial,sans-serif}:host-context(.xpo-internal){display:inline-flex;padding:5px 8px;font-size:1rem;font-weight:700;color:#0091ea;text-align:inherit;text-decoration:none;text-transform:uppercase;border:0;background:0 0}:host-context(.xpo-internal):active,:host-context(.xpo-internal):hover{color:#333}:host-context(.xpo-internal):disabled{cursor:not-allowed;color:#bdbdbd}:host-context(.xpo-internal):focus{outline-color:#80d8ff;outline-width:3px}:host-context(.xpo-internal) .xpo-btn-wrapper{display:flex;align-items:center}:host-context(.xpo-internal)[xpo-btn~=secondary]{color:#333}:host-context(.xpo-internal)[xpo-btn~=secondary]:active,:host-context(.xpo-internal)[xpo-btn~=secondary]:hover{color:#9e9e9e}:host-context(.xpo-internal)[xpo-btn~=secondary]:disabled{color:#bdbdbd}:host-context(.xpo-internal)[xpo-btn~=primary-dark]{color:#80d8ff}:host-context(.xpo-internal)[xpo-btn~=primary-dark]:active,:host-context(.xpo-internal)[xpo-btn~=primary-dark]:hover{color:#fff}:host-context(.xpo-internal)[xpo-btn~=primary-dark]:disabled{color:#858585}:host-context(.xpo-internal) ::ng-deep [class*=xico-]{margin-right:7px;font-size:16px}:host-context(.xpo-external){display:inline-block;vertical-align:baseline;min-width:138px;height:34px;padding:0 10px;font-size:14px;color:#fff;line-height:32px;text-align:center;text-decoration:none;user-select:none;border:1px solid #333;background-color:#333}:host-context(.xpo-external):focus,:host-context(.xpo-external):hover{cursor:pointer;border-color:#858585;background-color:#858585}:host-context(.xpo-external):focus{box-shadow:0 0 5px 0 #0091ea;outline:0;appearance:none}:host-context(.xpo-external)[disabled]{cursor:not-allowed;border-color:#bdbdbd;background-color:#bdbdbd}:host-context(.xpo-external) .xpo-btn-wrapper{display:flex;align-items:center;justify-content:center}:host-context(.xpo-external)[xpo-btn~=primary-form]{color:#fff;border-color:#d50000;background:#d50000}:host-context(.xpo-external)[xpo-btn~=primary-form]:focus,:host-context(.xpo-external)[xpo-btn~=primary-form]:hover{text-decoration:none;border-color:#b10000;background:#b10000}:host-context(.xpo-external)[xpo-btn~=primary-form][disabled]{border-color:#bdbdbd!important;background-color:#bdbdbd!important}:host-context(.xpo-external)[xpo-btn~=plain]{color:#333;border:1px solid #dfdfdf;background-color:#fff}:host-context(.xpo-external)[xpo-btn~=plain]:focus,:host-context(.xpo-external)[xpo-btn~=plain]:hover{border:1px solid #858585;background-color:#fff}:host-context(.xpo-external)[xpo-btn~=plain][disabled]{color:#bdbdbd;border-color:#dfdfdf;background-color:inherit!important}:host-context(.xpo-external)[xpo-btn~=link]{color:#0091ea;border-color:transparent;background-color:transparent}:host-context(.xpo-external)[xpo-btn~=link]:focus,:host-context(.xpo-external)[xpo-btn~=link]:hover{color:#333;border-color:transparent;background-color:inherit}:host-context(.xpo-external)[xpo-btn~=link][disabled]{color:#bdbdbd;background-color:transparent!important}:host-context(.xpo-external)[xpo-btn~=lg]{height:44px;font-size:16px;line-height:42px}:host-context(.xpo-external)[xpo-btn~=xl]{height:54px;font-size:16px;line-height:52px}:host-context(.xpo-external)>>>[class*=xico-]{margin-right:8px} /*# sourceMappingURL=button.css.map */ "],
                inputs: ['disabled'],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoButton.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: Platform, },
    { type: FocusOriginMonitor, },
]; };
XpoButton.propDecorators = {
    'color': [{ type: Input },],
};
/**
 * Raised Material design button.
 */
var XpoAnchor = (function (_super) {
    __extends(XpoAnchor, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     * @param {?} platform
     * @param {?} focusOriginMonitor
     */
    function XpoAnchor(elementRef, renderer, platform, focusOriginMonitor) {
        return _super.call(this, elementRef, renderer, platform, focusOriginMonitor) || this;
    }
    Object.defineProperty(XpoAnchor.prototype, "tabIndex", {
        /**
         * \@docs-private
         * @return {?}
         */
        get: function () {
            return this.disabled ? -1 : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoAnchor.prototype, "_isAriaDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this.disabled ? 'true' : 'false';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    XpoAnchor.prototype._haltDisabledEvents = function (event) {
        // A disabled button shouldn't apply any actions
        if (this.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    };
    return XpoAnchor;
}(XpoButton));
XpoAnchor.decorators = [
    { type: Component, args: [{ selector: "a[xpo-btn], a[xpo-icon-btn],\n             a[xpo-fab], a[xpo-mini-fab]",
                host: {
                    '[attr.disabled]': 'disabled || null',
                    '[attr.aria-disabled]': '_isAriaDisabled',
                    '(click)': '_haltDisabledEvents($event)',
                },
                inputs: ['disabled'],
                template: "<span class=\"xpo-btn-wrapper\"> <ng-content></ng-content> </span> <!-- <div class=\"xpo-button-focus-overlay\"></div> -->",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{cursor:pointer;font-family:Roboto,Helvetica,Arial,sans-serif}:host-context(.xpo-internal){display:inline-flex;padding:5px 8px;font-size:1rem;font-weight:700;color:#0091ea;text-align:inherit;text-decoration:none;text-transform:uppercase;border:0;background:0 0}:host-context(.xpo-internal):active,:host-context(.xpo-internal):hover{color:#333}:host-context(.xpo-internal):disabled{cursor:not-allowed;color:#bdbdbd}:host-context(.xpo-internal):focus{outline-color:#80d8ff;outline-width:3px}:host-context(.xpo-internal) .xpo-btn-wrapper{display:flex;align-items:center}:host-context(.xpo-internal)[xpo-btn~=secondary]{color:#333}:host-context(.xpo-internal)[xpo-btn~=secondary]:active,:host-context(.xpo-internal)[xpo-btn~=secondary]:hover{color:#9e9e9e}:host-context(.xpo-internal)[xpo-btn~=secondary]:disabled{color:#bdbdbd}:host-context(.xpo-internal)[xpo-btn~=primary-dark]{color:#80d8ff}:host-context(.xpo-internal)[xpo-btn~=primary-dark]:active,:host-context(.xpo-internal)[xpo-btn~=primary-dark]:hover{color:#fff}:host-context(.xpo-internal)[xpo-btn~=primary-dark]:disabled{color:#858585}:host-context(.xpo-internal) ::ng-deep [class*=xico-]{margin-right:7px;font-size:16px}:host-context(.xpo-external){display:inline-block;vertical-align:baseline;min-width:138px;height:34px;padding:0 10px;font-size:14px;color:#fff;line-height:32px;text-align:center;text-decoration:none;user-select:none;border:1px solid #333;background-color:#333}:host-context(.xpo-external):focus,:host-context(.xpo-external):hover{cursor:pointer;border-color:#858585;background-color:#858585}:host-context(.xpo-external):focus{box-shadow:0 0 5px 0 #0091ea;outline:0;appearance:none}:host-context(.xpo-external)[disabled]{cursor:not-allowed;border-color:#bdbdbd;background-color:#bdbdbd}:host-context(.xpo-external) .xpo-btn-wrapper{display:flex;align-items:center;justify-content:center}:host-context(.xpo-external)[xpo-btn~=primary-form]{color:#fff;border-color:#d50000;background:#d50000}:host-context(.xpo-external)[xpo-btn~=primary-form]:focus,:host-context(.xpo-external)[xpo-btn~=primary-form]:hover{text-decoration:none;border-color:#b10000;background:#b10000}:host-context(.xpo-external)[xpo-btn~=primary-form][disabled]{border-color:#bdbdbd!important;background-color:#bdbdbd!important}:host-context(.xpo-external)[xpo-btn~=plain]{color:#333;border:1px solid #dfdfdf;background-color:#fff}:host-context(.xpo-external)[xpo-btn~=plain]:focus,:host-context(.xpo-external)[xpo-btn~=plain]:hover{border:1px solid #858585;background-color:#fff}:host-context(.xpo-external)[xpo-btn~=plain][disabled]{color:#bdbdbd;border-color:#dfdfdf;background-color:inherit!important}:host-context(.xpo-external)[xpo-btn~=link]{color:#0091ea;border-color:transparent;background-color:transparent}:host-context(.xpo-external)[xpo-btn~=link]:focus,:host-context(.xpo-external)[xpo-btn~=link]:hover{color:#333;border-color:transparent;background-color:inherit}:host-context(.xpo-external)[xpo-btn~=link][disabled]{color:#bdbdbd;background-color:transparent!important}:host-context(.xpo-external)[xpo-btn~=lg]{height:44px;font-size:16px;line-height:42px}:host-context(.xpo-external)[xpo-btn~=xl]{height:54px;font-size:16px;line-height:52px}:host-context(.xpo-external)>>>[class*=xico-]{margin-right:8px} /*# sourceMappingURL=button.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
            },] },
];
/**
 * @nocollapse
 */
XpoAnchor.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: Platform, },
    { type: FocusOriginMonitor, },
]; };
XpoAnchor.propDecorators = {
    'tabIndex': [{ type: HostBinding, args: ['tabIndex',] },],
};
var XpoButtonModule = (function () {
    function XpoButtonModule() {
    }
    return XpoButtonModule;
}());
XpoButtonModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    XpoRippleModule,
                    XpoCommonModule,
                    StyleModule,
                ],
                exports: [
                    XpoButton,
                    XpoAnchor,
                    XpoCommonModule,
                    XpoButtonCssMatStyler,
                    XpoIconButtonCssMatStyler,
                    XpoRaisedButtonCssMatStyler,
                    XpoFabCssMatStyler,
                    XpoMiniFabCssMatStyler,
                ],
                declarations: [
                    XpoButton,
                    XpoAnchor,
                    XpoButtonCssMatStyler,
                    XpoIconButtonCssMatStyler,
                    XpoRaisedButtonCssMatStyler,
                    XpoFabCssMatStyler,
                    XpoMiniFabCssMatStyler,
                ],
            },] },
];
/**
 * @nocollapse
 */
XpoButtonModule.ctorParameters = function () { return []; };
/* tslint:disable */
/**
 * Provider Expression that allows xpo-button-toggle-group to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)].
 * \@docs-private
 */
var XPO_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return XpoButtonToggleGroup; }),
    multi: true,
};
var _uniqueIdCounter$1 = 0;
/**
 * Change event object emitted by XpoButtonToggle.
 */
var XpoButtonToggleChange = (function () {
    function XpoButtonToggleChange() {
    }
    return XpoButtonToggleChange;
}());
/**
 * Exclusive selection button toggle group that behaves like a radio-button group.
 */
var XpoButtonToggleGroup = (function () {
    function XpoButtonToggleGroup() {
        /**
         * The value for the button toggle group. Should match currently selected button toggle.
         */
        this._value = null;
        /**
         * The HTML name attribute applied to toggles in this group.
         */
        this._name = "xpo-button-toggle-group-" + _uniqueIdCounter$1++;
        /**
         * Disables all toggles in the group.
         */
        this._disabled = null;
        /**
         * Whether the button toggle group should be vertical.
         */
        this._vertical = false;
        /**
         * The currently selected button toggle, should match the value.
         */
        this._selected = null;
        /**
         * Whether the button toggle group is initialized or not.
         */
        this._isInitialized = false;
        /**
         * The method to be called in order to update ngModel.
         * Now `ngModel` binding is not supported in multiple selection mode.
         */
        this._controlValueAccessorChangeFn = function (value) { };
        /**
         * onTouch function registered via registerOnTouch (ControlValueAccessor).
         */
        this.onTouched = function () { };
        /**
         * Child button toggle buttons.
         */
        this._buttonToggles = null;
        /**
         * Event emitted when the group's value changes.
         */
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    XpoButtonToggleGroup.prototype.ngAfterViewInit = function () {
        this._isInitialized = true;
    };
    Object.defineProperty(XpoButtonToggleGroup.prototype, "name", {
        /**
         * `name` attribute for the underlying `input` element.
         * @return {?}
         */
        get: function () {
            return this._name;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._name = value;
            this._updateButtonToggleNames();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoButtonToggleGroup.prototype, "disabled", {
        /**
         * Whether the toggle group is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoButtonToggleGroup.prototype, "vertical", {
        /**
         * Whether the toggle group is vertical.
         * @return {?}
         */
        get: function () {
            return this._vertical;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._vertical = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoButtonToggleGroup.prototype, "value", {
        /**
         * Value of the toggle group.
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} newValue
         * @return {?}
         */
        set: function (newValue) {
            if (this._value != newValue) {
                this._value = newValue;
                this._updateSelectedButtonToggleFromValue();
                // Only emit a change event if the view is completely initialized.
                // We don't want to emit a change event for the initial values.
                if (this._isInitialized) {
                    this._emitChangeEvent();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoButtonToggleGroup.prototype, "selected", {
        /**
         * Whether the toggle group is selected.
         * @return {?}
         */
        get: function () {
            return this._selected;
        },
        /**
         * @param {?} selected
         * @return {?}
         */
        set: function (selected) {
            this._selected = selected;
            this.value = selected ? selected.value : null;
            if (selected && !selected.checked) {
                selected.checked = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoButtonToggleGroup.prototype._updateButtonToggleNames = function () {
        var _this = this;
        if (this._buttonToggles) {
            this._buttonToggles.forEach(function (toggle) {
                toggle.name = _this._name;
            });
        }
    };
    /**
     * @return {?}
     */
    XpoButtonToggleGroup.prototype._updateSelectedButtonToggleFromValue = function () {
        var _this = this;
        var /** @type {?} */ isAlreadySelected = this._selected != null && this._selected.value == this._value;
        if (this._buttonToggles != null && !isAlreadySelected) {
            var /** @type {?} */ matchingButtonToggle = this._buttonToggles.filter(function (buttonToggle) { return buttonToggle.value == _this._value; })[0];
            if (matchingButtonToggle) {
                this.selected = matchingButtonToggle;
            }
            else if (this.value == null) {
                this.selected = null;
                this._buttonToggles.forEach(function (buttonToggle) {
                    buttonToggle.checked = false;
                });
            }
        }
    };
    /**
     * Dispatch change event with current selection and group value.
     * @return {?}
     */
    XpoButtonToggleGroup.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new XpoButtonToggleChange();
        event.source = this._selected;
        event.value = this._value;
        this._controlValueAccessorChangeFn(event.value);
        this.change.emit(event);
    };
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param {?} value Value to be set to the model.
     * @return {?}
     */
    XpoButtonToggleGroup.prototype.writeValue = function (value) {
        this.value = value;
    };
    /**
     * Registers a callback that will be triggered when the value has changed.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn On change callback function.
     * @return {?}
     */
    XpoButtonToggleGroup.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * Registers a callback that will be triggered when the control has been touched.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn On touch callback function.
     * @return {?}
     */
    XpoButtonToggleGroup.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Toggles the disabled state of the component. Implemented as part of ControlValueAccessor.
     * @param {?} isDisabled Whether the component should be disabled.
     * @return {?}
     */
    XpoButtonToggleGroup.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return XpoButtonToggleGroup;
}());
XpoButtonToggleGroup.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-button-toggle-group:not([multiple])',
                providers: [XPO_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR],
                host: {
                    '[class.xpo-button-toggle-group]': 'true',
                    'role': 'radiogroup',
                    '[class.xpo-button-toggle-vertical]': 'vertical',
                },
                exportAs: 'xpoButtonToggleGroup',
            },] },
];
/**
 * @nocollapse
 */
XpoButtonToggleGroup.ctorParameters = function () { return []; };
XpoButtonToggleGroup.propDecorators = {
    '_buttonToggles': [{ type: ContentChildren, args: [forwardRef(function () { return XpoButtonToggle; }),] },],
    'name': [{ type: Input },],
    'disabled': [{ type: Input },],
    'vertical': [{ type: Input },],
    'value': [{ type: Input },],
    'selected': [{ type: Input },],
    'change': [{ type: Output },],
};
/**
 * Multiple selection button-toggle group. `ngModel` is not supported in this mode.
 */
var XpoButtonToggleGroupMultiple = (function () {
    function XpoButtonToggleGroupMultiple() {
        /**
         * Disables all toggles in the group.
         */
        this._disabled = null;
        /**
         * Whether the button toggle group should be vertical.
         */
        this._vertical = false;
    }
    Object.defineProperty(XpoButtonToggleGroupMultiple.prototype, "disabled", {
        /**
         * Whether the toggle group is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = (value != null && value !== false) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoButtonToggleGroupMultiple.prototype, "vertical", {
        /**
         * Whether the toggle group is vertical.
         * @return {?}
         */
        get: function () {
            return this._vertical;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._vertical = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    return XpoButtonToggleGroupMultiple;
}());
XpoButtonToggleGroupMultiple.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-button-toggle-group[multiple], xpo-button-toggle-group[multiple]',
                exportAs: 'xpoButtonToggleGroup',
                host: {
                    '[class.xpo-button-toggle-group]': 'true',
                    '[class.xpo-button-toggle-vertical]': 'vertical',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoButtonToggleGroupMultiple.ctorParameters = function () { return []; };
XpoButtonToggleGroupMultiple.propDecorators = {
    'disabled': [{ type: Input },],
    'vertical': [{ type: Input },],
};
/**
 * Single button inside of a toggle group.
 */
var XpoButtonToggle = (function () {
    /**
     * @param {?} toggleGroup
     * @param {?} toggleGroupMultiple
     * @param {?} _buttonToggleDispatcher
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _focusOriginMonitor
     */
    function XpoButtonToggle(toggleGroup, toggleGroupMultiple, _buttonToggleDispatcher, _renderer, _elementRef, _focusOriginMonitor) {
        var _this = this;
        this._buttonToggleDispatcher = _buttonToggleDispatcher;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._focusOriginMonitor = _focusOriginMonitor;
        /**
         * Whether or not this button toggle is checked.
         */
        this._checked = false;
        /**
         * Whether or not this button toggle is disabled.
         */
        this._disabled = null;
        /**
         * Value assigned to this button toggle.
         */
        this._value = null;
        /**
         * Whether or not the button toggle is a single selection.
         */
        this._isSingleSelector = null;
        /**
         * Event emitted when the group value changes.
         */
        this.change = new EventEmitter();
        this.buttonToggleGroup = toggleGroup;
        this.buttonToggleGroupMultiple = toggleGroupMultiple;
        if (this.buttonToggleGroup) {
            _buttonToggleDispatcher.listen(function (id, name) {
                if (id != _this.id && name == _this.name) {
                    _this.checked = false;
                }
            });
            this._type = 'radio';
            this.name = this.buttonToggleGroup.name;
            this._isSingleSelector = true;
        }
        else {
            // Even if there is no group at all, treat the button toggle as a checkbox so it can be
            // toggled on or off.
            this._type = 'checkbox';
            this._isSingleSelector = false;
        }
    }
    Object.defineProperty(XpoButtonToggle.prototype, "inputId", {
        /**
         * Unique ID for the underlying `input` element.
         * @return {?}
         */
        get: function () {
            return this.id + "-input";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoButtonToggle.prototype, "checked", {
        /**
         * Whether the button is checked.
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        /**
         * @param {?} newCheckedState
         * @return {?}
         */
        set: function (newCheckedState) {
            if (this._isSingleSelector) {
                if (newCheckedState) {
                    // Notify all button toggles with the same name (in the same group) to un-check.
                    this._buttonToggleDispatcher.notify(this.id, this.name);
                }
            }
            this._checked = newCheckedState;
            if (newCheckedState && this._isSingleSelector && this.buttonToggleGroup.value != this.value) {
                this.buttonToggleGroup.selected = this;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoButtonToggle.prototype, "value", {
        /**
         * XpoButtonToggleGroup reads this to assign its own value.
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value != value) {
                if (this.buttonToggleGroup != null && this.checked) {
                    this.buttonToggleGroup.value = value;
                }
                this._value = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoButtonToggle.prototype, "disabled", {
        /**
         * Whether the button is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled || (this.buttonToggleGroup != null && this.buttonToggleGroup.disabled) ||
                (this.buttonToggleGroupMultiple != null && this.buttonToggleGroupMultiple.disabled);
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = (value != null && value !== false) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoButtonToggle.prototype.ngOnInit = function () {
        if (this.id == null) {
            this.id = "xpo-button-toggle-" + _uniqueIdCounter$1++;
        }
        if (this.buttonToggleGroup && this._value == this.buttonToggleGroup.value) {
            this._checked = true;
        }
        this._focusOriginMonitor.monitor(this._elementRef.nativeElement, this._renderer, true);
    };
    /**
     * Focuses the button.
     * @return {?}
     */
    XpoButtonToggle.prototype.focus = function () {
        this._inputElement.nativeElement.focus();
    };
    /**
     * Toggle the state of the current button toggle.
     * @return {?}
     */
    XpoButtonToggle.prototype._toggle = function () {
        this.checked = !this.checked;
    };
    /**
     * Checks the button toggle due to an interaction with the underlying native input.
     * @param {?} event
     * @return {?}
     */
    XpoButtonToggle.prototype._onInputChange = function (event) {
        event.stopPropagation();
        if (this._isSingleSelector) {
            // Propagate the change one-way via the group, which will in turn mark this
            // button toggle as checked.
            this.checked = true;
            this.buttonToggleGroup.selected = this;
            this.buttonToggleGroup.onTouched();
        }
        else {
            this._toggle();
        }
        // Emit a change event when the native input does.
        this._emitChangeEvent();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoButtonToggle.prototype._onInputClick = function (event) {
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `slide-toggle` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
    };
    /**
     * Dispatch change event with current value.
     * @return {?}
     */
    XpoButtonToggle.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new XpoButtonToggleChange();
        event.source = this;
        event.value = this._value;
        this.change.emit(event);
    };
    return XpoButtonToggle;
}());
XpoButtonToggle.decorators = [
    { type: Component, args: [{ selector: 'xpo-button-toggle',
                template: "<label [attr.for]=\"inputId\" class=\"xpo-button-toggle-label\"> <input #input class=\"xpo-button-toggle-input cdk-visually-hidden\" [type]=\"_type\" [id]=\"inputId\" [checked]=\"checked\" [disabled]=\"disabled\" [name]=\"name\" (change)=\"_onInputChange($event)\" (click)=\"_onInputClick($event)\"> <div class=\"xpo-button-toggle-label-content\"> <ng-content></ng-content> </div> </label> <!-- the touchstart handler prevents the overlay from capturing the initial tap on touch devices --> <div class=\"xpo-button-toggle-focus-overlay\" (touchstart)=\"$event.preventDefault()\"></div>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}.xpo-button-toggle-group{display:inline-flex;flex-direction:row;position:relative;cursor:pointer;white-space:nowrap;border-radius:2px}.xpo-button-toggle-vertical{flex-direction:column}.xpo-button-toggle-vertical .xpo-button-toggle-label-content{display:block}.xpo-button-toggle-disabled .xpo-button-toggle-label-content{cursor:default}.xpo-button-toggle{position:relative;white-space:nowrap}.xpo-button-toggle.cdk-keyboard-focused .xpo-button-toggle-focus-overlay{opacity:1}.xpo-button-toggle-label-content{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;padding:0 16px;cursor:pointer;line-height:36px}.xpo-button-toggle-label-content>*{vertical-align:middle}.xpo-button-toggle-focus-overlay{position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;border-radius:inherit;pointer-events:none} /*# sourceMappingURL=button-toggle.css.map */ "],
                encapsulation: ViewEncapsulation.None,
                host: {
                    '[class.xpo-button-toggle]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoButtonToggle.ctorParameters = function () { return [
    { type: XpoButtonToggleGroup, decorators: [{ type: Optional },] },
    { type: XpoButtonToggleGroupMultiple, decorators: [{ type: Optional },] },
    { type: UniqueSelectionDispatcher, },
    { type: Renderer2, },
    { type: ElementRef, },
    { type: FocusOriginMonitor, },
]; };
XpoButtonToggle.propDecorators = {
    '_inputElement': [{ type: ViewChild, args: ['input',] },],
    'id': [{ type: HostBinding }, { type: Input },],
    'name': [{ type: Input },],
    'checked': [{ type: HostBinding, args: ['class.xpo-button-toggle-checked',] }, { type: Input },],
    'value': [{ type: Input },],
    'disabled': [{ type: HostBinding, args: ['class.xpo-button-toggle-disabled',] }, { type: Input },],
    'change': [{ type: Output },],
};
var XpoButtonToggleModule = (function () {
    function XpoButtonToggleModule() {
    }
    return XpoButtonToggleModule;
}());
XpoButtonToggleModule.decorators = [
    { type: NgModule, args: [{
                imports: [FormsModule, XpoCommonModule, StyleModule],
                exports: [
                    XpoButtonToggleGroup,
                    XpoButtonToggleGroupMultiple,
                    XpoButtonToggle,
                    XpoCommonModule,
                ],
                declarations: [XpoButtonToggleGroup, XpoButtonToggleGroupMultiple, XpoButtonToggle],
                providers: [UNIQUE_SELECTION_DISPATCHER_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
XpoButtonToggleModule.ctorParameters = function () { return []; };
/**
 * Xpo common <xpo-app> app component.
 *
 * The App is the global component for the page area holding things like xpo-header and xpo-footer and xpo-main.
 */
var XpoExternalApp = (function () {
    /**
     * @param {?} hostElement
     */
    function XpoExternalApp(hostElement) {
        this.hostElement = hostElement;
        document.body.classList.add('xpo-external');
    }
    Object.defineProperty(XpoExternalApp.prototype, "helper", {
        /**
         * The xpo-app helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoExternalApp;
}());
XpoExternalApp.decorators = [
    { type: Component, args: [{ selector: 'xpo-external-app',
                host: {},
                template: "<div class=\"xpo-external\" xpo-flex-stack> <ng-content></ng-content> </div>",
                styles: ["/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */@import url(https://fonts.googleapis.com/css?family=Roboto:400,700);html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{text-decoration:underline;text-decoration:underline dotted;border-bottom:none}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{color:#000;background-color:#ff0}small{font-size:80%}sub,sup{vertical-align:baseline;position:relative;font-size:75%;line-height:0}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:100%;line-height:1.15}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{margin:0 2px;padding:.35em .625em .75em;border:1px solid silver}legend{display:table;box-sizing:border-box;max-width:100%;padding:0;color:inherit;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:textfield}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}template{display:none}[hidden]{display:none}*,:after,:before{box-sizing:border-box}html{height:100%;position:relative}body{height:100%;font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:400;color:#333}img{max-width:100%;border-style:none}button,input,textarea{-webkit-border-radius:0;appearance:none}hr{margin:10px 0;border:none;border-top:2px solid}h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:700;color:inherit;text-transform:uppercase;text-rendering:optimizelegibility}a{cursor:pointer;text-decoration:none}b,em,strong{font-weight:700}.layout--board{min-width:1100px}:root{font-size:12px}@media (min-width:600px){:root{font-size:14px}}body{line-height:1.4;background-color:#fff}main{overflow:hidden}h1,h2,h3,h4,h5,h6{line-height:1.15}h1:first-of-type,h2:first-of-type,h3:first-of-type,h4:first-of-type,h5:first-of-type,h6:first-of-type{margin-top:0}h1{margin:0;font-size:1.8333rem;color:#d50000}@media (min-width:600px){h1{font-size:2.571rem}}h2{margin:0;font-size:1.6667rem}@media (min-width:600px){h2{font-size:1.429rem}}h3{margin:25px 0;font-size:1.5rem}@media (min-width:600px){h3{font-size:1.286rem}}h4{margin:25px 0;font-size:1.3333rem}@media (min-width:600px){h4{font-size:1.143rem}}h5{margin:20px 0;font-size:1.25rem}@media (min-width:600px){h5{font-size:1rem}}p{margin-bottom:10px;line-height:1.4}a{color:#0091ea}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}@media screen and (min-width:)){.grid-cycle-1 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-1 .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1 .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-2 .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2 .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-3 .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3 .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-4 .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4 .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-5 .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5 .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-6 .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6 .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-7 .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7 .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-8 .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8 .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-9 .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9 .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-10 .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10 .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-11 .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11 .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-12 .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12 .grid-lego:nth-child(12n+1){padding-left:0}.grid-cycle-13 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-13 .grid-lego:nth-child(13n){padding-right:0}.grid-cycle-13 .grid-lego:nth-child(13n+1){padding-left:0}.grid-cycle-14 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-14 .grid-lego:nth-child(14n){padding-right:0}.grid-cycle-14 .grid-lego:nth-child(14n+1){padding-left:0}.grid-cycle-15 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-15 .grid-lego:nth-child(15n){padding-right:0}.grid-cycle-15 .grid-lego:nth-child(15n+1){padding-left:0}.grid-cycle-16 [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-16 .grid-lego:nth-child(16n){padding-right:0}.grid-cycle-16 .grid-lego:nth-child(16n+1){padding-left:0}}@media screen and (min-width:480px){.grid-cycle-1-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-1-xs .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-xs .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-2-xs .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-xs .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-3-xs .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-xs .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-4-xs .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-xs .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-5-xs .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-xs .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-6-xs .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-xs .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-7-xs .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-xs .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-8-xs .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-xs .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-9-xs .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-xs .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-10-xs .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-xs .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-11-xs .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-xs .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-12-xs .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-xs .grid-lego:nth-child(12n+1){padding-left:0}.grid-cycle-13-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-13-xs .grid-lego:nth-child(13n){padding-right:0}.grid-cycle-13-xs .grid-lego:nth-child(13n+1){padding-left:0}.grid-cycle-14-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-14-xs .grid-lego:nth-child(14n){padding-right:0}.grid-cycle-14-xs .grid-lego:nth-child(14n+1){padding-left:0}.grid-cycle-15-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-15-xs .grid-lego:nth-child(15n){padding-right:0}.grid-cycle-15-xs .grid-lego:nth-child(15n+1){padding-left:0}.grid-cycle-16-xs [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-16-xs .grid-lego:nth-child(16n){padding-right:0}.grid-cycle-16-xs .grid-lego:nth-child(16n+1){padding-left:0}}@media screen and (min-width:600px){.grid-cycle-1-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-1-sm .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-sm .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-2-sm .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-sm .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-3-sm .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-sm .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-4-sm .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-sm .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-5-sm .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-sm .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-6-sm .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-sm .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-7-sm .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-sm .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-8-sm .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-sm .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-9-sm .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-sm .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-10-sm .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-sm .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-11-sm .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-sm .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-12-sm .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-sm .grid-lego:nth-child(12n+1){padding-left:0}.grid-cycle-13-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-13-sm .grid-lego:nth-child(13n){padding-right:0}.grid-cycle-13-sm .grid-lego:nth-child(13n+1){padding-left:0}.grid-cycle-14-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-14-sm .grid-lego:nth-child(14n){padding-right:0}.grid-cycle-14-sm .grid-lego:nth-child(14n+1){padding-left:0}.grid-cycle-15-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-15-sm .grid-lego:nth-child(15n){padding-right:0}.grid-cycle-15-sm .grid-lego:nth-child(15n+1){padding-left:0}.grid-cycle-16-sm [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-16-sm .grid-lego:nth-child(16n){padding-right:0}.grid-cycle-16-sm .grid-lego:nth-child(16n+1){padding-left:0}}@media screen and (min-width:768px){.grid-cycle-1-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-1-md .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-md .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-2-md .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-md .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-3-md .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-md .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-4-md .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-md .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-5-md .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-md .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-6-md .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-md .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-7-md .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-md .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-8-md .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-md .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-9-md .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-md .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-10-md .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-md .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-11-md .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-md .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-12-md .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-md .grid-lego:nth-child(12n+1){padding-left:0}.grid-cycle-13-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-13-md .grid-lego:nth-child(13n){padding-right:0}.grid-cycle-13-md .grid-lego:nth-child(13n+1){padding-left:0}.grid-cycle-14-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-14-md .grid-lego:nth-child(14n){padding-right:0}.grid-cycle-14-md .grid-lego:nth-child(14n+1){padding-left:0}.grid-cycle-15-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-15-md .grid-lego:nth-child(15n){padding-right:0}.grid-cycle-15-md .grid-lego:nth-child(15n+1){padding-left:0}.grid-cycle-16-md [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-16-md .grid-lego:nth-child(16n){padding-right:0}.grid-cycle-16-md .grid-lego:nth-child(16n+1){padding-left:0}}@media screen and (min-width:1025px){.grid-cycle-1-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-1-lg .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-lg .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-2-lg .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-lg .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-3-lg .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-lg .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-4-lg .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-lg .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-5-lg .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-lg .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-6-lg .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-lg .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-7-lg .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-lg .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-8-lg .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-lg .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-9-lg .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-lg .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-10-lg .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-lg .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-11-lg .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-lg .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-12-lg .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-lg .grid-lego:nth-child(12n+1){padding-left:0}.grid-cycle-13-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-13-lg .grid-lego:nth-child(13n){padding-right:0}.grid-cycle-13-lg .grid-lego:nth-child(13n+1){padding-left:0}.grid-cycle-14-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-14-lg .grid-lego:nth-child(14n){padding-right:0}.grid-cycle-14-lg .grid-lego:nth-child(14n+1){padding-left:0}.grid-cycle-15-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-15-lg .grid-lego:nth-child(15n){padding-right:0}.grid-cycle-15-lg .grid-lego:nth-child(15n+1){padding-left:0}.grid-cycle-16-lg [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-16-lg .grid-lego:nth-child(16n){padding-right:0}.grid-cycle-16-lg .grid-lego:nth-child(16n+1){padding-left:0}}@media screen and (min-width:1440px){.grid-cycle-1-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-1-xl .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-xl .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-2-xl .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-xl .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-3-xl .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-xl .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-4-xl .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-xl .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-5-xl .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-xl .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-6-xl .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-xl .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-7-xl .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-xl .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-8-xl .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-xl .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-9-xl .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-xl .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-10-xl .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-xl .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-11-xl .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-xl .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-12-xl .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-xl .grid-lego:nth-child(12n+1){padding-left:0}.grid-cycle-13-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-13-xl .grid-lego:nth-child(13n){padding-right:0}.grid-cycle-13-xl .grid-lego:nth-child(13n+1){padding-left:0}.grid-cycle-14-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-14-xl .grid-lego:nth-child(14n){padding-right:0}.grid-cycle-14-xl .grid-lego:nth-child(14n+1){padding-left:0}.grid-cycle-15-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-15-xl .grid-lego:nth-child(15n){padding-right:0}.grid-cycle-15-xl .grid-lego:nth-child(15n+1){padding-left:0}.grid-cycle-16-xl [class^=grid-lego]:nth-child(1n){padding:0 10px}.grid-cycle-16-xl .grid-lego:nth-child(16n){padding-right:0}.grid-cycle-16-xl .grid-lego:nth-child(16n+1){padding-left:0}}.grid .grid-lego:first-child{padding-left:0}.grid .grid-lego:last-child{padding-right:0}.grid--full-bleed .grid-lego{padding:0}.grid--space-between{justify-content:space-between}.grid--center{justify-content:center}.grid--grow .grid-lego{flex:1;padding:0 10px}@supports (display:flex){.grid{display:flex;flex-wrap:wrap;margin:0;padding:0}.grid-lego{display:flex;flex-direction:column;flex:0 0 auto;min-width:0}.grid-lego.grid-lego-1{flex-basis:6.25%;padding:0 10px}.grid-lego.grid-lego-offset-1{margin-left:6.25%}.grid-lego.grid-lego-2{flex-basis:12.5%;padding:0 10px}.grid-lego.grid-lego-offset-2{margin-left:12.5%}.grid-lego.grid-lego-3{flex-basis:18.75%;padding:0 10px}.grid-lego.grid-lego-offset-3{margin-left:18.75%}.grid-lego.grid-lego-4{flex-basis:25%;padding:0 10px}.grid-lego.grid-lego-offset-4{margin-left:25%}.grid-lego.grid-lego-5{flex-basis:31.25%;padding:0 10px}.grid-lego.grid-lego-offset-5{margin-left:31.25%}.grid-lego.grid-lego-6{flex-basis:37.5%;padding:0 10px}.grid-lego.grid-lego-offset-6{margin-left:37.5%}.grid-lego.grid-lego-7{flex-basis:43.75%;padding:0 10px}.grid-lego.grid-lego-offset-7{margin-left:43.75%}.grid-lego.grid-lego-8{flex-basis:50%;padding:0 10px}.grid-lego.grid-lego-offset-8{margin-left:50%}.grid-lego.grid-lego-9{flex-basis:56.25%;padding:0 10px}.grid-lego.grid-lego-offset-9{margin-left:56.25%}.grid-lego.grid-lego-10{flex-basis:62.5%;padding:0 10px}.grid-lego.grid-lego-offset-10{margin-left:62.5%}.grid-lego.grid-lego-11{flex-basis:68.75%;padding:0 10px}.grid-lego.grid-lego-offset-11{margin-left:68.75%}.grid-lego.grid-lego-12{flex-basis:75%;padding:0 10px}.grid-lego.grid-lego-offset-12{margin-left:75%}.grid-lego.grid-lego-13{flex-basis:81.25%;padding:0 10px}.grid-lego.grid-lego-offset-13{margin-left:81.25%}.grid-lego.grid-lego-14{flex-basis:87.5%;padding:0 10px}.grid-lego.grid-lego-offset-14{margin-left:87.5%}.grid-lego.grid-lego-15{flex-basis:93.75%;padding:0 10px}.grid-lego.grid-lego-offset-15{margin-left:93.75%}.grid-lego.grid-lego-16{flex-basis:100%}.grid-lego.grid-lego-offset-16{margin-left:100%}@media screen and (min-width:480px){.grid-lego.grid-lego-1-xs{flex-basis:6.25%;padding:0 10px}.grid-lego.grid-lego-offset-1-xs{margin-left:6.25%}.grid-lego.grid-lego-2-xs{flex-basis:12.5%;padding:0 10px}.grid-lego.grid-lego-offset-2-xs{margin-left:12.5%}.grid-lego.grid-lego-3-xs{flex-basis:18.75%;padding:0 10px}.grid-lego.grid-lego-offset-3-xs{margin-left:18.75%}.grid-lego.grid-lego-4-xs{flex-basis:25%;padding:0 10px}.grid-lego.grid-lego-offset-4-xs{margin-left:25%}.grid-lego.grid-lego-5-xs{flex-basis:31.25%;padding:0 10px}.grid-lego.grid-lego-offset-5-xs{margin-left:31.25%}.grid-lego.grid-lego-6-xs{flex-basis:37.5%;padding:0 10px}.grid-lego.grid-lego-offset-6-xs{margin-left:37.5%}.grid-lego.grid-lego-7-xs{flex-basis:43.75%;padding:0 10px}.grid-lego.grid-lego-offset-7-xs{margin-left:43.75%}.grid-lego.grid-lego-8-xs{flex-basis:50%;padding:0 10px}.grid-lego.grid-lego-offset-8-xs{margin-left:50%}.grid-lego.grid-lego-9-xs{flex-basis:56.25%;padding:0 10px}.grid-lego.grid-lego-offset-9-xs{margin-left:56.25%}.grid-lego.grid-lego-10-xs{flex-basis:62.5%;padding:0 10px}.grid-lego.grid-lego-offset-10-xs{margin-left:62.5%}.grid-lego.grid-lego-11-xs{flex-basis:68.75%;padding:0 10px}.grid-lego.grid-lego-offset-11-xs{margin-left:68.75%}.grid-lego.grid-lego-12-xs{flex-basis:75%;padding:0 10px}.grid-lego.grid-lego-offset-12-xs{margin-left:75%}.grid-lego.grid-lego-13-xs{flex-basis:81.25%;padding:0 10px}.grid-lego.grid-lego-offset-13-xs{margin-left:81.25%}.grid-lego.grid-lego-14-xs{flex-basis:87.5%;padding:0 10px}.grid-lego.grid-lego-offset-14-xs{margin-left:87.5%}.grid-lego.grid-lego-15-xs{flex-basis:93.75%;padding:0 10px}.grid-lego.grid-lego-offset-15-xs{margin-left:93.75%}.grid-lego.grid-lego-16-xs{flex-basis:100%;padding:0 10px}.grid-lego.grid-lego-offset-16-xs{margin-left:100%}}@media screen and (min-width:600px){.grid-lego.grid-lego-1-sm{flex-basis:6.25%;padding:0 10px}.grid-lego.grid-lego-offset-1-sm{margin-left:6.25%}.grid-lego.grid-lego-2-sm{flex-basis:12.5%;padding:0 10px}.grid-lego.grid-lego-offset-2-sm{margin-left:12.5%}.grid-lego.grid-lego-3-sm{flex-basis:18.75%;padding:0 10px}.grid-lego.grid-lego-offset-3-sm{margin-left:18.75%}.grid-lego.grid-lego-4-sm{flex-basis:25%;padding:0 10px}.grid-lego.grid-lego-offset-4-sm{margin-left:25%}.grid-lego.grid-lego-5-sm{flex-basis:31.25%;padding:0 10px}.grid-lego.grid-lego-offset-5-sm{margin-left:31.25%}.grid-lego.grid-lego-6-sm{flex-basis:37.5%;padding:0 10px}.grid-lego.grid-lego-offset-6-sm{margin-left:37.5%}.grid-lego.grid-lego-7-sm{flex-basis:43.75%;padding:0 10px}.grid-lego.grid-lego-offset-7-sm{margin-left:43.75%}.grid-lego.grid-lego-8-sm{flex-basis:50%;padding:0 10px}.grid-lego.grid-lego-offset-8-sm{margin-left:50%}.grid-lego.grid-lego-9-sm{flex-basis:56.25%;padding:0 10px}.grid-lego.grid-lego-offset-9-sm{margin-left:56.25%}.grid-lego.grid-lego-10-sm{flex-basis:62.5%;padding:0 10px}.grid-lego.grid-lego-offset-10-sm{margin-left:62.5%}.grid-lego.grid-lego-11-sm{flex-basis:68.75%;padding:0 10px}.grid-lego.grid-lego-offset-11-sm{margin-left:68.75%}.grid-lego.grid-lego-12-sm{flex-basis:75%;padding:0 10px}.grid-lego.grid-lego-offset-12-sm{margin-left:75%}.grid-lego.grid-lego-13-sm{flex-basis:81.25%;padding:0 10px}.grid-lego.grid-lego-offset-13-sm{margin-left:81.25%}.grid-lego.grid-lego-14-sm{flex-basis:87.5%;padding:0 10px}.grid-lego.grid-lego-offset-14-sm{margin-left:87.5%}.grid-lego.grid-lego-15-sm{flex-basis:93.75%;padding:0 10px}.grid-lego.grid-lego-offset-15-sm{margin-left:93.75%}.grid-lego.grid-lego-16-sm{flex-basis:100%;padding:0 10px}.grid-lego.grid-lego-offset-16-sm{margin-left:100%}}@media screen and (min-width:768px){.grid-lego.grid-lego-1-md{flex-basis:6.25%;padding:0 10px}.grid-lego.grid-lego-offset-1-md{margin-left:6.25%}.grid-lego.grid-lego-2-md{flex-basis:12.5%;padding:0 10px}.grid-lego.grid-lego-offset-2-md{margin-left:12.5%}.grid-lego.grid-lego-3-md{flex-basis:18.75%;padding:0 10px}.grid-lego.grid-lego-offset-3-md{margin-left:18.75%}.grid-lego.grid-lego-4-md{flex-basis:25%;padding:0 10px}.grid-lego.grid-lego-offset-4-md{margin-left:25%}.grid-lego.grid-lego-5-md{flex-basis:31.25%;padding:0 10px}.grid-lego.grid-lego-offset-5-md{margin-left:31.25%}.grid-lego.grid-lego-6-md{flex-basis:37.5%;padding:0 10px}.grid-lego.grid-lego-offset-6-md{margin-left:37.5%}.grid-lego.grid-lego-7-md{flex-basis:43.75%;padding:0 10px}.grid-lego.grid-lego-offset-7-md{margin-left:43.75%}.grid-lego.grid-lego-8-md{flex-basis:50%;padding:0 10px}.grid-lego.grid-lego-offset-8-md{margin-left:50%}.grid-lego.grid-lego-9-md{flex-basis:56.25%;padding:0 10px}.grid-lego.grid-lego-offset-9-md{margin-left:56.25%}.grid-lego.grid-lego-10-md{flex-basis:62.5%;padding:0 10px}.grid-lego.grid-lego-offset-10-md{margin-left:62.5%}.grid-lego.grid-lego-11-md{flex-basis:68.75%;padding:0 10px}.grid-lego.grid-lego-offset-11-md{margin-left:68.75%}.grid-lego.grid-lego-12-md{flex-basis:75%;padding:0 10px}.grid-lego.grid-lego-offset-12-md{margin-left:75%}.grid-lego.grid-lego-13-md{flex-basis:81.25%;padding:0 10px}.grid-lego.grid-lego-offset-13-md{margin-left:81.25%}.grid-lego.grid-lego-14-md{flex-basis:87.5%;padding:0 10px}.grid-lego.grid-lego-offset-14-md{margin-left:87.5%}.grid-lego.grid-lego-15-md{flex-basis:93.75%;padding:0 10px}.grid-lego.grid-lego-offset-15-md{margin-left:93.75%}.grid-lego.grid-lego-16-md{flex-basis:100%;padding:0 10px}.grid-lego.grid-lego-offset-16-md{margin-left:100%}}@media screen and (min-width:1025px){.grid-lego.grid-lego-1-lg{flex-basis:6.25%;padding:0 10px}.grid-lego.grid-lego-offset-1-lg{margin-left:6.25%}.grid-lego.grid-lego-2-lg{flex-basis:12.5%;padding:0 10px}.grid-lego.grid-lego-offset-2-lg{margin-left:12.5%}.grid-lego.grid-lego-3-lg{flex-basis:18.75%;padding:0 10px}.grid-lego.grid-lego-offset-3-lg{margin-left:18.75%}.grid-lego.grid-lego-4-lg{flex-basis:25%;padding:0 10px}.grid-lego.grid-lego-offset-4-lg{margin-left:25%}.grid-lego.grid-lego-5-lg{flex-basis:31.25%;padding:0 10px}.grid-lego.grid-lego-offset-5-lg{margin-left:31.25%}.grid-lego.grid-lego-6-lg{flex-basis:37.5%;padding:0 10px}.grid-lego.grid-lego-offset-6-lg{margin-left:37.5%}.grid-lego.grid-lego-7-lg{flex-basis:43.75%;padding:0 10px}.grid-lego.grid-lego-offset-7-lg{margin-left:43.75%}.grid-lego.grid-lego-8-lg{flex-basis:50%;padding:0 10px}.grid-lego.grid-lego-offset-8-lg{margin-left:50%}.grid-lego.grid-lego-9-lg{flex-basis:56.25%;padding:0 10px}.grid-lego.grid-lego-offset-9-lg{margin-left:56.25%}.grid-lego.grid-lego-10-lg{flex-basis:62.5%;padding:0 10px}.grid-lego.grid-lego-offset-10-lg{margin-left:62.5%}.grid-lego.grid-lego-11-lg{flex-basis:68.75%;padding:0 10px}.grid-lego.grid-lego-offset-11-lg{margin-left:68.75%}.grid-lego.grid-lego-12-lg{flex-basis:75%;padding:0 10px}.grid-lego.grid-lego-offset-12-lg{margin-left:75%}.grid-lego.grid-lego-13-lg{flex-basis:81.25%;padding:0 10px}.grid-lego.grid-lego-offset-13-lg{margin-left:81.25%}.grid-lego.grid-lego-14-lg{flex-basis:87.5%;padding:0 10px}.grid-lego.grid-lego-offset-14-lg{margin-left:87.5%}.grid-lego.grid-lego-15-lg{flex-basis:93.75%;padding:0 10px}.grid-lego.grid-lego-offset-15-lg{margin-left:93.75%}.grid-lego.grid-lego-16-lg{flex-basis:100%;padding:0 10px}.grid-lego.grid-lego-offset-16-lg{margin-left:100%}}@media screen and (min-width:1440px){.grid-lego.grid-lego-1-xl{flex-basis:6.25%;padding:0 10px}.grid-lego.grid-lego-offset-1-xl{margin-left:6.25%}.grid-lego.grid-lego-2-xl{flex-basis:12.5%;padding:0 10px}.grid-lego.grid-lego-offset-2-xl{margin-left:12.5%}.grid-lego.grid-lego-3-xl{flex-basis:18.75%;padding:0 10px}.grid-lego.grid-lego-offset-3-xl{margin-left:18.75%}.grid-lego.grid-lego-4-xl{flex-basis:25%;padding:0 10px}.grid-lego.grid-lego-offset-4-xl{margin-left:25%}.grid-lego.grid-lego-5-xl{flex-basis:31.25%;padding:0 10px}.grid-lego.grid-lego-offset-5-xl{margin-left:31.25%}.grid-lego.grid-lego-6-xl{flex-basis:37.5%;padding:0 10px}.grid-lego.grid-lego-offset-6-xl{margin-left:37.5%}.grid-lego.grid-lego-7-xl{flex-basis:43.75%;padding:0 10px}.grid-lego.grid-lego-offset-7-xl{margin-left:43.75%}.grid-lego.grid-lego-8-xl{flex-basis:50%;padding:0 10px}.grid-lego.grid-lego-offset-8-xl{margin-left:50%}.grid-lego.grid-lego-9-xl{flex-basis:56.25%;padding:0 10px}.grid-lego.grid-lego-offset-9-xl{margin-left:56.25%}.grid-lego.grid-lego-10-xl{flex-basis:62.5%;padding:0 10px}.grid-lego.grid-lego-offset-10-xl{margin-left:62.5%}.grid-lego.grid-lego-11-xl{flex-basis:68.75%;padding:0 10px}.grid-lego.grid-lego-offset-11-xl{margin-left:68.75%}.grid-lego.grid-lego-12-xl{flex-basis:75%;padding:0 10px}.grid-lego.grid-lego-offset-12-xl{margin-left:75%}.grid-lego.grid-lego-13-xl{flex-basis:81.25%;padding:0 10px}.grid-lego.grid-lego-offset-13-xl{margin-left:81.25%}.grid-lego.grid-lego-14-xl{flex-basis:87.5%;padding:0 10px}.grid-lego.grid-lego-offset-14-xl{margin-left:87.5%}.grid-lego.grid-lego-15-xl{flex-basis:93.75%;padding:0 10px}.grid-lego.grid-lego-offset-15-xl{margin-left:93.75%}.grid-lego.grid-lego-16-xl{flex-basis:100%;padding:0 10px}.grid-lego.grid-lego-offset-16-xl{margin-left:100%}}}.content-align--left{text-align:left}.content-align--right{text-align:right}.content-align--center{text-align:center}[xpo-flex-stack]{display:flex;flex-direction:column;height:100%}[xpo-flex-vcenter]{display:flex;align-items:center}[xpo-flex-vstretch]{display:flex}[xpo-flex-right]{display:flex;justify-content:flex-end}[xpo-flex-stretch]{flex:1}[xpo-flex-stretch-clear]{flex-basis:100%}[xpo-scroll-content]{height:100%;overflow:auto}.cdk-global-overlay-wrapper,.cdk-overlay-container{width:100%;height:100%;top:0;left:0;pointer-events:none}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{box-sizing:border-box;position:absolute;z-index:1000;pointer-events:auto}.cdk-overlay-pane__dialog{width:100%;height:100%;overflow:auto}.cdk-overlay-backdrop{position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;z-index:1000;transition:opacity .4s cubic-bezier(.25,.8,.25,1);pointer-events:auto}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.65}.cdk-overlay-dark-backdrop{background:1000;background-color:#333}.cdk-overlay-transparent-backdrop{background:0 0}.cdk-global-scrollblock{width:100%;overflow-y:scroll;position:fixed} /*# sourceMappingURL=external-app.css.map */ "],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoExternalApp.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
XpoExternalApp.propDecorators = {
    'helper': [{ type: Input },],
};
var XpoExternalAppModule = (function () {
    function XpoExternalAppModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoExternalAppModule.forRoot = function () {
        return {
            ngModule: XpoExternalAppModule,
        };
    };
    return XpoExternalAppModule;
}());
XpoExternalAppModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoExternalApp],
                declarations: [XpoExternalApp],
            },] },
];
/**
 * @nocollapse
 */
XpoExternalAppModule.ctorParameters = function () { return []; };
/**
 * <xpo-footer> component is a layout component for the web page footer.
 */
var XpoFooter = (function () {
    function XpoFooter() {
        this.copyright = (new Date()).getFullYear() + ' XPO Logistics, Inc. All rights reserved.';
        this.menuEntries = [];
        this.layout = 'internal';
        this.version = null;
        // TODO: take in config service and automatically set layout
    }
    return XpoFooter;
}());
XpoFooter.decorators = [
    { type: Component, args: [{ selector: 'xpo-footer',
                host: {},
                template: "<div class=\"footer\"> <div class=\"footer-col footer__copyright-col\"> &#169; {{ copyright }} </div> <div class=\"footer-col footer__version-col\" *ngIf=\"version\"> {{ version }} </div> <div class=\"footer-col footer__menu-col\" *ngIf=\"menuEntries\"> <xpo-footer-menu [entries]=\"menuEntries\"></xpo-footer-menu> </div> </div> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host .footer{display:flex}:host .footer-col{flex:1}:host .footer__menu-col{display:flex}:host-context(.xpo-internal){padding:10px 15px;font-size:.83333rem;color:#9e9e9e;background-color:#212121}:host-context(.xpo-internal) ::ng-deep a{color:#9e9e9e}:host-context(.xpo-internal) ::ng-deep a:hover{color:#fff}:host-context(.xpo-internal) .footer__version-col{text-align:center}:host-context(.xpo-internal) .footer__menu-col{justify-content:flex-end}:host-context(.xpo-external){padding:28px 15px;font-size:.91667rem;color:#858585;background-color:#333}:host-context(.xpo-external) a{color:#fff}:host-context(.xpo-external) a:hover{color:#9e9e9e}:host-context(.xpo-external) .footer{display:flex;flex-wrap:wrap}:host-context(.xpo-external) .footer__copyright-col{flex:1;order:2;text-align:left}:host-context(.xpo-external) .footer__version-col{justify-content:flex-start;flex:0 1 0%;order:3;padding-left:10px}:host-context(.xpo-external) .footer__menu-col{justify-content:flex-start;flex-basis:100%;margin-bottom:30px}@media (min-width:600px){:host-context(.xpo-external) .footer__menu-col{justify-content:center}}@media (min-width:768px){:host-context(.xpo-external){padding-right:30px;padding-left:30px}:host-context(.xpo-external) .footer__menu-col{justify-content:flex-start}}@media (min-width:1025px){:host-context(.xpo-external) .footer{flex-wrap:nowrap}:host-context(.xpo-external) .footer-col{flex:1}:host-context(.xpo-external) .footer__copyright-col{order:3;text-align:right}:host-context(.xpo-external) .footer__version-col{order:2;text-align:center}:host-context(.xpo-external) .footer__menu-col{margin-bottom:0}} /*# sourceMappingURL=footer.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoFooter.ctorParameters = function () { return []; };
XpoFooter.propDecorators = {
    'menuEntries': [{ type: Input },],
    'layout': [{ type: Input },],
    'version': [{ type: Input },],
};
/* tslint:disable */
/**
 * <xpo-footer-menu> It requires a MenuBarSource made up of an array of objects that contain 'name' and 'link' key value pairs.
 */
var XpoFooterMenu = (function () {
    /**
     * @param {?} permissionService
     * @param {?} ref
     */
    function XpoFooterMenu(permissionService, ref) {
        this.permissionService = permissionService;
        this.ref = ref;
        this.entriesNormalized = [];
    }
    /**
     * @return {?}
     */
    XpoFooterMenu.prototype.ngOnInit = function () {
        var _this = this;
        this.permissionsub = this.permissionService.permissions.subscribe(function (resultArray) { _this.permissionList = resultArray; _this.ref.markForCheck(); });
    };
    /**
     * @return {?}
     */
    XpoFooterMenu.prototype.ngOnDestroy = function () {
        this.permissionsub.unsubscribe();
    };
    Object.defineProperty(XpoFooterMenu.prototype, "entries", {
        /**
         * @return {?}
         */
        get: function () { return this.entriesNormalized; },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) { this.entriesNormalized = this.normalize(val); },
        enumerable: true,
        configurable: true
    });
    /**
     * Checking the router link, if it start with http then it will be be displayed as a href and not a router link.
     * @param {?} url
     * @return {?}
     */
    XpoFooterMenu.prototype.isHttpUrl = function (url) {
        return url.substr(0, 4).toUpperCase() === 'HTTP';
    };
    /**
     * @param {?} val
     * @return {?}
     */
    XpoFooterMenu.prototype.normalize = function (val) {
        (val || []).forEach(function (m) { return m.route = m.route || m.link; });
        return val || [];
    };
    /**
     * @param {?} p
     * @return {?}
     */
    XpoFooterMenu.prototype.checkPermission = function (p) {
        if (p != undefined) {
            return this.permissionList.findIndex(function (k) { return k == p; }) !== -1;
        }
        else {
            return true;
        }
    };
    /**
     * @param {?} list
     * @return {?}
     */
    XpoFooterMenu.prototype.buildMenuList = function (list) {
        var _this = this;
        return list.filter(function (item) { return _this.checkPermissionArray(item.permissions); });
    };
    /**
     * @param {?} permissions
     * @return {?}
     */
    XpoFooterMenu.prototype.checkPermissionArray = function (permissions) {
        var /** @type {?} */ ret = true;
        if (permissions != undefined) {
            for (var _i = 0, permissions_1 = permissions; _i < permissions_1.length; _i++) {
                var permission = permissions_1[_i];
                if (!this.checkPermission(permission)) {
                    ret = false;
                }
            }
        }
        return ret;
    };
    return XpoFooterMenu;
}());
XpoFooterMenu.decorators = [
    { type: Component, args: [{ selector: 'xpo-footer-menu',
                host: {},
                template: "<div class=\"footer-menu\"> <ul class=\"footer-menu__nav\"> <li class=\"footer-menu__item\" *ngFor=\"let item of this.buildMenuList(entriesNormalized)\"> <a *ngIf=\"!isHttpUrl(item.route);\" class=\"footer-menu__link\" routerLink=\"{{item.route}}\" [target]=\"item.target\">{{item.name}}</a> <a *ngIf=\"isHttpUrl(item.route);\" href=\"{{item.route}}\" class=\"footer-menu__link\" [target]=\"item.target\">{{item.name}}</a> </li> </ul> </div> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex}:host .footer-menu__nav{display:flex;margin:0;padding:0;list-style-type:none}:host .footer-menu__item{flex:1;white-space:nowrap}:host-context(.xpo-internal) .footer-menu__nav{justify-content:flex-end}:host-context(.xpo-internal) .footer-menu__item{flex:0 1 auto;margin-left:8px;padding-left:8px;font-size:.83333rem;border-left:1px solid #858585}:host-context(.xpo-internal) .footer-menu__item:first-child{margin-left:0;padding-left:0;border-left:none}:host-context(.xpo-internal) .footer-menu__link{color:#858585}:host-context(.xpo-internal) .footer-menu__link:hover{color:#fff}:host-context(.xpo-external) .footer-menu__nav{flex-wrap:wrap}:host-context(.xpo-external) .footer-menu__item{flex-basis:100%;margin-bottom:25px;font-size:.91667rem}:host-context(.xpo-external) .footer-menu__item:last-child{margin-bottom:0}:host-context(.xpo-external) .footer-menu__link{color:#fff}:host-context(.xpo-external) .footer-menu__link:hover{color:#9e9e9e}@media (min-width:600px){:host-context(.xpo-external) .footer-menu{display:flex;justify-content:center}:host-context(.xpo-external) .footer-menu__nav{flex-wrap:nowrap}:host-context(.xpo-external) .footer-menu__item{margin-bottom:0;margin-left:30px}:host-context(.xpo-external) .footer-menu__item:first-child{margin-left:0}}@media (min-width:1025px){:host-context(.xpo-external) .footer-menu{justify-content:flex-start}} /*# sourceMappingURL=footer-menu.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoFooterMenu.ctorParameters = function () { return [
    { type: XpoPermissionService, },
    { type: ChangeDetectorRef, },
]; };
XpoFooterMenu.propDecorators = {
    'entries': [{ type: Input },],
};
var XpoFooterModule = (function () {
    function XpoFooterModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoFooterModule.forRoot = function () {
        return {
            ngModule: XpoFooterModule,
        };
    };
    return XpoFooterModule;
}());
XpoFooterModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, RouterModule],
                exports: [XpoFooter, XpoFooterMenu],
                declarations: [XpoFooter, XpoFooterMenu],
            },] },
];
/**
 * @nocollapse
 */
XpoFooterModule.ctorParameters = function () { return []; };
/**
 * <xpo-header> component wraps content within a header (class="xpo-header") block.
 */
var XpoHeader = (function () {
    function XpoHeader() {
        this.isSubMenuVisible = false;
        this._menuEntries = [];
        this.layout = 'internal';
        this.logoUrl = null;
    }
    Object.defineProperty(XpoHeader.prototype, "menuEntries", {
        /**
         * @return {?}
         */
        get: function () {
            return this._menuEntries;
        },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this._menuEntries = val;
            this.isSubMenuVisible = val && val.some(function (entry) { return entry.children && entry.children.length > 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoHeader.prototype, "helper", {
        /**
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoHeader;
}());
XpoHeader.decorators = [
    { type: Component, args: [{ selector: 'xpo-header',
                host: {},
                template: "<header class=\"site-header\"> <div class=\"site-header__left\"> <xpo-header-menu [entries]=\"menuEntries\" [logoUrl]=\"logoUrl\"></xpo-header-menu> </div> <div class=\"site-header__right\" *ngIf=\"menuEntries\"> <ng-content></ng-content> </div> </header> <!-- <div class=\"grid grid--grow\" style=\"width: 100%;\"> <div class=\"grid-lego\"> <xpo-header-sub-menu [entries]=\"menuEntries\"></xpo-header-sub-menu> </div> </div>--> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex;flex-shrink:0;min-height:44px}:host .site-header{display:flex;width:100%}:host .site-header__left{display:flex;flex:1}:host .site-header__right{display:flex;align-items:center;justify-content:flex-end;flex:1}:host-context(.xpo-internal){background-color:#212121}:host-context(.xpo-internal) .site-header{padding:0 15px}:host-context(.xpo-internal) ::ng-deep a{color:#9e9e9e}:host-context(.xpo-external){background-color:#fff}:host-context(.xpo-external) ::ng-deep a{color:#333} /*# sourceMappingURL=header.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoHeader.ctorParameters = function () { return []; };
XpoHeader.propDecorators = {
    'menuEntries': [{ type: Input },],
    'layout': [{ type: Input },],
    'logoUrl': [{ type: Input },],
    'helper': [{ type: Input },],
};
/* tslint:disable */
var XpoHeaderMenu = (function () {
    /**
     * @param {?} permissionService
     * @param {?} ref
     */
    function XpoHeaderMenu(permissionService, ref) {
        this.permissionService = permissionService;
        this.ref = ref;
        /**
         * Menu items to be displayed
         */
        this.entries = [];
        /**
         * Logo to be displayed
         */
        this.logoUrl = null;
    }
    /**
     * @return {?}
     */
    XpoHeaderMenu.prototype.ngOnInit = function () {
        var _this = this;
        this.permissionsub = this.permissionService.permissions.subscribe(function (resultArray) { _this.permissionList = resultArray; _this.ref.markForCheck(); });
    };
    /**
     * @return {?}
     */
    XpoHeaderMenu.prototype.ngOnDestroy = function () {
        this.permissionsub.unsubscribe();
    };
    /**
     * Checking the router link, if it start with http then it will be be displayed as a href and not a router link.
     * @param {?} url
     * @return {?}
     */
    XpoHeaderMenu.prototype.isHttpUrl = function (url) {
        return url.substr(0, 4).toUpperCase() === 'HTTP';
    };
    /**
     * @param {?} p
     * @return {?}
     */
    XpoHeaderMenu.prototype.checkPermission = function (p) {
        if (p != undefined) {
            return this.permissionList.findIndex(function (k) { return k == p; }) !== -1;
        }
        else {
            return true;
        }
    };
    /**
     * @param {?} list
     * @return {?}
     */
    XpoHeaderMenu.prototype.buildMenuList = function (list) {
        var _this = this;
        return list.filter(function (item) { return _this.checkPermissionArray(item.permissions); });
    };
    /**
     * @param {?} permissions
     * @return {?}
     */
    XpoHeaderMenu.prototype.checkPermissionArray = function (permissions) {
        var /** @type {?} */ ret = true;
        if (permissions != undefined) {
            for (var _i = 0, permissions_2 = permissions; _i < permissions_2.length; _i++) {
                var permission = permissions_2[_i];
                if (!this.checkPermission(permission)) {
                    ret = false;
                }
            }
        }
        return ret;
    };
    return XpoHeaderMenu;
}());
XpoHeaderMenu.decorators = [
    { type: Component, args: [{ selector: 'xpo-header-menu',
                host: {},
                template: "<div class=\"logo\"> <a routerLink=\"/\" *ngIf=\"!logoUrl\" class=\"logo__link\"> <span class=\"logo-faux\"> <span class=\"logo-faux__xpo\">XPO</span><span class=\"logo-faux__logistics\">Logistics</span> </span> </a> <a routerLink=\"/\" *ngIf=\"logoUrl\" class=\"logo__link\"> <img src=\"{{logoUrl}}\" alt=\"home\" /> </a> </div> <nav class=\"nav\"> <!--THIS RUNS A SWITCH BASED ON THE START OF THE LINK, IF IT IS HTTP then it will use an href, otherwise it will treat it as a link--> <!-- PERMISSIONS ARE USED --> <ul class=\"nav__list\"> <li *ngFor=\"let item of this.buildMenuList(entries)\" class=\"nav__item\"> <a *ngIf=\"!isHttpUrl(item.route)\" routerLink=\"{{item.route}}\" routerLinkActive=\"nav__link--active\" class=\"nav__link\" [target]=\"item.target\">{{item.name}}</a> <a *ngIf=\"isHttpUrl(item.route)\" href=\"{{item.route}}\" [target]=\"item.target\">{{item.name}}</a> </li> </ul> </nav> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex}:host a{outline:0;text-decoration:none}:host .logo{display:inline-flex;flex-shrink:0;padding:5px 0}:host .logo__link{display:flex;align-self:center}:host .logo__link img{widows:auto;height:16px}:host .logo-faux{font-family:\"Arial Black\";font-size:13px;letter-spacing:-.5px}:host .logo-faux__xpo{color:#c00}:host .logo-faux__logistics{color:#fff}:host .nav{display:flex}:host .nav__list{display:flex;margin:0;padding:0;list-style-type:none}:host .nav__item a{font-size:1.167rem}:host-context(.xpo-internal) .nav{line-height:44px}:host-context(.xpo-internal) .nav__item{margin-left:30px}:host-context(.xpo-internal) .nav__item a{font-size:1.167rem;white-space:nowrap}:host-context(.xpo-internal) .nav__item a:hover{color:#fff}:host-context(.xpo-internal) .nav__item a.active{color:#fff}:host-context(.xpo-internal) .nav__link{display:inline-block;height:100%}:host-context(.xpo-internal) .nav__link--active{position:relative;color:#fff}:host-context(.xpo-internal) .nav__link--active::after{width:0;height:0;position:absolute;bottom:0;left:calc(50% - 8px);content:\"\";border-color:transparent transparent #fff;border-style:solid;border-width:0 8px 8px} /*# sourceMappingURL=header-menu.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderMenu.ctorParameters = function () { return [
    { type: XpoPermissionService, },
    { type: ChangeDetectorRef, },
]; };
XpoHeaderMenu.propDecorators = {
    'entries': [{ type: Input },],
    'logoUrl': [{ type: Input },],
};
/* tslint:disable */
var XpoHeaderSubMenu = (function () {
    /**
     * @param {?} router
     * @param {?} activatedRoute
     * @param {?} changeDetection
     */
    function XpoHeaderSubMenu(router, activatedRoute, changeDetection) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.changeDetection = changeDetection;
        this.entries = [];
        this.visibleEntries = [];
    }
    /**
     * @return {?}
     */
    XpoHeaderSubMenu.prototype.ngOnInit = function () {
        var _this = this;
        // based on logic taken from https://toddmotto.com/dynamic-page-titles-angular-2-router-events
        this.router.events
            .filter(function (event) { return event instanceof NavigationEnd; })
            .map(function () { return _this.activatedRoute; })
            .map(function (route) {
            while (route.firstChild)
                route = route.firstChild;
            return route;
        })
            .filter(function (route) { return route.outlet === 'primary'; })
            .mergeMap(function (route) { return route.data; })
            .subscribe(function (event) {
            debugger;
            _this.visibleEntries = _this.entries;
            _this.changeDetection.detectChanges();
        });
    };
    /**
     * Checking the router link, if it start with http then it will be be displayed as a href and not a router link.
     * @param {?} url
     * @return {?}
     */
    XpoHeaderSubMenu.prototype.isHttpUrl = function (url) {
        return url.substr(0, 4).toUpperCase() === 'HTTP';
    };
    /**
     * @return {?}
     */
    XpoHeaderSubMenu.prototype.ngOnDestroy = function () {
    };
    return XpoHeaderSubMenu;
}());
XpoHeaderSubMenu.decorators = [
    { type: Component, args: [{ selector: 'xpo-header-sub-menu',
                host: {},
                template: "<div> <!-- thas been updated so that if the link begins with http then it will display as a href otherwise it will display as a routerlink--> <!--THIS RUNS A SWITCH BASED ON THE START OF THE LINK, IF IT IS HTTP then it will use an href, otherwise it will treat it as a linkn--> <span *ngFor=\"let item of visibleEntries\"> <a *ngIf=\"!isHttpUrl(item.route);\" routerLink=\"{{item.route}}\" [target]=\"item.target\">{{item.name}}</a> <a *ngIf=\"isHttpUrl(item.route);\" href=\"{{item.route}}\" [target]=\"item.target\">{{item.name}}</a> </span> <!--END OF THE CHECK FOR THE HREF--> </div> <h2>{{ visibleEntries.length }}</h2> ",
                styles: [":host(){background:#fff} /*# sourceMappingURL=header-sub-menu.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderSubMenu.ctorParameters = function () { return [
    { type: Router, },
    { type: ActivatedRoute, },
    { type: ChangeDetectorRef, },
]; };
XpoHeaderSubMenu.propDecorators = {
    'entries': [{ type: Input },],
};
var XpoHeaderModule = (function () {
    function XpoHeaderModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoHeaderModule.forRoot = function () {
        return {
            ngModule: XpoHeaderModule,
        };
    };
    return XpoHeaderModule;
}());
XpoHeaderModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, RouterModule],
                exports: [XpoHeader, XpoHeaderMenu, XpoHeaderSubMenu],
                declarations: [XpoHeader, XpoHeaderMenu, XpoHeaderSubMenu],
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderModule.ctorParameters = function () { return []; };
/**
 * <xpo-header> component wraps content within a header (class="xpo-header") block.
 */
var XpoHeaderExt = (function () {
    function XpoHeaderExt() {
    }
    Object.defineProperty(XpoHeaderExt.prototype, "helper", {
        /**
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoHeaderExt;
}());
XpoHeaderExt.decorators = [
    { type: Component, args: [{ selector: 'xpo-header-ext',
                host: {},
                template: "<header class=\"xpo-header-ext\"> <ng-content></ng-content> </header>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex;flex-shrink:0}:host header-ext{width:100%;margin-top:1em}:host /deep/ xpo-header-ext-row{display:flex;width:100%;height:5em}:host /deep/ xpo-header-ext-col:nth-child(1){display:flex;flex-basis:35%}:host /deep/ xpo-header-ext-col:nth-child(2){display:flex;flex-direction:row-reverse;align-self:center;flex-basis:65%}:host /deep/ xpo-img{align-self:center;padding-left:5em}:host /deep/ .xpo-mobile-icon{display:none}@media (max-width:768px){:host{flex-direction:column}:host /deep/ xpo-menubar{display:none}:host /deep/ xpo-menubar.active{display:flex}:host header{flex-direction:column;max-height:inherit}:host /deep/ xpo-header-ext-row{display:flex;flex-direction:column;align-content:center;width:100%;height:auto}:host /deep/ xpo-header-ext-col:nth-child(1){width:auto;height:5em}:host /deep/ xpo-header-ext-col:nth-child(2){flex:1;flex-shrink:1;flex-basis:49%;width:80%;margin-top:40px;margin-bottom:32px;margin-left:7%;font-size:1em}:host /deep/ xpo-img{align-self:center;width:auto;margin-left:7%;padding-left:inherit}:host /deep/ xpo-img /deep/ span{display:flex;width:100%;cursor:pointer}:host /deep/ xpo-img /deep/ img{display:flex;max-width:100%;border-style:none}:host /deep/ xpo-header-ext-col:nth-child(2){flex-direction:column;flex:1;width:100%;margin:0;margin-top:3em}:host /deep/ header xpo-header-ext-col .person{flex-direction:column;width:100%;margin-top:0;margin-bottom:0}:host /deep/ header .person{padding-left:inherit;border-left:0}:host /deep/ .line1,:host /deep/ .line2,:host /deep/ .line3{display:block;width:25px;height:3px;margin-top:5px;position:relative;opacity:1;border-radius:15%;background-color:#d50000;transition:all .3s}:host /deep/ .line1.active{top:5px;transform:rotate(270deg);opacity:0;background-color:#1c1e1c}:host /deep/ .line2.active{transform:rotate(45deg);background-color:#1c1e1c}:host /deep/ .line3.active{top:-7px;transform:rotate(-45deg);background-color:#1c1e1c}:host /deep/ .xpo-mobile-icon{display:block;width:25px;height:25px;margin-top:.5em;margin-right:50px;position:absolute;top:20px;right:0;cursor:pointer;color:#d50000;text-decoration:none;z-index:100;trainsition:background-position .3s}}:host-context(.xpo-internal){background:#383838}:host-context(.xpo-internal) /deep/ xpo-header-ext-row[light]{color:#333;background-color:#fff}:host-context(.xpo-internal) /deep/ xpo-header-ext-col[light]{color:#333;background-color:#fff}:host-context(.xpo-internal) /deep/ .navigation a{color:#fff}:host-context(.xpo-external) /deep/ xpo-header-ext-row[light]{color:#333;background-color:#fff}:host-context(.xpo-external) /deep/ xpo-header-ext-col[light]{color:#333;background-color:#fff}:host-context(.xpo-external) /deep/ xpo-menubar .navigation a{color:#1c1e1c} /*# sourceMappingURL=header-ext.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderExt.ctorParameters = function () { return []; };
XpoHeaderExt.propDecorators = {
    'helper': [{ type: Input },],
};
/**
 * <xpo-header-ext-col> directrive represents a column within XpoHeader header block.
 */
var XpoHeaderExtCol = (function () {
    function XpoHeaderExtCol() {
    }
    return XpoHeaderExtCol;
}());
XpoHeaderExtCol.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-header-ext-col',
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderExtCol.ctorParameters = function () { return []; };
/**
 * <xpo-header-ext-row> directrive represents a row within XpoHeader header block.
 */
var XpoHeaderExtRow = (function () {
    function XpoHeaderExtRow() {
    }
    Object.defineProperty(XpoHeaderExtRow.prototype, "light", {
        /**
         * Whether or not _light property is set to true.
         * @return {?}
         */
        get: function () { return this._light; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._light = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    return XpoHeaderExtRow;
}());
XpoHeaderExtRow.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-header-ext-row',
                host: {
                    '[class.xpo-header-ext-row--light]': 'light',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderExtRow.ctorParameters = function () { return []; };
XpoHeaderExtRow.propDecorators = {
    'light': [{ type: Input },],
};
var XpoHeaderExtModule = (function () {
    function XpoHeaderExtModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoHeaderExtModule.forRoot = function () {
        return {
            ngModule: XpoHeaderExtModule,
        };
    };
    return XpoHeaderExtModule;
}());
XpoHeaderExtModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoHeaderExt, XpoHeaderExtRow, XpoHeaderExtCol],
                declarations: [XpoHeaderExt, XpoHeaderExtRow, XpoHeaderExtCol],
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderExtModule.ctorParameters = function () { return []; };
/**
 * <xpo-header> component wraps content within a header (class="xpo-header") block.
 */
var XpoHeaderInt = (function () {
    function XpoHeaderInt() {
    }
    Object.defineProperty(XpoHeaderInt.prototype, "helper", {
        /**
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoHeaderInt;
}());
XpoHeaderInt.decorators = [
    { type: Component, args: [{ selector: 'xpo-header-int',
                host: {},
                template: "<ng-content></ng-content> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host-context(.xpo-internal){color:#fff;background:#212121}:host-context(.xpo-internal) /deep/ xpo-header-int-row{display:flex;flex-direction:row;align-items:center;justify-content:flex-start;width:100%;height:44px!important}:host-context(.xpo-internal) /deep/ xpo-header-int-row[light]{color:#333;background-color:#fff}:host-context(.xpo-internal) /deep/ xpo-header-int-col{display:flex;flex-direction:row;align-items:center;justify-content:flex-start;height:44px!important;max-height:44px!important;min-height:44px!important;line-height:44px!important}:host-context(.xpo-internal) /deep/ xpo-header-int-col[light]{color:#333;background-color:#fff}:host-context(.xpo-internal) /deep/ xpo-header-int-col /deep/ xpo-img{margin-right:15px;margin-left:30px;padding-top:10px}:host-context(.xpo-internal) /deep/ xpo-header-int-col /deep/ button.red-button{display:inline-flex;align-items:center;justify-content:center;width:120px;height:34px;margin:0 10px;font-size:12px;color:#ddd;letter-spacing:.1em;border-color:#d50000;background:#d50000}:host-context(.xpo-internal) /deep/ xpo-header-int-col /deep/ button.red-button:active,:host-context(.xpo-internal) /deep/ xpo-header-int-col /deep/ button.red-button:focus{outline:0}:host-context(.xpo-internal) /deep/ xpo-header-int-col.flex-right{margin-left:auto}:host-context(.xpo-internal) /deep/ xpo-header-int-col.icon-button{justify-content:center;align-self:center;max-width:44px;min-width:44px}:host-context(.xpo-internal) /deep/ xpo-header-int-col.icon-button /deep/ button{width:44px;height:44px;color:#fff;border-color:#212121 #424242;border-style:solid;border-width:1px;background:#212121}:host-context(.xpo-internal) /deep/ xpo-header-int-col.icon-button /deep/ button:active,:host-context(.xpo-internal) /deep/ xpo-header-int-col.icon-button /deep/ button:focus{outline:0}:host-context(.xpo-internal) /deep/ xpo-header-int-col.icon-button /deep/ button /deep/ xpo-icon{padding-top:7px;font-size:20px;color:#fff}:host-context(.xpo-internal) /deep/ xpo-header-int-col.icon-button /deep/ button /deep/ xpo-icon:hover{color:#9e9e9e}:host-context(.xpo-internal) /deep/ .navigation a{font-size:14px;font-weight:400;color:#9e9e9e}:host-context(.xpo-internal) /deep/ .navigation a:active,:host-context(.xpo-internal) /deep/ .navigation a:hover{font-weight:700;color:#fff}:host /deep/ .xpo-mobile-icon{display:none}@media (max-width:768px){:host{flex-direction:column}:host /deep/ xpo-menubar{display:none}:host /deep/ xpo-menubar.active{display:flex}:host header{flex-direction:column;max-height:inherit}:host /deep/ xpo-header-int-row{display:flex;flex-direction:column;align-content:center;width:100%;height:auto}:host /deep/ xpo-header-int-col:nth-child(1){width:auto;height:5em}:host /deep/ xpo-header-int-col:nth-child(2){flex:1;flex-shrink:1;flex-basis:49%;width:80%;margin-top:40px;margin-bottom:32px;margin-left:7%;font-size:1em}:host /deep/ xpo-img{align-self:center;width:auto;margin-left:7%;padding-left:inherit}:host /deep/ xpo-img /deep/ span{display:flex;width:100%;cursor:pointer}:host /deep/ xpo-img /deep/ img{display:flex;max-width:100%;border-style:none}:host /deep/ xpo-header-int-col:nth-child(2){flex-direction:column;flex:1;width:100%;margin:0;margin-top:3em}:host /deep/ header xpo-header-int-col .person{flex-direction:column;width:100%;margin-top:0;margin-bottom:0}:host /deep/ header .person{padding-left:inherit;border-left:0}:host /deep/ .line1,:host /deep/ .line2,:host /deep/ .line3{display:block;width:25px;height:3px;margin-top:5px;position:relative;opacity:1;border-radius:15%;background-color:#d50000;transition:all .3s}:host /deep/ .line1.active{top:5px;transform:rotate(270deg);opacity:0;background-color:#1c1e1c}:host /deep/ .line2.active{transform:rotate(45deg);background-color:#1c1e1c}:host /deep/ .line3.active{top:-7px;transform:rotate(-45deg);background-color:#1c1e1c}:host /deep/ .xpo-mobile-icon{display:block;width:25px;height:25px;margin-top:.5em;margin-right:50px;position:absolute;top:20px;right:0;cursor:pointer;color:#d50000;text-decoration:none;z-index:100;transition:background-position .3s}} /*# sourceMappingURL=header-int.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderInt.ctorParameters = function () { return []; };
XpoHeaderInt.propDecorators = {
    'helper': [{ type: Input },],
};
/**
 * <xpo-header-int-col> directrive represents a column within XpoHeader header block.
 */
var XpoHeaderIntCol = (function () {
    function XpoHeaderIntCol() {
    }
    return XpoHeaderIntCol;
}());
XpoHeaderIntCol.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-header-int-col',
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderIntCol.ctorParameters = function () { return []; };
/**
 * <xpo-header-int-row> directrive represents a row within XpoHeader header block.
 */
var XpoHeaderIntRow = (function () {
    function XpoHeaderIntRow() {
    }
    Object.defineProperty(XpoHeaderIntRow.prototype, "light", {
        /**
         * Whether or not _light property is set to true.
         * @return {?}
         */
        get: function () { return this._light; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._light = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    return XpoHeaderIntRow;
}());
XpoHeaderIntRow.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-header-int-row',
                host: {
                    '[class.xpo-header-int-row--light]': 'light',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderIntRow.ctorParameters = function () { return []; };
XpoHeaderIntRow.propDecorators = {
    'light': [{ type: Input },],
};
var XpoHeaderIntModule = (function () {
    function XpoHeaderIntModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoHeaderIntModule.forRoot = function () {
        return {
            ngModule: XpoHeaderIntModule,
        };
    };
    return XpoHeaderIntModule;
}());
XpoHeaderIntModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoHeaderInt, XpoHeaderIntRow, XpoHeaderIntCol],
                declarations: [XpoHeaderInt, XpoHeaderIntRow, XpoHeaderIntCol],
            },] },
];
/**
 * @nocollapse
 */
XpoHeaderIntModule.ctorParameters = function () { return []; };
/**
 * <xpo-img> component presents styles an image for display.
 */
var XpoImg = (function () {
    function XpoImg() {
        this._src = null;
        this._alt = null;
        this._title = null;
        this._height = null;
        this._width = null;
        this._borderRadius = null;
    }
    Object.defineProperty(XpoImg.prototype, "src", {
        /**
         * The source of the image
         * @return {?}
         */
        get: function () { return this._src; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._src = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoImg.prototype, "alt", {
        /**
         * The alt tag of the image
         * @return {?}
         */
        get: function () { return this._alt; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._alt = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoImg.prototype, "title", {
        /**
         * The title tag of the image
         * @return {?}
         */
        get: function () { return this._title; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._title = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoImg.prototype, "height", {
        /**
         * The height tag of the image
         * @return {?}
         */
        get: function () { return this._height; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._height = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoImg.prototype, "width", {
        /**
         * The width tag of the image
         * @return {?}
         */
        get: function () { return this._width; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._width = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoImg.prototype, "radius", {
        /**
         * The radius of the image
         * @return {?}
         */
        get: function () { return this._borderRadius; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._borderRadius = value; },
        enumerable: true,
        configurable: true
    });
    return XpoImg;
}());
XpoImg.decorators = [
    { type: Component, args: [{ selector: 'xpo-img',
                host: {},
                template: "<span *ngIf=\"!helperObj\"> <img [src]=\"src\" [alt]=\"alt\" [title]=\"\" [width]=\"width\" [height]=\"height\" class=\"xpo-img-element\" [ngStyle]=\"{ 'border-radius': _borderRadius }\"> </span>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:inline-block;width:auto;height:auto}:host([polaroid]){display:inline-block;margin:0 0 27px 30px;padding:10px 10px 15px;float:left;font-size:18px;color:#333;text-align:center;text-decoration:none;background:#fff;box-shadow:0 3px 6px rgba(0,0,0,.25)}:host([polaroid]):nth-child(odd){transform:rotate(-2deg)}:host([polaroid]):nth-child(even){transform:rotate(2deg)}:host([polaroid])::after{display:block;content:attr(title)}:host([rounded]) .xpo-img-element{border-radius:8px}:host([icon]) .xpo-img-element{border-radius:30px}:host([circle]) .xpo-img-element{border-radius:100%}.xpo-primary{color:red!important} /*# sourceMappingURL=img.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoImg.ctorParameters = function () { return []; };
XpoImg.propDecorators = {
    'src': [{ type: Input },],
    'alt': [{ type: Input },],
    'title': [{ type: Input },],
    'height': [{ type: Input },],
    'width': [{ type: Input },],
    'radius': [{ type: Input },],
};
var XpoImgModule = (function () {
    function XpoImgModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoImgModule.forRoot = function () {
        return {
            ngModule: XpoImgModule,
        };
    };
    return XpoImgModule;
}());
XpoImgModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoImg],
                declarations: [XpoImg],
            },] },
];
/**
 * @nocollapse
 */
XpoImgModule.ctorParameters = function () { return []; };
/* tslint:disable */
/**
 * Xpo common <xpo-app> app component.
 *
 * The App is the global component for the page area holding things like xpo-header and xpo-footer and xpo-main.
 */
var XpoInternalApp = (function () {
    /**
     * @param {?} hostElement
     */
    function XpoInternalApp(hostElement) {
        this.hostElement = hostElement;
        document.body.classList.add("xpo-internal");
    }
    Object.defineProperty(XpoInternalApp.prototype, "helper", {
        /**
         * The xpo-app helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoInternalApp;
}());
XpoInternalApp.decorators = [
    { type: Component, args: [{ selector: 'xpo-internal-app',
                host: {},
                template: "<div class=\"xpo-internal\"> <ng-content></ng-content> </div>",
                styles: ["/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */@import url(https://fonts.googleapis.com/css?family=Roboto:400,700);html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{text-decoration:underline;text-decoration:underline dotted;border-bottom:none}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{color:#000;background-color:#ff0}small{font-size:80%}sub,sup{vertical-align:baseline;position:relative;font-size:75%;line-height:0}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:100%;line-height:1.15}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{margin:0 2px;padding:.35em .625em .75em;border:1px solid silver}legend{display:table;box-sizing:border-box;max-width:100%;padding:0;color:inherit;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:textfield}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}template{display:none}[hidden]{display:none}*,:after,:before{box-sizing:border-box}html{height:100%;position:relative}body{height:100%;font-family:Roboto,Helvetica,Arial,sans-serif;font-weight:400;color:#333}img{max-width:100%;border-style:none}button,input,textarea{-webkit-border-radius:0;appearance:none}hr{margin:10px 0;border:none;border-top:2px solid}h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:700;color:inherit;text-transform:uppercase;text-rendering:optimizelegibility}a{cursor:pointer;text-decoration:none}b,em,strong{font-weight:700}.layout--board{min-width:1100px}:root{font-size:12px}body{line-height:1.4;background-color:#dfdfdf}main{overflow:hidden}h1,h2,h3,h4,h5,h6{line-height:1.15}h1:first-of-type,h2:first-of-type,h3:first-of-type,h4:first-of-type,h5:first-of-type,h6:first-of-type{margin-top:0}h1{font-size:1.5rem}h2{font-size:1.33333rem}h3{margin:1.25rem 0;font-size:1.16667rem}h4{font-size:1rem}h5{font-size:.83333rem}p{margin:0 0 10px;line-height:1.4}a{color:#0091ea}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}@media screen and (min-width:)){.grid-cycle-1 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-1 .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1 .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-2 .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2 .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-3 .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3 .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-4 .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4 .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-5 .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5 .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-6 .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6 .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-7 .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7 .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-8 .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8 .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-9 .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9 .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-10 .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10 .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-11 .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11 .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12 [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-12 .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12 .grid-lego:nth-child(12n+1){padding-left:0}}@media screen and (min-width:480px){.grid-cycle-1-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-1-xs .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-xs .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-2-xs .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-xs .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-3-xs .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-xs .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-4-xs .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-xs .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-5-xs .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-xs .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-6-xs .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-xs .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-7-xs .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-xs .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-8-xs .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-xs .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-9-xs .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-xs .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-10-xs .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-xs .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-11-xs .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-xs .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-xs [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-12-xs .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-xs .grid-lego:nth-child(12n+1){padding-left:0}}@media screen and (min-width:600px){.grid-cycle-1-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-1-sm .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-sm .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-2-sm .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-sm .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-3-sm .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-sm .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-4-sm .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-sm .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-5-sm .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-sm .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-6-sm .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-sm .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-7-sm .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-sm .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-8-sm .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-sm .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-9-sm .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-sm .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-10-sm .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-sm .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-11-sm .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-sm .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-sm [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-12-sm .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-sm .grid-lego:nth-child(12n+1){padding-left:0}}@media screen and (min-width:768px){.grid-cycle-1-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-1-md .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-md .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-2-md .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-md .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-3-md .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-md .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-4-md .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-md .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-5-md .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-md .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-6-md .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-md .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-7-md .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-md .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-8-md .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-md .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-9-md .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-md .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-10-md .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-md .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-11-md .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-md .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-md [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-12-md .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-md .grid-lego:nth-child(12n+1){padding-left:0}}@media screen and (min-width:1025px){.grid-cycle-1-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-1-lg .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-lg .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-2-lg .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-lg .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-3-lg .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-lg .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-4-lg .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-lg .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-5-lg .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-lg .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-6-lg .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-lg .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-7-lg .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-lg .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-8-lg .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-lg .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-9-lg .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-lg .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-10-lg .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-lg .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-11-lg .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-lg .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-lg [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-12-lg .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-lg .grid-lego:nth-child(12n+1){padding-left:0}}@media screen and (min-width:1440px){.grid-cycle-1-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-1-xl .grid-lego:nth-child(1n){padding-right:0}.grid-cycle-1-xl .grid-lego:nth-child(1n+1){padding-left:0}.grid-cycle-2-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-2-xl .grid-lego:nth-child(2n){padding-right:0}.grid-cycle-2-xl .grid-lego:nth-child(2n+1){padding-left:0}.grid-cycle-3-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-3-xl .grid-lego:nth-child(3n){padding-right:0}.grid-cycle-3-xl .grid-lego:nth-child(3n+1){padding-left:0}.grid-cycle-4-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-4-xl .grid-lego:nth-child(4n){padding-right:0}.grid-cycle-4-xl .grid-lego:nth-child(4n+1){padding-left:0}.grid-cycle-5-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-5-xl .grid-lego:nth-child(5n){padding-right:0}.grid-cycle-5-xl .grid-lego:nth-child(5n+1){padding-left:0}.grid-cycle-6-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-6-xl .grid-lego:nth-child(6n){padding-right:0}.grid-cycle-6-xl .grid-lego:nth-child(6n+1){padding-left:0}.grid-cycle-7-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-7-xl .grid-lego:nth-child(7n){padding-right:0}.grid-cycle-7-xl .grid-lego:nth-child(7n+1){padding-left:0}.grid-cycle-8-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-8-xl .grid-lego:nth-child(8n){padding-right:0}.grid-cycle-8-xl .grid-lego:nth-child(8n+1){padding-left:0}.grid-cycle-9-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-9-xl .grid-lego:nth-child(9n){padding-right:0}.grid-cycle-9-xl .grid-lego:nth-child(9n+1){padding-left:0}.grid-cycle-10-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-10-xl .grid-lego:nth-child(10n){padding-right:0}.grid-cycle-10-xl .grid-lego:nth-child(10n+1){padding-left:0}.grid-cycle-11-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-11-xl .grid-lego:nth-child(11n){padding-right:0}.grid-cycle-11-xl .grid-lego:nth-child(11n+1){padding-left:0}.grid-cycle-12-xl [class^=grid-lego]:nth-child(1n){padding:0 8px}.grid-cycle-12-xl .grid-lego:nth-child(12n){padding-right:0}.grid-cycle-12-xl .grid-lego:nth-child(12n+1){padding-left:0}}.grid .grid-lego:first-child{padding-left:0}.grid .grid-lego:last-child{padding-right:0}.grid--full-bleed .grid-lego{padding:0}.grid--space-between{justify-content:space-between}.grid--center{justify-content:center}.grid--grow .grid-lego{flex:1;padding:0 8px}@supports (display:flex){.grid{display:flex;flex-wrap:wrap;margin:0;padding:0}.grid-lego{display:flex;flex-direction:column;flex:0 0 auto;min-width:0}.grid-lego.grid-lego-1{flex-basis:8.33333%;padding:0 8px}.grid-lego.grid-lego-offset-1{margin-left:8.33333%}.grid-lego.grid-lego-2{flex-basis:16.66667%;padding:0 8px}.grid-lego.grid-lego-offset-2{margin-left:16.66667%}.grid-lego.grid-lego-3{flex-basis:25%;padding:0 8px}.grid-lego.grid-lego-offset-3{margin-left:25%}.grid-lego.grid-lego-4{flex-basis:33.33333%;padding:0 8px}.grid-lego.grid-lego-offset-4{margin-left:33.33333%}.grid-lego.grid-lego-5{flex-basis:41.66667%;padding:0 8px}.grid-lego.grid-lego-offset-5{margin-left:41.66667%}.grid-lego.grid-lego-6{flex-basis:50%;padding:0 8px}.grid-lego.grid-lego-offset-6{margin-left:50%}.grid-lego.grid-lego-7{flex-basis:58.33333%;padding:0 8px}.grid-lego.grid-lego-offset-7{margin-left:58.33333%}.grid-lego.grid-lego-8{flex-basis:66.66667%;padding:0 8px}.grid-lego.grid-lego-offset-8{margin-left:66.66667%}.grid-lego.grid-lego-9{flex-basis:75%;padding:0 8px}.grid-lego.grid-lego-offset-9{margin-left:75%}.grid-lego.grid-lego-10{flex-basis:83.33333%;padding:0 8px}.grid-lego.grid-lego-offset-10{margin-left:83.33333%}.grid-lego.grid-lego-11{flex-basis:91.66667%;padding:0 8px}.grid-lego.grid-lego-offset-11{margin-left:91.66667%}.grid-lego.grid-lego-12{flex-basis:100%}.grid-lego.grid-lego-offset-12{margin-left:100%}@media screen and (min-width:480px){.grid-lego.grid-lego-1-xs{flex-basis:8.33333%;padding:0 8px}.grid-lego.grid-lego-offset-1-xs{margin-left:8.33333%}.grid-lego.grid-lego-2-xs{flex-basis:16.66667%;padding:0 8px}.grid-lego.grid-lego-offset-2-xs{margin-left:16.66667%}.grid-lego.grid-lego-3-xs{flex-basis:25%;padding:0 8px}.grid-lego.grid-lego-offset-3-xs{margin-left:25%}.grid-lego.grid-lego-4-xs{flex-basis:33.33333%;padding:0 8px}.grid-lego.grid-lego-offset-4-xs{margin-left:33.33333%}.grid-lego.grid-lego-5-xs{flex-basis:41.66667%;padding:0 8px}.grid-lego.grid-lego-offset-5-xs{margin-left:41.66667%}.grid-lego.grid-lego-6-xs{flex-basis:50%;padding:0 8px}.grid-lego.grid-lego-offset-6-xs{margin-left:50%}.grid-lego.grid-lego-7-xs{flex-basis:58.33333%;padding:0 8px}.grid-lego.grid-lego-offset-7-xs{margin-left:58.33333%}.grid-lego.grid-lego-8-xs{flex-basis:66.66667%;padding:0 8px}.grid-lego.grid-lego-offset-8-xs{margin-left:66.66667%}.grid-lego.grid-lego-9-xs{flex-basis:75%;padding:0 8px}.grid-lego.grid-lego-offset-9-xs{margin-left:75%}.grid-lego.grid-lego-10-xs{flex-basis:83.33333%;padding:0 8px}.grid-lego.grid-lego-offset-10-xs{margin-left:83.33333%}.grid-lego.grid-lego-11-xs{flex-basis:91.66667%;padding:0 8px}.grid-lego.grid-lego-offset-11-xs{margin-left:91.66667%}.grid-lego.grid-lego-12-xs{flex-basis:100%;padding:0 8px}.grid-lego.grid-lego-offset-12-xs{margin-left:100%}}@media screen and (min-width:600px){.grid-lego.grid-lego-1-sm{flex-basis:8.33333%;padding:0 8px}.grid-lego.grid-lego-offset-1-sm{margin-left:8.33333%}.grid-lego.grid-lego-2-sm{flex-basis:16.66667%;padding:0 8px}.grid-lego.grid-lego-offset-2-sm{margin-left:16.66667%}.grid-lego.grid-lego-3-sm{flex-basis:25%;padding:0 8px}.grid-lego.grid-lego-offset-3-sm{margin-left:25%}.grid-lego.grid-lego-4-sm{flex-basis:33.33333%;padding:0 8px}.grid-lego.grid-lego-offset-4-sm{margin-left:33.33333%}.grid-lego.grid-lego-5-sm{flex-basis:41.66667%;padding:0 8px}.grid-lego.grid-lego-offset-5-sm{margin-left:41.66667%}.grid-lego.grid-lego-6-sm{flex-basis:50%;padding:0 8px}.grid-lego.grid-lego-offset-6-sm{margin-left:50%}.grid-lego.grid-lego-7-sm{flex-basis:58.33333%;padding:0 8px}.grid-lego.grid-lego-offset-7-sm{margin-left:58.33333%}.grid-lego.grid-lego-8-sm{flex-basis:66.66667%;padding:0 8px}.grid-lego.grid-lego-offset-8-sm{margin-left:66.66667%}.grid-lego.grid-lego-9-sm{flex-basis:75%;padding:0 8px}.grid-lego.grid-lego-offset-9-sm{margin-left:75%}.grid-lego.grid-lego-10-sm{flex-basis:83.33333%;padding:0 8px}.grid-lego.grid-lego-offset-10-sm{margin-left:83.33333%}.grid-lego.grid-lego-11-sm{flex-basis:91.66667%;padding:0 8px}.grid-lego.grid-lego-offset-11-sm{margin-left:91.66667%}.grid-lego.grid-lego-12-sm{flex-basis:100%;padding:0 8px}.grid-lego.grid-lego-offset-12-sm{margin-left:100%}}@media screen and (min-width:768px){.grid-lego.grid-lego-1-md{flex-basis:8.33333%;padding:0 8px}.grid-lego.grid-lego-offset-1-md{margin-left:8.33333%}.grid-lego.grid-lego-2-md{flex-basis:16.66667%;padding:0 8px}.grid-lego.grid-lego-offset-2-md{margin-left:16.66667%}.grid-lego.grid-lego-3-md{flex-basis:25%;padding:0 8px}.grid-lego.grid-lego-offset-3-md{margin-left:25%}.grid-lego.grid-lego-4-md{flex-basis:33.33333%;padding:0 8px}.grid-lego.grid-lego-offset-4-md{margin-left:33.33333%}.grid-lego.grid-lego-5-md{flex-basis:41.66667%;padding:0 8px}.grid-lego.grid-lego-offset-5-md{margin-left:41.66667%}.grid-lego.grid-lego-6-md{flex-basis:50%;padding:0 8px}.grid-lego.grid-lego-offset-6-md{margin-left:50%}.grid-lego.grid-lego-7-md{flex-basis:58.33333%;padding:0 8px}.grid-lego.grid-lego-offset-7-md{margin-left:58.33333%}.grid-lego.grid-lego-8-md{flex-basis:66.66667%;padding:0 8px}.grid-lego.grid-lego-offset-8-md{margin-left:66.66667%}.grid-lego.grid-lego-9-md{flex-basis:75%;padding:0 8px}.grid-lego.grid-lego-offset-9-md{margin-left:75%}.grid-lego.grid-lego-10-md{flex-basis:83.33333%;padding:0 8px}.grid-lego.grid-lego-offset-10-md{margin-left:83.33333%}.grid-lego.grid-lego-11-md{flex-basis:91.66667%;padding:0 8px}.grid-lego.grid-lego-offset-11-md{margin-left:91.66667%}.grid-lego.grid-lego-12-md{flex-basis:100%;padding:0 8px}.grid-lego.grid-lego-offset-12-md{margin-left:100%}}@media screen and (min-width:1025px){.grid-lego.grid-lego-1-lg{flex-basis:8.33333%;padding:0 8px}.grid-lego.grid-lego-offset-1-lg{margin-left:8.33333%}.grid-lego.grid-lego-2-lg{flex-basis:16.66667%;padding:0 8px}.grid-lego.grid-lego-offset-2-lg{margin-left:16.66667%}.grid-lego.grid-lego-3-lg{flex-basis:25%;padding:0 8px}.grid-lego.grid-lego-offset-3-lg{margin-left:25%}.grid-lego.grid-lego-4-lg{flex-basis:33.33333%;padding:0 8px}.grid-lego.grid-lego-offset-4-lg{margin-left:33.33333%}.grid-lego.grid-lego-5-lg{flex-basis:41.66667%;padding:0 8px}.grid-lego.grid-lego-offset-5-lg{margin-left:41.66667%}.grid-lego.grid-lego-6-lg{flex-basis:50%;padding:0 8px}.grid-lego.grid-lego-offset-6-lg{margin-left:50%}.grid-lego.grid-lego-7-lg{flex-basis:58.33333%;padding:0 8px}.grid-lego.grid-lego-offset-7-lg{margin-left:58.33333%}.grid-lego.grid-lego-8-lg{flex-basis:66.66667%;padding:0 8px}.grid-lego.grid-lego-offset-8-lg{margin-left:66.66667%}.grid-lego.grid-lego-9-lg{flex-basis:75%;padding:0 8px}.grid-lego.grid-lego-offset-9-lg{margin-left:75%}.grid-lego.grid-lego-10-lg{flex-basis:83.33333%;padding:0 8px}.grid-lego.grid-lego-offset-10-lg{margin-left:83.33333%}.grid-lego.grid-lego-11-lg{flex-basis:91.66667%;padding:0 8px}.grid-lego.grid-lego-offset-11-lg{margin-left:91.66667%}.grid-lego.grid-lego-12-lg{flex-basis:100%;padding:0 8px}.grid-lego.grid-lego-offset-12-lg{margin-left:100%}}@media screen and (min-width:1440px){.grid-lego.grid-lego-1-xl{flex-basis:8.33333%;padding:0 8px}.grid-lego.grid-lego-offset-1-xl{margin-left:8.33333%}.grid-lego.grid-lego-2-xl{flex-basis:16.66667%;padding:0 8px}.grid-lego.grid-lego-offset-2-xl{margin-left:16.66667%}.grid-lego.grid-lego-3-xl{flex-basis:25%;padding:0 8px}.grid-lego.grid-lego-offset-3-xl{margin-left:25%}.grid-lego.grid-lego-4-xl{flex-basis:33.33333%;padding:0 8px}.grid-lego.grid-lego-offset-4-xl{margin-left:33.33333%}.grid-lego.grid-lego-5-xl{flex-basis:41.66667%;padding:0 8px}.grid-lego.grid-lego-offset-5-xl{margin-left:41.66667%}.grid-lego.grid-lego-6-xl{flex-basis:50%;padding:0 8px}.grid-lego.grid-lego-offset-6-xl{margin-left:50%}.grid-lego.grid-lego-7-xl{flex-basis:58.33333%;padding:0 8px}.grid-lego.grid-lego-offset-7-xl{margin-left:58.33333%}.grid-lego.grid-lego-8-xl{flex-basis:66.66667%;padding:0 8px}.grid-lego.grid-lego-offset-8-xl{margin-left:66.66667%}.grid-lego.grid-lego-9-xl{flex-basis:75%;padding:0 8px}.grid-lego.grid-lego-offset-9-xl{margin-left:75%}.grid-lego.grid-lego-10-xl{flex-basis:83.33333%;padding:0 8px}.grid-lego.grid-lego-offset-10-xl{margin-left:83.33333%}.grid-lego.grid-lego-11-xl{flex-basis:91.66667%;padding:0 8px}.grid-lego.grid-lego-offset-11-xl{margin-left:91.66667%}.grid-lego.grid-lego-12-xl{flex-basis:100%;padding:0 8px}.grid-lego.grid-lego-offset-12-xl{margin-left:100%}}}.content-align--left{text-align:left}.content-align--right{text-align:right}.content-align--center{text-align:center}[xpo-flex-stack]{display:flex;flex-direction:column;height:100%}[xpo-flex-vcenter]{display:flex;align-items:center}[xpo-flex-vstretch]{display:flex}[xpo-flex-right]{display:flex;justify-content:flex-end}[xpo-flex-stretch]{flex:1}[xpo-flex-stretch-clear]{flex-basis:100%}[xpo-scroll-content]{height:100%;overflow:auto}.cdk-global-overlay-wrapper,.cdk-overlay-container{width:100%;height:100%;top:0;left:0;pointer-events:none}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{box-sizing:border-box;position:absolute;z-index:1000;pointer-events:auto}.cdk-overlay-pane__dialog{width:100%;height:100%;overflow:auto}.cdk-overlay-backdrop{position:absolute;top:0;right:0;bottom:0;left:0;opacity:0;z-index:1000;transition:opacity .4s cubic-bezier(.25,.8,.25,1);pointer-events:auto}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.65}.cdk-overlay-dark-backdrop{background:1000;background-color:#333}.cdk-overlay-transparent-backdrop{background:0 0}.cdk-global-scrollblock{width:100%;overflow-y:scroll;position:fixed}.xpo-internal,xpo-app{display:flex;flex-direction:column;height:100%} /*# sourceMappingURL=internal-app.css.map */ "],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoInternalApp.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
XpoInternalApp.propDecorators = {
    'helper': [{ type: Input },],
};
var XpoInternalAppModule = (function () {
    function XpoInternalAppModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoInternalAppModule.forRoot = function () {
        return {
            ngModule: XpoInternalAppModule,
        };
    };
    return XpoInternalAppModule;
}());
XpoInternalAppModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoInternalApp],
                declarations: [XpoInternalApp],
            },] },
];
/**
 * @nocollapse
 */
XpoInternalAppModule.ctorParameters = function () { return []; };
/**
 * <xpo-main> is the Xpo common main component. Place under app as the general site content area (similar to the main tag on html).
 */
var XpoMain = (function () {
    function XpoMain() {
    }
    return XpoMain;
}());
XpoMain.decorators = [
    { type: Component, args: [{ selector: 'xpo-main',
                template: '<ng-content></ng-content>',
                styles: [" /*# sourceMappingURL=main.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
            },] },
];
/**
 * @nocollapse
 */
XpoMain.ctorParameters = function () { return []; };
var XpoMainModule = (function () {
    function XpoMainModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoMainModule.forRoot = function () {
        return {
            ngModule: XpoMainModule,
        };
    };
    return XpoMainModule;
}());
XpoMainModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoMain],
                declarations: [XpoMain],
            },] },
];
/**
 * @nocollapse
 */
XpoMainModule.ctorParameters = function () { return []; };
/* tslint:disable */
/**
 * <xpo-menubar> holds multiple xpo-components to generate a menu.  It requires a MenuBarSource made up of an array of objects that contain 'name' and 'link' key value pairs.
 */
var XpoMenuBar = (function () {
    function XpoMenuBar() {
        /**
         * Checking the router link, if it start with http then it will be be displayed as a href and not a router link.
         */
        this.checkLink = function (LINK) {
            var boolVal = false;
            var linkval = LINK.substr(0, 3);
            linkval = linkval.toUpperCase();
            if (linkval == 'HTTP') {
                boolVal = true;
            }
            return true;
        };
    }
    Object.defineProperty(XpoMenuBar.prototype, "source", {
        /**
         * An array of objects that contain 'name' and 'link' key value pairs.
         * @return {?}
         */
        get: function () { return this.menubarSource; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.menubarSource = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenuBar.prototype, "menutype", {
        /**
         * An array of objects that contain 'name' and 'link' key value pairs.
         * @return {?}
         */
        get: function () { return this.menuType; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.menuType = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenuBar.prototype, "loginprofile", {
        /**
         * Whether or not the login profile is displayed.
         * @return {?}
         */
        get: function () { return this.loginProfile; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.loginProfile = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenuBar.prototype, "globalsearch", {
        /**
         * Whether or not the global search field is displayed.
         * @return {?}
         */
        get: function () { return this.globalsearchSwitch; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.globalsearchSwitch = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenuBar.prototype, "sitelogo", {
        /**
         * Path to the site logo image file.
         * @return {?}
         */
        get: function () { return this.siteimglogo; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.siteimglogo = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenuBar.prototype, "profileicon", {
        /**
         * Path to the user profile logo image file.
         * @return {?}
         */
        get: function () { return this.userprofilelogo; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.userprofilelogo = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenuBar.prototype, "searchicon", {
        /**
         * Path to the search icon logo image file.
         * @return {?}
         */
        get: function () { return this.searchiconlogo; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.searchiconlogo = value; },
        enumerable: true,
        configurable: true
    });
    return XpoMenuBar;
}());
XpoMenuBar.decorators = [
    { type: Component, args: [{ selector: 'xpo-menubar',
                host: {},
                template: "<ng-content></ng-content> <!-- Here are the logo variables that are passed in (string) siteimglogo can be used as <img src=\"{{this.siteimglogo}}\"> userprofilelogo can be used as <img src=\"{{this.userprofilelogo}}\"> searchiconlogo can be used as <img src=\"{{this.searchiconlogo}}\"> --> <!-- ***************************************************************************** --> <!-- THIS IS ADDED AS THE HTML OUTPUT FOR THE MENUTYPE THESE OPTIONS ARE AVAILABLE --> <!-- ***************************************************************************** --> <span *ngIf=\"this.menuType\"> <!-- ********************************************** --> <!-- THIS IS SHOWN IF THE MENUTYPE IS SET TO HEADER --> <!-- ********************************************** --> <header class=\"menubar__header\" *ngIf=\"this.menuType === 'header'\"> <div class=\"navigation\"> <!-- thas been updated so that if the link begins with http then it will display as a href otherwise it will display as a routerlink--> <!--THIS RUNS A SWITCH BASED ON THE START OF THE LINK, IF IT IS HTTP then it will use an href, otherwise it will treat it as a linkn--> <span *ngFor=\"let menusrc of this.menubarSource.src\"> <a routerLink=\"{{menusrc.link}}\"  *ngIf=\"!checkLink(menusrc.link);\">{{menusrc.name}}</a> <a href=\"{{menusrc.link}}\" target=\"_blank\" *ngIf=\"checkLink(menusrc.link);\">{{menusrc.name}}</a> </span> <!--END OF THE CHECK FOR THE HREF--> </div> <div class=\"person\" *ngIf=\"this.loginProfile == true\"> <a routerLink=\"#\" class=\"user\"></a> </div> </header> <!-- ********************************************** --> <!-- THIS IS SHOWN IF THE MENUTYPE IS SET TO BODY   --> <!-- ********************************************** --> <header class=\"menubar__header\" *ngIf=\"this.menuType === 'body'\"> <div class=\"navigation\"> <!--THIS RUNS A SWITCH BASED ON THE START OF THE LINK, IF IT IS HTTP then it will use an href, otherwise it will treat it as a linkn--> <span *ngFor=\"let menusrc of this.menubarSource.src\"> <a routerLink=\"{{menusrc.link}}\"  *ngIf=\"!checkLink(menusrc.link);\">{{menusrc.name}}</a> <a href=\"{{menusrc.link}}\" target=\"_blank\" *ngIf=\"checkLink(menusrc.link);\">{{menusrc.name}}</a> </span> <!--END OF THE CHECK FOR THE HREF--> </div> <div class=\"person\" *ngIf=\"this.loginProfile == true\"> <a routerLink=\"#\" class=\"user\"></a> </div> </header> <!-- ********************************************** --> <!-- THIS IS SHOWN IF THE MENUTYPE IS SET TO FOOTER  --> <!-- ********************************************** --> <div class=\"menubar__footer\" *ngIf=\"this.menuType === 'footer'\"> <ul class=\"menubar__footer-nav\"> <li class=\"menubar__footer-item\" *ngFor=\"let menusrc of this.menubarSource.src\"> <a class=\"menubar__footer-link\" routerLink=\"{{menusrc.link}}\" *ngIf=\"!checkLink(menusrc.link);\">{{menusrc.name}}</a> <a href=\"{{menusrc.link}}\" target=\"_blank\" class=\"menubar__footer-link\" *ngIf=\"checkLink(menusrc.link);\">{{menusrc.name}}</a> </li> </ul> </div> <!-- ************************************************************************* --> <!-- THIS IS ADDED AS THE DEFAULT, IF YOU DO NOT USE A MENU TYPE THIS IS SHOWN --> <!-- ************************************************************************* --> <span *ngIf=\"!this.menuType\"> <header class=\"topMenu\"> <div class=\"navigation\"> <span *ngFor=\"let menusrc of this.menubarSource.src\"> <a routerLink=\"{{menusrc.link}}\"  *ngIf=\"!checkLink(menusrc.link);\">{{menusrc.name}}</a> <a href=\"{{menusrc.link}}\" target=\"_blank\" *ngIf=\"checkLink(menusrc.link);\">{{menusrc.name}}</a> </span> </div> <div class=\"person\" *ngIf=\"this.loginProfile == true\"> <a routerLink=\"#\" class=\"user\"></a> </div> </header> </span> <!-- ************************************************************************* --> <!-- THIS IS USED IF THE MENU TYPE IS BLANK --> <!-- ************************************************************************* --> <header class=\"topMenu\" *ngIf=\"this.menuType === ''\"> <div class=\"navigation\"> <!--THIS RUNS A SWITCH BASED ON THE START OF THE LINK, IF IT IS HTTP then it will use an href, otherwise it will treat it as a linkn--> <span *ngFor=\"let menusrc of this.menubarSource.src\"> <a routerLink=\"{{menusrc.link}}\"  *ngIf=\"!checkLink(menusrc.link);\">{{menusrc.name}}</a> <a href=\"{{menusrc.link}}\" target=\"_blank\" *ngIf=\"checkLink(menusrc.link);\">{{menusrc.name}}</a> </span> <!--END OF THE CHECK FOR THE HREF--> </div> <div class=\"person\" *ngIf=\"this.loginProfile == true\"> <a routerLink=\"#\" class=\"user\"></a> </div> </header> </span>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex}:host>span{display:block;width:100%}:host .user{display:flex;min-width:24px;min-height:24px;background-image:url(data:image/svg+xml;base64,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);background-repeat:round}:host header{display:flex}:host header .logo{display:inline-flex;flex-basis:35%}:host header .logo a{text-decoration:none}:host header a{outline:0;font-weight:500}:host header .navigation{display:flex}:host header .person{display:inline-flex;align-self:auto;flex:1;flex-basis:20%;margin-left:0;padding-right:3.4em;padding-left:7%;border-left:1px #ccc solid}:host header .person img{width:32px;height:32px;margin-top:-10px}:host header .navigation a,:host header .person a{align-self:center;padding-right:1em;padding-left:1em;font-size:1.2em;text-decoration:none;white-space:nowrap}:host header a.active{text-decoration:underline}:host .menubar__footer-nav{display:flex;margin:0;padding:0;list-style-type:none}:host .menubar__footer-item{flex:1}@media (max-width:768px){:host header .person{border-left:0}:host header .navigation a{align-self:flex-start;flex:inherit;padding-right:1em;padding-left:1em;text-align:left;text-decoration:none;white-space:nowrap}:host header .person a{align-self:flex-start;flex:inherit;padding-right:1em;padding-left:1em;text-decoration:none;white-space:nowrap}:host header .logo{width:auto;height:5em}:host header .navigation{font-size:1em}:host header{flex-direction:column;width:100%;height:inherit;max-height:inherit}:host header .person{align-self:flex-start;flex:initial;margin:0;margin-top:0;margin-bottom:2%;margin-left:0;padding-top:2%;padding-left:2%;text-align:initial;border-top:1px solid #ccc}:host header .navigation{flex-direction:column;flex:1;width:100%;margin-top:1em}:host header .navigation a{flex:1;width:100%;height:4em;margin-left:0;padding-top:1.3em;border-top:1px solid #ccc}}:host-context(.xpo-internal) .menubar__footer-nav{justify-content:flex-end}:host-context(.xpo-internal) .menubar__footer-item{flex:0 1 auto;margin-left:8px;padding-left:8px;font-size:.83333rem;border-left:1px solid #858585}:host-context(.xpo-internal) .menubar__footer-item:first-child{margin-left:0;padding-left:0;border-left:none}:host-context(.xpo-external) .menubar__footer-nav{flex-wrap:wrap}:host-context(.xpo-external) .menubar__footer-item{flex-basis:100%;margin-bottom:25px;font-size:.91667rem;white-space:nowrap}:host-context(.xpo-external) .menubar__footer-item:last-child{margin-bottom:0}:host-context(.xpo-external) .menubar__footer-link{color:#fff}:host-context(.xpo-external) .menubar__footer-link:hover{color:#9e9e9e}@media (min-width:600px){:host-context(.xpo-external) .menubar__footer{display:flex;justify-content:center}:host-context(.xpo-external) .menubar__footer-nav{flex-wrap:nowrap}:host-context(.xpo-external) .menubar__footer-item{margin-bottom:0;margin-left:30px}:host-context(.xpo-external) .menubar__footer-item:first-child{margin-left:0}}@media (min-width:768px){:host-context(.xpo-external) .menubar__footer{justify-content:flex-end}} /*# sourceMappingURL=menubar.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoMenuBar.ctorParameters = function () { return []; };
XpoMenuBar.propDecorators = {
    'source': [{ type: Input },],
    'menutype': [{ type: Input },],
    'loginprofile': [{ type: Input },],
    'globalsearch': [{ type: Input },],
    'sitelogo': [{ type: Input },],
    'profileicon': [{ type: Input },],
    'searchicon': [{ type: Input },],
};
var XpoMenuBarModule = (function () {
    function XpoMenuBarModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoMenuBarModule.forRoot = function () {
        return {
            ngModule: XpoMenuBarModule,
        };
    };
    return XpoMenuBarModule;
}());
XpoMenuBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, RouterModule, XpoActionBarModule],
                exports: [XpoMenuBar],
                declarations: [XpoMenuBar],
            },] },
];
/**
 * @nocollapse
 */
XpoMenuBarModule.ctorParameters = function () { return []; };
/**
 * <xpo-icon> component presents an icon from the XPOIcons library.
 */
var XpoIcon = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _viewContainerRef
     */
    function XpoIcon(_elementRef, _renderer, _viewContainerRef) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._viewContainerRef = _viewContainerRef;
    }
    /**
     * @return {?}
     */
    XpoIcon.prototype.ngOnInit = function () { };
    /**
     * @return {?}
     */
    XpoIcon.prototype.ngAfterViewInit = function () {
        var /** @type {?} */ elem = this._elementRef.nativeElement;
        this.fontSetClass = this._getIconClass();
        this._renderer.addClass(elem, this.fontSetClass);
        // console.dir(elem.innerHTML);
        elem.innerHTML = '';
    };
    /**
     * @return {?}
     */
    XpoIcon.prototype._getIconClass = function () {
        var /** @type {?} */ text = this._elementRef.nativeElement.textContent;
        if (text) {
            return 'xico-' + text.trim();
        }
        return null;
    };
    return XpoIcon;
}());
XpoIcon.decorators = [
    { type: Component, args: [{
                selector: 'xpo-icon',
                template: '<ng-content></ng-content>',
                styles: [":host{display:inline-block;height:100%;fill:currentColor} /*# sourceMappingURL=icon.css.map */ "],
            },] },
];
/**
 * @nocollapse
 */
XpoIcon.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: ViewContainerRef, },
]; };
var XpoIconModule = (function () {
    function XpoIconModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoIconModule.forRoot = function () {
        return {
            ngModule: XpoIconModule,
        };
    };
    return XpoIconModule;
}());
XpoIconModule.decorators = [
    { type: NgModule, args: [{
                imports: [HttpModule, CommonModule],
                exports: [XpoIcon],
                declarations: [XpoIcon],
            },] },
];
/**
 * @nocollapse
 */
XpoIconModule.ctorParameters = function () { return []; };
/**
 * <xpo-address> component displays the company name, street address, city, state, zip, phone and email address.
 */
var XPOAddress = (function () {
    function XPOAddress() {
        /**
         * Full street address string.
         */
        this.ILADDRESS = 'Default Value';
        /**
         * Company name.
         */
        this.ILCOMPANY = 'XPO Logistics Inc.';
        /**
         * Street address.
         */
        this.ILSTREET = 'Five Greenwich Office Park';
        /**
         * City.
         */
        this.ILCITY = 'Greenwich';
        /**
         * State.
         */
        this.ILSTATE = 'CT';
        /**
         * ZIP code.
         */
        this.ILZIP = '06831';
        /**
         * Phone number.
         */
        this.ILPHONE = '800-755-2728';
        /**
         * Email address.
         */
        this.ILEMAIL = 'contact@company.com';
    }
    Object.defineProperty(XPOAddress.prototype, "helper", {
        /**
         * The full address string
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XPOAddress.prototype, "company", {
        /**
         * The company name
         * @return {?}
         */
        get: function () { return this.ILCOMPANY; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.ILCOMPANY = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XPOAddress.prototype, "street", {
        /**
         * The street address
         * @return {?}
         */
        get: function () { return this.ILSTREET; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.ILSTREET = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XPOAddress.prototype, "city", {
        /**
         * The city
         * @return {?}
         */
        get: function () { return this.ILCITY; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.ILCITY = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XPOAddress.prototype, "state", {
        /**
         * The state
         * @return {?}
         */
        get: function () { return this.ILSTATE; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.ILSTATE = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XPOAddress.prototype, "zip", {
        /**
         * The zip
         * @return {?}
         */
        get: function () { return this.ILZIP; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.ILZIP = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XPOAddress.prototype, "phone", {
        /**
         * The phone
         * @return {?}
         */
        get: function () { return this.ILPHONE; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.ILPHONE = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XPOAddress.prototype, "email", {
        /**
         * The email
         * @return {?}
         */
        get: function () { return this.ILEMAIL; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.ILEMAIL = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XPOAddress.prototype, "address", {
        /**
         * The address
         * @return {?}
         */
        get: function () { return this.ILADDRESS; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.ILADDRESS = value; },
        enumerable: true,
        configurable: true
    });
    return XPOAddress;
}());
XPOAddress.decorators = [
    { type: Component, args: [{ selector: 'xpo-address',
                host: {},
                template: "<span *ngIf=\"helperObj\"> <div> <div vocab=\"http://schema.org/\" typeof=\"Organization\"> <span property=\"name\">{{ helperObj.company }}</span> <address property=\"address\" typeof=\"PostalAddress\"> <span property=\"streetAddress\">{{ helperObj.street }}</span> <span property=\"addressLocality\">{{ helperObj.city }}, {{ helperObj.state }}</span> <span property=\"postalCode\">{{ helperObj.zip }}</span> </address> <span property=\"telephone\">{{ helperObj.phone }}</span> <span property=\"email\">{{ helperObj.email }}</span> </div> </div> </span> <span *ngIf=\"!helperObj\"> <div> <div vocab=\"http://schema.org/\" typeof=\"Organization\"> <span property=\"name\" class=\"address-title\">{{ ILCOMPANY }}</span> <address property=\"address\" typeof=\"PostalAddress\"> <span property=\"streetAddress\"> {{ ILSTREET }} </span> <span property=\"addressLocality\">{{ ILCITY }}, {{ ILSTATE }}</span> <span property=\"postalCode\">{{ ILZIP }}</span> </address> <span property=\"telephone\">{{ ILPHONE }}</span> <span property=\"email\">{{ ILEMAIL }}</span> </div> </div> </span>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0} /*# sourceMappingURL=address.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XPOAddress.ctorParameters = function () { return []; };
XPOAddress.propDecorators = {
    'helper': [{ type: Input },],
    'company': [{ type: Input },],
    'street': [{ type: Input },],
    'city': [{ type: Input },],
    'state': [{ type: Input },],
    'zip': [{ type: Input },],
    'phone': [{ type: Input },],
    'email': [{ type: Input },],
    'address': [{ type: Input },],
};
var XpoAddressModule = (function () {
    function XpoAddressModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoAddressModule.forRoot = function () {
        return {
            ngModule: XpoAddressModule,
        };
    };
    return XpoAddressModule;
}());
XpoAddressModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XPOAddress],
                declarations: [XPOAddress],
            },] },
];
/**
 * @nocollapse
 */
XpoAddressModule.ctorParameters = function () { return []; };
/**
 * This class manages keyboard events for selectable lists. If you pass it a query list
 * of items, it will set the active item correctly when arrow events occur.
 */
var ListKeyManager = (function () {
    /**
     * @param {?} _items
     */
    function ListKeyManager(_items) {
        this._items = _items;
        this._activeItemIndex = null;
        this._tabOut = new Subject();
        this._wrap = false;
    }
    /**
     * Turns on wrapping mode, which ensures that the active item will wrap to
     * the other end of list when there are no more items in the given direction.
     *
     * @return {?} The ListKeyManager that the method was called on.
     */
    ListKeyManager.prototype.withWrap = function () {
        this._wrap = true;
        return this;
    };
    /**
     * Sets the active item to the item at the index specified.
     *
     * @param {?} index The index of the item to be set as active.
     * @return {?}
     */
    ListKeyManager.prototype.setActiveItem = function (index) {
        this._activeItemIndex = index;
        this._activeItem = this._items.toArray()[index];
    };
    /**
     * Sets the active item depending on the key event passed in.
     * @param {?} event Keyboard event to be used for determining which element should be active.
     * @return {?}
     */
    ListKeyManager.prototype.onKeydown = function (event) {
        switch (event.keyCode) {
            case DOWN_ARROW:
                this.setNextItemActive();
                break;
            case UP_ARROW:
                this.setPreviousItemActive();
                break;
            case TAB:
                // Note that we shouldn't prevent the default action on tab.
                this._tabOut.next(null);
                return;
            default:
                return;
        }
        event.preventDefault();
    };
    Object.defineProperty(ListKeyManager.prototype, "activeItemIndex", {
        /**
         * Returns the index of the currently active item.
         * @return {?}
         */
        get: function () {
            return this._activeItemIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListKeyManager.prototype, "activeItem", {
        /**
         * Returns the currently active item.
         * @return {?}
         */
        get: function () {
            return this._activeItem;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the active item to the first enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setFirstItemActive = function () {
        this._setActiveItemByIndex(0, 1);
    };
    /**
     * Sets the active item to the last enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setLastItemActive = function () {
        this._setActiveItemByIndex(this._items.length - 1, -1);
    };
    /**
     * Sets the active item to the next enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setNextItemActive = function () {
        this._activeItemIndex === null ? this.setFirstItemActive() : this._setActiveItemByDelta(1);
    };
    /**
     * Sets the active item to a previous enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setPreviousItemActive = function () {
        this._activeItemIndex === null && this._wrap ? this.setLastItemActive()
            : this._setActiveItemByDelta(-1);
    };
    /**
     * Allows setting of the activeItemIndex without any other effects.
     * @param {?} index The new activeItemIndex.
     * @return {?}
     */
    ListKeyManager.prototype.updateActiveItemIndex = function (index) {
        this._activeItemIndex = index;
    };
    Object.defineProperty(ListKeyManager.prototype, "tabOut", {
        /**
         * Observable that emits any time the TAB key is pressed, so components can react
         * when focus is shifted off of the list.
         * @return {?}
         */
        get: function () {
            return this._tabOut.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This method sets the active item, given a list of items and the delta between the
     * currently active item and the new active item. It will calculate differently
     * depending on whether wrap mode is turned on.
     * @param {?} delta
     * @param {?=} items
     * @return {?}
     */
    ListKeyManager.prototype._setActiveItemByDelta = function (delta, items) {
        if (items === void 0) { items = this._items.toArray(); }
        this._wrap ? this._setActiveInWrapMode(delta, items)
            : this._setActiveInDefaultMode(delta, items);
    };
    /**
     * Sets the active item properly given "wrap" mode. In other words, it will continue to move
     * down the list until it finds an item that is not disabled, and it will wrap if it
     * encounters either end of the list.
     * @param {?} delta
     * @param {?} items
     * @return {?}
     */
    ListKeyManager.prototype._setActiveInWrapMode = function (delta, items) {
        // when active item would leave menu, wrap to beginning or end
        this._activeItemIndex =
            (this._activeItemIndex + delta + items.length) % items.length;
        // skip all disabled menu items recursively until an enabled one is reached
        if (items[this._activeItemIndex].disabled) {
            this._setActiveInWrapMode(delta, items);
        }
        else {
            this.setActiveItem(this._activeItemIndex);
        }
    };
    /**
     * Sets the active item properly given the default mode. In other words, it will
     * continue to move down the list until it finds an item that is not disabled. If
     * it encounters either end of the list, it will stop and not wrap.
     * @param {?} delta
     * @param {?} items
     * @return {?}
     */
    ListKeyManager.prototype._setActiveInDefaultMode = function (delta, items) {
        this._setActiveItemByIndex(this._activeItemIndex + delta, delta, items);
    };
    /**
     * Sets the active item to the first enabled item starting at the index specified. If the
     * item is disabled, it will move in the fallbackDelta direction until it either
     * finds an enabled item or encounters the end of the list.
     * @param {?} index
     * @param {?} fallbackDelta
     * @param {?=} items
     * @return {?}
     */
    ListKeyManager.prototype._setActiveItemByIndex = function (index, fallbackDelta, items) {
        if (items === void 0) { items = this._items.toArray(); }
        if (!items[index]) {
            return;
        }
        while (items[index].disabled) {
            index += fallbackDelta;
            if (!items[index]) {
                return;
            }
        }
        this.setActiveItem(index);
    };
    return ListKeyManager;
}());
/* tslint:disable */
var ActiveDescendantKeyManager = (function (_super) {
    __extends(ActiveDescendantKeyManager, _super);
    function ActiveDescendantKeyManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This method sets the active item to the item at the specified index.
     * It also adds active styles to the newly active item and removes active
     * styles from the previously active item.
     * @param {?} index
     * @return {?}
     */
    ActiveDescendantKeyManager.prototype.setActiveItem = function (index) {
        var _this = this;
        Promise.resolve().then(function () {
            if (_this.activeItem) {
                _this.activeItem.setInactiveStyles();
            }
            _super.prototype.setActiveItem.call(_this, index);
            if (_this.activeItem) {
                _this.activeItem.setActiveStyles();
            }
        });
    };
    return ActiveDescendantKeyManager;
}(ListKeyManager));
/* tslint:disable */
/**
 * Autocomplete IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
var _uniqueAutocompleteIdCounter = 0;
/**
 * <xpo-autocomplete> component is a normal text input enhanced by a panel of suggested options
 */
var XpoAutocomplete = (function () {
    /**
     * @param {?} _changeDetectorRef
     */
    function XpoAutocomplete(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        /**
         * Whether the autocomplete panel displays above or below its trigger.
         */
        this.positionY = 'below';
        /**
         * Whether the autocomplete panel should be visible, depending on option length.
         */
        this.showPanel = false;
        /**
         * Unique ID to be used by autocomplete trigger's "aria-owns" property.
         */
        this.id = "xpo-autocomplete-" + _uniqueAutocompleteIdCounter++;
    }
    /**
     * @return {?}
     */
    XpoAutocomplete.prototype.ngAfterContentInit = function () {
        this._keyManager = new ActiveDescendantKeyManager(this.options).withWrap();
    };
    /**
     * Sets the panel scrollTop. This allows us to manually scroll to display
     * options below the fold, as they are not actually being focused when active.
     * @param {?} scrollTop
     * @return {?}
     */
    XpoAutocomplete.prototype._setScrollTop = function (scrollTop) {
        if (this.panel) {
            this.panel.nativeElement.scrollTop = scrollTop;
        }
    };
    /**
     * Panel should hide itself when the option list is empty.
     * @return {?}
     */
    XpoAutocomplete.prototype._setVisibility = function () {
        var _this = this;
        Promise.resolve().then(function () {
            _this.showPanel = !!_this.options.length;
            _this._changeDetectorRef.markForCheck();
        });
    };
    /**
     * Sets a class on the panel based on its position (used to set y-offset).
     * @return {?}
     */
    XpoAutocomplete.prototype._getClassList = function () {
        return {};
    };
    return XpoAutocomplete;
}());
XpoAutocomplete.decorators = [
    { type: Component, args: [{ selector: 'xpo-autocomplete',
                template: "<ng-template> <div class=\"xpo-autocomplete-panel\" role=\"listbox\" [id]=\"id\" [ngClass]=\"_getClassList()\" #panel> <ng-content></ng-content> </div> </ng-template>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}::ng-deep input::selection{background:#fafafa}::ng-deep .xpo-autocomplete-panel{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12);max-height:170px;overflow-y:auto;border-bottom:1px solid #dfdfdf}::ng-deep .xpo-autocomplete-panel xpo-option{display:flex;padding-left:15px;cursor:pointer}::ng-deep .xpo-autocomplete-panel xpo-option:hover{background:#eee}::ng-deep .xpo-autocomplete-panel xpo-option:focus{outline:0}::ng-deep .xpo-internal .xpo-autocomplete-panel{margin-top:5px}::ng-deep .xpo-external .xpo-autocomplete-panel{margin-top:12px} /*# sourceMappingURL=autocomplete.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                exportAs: 'xpoAutocomplete',
                host: {
                    '[class.xpo-autocomplete]': 'false',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoAutocomplete.ctorParameters = function () { return [
    { type: ChangeDetectorRef, },
]; };
XpoAutocomplete.propDecorators = {
    'template': [{ type: ViewChild, args: [TemplateRef,] },],
    'panel': [{ type: ViewChild, args: ['panel',] },],
    'options': [{ type: ContentChildren, args: [XpoOption,] },],
    'displayWith': [{ type: Input },],
};
/**
 * \@docs-private
 * @return {?}
 */
function getXpoInputContainerPlaceholderConflictError() {
    return new Error('Placeholder attribute and child element were both specified.');
}
/**
 * \@docs-private
 * @param {?} type
 * @return {?}
 */
function getXpoInputContainerUnsupportedTypeError(type) {
    return new Error("Input type \"" + type + "\" isn't supported by xpo-input-container.");
}
/**
 * \@docs-private
 * @param {?} align
 * @return {?}
 */
function getXpoInputContainerDuplicatedHintError(align) {
    return new Error("A hint was already declared for 'align=\"" + align + "\"'.");
}
/**
 * \@docs-private
 * @return {?}
 */
function getXpoInputContainerMissingXpoInputError() {
    return new Error('xpo-input-container must contain an xpoInput directive. ' +
        'Did you forget to add xpoInput to the native input or textarea element?');
}
// Invalid input type. Using one of these will throw an XpoInputContainerUnsupportedTypeError.
var XPO_INPUT_INVALID_TYPES = [
    'button',
    'checkbox',
    'color',
    'file',
    'hidden',
    'image',
    'radio',
    'range',
    'reset',
    'submit',
];
var nextUniqueId$1 = 0;
/**
 * <xpo-placeholder> is the placeholder directive. The content can declare this to implement more
 * complex placeholders.
 */
var XpoPlaceholder = (function () {
    function XpoPlaceholder() {
    }
    return XpoPlaceholder;
}());
XpoPlaceholder.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-placeholderr',
            },] },
];
/**
 * @nocollapse
 */
XpoPlaceholder.ctorParameters = function () { return []; };
/**
 * <xpo-hint> displays hint text to be shown underneath the input.
 */
var XpoHint = (function () {
    function XpoHint() {
        // Whether to align the hint label at the start or end of the line.
        this.align = 'start';
        // Unique ID for the hint. Used for the aria-describedby on the input.
        this.id = "xpo-input-hint-" + nextUniqueId$1++;
    }
    return XpoHint;
}());
XpoHint.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-hint',
                host: {
                    '[class.xpo-hint]': 'true',
                    '[class.xpo-right]': 'align == "end"',
                    '[attr.id]': 'id',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoHint.ctorParameters = function () { return []; };
XpoHint.propDecorators = {
    'align': [{ type: Input },],
    'id': [{ type: Input },],
};
/**
 * <xpo-error> is a single error message to be shown underneath the input.
 */
var XpoErrorDirective = (function () {
    function XpoErrorDirective() {
    }
    return XpoErrorDirective;
}());
XpoErrorDirective.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-error',
                host: {
                    '[class.xpo-input-error]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoErrorDirective.ctorParameters = function () { return []; };
/**
 * Prefix to be placed the the front of the input.
 */
var XpoPrefix = (function () {
    function XpoPrefix() {
    }
    return XpoPrefix;
}());
XpoPrefix.decorators = [
    { type: Directive, args: [{
                selector: '[xpoPrefix], [xpo-prefix]',
            },] },
];
/**
 * @nocollapse
 */
XpoPrefix.ctorParameters = function () { return []; };
/**
 * Suffix to be placed at the end of the input.
 */
var XpoSuffix = (function () {
    function XpoSuffix() {
    }
    return XpoSuffix;
}());
XpoSuffix.decorators = [
    { type: Directive, args: [{
                selector: '[xpoSuffix], [xpo-suffix]',
            },] },
];
/**
 * @nocollapse
 */
XpoSuffix.ctorParameters = function () { return []; };
/**
 * Marker for the input element that `XpoInputContainer` is wrapping.
 */
var XpoInputDirective = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _ngControl
     */
    function XpoInputDirective(_elementRef, _renderer, _ngControl) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._ngControl = _ngControl;
        /**
         * Variables used as cache for getters and setters.
         */
        this._type = 'text';
        this._placeholder = '';
        this._disabled = false;
        this._required = false;
        /**
         * Whether the element is focused or not.
         */
        this.focused = false;
        /**
         * Emits an event when the placeholder changes so that the `xpo-input-container` can re-validate.
         */
        this._placeholderChange = new EventEmitter();
        this._neverEmptyInputTypes = [
            'date',
            'datetime',
            'datetime-local',
            'month',
            'time',
            'week',
        ].filter(function (t) { return getSupportedInputTypes().has(t); });
        // Force setter to be called in case id was not specified.
        this.id = this.id;
    }
    Object.defineProperty(XpoInputDirective.prototype, "disabled", {
        /**
         * Whether the element is disabled.
         * @return {?}
         */
        get: function () {
            return this._ngControl ? this._ngControl.disabled : this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputDirective.prototype, "id", {
        /**
         * Unique id of the element.
         * @return {?}
         */
        get: function () { return this._id; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._id = value || this._uid; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputDirective.prototype, "placeholder", {
        /**
         * Placeholder attribute of the element.
         * @return {?}
         */
        get: function () { return this._placeholder; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._placeholder !== value) {
                this._placeholder = value;
                this._placeholderChange.emit(this._placeholder);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputDirective.prototype, "required", {
        /**
         * Whether the element is required.
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._required = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputDirective.prototype, "type", {
        /**
         * Input type of the element.
         * @return {?}
         */
        get: function () { return this._type; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._type = value || 'text';
            this._validateType();
            // When using Angular inputs, developers are no longer able to set the properties on the native
            // input element. To ensure that bindings for `type` work, we need to sync the setter
            // with the native property. Textarea elements don't support the type property or attribute.
            if (!this._isTextarea() && getSupportedInputTypes().has(this._type)) {
                this._renderer.setProperty(this._elementRef.nativeElement, 'type', this._type);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputDirective.prototype, "value", {
        /**
         * The input element's value.
         * @return {?}
         */
        get: function () { return this._elementRef.nativeElement.value; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._elementRef.nativeElement.value = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputDirective.prototype, "empty", {
        /**
         * @return {?}
         */
        get: function () {
            return !this._isNeverEmpty() &&
                (this.value == null || this.value === '') &&
                // Check if the input contains bad input. If so, we know that it only appears empty because
                // the value failed to parse. From the user's perspective it is not empty.
                // TODO(mmalerba): Add e2e test for bad input case.
                !this._isBadInput();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputDirective.prototype, "_uid", {
        /**
         * @return {?}
         */
        get: function () { return this._cachedUid = this._cachedUid || "xpo-input-" + nextUniqueId$1++; },
        enumerable: true,
        configurable: true
    });
    /**
     * Focuses the input element.
     * @return {?}
     */
    XpoInputDirective.prototype.focus = function () { this._elementRef.nativeElement.focus(); };
    /**
     * @return {?}
     */
    XpoInputDirective.prototype._onFocus = function () { this.focused = true; };
    /**
     * @return {?}
     */
    XpoInputDirective.prototype._onBlur = function () { this.focused = false; };
    /**
     * @return {?}
     */
    XpoInputDirective.prototype._onInput = function () {
        // This is a noop function and is used to let Angular know whenever the value changes.
        // Angular will run a new change detection each time the `input` event has been dispatched.
        // It's necessary that Angular recognizes the value change, because when floatingLabel
        // is set to false and Angular forms aren't used, the placeholder won't recognize the
        // value changes and will not disappear.
        // Listening to the input event wouldn't be necessary when the input is using the
        // FormsModule or ReactiveFormsModule, because Angular forms also listens to input events.
    };
    /**
     * Make sure the input is a supported type.
     * @return {?}
     */
    XpoInputDirective.prototype._validateType = function () {
        if (XPO_INPUT_INVALID_TYPES.indexOf(this._type) !== -1) {
            throw getXpoInputContainerUnsupportedTypeError(this._type);
        }
    };
    /**
     * @return {?}
     */
    XpoInputDirective.prototype._isNeverEmpty = function () { return this._neverEmptyInputTypes.indexOf(this._type) !== -1; };
    /**
     * @return {?}
     */
    XpoInputDirective.prototype._isBadInput = function () {
        return ((this._elementRef.nativeElement)).validity.badInput;
    };
    /**
     * Determines if the component host is a textarea. If not recognizable it returns false.
     * @return {?}
     */
    XpoInputDirective.prototype._isTextarea = function () {
        var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
        return nativeElement ? nativeElement.nodeName.toLowerCase() === 'textarea' : false;
    };
    return XpoInputDirective;
}());
XpoInputDirective.decorators = [
    { type: Directive, args: [{
                selector: "input[xpoInput], textarea[xpoInput]",
                host: {
                    '[class.xpo-input-element]': 'true',
                    // Native input properties that are overwritten by Angular inputs need to be synced with
                    // the native input element. Otherwise property bindings for those don't work.
                    '[id]': 'id',
                    '[placeholder]': 'placeholder',
                    '[disabled]': 'disabled',
                    '[required]': 'required',
                    '[attr.aria-describedby]': 'ariaDescribedby || null',
                    '(blur)': '_onBlur()',
                    '(focus)': '_onFocus()',
                    '(input)': '_onInput()',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoInputDirective.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: NgControl, decorators: [{ type: Optional }, { type: Self },] },
]; };
XpoInputDirective.propDecorators = {
    'disabled': [{ type: Input },],
    'id': [{ type: Input },],
    'placeholder': [{ type: Input },],
    'required': [{ type: Input },],
    'type': [{ type: Input },],
    '_placeholderChange': [{ type: Output },],
};
/**
 * <xpo-input-container> component is a container for text inputs that applies XPO Design styling and behavior.
 */
var XpoInputContainer = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _changeDetectorRef
     * @param {?} _parentForm
     * @param {?} _parentFormGroup
     */
    function XpoInputContainer(_elementRef, _changeDetectorRef, _parentForm, _parentFormGroup) {
        this._elementRef = _elementRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        /**
         * Alignment of the input container's content.
         */
        this.align = 'start';
        /**
         * Color of the input divider, based on the theme.
         */
        this.color = 'primary';
        /**
         * State of the xpo-hint and xpo-error animations.
         */
        this._subscriptAnimationState = '';
        this._hintLabel = '';
        // Unique id for the hint label.
        this._hintLabelId = "xpo-input-hint-" + nextUniqueId$1++;
    }
    Object.defineProperty(XpoInputContainer.prototype, "dividerColor", {
        /**
         * @deprecated Use color instead.
         * @return {?}
         */
        get: function () { return this.color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.color = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputContainer.prototype, "hideRequiredMarker", {
        /**
         * Whether we should hide the required marker.
         * @return {?}
         */
        get: function () { return this._hideRequiredMarker; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._hideRequiredMarker = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoInputContainer.prototype, "hintLabel", {
        /**
         * Text for the input hint.
         * @return {?}
         */
        get: function () { return this._hintLabel; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._hintLabel = value;
            this._processHints();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoInputContainer.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._validateInputChild();
        this._processHints();
        this._validatePlaceholders();
        // Re-validate when things change.
        this._hintChildren.changes.subscribe(function () { return _this._processHints(); });
        this._xpoInputChild._placeholderChange.subscribe(function () { return _this._validatePlaceholders(); });
    };
    /**
     * @return {?}
     */
    XpoInputContainer.prototype.ngAfterContentChecked = function () {
        this._validateInputChild();
    };
    /**
     * @return {?}
     */
    XpoInputContainer.prototype.ngAfterViewInit = function () {
        // Avoid animations on load.
        this._subscriptAnimationState = 'enter';
        this._changeDetectorRef.detectChanges();
    };
    /**
     * Determines whether a class from the NgControl should be forwarded to the host element.
     * @param {?} prop
     * @return {?}
     */
    XpoInputContainer.prototype._shouldForward = function (prop) {
        var /** @type {?} */ control = this._xpoInputChild ? this._xpoInputChild._ngControl : null;
        return control && ((control))[prop];
    };
    /**
     * Whether the input has a placeholder.
     * @return {?}
     */
    XpoInputContainer.prototype._hasPlaceholder = function () { return !!(this._xpoInputChild.placeholder || this._placeholderChild); };
    /**
     * Focuses the underlying input.
     * @return {?}
     */
    XpoInputContainer.prototype._focusInput = function () { this._xpoInputChild.focus(); };
    /**
     * Whether the input container is in an error state.
     * @return {?}
     */
    XpoInputContainer.prototype._isErrorState = function () {
        var /** @type {?} */ control = this._xpoInputChild._ngControl;
        var /** @type {?} */ isInvalid = control && control.invalid;
        var /** @type {?} */ isTouched = control && control.touched;
        var /** @type {?} */ isSubmitted = (this._parentFormGroup && this._parentFormGroup.submitted) ||
            (this._parentForm && this._parentForm.submitted);
        return !!(isInvalid && (isTouched || isSubmitted));
    };
    /**
     * Determines whether to display hints or errors.
     * @return {?}
     */
    XpoInputContainer.prototype._getDisplayedMessages = function () {
        return (this._errorChildren.length > 0 && this._isErrorState()) ? 'error' : 'hint';
    };
    /**
     * Ensure that there is only one placeholder (either `input` attribute or child element with the
     * `xpo-placeholder` attribute.
     * @return {?}
     */
    XpoInputContainer.prototype._validatePlaceholders = function () {
        if (this._xpoInputChild.placeholder && this._placeholderChild) {
            throw getXpoInputContainerPlaceholderConflictError();
        }
    };
    /**
     * Does any extra processing that is required when handling the hints.
     * @return {?}
     */
    XpoInputContainer.prototype._processHints = function () {
        this._validateHints();
        this._syncAriaDescribedby();
    };
    /**
     * Ensure that there is a maximum of one of each `<xpo-hint>` alignment specified, with the
     * attribute being considered as `align="start"`.
     * @return {?}
     */
    XpoInputContainer.prototype._validateHints = function () {
        var _this = this;
        if (this._hintChildren) {
            var /** @type {?} */ startHint_1 = null;
            var /** @type {?} */ endHint_1 = null;
            this._hintChildren.forEach(function (hint) {
                if (hint.align == 'start') {
                    if (startHint_1 || _this.hintLabel) {
                        throw getXpoInputContainerDuplicatedHintError('start');
                    }
                    startHint_1 = hint;
                }
                else if (hint.align == 'end') {
                    if (endHint_1) {
                        throw getXpoInputContainerDuplicatedHintError('end');
                    }
                    endHint_1 = hint;
                }
            });
        }
    };
    /**
     * Sets the child input's `aria-describedby` to a space-separated list of the ids
     * of the currently-specified hints, as well as a generated id for the hint label.
     * @return {?}
     */
    XpoInputContainer.prototype._syncAriaDescribedby = function () {
        if (this._xpoInputChild) {
            var /** @type {?} */ ids = [];
            var /** @type {?} */ startHint = this._hintChildren ?
                this._hintChildren.find(function (hint) { return hint.align === 'start'; }) : null;
            var /** @type {?} */ endHint = this._hintChildren ?
                this._hintChildren.find(function (hint) { return hint.align === 'end'; }) : null;
            if (startHint) {
                ids.push(startHint.id);
            }
            else if (this._hintLabel) {
                ids.push(this._hintLabelId);
            }
            if (endHint) {
                ids.push(endHint.id);
            }
            this._xpoInputChild.ariaDescribedby = ids.join(' ');
        }
    };
    /**
     * Throws an error if the container's input child was removed.
     * @return {?}
     */
    XpoInputContainer.prototype._validateInputChild = function () {
        if (!this._xpoInputChild) {
            throw getXpoInputContainerMissingXpoInputError();
        }
    };
    return XpoInputContainer;
}());
XpoInputContainer.decorators = [
    { type: Component, args: [{ selector: 'xpo-input-container',
                template: "<xpo-form-group [labelPosition]=\"labelPosition\"> <div class=\"xpo-input-wrapper\" [class.xpo-empty]=\"_xpoInputChild.empty && !_hasPlaceholder()\" [class.xpo-focused]=\"_xpoInputChild.focused\" [class.xpo-error]=\"_isErrorState()\"> <div class=\"xpo-input-flex\"> <div class=\"xpo-input-prefix\" *ngIf=\"_prefixChildren.length\"> <ng-content select=\"[xpoPrefix], [xpo-prefix]\"></ng-content> </div> <div class=\"xpo-input-infix\"> <ng-content selector=\"input, textarea\"></ng-content> <span class=\"xpo-input-placeholder-wrapper\"> <span class=\"xpo-input-placeholder\" *ngIf=\"_hasPlaceholder() && _xpoInputChild.empty\"> <ng-content select=\"xpo-placeholder\"></ng-content> {{_xpoInputChild.placeholder}} <span class=\"xpo-placeholder-required\" *ngIf=\"!hideRequiredMarker && _xpoInputChild.required\">*</span> </span> </span> </div> <div class=\"xpo-input-suffix\" *ngIf=\"_suffixChildren.length\"> <ng-content select=\"[xpoSuffix], [xpo-suffix]\"></ng-content> </div> </div> <div class=\"xpo-input-underline\" #underline [class.xpo-disabled]=\"_xpoInputChild.disabled\"> </div> <div class=\"xpo-input-subscript-wrapper\" [ngSwitch]=\"_getDisplayedMessages()\"> <div *ngSwitchCase=\"'error'\" [@transitionMessages]=\"_subscriptAnimationState\"> <ng-content select=\"xpo-error\"></ng-content> </div> <div class=\"xpo-input-hint-wrapper\" *ngSwitchCase=\"'hint'\" [@transitionMessages]=\"_subscriptAnimationState\"> <div *ngIf=\"hintLabel\" [id]=\"_hintLabelId\" class=\"xpo-hint\">{{hintLabel}}</div> <ng-content select=\"xpo-hint:not([align='end']), xpo-hint:not([align='end'])\"></ng-content> <div class=\"xpo-input-hint-spacer\"></div> <ng-content select=\"xpo-hint[align='end'], xpo-hint[align='end']\"></ng-content> </div> </div> </div> <label *ngIf=\"label\" [attr.for]=\"_xpoInputChild.id\">{{ label }}</label> </xpo-form-group> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:block;position:relative;text-align:left}[dir=rtl] :host{text-align:right}:host.xpo-input-invalid .xpo-input-underline{background-color:#d50000}:host.xpo-input-invalid label{color:#d50000}:host ::ng-deep .xpo-hint,:host ::ng-deep .xpo-input-error{display:block}:host ::ng-deep .xpo-hint{color:#bdbdbd}:host ::ng-deep .xpo-input-error{color:#d50000}.xpo-input-wrapper{flex:1;position:relative}.xpo-input-wrapper.xpo-focused+label{color:#0091ea}.xpo-input-flex{display:inline-flex;align-items:baseline;width:100%}.xpo-input-prefix,.xpo-input-suffix{align-self:flex-start;flex:none;white-space:nowrap}.xpo-input-prefix ::ng-deep .xpo-datepicker-toggle,.xpo-input-prefix ::ng-deep .xpo-icon,.xpo-input-suffix ::ng-deep .xpo-datepicker-toggle,.xpo-input-suffix ::ng-deep .xpo-icon{vertical-align:text-bottom;width:1em;height:1em}.xpo-input-infix{display:block;flex:auto;position:relative}::ng-deep .xpo-input-element{vertical-align:bottom;width:100%;max-width:100%;padding:0;position:relative;outline:0;resize:vertical;font:inherit;color:currentColor;border:none;background:0 0}::ng-deep .xpo-input-element::placeholder{color:transparent!important}::ng-deep .xpo-input-element::-moz-placeholder{color:transparent!important}::ng-deep .xpo-input-element::-webkit-input-placeholder{color:transparent!important}::ng-deep .xpo-input-element:-ms-input-placeholder{color:transparent!important}::ng-deep .xpo-input-element:-moz-ui-invalid{box-shadow:none}::ng-deep .xpo-input-element:-webkit-autofill+.xpo-input-placeholder-wrapper{display:block;width:133.33333%;transform:translate3d(0,-1.35em,0) scale(.75)}::ng-deep .xpo-input-element:-webkit-autofill+.xpo-input-placeholder-wrapper .xpo-input-placeholder{display:none}::ng-deep .xpo-input-element:-webkit-autofill+.xpo-input-placeholder-wrapper .xpo-float{display:block;transition:none}.xpo-input-placeholder-wrapper{box-sizing:content-box;width:100%;height:100%;padding:0 2px;overflow:hidden;position:absolute;left:0;pointer-events:none}textarea.mat-input-element{overflow:auto}.xpo-input-placeholder{width:100%;overflow:hidden;position:absolute;left:0;font-size:100%;text-overflow:ellipsis;white-space:nowrap;pointer-events:none}.xpo-input-placeholder.xpo-float:not(.xpo-empty),:host(.xpo-focused) .xpo-input-placeholder.xpo-float{display:block;width:133.33333%;transform:translate3d(0,-1.35em,0) scale(.75)}[dir=rtl] .xpo-input-placeholder{right:0;left:auto;transform-origin:100% 0}.xpo-input-placeholder:not(.xpo-empty){transition:none}.xpo-input-underline{width:100%;height:1px;position:absolute;background-color:#bdbdbd}.xpo-input-underline.xpo-disabled{background-image:linear-gradient(to right,rgba(0,0,0,.26) 0,rgba(0,0,0,.26) 33%,transparent 0);background-repeat:repeat-x;background-size:4px 1px;background-color:transparent;background-position:0}:host(.xpo-focused) .xpo-input-underline{background-color:#0091ea;transition:transform 150ms linear,background-color .3s cubic-bezier(.55,0,.55,.2)}.xpo-input-subscript-wrapper{width:100%;overflow:hidden;position:absolute}.xpo-input-placeholder-wrapper ::ng-deep .xpo-datepicker-toggle,.xpo-input-placeholder-wrapper ::ng-deep .xpo-icon,.xpo-input-subscript-wrapper ::ng-deep .xpo-datepicker-toggle,.xpo-input-subscript-wrapper ::ng-deep .xpo-icon{vertical-align:baseline;width:1em;height:1em;font-size:inherit}.xpo-input-hint-wrapper{display:flex}.xpo-input-hint-spacer{flex:1 0 10px}:host-context(.xpo-internal) .xpo-input-wrapper{min-height:17px}:host-context(.xpo-internal) ::ng-deep .xpo-input-element{bottom:1px}:host-context(.xpo-internal) .xpo-input-placeholder-wrapper{bottom:2px}:host-context(.xpo-internal) .xpo-input-placeholder{color:#bdbdbd}:host-context(.xpo-internal) .xpo-input-underline{bottom:-1px}:host-context(.xpo-internal) .xpo-input-subscript-wrapper{bottom:-18px;font-size:.83333rem}:host-context(.xpo-external) .xpo-input-wrapper{min-height:28px}:host-context(.xpo-external) ::ng-deep .xpo-input-element{bottom:4px;font-size:1.1667rem}:host-context(.xpo-external) .xpo-input-placeholder-wrapper{bottom:4px;font-size:1.1667rem}:host-context(.xpo-external) .xpo-input-placeholder{color:#858585}:host-context(.xpo-external) .xpo-input-underline{bottom:0}:host-context(.xpo-external) .xpo-input-subscript-wrapper{bottom:-19px;font-size:.91667rem} /*# sourceMappingURL=input-container.css.map */ "],
                animations: [
                    trigger('transitionMessages', [
                        state('enter', style({ opacity: 1, transform: 'translateY(0%)' })),
                        transition('void => enter', [
                            style({ opacity: 0, transform: 'translateY(-100%)' }),
                            animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
                        ]),
                    ]),
                ],
                host: {
                    // Remove align attribute to prevent it from interfering with layout.
                    '[attr.align]': 'null',
                    '[class.xpo-input-container]': 'true',
                    '[class.xpo-input-invalid]': '_isErrorState()',
                    '[class.xpo-empty]': '_xpoInputChild.empty && !_hasPlaceholder()',
                    '[class.xpo-focused]': '_xpoInputChild.focused',
                    '[class.ng-untouched]': '_shouldForward("untouched")',
                    '[class.ng-touched]': '_shouldForward("touched")',
                    '[class.ng-pristine]': '_shouldForward("pristine")',
                    '[class.ng-dirty]': '_shouldForward("dirty")',
                    '[class.ng-valid]': '_shouldForward("valid")',
                    '[class.ng-invalid]': '_shouldForward("invalid")',
                    '[class.ng-pending]': '_shouldForward("pending")',
                    '(click)': '_focusInput()',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoInputContainer.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: ChangeDetectorRef, },
    { type: NgForm, decorators: [{ type: Optional },] },
    { type: FormGroupDirective, decorators: [{ type: Optional },] },
]; };
XpoInputContainer.propDecorators = {
    'align': [{ type: Input },],
    'color': [{ type: Input },],
    'dividerColor': [{ type: Input },],
    'hideRequiredMarker': [{ type: Input },],
    'label': [{ type: Input },],
    'labelPosition': [{ type: Input },],
    'hintLabel': [{ type: Input },],
    'underlineRef': [{ type: ViewChild, args: ['underline',] },],
    '_xpoInputChild': [{ type: ContentChild, args: [XpoInputDirective,] },],
    '_placeholderChild': [{ type: ContentChild, args: [XpoPlaceholder,] },],
    '_errorChildren': [{ type: ContentChildren, args: [XpoErrorDirective,] },],
    '_hintChildren': [{ type: ContentChildren, args: [XpoHint,] },],
    '_prefixChildren': [{ type: ContentChildren, args: [XpoPrefix,] },],
    '_suffixChildren': [{ type: ContentChildren, args: [XpoSuffix,] },],
};
/**
 * The height of each autocomplete option.
 */
var AUTOCOMPLETE_OPTION_HEIGHT = 34;
/**
 * The total height of the autocomplete panel.
 */
var AUTOCOMPLETE_PANEL_HEIGHT = 34 * 5;
/**
 * Provider that allows the autocomplete to register as a ControlValueAccessor.
 * \@docs-private
 */
var XPO_AUTOCOMPLETE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return XpoAutocompleteTrigger; }),
    multi: true,
};
var XpoAutocompleteTrigger = (function () {
    /**
     * @param {?} _element
     * @param {?} _overlay
     * @param {?} _viewContainerRef
     * @param {?} _changeDetectorRef
     * @param {?} _scrollDispatcher
     * @param {?} _dir
     * @param {?} _zone
     * @param {?} _inputContainer
     * @param {?} _document
     */
    function XpoAutocompleteTrigger(_element, _overlay, _viewContainerRef, _changeDetectorRef, _scrollDispatcher, _dir, _zone, _inputContainer, _document) {
        this._element = _element;
        this._overlay = _overlay;
        this._viewContainerRef = _viewContainerRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._scrollDispatcher = _scrollDispatcher;
        this._dir = _dir;
        this._zone = _zone;
        this._inputContainer = _inputContainer;
        this._document = _document;
        this._panelOpen = false;
        /**
         * View -> model callback called when value changes
         */
        this._onChange = function (value) { };
        /**
         * View -> model callback called when autocomplete has been touched
         */
        this._onTouched = function () { };
        this.optionSelected = new EventEmitter();
    }
    Object.defineProperty(XpoAutocompleteTrigger.prototype, "_matAutocomplete", {
        /**
         * Property with xpo- prefix for no-conflict mode.
         * @return {?}
         */
        get: function () {
            return this.autocomplete;
        },
        /**
         * @param {?} autocomplete
         * @return {?}
         */
        set: function (autocomplete) {
            this.autocomplete = autocomplete;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype.ngOnDestroy = function () {
        if (this._panelPositionSubscription) {
            this._panelPositionSubscription.unsubscribe();
        }
        this._destroyPanel();
    };
    Object.defineProperty(XpoAutocompleteTrigger.prototype, "panelOpen", {
        /**
         * @return {?}
         */
        get: function () {
            return this._panelOpen && this.autocomplete.showPanel;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Opens the autocomplete suggestion panel.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype.openPanel = function () {
        if (!this._overlayRef) {
            this._createOverlay();
        }
        else {
            /** Update the panel width, in case the host width has changed */
            this._overlayRef.getConfig().width = this._getHostWidth();
            this._overlayRef.updateSize();
        }
        if (!this._overlayRef.hasAttached()) {
            this._overlayRef.attach(this._portal);
            this._subscribeToClosingActions();
        }
        this.autocomplete._setVisibility();
        this._panelOpen = true;
    };
    /**
     * Closes the autocomplete suggestion panel.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype.closePanel = function () {
        if (this._overlayRef && this._overlayRef.hasAttached()) {
            this._overlayRef.detach();
        }
        this._panelOpen = false;
        // We need to trigger change detection manually, because
        // `fromEvent` doesn't seem to do it at the proper time.
        // This ensures that the placeholder is reset when the
        // user clicks outside.
        this._changeDetectorRef.detectChanges();
    };
    Object.defineProperty(XpoAutocompleteTrigger.prototype, "panelClosingActions", {
        /**
         * A stream of actions that should close the autocomplete panel, including
         * when an option is selected, on blur, and when TAB is pressed.
         * @return {?}
         */
        get: function () {
            return Observable.merge(this.optionSelections, this.autocomplete._keyManager.tabOut, this._outsideClickStream);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoAutocompleteTrigger.prototype, "optionSelections", {
        /**
         * Stream of autocomplete option selections.
         * @return {?}
         */
        get: function () {
            return Observable.merge.apply(Observable, this.autocomplete.options.map(function (option) { return option.onSelectionChange; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoAutocompleteTrigger.prototype, "activeOption", {
        /**
         * The currently active option, coerced to XpoOption type.
         * @return {?}
         */
        get: function () {
            if (this.autocomplete._keyManager) {
                return (this.autocomplete._keyManager.activeItem);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoAutocompleteTrigger.prototype, "_outsideClickStream", {
        /**
         * Stream of clicks outside of the autocomplete panel.
         * @return {?}
         */
        get: function () {
            var _this = this;
            if (this._document) {
                return Observable.fromEvent(this._document, 'click').filter(function (event) {
                    var /** @type {?} */ clickTarget = (event.target);
                    var /** @type {?} */ inputContainer = _this._inputContainer ?
                        _this._inputContainer._elementRef.nativeElement : null;
                    return _this._panelOpen &&
                        clickTarget !== _this._element.nativeElement &&
                        (!inputContainer || !inputContainer.contains(clickTarget)) &&
                        !_this._overlayRef.overlayElement.contains(clickTarget);
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the autocomplete's value. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param {?} value New value to be written to the model.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype.writeValue = function (value) {
        var _this = this;
        Promise.resolve(null).then(function () { return _this._setTriggerValue(value); });
    };
    /**
     * Saves a callback function to be invoked when the autocomplete's value
     * changes from user input. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param {?} fn Callback to be triggered when the value changes.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    /**
     * Saves a callback function to be invoked when the autocomplete is blurred
     * by the user. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param {?} fn Callback to be triggered when the component has been touched.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._handleKeydown = function (event) {
        var _this = this;
        if (this.activeOption && event.keyCode === ENTER) {
            this.activeOption._selectViaInteraction();
            event.preventDefault();
        }
        else {
            var /** @type {?} */ prevActiveItem_1 = this.autocomplete._keyManager.activeItem;
            var /** @type {?} */ isArrowKey_1 = event.keyCode === UP_ARROW || event.keyCode === DOWN_ARROW;
            this.autocomplete._keyManager.onKeydown(event);
            if (isArrowKey_1) {
                this.openPanel();
            }
            Promise.resolve().then(function () {
                if (isArrowKey_1 || _this.autocomplete._keyManager.activeItem !== prevActiveItem_1) {
                    _this._scrollToOption();
                }
            });
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._handleInput = function (event) {
        // We need to ensure that the input is focused, because IE will fire the `input`
        // event on focus/blur/load if the input has a placeholder. See:
        // https://connect.microsoft.com/IE/feedback/details/885747/
        if (document.activeElement === event.target) {
            this._onChange(((event.target)).value);
            this.openPanel();
        }
    };
    /**
     * Given that we are not actually focusing active options, we must manually adjust scroll
     * to reveal options below the fold. First, we find the offset of the option from the top
     * of the panel. The new scrollTop will be that offset - the panel height + the option
     * height, so the active option will be just visible at the bottom of the panel.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._scrollToOption = function () {
        var /** @type {?} */ optionOffset = this.autocomplete._keyManager.activeItemIndex * AUTOCOMPLETE_OPTION_HEIGHT;
        var /** @type {?} */ newScrollTop = Math.max(0, optionOffset - AUTOCOMPLETE_PANEL_HEIGHT + AUTOCOMPLETE_OPTION_HEIGHT);
        this.autocomplete._setScrollTop(newScrollTop);
    };
    /**
     * This method listens to a stream of panel closing actions and resets the
     * stream every time the option list changes.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._subscribeToClosingActions = function () {
        var _this = this;
        // When the zone is stable initially, and when the option list changes...
        Observable.merge(this._zone.onStable.first(), this.autocomplete.options.changes)
            .switchMap(function () {
            _this._resetPanel();
            return _this.panelClosingActions;
        })
            .first()
            .subscribe(function (event) { return _this._setValueAndClose(event); });
    };
    /**
     * Destroys the autocomplete suggestion panel.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._destroyPanel = function () {
        if (this._overlayRef) {
            this.closePanel();
            this._overlayRef.dispose();
            this._overlayRef = null;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._setTriggerValue = function (value) {
        var /** @type {?} */ toDisplay = this.autocomplete.displayWith ? this.autocomplete.displayWith(value) : value;
        this._element.nativeElement.value = toDisplay || '';
    };
    /**
     * This method closes the panel, and if a value is specified, also sets the associated
     * control to that value. It will also mark the control as dirty if this interaction
     * stemmed from the user.
     * @param {?} event
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._setValueAndClose = function (event) {
        if (event && event.source) {
            this._clearPreviousSelectedOption(event.source);
            this._setTriggerValue(event.source.value);
            this.optionSelected.emit(event.source.value);
            this._onChange(event.source.value);
        }
        this.closePanel();
    };
    /**
     * Clear any previous selected option and emit a selection change event for this option
     * @param {?} skip
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._clearPreviousSelectedOption = function (skip) {
        this.autocomplete.options.forEach(function (option) {
            if (option != skip && option.selected) {
                option.deselect();
            }
        });
    };
    /**
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._createOverlay = function () {
        this._portal = new TemplatePortal(this.autocomplete.template, this._viewContainerRef);
        this._overlayRef = this._overlay.create(this._getOverlayConfig());
    };
    /**
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._getOverlayConfig = function () {
        var /** @type {?} */ overlayState = new OverlayState();
        overlayState.positionStrategy = this._getOverlayPosition();
        overlayState.width = this._getHostWidth();
        overlayState.direction = this._dir ? this._dir.value : 'ltr';
        overlayState.scrollStrategy = new RepositionScrollStrategy(this._scrollDispatcher);
        return overlayState;
    };
    /**
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._getOverlayPosition = function () {
        this._positionStrategy = this._overlay.position().connectedTo(this._element, { originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' })
            .withFallbackPosition({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' });
        this._subscribeToPositionChanges(this._positionStrategy);
        return this._positionStrategy;
    };
    /**
     * This method subscribes to position changes in the autocomplete panel, so the panel's
     * y-offset can be adjusted to match the new position.
     * @param {?} strategy
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._subscribeToPositionChanges = function (strategy) {
        var _this = this;
        this._panelPositionSubscription = strategy.onPositionChange.subscribe(function (change) {
            _this.autocomplete.positionY = change.connectionPair.originY === 'top' ? 'above' : 'below';
        });
    };
    /**
     * Returns the width of the input element, so the panel width can match it.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._getHostWidth = function () {
        return this._element.nativeElement.getBoundingClientRect().width;
    };
    /**
     * Reset active item to null so arrow events will activate the correct options.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._resetActiveItem = function () {
        this.autocomplete._keyManager.setActiveItem(null);
    };
    /**
     * Resets the active item and re-calculates alignment of the panel in case its size
     * has changed due to fewer or greater number of options.
     * @return {?}
     */
    XpoAutocompleteTrigger.prototype._resetPanel = function () {
        this._resetActiveItem();
        this._positionStrategy.recalculateLastPosition();
        this.autocomplete._setVisibility();
    };
    return XpoAutocompleteTrigger;
}());
XpoAutocompleteTrigger.decorators = [
    { type: Directive, args: [{
                selector: 'input[xpoAutocomplete]',
                host: {
                    'role': 'combobox',
                    'autocomplete': 'off',
                    'aria-autocomplete': 'list',
                    'aria-multiline': 'false',
                    '[attr.aria-activedescendant]': 'activeOption?.id',
                    '[attr.aria-expanded]': 'panelOpen.toString()',
                    '[attr.aria-owns]': 'autocomplete?.id',
                    '(focus)': 'openPanel()',
                    '(input)': '_handleInput($event)',
                    '(blur)': '_onTouched()',
                    '(keydown)': '_handleKeydown($event)',
                },
                providers: [XPO_AUTOCOMPLETE_VALUE_ACCESSOR],
            },] },
];
/**
 * @nocollapse
 */
XpoAutocompleteTrigger.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Overlay, },
    { type: ViewContainerRef, },
    { type: ChangeDetectorRef, },
    { type: ScrollDispatcher, },
    { type: Dir, decorators: [{ type: Optional },] },
    { type: NgZone, },
    { type: XpoInputContainer, decorators: [{ type: Optional }, { type: Host },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] },] },
]; };
XpoAutocompleteTrigger.propDecorators = {
    'autocomplete': [{ type: Input, args: ['xpoAutocomplete',] },],
    'optionSelected': [{ type: Output },],
    '_matAutocomplete': [{ type: Input, args: ['matAutocomplete',] },],
};
var XpoAutocompleteModule = (function () {
    function XpoAutocompleteModule() {
    }
    return XpoAutocompleteModule;
}());
XpoAutocompleteModule.decorators = [
    { type: NgModule, args: [{
                imports: [XpoOptionModule, OverlayModule, XpoCommonModule, CommonModule],
                exports: [XpoAutocomplete, XpoOptionModule, XpoAutocompleteTrigger, XpoCommonModule],
                declarations: [XpoAutocomplete, XpoAutocompleteTrigger],
            },] },
];
/**
 * @nocollapse
 */
XpoAutocompleteModule.ctorParameters = function () { return []; };
/**
 * <xpo-badge> badge component displays the company name, street address, city, state, zip, phone and email address.
 */
var XpoBadge = (function () {
    function XpoBadge() {
    }
    Object.defineProperty(XpoBadge.prototype, "helper", {
        /**
         * The badge helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoBadge.prototype, "value", {
        /**
         * The badge number value.
         * @return {?}
         */
        get: function () { return this._value; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._value = value; },
        enumerable: true,
        configurable: true
    });
    return XpoBadge;
}());
XpoBadge.decorators = [
    { type: Component, args: [{ selector: 'xpo-badge',
                host: {},
                template: "<span *ngIf=\"helperObj\"> {{ helperObj.value }} </span> <span *ngIf=\"!helperObj\"> {{value}} </span> <span> <ng-content></ng-content> </span>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex;align-items:center;justify-content:center;width:25px;height:25px;font-weight:700;color:#fff;border-radius:50%;background-color:red} /*# sourceMappingURL=badge.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoBadge.ctorParameters = function () { return []; };
XpoBadge.propDecorators = {
    'helper': [{ type: Input },],
    'value': [{ type: Input },],
};
var XpoBadgeModule = (function () {
    function XpoBadgeModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoBadgeModule.forRoot = function () {
        return {
            ngModule: XpoBadgeModule,
        };
    };
    return XpoBadgeModule;
}());
XpoBadgeModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoBadge],
                declarations: [XpoBadge],
            },] },
];
/**
 * @nocollapse
 */
XpoBadgeModule.ctorParameters = function () { return []; };
/* tslint:disable */
var XpoFormGroup = (function () {
    function XpoFormGroup() {
        this._labelPosition = 'left';
    }
    Object.defineProperty(XpoFormGroup.prototype, "labelPosition", {
        /**
         * Whether the label should be on the left, top, or animate on the input
         * @return {?}
         */
        get: function () { return this._labelPosition; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._labelPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    return XpoFormGroup;
}());
XpoFormGroup.decorators = [
    { type: Component, args: [{
                selector: 'xpo-form-group',
                template: '<ng-content></ng-content>',
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}::ng-deep .form-section-title{margin:20px 0 25px;font-size:15px;font-weight:700;text-transform:uppercase}::ng-deep .xpo-form-group{display:flex;position:relative}::ng-deep .xpo-form-group .xpo-select-trigger+label{transition:color .4s cubic-bezier(.25,.8,.25,1)}::ng-deep .xpo-form-group .xpo-select-trigger.xpo-focused+label{color:#0091ea}::ng-deep .xpo-form-group .xpo-slide-toggle{display:table}::ng-deep .xpo-form-group__label--left{flex-direction:row}::ng-deep .xpo-form-group__label--left .xpo-select-trigger{flex-basis:66%}::ng-deep .xpo-form-group__label--left .xpo-select-trigger+label{align-self:flex-start;flex-basis:34%;order:-1;padding-right:15px}::ng-deep .xpo-form-group__label--left .xpo-select-error{margin-left:34%}::ng-deep .xpo-form-group__label--left .input-wrapper+.xpo-legend{order:-1;width:34%;padding-right:15px}::ng-deep .xpo-form-group__label--left .xpo-slide-toggle:first-child{margin-top:-4px}::ng-deep .xpo-form-group__label--left .xpo-input-wrapper+label{order:-1;width:34%;padding-right:15px}::ng-deep .xpo-form-group__label--left.xpo-form-group__upload{align-items:baseline}::ng-deep .xpo-form-group__label--left .upload__label{order:-1;width:34%;padding-right:15px}::ng-deep .xpo-form-group__label--top{flex-direction:column}::ng-deep .xpo-form-group__label--top .xpo-select-trigger+label{order:-1;margin-bottom:15px}::ng-deep .xpo-form-group__label--top .input-wrapper+.xpo-legend{order:-1;margin-bottom:15px}::ng-deep .xpo-form-group__label--top .xpo-input-wrapper+label{order:-1;margin-bottom:15px}::ng-deep .xpo-form-group__label--top .upload__label{order:-1;margin-bottom:10px}::ng-deep .xpo-form-group__label--animate{flex-direction:column;position:relative}::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper{margin-bottom:25px}::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper+label{width:auto;position:absolute;left:0;-ms-transform:none;transform:perspective(100px);transform-origin:0 0;cursor:pointer;transition:transform .4s cubic-bezier(.25,.8,.25,1);pointer-events:none}::ng-deep .xpo-form-group__label--animate .xpo-select-trigger+label{width:auto;padding-right:20px;position:absolute;left:0;-ms-transform:none;transform:perspective(100px);transform-origin:0 0;cursor:pointer;transition:transform .4s cubic-bezier(.25,.8,.25,1);pointer-events:none}::ng-deep .xpo-select-error{position:absolute;color:#d50000}::ng-deep .xpo-fieldset .xpo-legend{font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group .xpo-select-placeholder{color:#858585}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--left{margin:26px 0 0;color:#333}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--left .xpo-input-wrapper+label{font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--left .xpo-select-trigger+label{font-size:1rem;font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--top{margin-bottom:20px}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--top .xpo-input-wrapper+label{font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--top .xpo-select-trigger+label{font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate{margin:15px 0 25px}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper.xpo-focused+label,:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper:not(.xpo-empty)+label{transform:scale(.75) translate3d(0,-25px,0)}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper+label{top:-1px}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger+label{bottom:1px;font-size:1rem;line-height:17px}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger.xpo-focused+label,:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger:not(.xpo-empty)+label{transform:scale(.75) translate3d(0,-25px,0)}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-select-value{bottom:1px}:host-context(.xpo-internal) ::ng-deep .xpo-select-error{bottom:-18px;font-size:.83333rem}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--left{margin:30px 0 20px;color:#333}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--left .upload__filename+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--left .xpo-input-wrapper+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--left .xpo-select-trigger+label{font-size:1rem;font-weight:700}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--top{margin-bottom:20px}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--top .upload__filename+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--top .xpo-input-wrapper+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--top .xpo-select-trigger+label{font-size:1rem;font-weight:700}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate{margin:30px 0 20px}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate>label{top:-4px;font-size:1.1667rem;color:#858585}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper.xpo-focused+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper:not(.xpo-empty)+label{transform:scale(.75) translate3d(0,-30px,0)}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger+label{top:-7px;line-height:27px}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger.xpo-focused+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger:not(.xpo-empty)+label{transform:scale(.75) translate3d(0,-30px,0)}:host-context(.xpo-external) ::ng-deep .xpo-form-group .xpo-select-placeholder{color:#858585}:host-context(.xpo-external) ::ng-deep .xpo-select-error{bottom:-21px;font-size:.91667rem} /*# sourceMappingURL=form.css.map */ "],
                host: {
                    'class': 'xpo-form-group',
                    '[class.xpo-form-group__label--left]': 'labelPosition === "left"',
                    '[class.xpo-form-group__label--top]': 'labelPosition === "top"',
                    '[class.xpo-form-group__label--animate]': 'labelPosition === "animate"',
                }
            },] },
];
/**
 * @nocollapse
 */
XpoFormGroup.ctorParameters = function () { return []; };
XpoFormGroup.propDecorators = {
    'labelPosition': [{ type: Input },],
};
/**
 * <form xpo-form> component is a container for HTML form fields.
 */
var XpoForm = (function () {
    function XpoForm() {
    }
    return XpoForm;
}());
XpoForm.decorators = [
    { type: Component, args: [{ selector: '[xpo-form]',
                template: '<ng-content></ng-content>',
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}::ng-deep .form-section-title{margin:20px 0 25px;font-size:15px;font-weight:700;text-transform:uppercase}::ng-deep .xpo-form-group{display:flex;position:relative}::ng-deep .xpo-form-group .xpo-select-trigger+label{transition:color .4s cubic-bezier(.25,.8,.25,1)}::ng-deep .xpo-form-group .xpo-select-trigger.xpo-focused+label{color:#0091ea}::ng-deep .xpo-form-group .xpo-slide-toggle{display:table}::ng-deep .xpo-form-group__label--left{flex-direction:row}::ng-deep .xpo-form-group__label--left .xpo-select-trigger{flex-basis:66%}::ng-deep .xpo-form-group__label--left .xpo-select-trigger+label{align-self:flex-start;flex-basis:34%;order:-1;padding-right:15px}::ng-deep .xpo-form-group__label--left .xpo-select-error{margin-left:34%}::ng-deep .xpo-form-group__label--left .input-wrapper+.xpo-legend{order:-1;width:34%;padding-right:15px}::ng-deep .xpo-form-group__label--left .xpo-slide-toggle:first-child{margin-top:-4px}::ng-deep .xpo-form-group__label--left .xpo-input-wrapper+label{order:-1;width:34%;padding-right:15px}::ng-deep .xpo-form-group__label--left.xpo-form-group__upload{align-items:baseline}::ng-deep .xpo-form-group__label--left .upload__label{order:-1;width:34%;padding-right:15px}::ng-deep .xpo-form-group__label--top{flex-direction:column}::ng-deep .xpo-form-group__label--top .xpo-select-trigger+label{order:-1;margin-bottom:15px}::ng-deep .xpo-form-group__label--top .input-wrapper+.xpo-legend{order:-1;margin-bottom:15px}::ng-deep .xpo-form-group__label--top .xpo-input-wrapper+label{order:-1;margin-bottom:15px}::ng-deep .xpo-form-group__label--top .upload__label{order:-1;margin-bottom:10px}::ng-deep .xpo-form-group__label--animate{flex-direction:column;position:relative}::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper{margin-bottom:25px}::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper+label{width:auto;position:absolute;left:0;-ms-transform:none;transform:perspective(100px);transform-origin:0 0;cursor:pointer;transition:transform .4s cubic-bezier(.25,.8,.25,1);pointer-events:none}::ng-deep .xpo-form-group__label--animate .xpo-select-trigger+label{width:auto;padding-right:20px;position:absolute;left:0;-ms-transform:none;transform:perspective(100px);transform-origin:0 0;cursor:pointer;transition:transform .4s cubic-bezier(.25,.8,.25,1);pointer-events:none}::ng-deep .xpo-select-error{position:absolute;color:#d50000}::ng-deep .xpo-fieldset .xpo-legend{font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group .xpo-select-placeholder{color:#858585}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--left{margin:26px 0 0;color:#333}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--left .xpo-input-wrapper+label{font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--left .xpo-select-trigger+label{font-size:1rem;font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--top{margin-bottom:20px}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--top .xpo-input-wrapper+label{font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--top .xpo-select-trigger+label{font-weight:700}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate{margin:15px 0 25px}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper.xpo-focused+label,:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper:not(.xpo-empty)+label{transform:scale(.75) translate3d(0,-25px,0)}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper+label{top:-1px}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger+label{bottom:1px;font-size:1rem;line-height:17px}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger.xpo-focused+label,:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger:not(.xpo-empty)+label{transform:scale(.75) translate3d(0,-25px,0)}:host-context(.xpo-internal) ::ng-deep .xpo-form-group__label--animate .xpo-select-value{bottom:1px}:host-context(.xpo-internal) ::ng-deep .xpo-select-error{bottom:-18px;font-size:.83333rem}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--left{margin:30px 0 20px;color:#333}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--left .upload__filename+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--left .xpo-input-wrapper+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--left .xpo-select-trigger+label{font-size:1rem;font-weight:700}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--top{margin-bottom:20px}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--top .upload__filename+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--top .xpo-input-wrapper+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--top .xpo-select-trigger+label{font-size:1rem;font-weight:700}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate{margin:30px 0 20px}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate>label{top:-4px;font-size:1.1667rem;color:#858585}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper.xpo-focused+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-input-wrapper:not(.xpo-empty)+label{transform:scale(.75) translate3d(0,-30px,0)}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger+label{top:-7px;line-height:27px}:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger.xpo-focused+label,:host-context(.xpo-external) ::ng-deep .xpo-form-group__label--animate .xpo-select-trigger:not(.xpo-empty)+label{transform:scale(.75) translate3d(0,-30px,0)}:host-context(.xpo-external) ::ng-deep .xpo-form-group .xpo-select-placeholder{color:#858585}:host-context(.xpo-external) ::ng-deep .xpo-select-error{bottom:-21px;font-size:.91667rem} /*# sourceMappingURL=form.css.map */ "],
            },] },
];
/**
 * @nocollapse
 */
XpoForm.ctorParameters = function () { return []; };
var XpoFormModule = (function () {
    function XpoFormModule() {
    }
    return XpoFormModule;
}());
XpoFormModule.decorators = [
    { type: NgModule, args: [{
                imports: [],
                exports: [XpoForm, XpoFormGroup],
                declarations: [XpoForm, XpoFormGroup],
            },] },
];
/**
 * @nocollapse
 */
XpoFormModule.ctorParameters = function () { return []; };
/**
 * Directive to automatically resize a textarea to fit its content.
 */
var XpoTextareaAutosize = (function () {
    /**
     * @param {?} _elementRef
     */
    function XpoTextareaAutosize(_elementRef) {
        this._elementRef = _elementRef;
    }
    Object.defineProperty(XpoTextareaAutosize.prototype, "minRows", {
        /**
         * @deprecated Use xpoAutosizeMinRows
         * @return {?}
         */
        get: function () { return this._minRows; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._minRows = value;
            this._setMinHeight();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTextareaAutosize.prototype, "maxRows", {
        /**
         * @deprecated Use xpoAutosizeMaxRows
         * @return {?}
         */
        get: function () { return this._maxRows; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._maxRows = value;
            this._setMaxHeight();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTextareaAutosize.prototype, "xpoAutosizeMinRows", {
        /**
         * Minimum number of rows for this textarea.
         * @return {?}
         */
        get: function () { return this.minRows; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.minRows = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTextareaAutosize.prototype, "xpoAutosizeMaxRows", {
        /**
         * Maximum number of rows for this textarea.
         * @return {?}
         */
        get: function () { return this.maxRows; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.maxRows = value; },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the minimum height of the textarea as determined by minRows.
     * @return {?}
     */
    XpoTextareaAutosize.prototype._setMinHeight = function () {
        var /** @type {?} */ minHeight = this.minRows && this._cachedLineHeight ?
            this.minRows * this._cachedLineHeight + "px" : null;
        if (minHeight) {
            this._setTextareaStyle('minHeight', minHeight);
        }
    };
    /**
     * Sets the maximum height of the textarea as determined by maxRows.
     * @return {?}
     */
    XpoTextareaAutosize.prototype._setMaxHeight = function () {
        var /** @type {?} */ maxHeight = this.maxRows && this._cachedLineHeight ?
            this.maxRows * this._cachedLineHeight + "px" : null;
        if (maxHeight) {
            this._setTextareaStyle('maxHeight', maxHeight);
        }
    };
    /**
     * @return {?}
     */
    XpoTextareaAutosize.prototype.ngAfterViewInit = function () {
        this._cacheTextareaLineHeight();
        this.resizeToFitContent();
    };
    /**
     * Sets a style property on the textarea element.
     * @param {?} property
     * @param {?} value
     * @return {?}
     */
    XpoTextareaAutosize.prototype._setTextareaStyle = function (property, value) {
        var /** @type {?} */ textarea = (this._elementRef.nativeElement);
        textarea.style[property] = value;
    };
    /**
     * Cache the height of a single-row textarea.
     *
     * We need to know how large a single "row" of a textarea is in order to apply minRows and
     * maxRows. For the initial version, we will assume that the height of a single line in the
     * textarea does not ever change.
     * @return {?}
     */
    XpoTextareaAutosize.prototype._cacheTextareaLineHeight = function () {
        var /** @type {?} */ textarea = (this._elementRef.nativeElement);
        // Use a clone element because we have to override some styles.
        var /** @type {?} */ textareaClone = (textarea.cloneNode(false));
        textareaClone.rows = 1;
        // Use `position: absolute` so that this doesn't cause a browser layout and use
        // `visibility: hidden` so that nothing is rendered. Clear any other styles that
        // would affect the height.
        textareaClone.style.position = 'absolute';
        textareaClone.style.visibility = 'hidden';
        textareaClone.style.border = 'none';
        textareaClone.style.padding = '0';
        textareaClone.style.height = '';
        textareaClone.style.minHeight = '';
        textareaClone.style.maxHeight = '';
        textarea.parentNode.appendChild(textareaClone);
        this._cachedLineHeight = textareaClone.clientHeight;
        textarea.parentNode.removeChild(textareaClone);
        // Min and max heights have to be re-calculated if the cached line height changes
        this._setMinHeight();
        this._setMaxHeight();
    };
    /**
     * Resize the textarea to fit its content.
     * @return {?}
     */
    XpoTextareaAutosize.prototype.resizeToFitContent = function () {
        var /** @type {?} */ textarea = (this._elementRef.nativeElement);
        // Reset the textarea height to auto in order to shrink back to its default size.
        textarea.style.height = 'auto';
        // Use the scrollHeight to know how large the textarea *would* be if fit its entire value.
        textarea.style.height = textarea.scrollHeight + "px";
    };
    return XpoTextareaAutosize;
}());
XpoTextareaAutosize.decorators = [
    { type: Directive, args: [{
                selector: 'textarea[xpo-autosize], textarea[xpoTextareaAutosize]',
                exportAs: 'xpoTextareaAutosize',
                host: {
                    '(input)': 'resizeToFitContent()',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoTextareaAutosize.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
XpoTextareaAutosize.propDecorators = {
    'minRows': [{ type: Input },],
    'maxRows': [{ type: Input },],
    'xpoAutosizeMinRows': [{ type: Input },],
    'xpoAutosizeMaxRows': [{ type: Input },],
};
var XpoInputModule = (function () {
    function XpoInputModule() {
    }
    return XpoInputModule;
}());
XpoInputModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    PlatformModule,
                    XpoFormModule,
                ],
                exports: [
                    XpoErrorDirective,
                    XpoHint,
                    XpoInputContainer,
                    XpoInputDirective,
                    XpoPlaceholder,
                    XpoPrefix,
                    XpoSuffix,
                    XpoTextareaAutosize,
                ],
                declarations: [
                    XpoErrorDirective,
                    XpoHint,
                    XpoInputContainer,
                    XpoInputDirective,
                    XpoPlaceholder,
                    XpoPrefix,
                    XpoSuffix,
                    XpoTextareaAutosize,
                ],
            },] },
];
/**
 * @nocollapse
 */
XpoInputModule.ctorParameters = function () { return []; };
/**
 * <xpo-card> is a basic content container component that adds the styles of a xpo common design card.
 *
 * While this component can be used alone, it also provides a number
 * of preset styles for common card sections, including:
 * - card-header-title
 * - card-header-subtitle
 * - card-content
 * - card-actions
 * - card-footer
 */
var XpoCard = (function () {
    function XpoCard() {
    }
    Object.defineProperty(XpoCard.prototype, "helper", {
        /**
         * The card helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoCard;
}());
XpoCard.decorators = [
    { type: Component, args: [{ selector: 'xpo-card',
                host: {},
                template: "<span *ngIf=\"helperObj\"> {{ helperObj.value }} </span> <ng-content></ng-content>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12);display:block;background-color:#fff}@media screen and (-ms-high-contrast:active){:host{outline:solid 1px}}:host ::ng-deep card-header{display:flex;align-items:center;flex-shrink:0;height:44px;padding:10px 15px;background-color:#f5f5f5}:host ::ng-deep [card-header-text]{display:flex;align-items:baseline;flex:1}:host ::ng-deep card-header-title,:host ::ng-deep card-header-title h1,:host ::ng-deep card-header-title h2,:host ::ng-deep card-header-title h3{margin:0;font-size:14px;font-weight:700}:host ::ng-deep card-header-subtitle{margin-left:10px}:host ::ng-deep .card-header-actions{display:flex}:host ::ng-deep .card-header-actions button,:host ::ng-deep .card-header-actions button[xpo-btn]{color:#333}:host ::ng-deep .card-header-actions button:hover,:host ::ng-deep .card-header-actions button[xpo-btn]:hover{color:#9e9e9e}:host ::ng-deep .card-header-actions button:last-of-type,:host ::ng-deep .card-header-actions button[xpo-btn]:last-of-type{min-width:initial;padding-right:0}:host ::ng-deep .card-header-actions button:last-of-type xpo-icon[class*=xico-],:host ::ng-deep .card-header-actions button[xpo-btn]:last-of-type xpo-icon[class*=xico-]{margin:0}:host ::ng-deep .card-header-actions button:focus,:host ::ng-deep .card-header-actions button[xpo-btn]:focus{outline:0}:host ::ng-deep card-content{display:block;background:#fff}:host ::ng-deep card-actions{display:flex;align-items:center;justify-content:flex-end}:host ::ng-deep card-actions>button{margin-left:10px}:host-context(.xpo-internal)[card-not-found] ::ng-deep .card-content{padding-top:20px;padding-bottom:20px}:host-context(.xpo-internal)[card-dialog]{border:1px solid #eee;box-shadow:unset}:host-context(.xpo-internal) ::ng-deep card-actions,:host-context(.xpo-internal) ::ng-deep card-content,:host-context(.xpo-internal) ::ng-deep card-header{padding-right:15px;padding-left:15px}:host-context(.xpo-internal) ::ng-deep card-content{padding:30px 15px}:host-context(.xpo-internal) ::ng-deep card-content[no-padding]{padding:0}:host-context(.xpo-internal) ::ng-deep card-actions{min-height:44px;padding-top:10px;padding-bottom:10px;border-top:1px solid #dfdfdf}:host-context(.xpo-external)[card-dialog]{border:1px solid #dfdfdf;box-shadow:unset}:host-context(.xpo-external)[card-dialog] ::ng-deep card-header{border-bottom:1px solid #dfdfdf}:host-context(.xpo-external) ::ng-deep card-actions,:host-context(.xpo-external) ::ng-deep card-content,:host-context(.xpo-external) ::ng-deep card-header{padding-right:15px;padding-left:15px}@media (min-width:600px) and (max-width:1024px){:host-context(.xpo-external) ::ng-deep card-actions,:host-context(.xpo-external) ::ng-deep card-content,:host-context(.xpo-external) ::ng-deep card-header{padding-right:30px;padding-left:30px}}:host-context(.xpo-external) ::ng-deep card-content{padding-top:20px;padding-bottom:20px}:host-context(.xpo-external) ::ng-deep card-content[no-padding]{padding:0}:host-context(.xpo-external) ::ng-deep card-actions{min-height:54px;padding-top:10px;padding-bottom:10px;border-top:1px solid #dfdfdf}@media (min-width:600px) and (max-width:1024px){:host-context(.xpo-external) ::ng-deep card-actions{padding-top:20px;padding-bottom:20px}} /*# sourceMappingURL=card.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoCard.ctorParameters = function () { return []; };
XpoCard.propDecorators = {
    'helper': [{ type: Input },],
};
/**
 * XPO-COMMON Card Module
 */
var XpoCardHeader = (function () {
    function XpoCardHeader() {
    }
    Object.defineProperty(XpoCardHeader.prototype, "helper", {
        /**
         * The card header helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoCardHeader;
}());
XpoCardHeader.decorators = [
    { type: Component, args: [{ selector: 'card-header',
                template: "<ng-content select=\"[card-avatar]\"></ng-content> <div card-header-text> <ng-content select=\"card-header-title, card-header-subtitle\"></ng-content> </div> <ng-content></ng-content>",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoCardHeader.ctorParameters = function () { return []; };
XpoCardHeader.propDecorators = {
    'helper': [{ type: Input },],
};
/**
 * XPO-COMMON Card Module
 */
var XpoCardTitleGroup = (function () {
    function XpoCardTitleGroup() {
    }
    Object.defineProperty(XpoCardTitleGroup.prototype, "helper", {
        /**
         * The card title group helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoCardTitleGroup;
}());
XpoCardTitleGroup.decorators = [
    { type: Component, args: [{ selector: 'card-title-group',
                host: {
                    '[class.card-title-group]': 'true',
                },
                template: "<div> <ng-content select=\"card-header-title, card-header-subtitle\"></ng-content> </div> <ng-content select=\"img\"></ng-content> <ng-content></ng-content>",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoCardTitleGroup.ctorParameters = function () { return []; };
XpoCardTitleGroup.propDecorators = {
    'helper': [{ type: Input },],
};
/**
 * Action section of a card, needed as it's used as a selector in the API.
 */
var CardActionsDirective = (function () {
    function CardActionsDirective() {
    }
    return CardActionsDirective;
}());
CardActionsDirective.decorators = [
    { type: Directive, args: [{
                selector: 'card-actions',
                host: {
                    '[class.card-actions]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardActionsDirective.ctorParameters = function () { return []; };
/**
 * Avatar image used in a card, needed to add the xpo- CSS styling.
 */
var CardAvatarDirective = (function () {
    function CardAvatarDirective() {
    }
    return CardAvatarDirective;
}());
CardAvatarDirective.decorators = [
    { type: Directive, args: [{
                selector: 'card-avatar',
                host: {
                    '[class.card-avatar]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardAvatarDirective.ctorParameters = function () { return []; };
/**
 * Content of a card, needed as it's used as a selector in the API.
 */
var CardContentDirective = (function () {
    function CardContentDirective() {
    }
    return CardContentDirective;
}());
CardContentDirective.decorators = [
    { type: Directive, args: [{
                selector: 'card-content',
                host: {
                    '[class.card-content]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardContentDirective.ctorParameters = function () { return []; };
/**
 * Footer of a card, needed as it's used as a selector in the API.
 */
var CardFooterDirective = (function () {
    function CardFooterDirective() {
    }
    return CardFooterDirective;
}());
CardFooterDirective.decorators = [
    { type: Directive, args: [{
                selector: 'card-footer',
                host: {
                    '[class.card-footer]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardFooterDirective.ctorParameters = function () { return []; };
/**
 * Image used in a card, needed to add the xpo- CSS styling.
 */
var CardImageDirective = (function () {
    function CardImageDirective() {
    }
    return CardImageDirective;
}());
CardImageDirective.decorators = [
    { type: Directive, args: [{
                selector: '[card-image]',
                host: {
                    '[class.card-image]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardImageDirective.ctorParameters = function () { return []; };
/**
 * Image used in a card, needed to add the xpo- CSS styling.
 */
var CardLgImageDirective = (function () {
    function CardLgImageDirective() {
    }
    return CardLgImageDirective;
}());
CardLgImageDirective.decorators = [
    { type: Directive, args: [{
                selector: '[card-lg-image]',
                host: {
                    'class.card-lg-image': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardLgImageDirective.ctorParameters = function () { return []; };
/**
 * Image used in a card, needed to add the xpo- CSS styling.
 */
var CardXpoImageDirective = (function () {
    function CardXpoImageDirective() {
    }
    return CardXpoImageDirective;
}());
CardXpoImageDirective.decorators = [
    { type: Directive, args: [{
                selector: '[card-xpo-image]',
                host: {
                    '[class.card-xpo-image]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardXpoImageDirective.ctorParameters = function () { return []; };
/**
 * Image used in a card, needed to add the xpo- CSS styling.
 */
var CardSmImageDirective = (function () {
    function CardSmImageDirective() {
    }
    return CardSmImageDirective;
}());
CardSmImageDirective.decorators = [
    { type: Directive, args: [{
                selector: '[card-sm-image]',
                host: {
                    '[class.cardsm-image]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardSmImageDirective.ctorParameters = function () { return []; };
/**
 * Sub-title of a card, needed as it's used as a selector in the API.
 */
var CardHeaderSubtitleDirective = (function () {
    function CardHeaderSubtitleDirective() {
    }
    return CardHeaderSubtitleDirective;
}());
CardHeaderSubtitleDirective.decorators = [
    { type: Directive, args: [{
                selector: 'card-header-subtitle',
                host: {
                    '[class.card-header-subtitle]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardHeaderSubtitleDirective.ctorParameters = function () { return []; };
/**
 * XPO-COMMON Card Module
 */
var CardHeaderTitleDirective = (function () {
    function CardHeaderTitleDirective() {
    }
    return CardHeaderTitleDirective;
}());
CardHeaderTitleDirective.decorators = [
    { type: Directive, args: [{
                selector: 'card-header-title',
                host: {
                    '[class.card-header-title]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardHeaderTitleDirective.ctorParameters = function () { return []; };
/**
 * Large image used in a card, needed to add the xpo- CSS styling.
 */
var CardXlImageDirective = (function () {
    function CardXlImageDirective() {
    }
    return CardXlImageDirective;
}());
CardXlImageDirective.decorators = [
    { type: Directive, args: [{
                selector: 'card-xl-image',
                host: {
                    '[class.card-xl-image]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardXlImageDirective.ctorParameters = function () { return []; };
/**
 * Action section of a card, needed as it's used as a selector in the API.
 */
var CardHeaderActionsDirective = (function () {
    function CardHeaderActionsDirective() {
    }
    return CardHeaderActionsDirective;
}());
CardHeaderActionsDirective.decorators = [
    { type: Directive, args: [{
                selector: 'card-header-actions',
                host: {
                    '[class.card-header-actions]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
CardHeaderActionsDirective.ctorParameters = function () { return []; };
var XpoCardModule = (function () {
    function XpoCardModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoCardModule.forRoot = function () {
        return {
            ngModule: XpoCardModule,
        };
    };
    return XpoCardModule;
}());
XpoCardModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [
                    XpoCard,
                    XpoCardHeader,
                    XpoCardTitleGroup,
                    CardContentDirective,
                    CardHeaderTitleDirective,
                    CardHeaderSubtitleDirective,
                    CardActionsDirective,
                    CardHeaderActionsDirective,
                    CardFooterDirective,
                    CardSmImageDirective,
                    CardXpoImageDirective,
                    CardLgImageDirective,
                    CardImageDirective,
                    CardXlImageDirective,
                    CardAvatarDirective,
                ],
                declarations: [
                    XpoCard,
                    XpoCardHeader,
                    XpoCardTitleGroup,
                    CardContentDirective,
                    CardHeaderTitleDirective,
                    CardHeaderSubtitleDirective,
                    CardActionsDirective,
                    CardHeaderActionsDirective,
                    CardFooterDirective,
                    CardSmImageDirective,
                    CardXpoImageDirective,
                    CardLgImageDirective,
                    CardImageDirective,
                    CardXlImageDirective,
                    CardAvatarDirective,
                ],
            },] },
];
/**
 * @nocollapse
 */
XpoCardModule.ctorParameters = function () { return []; };
var nextId$1 = 0;
/**
 * Provider Expression that allows xpo-checkbox to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)].
 * \@docs-private
 */
var XPO_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return XpoCheckBox; }),
    multi: true,
};
var TransitionCheckState = {};
TransitionCheckState.Init = 0;
TransitionCheckState.Checked = 1;
TransitionCheckState.Unchecked = 2;
TransitionCheckState[TransitionCheckState.Init] = "Init";
TransitionCheckState[TransitionCheckState.Checked] = "Checked";
TransitionCheckState[TransitionCheckState.Unchecked] = "Unchecked";
/**
 * Change event object emitted by XpoCheckbox.
 */
var XpoCheckboxChange = (function () {
    function XpoCheckboxChange() {
    }
    return XpoCheckboxChange;
}());
/**
 * <xpo-checkbox> component displays a checkbox form input.
 */
var XpoCheckBox = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _changeDetectorRef
     */
    function XpoCheckBox(_renderer, _elementRef, _changeDetectorRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._disabled = false;
        this._currentAnimationClass = '';
        this._currentCheckState = TransitionCheckState.Init;
        this._checked = false;
        this._hasFocus = false;
        /**
         * Attached to the aria-label attribute of the host element. In most cases, arial-labelledby will
         * take precedence so this may be omitted.
         */
        this.ariaLabel = '';
        /**
         * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
         */
        this.ariaLabelledby = null;
        /**
         * A unique id for the checkbox. If one is not supplied, it is auto-generated.
         */
        this.id = "xpo-checkbox-" + ++nextId$1;
        /**
         * \@docs-private
         */
        this.tabindex = 0;
        /**
         * Name value will be applied to the input element if present
         */
        this.name = null;
        /**
         * Event emitted when the checkbox's `checked` value changes.
         */
        this.change = new EventEmitter();
        /**
         * Called when the checkbox is blurred. Needed to properly implement ControlValueAccessor.
         * \@docs-private
         */
        this.onTouched = function () { };
        this._controlValueAccessorChangeFn = function (value) { };
    }
    Object.defineProperty(XpoCheckBox.prototype, "inputId", {
        /**
         * ID of the native input element inside `<xpo-checkbox>`
         * @return {?}
         */
        get: function () {
            return "input-" + this.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoCheckBox.prototype, "required", {
        /**
         * Whether the checkbox is required.
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._required = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoCheckBox.prototype, "disabled", {
        /**
         * Whether the checkbox is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoCheckBox.prototype, "checked", {
        /**
         * Whether the checkbox is checked.
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        /**
         * @param {?} checked
         * @return {?}
         */
        set: function (checked) {
            if (checked != this.checked) {
                this._checked = checked;
                this._transitionCheckState(this._checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
                this._changeDetectorRef.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param {?} value Value to be set to the model.
     * @return {?}
     */
    XpoCheckBox.prototype.writeValue = function (value) {
        this.checked = !!value;
    };
    /**
     * Registers a callback to be triggered when the value has changed.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Function to be called on change.
     * @return {?}
     */
    XpoCheckBox.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * Registers a callback to be triggered when the control has been touched.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be triggered when the checkbox is touched.
     * @return {?}
     */
    XpoCheckBox.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Sets the checkbox's disabled state. Implemented as a part of ControlValueAccessor.
     * @param {?} isDisabled Whether the checkbox should be disabled.
     * @return {?}
     */
    XpoCheckBox.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * @param {?} newState
     * @return {?}
     */
    XpoCheckBox.prototype._transitionCheckState = function (newState) {
        var /** @type {?} */ oldState = this._currentCheckState;
        if (oldState === newState) {
            return;
        }
        this._currentCheckState = newState;
    };
    /**
     * @return {?}
     */
    XpoCheckBox.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new XpoCheckboxChange();
        event.source = this;
        event.checked = this.checked;
        this._controlValueAccessorChangeFn(this.checked);
        this.change.emit(event);
    };
    /**
     * Informs the component when the input has focus so that we can style accordingly
     * @return {?}
     */
    XpoCheckBox.prototype._onInputFocus = function () {
        this._hasFocus = true;
    };
    /**
     * Informs the component when we lose focus in order to style accordingly
     * @return {?}
     */
    XpoCheckBox.prototype._onInputBlur = function () {
        this._hasFocus = false;
        this.onTouched();
    };
    /**
     * Toggles the `checked` state of the checkbox.
     * @return {?}
     */
    XpoCheckBox.prototype.toggle = function () {
        this.checked = !this.checked;
    };
    /**
     * Event handler for checkbox input element.
     * Toggles checked state if element is not disabled.
     * @param {?} event
     * @return {?}
     */
    XpoCheckBox.prototype._onInteractionEvent = function (event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the `change` output.
        event.stopPropagation();
        if (!this.disabled) {
            this.toggle();
            // Emit our custom change event if the native input emitted one.
            // It is important to only emit it, if the native input triggered one, because
            // we don't want to trigger a change event, when the `checked` variable changes for example.
            this._emitChangeEvent();
        }
    };
    /**
     * Focuses the checkbox.
     * @return {?}
     */
    XpoCheckBox.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._inputElement.nativeElement, 'focus');
        this._onInputFocus();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoCheckBox.prototype._onInputClick = function (event) {
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `checkbox` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
    };
    /**
     * @return {?}
     */
    XpoCheckBox.prototype._getHostElement = function () {
        return this._elementRef.nativeElement;
    };
    return XpoCheckBox;
}());
XpoCheckBox.decorators = [
    { type: Component, args: [{ selector: 'xpo-checkbox',
                host: {
                    '[class.xpo-checkbox--checked]': 'checked',
                    '[class.xpo-checkbox--disabled]': 'disabled',
                    '[class.xpo-checkbox--focused]': '_hasFocus',
                    '[class.xpo-checkbox__label--left]': 'labelPosition == "left"',
                    '[class.xpo-checkbox__label--right]': 'labelPosition == "right"',
                },
                providers: [XPO_CHECKBOX_CONTROL_VALUE_ACCESSOR],
                template: "<label class=\"xpo-checkbox__wrapper\"> <span class=\"xpo-checkbox__label-text\"> <ng-content></ng-content> </span> <div class=\"xpo-checkbox__inner\"> <input #input class=\"xpo-checkbox__input\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [checked]=\"checked\" [value]=\"value\" [disabled]=\"disabled\" [name]=\"name\" [tabIndex]=\"tabindex\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (focus)=\"_onInputFocus()\" (blur)=\"_onInputBlur()\" (change)=\"_onInteractionEvent($event)\" (click)=\"_onInputClick($event)\"> <!-- span styles display the checkbox: --> <span></span> </div> </label>",
                styles: ["@charset \"UTF-8\";@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex}:host .xpo-checkbox__wrapper{display:flex;flex-basis:100%}:host .xpo-checkbox__inner{display:block;width:17px;height:17px;position:relative;background:#fff}:host .xpo-checkbox__inner input{width:17px;height:17px;position:relative;outline:0;cursor:pointer;border:0;background-color:transparent;z-index:1;-webkit-appearance:none;-moz-appearance:none}:host .xpo-checkbox__inner input:hover+span{border:1px solid #858585}:host .xpo-checkbox__inner input:focus+span{box-shadow:0 0 2px 1px #80d8ff}:host .xpo-checkbox__inner input:checked+span{border-color:#000}:host .xpo-checkbox__inner input:checked+span::before{content:\"\";font-family:XPOicon;font-size:12px;line-height:14px}:host .xpo-checkbox__inner input:disabled{cursor:not-allowed}:host .xpo-checkbox__inner input:disabled+span{border:1px solid #dfdfdf}:host .xpo-checkbox__inner span{display:block;width:17px;height:17px;padding-left:1px;position:absolute;top:0;left:0;cursor:pointer;border:1px solid #bdbdbd;background:#fff}:host .xpo-checkbox__label-text{flex:1;cursor:pointer}:host.xpo-checkbox__label--right .xpo-checkbox__label-text{order:1}:host-context(.xpo-internal) .xpo-checkbox__label-text{margin-right:10px;margin-left:0}:host-context(.xpo-internal).xpo-checkbox__label--right .xpo-checkbox__label-text{margin-right:0;margin-left:10px}:host-context(.xpo-external) .xpo-checkbox__label-text{align-self:center;font-size:1rem;margin-right:15px;margin-left:0}:host-context(.xpo-external).xpo-checkbox__label--right .xpo-checkbox__label-text{margin-right:0;margin-left:15px}:host-context(.xpo-external) .xpo-checkbox__inner{width:24px;height:24px}:host-context(.xpo-external) .xpo-checkbox__inner span{width:24px;height:24px;padding:3px 0 0 4px}:host-context(.xpo-external) .xpo-checkbox__inner input{width:24px;height:24px}:host-context(.xpo-external) .xpo-checkbox__inner input:checked+span::before{font-size:14px;line-height:16px} /*# sourceMappingURL=checkbox.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoCheckBox.ctorParameters = function () { return [
    { type: Renderer, },
    { type: ElementRef, },
    { type: ChangeDetectorRef, },
]; };
XpoCheckBox.propDecorators = {
    '_inputElement': [{ type: ViewChild, args: ['input',] },],
    'ariaLabel': [{ type: Input, args: ['aria-label',] },],
    'ariaLabelledby': [{ type: Input, args: ['aria-labelledby',] },],
    'id': [{ type: Input },],
    'required': [{ type: Input },],
    'labelPosition': [{ type: Input },],
    'disabled': [{ type: Input },],
    'tabindex': [{ type: Input },],
    'name': [{ type: Input },],
    'change': [{ type: Output },],
    'value': [{ type: Input },],
    'checked': [{ type: Input },],
};
var XpoCheckboxGroup = (function () {
    function XpoCheckboxGroup() {
        this.checkboxLayout = 'vertical';
    }
    return XpoCheckboxGroup;
}());
XpoCheckboxGroup.decorators = [
    { type: Component, args: [{ selector: 'xpo-checkbox-group',
                template: "<xpo-form-group class=\"xpo-fieldset\" [labelPosition]=\"labelPosition\"> <div class=\"input-wrapper checkbox-layout--{{checkboxLayout}}\"> <ng-content></ng-content> </div> <div *ngIf=\"label\" class=\"xpo-legend\">{{ label }}</div> </xpo-form-group> ",
                styles: [":host .checkbox-layout--vertical{display:flex;flex-direction:column}:host .checkbox-layout--vertical ::ng-deep xpo-checkbox{margin-top:15px}:host .checkbox-layout--vertical ::ng-deep xpo-checkbox:first-of-type{margin-top:0}:host .checkbox-layout--horizontal{display:flex}:host .checkbox-layout--horizontal ::ng-deep xpo-checkbox{margin-left:15px}:host .checkbox-layout--horizontal ::ng-deep xpo-checkbox:first-of-type{margin-left:0} /*# sourceMappingURL=checkbox-group.css.map */ "],
            },] },
];
/**
 * @nocollapse
 */
XpoCheckboxGroup.ctorParameters = function () { return []; };
XpoCheckboxGroup.propDecorators = {
    'label': [{ type: Input },],
    'labelPosition': [{ type: Input },],
    'checkboxLayout': [{ type: Input },],
};
var XpoCheckBoxModule = (function () {
    function XpoCheckBoxModule() {
    }
    return XpoCheckBoxModule;
}());
XpoCheckBoxModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, XpoFormModule],
                exports: [XpoCheckBox, XpoCheckboxGroup],
                declarations: [XpoCheckBox, XpoCheckboxGroup],
            },] },
];
/**
 * @nocollapse
 */
XpoCheckBoxModule.ctorParameters = function () { return []; };
/**
 * <xpo-chip> component displays a styled Chip. Used inside the XpoChipList component.
 */
var XpoChip = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function XpoChip(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * Whether or not the chip is disabled. Disabled chips cannot be focused.
         */
        this._disabled = null;
        /**
         * Whether or not the chip is selected.
         */
        this._selected = false;
        /**
         * The palette color of selected chips.
         */
        this._color = 'primary';
        /**
         * Emitted when the chip is focused.
         */
        this.onFocus = new EventEmitter();
        /**
         * Emitted when the chip is selected.
         */
        this.select = new EventEmitter();
        /**
         * Emitted when the chip is deselected.
         */
        this.deselect = new EventEmitter();
        /**
         * Emitted when the chip is destroyed.
         */
        this.destroy = new EventEmitter();
    }
    /**
     * @return {?}
     */
    XpoChip.prototype.ngOnInit = function () {
        this._addDefaultCSSClass();
        this._updateColor(this._color);
    };
    /**
     * @return {?}
     */
    XpoChip.prototype.ngOnDestroy = function () {
        this.destroy.emit({ chip: this });
    };
    Object.defineProperty(XpoChip.prototype, "disabled", {
        /**
         * Whether or not the chip is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * Sets the disabled state of the chip.
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoChip.prototype, "_isAriaDisabled", {
        /**
         * A String representation of the current disabled state.
         * @return {?}
         */
        get: function () {
            return String(coerceBooleanProperty(this.disabled));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoChip.prototype, "selected", {
        /**
         * Whether or not this chip is selected.
         * @return {?}
         */
        get: function () {
            return this._selected;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selected = coerceBooleanProperty(value);
            if (this._selected) {
                this.select.emit({ chip: this });
            }
            else {
                this.deselect.emit({ chip: this });
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggles the current selected state of this chip.
     * @return {?} Whether the chip is selected.
     */
    XpoChip.prototype.toggleSelected = function () {
        this.selected = !this.selected;
        return this.selected;
    };
    Object.defineProperty(XpoChip.prototype, "color", {
        /**
         * The color of the chip. Can be `primary`, `accent`, or `warn`.
         * @return {?}
         */
        get: function () {
            return this._color;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateColor(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Allows for programmatic focusing of the chip.
     * @return {?}
     */
    XpoChip.prototype.focus = function () {
        this._elementRef.nativeElement.focus();
        this.onFocus.emit({ chip: this });
    };
    /**
     * Ensures events fire properly upon click.
     * @param {?} event
     * @return {?}
     */
    XpoChip.prototype._handleClick = function (event) {
        // Check disabled
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            this.focus();
        }
    };
    /**
     * Initializes the appropriate CSS classes based on the chip type (basic or standard).
     * @return {?}
     */
    XpoChip.prototype._addDefaultCSSClass = function () {
        var /** @type {?} */ el = this._elementRef.nativeElement;
        // Always add the `xpo-chip` class
        this._renderer.addClass(el, 'xpo-chip');
        // If we are a basic chip, also add the `xpo-basic-chip` class for :not() targeting
        if (el.nodeName.toLowerCase() == 'xpo-basic-chip' || el.hasAttribute('xpo-basic-chip') ||
            el.nodeName.toLowerCase() == 'xpo-basic-chip' || el.hasAttribute('xpo-basic-chip')) {
            this._renderer.addClass(el, 'xpo-basic-chip');
        }
    };
    /**
     * Updates the private _color variable and the native element.
     * @param {?} newColor
     * @return {?}
     */
    XpoChip.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * Sets the xpo-color on the native element.
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    XpoChip.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            if (isAdd) {
                this._renderer.addClass(this._elementRef.nativeElement, "xpo-" + color);
            }
            else {
                this._renderer.removeClass(this._elementRef.nativeElement, "xpo-" + color);
            }
        }
    };
    return XpoChip;
}());
XpoChip.decorators = [
    { type: Component, args: [{
                selector: "xpo-basic-chip, [xpo-basic-chip], xpo-chip, [xpo-chip]",
                template: "<ng-content></ng-content>",
                host: {
                    '[class.xpo-chip]': 'false',
                    'tabindex': '-1',
                    'role': 'option',
                    '[class.xpo-chip-selected]': 'selected',
                    '[attr.disabled]': 'disabled',
                    '[attr.aria-disabled]': '_isAriaDisabled',
                    '(click)': '_handleClick($event)',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoChip.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: ElementRef, },
]; };
XpoChip.propDecorators = {
    'select': [{ type: Output },],
    'deselect': [{ type: Output },],
    'destroy': [{ type: Output },],
    'disabled': [{ type: Input },],
    'selected': [{ type: Input },],
    'color': [{ type: Input },],
};
/* tslint:disable */
var FocusKeyManager = (function (_super) {
    __extends(FocusKeyManager, _super);
    /**
     * @param {?} items
     */
    function FocusKeyManager(items) {
        return _super.call(this, items) || this;
    }
    /**
     * This method sets the active item to the item at the specified index.
     * It also adds focuses the newly active item.
     * @param {?} index
     * @return {?}
     */
    FocusKeyManager.prototype.setActiveItem = function (index) {
        _super.prototype.setActiveItem.call(this, index);
        if (this.activeItem) {
            this.activeItem.focus();
        }
    };
    return FocusKeyManager;
}(ListKeyManager));
/**
 * <xpo-chip-list> component (named ChipList for it's similarity to the List component) is a container for <xpo-chip> items.
 *
 * Example:
 *
 *     <xpo-chip-list>
 *       <xpo-chip>Chip 1<xpo-chip>
 *       <xpo-chip>Chip 2<xpo-chip>
 *     </xpo-chip-list>
 */
var XpoChipList = (function () {
    /**
     * @param {?} _elementRef
     */
    function XpoChipList(_elementRef) {
        this._elementRef = _elementRef;
        /**
         * Track which chips we're listening to for focus/destruction.
         */
        this._subscribed = new WeakMap();
        /**
         * Whether or not the chip is selectable.
         */
        this._selectable = true;
    }
    /**
     * @return {?}
     */
    XpoChipList.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._keyManager = new FocusKeyManager(this.chips).withWrap();
        // Go ahead and subscribe all of the initial chips
        this._subscribeChips(this.chips);
        // When the list changes, re-subscribe
        this.chips.changes.subscribe(function (chips) {
            _this._subscribeChips(chips);
        });
    };
    Object.defineProperty(XpoChipList.prototype, "selectable", {
        /**
         * Whether or not this chip is selectable. When a chip is not selectable,
         * it's selected state is always ignored.
         * @return {?}
         */
        get: function () {
            return this._selectable;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selectable = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Programmatically focus the chip list. This in turn focuses the first
     * non-disabled chip in this chip list.
     * @return {?}
     */
    XpoChipList.prototype.focus = function () {
        // TODO: ARIA says this should focus the first `selected` chip.
        this._keyManager.setFirstItemActive();
    };
    /**
     * Passes relevant key presses to our key manager.
     * @param {?} event
     * @return {?}
     */
    XpoChipList.prototype._keydown = function (event) {
        var /** @type {?} */ target = (event.target);
        // If they are on a chip, check for space/left/right, otherwise pass to our key manager
        if (target && target.classList.contains('xpo-chip')) {
            switch (event.keyCode) {
                case SPACE:
                    // If we are selectable, toggle the focused chip
                    if (this.selectable) {
                        this._toggleSelectOnFocusedChip();
                    }
                    // Always prevent space from scrolling the page since the list has focus
                    event.preventDefault();
                    break;
                case LEFT_ARROW:
                    this._keyManager.setPreviousItemActive();
                    event.preventDefault();
                    break;
                case RIGHT_ARROW:
                    this._keyManager.setNextItemActive();
                    event.preventDefault();
                    break;
                default:
                    this._keyManager.onKeydown(event);
            }
        }
    };
    /**
     * Toggles the selected state of the currently focused chip.
     * @return {?}
     */
    XpoChipList.prototype._toggleSelectOnFocusedChip = function () {
        // Allow disabling of chip selection
        if (!this.selectable) {
            return;
        }
        var /** @type {?} */ focusedIndex = this._keyManager.activeItemIndex;
        if (this._isValidIndex(focusedIndex)) {
            var /** @type {?} */ focusedChip = this.chips.toArray()[focusedIndex];
            if (focusedChip) {
                focusedChip.toggleSelected();
            }
        }
    };
    /**
     * Iterate through the list of chips and add them to our list of
     * subscribed chips.
     *
     * @param {?} chips The list of chips to be subscribed.
     * @return {?}
     */
    XpoChipList.prototype._subscribeChips = function (chips) {
        var _this = this;
        chips.forEach(function (chip) { return _this._addChip(chip); });
    };
    /**
     * Add a specific chip to our subscribed list. If the chip has
     * already been subscribed, this ensures it is only subscribed
     * once.
     *
     * @param {?} chip The chip to be subscribed (or checked for existing
     * subscription).
     * @return {?}
     */
    XpoChipList.prototype._addChip = function (chip) {
        var _this = this;
        // If we've already been subscribed to a parent, do nothing
        if (this._subscribed.has(chip)) {
            return;
        }
        // Watch for focus events outside of the keyboard navigation
        chip.onFocus.subscribe(function () {
            var /** @type {?} */ chipIndex = _this.chips.toArray().indexOf(chip);
            if (_this._isValidIndex(chipIndex)) {
                _this._keyManager.updateActiveItemIndex(chipIndex);
            }
        });
        // On destroy, remove the item from our list, and check focus
        chip.destroy.subscribe(function () {
            var /** @type {?} */ chipIndex = _this.chips.toArray().indexOf(chip);
            if (_this._isValidIndex(chipIndex)) {
                // Check whether the chip is the last item
                if (chipIndex < _this.chips.length - 1) {
                    _this._keyManager.setActiveItem(chipIndex);
                }
                else if (chipIndex - 1 >= 0) {
                    _this._keyManager.setActiveItem(chipIndex - 1);
                }
            }
            _this._subscribed.delete(chip);
            chip.destroy.unsubscribe();
        });
        this._subscribed.set(chip, true);
    };
    /**
     * Utility to ensure all indexes are valid.
     *
     * @param {?} index The index to be checked.
     * @return {?} True if the index is valid for our list of chips.
     */
    XpoChipList.prototype._isValidIndex = function (index) {
        return index >= 0 && index < this.chips.length;
    };
    return XpoChipList;
}());
XpoChipList.decorators = [
    { type: Component, args: [{ selector: 'xpo-chip-list',
                template: "<div class=\"xpo-chip-list-wrapper\"><ng-content></ng-content></div>",
                host: {
                    // Properties
                    'tabindex': '0',
                    'role': 'listbox',
                    '[class.xpo-chip-list]': 'true',
                    // Events
                    '(focus)': 'focus()',
                    '(keydown)': '_keydown($event)',
                },
                queries: {
                    chips: new ContentChildren(XpoChip),
                },
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}xpo-chip-list{display:flex;flex-basis:100%}xpo-chip-list .xpo-chip-list-wrapper{display:flex;flex-basis:100%}xpo-chip-list xpo-chip{display:flex;flex-basis:100%;height:2.5em;margin-right:1em;margin-bottom:.5em;padding-top:.4em;padding-right:1em;padding-left:1em;color:#fff;text-align:center;border-radius:500px;background:#8b8b8b}xpo-chip-list [ng-reflect-color=none]{background:#8b8b8b}xpo-chip-list [ng-reflect-color=primary]{background:#00c3d7}xpo-chip-list [ng-reflect-color=accent]{color:#000;background:#ffdc5c}xpo-chip-list [ng-reflect-color=warm]{background:#ff4c45}.chip-horizontal .xpo-chip-list-wrapper{flex-direction:row}.chip-vertical .xpo-chip-list-wrapper{flex-direction:column} /*# sourceMappingURL=chips.css.map */ "],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoChipList.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
XpoChipList.propDecorators = {
    'selectable': [{ type: Input },],
};
var XpoChipsModule = (function () {
    function XpoChipsModule() {
    }
    return XpoChipsModule;
}());
XpoChipsModule.decorators = [
    { type: NgModule, args: [{
                imports: [],
                exports: [XpoChipList, XpoChip],
                declarations: [XpoChipList, XpoChip],
            },] },
];
/**
 * @nocollapse
 */
XpoChipsModule.ctorParameters = function () { return []; };
/**
 * <xpo-confirm-dialog> component displays a confirmation dialog, prompting a user to confirm their action.
 */
var XpoConfirmDialog = (function () {
    function XpoConfirmDialog() {
    }
    Object.defineProperty(XpoConfirmDialog.prototype, "helper", {
        /**
         * The dialog helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoConfirmDialog;
}());
XpoConfirmDialog.decorators = [
    { type: Component, args: [{ selector: 'xpo-confirm-dialog',
                host: {},
                template: "<span *ngIf=\"helperObj\"> {{ helperObj.value }} </span> <ng-content></ng-content>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0} /*# sourceMappingURL=confirm-dialog.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoConfirmDialog.ctorParameters = function () { return []; };
XpoConfirmDialog.propDecorators = {
    'helper': [{ type: Input },],
};
var XpoConfirmDialogModule = (function () {
    function XpoConfirmDialogModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoConfirmDialogModule.forRoot = function () {
        return {
            ngModule: XpoConfirmDialogModule,
        };
    };
    return XpoConfirmDialogModule;
}());
XpoConfirmDialogModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoConfirmDialog],
                declarations: [XpoConfirmDialog],
            },] },
];
/**
 * @nocollapse
 */
XpoConfirmDialogModule.ctorParameters = function () { return []; };
/**
 * <xpo-content> component is a content segment allowing us to orgnaize text content on a page and dictate the formatting of that text.
 */
var XpoContent = (function () {
    function XpoContent() {
    }
    Object.defineProperty(XpoContent.prototype, "helper", {
        /**
         * The badge helper.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XpoContent;
}());
XpoContent.decorators = [
    { type: Component, args: [{ selector: 'xpo-content',
                host: {},
                template: "<div> <span *ngIf=\"helperObj\"> {{ helperObj.value }} </span> <ng-content></ng-content> </div>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0} /*# sourceMappingURL=content.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoContent.ctorParameters = function () { return []; };
XpoContent.propDecorators = {
    'helper': [{ type: Input },],
};
var XpoContentModule = (function () {
    function XpoContentModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoContentModule.forRoot = function () {
        return {
            ngModule: XpoContentModule,
        };
    };
    return XpoContentModule;
}());
XpoContentModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoContent],
                declarations: [XpoContent],
            },] },
];
/**
 * @nocollapse
 */
XpoContentModule.ctorParameters = function () { return []; };
/**
 * Extends an object with the *enumerable* and *own* properties of one or more source objects,
 * similar to Object.assign.
 *
 * @param {?} dest The object which will have properties copied to it.
 * @param {...?} sources The source objects from which properties will be copied.
 * @return {?}
 */
function extendObject(dest) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (dest == null) {
        throw TypeError('Cannot convert undefined or null to object');
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        if (source != null) {
            for (var /** @type {?} */ key in source) {
                if (source.hasOwnProperty(key)) {
                    dest[key] = source[key];
                }
            }
        }
    }
    return dest;
}
/**
 * Configuration for opening a modal dialog with the XpoDialog service.
 */
var XpoDialogConfig = (function () {
    function XpoDialogConfig() {
        /**
         * The ARIA role of the dialog element.
         */
        this.role = 'dialog';
        /**
         * Custom class for the overlay pane.
         */
        this.panelClass = '';
        /**
         * Whether the dialog has a backdrop.
         */
        this.hasBackdrop = true;
        /**
         * Custom class for the backdrop,
         */
        this.backdropClass = '';
        /**
         * Whether the user can use escape or clicking outside to close a modal.
         */
        this.disableClose = false;
        /**
         * Width of the dialog.
         */
        this.width = '';
        /**
         * Height of the dialog.
         */
        this.height = '';
        /**
         * Data being injected into the child component.
         */
        this.data = null;
        /**
         * Layout direction for the dialog's content.
         */
        this.direction = 'ltr';
        /**
         * ID of the element that describes the dialog.
         */
        this.ariaDescribedBy = null;
        // TODO(jelbourn): add configuration for lifecycle hooks, ARIA labelling.
    }
    return XpoDialogConfig;
}());
/**
 * Throws an exception for the case when a ComponentPortal is
 * attached to a DomPortalHost without an origin.
 * \@docs-private
 * @return {?}
 */
function throwXpoDialogContentAlreadyAttachedError() {
    throw new Error('Attempting to attach dialog content after content is already attached');
}
/**
 * Internal component that wraps user-provided dialog content.
 * Animation is based on https://material.io/guidelines/motion/choreography.html.
 * \@docs-private
 */
var XpoDialogContainer = (function (_super) {
    __extends(XpoDialogContainer, _super);
    /**
     * @param {?} _ngZone
     * @param {?} _elementRef
     * @param {?} _focusTrapFactory
     * @param {?} _document
     */
    function XpoDialogContainer(_ngZone, _elementRef, _focusTrapFactory, _document) {
        var _this = _super.call(this) || this;
        _this._ngZone = _ngZone;
        _this._elementRef = _elementRef;
        _this._focusTrapFactory = _focusTrapFactory;
        /**
         * Element that was focused before the dialog was opened. Save this to restore upon close.
         */
        _this._elementFocusedBeforeDialogWasOpened = null;
        /**
         * State of the dialog animation.
         */
        _this._state = 'enter';
        /**
         * Emits the current animation state whenever it changes.
         */
        _this._onAnimationStateChange = new EventEmitter();
        _this._document = _document;
        return _this;
    }
    /**
     * Attach a ComponentPortal as content to this dialog container.
     * @template T
     * @param {?} portal Portal to be attached as the dialog content.
     * @return {?}
     */
    XpoDialogContainer.prototype.attachComponentPortal = function (portal) {
        if (this._portalHost.hasAttached()) {
            throwXpoDialogContentAlreadyAttachedError();
        }
        this._savePreviouslyFocusedElement();
        return this._portalHost.attachComponentPortal(portal);
    };
    /**
     * Attach a TemplatePortal as content to this dialog container.
     * @param {?} portal Portal to be attached as the dialog content.
     * @return {?}
     */
    XpoDialogContainer.prototype.attachTemplatePortal = function (portal) {
        if (this._portalHost.hasAttached()) {
            throwXpoDialogContentAlreadyAttachedError();
        }
        this._savePreviouslyFocusedElement();
        return this._portalHost.attachTemplatePortal(portal);
    };
    /**
     * Moves the focus inside the focus trap.
     * @return {?}
     */
    XpoDialogContainer.prototype._trapFocus = function () {
        if (!this._focusTrap) {
            this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
        }
        // If were to attempt to focus immediately, then the content of the dialog would not yet be
        // ready in instances where change detection has to run first. To deal with this, we simply
        // wait for the microtask queue to be empty.
        this._focusTrap.focusInitialElementWhenReady();
    };
    /**
     * Restores focus to the element that was focused before the dialog opened.
     * @return {?}
     */
    XpoDialogContainer.prototype._restoreFocus = function () {
        var /** @type {?} */ toFocus = this._elementFocusedBeforeDialogWasOpened;
        // We need the extra check, because IE can set the `activeElement` to null in some cases.
        if (toFocus && 'focus' in toFocus) {
            toFocus.focus();
        }
        if (this._focusTrap) {
            this._focusTrap.destroy();
        }
    };
    /**
     * Saves a reference to the element that was focused before the dialog was opened.
     * @return {?}
     */
    XpoDialogContainer.prototype._savePreviouslyFocusedElement = function () {
        if (this._document) {
            this._elementFocusedBeforeDialogWasOpened = (this._document.activeElement);
        }
    };
    /**
     * Callback, invoked whenever an animation on the host completes.
     * @param {?} event
     * @return {?}
     */
    XpoDialogContainer.prototype._onAnimationDone = function (event) {
        this._onAnimationStateChange.emit(event);
        if (event.toState === 'enter') {
            this._trapFocus();
        }
        else if (event.toState === 'exit') {
            this._restoreFocus();
            this._onAnimationStateChange.complete();
        }
    };
    return XpoDialogContainer;
}(BasePortalHost));
XpoDialogContainer.decorators = [
    { type: Component, args: [{ selector: 'xpo-dialog-container',
                template: "<ng-template cdkPortalHost></ng-template>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:block;max-width:100%;margin:0 auto;transform:translateY(-25%);background-color:#fff;z-index:11;transition:transform .3s}:host xpo-card{margin:0}::ng-deep .xpo-dialog-header{display:flex;align-items:center;min-height:54px}::ng-deep .xpo-dialog-header__title{display:flex;flex:1;margin:0;font-weight:700}::ng-deep .xpo-dialog-header__title h1,::ng-deep .xpo-dialog-header__title h2,::ng-deep .xpo-dialog-header__title h3,::ng-deep .xpo-dialog-header__title h4{margin:0}::ng-deep .xpo-dialog-header__actions{font-size:18px}::ng-deep .xpo-dialog-header__actions button{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;cursor:pointer;border:none;background-color:transparent}::ng-deep .xpo-dialog-header__actions button:focus{outline:0}::ng-deep .xpo-dialog-content{display:block;background-color:#fff}::ng-deep .xpo-dialog-actions{display:flex}:host-context(.xpo-internal){width:600px;margin-top:10vh;margin-bottom:15px}:host-context(.xpo-internal) ::ng-deep .xpo-dialog-header{padding:15px 18px 15px 15px;background-color:#f5f5f5}:host-context(.xpo-internal) ::ng-deep .xpo-dialog-header__title{font-size:1.5rem}:host-context(.xpo-internal) ::ng-deep .xpo-dialog-header__title h1,:host-context(.xpo-internal) ::ng-deep .xpo-dialog-header__title h2,:host-context(.xpo-internal) ::ng-deep .xpo-dialog-header__title h3,:host-context(.xpo-internal) ::ng-deep .xpo-dialog-header__title h4{font-size:1.5rem}:host-context(.xpo-internal) ::ng-deep .xpo-dialog-content{padding:30px 30px 30px 15px}:host-context(.xpo-internal) ::ng-deep .xpo-dialog-actions{flex-direction:row;justify-content:flex-end;padding:10px 30px 10px 15px;border-top:1px solid #dfdfdf}:host-context(.xpo-internal) ::ng-deep .xpo-dialog-actions button{margin-left:14px}:host-context(.xpo-internal) ::ng-deep .xpo-dialog-actions button:last-child{margin-right:-8px}:host-context(.xpo-external){width:445px}@media (min-width:1025px){:host-context(.xpo-external){margin-top:10vh;margin-bottom:15px}}:host-context(.xpo-external) ::ng-deep .xpo-dialog-header{padding:15px;color:#fff;background-color:#333}:host-context(.xpo-external) ::ng-deep .xpo-dialog-header__title{font-size:1.286rem;color:#fff}:host-context(.xpo-external) ::ng-deep .xpo-dialog-header__title h1,:host-context(.xpo-external) ::ng-deep .xpo-dialog-header__title h2,:host-context(.xpo-external) ::ng-deep .xpo-dialog-header__title h3,:host-context(.xpo-external) ::ng-deep .xpo-dialog-header__title h4{font-size:1.286rem}:host-context(.xpo-external) ::ng-deep .xpo-dialog-header__actions{color:#fff}:host-context(.xpo-external) ::ng-deep .xpo-dialog-header__actions button{color:#fff}:host-context(.xpo-external) ::ng-deep .xpo-dialog-content{padding:30px 15px}:host-context(.xpo-external) ::ng-deep .xpo-dialog-actions{flex-direction:column;padding:0 15px 15px}:host-context(.xpo-external) ::ng-deep .xpo-dialog-actions [xpo-btn]{width:100%;margin-top:10px}:host-context(.xpo-external) ::ng-deep .xpo-dialog-actions [xpo-btn]:first-of-type{margin-top:0} /*# sourceMappingURL=dialog.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                animations: [
                    trigger('slideDialog', [
                        state('void', style({ transform: 'translate3d(0, 25%, 0) scale(0.9)', opacity: 0 })),
                        state('enter', style({ transform: 'translate3d(0, 0, 0) scale(1)', opacity: 1 })),
                        state('exit', style({ transform: 'translate3d(0, 25%, 0)', opacity: 0 })),
                        transition('* => *', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
                    ]),
                ],
                host: {
                    '[class.xpo-dialog-container]': 'true',
                    '[attr.role]': '_config?.role',
                    '[@slideDialog]': '_state',
                    '(@slideDialog.done)': '_onAnimationDone($event)',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoDialogContainer.ctorParameters = function () { return [
    { type: NgZone, },
    { type: ElementRef, },
    { type: FocusTrapFactory, },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] },] },
]; };
XpoDialogContainer.propDecorators = {
    '_portalHost': [{ type: ViewChild, args: [PortalHostDirective,] },],
};
/**
 * Custom injector type specifically for instantiating components with a dialog.
 */
var DialogInjector = (function () {
    /**
     * @param {?} _parentInjector
     * @param {?} _customTokens
     */
    function DialogInjector(_parentInjector, _customTokens) {
        this._parentInjector = _parentInjector;
        this._customTokens = _customTokens;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    DialogInjector.prototype.get = function (token, notFoundValue) {
        var /** @type {?} */ value = this._customTokens.get(token);
        if (typeof value !== 'undefined') {
            return value;
        }
        return this._parentInjector.get(token, notFoundValue);
    };
    return DialogInjector;
}());
/**
 * Reference to a dialog opened via the XpoDialog service.
 */
var XpoDialogRef = (function () {
    /**
     * @param {?} _overlayRef
     * @param {?} _containerInstance
     */
    function XpoDialogRef(_overlayRef, _containerInstance) {
        var _this = this;
        this._overlayRef = _overlayRef;
        this._containerInstance = _containerInstance;
        /**
         * Whether the user is allowed to close the dialog.
         */
        this.disableClose = this._containerInstance._config.disableClose;
        /**
         * Subject for notifying the user that the dialog has finished closing.
         */
        this._afterClosed = new Subject();
        _containerInstance._onAnimationStateChange
            .filter(function (event) { return event.toState === 'exit'; })
            .subscribe(function () {
            _this._overlayRef.dispose();
            _this.componentInstance = null;
        }, null, function () {
            _this._afterClosed.next(_this._result);
            _this._afterClosed.complete();
        });
    }
    /**
     * Close the dialog.
     * @param {?=} dialogResult Optional result to return to the dialog opener.
     * @return {?}
     */
    XpoDialogRef.prototype.close = function (dialogResult) {
        this._result = dialogResult;
        this._containerInstance._state = 'exit';
        this._overlayRef.detachBackdrop(); // Transition the backdrop in parallel with the dialog.
    };
    /**
     * Gets an observable that is notified when the dialog is finished closing.
     * @return {?}
     */
    XpoDialogRef.prototype.afterClosed = function () {
        return this._afterClosed.asObservable();
    };
    /**
     * Updates the dialog's position.
     * @param {?=} position New dialog position.
     * @return {?}
     */
    XpoDialogRef.prototype.updatePosition = function (position) {
        var /** @type {?} */ strategy = this._getPositionStrategy();
        if (position && (position.left || position.right)) {
            position.left ? strategy.left(position.left) : strategy.right(position.right);
        }
        else {
            strategy.centerHorizontally();
        }
        if (position && (position.top || position.bottom)) {
            position.top ? strategy.top(position.top) : strategy.bottom(position.bottom);
        }
        else {
            strategy.centerVertically();
        }
        this._overlayRef.updatePosition();
        return this;
    };
    /**
     * Updates the dialog's width and height.
     * @param {?=} width New width of the dialog.
     * @param {?=} height New height of the dialog.
     * @return {?}
     */
    XpoDialogRef.prototype.updateSize = function (width, height) {
        if (width === void 0) { width = 'auto'; }
        if (height === void 0) { height = 'auto'; }
        this._getPositionStrategy().width(width).height(height);
        this._overlayRef.updatePosition();
        return this;
    };
    /**
     * Fetches the position strategy object from the overlay ref.
     * @return {?}
     */
    XpoDialogRef.prototype._getPositionStrategy = function () {
        return (this._overlayRef.getConfig().positionStrategy);
    };
    return XpoDialogRef;
}());
var XPO_DIALOG_DATA = new InjectionToken('XpoDialogData');
/**
 * Service to open Xpo common modal dialogs.
 */
var XpoDialog = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _injector
     * @param {?} _location
     * @param {?} _parentDialog
     */
    function XpoDialog(_overlay, _injector, _location, _parentDialog) {
        var _this = this;
        this._overlay = _overlay;
        this._injector = _injector;
        this._location = _location;
        this._parentDialog = _parentDialog;
        this._openDialogsAtThisLevel = [];
        this._afterAllClosedAtThisLevel = new Subject();
        this._afterOpenAtThisLevel = new Subject();
        this._boundKeydown = this._handleKeydown.bind(this);
        /**
         * Gets an observable that is notified when a dialog has been opened.
         */
        this.afterOpen = this._afterOpen.asObservable();
        /**
         * Gets an observable that is notified when all open dialog have finished closing.
         */
        this.afterAllClosed = this._afterAllClosed.asObservable();
        // Close all of the dialogs when the user goes forwards/backwards in history or when the
        // location hash changes. Note that this usually doesn't include clicking on links (unless
        // the user is using the `HashLocationStrategy`).
        if (!_parentDialog && _location) {
            _location.subscribe(function () { return _this.closeAll(); });
        }
    }
    Object.defineProperty(XpoDialog.prototype, "_openDialogs", {
        /**
         * Keeps track of the currently-open dialogs.
         * @return {?}
         */
        get: function () {
            return this._parentDialog ? this._parentDialog._openDialogs : this._openDialogsAtThisLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDialog.prototype, "_afterOpen", {
        /**
         * Subject for notifying the user that a dialog has opened.
         * @return {?}
         */
        get: function () {
            return this._parentDialog ? this._parentDialog._afterOpen : this._afterOpenAtThisLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDialog.prototype, "_afterAllClosed", {
        /**
         * Subject for notifying the user that all open dialogs have finished closing.
         * @return {?}
         */
        get: function () {
            return this._parentDialog ?
                this._parentDialog._afterAllClosed : this._afterAllClosedAtThisLevel;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Opens a modal dialog containing the given component.
     * @template T
     * @param {?} componentOrTemplateRef Type of the component to load into the dialog,
     *     or a TemplateRef to instantiate as the dialog content.
     * @param {?=} config Extra configuration options.
     * @return {?} Reference to the newly-opened dialog.
     */
    XpoDialog.prototype.open = function (componentOrTemplateRef, config) {
        var _this = this;
        config = _applyConfigDefaults(config);
        var /** @type {?} */ overlayRef = this._createOverlay(config);
        overlayRef.overlayElement.classList.add('cdk-overlay-pane__dialog'); // scrollable body
        var /** @type {?} */ dialogContainer = this._attachDialogContainer(overlayRef, config);
        var /** @type {?} */ dialogRef = this._attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config);
        if (!this._openDialogs.length) {
            document.addEventListener('keydown', this._boundKeydown);
        }
        this._openDialogs.push(dialogRef);
        dialogRef.afterClosed().subscribe(function () { return _this._removeOpenDialog(dialogRef); });
        this._afterOpen.next(dialogRef);
        return dialogRef;
    };
    /**
     * Closes all of the currently-open dialogs.
     * @return {?}
     */
    XpoDialog.prototype.closeAll = function () {
        var /** @type {?} */ i = this._openDialogs.length;
        while (i--) {
            // The `_openDialogs` property isn't updated after close until the rxjs subscription
            // runs on the next microtask, in addition to modifying the array as we're going
            // through it. We loop through all of them and call close without assuming that
            // they'll be removed from the list instantaneously.
            this._openDialogs[i].close();
        }
    };
    /**
     * Creates the overlay into which the dialog will be loaded.
     * @param {?} config The dialog configuration.
     * @return {?} A promise resolving to the OverlayRef for the created overlay.
     */
    XpoDialog.prototype._createOverlay = function (config) {
        var /** @type {?} */ overlayState = this._getOverlayState(config);
        return this._overlay.create(overlayState);
    };
    /**
     * Creates an overlay state from a dialog config.
     * @param {?} dialogConfig The dialog configuration.
     * @return {?} The overlay configuration.
     */
    XpoDialog.prototype._getOverlayState = function (dialogConfig) {
        var /** @type {?} */ overlayState = new OverlayState();
        overlayState.panelClass = dialogConfig.panelClass;
        overlayState.hasBackdrop = dialogConfig.hasBackdrop;
        overlayState.scrollStrategy = this._overlay.scrollStrategies.block();
        overlayState.direction = dialogConfig.direction;
        if (dialogConfig.backdropClass) {
            overlayState.backdropClass = dialogConfig.backdropClass;
        }
        overlayState.positionStrategy = this._overlay.position().global();
        return overlayState;
    };
    /**
     * Attaches an XpoDialogContainer to a dialog's already-created overlay.
     * @param {?} overlay Reference to the dialog's underlying overlay.
     * @param {?} config The dialog configuration.
     * @return {?} A promise resolving to a ComponentRef for the attached container.
     */
    XpoDialog.prototype._attachDialogContainer = function (overlay, config) {
        var /** @type {?} */ containerPortal = new ComponentPortal(XpoDialogContainer, config.viewContainerRef);
        var /** @type {?} */ containerRef = overlay.attach(containerPortal);
        containerRef.instance._config = config;
        return containerRef.instance;
    };
    /**
     * Attaches the user-provided component to the already-created XpoDialogContainer.
     * @template T
     * @param {?} componentOrTemplateRef The type of component being loaded into the dialog,
     *     or a TemplateRef to instantiate as the content.
     * @param {?} dialogContainer Reference to the wrapping XpoDialogContainer.
     * @param {?} overlayRef Reference to the overlay in which the dialog resides.
     * @param {?} config The dialog configuration.
     * @return {?} A promise resolving to the XpoDialogRef that should be returned to the user.
     */
    XpoDialog.prototype._attachDialogContent = function (componentOrTemplateRef, dialogContainer, overlayRef, config) {
        // Create a reference to the dialog we're creating in order to give the user a handle
        // to modify and close it.
        var /** @type {?} */ dialogRef = new XpoDialogRef(overlayRef, dialogContainer);
        // When the dialog backdrop is clicked, we want to close it.
        if (config.hasBackdrop) {
            overlayRef.backdropClick().subscribe(function () {
                if (!dialogRef.disableClose) {
                    dialogRef.close();
                }
            });
        }
        if (componentOrTemplateRef instanceof TemplateRef) {
            dialogContainer.attachTemplatePortal(new TemplatePortal(componentOrTemplateRef, /** @type {?} */ ((null))));
        }
        else {
            var /** @type {?} */ injector = this._createInjector(config, dialogRef, dialogContainer);
            var /** @type {?} */ contentRef = dialogContainer.attachComponentPortal(new ComponentPortal(componentOrTemplateRef, undefined, injector));
            dialogRef.componentInstance = contentRef.instance;
        }
        dialogRef
            .updateSize(config.width, config.height)
            .updatePosition(config.position);
        return dialogRef;
    };
    /**
     * Creates a custom injector to be used inside the dialog. This allows a component loaded inside
     * of a dialog to close itself and, optionally, to return a value.
     * @template T
     * @param {?} config Config object that is used to construct the dialog.
     * @param {?} dialogRef Reference to the dialog.
     * @param {?} dialogContainer
     * @return {?} The custom injector that can be used inside the dialog.
     */
    XpoDialog.prototype._createInjector = function (config, dialogRef, dialogContainer) {
        var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
        var /** @type {?} */ injectionTokens = new WeakMap();
        injectionTokens.set(XpoDialogRef, dialogRef);
        injectionTokens.set(XpoDialogContainer, dialogContainer);
        injectionTokens.set(XPO_DIALOG_DATA, config.data);
        return new DialogInjector(userInjector || this._injector, injectionTokens);
    };
    /**
     * Removes a dialog from the array of open dialogs.
     * @param {?} dialogRef Dialog to be removed.
     * @return {?}
     */
    XpoDialog.prototype._removeOpenDialog = function (dialogRef) {
        var /** @type {?} */ index = this._openDialogs.indexOf(dialogRef);
        if (index > -1) {
            this._openDialogs.splice(index, 1);
            // no open dialogs are left, call next on afterAllClosed Subject
            if (!this._openDialogs.length) {
                this._afterAllClosed.next();
                document.removeEventListener('keydown', this._boundKeydown);
            }
        }
    };
    /**
     * Handles global key presses while there are open dialogs. Closes the
     * top dialog when the user presses escape.
     * @param {?} event
     * @return {?}
     */
    XpoDialog.prototype._handleKeydown = function (event) {
        var /** @type {?} */ topDialog = this._openDialogs[this._openDialogs.length - 1];
        var /** @type {?} */ canClose = topDialog ? !topDialog.disableClose : false;
        if (event.keyCode === ESCAPE && canClose) {
            topDialog.close();
        }
    };
    return XpoDialog;
}());
XpoDialog.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
XpoDialog.ctorParameters = function () { return [
    { type: Overlay, },
    { type: Injector, },
    { type: Location, decorators: [{ type: Optional },] },
    { type: XpoDialog, decorators: [{ type: Optional }, { type: SkipSelf },] },
]; };
/**
 * Applies default options to the dialog config.
 * @param {?} config Config to be modified.
 * @return {?} The new configuration object.
 */
function _applyConfigDefaults(config) {
    return extendObject(new XpoDialogConfig(), config);
}
var XpoDialogHeader = (function () {
    function XpoDialogHeader() {
    }
    return XpoDialogHeader;
}());
XpoDialogHeader.decorators = [
    { type: Component, args: [{ selector: 'dialog-header',
                host: {
                    '[class.xpo-dialog-header]': 'true',
                },
                template: "<ng-content select=\"dialog-header-title\"></ng-content> <ng-content></ng-content> ",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoDialogHeader.ctorParameters = function () { return []; };
/**
 * Button that will close the current dialog.
 */
var XpoDialogClose = (function () {
    /**
     * @param {?} dialogRef
     */
    function XpoDialogClose(dialogRef) {
        this.dialogRef = dialogRef;
        /**
         * Screenreader label for the button.
         */
        this.ariaLabel = 'Close dialog';
    }
    Object.defineProperty(XpoDialogClose.prototype, "_matDialogClose", {
        /**
         * Dialog close input for compatibility mode.
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.dialogResult = value; },
        enumerable: true,
        configurable: true
    });
    return XpoDialogClose;
}());
XpoDialogClose.decorators = [
    { type: Directive, args: [{
                selector: 'button[xpo-dialog-close]',
                host: {
                    '(click)': 'dialogRef.close(dialogResult)',
                    '[attr.aria-label]': 'ariaLabel',
                    'type': 'button',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoDialogClose.ctorParameters = function () { return [
    { type: XpoDialogRef, },
]; };
XpoDialogClose.propDecorators = {
    'ariaLabel': [{ type: Input, args: ['aria-label',] },],
    'dialogResult': [{ type: Input, args: ['xpo-dialog-close',] },],
    '_matDialogClose': [{ type: Input, args: ['xpo-dialog-close',] },],
};
/**
 * Head action section of a dialog, needed as it's used as a selector in the API.
 */
var XpoDialogHeaderActions = (function () {
    function XpoDialogHeaderActions() {
    }
    return XpoDialogHeaderActions;
}());
XpoDialogHeaderActions.decorators = [
    { type: Directive, args: [{
                selector: 'dialog-header-actions',
                host: {
                    '[class.xpo-dialog-header__actions]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoDialogHeaderActions.ctorParameters = function () { return []; };
/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
var XpoDialogHeaderTitle = (function () {
    function XpoDialogHeaderTitle() {
    }
    return XpoDialogHeaderTitle;
}());
XpoDialogHeaderTitle.decorators = [
    { type: Directive, args: [{
                selector: 'dialog-header-title',
                host: {
                    '[class.xpo-dialog-header__title]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoDialogHeaderTitle.ctorParameters = function () { return []; };
/**
 * Scrollable content container of a dialog.
 */
var XpoDialogContent = (function () {
    function XpoDialogContent() {
    }
    return XpoDialogContent;
}());
XpoDialogContent.decorators = [
    { type: Directive, args: [{
                selector: 'dialog-content',
                host: {
                    '[class.xpo-dialog-content]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoDialogContent.ctorParameters = function () { return []; };
/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
var XpoDialogActions = (function () {
    function XpoDialogActions() {
    }
    return XpoDialogActions;
}());
XpoDialogActions.decorators = [
    { type: Directive, args: [{
                selector: 'dialog-actions',
                host: {
                    '[class.xpo-dialog-actions]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoDialogActions.ctorParameters = function () { return []; };
var XpoDialogModule = (function () {
    function XpoDialogModule() {
    }
    return XpoDialogModule;
}());
XpoDialogModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    OverlayModule,
                    PortalModule,
                    A11yModule,
                    XpoCommonModule,
                ],
                exports: [
                    XpoDialogContainer,
                    XpoDialogClose,
                    XpoDialogHeader,
                    XpoDialogHeaderActions,
                    XpoDialogHeaderTitle,
                    XpoDialogContent,
                    XpoDialogActions,
                    XpoCommonModule,
                ],
                declarations: [
                    XpoDialogContainer,
                    XpoDialogClose,
                    XpoDialogHeader,
                    XpoDialogHeaderActions,
                    XpoDialogHeaderTitle,
                    XpoDialogActions,
                    XpoDialogContent,
                ],
                providers: [
                    XpoDialog,
                ],
                entryComponents: [XpoDialogContainer],
            },] },
];
/**
 * @nocollapse
 */
XpoDialogModule.ctorParameters = function () { return []; };
/**
 * \@docs-private
 * @param {?} provider
 * @return {?}
 */
function createMissingDateImplError(provider) {
    return new Error("XpoDatepicker: No provider found for " + provider + ". You must import one of the following" +
        "modules at your application root: XpoNativeDateModule, or provide a custom implementation.");
}
/**
 * Datepicker data that requires internationalization.
 */
var XpoDatepickerIntl = (function () {
    function XpoDatepickerIntl() {
        /**
         * A label for the calendar popup (used by screen readers).
         */
        this.calendarLabel = 'Calendar';
        /**
         * A label for the button used to open the calendar popup (used by screen readers).
         */
        this.openCalendarLabel = 'Open calendar';
        /**
         * A label for the previous month button (used by screen readers).
         */
        this.prevMonthLabel = 'Previous month';
        /**
         * A label for the next month button (used by screen readers).
         */
        this.nextMonthLabel = 'Next month';
        /**
         * A label for the previous year button (used by screen readers).
         */
        this.prevYearLabel = 'Previous year';
        /**
         * A label for the next year button (used by screen readers).
         */
        this.nextYearLabel = 'Next year';
        /**
         * A label for the 'switch to month view' button (used by screen readers).
         */
        this.switchToMonthViewLabel = 'Change to month view';
        /**
         * A label for the 'switch to year view' button (used by screen readers).
         */
        this.switchToYearViewLabel = 'Change to year view';
    }
    return XpoDatepickerIntl;
}());
XpoDatepickerIntl.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
XpoDatepickerIntl.ctorParameters = function () { return []; };
/**
 * A calendar that is used as part of the datepicker.
 * \@docs-private
 */
var XpoCalendar = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _intl
     * @param {?} _ngZone
     * @param {?} _dateAdapter
     * @param {?} _dateFormats
     */
    function XpoCalendar(_elementRef, _intl, _ngZone, _dateAdapter, _dateFormats) {
        var _this = this;
        this._elementRef = _elementRef;
        this._intl = _intl;
        this._ngZone = _ngZone;
        this._dateAdapter = _dateAdapter;
        this._dateFormats = _dateFormats;
        /**
         * Whether the calendar should be started in month or year view.
         */
        this.startView = 'month';
        /**
         * Emits when the currently selected date changes.
         */
        this.selectedChange = new EventEmitter();
        /**
         * Date filter for the month and year views.
         */
        this._dateFilterForViews = function (date) {
            return !!date &&
                (!_this.dateFilter || _this.dateFilter(date)) &&
                (!_this.minDate || _this._dateAdapter.compareDate(date, _this.minDate) >= 0) &&
                (!_this.maxDate || _this._dateAdapter.compareDate(date, _this.maxDate) <= 0);
        };
        if (!this._dateAdapter) {
            throw createMissingDateImplError('DateAdapter');
        }
        if (!this._dateFormats) {
            throw createMissingDateImplError('XPO_DATE_FORMATS');
        }
    }
    Object.defineProperty(XpoCalendar.prototype, "_activeDate", {
        /**
         * The current active date. This determines which time period is shown and which date is
         * highlighted when using keyboard navigation.
         * @return {?}
         */
        get: function () { return this._clampedActiveDate; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._clampedActiveDate = this._dateAdapter.clampDate(value, this.minDate, this.maxDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoCalendar.prototype, "_periodButtonText", {
        /**
         * The label for the current calendar view.
         * @return {?}
         */
        get: function () {
            return this._monthView ?
                this._dateAdapter.format(this._activeDate, this._dateFormats.display.monthYearLabel)
                    .toLocaleUpperCase() :
                this._dateAdapter.getYearName(this._activeDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoCalendar.prototype, "_periodButtonLabel", {
        /**
         * @return {?}
         */
        get: function () {
            return this._monthView ? this._intl.switchToYearViewLabel : this._intl.switchToMonthViewLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoCalendar.prototype, "_prevButtonLabel", {
        /**
         * The label for the the previous button.
         * @return {?}
         */
        get: function () {
            return this._monthView ? this._intl.prevMonthLabel : this._intl.prevYearLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoCalendar.prototype, "_nextButtonLabel", {
        /**
         * The label for the the next button.
         * @return {?}
         */
        get: function () {
            return this._monthView ? this._intl.nextMonthLabel : this._intl.nextYearLabel;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoCalendar.prototype.ngAfterContentInit = function () {
        this._activeDate = this.startAt || this._dateAdapter.today();
        this._focusActiveCell();
        this._monthView = this.startView != 'year';
    };
    /**
     * Handles date selection in the month view.
     * @param {?} date
     * @return {?}
     */
    XpoCalendar.prototype._dateSelected = function (date) {
        if (!this._dateAdapter.sameDate(date, this.selected)) {
            this.selectedChange.emit(date);
        }
    };
    /**
     * Handles month selection in the year view.
     * @param {?} month
     * @return {?}
     */
    XpoCalendar.prototype._monthSelected = function (month) {
        this._activeDate = month;
        this._monthView = true;
    };
    /**
     * Handles user clicks on the period label.
     * @return {?}
     */
    XpoCalendar.prototype._currentPeriodClicked = function () {
        this._monthView = !this._monthView;
    };
    /**
     * Handles user clicks on the previous button.
     * @return {?}
     */
    XpoCalendar.prototype._previousClicked = function () {
        this._activeDate = this._monthView ?
            this._dateAdapter.addCalendarMonths(this._activeDate, -1) :
            this._dateAdapter.addCalendarYears(this._activeDate, -1);
    };
    /**
     * Handles user clicks on the next button.
     * @return {?}
     */
    XpoCalendar.prototype._nextClicked = function () {
        this._activeDate = this._monthView ?
            this._dateAdapter.addCalendarMonths(this._activeDate, 1) :
            this._dateAdapter.addCalendarYears(this._activeDate, 1);
    };
    /**
     * Whether the previous period button is enabled.
     * @return {?}
     */
    XpoCalendar.prototype._previousEnabled = function () {
        if (!this.minDate) {
            return true;
        }
        return !this.minDate || !this._isSameView(this._activeDate, this.minDate);
    };
    /**
     * Whether the next period button is enabled.
     * @return {?}
     */
    XpoCalendar.prototype._nextEnabled = function () {
        return !this.maxDate || !this._isSameView(this._activeDate, this.maxDate);
    };
    /**
     * Handles keydown events on the calendar body.
     * @param {?} event
     * @return {?}
     */
    XpoCalendar.prototype._handleCalendarBodyKeydown = function (event) {
        // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
        // disabled ones from being selected. This may not be ideal, we should look into whether
        // navigation should skip over disabled dates, and if so, how to implement that efficiently.
        if (this._monthView) {
            this._handleCalendarBodyKeydownInMonthView(event);
        }
        else {
            this._handleCalendarBodyKeydownInYearView(event);
        }
    };
    /**
     * Focuses the active cell after the microtask queue is empty.
     * @return {?}
     */
    XpoCalendar.prototype._focusActiveCell = function () {
        var _this = this;
        this._ngZone.runOutsideAngular(function () { return _this._ngZone.onStable.first().subscribe(function () {
            var /** @type {?} */ activeEl = _this._elementRef.nativeElement.querySelector('.xpo-calendar-body-active');
            activeEl.focus();
        }); });
    };
    /**
     * Whether the two dates represent the same view in the current view mode (month or year).
     * @param {?} date1
     * @param {?} date2
     * @return {?}
     */
    XpoCalendar.prototype._isSameView = function (date1, date2) {
        return this._monthView ?
            this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2) &&
                this._dateAdapter.getMonth(date1) == this._dateAdapter.getMonth(date2) :
            this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2);
    };
    /**
     * Handles keydown events on the calendar body when calendar is in month view.
     * @param {?} event
     * @return {?}
     */
    XpoCalendar.prototype._handleCalendarBodyKeydownInMonthView = function (event) {
        switch (event.keyCode) {
            case LEFT_ARROW:
                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -1);
                break;
            case RIGHT_ARROW:
                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1);
                break;
            case UP_ARROW:
                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -7);
                break;
            case DOWN_ARROW:
                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 7);
                break;
            case HOME:
                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1 - this._dateAdapter.getDate(this._activeDate));
                break;
            case END:
                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, (this._dateAdapter.getNumDaysInMonth(this._activeDate) -
                    this._dateAdapter.getDate(this._activeDate)));
                break;
            case PAGE_UP:
                this._activeDate = event.altKey ?
                    this._dateAdapter.addCalendarYears(this._activeDate, -1) :
                    this._dateAdapter.addCalendarMonths(this._activeDate, -1);
                break;
            case PAGE_DOWN:
                this._activeDate = event.altKey ?
                    this._dateAdapter.addCalendarYears(this._activeDate, 1) :
                    this._dateAdapter.addCalendarMonths(this._activeDate, 1);
                break;
            case ENTER:
                if (this._dateFilterForViews(this._activeDate)) {
                    this._dateSelected(this._activeDate);
                    // Prevent unexpected default actions such as form submission.
                    event.preventDefault();
                }
                return;
            default:
                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                return;
        }
        this._focusActiveCell();
        // Prevent unexpected default actions such as form submission.
        event.preventDefault();
    };
    /**
     * Handles keydown events on the calendar body when calendar is in year view.
     * @param {?} event
     * @return {?}
     */
    XpoCalendar.prototype._handleCalendarBodyKeydownInYearView = function (event) {
        switch (event.keyCode) {
            case LEFT_ARROW:
                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -1);
                break;
            case RIGHT_ARROW:
                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 1);
                break;
            case UP_ARROW:
                this._activeDate = this._prevMonthInSameCol(this._activeDate);
                break;
            case DOWN_ARROW:
                this._activeDate = this._nextMonthInSameCol(this._activeDate);
                break;
            case HOME:
                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._dateAdapter.getMonth(this._activeDate));
                break;
            case END:
                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 11 - this._dateAdapter.getMonth(this._activeDate));
                break;
            case PAGE_UP:
                this._activeDate =
                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -10 : -1);
                break;
            case PAGE_DOWN:
                this._activeDate =
                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? 10 : 1);
                break;
            case ENTER:
                this._monthSelected(this._activeDate);
                break;
            default:
                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
                return;
        }
        this._focusActiveCell();
        // Prevent unexpected default actions such as form submission.
        event.preventDefault();
    };
    /**
     * Determine the date for the month that comes before the given month in the same column in the
     * calendar table.
     * @param {?} date
     * @return {?}
     */
    XpoCalendar.prototype._prevMonthInSameCol = function (date) {
        // Determine how many months to jump forward given that there are 2 empty slots at the beginning
        // of each year.
        var /** @type {?} */ increment = this._dateAdapter.getMonth(date) <= 4 ? -5 :
            (this._dateAdapter.getMonth(date) >= 7 ? -7 : -12);
        return this._dateAdapter.addCalendarMonths(date, increment);
    };
    /**
     * Determine the date for the month that comes after the given month in the same column in the
     * calendar table.
     * @param {?} date
     * @return {?}
     */
    XpoCalendar.prototype._nextMonthInSameCol = function (date) {
        // Determine how many months to jump forward given that there are 2 empty slots at the beginning
        // of each year.
        var /** @type {?} */ increment = this._dateAdapter.getMonth(date) <= 4 ? 7 :
            (this._dateAdapter.getMonth(date) >= 7 ? 5 : 12);
        return this._dateAdapter.addCalendarMonths(date, increment);
    };
    return XpoCalendar;
}());
XpoCalendar.decorators = [
    { type: Component, args: [{ selector: 'xpo-calendar',
                template: "<div class=\"xpo-calendar-header\"> <div class=\"xpo-calendar-controls\"> <button xpo-button class=\"xpo-calendar-period-button\" (click)=\"_currentPeriodClicked()\" [attr.aria-label]=\"_periodButtonLabel\"> {{_periodButtonText}} <div class=\"xpo-calendar-arrow\" [class.xpo-calendar-invert]=\"!_monthView\"></div> </button> <div class=\"xpo-calendar-spacer\"></div> <button xpo-icon-button class=\"xpo-calendar-previous-button\" [disabled]=\"!_previousEnabled()\" (click)=\"_previousClicked()\" [attr.aria-label]=\"_prevButtonLabel\"> </button> <button xpo-icon-button class=\"xpo-calendar-next-button\" [disabled]=\"!_nextEnabled()\" (click)=\"_nextClicked()\" [attr.aria-label]=\"_nextButtonLabel\"> </button> </div> </div> <div class=\"xpo-calendar-content\" (keydown)=\"_handleCalendarBodyKeydown($event)\" cdkMonitorSubtreeFocus> <xpo-month-view *ngIf=\"_monthView\" [activeDate]=\"_activeDate\" [selected]=\"selected\" [dateFilter]=\"_dateFilterForViews\" (selectedChange)=\"_dateSelected($event)\"> </xpo-month-view> <xpo-year-view *ngIf=\"!_monthView\" [activeDate]=\"_activeDate\" [selected]=\"selected\" [dateFilter]=\"_dateFilterForViews\" (selectedChange)=\"_monthSelected($event)\"> </xpo-year-view> </div>",
                styles: ["@charset \"UTF-8\";.xpo-calendar{display:block;border:1px solid;border-color:#dfdfdf}.xpo-calendar-header{padding:8px 8px 0 8px}.xpo-calendar-content{padding:0 8px 8px 8px;outline:0}.xpo-calendar-controls{display:flex;padding:5% calc(100% / 14 - 22px) 5% calc(100% / 14 - 22px)}.xpo-calendar-spacer{flex:1 1 auto}.xpo-calendar-period-button{min-width:0;padding:0;font:inherit;font-size:14px;font-weight:700;border:none;background-color:transparent}.xpo-calendar-arrow{display:inline-block;vertical-align:middle;width:0;height:0;margin:0 0 0 5px;border-top-style:solid;border-top-width:5px;border-right:5px solid transparent;border-left:5px solid transparent}.xpo-calendar-arrow.xpo-calendar-invert{transform:rotate(180deg)}.xpo-calendar-next-button,.xpo-calendar-previous-button{width:20px;height:20px;padding:0;position:relative;font-family:XPOicon;font-size:20px;border:none;background-color:transparent}.xpo-calendar-next-button::after,.xpo-calendar-previous-button::after{position:absolute;right:0}.xpo-calendar-previous-button::after{top:0;left:-1px;content:\"\"}.xpo-calendar-next-button{margin-left:10px}.xpo-calendar-next-button::after{top:0;left:0;transform:rotate(180deg);content:\"\"}.xpo-calendar-table{width:100%;border-collapse:collapse;border-spacing:0}.xpo-calendar-table-header th{padding:0 0 8px 0;font-size:11px;font-weight:400;text-align:center}.xpo-calendar-table-header-divider{height:1px;position:relative}.xpo-calendar-table-header-divider::after{height:1px;position:absolute;top:0;right:-8px;left:-8px;content:\"\"}xpo-calendar{background:#fff} /*# sourceMappingURL=calendar.css.map */ "],
                host: {
                    '[class.xpo-calendar]': 'true',
                },
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoCalendar.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: XpoDatepickerIntl, },
    { type: NgZone, },
    { type: DateAdapter, decorators: [{ type: Optional },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [XPO_DATE_FORMATS,] },] },
]; };
XpoCalendar.propDecorators = {
    'startAt': [{ type: Input },],
    'startView': [{ type: Input },],
    'selected': [{ type: Input },],
    'minDate': [{ type: Input },],
    'maxDate': [{ type: Input },],
    'dateFilter': [{ type: Input },],
    'selectedChange': [{ type: Output },],
};
/**
 * An internal class that represents the data corresponding to a single calendar cell.
 * \@docs-private
 */
var XpoCalendarCell = (function () {
    /**
     * @param {?} value
     * @param {?} displayValue
     * @param {?} ariaLabel
     * @param {?} enabled
     */
    function XpoCalendarCell(value, displayValue, ariaLabel, enabled) {
        this.value = value;
        this.displayValue = displayValue;
        this.ariaLabel = ariaLabel;
        this.enabled = enabled;
    }
    return XpoCalendarCell;
}());
/**
 * An internal component used to display calendar data in a table.
 * \@docs-private
 */
var XpoCalendarBody = (function () {
    function XpoCalendarBody() {
        /**
         * The number of columns in the table.
         */
        this.numCols = 7;
        /**
         * Whether to allow selection of disabled cells.
         */
        this.allowDisabledSelection = false;
        /**
         * The cell number of the active cell in the table.
         */
        this.activeCell = 0;
        /**
         * Emits when a new value is selected.
         */
        this.selectedValueChange = new EventEmitter();
    }
    /**
     * @param {?} cell
     * @return {?}
     */
    XpoCalendarBody.prototype._cellClicked = function (cell) {
        if (!this.allowDisabledSelection && !cell.enabled) {
            return;
        }
        this.selectedValueChange.emit(cell.value);
    };
    Object.defineProperty(XpoCalendarBody.prototype, "_firstRowOffset", {
        /**
         * The number of blank cells to put at the beginning for the first row.
         * @return {?}
         */
        get: function () {
            return this.rows && this.rows.length && this.rows[0].length ?
                this.numCols - this.rows[0].length : 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} rowIndex
     * @param {?} colIndex
     * @return {?}
     */
    XpoCalendarBody.prototype._isActiveCell = function (rowIndex, colIndex) {
        var /** @type {?} */ cellNumber = rowIndex * this.numCols + colIndex;
        // Account for the fact that the first row may not have as many cells.
        if (rowIndex) {
            cellNumber -= this._firstRowOffset;
        }
        return cellNumber == this.activeCell;
    };
    return XpoCalendarBody;
}());
XpoCalendarBody.decorators = [
    { type: Component, args: [{ selector: '[xpo-calendar-body]',
                template: "<!-- If there's not enough space in the first row, create a separate label row. We mark this row as aria-hidden because we don't want it to be read out as one of the weeks in the month. --> <tr *ngIf=\"_firstRowOffset < labelMinRequiredCells\" aria-hidden=\"true\"> <td class=\"xpo-calendar-body-label\" [attr.colspan]=\"numCols\">{{label}}</td> </tr> <!-- Create the first row separately so we can include a special spacer cell. --> <tr *ngFor=\"let row of rows; let rowIndex = index\" role=\"row\"> <!-- We mark this cell as aria-hidden so it doesn't get read out as one of the days in the week. --> <td *ngIf=\"rowIndex === 0 && _firstRowOffset\" aria-hidden=\"true\" class=\"xpo-calendar-body-label\" [attr.colspan]=\"_firstRowOffset\"> {{_firstRowOffset >= labelMinRequiredCells ? label : ''}} </td> <td *ngFor=\"let item of row; let colIndex = index\" role=\"gridcell\" class=\"xpo-calendar-body-cell\" [tabindex]=\"_isActiveCell(rowIndex, colIndex) ? 0 : -1\" [class.xpo-calendar-body-disabled]=\"!item.enabled\" [class.xpo-calendar-body-active]=\"_isActiveCell(rowIndex, colIndex)\" [attr.aria-label]=\"item.ariaLabel\" [attr.aria-disabled]=\"!item.enabled || null\" (click)=\"_cellClicked(item)\"> <div class=\"xpo-calendar-body-cell-content\" [class.xpo-calendar-body-selected]=\"selectedValue === item.value\" [class.xpo-calendar-body-today]=\"todayValue === item.value\"> {{item.displayValue}} </div> </td> </tr>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}.xpo-calendar-body{min-width:224px;font-size:13px}.xpo-calendar-body-label{height:0;padding:7.14286% 0 7.14286%;font-size:14px;font-weight:700;line-height:0;text-align:left}.xpo-calendar-body-cell{width:14.28571%;height:0;padding:7.14286% 0;position:relative;outline:0;cursor:pointer;line-height:0;text-align:center;border:1px solid #bdbdbd}.xpo-calendar-body-disabled{cursor:default}.xpo-calendar-body-cell-content{display:flex;align-items:center;justify-content:center;position:absolute;top:-1px;right:-1px;bottom:-1px;left:-1px;border:1px solid transparent;transition:border-color .2s}.xpo-calendar-body-cell-content:hover{border-color:#333}.xpo-calendar-body-today{font-weight:700}.xpo-calendar-body-selected{color:#fff;background-color:#333}[dir=rtl] .xpo-calendar-body-label{padding:0 7.14286% 0 0;transform:translateX(6px);text-align:right} /*# sourceMappingURL=calendar-body.css.map */ "],
                host: {
                    class: 'xpo-calendar-body',
                },
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoCalendarBody.ctorParameters = function () { return []; };
XpoCalendarBody.propDecorators = {
    'label': [{ type: Input },],
    'rows': [{ type: Input },],
    'todayValue': [{ type: Input },],
    'selectedValue': [{ type: Input },],
    'labelMinRequiredCells': [{ type: Input },],
    'numCols': [{ type: Input },],
    'allowDisabledSelection': [{ type: Input },],
    'activeCell': [{ type: Input },],
    'selectedValueChange': [{ type: Output },],
};
/**
 * Used to generate a unique ID for each datepicker instance.
 */
var datepickerUid = 0;
/**
 * Component used as the content for the datepicker dialog and popup. We use this instead of using
 * XpoCalendar directly as the content so we can control the initial focus. This also gives us a
 * place to put additional features of the popup that are not part of the calendar itself in the
 * future. (e.g. confirmation buttons).
 * \@docs-private
 */
var XpoDatepickerContent = (function () {
    function XpoDatepickerContent() {
    }
    /**
     * @return {?}
     */
    XpoDatepickerContent.prototype.ngAfterContentInit = function () {
        this._calendar._focusActiveCell();
    };
    /**
     * Handles keydown event on datepicker content.
     * @param {?} event The event.
     * @return {?}
     */
    XpoDatepickerContent.prototype._handleKeydown = function (event) {
        if (event.keyCode === ESCAPE) {
            this.datepicker.close();
            event.preventDefault();
        }
    };
    return XpoDatepickerContent;
}());
XpoDatepickerContent.decorators = [
    { type: Component, args: [{ selector: 'xpo-datepicker-content',
                template: "<xpo-calendar cdkTrapFocus [id]=\"datepicker.id\" [startAt]=\"datepicker.startAt\" [startView]=\"datepicker.startView\" [minDate]=\"datepicker._minDate\" [maxDate]=\"datepicker._maxDate\" [dateFilter]=\"datepicker._dateFilter\" [selected]=\"datepicker._selected\" (selectedChange)=\"datepicker._selectAndClose($event)\"> </xpo-calendar>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}.xpo-calendar{width:296px}.xpo-datepicker-content-touch{display:block;max-height:80vh;margin:-24px;overflow:auto}.xpo-datepicker-content-touch .xpo-calendar{width:64vmin;max-width:750px;min-width:250px;height:80vmin;max-height:788px;min-height:312px} /*# sourceMappingURL=datepicker-content.css.map */ "],
                host: {
                    'class': 'xpo-datepicker-content',
                    '[class.xpo-datepicker-content-touch]': 'datepicker.touchUi',
                    '(keydown)': '_handleKeydown($event)',
                },
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoDatepickerContent.ctorParameters = function () { return []; };
XpoDatepickerContent.propDecorators = {
    '_calendar': [{ type: ViewChild, args: [XpoCalendar,] },],
};
/**
 * Component responsible for managing the datepicker popup/dialog.
 */
var XpoDatepicker = (function () {
    /**
     * @param {?} _dialog
     * @param {?} _overlay
     * @param {?} _ngZone
     * @param {?} _viewContainerRef
     * @param {?} _dateAdapter
     * @param {?} _dir
     * @param {?} _document
     */
    function XpoDatepicker(_dialog, _overlay, _ngZone, _viewContainerRef, _dateAdapter, _dir, _document) {
        this._dialog = _dialog;
        this._overlay = _overlay;
        this._ngZone = _ngZone;
        this._viewContainerRef = _viewContainerRef;
        this._dateAdapter = _dateAdapter;
        this._dir = _dir;
        this._document = _document;
        /**
         * The view that the calendar should start in.
         */
        this.startView = 'month';
        /**
         * Whether the calendar UI is in touch mode. In touch mode the calendar opens in a dialog rather
         * than a popup and elements have more padding to allow for bigger touch targets.
         */
        this.touchUi = false;
        /**
         * Emits new selected date when selected date changes.
         */
        this.selectedChanged = new EventEmitter();
        /**
         * Whether the calendar is open.
         */
        this.opened = false;
        /**
         * The id for the datepicker calendar.
         */
        this.id = "xpo-datepicker-" + datepickerUid++;
        /**
         * The currently selected date.
         */
        this._selected = null;
        /**
         * The element that was focused before the datepicker was opened.
         */
        this._focusedElementBeforeOpen = null;
        if (!this._dateAdapter) {
            throw createMissingDateImplError('DateAdapter');
        }
    }
    Object.defineProperty(XpoDatepicker.prototype, "startAt", {
        /**
         * The date to open the calendar to initially.
         * @return {?}
         */
        get: function () {
            // If an explicit startAt is set we start there, otherwise we start at whatever the currently
            // selected value is.
            return this._startAt || (this._datepickerInput ? this._datepickerInput.value : null);
        },
        /**
         * @param {?} date
         * @return {?}
         */
        set: function (date) { this._startAt = date; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepicker.prototype, "disabled", {
        /**
         * Whether the datepicker pop-up should be disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled === undefined ? this._datepickerInput.disabled : this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepicker.prototype, "_minDate", {
        /**
         * The minimum selectable date.
         * @return {?}
         */
        get: function () {
            return this._datepickerInput && this._datepickerInput.min;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepicker.prototype, "_maxDate", {
        /**
         * The maximum selectable date.
         * @return {?}
         */
        get: function () {
            return this._datepickerInput && this._datepickerInput.max;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepicker.prototype, "_dateFilter", {
        /**
         * @return {?}
         */
        get: function () {
            return this._datepickerInput && this._datepickerInput._dateFilter;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoDatepicker.prototype.ngOnDestroy = function () {
        this.close();
        if (this._popupRef) {
            this._popupRef.dispose();
        }
        if (this._inputSubscription) {
            this._inputSubscription.unsubscribe();
        }
    };
    /**
     * Selects the given date and closes the currently open popup or dialog.
     * @param {?} date
     * @return {?}
     */
    XpoDatepicker.prototype._selectAndClose = function (date) {
        var /** @type {?} */ oldValue = this._selected;
        this._selected = date;
        if (!this._dateAdapter.sameDate(oldValue, this._selected)) {
            this.selectedChanged.emit(date);
        }
        this.close();
    };
    /**
     * Register an input with this datepicker.
     * @param {?} input The datepicker input to register with this datepicker.
     * @return {?}
     */
    XpoDatepicker.prototype._registerInput = function (input) {
        var _this = this;
        if (this._datepickerInput) {
            throw Error('An XpoDatepicker can only be associated with a single input.');
        }
        this._datepickerInput = input;
        this._inputSubscription =
            this._datepickerInput._valueChange.subscribe(function (value) { return _this._selected = value; });
    };
    /**
     * Open the calendar.
     * @return {?}
     */
    XpoDatepicker.prototype.open = function () {
        if (this.opened || this.disabled) {
            return;
        }
        if (!this._datepickerInput) {
            throw Error('Attempted to open an XpoDatepicker with no associated input.');
        }
        if (this._document) {
            this._focusedElementBeforeOpen = this._document.activeElement;
        }
        this.touchUi ? this._openAsDialog() : this._openAsPopup();
        this.opened = true;
    };
    /**
     * Close the calendar.
     * @return {?}
     */
    XpoDatepicker.prototype.close = function () {
        if (!this.opened) {
            return;
        }
        if (this._popupRef && this._popupRef.hasAttached()) {
            this._popupRef.detach();
        }
        if (this._dialogRef) {
            this._dialogRef.close();
            this._dialogRef = null;
        }
        if (this._calendarPortal && this._calendarPortal.isAttached) {
            this._calendarPortal.detach();
        }
        if (this._focusedElementBeforeOpen && 'focus' in this._focusedElementBeforeOpen) {
            this._focusedElementBeforeOpen.focus();
            this._focusedElementBeforeOpen = null;
        }
        this.opened = false;
    };
    /**
     * Open the calendar as a dialog.
     * @return {?}
     */
    XpoDatepicker.prototype._openAsDialog = function () {
        var _this = this;
        this._dialogRef = this._dialog.open(XpoDatepickerContent, {
            viewContainerRef: this._viewContainerRef,
            direction: this._dir ? this._dir.value : 'ltr',
        });
        this._dialogRef.afterClosed().subscribe(function () { return _this.close(); });
        this._dialogRef.componentInstance.datepicker = this;
    };
    /**
     * Open the calendar as a popup.
     * @return {?}
     */
    XpoDatepicker.prototype._openAsPopup = function () {
        var _this = this;
        if (!this._calendarPortal) {
            this._calendarPortal = new ComponentPortal(XpoDatepickerContent, this._viewContainerRef);
        }
        if (!this._popupRef) {
            this._createPopup();
        }
        if (!this._popupRef.hasAttached()) {
            var /** @type {?} */ componentRef = this._popupRef.attach(this._calendarPortal);
            componentRef.instance.datepicker = this;
            // Update the position once the calendar has rendered.
            first$1.call(this._ngZone.onStable).subscribe(function () { return _this._popupRef.updatePosition(); });
        }
        this._popupRef.backdropClick().subscribe(function () { return _this.close(); });
    };
    /**
     * Create the popup.
     * @return {?}
     */
    XpoDatepicker.prototype._createPopup = function () {
        var /** @type {?} */ overlayState = new OverlayState();
        overlayState.positionStrategy = this._createPopupPositionStrategy();
        overlayState.hasBackdrop = true;
        overlayState.backdropClass = 'xpo-overlay-transparent-backdrop';
        overlayState.direction = this._dir ? this._dir.value : 'ltr';
        overlayState.scrollStrategy = this._overlay.scrollStrategies.reposition();
        this._popupRef = this._overlay.create(overlayState);
    };
    /**
     * Create the popup PositionStrategy.
     * @return {?}
     */
    XpoDatepicker.prototype._createPopupPositionStrategy = function () {
        return this._overlay.position()
            .connectedTo(this._datepickerInput.getPopupConnectionElementRef(), { originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' })
            .withFallbackPosition({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' })
            .withFallbackPosition({ originX: 'end', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' })
            .withFallbackPosition({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' });
    };
    return XpoDatepicker;
}());
XpoDatepicker.decorators = [
    { type: Component, args: [{ selector: 'xpo-datepicker',
                template: '',
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoDatepicker.ctorParameters = function () { return [
    { type: XpoDialog, },
    { type: Overlay, },
    { type: NgZone, },
    { type: ViewContainerRef, },
    { type: DateAdapter, decorators: [{ type: Optional },] },
    { type: Directionality, decorators: [{ type: Optional },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] },] },
]; };
XpoDatepicker.propDecorators = {
    'startAt': [{ type: Input },],
    'startView': [{ type: Input },],
    'touchUi': [{ type: Input },],
    'disabled': [{ type: Input },],
    'selectedChanged': [{ type: Output },],
};
var XPO_DATEPICKER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return XpoDatepickerInput; }),
    multi: true,
};
var XPO_DATEPICKER_VALIDATORS = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return XpoDatepickerInput; }),
    multi: true,
};
/**
 * Directive used to connect an input to a XpoDatepicker.
 */
var XpoDatepickerInput = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _dateAdapter
     * @param {?} _dateFormats
     * @param {?} _xpoInputContainer
     */
    function XpoDatepickerInput(_elementRef, _renderer, _dateAdapter, _dateFormats, _xpoInputContainer) {
        var _this = this;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._dateAdapter = _dateAdapter;
        this._dateFormats = _dateFormats;
        this._xpoInputContainer = _xpoInputContainer;
        /**
         * Emits when the value changes (either due to user input or programmatic change).
         */
        this._valueChange = new EventEmitter();
        this._onTouched = function () { };
        this._cvaOnChange = function () { };
        this._validatorOnChange = function () { };
        /**
         * The form control validator for the min date.
         */
        this._minValidator = function (control) {
            return (!_this.min || !control.value ||
                _this._dateAdapter.compareDate(_this.min, control.value) <= 0) ?
                null : { xpoDatepickerMin: { min: _this.min, actual: control.value } };
        };
        /**
         * The form control validator for the max date.
         */
        this._maxValidator = function (control) {
            return (!_this.max || !control.value ||
                _this._dateAdapter.compareDate(_this.max, control.value) >= 0) ?
                null : { xpoDatepickerMax: { max: _this.max, actual: control.value } };
        };
        /**
         * The form control validator for the date filter.
         */
        this._filterValidator = function (control) {
            return !_this._dateFilter || !control.value || _this._dateFilter(control.value) ?
                null : { xpoDatepickerFilter: true };
        };
        /**
         * The combined form control validator for this input.
         */
        this._validator = Validators.compose([this._minValidator, this._maxValidator, this._filterValidator]);
        if (!this._dateAdapter) {
            throw createMissingDateImplError('DateAdapter');
        }
        if (!this._dateFormats) {
            throw createMissingDateImplError('XPO_DATE_FORMATS');
        }
    }
    Object.defineProperty(XpoDatepickerInput.prototype, "xpoDatepicker", {
        /**
         * The datepicker that this input is associated with.
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._datepicker = value;
                this._datepicker._registerInput(this);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepickerInput.prototype, "xpoDatepickerFilter", {
        /**
         * @param {?} filter
         * @return {?}
         */
        set: function (filter$$1) {
            this._dateFilter = filter$$1;
            this._validatorOnChange();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepickerInput.prototype, "matDatepickerFilter", {
        /**
         * @param {?} filter
         * @return {?}
         */
        set: function (filter$$1) {
            this.xpoDatepickerFilter = filter$$1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepickerInput.prototype, "value", {
        /**
         * The value of the input.
         * @return {?}
         */
        get: function () {
            return this._dateAdapter.parse(this._elementRef.nativeElement.value, this._dateFormats.parse.dateInput);
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var /** @type {?} */ date = this._dateAdapter.parse(value, this._dateFormats.parse.dateInput);
            var /** @type {?} */ oldDate = this.value;
            this._renderer.setProperty(this._elementRef.nativeElement, 'value', date ? this._dateAdapter.format(date, this._dateFormats.display.dateInput) : '');
            if (!this._dateAdapter.sameDate(oldDate, date)) {
                this._valueChange.emit(date);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepickerInput.prototype, "min", {
        /**
         * The minimum valid date.
         * @return {?}
         */
        get: function () { return this._min; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._min = value;
            this._validatorOnChange();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepickerInput.prototype, "max", {
        /**
         * The maximum valid date.
         * @return {?}
         */
        get: function () { return this._max; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._max = value;
            this._validatorOnChange();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoDatepickerInput.prototype, "disabled", {
        /**
         * Whether the datepicker-input is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoDatepickerInput.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (this._datepicker) {
            this._datepickerSubscription =
                this._datepicker.selectedChanged.subscribe(function (selected) {
                    _this.value = selected;
                    _this._cvaOnChange(selected);
                });
        }
    };
    /**
     * @return {?}
     */
    XpoDatepickerInput.prototype.ngOnDestroy = function () {
        if (this._datepickerSubscription) {
            this._datepickerSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    XpoDatepickerInput.prototype.registerOnValidatorChange = function (fn) {
        this._validatorOnChange = fn;
    };
    /**
     * @param {?} c
     * @return {?}
     */
    XpoDatepickerInput.prototype.validate = function (c) {
        return this._validator ? this._validator(c) : null;
    };
    /**
     * Gets the element that the datepicker popup should be connected to.
     * @return {?} The element to connect the popup to.
     */
    XpoDatepickerInput.prototype.getPopupConnectionElementRef = function () {
        return this._xpoInputContainer ? this._xpoInputContainer.underlineRef : this._elementRef;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    XpoDatepickerInput.prototype.writeValue = function (value) {
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    XpoDatepickerInput.prototype.registerOnChange = function (fn) {
        this._cvaOnChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    XpoDatepickerInput.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    /**
     * @param {?} disabled
     * @return {?}
     */
    XpoDatepickerInput.prototype.setDisabledState = function (disabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', disabled);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoDatepickerInput.prototype._onKeydown = function (event) {
        if (event.altKey && event.keyCode === DOWN_ARROW) {
            this._datepicker.open();
            event.preventDefault();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    XpoDatepickerInput.prototype._onInput = function (value) {
        var /** @type {?} */ date = this._dateAdapter.parse(value, this._dateFormats.parse.dateInput);
        this._cvaOnChange(date);
        this._valueChange.emit(date);
    };
    return XpoDatepickerInput;
}());
XpoDatepickerInput.decorators = [
    { type: Directive, args: [{
                selector: 'input[xpoDatepicker]',
                providers: [XPO_DATEPICKER_VALUE_ACCESSOR, XPO_DATEPICKER_VALIDATORS],
                host: {
                    '[attr.aria-expanded]': '_datepicker?.opened || "false"',
                    '[attr.aria-haspopup]': 'true',
                    '[attr.aria-owns]': '_datepicker?.id',
                    '[attr.min]': 'min ? _dateAdapter.getISODateString(min) : null',
                    '[attr.max]': 'max ? _dateAdapter.getISODateString(max) : null',
                    '[disabled]': 'disabled',
                    '(input)': '_onInput($event.target.value)',
                    '(blur)': '_onTouched()',
                    '(keydown)': '_onKeydown($event)',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoDatepickerInput.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: DateAdapter, decorators: [{ type: Optional },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [XPO_DATE_FORMATS,] },] },
    { type: XpoInputContainer, decorators: [{ type: Optional },] },
]; };
XpoDatepickerInput.propDecorators = {
    'xpoDatepicker': [{ type: Input },],
    'xpoDatepickerFilter': [{ type: Input },],
    'matDatepickerFilter': [{ type: Input },],
    'value': [{ type: Input },],
    'min': [{ type: Input },],
    'max': [{ type: Input },],
    'disabled': [{ type: Input },],
};
var XpoDatepickerToggle = (function () {
    /**
     * @param {?} _intl
     */
    function XpoDatepickerToggle(_intl) {
        this._intl = _intl;
        /**
         * Type of the button.
         */
        this.type = 'button';
    }
    Object.defineProperty(XpoDatepickerToggle.prototype, "_datepicker", {
        /**
         * @return {?}
         */
        get: function () { return this.datepicker; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.datepicker = v; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    XpoDatepickerToggle.prototype._open = function (event) {
        if (this.datepicker) {
            this.datepicker.open();
            event.stopPropagation();
        }
    };
    return XpoDatepickerToggle;
}());
XpoDatepickerToggle.decorators = [
    { type: Component, args: [{ selector: 'button[xpoDatepickerToggle], button[matDatepickerToggle]',
                template: '',
                styles: ["@charset \"UTF-8\";:host.xpo-datepicker-toggle{display:inline-block;width:16px;height:16px;padding:0;outline:0;font-family:XPOicon;line-height:1;border:none;background-color:transparent;-webkit-font-smoothing:antialiased}:host.xpo-datepicker-toggle::before{content:\"\"}:host.xpo-datepicker-toggle:not([disabled]){cursor:pointer}:host-context(.xpo-internal){transform:translateY(-2px);font-size:14px}:host-context(.xpo-external){font-size:16px} /*# sourceMappingURL=datepicker-toggle.css.map */ "],
                host: {
                    '[attr.type]': 'type',
                    '[class.xpo-datepicker-toggle]': 'true',
                    '[attr.aria-label]': '_intl.openCalendarLabel',
                    '(click)': '_open($event)',
                },
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoDatepickerToggle.ctorParameters = function () { return [
    { type: XpoDatepickerIntl, },
]; };
XpoDatepickerToggle.propDecorators = {
    'datepicker': [{ type: Input, args: ['xpoDatepickerToggle',] },],
    'type': [{ type: Input },],
    '_datepicker': [{ type: Input, args: ['matDatepickerToggle',] },],
};
var DAYS_PER_WEEK = 7;
/**
 * An internal component used to display a single month in the datepicker.
 * \@docs-private
 */
var XpoMonthView = (function () {
    /**
     * @param {?} _dateAdapter
     * @param {?} _dateFormats
     */
    function XpoMonthView(_dateAdapter, _dateFormats) {
        this._dateAdapter = _dateAdapter;
        this._dateFormats = _dateFormats;
        /**
         * Emits when a new date is selected.
         */
        this.selectedChange = new EventEmitter();
        if (!this._dateAdapter) {
            throw createMissingDateImplError('DateAdapter');
        }
        if (!this._dateFormats) {
            throw createMissingDateImplError('XPO_DATE_FORMATS');
        }
        var firstDayOfWeek = this._dateAdapter.getFirstDayOfWeek();
        var narrowWeekdays = this._dateAdapter.getDayOfWeekNames('narrow');
        var longWeekdays = this._dateAdapter.getDayOfWeekNames('long');
        // Rotate the labels for days of the week based on the configured first day of the week.
        var weekdays = longWeekdays.map(function (long, i) {
            return { long: long, narrow: narrowWeekdays[i] };
        });
        this._weekdays = weekdays.slice(firstDayOfWeek).concat(weekdays.slice(0, firstDayOfWeek));
        this._activeDate = this._dateAdapter.today();
    }
    Object.defineProperty(XpoMonthView.prototype, "activeDate", {
        /**
         * The date to display in this month view (everything other than the month and year is ignored).
         * @return {?}
         */
        get: function () { return this._activeDate; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var /** @type {?} */ oldActiveDate = this._activeDate;
            this._activeDate = value || this._dateAdapter.today();
            if (!this._hasSameMonthAndYear(oldActiveDate, this._activeDate)) {
                this._init();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMonthView.prototype, "selected", {
        /**
         * The currently selected date.
         * @return {?}
         */
        get: function () { return this._selected; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selected = value;
            this._selectedDate = this._getDateInCurrentMonth(this.selected);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoMonthView.prototype.ngAfterContentInit = function () {
        this._init();
    };
    /**
     * Handles when a new date is selected.
     * @param {?} date
     * @return {?}
     */
    XpoMonthView.prototype._dateSelected = function (date) {
        if (this._selectedDate == date) {
            return;
        }
        this.selectedChange.emit(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), date));
    };
    /**
     * Initializes this month view.
     * @return {?}
     */
    XpoMonthView.prototype._init = function () {
        this._selectedDate = this._getDateInCurrentMonth(this.selected);
        this._todayDate = this._getDateInCurrentMonth(this._dateAdapter.today());
        this._monthLabel =
            this._dateAdapter.getMonthNames('short')[this._dateAdapter.getMonth(this.activeDate)]
                .toLocaleUpperCase();
        var /** @type {?} */ firstOfMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), 1);
        this._firstWeekOffset =
            (DAYS_PER_WEEK + this._dateAdapter.getDayOfWeek(firstOfMonth) -
                this._dateAdapter.getFirstDayOfWeek()) % DAYS_PER_WEEK;
        this._createWeekCells();
    };
    /**
     * Creates XpoCalendarCells for the dates in this month.
     * @return {?}
     */
    XpoMonthView.prototype._createWeekCells = function () {
        var /** @type {?} */ daysInMonth = this._dateAdapter.getNumDaysInMonth(this.activeDate);
        var /** @type {?} */ dateNames = this._dateAdapter.getDateNames();
        this._weeks = [[]];
        for (var /** @type {?} */ i = 0, /** @type {?} */ cell = this._firstWeekOffset; i < daysInMonth; i++, cell++) {
            if (cell == DAYS_PER_WEEK) {
                this._weeks.push([]);
                cell = 0;
            }
            var /** @type {?} */ date = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), i + 1);
            var /** @type {?} */ enabled = !this.dateFilter ||
                this.dateFilter(date);
            var /** @type {?} */ ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.dateA11yLabel);
            this._weeks[this._weeks.length - 1]
                .push(new XpoCalendarCell(i + 1, dateNames[i], ariaLabel, enabled));
        }
    };
    /**
     * Gets the date in this month that the given Date falls on.
     * Returns null if the given Date is in another month.
     * @param {?} date
     * @return {?}
     */
    XpoMonthView.prototype._getDateInCurrentMonth = function (date) {
        return this._hasSameMonthAndYear(date, this.activeDate) ?
            this._dateAdapter.getDate(date) : null;
    };
    /**
     * Checks whether the 2 dates are non-null and fall within the same month of the same year.
     * @param {?} d1
     * @param {?} d2
     * @return {?}
     */
    XpoMonthView.prototype._hasSameMonthAndYear = function (d1, d2) {
        return !!(d1 && d2 && this._dateAdapter.getMonth(d1) == this._dateAdapter.getMonth(d2) &&
            this._dateAdapter.getYear(d1) == this._dateAdapter.getYear(d2));
    };
    return XpoMonthView;
}());
XpoMonthView.decorators = [
    { type: Component, args: [{ selector: 'xpo-month-view',
                template: "<table class=\"xpo-calendar-table\"> <thead class=\"xpo-calendar-table-header\"> <tr> <th *ngFor=\"let day of _weekdays\" [attr.aria-label]=\"day.long\">{{day.narrow}}</th> </tr> <tr> <th class=\"xpo-calendar-table-header-divider\" colspan=\"7\" aria-hidden=\"true\"></th> </tr> </thead> <tbody xpo-calendar-body role=\"grid\" [label]=\"_monthLabel\" [rows]=\"_weeks\" [todayValue]=\"_todayDate\" [selectedValue]=\"_selectedDate\" [labelMinRequiredCells]=\"3\" [activeCell]=\"_dateAdapter.getDate(activeDate) - 1\" (selectedValueChange)=\"_dateSelected($event)\"> </tbody> </table>",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoMonthView.ctorParameters = function () { return [
    { type: DateAdapter, decorators: [{ type: Optional },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [XPO_DATE_FORMATS,] },] },
]; };
XpoMonthView.propDecorators = {
    'activeDate': [{ type: Input },],
    'selected': [{ type: Input },],
    'dateFilter': [{ type: Input },],
    'selectedChange': [{ type: Output },],
};
/**
 * An internal component used to display a single year in the datepicker.
 * \@docs-private
 */
var XpoYearView = (function () {
    /**
     * @param {?} _dateAdapter
     * @param {?} _dateFormats
     */
    function XpoYearView(_dateAdapter, _dateFormats) {
        this._dateAdapter = _dateAdapter;
        this._dateFormats = _dateFormats;
        /**
         * Emits when a new month is selected.
         */
        this.selectedChange = new EventEmitter();
        if (!this._dateAdapter) {
            throw createMissingDateImplError('DateAdapter');
        }
        if (!this._dateFormats) {
            throw createMissingDateImplError('XPO_DATE_FORMATS');
        }
        this._activeDate = this._dateAdapter.today();
    }
    Object.defineProperty(XpoYearView.prototype, "activeDate", {
        /**
         * The date to display in this year view (everything other than the year is ignored).
         * @return {?}
         */
        get: function () { return this._activeDate; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var /** @type {?} */ oldActiveDate = this._activeDate;
            this._activeDate = value || this._dateAdapter.today();
            if (this._dateAdapter.getYear(oldActiveDate) != this._dateAdapter.getYear(this._activeDate)) {
                this._init();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoYearView.prototype, "selected", {
        /**
         * The currently selected date.
         * @return {?}
         */
        get: function () { return this._selected; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selected = value;
            this._selectedMonth = this._getMonthInCurrentYear(this.selected);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoYearView.prototype.ngAfterContentInit = function () {
        this._init();
    };
    /**
     * Handles when a new month is selected.
     * @param {?} month
     * @return {?}
     */
    XpoYearView.prototype._monthSelected = function (month) {
        this.selectedChange.emit(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, this._dateAdapter.getDate(this.activeDate)));
    };
    /**
     * Initializes this month view.
     * @return {?}
     */
    XpoYearView.prototype._init = function () {
        var _this = this;
        this._selectedMonth = this._getMonthInCurrentYear(this.selected);
        this._todayMonth = this._getMonthInCurrentYear(this._dateAdapter.today());
        this._yearLabel = this._dateAdapter.getYearName(this.activeDate);
        var /** @type {?} */ monthNames = this._dateAdapter.getMonthNames('short');
        // First row of months only contains 5 elements so we can fit the year label on the same row.
        this._months = [[0, 1, 2, 3, 4], [5, 6, 7, 8, 9, 10, 11]].map(function (row) { return row.map(function (month) { return _this._createCellForMonth(month, monthNames[month]); }); });
    };
    /**
     * Gets the month in this year that the given Date falls on.
     * Returns null if the given Date is in another year.
     * @param {?} date
     * @return {?}
     */
    XpoYearView.prototype._getMonthInCurrentYear = function (date) {
        return date && this._dateAdapter.getYear(date) == this._dateAdapter.getYear(this.activeDate) ?
            this._dateAdapter.getMonth(date) : null;
    };
    /**
     * Creates an XpoCalendarCell for the given month.
     * @param {?} month
     * @param {?} monthName
     * @return {?}
     */
    XpoYearView.prototype._createCellForMonth = function (month, monthName) {
        var /** @type {?} */ ariaLabel = this._dateAdapter.format(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1), this._dateFormats.display.monthYearA11yLabel);
        return new XpoCalendarCell(month, monthName.toLocaleUpperCase(), ariaLabel, this._isMonthEnabled(month));
    };
    /**
     * Whether the given month is enabled.
     * @param {?} month
     * @return {?}
     */
    XpoYearView.prototype._isMonthEnabled = function (month) {
        if (!this.dateFilter) {
            return true;
        }
        var /** @type {?} */ firstOfMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
        // If any date in the month is enabled count the month as enabled.
        for (var /** @type {?} */ date = firstOfMonth; this._dateAdapter.getMonth(date) == month; date = this._dateAdapter.addCalendarDays(date, 1)) {
            if (this.dateFilter(date)) {
                return true;
            }
        }
        return false;
    };
    return XpoYearView;
}());
XpoYearView.decorators = [
    { type: Component, args: [{ selector: 'xpo-year-view',
                template: "<table class=\"xpo-calendar-table\"> <thead class=\"xpo-calendar-table-header\"> <tr> <th class=\"xpo-calendar-table-header-divider\" colspan=\"7\"></th> </tr> </thead> <tbody xpo-calendar-body role=\"grid\" allowDisabledSelection=\"true\" [label]=\"_yearLabel\" [rows]=\"_months\" [todayValue]=\"_todayMonth\" [selectedValue]=\"_selectedMonth\" [labelMinRequiredCells]=\"2\" [activeCell]=\"_dateAdapter.getMonth(activeDate)\" (selectedValueChange)=\"_monthSelected($event)\"> </tbody> </table>",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoYearView.ctorParameters = function () { return [
    { type: DateAdapter, decorators: [{ type: Optional },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [XPO_DATE_FORMATS,] },] },
]; };
XpoYearView.propDecorators = {
    'activeDate': [{ type: Input },],
    'selected': [{ type: Input },],
    'dateFilter': [{ type: Input },],
    'selectedChange': [{ type: Output },],
};
var XpoDatepickerModule = (function () {
    function XpoDatepickerModule() {
    }
    return XpoDatepickerModule;
}());
XpoDatepickerModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    XpoButtonModule,
                    XpoDialogModule,
                    OverlayModule,
                    StyleModule,
                    A11yModule,
                ],
                exports: [
                    XpoDatepicker,
                    XpoDatepickerContent,
                    XpoDatepickerInput,
                    XpoDatepickerToggle,
                ],
                declarations: [
                    XpoCalendar,
                    XpoCalendarBody,
                    XpoDatepicker,
                    XpoDatepickerContent,
                    XpoDatepickerInput,
                    XpoDatepickerToggle,
                    XpoMonthView,
                    XpoYearView,
                ],
                providers: [
                    XpoDatepickerIntl,
                ],
                entryComponents: [
                    XpoDatepickerContent,
                ],
            },] },
];
/**
 * @nocollapse
 */
XpoDatepickerModule.ctorParameters = function () { return []; };
var XpoHttpError = (function () {
    function XpoHttpError() {
        this.httpStatusCode = 0;
        this.summary = '';
        this.detail = '';
    }
    /**
     * @return {?}
     */
    XpoHttpError.prototype.ngOnInit = function () {
        if (this.httpStatusCode == 403) {
            this.summary = this.summary ? this.summary : "Access Denied";
            this.detail = this.detail ? this.detail : "You do not have permissions to access the requested page.";
        }
        if (this.httpStatusCode == 404) {
            this.summary = this.summary ? this.summary : "Page Not Found";
            this.detail = this.detail ? this.detail : "We're sorry, but we could not find the page you are looking for.";
        }
        if (this.httpStatusCode == 500) {
            this.summary = this.summary ? this.summary : "Internal Server Error";
            this.detail = this.detail ? this.detail : "We apologize for the inconvenience. The issue has been logged and we will be working to correct it.";
        }
    };
    return XpoHttpError;
}());
XpoHttpError.decorators = [
    { type: Component, args: [{ selector: 'xpo-http-error',
                template: "<h1> {{ httpStatusCode }}</h1> <p class=\"summary\">{{ summary }}</p> <p class=\"details\">{{ detail }}</p> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:block;width:300px;margin:0 auto;padding:15px;text-align:center}h1{margin:0;font-size:8rem;color:#d50000;line-height:1}.summary{margin:0;font-size:1.6666rem;font-weight:700;text-transform:uppercase}.details{margin:26px 0 0;font-size:1.3333rem} /*# sourceMappingURL=http-error.css.map */ "],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.Emulated,
            },] },
];
/**
 * @nocollapse
 */
XpoHttpError.ctorParameters = function () { return []; };
XpoHttpError.propDecorators = {
    'httpStatusCode': [{ type: Input },],
    'summary': [{ type: Input },],
    'detail': [{ type: Input },],
};
var XpoHttpErrorModule = (function () {
    function XpoHttpErrorModule() {
    }
    return XpoHttpErrorModule;
}());
XpoHttpErrorModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                ],
                exports: [
                    XpoHttpError,
                ],
                declarations: [
                    XpoHttpError,
                ],
            },] },
];
/**
 * @nocollapse
 */
XpoHttpErrorModule.ctorParameters = function () { return []; };
/**
 * <xpo-loader> displays an animated icon to the user while waiting for an event action or page load to complete.
 */
var XpoLoader = (function () {
    function XpoLoader() {
        this.spinnerType = 'S-6';
        this.backgroundColor = null;
    }
    Object.defineProperty(XpoLoader.prototype, "type", {
        /**
         * Type of loader.
         * @return {?}
         */
        get: function () { return this.spinnerType; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.spinnerType = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoLoader.prototype, "color", {
        /**
         * Color of the loader.
         * @return {?}
         */
        get: function () { return this.backgroundColor; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.backgroundColor = value; },
        enumerable: true,
        configurable: true
    });
    return XpoLoader;
}());
XpoLoader.decorators = [
    { type: Component, args: [{ selector: 'xpo-loader',
                host: {},
                template: "<!-- TWISTING BOX --> <div class=\"spinner1\" *ngIf=\"spinnerType === 'S-1'\" [ngStyle]=\"{ 'background-color': backgroundColor }\"></div> <!-- CUBE GRID --> <div class=\"sk-cube-grid\" *ngIf=\"spinnerType === 'S-2'\" [ngStyle]=\"{ 'background-color': backgroundColor }\"> <div class=\"sk-cube sk-cube1\"></div> <div class=\"sk-cube sk-cube2\"></div> <div class=\"sk-cube sk-cube3\"></div> <div class=\"sk-cube sk-cube4\"></div> <div class=\"sk-cube sk-cube5\"></div> <div class=\"sk-cube sk-cube6\"></div> <div class=\"sk-cube sk-cube7\"></div> <div class=\"sk-cube sk-cube8\"></div> <div class=\"sk-cube sk-cube9\"></div> </div> <!-- PULSING CIRCLE --> <div class=\"spinner3\" *ngIf=\"spinnerType === 'S-3'\" [ngStyle]=\"{ 'background-color': backgroundColor }\"> <div class=\"double-bounce1\"></div> <div class=\"double-bounce2\"></div> </div> <!-- LINES --> <div class=\"spinner4\" *ngIf=\"spinnerType === 'S-4'\" [ngStyle]=\"{ 'background-color': backgroundColor }\"> <div class=\"rect1\"></div> <div class=\"rect2\"></div> <div class=\"rect3\"></div> <div class=\"rect4\"></div> <div class=\"rect5\"></div> </div> <!--PULSING CIRCLES--> <div class=\"spinner5\" *ngIf=\"spinnerType === 'S-5'\" [ngStyle]=\"{ 'background-color': backgroundColor }\"> <div class=\"bounce1\"></div> <div class=\"bounce2\"></div> <div class=\"bounce3\"></div> </div> <!--ROTATING CIRCLE--> <div class=\"sk-circle\" *ngIf=\"spinnerType === 'S-6'\" [ngStyle]=\"{ 'background-color': backgroundColor }\"> <div class=\"sk-circle1 sk-child\"></div> <div class=\"sk-circle2 sk-child\"></div> <div class=\"sk-circle3 sk-child\"></div> <div class=\"sk-circle4 sk-child\"></div> <div class=\"sk-circle5 sk-child\"></div> <div class=\"sk-circle6 sk-child\"></div> <div class=\"sk-circle7 sk-child\"></div> <div class=\"sk-circle8 sk-child\"></div> <div class=\"sk-circle9 sk-child\"></div> <div class=\"sk-circle10 sk-child\"></div> <div class=\"sk-circle11 sk-child\"></div> <div class=\"sk-circle12 sk-child\"></div> </div> <!--FOLDING CUBE--> <div class=\"sk-folding-cube\" *ngIf=\"spinnerType === 'S-7'\" [ngStyle]=\"{ 'background-color': backgroundColor }\"> <div class=\"sk-cube1 sk-cube\"></div> <div class=\"sk-cube2 sk-cube\"></div> <div class=\"sk-cube4 sk-cube\"></div> <div class=\"sk-cube3 sk-cube\"></div> </div>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host .spinner1{width:40px;height:40px;margin:100px auto;background-color:#333;-webkit-animation:sk-rotateplane 1.2s infinite ease-in-out;animation:sk-rotateplane 1.2s infinite ease-in-out}:host .sk-cube-grid{width:40px;height:40px;margin:100px auto}:host .sk-cube-grid .sk-cube{width:33%;height:33%;float:left;background-color:#333;-webkit-animation:sk-cubeGridScaleDelay 1.3s infinite ease-in-out;animation:sk-cubeGridScaleDelay 1.3s infinite ease-in-out}:host .sk-cube-grid .sk-cube1{-webkit-animation-delay:.2s;animation-delay:.2s}:host .sk-cube-grid .sk-cube2{-webkit-animation-delay:.3s;animation-delay:.3s}:host .sk-cube-grid .sk-cube3{-webkit-animation-delay:.4s;animation-delay:.4s}:host .sk-cube-grid .sk-cube4{-webkit-animation-delay:.1s;animation-delay:.1s}:host .sk-cube-grid .sk-cube5{-webkit-animation-delay:.2s;animation-delay:.2s}:host .sk-cube-grid .sk-cube6{-webkit-animation-delay:.3s;animation-delay:.3s}:host .sk-cube-grid .sk-cube7{-webkit-animation-delay:0s;animation-delay:0s}:host .sk-cube-grid .sk-cube8{-webkit-animation-delay:.1s;animation-delay:.1s}:host .sk-cube-grid .sk-cube9{-webkit-animation-delay:.2s;animation-delay:.2s}:host .spinner3{width:40px;height:40px;margin:100px auto;position:relative}:host .double-bounce1,:host .double-bounce2{width:100%;height:100%;position:absolute;top:0;left:0;opacity:.6;border-radius:50%;background-color:#333;-webkit-animation:sk-bounce 2s infinite ease-in-out;animation:sk-bounce 2s infinite ease-in-out}:host .double-bounce2{-webkit-animation-delay:-1s;animation-delay:-1s}:host .spinner4{width:50px;height:40px;margin:100px auto;font-size:10px;text-align:center}:host .spinner4>div{display:inline-block;width:6px;height:100%;background-color:#333;-webkit-animation:sk-stretchdelay 1.2s infinite ease-in-out;animation:sk-stretchdelay 1.2s infinite ease-in-out}:host .spinner4 .rect2{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}:host .spinner4 .rect3{-webkit-animation-delay:-1s;animation-delay:-1s}:host .spinner4 .rect4{-webkit-animation-delay:-.9s;animation-delay:-.9s}:host .spinner4 .rect5{-webkit-animation-delay:-.8s;animation-delay:-.8s}:host .spinner5{width:70px;margin:100px auto 0;text-align:center}:host .spinner5>div{display:inline-block;width:18px;height:18px;border-radius:100%;background-color:#333;-webkit-animation:sk-bouncedelay 1.4s infinite ease-in-out both;animation:sk-bouncedelay 1.4s infinite ease-in-out both}:host .spinner5 .bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}:host .spinner5 .bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}:host .sk-circle{width:40px;height:40px;margin:100px auto;position:relative}:host .sk-circle .sk-child{width:100%;height:100%;position:absolute;top:0;left:0}:host .sk-circle .sk-child::before{display:block;width:15%;height:15%;margin:0 auto;content:\"\";border-radius:100%;background-color:#333;-webkit-animation:sk-circleBounceDelay 1.2s infinite ease-in-out both;animation:sk-circleBounceDelay 1.2s infinite ease-in-out both}:host .sk-circle .sk-circle2{-webkit-transform:rotate(30deg);-ms-transform:rotate(30deg);transform:rotate(30deg)}:host .sk-circle .sk-circle3{-webkit-transform:rotate(60deg);-ms-transform:rotate(60deg);transform:rotate(60deg)}:host .sk-circle .sk-circle4{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}:host .sk-circle .sk-circle5{-webkit-transform:rotate(120deg);-ms-transform:rotate(120deg);transform:rotate(120deg)}:host .sk-circle .sk-circle6{-webkit-transform:rotate(150deg);-ms-transform:rotate(150deg);transform:rotate(150deg)}:host .sk-circle .sk-circle7{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}:host .sk-circle .sk-circle8{-webkit-transform:rotate(210deg);-ms-transform:rotate(210deg);transform:rotate(210deg)}:host .sk-circle .sk-circle9{-webkit-transform:rotate(240deg);-ms-transform:rotate(240deg);transform:rotate(240deg)}:host .sk-circle .sk-circle10{-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}:host .sk-circle .sk-circle11{-webkit-transform:rotate(300deg);-ms-transform:rotate(300deg);transform:rotate(300deg)}:host .sk-circle .sk-circle12{-webkit-transform:rotate(330deg);-ms-transform:rotate(330deg);transform:rotate(330deg)}:host .sk-circle .sk-circle2::before{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}:host .sk-circle .sk-circle3::before{-webkit-animation-delay:-1s;animation-delay:-1s}:host .sk-circle .sk-circle4::before{-webkit-animation-delay:-.9s;animation-delay:-.9s}:host .sk-circle .sk-circle5::before{-webkit-animation-delay:-.8s;animation-delay:-.8s}:host .sk-circle .sk-circle6::before{-webkit-animation-delay:-.7s;animation-delay:-.7s}:host .sk-circle .sk-circle7::before{-webkit-animation-delay:-.6s;animation-delay:-.6s}:host .sk-circle .sk-circle8::before{-webkit-animation-delay:-.5s;animation-delay:-.5s}:host .sk-circle .sk-circle9::before{-webkit-animation-delay:-.4s;animation-delay:-.4s}:host .sk-circle .sk-circle10::before{-webkit-animation-delay:-.3s;animation-delay:-.3s}:host .sk-circle .sk-circle11::before{-webkit-animation-delay:-.2s;animation-delay:-.2s}:host .sk-circle .sk-circle12::before{-webkit-animation-delay:-.1s;animation-delay:-.1s}:host .sk-folding-cube{width:40px;height:40px;margin:20px auto;position:relative;-webkit-transform:rotateZ(45deg);transform:rotateZ(45deg)}:host .sk-folding-cube .sk-cube{width:50%;height:50%;position:relative;float:left;-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}:host .sk-folding-cube .sk-cube::before{width:100%;height:100%;position:absolute;top:0;left:0;-ms-transform-origin:100% 100%;-webkit-transform-origin:100% 100%;transform-origin:100% 100%;content:\"\";background-color:#333;-webkit-animation:sk-foldCubeAngle 2.4s infinite linear both;animation:sk-foldCubeAngle 2.4s infinite linear both}:host .sk-folding-cube .sk-cube2{-webkit-transform:scale(1.1) rotateZ(90deg);transform:scale(1.1) rotateZ(90deg)}:host .sk-folding-cube .sk-cube3{-webkit-transform:scale(1.1) rotateZ(180deg);transform:scale(1.1) rotateZ(180deg)}:host .sk-folding-cube .sk-cube4{-webkit-transform:scale(1.1) rotateZ(270deg);transform:scale(1.1) rotateZ(270deg)}:host .sk-folding-cube .sk-cube2::before{-webkit-animation-delay:.3s;animation-delay:.3s}:host .sk-folding-cube .sk-cube3::before{-webkit-animation-delay:.6s;animation-delay:.6s}:host .sk-folding-cube .sk-cube4::before{-webkit-animation-delay:.9s;animation-delay:.9s}@-webkit-keyframes sk-cubeGridScaleDelay{0%,100%,70%{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}35%{-webkit-transform:scale3d(0,0,1);transform:scale3d(0,0,1)}}@keyframes sk-cubeGridScaleDelay{0%,100%,70%{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1)}35%{-webkit-transform:scale3d(0,0,1);transform:scale3d(0,0,1)}}@-webkit-keyframes sk-rotateplane{0%{-webkit-transform:perspective(120px)}50%{-webkit-transform:perspective(120px) rotateY(180deg)}100%{-webkit-transform:perspective(120px) rotateY(180deg) rotateX(180deg)}}@keyframes sk-rotateplane{0%{-webkit-transform:perspective(120px) rotateX(0) rotateY(0);transform:perspective(120px) rotateX(0) rotateY(0)}50%{-webkit-transform:perspective(120px) rotateX(-180.1deg) rotateY(0);transform:perspective(120px) rotateX(-180.1deg) rotateY(0)}100%{-webkit-transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg);transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg)}}@-webkit-keyframes sk-bounce{0%,100%{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,100%{-webkit-transform:scale(0);transform:scale(0)}50%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes sk-stretchdelay{0%,100%,40%{-webkit-transform:scaleY(.4)}20%{-webkit-transform:scaleY(1)}}@keyframes sk-stretchdelay{0%,100%,40%{-webkit-transform:scaleY(.4);transform:scaleY(.4)}20%{-webkit-transform:scaleY(1);transform:scaleY(1)}}@-webkit-keyframes sk-bouncedelay{0%,100%,80%{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes sk-circleBounceDelay{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes sk-circleBounceDelay{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes sk-foldCubeAngle{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0);transform:perspective(140px) rotateX(0);opacity:1}100%,90%{-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);opacity:0}}@keyframes sk-foldCubeAngle{0%,10%{-webkit-transform:perspective(140px) rotateX(-180deg);transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{-webkit-transform:perspective(140px) rotateX(0);transform:perspective(140px) rotateX(0);opacity:1}100%,90%{-webkit-transform:perspective(140px) rotateY(180deg);transform:perspective(140px) rotateY(180deg);opacity:0}} /*# sourceMappingURL=loader.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoLoader.ctorParameters = function () { return []; };
XpoLoader.propDecorators = {
    'type': [{ type: Input },],
    'color': [{ type: Input },],
};
var XpoLoaderModule = (function () {
    function XpoLoaderModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoLoaderModule.forRoot = function () {
        return {
            ngModule: XpoLoaderModule,
        };
    };
    return XpoLoaderModule;
}());
XpoLoaderModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoLoader],
                declarations: [XpoLoader],
            },] },
];
/**
 * @nocollapse
 */
XpoLoaderModule.ctorParameters = function () { return []; };
/**
 * Below are all the animations for the xpo-menu component.
 * Animation duration and timing values are based on AngularJS Material.
 */
/**
 * This animation controls the menu panel's entry and exit from the page.
 *
 * When the menu panel is added to the DOM, it scales in and fades in its border.
 *
 * When the menu panel is removed from the DOM, it simply fades out after a brief
 * delay to display the ripple.
 */
// TODO(kara): switch to :enter and :leave once Mobile Safari is sorted out.
var transformMenu = trigger('transformMenu', [
    state('showing', style({
        opacity: 1,
        transform: "scale(1)",
    })),
    transition('void => *', [
        style({
            opacity: 0,
            transform: "scale(0)",
        }),
        animate("200ms cubic-bezier(0.25, 0.8, 0.25, 1)"),
    ]),
    transition('* => void', [
        animate('50ms 100ms linear', style({ opacity: 0 })),
    ]),
]);
/**
 * This animation fades in the background color and content of the menu panel
 * after its containing element is scaled in.
 */
var fadeInItems = trigger('fadeInItems', [
    state('showing', style({ opacity: 1 })),
    transition('void => *', [
        style({ opacity: 0 }),
        animate("200ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)"),
    ]),
]);
/**
 * Throws an exception for the case when menu trigger doesn't have a valid xpo-menu instance
 * \@docs-private
 * @return {?}
 */
function throwXpoMenuMissingError() {
    throw new Error("xpo-menu-trigger: must pass in an xpo-menu instance.\n\n    Example:\n      <xpo-menu #menu=\"xpoMenu\"></xpo-menu>\n      <button [xpoMenuTriggerFor]=\"menu\"></button>");
}
/**
 * Throws an exception for the case when menu's x-position value isn't valid.
 * In other words, it doesn't match 'before' or 'after'.
 * \@docs-private
 * @return {?}
 */
function throwXpoMenuInvalidPositionX() {
    throw new Error("x-position value must be either 'before' or after'.\n      Example: <xpo-menu x-position=\"before\" #menu=\"xpoMenu\"></xpo-menu>");
}
/**
 * Throws an exception for the case when menu's y-position value isn't valid.
 * In other words, it doesn't match 'above' or 'below'.
 * \@docs-private
 * @return {?}
 */
function throwXpoMenuInvalidPositionY() {
    throw new Error("y-position value must be either 'above' or below'.\n      Example: <xpo-menu y-position=\"above\" #menu=\"xpoMenu\"></xpo-menu>");
}
/**
 * The [xpo-menu-item] directive is intended to be used inside an <xpo-menu> tag.
 * It exists mostly to set the role attribute.
 */
var XpoMenuItem = (function () {
    /**
     * @param {?} _elementRef
     */
    function XpoMenuItem(_elementRef) {
        this._elementRef = _elementRef;
        /**
         * Whether the menu item is disabled
         */
        this._disabled = false;
    }
    /**
     * Focuses the menu item.
     * @return {?}
     */
    XpoMenuItem.prototype.focus = function () {
        this._getHostElement().focus();
    };
    Object.defineProperty(XpoMenuItem.prototype, "disabled", {
        /**
         * Whether the menu item is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Used to set the `tabindex`.
     * @return {?}
     */
    XpoMenuItem.prototype._getTabIndex = function () {
        return this._disabled ? '-1' : '0';
    };
    /**
     * Used to set the HTML `disabled` attribute. Necessary for links to be disabled properly.
     * @return {?}
     */
    XpoMenuItem.prototype._getDisabledAttr = function () {
        return this._disabled ? true : null;
    };
    /**
     * Returns the host DOM element.
     * @return {?}
     */
    XpoMenuItem.prototype._getHostElement = function () {
        return this._elementRef.nativeElement;
    };
    /**
     * Prevents the default element actions if it is disabled.
     * @param {?} event
     * @return {?}
     */
    XpoMenuItem.prototype._checkDisabled = function (event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    return XpoMenuItem;
}());
XpoMenuItem.decorators = [
    { type: Component, args: [{ selector: '[xpo-menu-item]',
                host: {
                    'role': 'menuitem',
                    '[class.xpo-menu-item]': 'true',
                    '[attr.tabindex]': '_getTabIndex()',
                    '[attr.aria-disabled]': 'disabled.toString()',
                    '[attr.disabled]': '_getDisabledAttr()',
                    '(click)': '_checkDisabled($event)',
                },
                template: "<ng-content></ng-content> <div class=\"xpo-menu-ripple\" *ngIf=\"!disabled\" xpo-ripple [xpoRippleTrigger]=\"_getHostElement()\"> </div>",
                exportAs: 'xpoMenuItem',
            },] },
];
/**
 * @nocollapse
 */
XpoMenuItem.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
XpoMenuItem.propDecorators = {
    'disabled': [{ type: Input },],
};
// TODO(kara): prevent-close functionality
/** XpoConfigService -
   *  This is the import for the service
   */
/**
 * <xpo-menu> is a floating panel containing list of options.
 * By itself, the <xpo-menu> element does not render anything.
 * The menu is attached to and opened via application of the 'xpoMenuTriggerFor' directive.
 */
var XpoMenu = (function () {
    function XpoMenu() {
        this._xPosition = 'after';
        this._yPosition = 'below';
        /**
         * Config object to be passed into the menu's ngClass
         */
        this._classList = {};
        /**
         * Whether the menu should overlap its trigger.
         */
        this.overlapTrigger = true;
        /**
         * Event emitted when the menu is closed.
         */
        this.close = new EventEmitter();
    }
    Object.defineProperty(XpoMenu.prototype, "xPosition", {
        /**
         * Position of the menu in the X axis.
         * @return {?}
         */
        get: function () { return this._xPosition; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value !== 'before' && value !== 'after') {
                throwXpoMenuInvalidPositionX();
            }
            this._xPosition = value;
            this.setPositionClasses();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenu.prototype, "yPosition", {
        /**
         * Position of the menu in the Y axis.
         * @return {?}
         */
        get: function () { return this._yPosition; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value !== 'above' && value !== 'below') {
                throwXpoMenuInvalidPositionY();
            }
            this._yPosition = value;
            this.setPositionClasses();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenu.prototype, "classList", {
        /**
         * This method takes classes set on the host xpo-menu element and applies them on the
         * menu template that displays in the overlay container.  Otherwise, it's difficult
         * to style the containing menu from outside the component.
         * @param {?} classes list of class names
         * @return {?}
         */
        set: function (classes) {
            this._classList = classes.split(' ').reduce(function (obj, className) {
                obj[className] = true;
                return obj;
            }, {});
            this.setPositionClasses();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoMenu.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._keyManager = new FocusKeyManager(this.items).withWrap();
        this._tabSubscription = this._keyManager.tabOut.subscribe(function () { return _this._emitCloseEvent(); });
    };
    /**
     * @return {?}
     */
    XpoMenu.prototype.ngOnDestroy = function () {
        if (this._tabSubscription) {
            this._tabSubscription.unsubscribe();
        }
    };
    /**
     * Handle a keyboard event from the menu, delegating to the appropriate action.
     * @param {?} event
     * @return {?}
     */
    XpoMenu.prototype._handleKeydown = function (event) {
        switch (event.keyCode) {
            case ESCAPE:
                this._emitCloseEvent();
                return;
            default:
                this._keyManager.onKeydown(event);
        }
    };
    /**
     * Focus the first item in the menu. This method is used by the menu trigger
     * to focus the first item when the menu is opened by the ENTER key.
     * @return {?}
     */
    XpoMenu.prototype.focusFirstItem = function () {
        this._keyManager.setFirstItemActive();
    };
    /**
     * This emits a close event to which the trigger is subscribed. When emitted, the
     * trigger will close the menu.
     * @return {?}
     */
    XpoMenu.prototype._emitCloseEvent = function () {
        this.close.emit();
    };
    /**
     * It's necessary to set position-based classes to ensure the menu panel animation
     * folds out from the correct direction.
     * @param {?=} posX
     * @param {?=} posY
     * @return {?}
     */
    XpoMenu.prototype.setPositionClasses = function (posX, posY) {
        if (posX === void 0) { posX = this.xPosition; }
        if (posY === void 0) { posY = this.yPosition; }
        this._classList['xpo-menu-before'] = posX === 'before';
        this._classList['xpo-menu-after'] = posX === 'after';
        this._classList['xpo-menu-above'] = posY === 'above';
        this._classList['xpo-menu-below'] = posY === 'below';
    };
    return XpoMenu;
}());
XpoMenu.decorators = [
    { type: Component, args: [{ selector: 'xpo-menu',
                host: { role: 'menu' },
                template: "<ng-template> <div class=\"xpo-menu-panel\" [ngClass]=\"_classList\" (keydown)=\"_handleKeydown($event)\" (click)=\"_emitCloseEvent()\" [@transformMenu]=\"'showing'\"> <div class=\"xpo-menu-content\" [@fadeInItems]=\"'showing'\"> <ng-content></ng-content> </div> </div> </ng-template>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}.xpo-menu-panel{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);max-width:280px;min-width:112px;overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh - 34px)}.xpo-menu-panel.xpo-menu-after.xpo-menu-below{transform-origin:left top}.xpo-menu-panel.xpo-menu-after.xpo-menu-above{transform-origin:left bottom}.xpo-menu-panel.xpo-menu-before.xpo-menu-below{transform-origin:right top}.xpo-menu-panel.xpo-menu-before.xpo-menu-above{transform-origin:right bottom}[dir=rtl] .xpo-menu-panel.xpo-menu-after.xpo-menu-below{transform-origin:right top}[dir=rtl] .xpo-menu-panel.xpo-menu-after.xpo-menu-above{transform-origin:right bottom}[dir=rtl] .xpo-menu-panel.xpo-menu-before.xpo-menu-below{transform-origin:left top}[dir=rtl] .xpo-menu-panel.xpo-menu-before.xpo-menu-above{transform-origin:left bottom}@media screen and (-ms-high-contrast:active){.xpo-menu-panel{outline:solid 1px}}.xpo-menu-content{padding-top:8px;padding-bottom:8px}.xpo-menu-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0;cursor:pointer;border:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;height:34px;padding:0 16px;line-height:34px;text-align:left;text-decoration:none;position:relative}.xpo-menu-item[disabled]{cursor:default}[dir=rtl] .xpo-menu-item{text-align:right}.xpo-menu-item .xpo-icon{margin-right:16px}[dir=rtl] .xpo-menu-item .xpo-icon{margin-right:0;margin-left:16px}button.xpo-menu-item{width:100%}.xpo-menu-ripple{position:absolute;top:0;right:0;bottom:0;left:0} /*# sourceMappingURL=menu.css.map */ "],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    transformMenu,
                    fadeInItems,
                ],
                exportAs: 'xpoMenu',
            },] },
];
/**
 * @nocollapse
 */
XpoMenu.ctorParameters = function () { return []; };
XpoMenu.propDecorators = {
    'xPosition': [{ type: Input },],
    'yPosition': [{ type: Input },],
    'templateRef': [{ type: ViewChild, args: [TemplateRef,] },],
    'items': [{ type: ContentChildren, args: [XpoMenuItem,] },],
    'overlapTrigger': [{ type: Input },],
    'classList': [{ type: Input, args: ['class',] },],
    'close': [{ type: Output },],
};
/* tslint:disable */
/**
 * This directive is intended to be used in conjunction with an xpo-menu tag.  It is
 * responsible for toggling the display of the provided menu instance.
 */
var XpoMenuTrigger = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _element
     * @param {?} _viewContainerRef
     * @param {?} _dir
     * @param {?} _scrollDispatcher
     */
    function XpoMenuTrigger(_overlay, _element, _viewContainerRef, _dir, _scrollDispatcher) {
        this._overlay = _overlay;
        this._element = _element;
        this._viewContainerRef = _viewContainerRef;
        this._dir = _dir;
        this._scrollDispatcher = _scrollDispatcher;
        this._menuOpen = false;
        this._openedByMouse = false;
        /**
         * Event emitted when the associated menu is opened.
         */
        this.onMenuOpen = new EventEmitter();
        /**
         * Event emitted when the associated menu is closed.
         */
        this.onMenuClose = new EventEmitter();
    }
    Object.defineProperty(XpoMenuTrigger.prototype, "_deprecatedXpoMenuTriggerFor", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.menu; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.menu = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenuTrigger.prototype, "_deprecatedMatMenuTriggerFor", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.menu; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.menu = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMenuTrigger.prototype, "_matMenuTriggerFor", {
        /**
         * @return {?}
         */
        get: function () { return this.menu; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.menu = v; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoMenuTrigger.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._checkMenu();
        this.menu.close.subscribe(function () { return _this.closeMenu(); });
    };
    /**
     * @return {?}
     */
    XpoMenuTrigger.prototype.ngOnDestroy = function () { this.destroyMenu(); };
    Object.defineProperty(XpoMenuTrigger.prototype, "menuOpen", {
        /**
         * Whether the menu is open.
         * @return {?}
         */
        get: function () { return this._menuOpen; },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggles the menu between the open and closed states.
     * @return {?}
     */
    XpoMenuTrigger.prototype.toggleMenu = function () {
        return this._menuOpen ? this.closeMenu() : this.openMenu();
    };
    /**
     * Opens the menu.
     * @return {?}
     */
    XpoMenuTrigger.prototype.openMenu = function () {
        if (!this._menuOpen) {
            this._createOverlay();
            this._overlayRef.attach(this._portal);
            this._subscribeToBackdrop();
            this._initMenu();
        }
    };
    /**
     * Closes the menu.
     * @return {?}
     */
    XpoMenuTrigger.prototype.closeMenu = function () {
        if (this._overlayRef) {
            this._overlayRef.detach();
            this._backdropSubscription.unsubscribe();
            this._resetMenu();
        }
    };
    /**
     * Removes the menu from the DOM.
     * @return {?}
     */
    XpoMenuTrigger.prototype.destroyMenu = function () {
        if (this._overlayRef) {
            this._overlayRef.dispose();
            this._overlayRef = null;
            this._cleanUpSubscriptions();
        }
    };
    /**
     * Focuses the menu trigger.
     * @return {?}
     */
    XpoMenuTrigger.prototype.focus = function () {
        this._element.nativeElement.focus();
    };
    Object.defineProperty(XpoMenuTrigger.prototype, "dir", {
        /**
         * The text direction of the containing app.
         * @return {?}
         */
        get: function () {
            return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This method ensures that the menu closes when the overlay backdrop is clicked.
     * We do not use first() here because doing so would not catch clicks from within
     * the menu, and it would fail to unsubscribe properly. Instead, we unsubscribe
     * explicitly when the menu is closed or destroyed.
     * @return {?}
     */
    XpoMenuTrigger.prototype._subscribeToBackdrop = function () {
        var _this = this;
        this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function () {
            _this.menu._emitCloseEvent();
        });
    };
    /**
     * This method sets the menu state to open and focuses the first item if
     * the menu was opened via the keyboard.
     * @return {?}
     */
    XpoMenuTrigger.prototype._initMenu = function () {
        this._setIsMenuOpen(true);
        // Should only set focus if opened via the keyboard, so keyboard users can
        // can easily navigate menu items. According to spec, mouse users should not
        // see the focus style.
        if (!this._openedByMouse) {
            this.menu.focusFirstItem();
        }
    };
    /**
     * This method resets the menu when it's closed, most importantly restoring
     * focus to the menu trigger if the menu was opened via the keyboard.
     * @return {?}
     */
    XpoMenuTrigger.prototype._resetMenu = function () {
        this._setIsMenuOpen(false);
        // Focus only needs to be reset to the host element if the menu was opened
        // by the keyboard and manually shifted to the first menu item.
        if (!this._openedByMouse) {
            this.focus();
        }
        this._openedByMouse = false;
    };
    /**
     * @param {?} isOpen
     * @return {?}
     */
    XpoMenuTrigger.prototype._setIsMenuOpen = function (isOpen) {
        this._menuOpen = isOpen;
        this._menuOpen ? this.onMenuOpen.emit() : this.onMenuClose.emit();
    };
    /**
     *  This method checks that a valid instance of XpoMenu has been passed into
     *  xpoMenuTriggerFor. If not, an exception is thrown.
     * @return {?}
     */
    XpoMenuTrigger.prototype._checkMenu = function () {
        if (!this.menu) {
            throwXpoMenuMissingError();
        }
    };
    /**
     *  This method creates the overlay from the provided menu's template and saves its
     *  OverlayRef so that it can be attached to the DOM when openMenu is called.
     * @return {?}
     */
    XpoMenuTrigger.prototype._createOverlay = function () {
        if (!this._overlayRef) {
            this._portal = new TemplatePortal(this.menu.templateRef, this._viewContainerRef);
            var /** @type {?} */ config = this._getOverlayConfig();
            this._subscribeToPositions(/** @type {?} */ (config.positionStrategy));
            this._overlayRef = this._overlay.create(config);
        }
    };
    /**
     * This method builds the configuration object needed to create the overlay, the OverlayState.
     * @return {?} OverlayState
     */
    XpoMenuTrigger.prototype._getOverlayConfig = function () {
        var /** @type {?} */ overlayState = new OverlayState();
        overlayState.positionStrategy = this._getPosition()
            .withDirection(this.dir);
        overlayState.hasBackdrop = true;
        overlayState.backdropClass = 'cdk-overlay-transparent-backdrop';
        overlayState.direction = this.dir;
        overlayState.scrollStrategy = new RepositionScrollStrategy(this._scrollDispatcher);
        return overlayState;
    };
    /**
     * Listens to changes in the position of the overlay and sets the correct classes
     * on the menu based on the new position. This ensures the animation origin is always
     * correct, even if a fallback position is used for the overlay.
     * @param {?} position
     * @return {?}
     */
    XpoMenuTrigger.prototype._subscribeToPositions = function (position) {
        var _this = this;
        this._positionSubscription = position.onPositionChange.subscribe(function (change) {
            var /** @type {?} */ posX = change.connectionPair.originX === 'start' ? 'after' : 'before';
            var /** @type {?} */ posY = change.connectionPair.originY === 'top' ? 'below' : 'above';
            if (!_this.menu.overlapTrigger) {
                posY = posY === 'below' ? 'above' : 'below';
            }
            _this.menu.setPositionClasses(posX, posY);
        });
    };
    /**
     * This method builds the position strategy for the overlay, so the menu is properly connected
     * to the trigger.
     * @return {?} ConnectedPositionStrategy
     */
    XpoMenuTrigger.prototype._getPosition = function () {
        var _a = this.menu.xPosition === 'before' ? ['end', 'start'] : ['start', 'end'], posX = _a[0], fallbackX = _a[1];
        var _b = this.menu.yPosition === 'above' ? ['bottom', 'top'] : ['top', 'bottom'], overlayY = _b[0], fallbackOverlayY = _b[1];
        var /** @type {?} */ originY = overlayY;
        var /** @type {?} */ fallbackOriginY = fallbackOverlayY;
        if (!this.menu.overlapTrigger) {
            originY = overlayY === 'top' ? 'bottom' : 'top';
            fallbackOriginY = fallbackOverlayY === 'top' ? 'bottom' : 'top';
        }
        return this._overlay.position()
            .connectedTo(this._element, { originX: posX, originY: originY }, { overlayX: posX, overlayY: overlayY })
            .withFallbackPosition({ originX: fallbackX, originY: originY }, { overlayX: fallbackX, overlayY: overlayY })
            .withFallbackPosition({ originX: posX, originY: fallbackOriginY }, { overlayX: posX, overlayY: fallbackOverlayY })
            .withFallbackPosition({ originX: fallbackX, originY: fallbackOriginY }, { overlayX: fallbackX, overlayY: fallbackOverlayY });
    };
    /**
     * @return {?}
     */
    XpoMenuTrigger.prototype._cleanUpSubscriptions = function () {
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
        }
        if (this._positionSubscription) {
            this._positionSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoMenuTrigger.prototype._handleMousedown = function (event) {
        if (!isFakeMousedownFromScreenReader(event)) {
            this._openedByMouse = true;
        }
    };
    return XpoMenuTrigger;
}());
XpoMenuTrigger.decorators = [
    { type: Directive, args: [{
                selector: "[xpo-menu-trigger-for],\n             [xpoMenuTriggerFor]",
                host: {
                    'aria-haspopup': 'true',
                    '(mousedown)': '_handleMousedown($event)',
                    '(click)': 'toggleMenu()',
                },
                exportAs: 'xpoMenuTrigger'
            },] },
];
/**
 * @nocollapse
 */
XpoMenuTrigger.ctorParameters = function () { return [
    { type: Overlay, },
    { type: ElementRef, },
    { type: ViewContainerRef, },
    { type: Dir, decorators: [{ type: Optional },] },
    { type: ScrollDispatcher, },
]; };
XpoMenuTrigger.propDecorators = {
    '_deprecatedXpoMenuTriggerFor': [{ type: Input, args: ['xpo-menu-trigger-for',] },],
    '_deprecatedMatMenuTriggerFor': [{ type: Input, args: ['xpo-menu-trigger-for',] },],
    '_matMenuTriggerFor': [{ type: Input, args: ['matMenuTriggerFor',] },],
    'menu': [{ type: Input, args: ['xpoMenuTriggerFor',] },],
    'onMenuOpen': [{ type: Output },],
    'onMenuClose': [{ type: Output },],
};
var XpoMenuModule = (function () {
    function XpoMenuModule() {
    }
    return XpoMenuModule;
}());
XpoMenuModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    OverlayModule,
                    CommonModule,
                    XpoRippleModule,
                    XpoCommonModule,
                ],
                exports: [XpoMenu, XpoMenuItem, XpoMenuTrigger, XpoCommonModule],
                declarations: [XpoMenu, XpoMenuItem, XpoMenuTrigger],
            },] },
];
/**
 * @nocollapse
 */
XpoMenuModule.ctorParameters = function () { return []; };
/**
 * <xpo-meter> displays a horizontal meter with minimum and maximum values, partially filled in depending on the current value.
 */
var XpoMeter = (function () {
    function XpoMeter() {
        this.val = null;
        this.minVal = null;
        this.maxVal = null;
        this.highVal = null;
        this.lowVal = null;
        this.optimumVal = null;
    }
    Object.defineProperty(XpoMeter.prototype, "helper", {
        /**
         * The helper object
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMeter.prototype, "value", {
        /**
         * The current value
         * @return {?}
         */
        get: function () { return this.val; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.val = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMeter.prototype, "min", {
        /**
         * The minimum value
         * @return {?}
         */
        get: function () { return this.minVal; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.minVal = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMeter.prototype, "max", {
        /**
         * The maximum value
         * @return {?}
         */
        get: function () { return this.maxVal; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.maxVal = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMeter.prototype, "high", {
        /**
         * The high value
         * @return {?}
         */
        get: function () { return this.highVal; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.highVal = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMeter.prototype, "low", {
        /**
         * The low value
         * @return {?}
         */
        get: function () { return this.lowVal; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.lowVal = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoMeter.prototype, "optimum", {
        /**
         * The optimum value
         * @return {?}
         */
        get: function () { return this.optimumVal; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.optimumVal = value; },
        enumerable: true,
        configurable: true
    });
    return XpoMeter;
}());
XpoMeter.decorators = [
    { type: Component, args: [{ selector: 'xpo-meter',
                host: {},
                template: "<span *ngIf=\"helperObj\"> <meter [value]=\"helperObj.val\" [min]=\"helperObj.min\" [max]=\"helperObj.max\" [high]=\"helperObj.high\" [low]=\"helperObj.low\" [optimum]=\"helperObj.optimum\"></meter> </span> <span *ngIf=\"!helperObj\"> <meter [value]=\"val\" [min]=\"minVal\" [max]=\"maxVal\" [high]=\"highVal\" [low]=\"lowVal\" [optimum]=\"optimumVal\"></meter> </span>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{height:100%} /*# sourceMappingURL=meter.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoMeter.ctorParameters = function () { return []; };
XpoMeter.propDecorators = {
    'helper': [{ type: Input },],
    'value': [{ type: Input },],
    'min': [{ type: Input },],
    'max': [{ type: Input },],
    'high': [{ type: Input },],
    'low': [{ type: Input },],
    'optimum': [{ type: Input },],
};
var XpoMeterModule = (function () {
    function XpoMeterModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoMeterModule.forRoot = function () {
        return {
            ngModule: XpoMeterModule,
        };
    };
    return XpoMeterModule;
}());
XpoMeterModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoMeter],
                declarations: [XpoMeter],
            },] },
];
/**
 * @nocollapse
 */
XpoMeterModule.ctorParameters = function () { return []; };
/**
 * The default template and styles for the pagination links are borrowed directly
 * from Zurb Foundation 6: http://foundation.zurb.com/sites/docs/pagination.html
 */
var DEFAULT_TEMPLATE = "\n    <pagination-template  #p=\"paginationApi\"\n                         [id]=\"id\"\n                         [maxSize]=\"maxSize\"\n                         (pageChange)=\"pageChange.emit($event)\">\n    <ul class=\"xpo-pagination\"\n        role=\"navigation\"\n        [attr.aria-label]=\"screenReaderPaginationLabel\"\n        *ngIf=\"!(autoHide && p.pages.length <= 1)\">\n\n        <li class=\"pagination-previous\" [class.disabled]=\"p.isFirstPage()\" *ngIf=\"directionLinks\">\n            <a *ngIf=\"1 < p.getCurrent()\" (click)=\"p.previous()\" [attr.aria-label]=\"previousLabel + ' ' + screenReaderPageLabel\">\n                {{ previousLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </a>\n            <span *ngIf=\"p.isFirstPage()\">\n                {{ previousLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </span>\n        </li>\n\n        <li [class.current]=\"p.getCurrent() === page.value\" *ngFor=\"let page of p.pages\">\n            <a (click)=\"p.setCurrent(page.value)\" *ngIf=\"p.getCurrent() !== page.value\">\n                <span class=\"show-for-sr\">{{ screenReaderPageLabel }} </span>\n                <span>{{ page.label }}</span>\n            </a>\n            <div *ngIf=\"p.getCurrent() === page.value\">\n                <span class=\"show-for-sr\">{{ screenReaderCurrentLabel }} </span>\n                <span>{{ page.label }}</span>\n            </div>\n        </li>\n\n        <li class=\"pagination-next\" [class.disabled]=\"p.isLastPage()\" *ngIf=\"directionLinks\">\n            <a *ngIf=\"!p.isLastPage()\" (click)=\"p.next()\" [attr.aria-label]=\"nextLabel + ' ' + screenReaderPageLabel\">\n                 {{ nextLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </a>\n            <span *ngIf=\"p.isLastPage()\">\n                 {{ nextLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </span>\n        </li>\n\n    </ul>\n    </pagination-template>\n    ";
var DEFAULT_STYLES = "\n.xpo-pagination {\n  margin-left: 0;\n  margin-bottom: 1rem; }\n  .xpo-pagination::before, .xpo-pagination::after {\n    content: ' ';\n    display: table; }\n  .xpo-pagination::after {\n    clear: both; }\n  .xpo-pagination li {\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    margin-right: 0.0625rem;\n    border-radius: 0; }\n  .xpo-pagination li {\n    display: inline-block; }\n  .xpo-pagination a,\n  .xpo-pagination button {\n    color: #0a0a0a;\n    display: block;\n    padding: 0.1875rem 0.625rem;\n    border-radius: 0; }\n    .xpo-pagination a:hover,\n    .xpo-pagination button:hover {\n      background: #e6e6e6; }\n  .xpo-pagination .current {\n    padding: 0.1875rem 0.625rem;\n    background: #2199e8;\n    color: #fefefe;\n    cursor: default; }\n  .xpo-pagination .disabled {\n    padding: 0.1875rem 0.625rem;\n    color: #cacaca;\n    cursor: default; }\n    .ngx-pagination .disabled:hover {\n      background: transparent; }\n  .xpo-pagination .ellipsis::after {\n    content: '\u2026';\n    padding: 0.1875rem 0.625rem;\n    color: #0a0a0a; }\n  .xpo-pagination a, .xpo-pagination button {\n    cursor: pointer; }\n\n.xpo-pagination .pagination-previous a::before,\n.xpo-pagination .pagination-previous.disabled::before {\n  content: '\u00AB';\n  display: inline-block;\n  margin-right: 0.5rem; }\n\n.xpo-pagination .pagination-next a::after,\n.xpo-pagination .pagination-next.disabled::after {\n  content: '\u00BB';\n  display: inline-block;\n  margin-left: 0.5rem; }\n\n.xpo-pagination .show-for-sr {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0); }";
/**
 * <xpo-pagination> displays links to navigate through page views of an ordered set of records.
 */
var XpoPagination = (function () {
    function XpoPagination() {
        /**
         * The maxium number of page links to display.
         */
        this.maxSize = 7;
        this.previousLabel = 'Previous';
        this.nextLabel = 'Next';
        this.screenReaderPaginationLabel = 'Pagination';
        this.screenReaderPageLabel = 'page';
        this.screenReaderCurrentLabel = "You're on page";
        this.pageChange = new EventEmitter();
        this._directionLinks = true;
        this._autoHide = false;
    }
    Object.defineProperty(XpoPagination.prototype, "helper", {
        /**
         * The helper object.
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoPagination.prototype, "directionLinks", {
        /**
         * Whether or not to display the 'Previous' and 'Next' links.
         * @return {?}
         */
        get: function () {
            return this._directionLinks;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._directionLinks = !!value && (value) !== 'false';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoPagination.prototype, "autoHide", {
        /**
         * Whether or not to auto-hide the links
         * @return {?}
         */
        get: function () {
            return this._autoHide;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._autoHide = !!value && (value) !== 'false';
        },
        enumerable: true,
        configurable: true
    });
    return XpoPagination;
}());
XpoPagination.decorators = [
    { type: Component, args: [{ selector: 'xpo-pagination',
                host: {},
                template: DEFAULT_TEMPLATE,
                styles: [DEFAULT_STYLES],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoPagination.ctorParameters = function () { return []; };
XpoPagination.propDecorators = {
    'helper': [{ type: Input },],
    'id': [{ type: Input },],
    'maxSize': [{ type: Input },],
    'directionLinks': [{ type: Input },],
    'autoHide': [{ type: Input },],
    'previousLabel': [{ type: Input },],
    'nextLabel': [{ type: Input },],
    'screenReaderPaginationLabel': [{ type: Input },],
    'screenReaderPageLabel': [{ type: Input },],
    'screenReaderCurrentLabel': [{ type: Input },],
    'pageChange': [{ type: Output },],
};
/* tslint:disable */
var PaginationService = (function () {
    function PaginationService() {
        this.change = new EventEmitter();
        this.instances = {};
        this.DEFAULT_ID = 'DEFAULT_PAGINATION_ID';
    }
    /**
     * @return {?}
     */
    PaginationService.prototype.defaultId = function () { return this.DEFAULT_ID; };
    /**
     * @param {?} instance
     * @return {?}
     */
    PaginationService.prototype.register = function (instance) {
        if (!instance.id) {
            instance.id = this.DEFAULT_ID;
        }
        if (!this.instances[instance.id]) {
            this.instances[instance.id] = instance;
            this.change.emit(instance.id);
        }
        else {
            var /** @type {?} */ changed = this.updateInstance(instance);
            if (changed) {
                this.change.emit(instance.id);
            }
        }
    };
    /**
     * Check each property of the instance and update any that have changed. Return
     * true if any changes were made, else return false.
     * @param {?} instance
     * @return {?}
     */
    PaginationService.prototype.updateInstance = function (instance) {
        var /** @type {?} */ changed = false;
        for (var /** @type {?} */ prop in this.instances[instance.id]) {
            if (instance[prop] !== this.instances[instance.id][prop]) {
                this.instances[instance.id][prop] = instance[prop];
                changed = true;
            }
        }
        return changed;
    };
    /**
     * Returns the current page number.
     * @param {?} id
     * @return {?}
     */
    PaginationService.prototype.getCurrentPage = function (id) {
        if (this.instances[id]) {
            return this.instances[id].currentPage;
        }
    };
    /**
     * Sets the current page number.
     * @param {?} id
     * @param {?} page
     * @return {?}
     */
    PaginationService.prototype.setCurrentPage = function (id, page) {
        if (this.instances[id]) {
            var /** @type {?} */ instance = this.instances[id];
            var /** @type {?} */ maxPage = Math.ceil(instance.totalItems / instance.itemsPerPage);
            if (page <= maxPage && 1 <= page) {
                this.instances[id].currentPage = page;
                this.change.emit(id);
            }
        }
    };
    /**
     * Sets the value of instance.totalItems
     * @param {?} id
     * @param {?} totalItems
     * @return {?}
     */
    PaginationService.prototype.setTotalItems = function (id, totalItems) {
        if (this.instances[id] && 0 <= totalItems) {
            this.instances[id].totalItems = totalItems;
            this.change.emit(id);
        }
    };
    /**
     * Sets the value of instance.itemsPerPage.
     * @param {?} id
     * @param {?} itemsPerPage
     * @return {?}
     */
    PaginationService.prototype.setItemsPerPage = function (id, itemsPerPage) {
        if (this.instances[id]) {
            this.instances[id].itemsPerPage = itemsPerPage;
            this.change.emit(id);
        }
    };
    /**
     * Returns a clone of the pagination instance object matching the id. If no
     * id specified, returns the instance corresponding to the default id.
     * @param {?=} id
     * @return {?}
     */
    PaginationService.prototype.getInstance = function (id) {
        if (id === void 0) { id = this.DEFAULT_ID; }
        if (this.instances[id]) {
            return this.clone(this.instances[id]);
        }
        return ({});
    };
    /**
     * Perform a shallow clone of an object.
     * @param {?} obj
     * @return {?}
     */
    PaginationService.prototype.clone = function (obj) {
        var /** @type {?} */ target = {};
        for (var /** @type {?} */ i in obj) {
            if (obj.hasOwnProperty(i)) {
                target[i] = obj[i];
            }
        }
        return target;
    };
    return PaginationService;
}());
/**
 * This directive is what powers all pagination controls components, including the default one.
 * It exposes an API which is hooked up to the PaginationService to keep the PaginatePipe in sync
 * with the pagination controls.
 */
var PaginationControlsDirective = (function () {
    /**
     * @param {?} service
     * @param {?} changeDetectorRef
     */
    function PaginationControlsDirective(service, changeDetectorRef) {
        var _this = this;
        this.service = service;
        this.changeDetectorRef = changeDetectorRef;
        this.maxSize = 7;
        this.pageChange = new EventEmitter();
        this.pages = [];
        this.changeSub = this.service.change
            .subscribe(function (id) {
            if (_this.id === id) {
                _this.updatePageLinks();
                _this.changeDetectorRef.markForCheck();
                _this.changeDetectorRef.detectChanges();
            }
        });
    }
    /**
     * @return {?}
     */
    PaginationControlsDirective.prototype.ngOnInit = function () {
        if (this.id === undefined) {
            this.id = this.service.defaultId();
        }
        this.updatePageLinks();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    PaginationControlsDirective.prototype.ngOnChanges = function (changes) {
        this.updatePageLinks();
    };
    /**
     * @return {?}
     */
    PaginationControlsDirective.prototype.ngOnDestroy = function () {
        this.changeSub.unsubscribe();
    };
    /**
     * Go to the previous page
     * @return {?}
     */
    PaginationControlsDirective.prototype.previous = function () {
        this.checkValidId();
        this.setCurrent(this.getCurrent() - 1);
    };
    /**
     * Go to the next page
     * @return {?}
     */
    PaginationControlsDirective.prototype.next = function () {
        this.checkValidId();
        this.setCurrent(this.getCurrent() + 1);
    };
    /**
     * Returns true if current page is first page
     * @return {?}
     */
    PaginationControlsDirective.prototype.isFirstPage = function () {
        return this.getCurrent() === 1;
    };
    /**
     * Returns true if current page is last page
     * @return {?}
     */
    PaginationControlsDirective.prototype.isLastPage = function () {
        return this.getLastPage() === this.getCurrent();
    };
    /**
     * Set the current page number.
     * @param {?} page
     * @return {?}
     */
    PaginationControlsDirective.prototype.setCurrent = function (page) {
        this.pageChange.emit(page);
    };
    /**
     * Get the current page number.
     * @return {?}
     */
    PaginationControlsDirective.prototype.getCurrent = function () {
        return this.service.getCurrentPage(this.id);
    };
    /**
     * Returns the last page number
     * @return {?}
     */
    PaginationControlsDirective.prototype.getLastPage = function () {
        var /** @type {?} */ inst = this.service.getInstance(this.id);
        if (inst.totalItems < 1) {
            // when there are 0 or fewer (an error case) items, there are no "pages" as such,
            // but it makes sense to consider a single, empty page as the last page.
            return 1;
        }
        return Math.ceil(inst.totalItems / inst.itemsPerPage);
    };
    /**
     * @return {?}
     */
    PaginationControlsDirective.prototype.checkValidId = function () {
        if (!this.service.getInstance(this.id).id) {
            console.warn("PaginationControlsDirective: the specified id \"" + this.id + "\" does not match any registered PaginationInstance");
        }
    };
    /**
     * Updates the page links and checks that the current page is valid. Should run whenever the
     * PaginationService.change stream emits a value matching the current ID, or when any of the
     * input values changes.
     * @return {?}
     */
    PaginationControlsDirective.prototype.updatePageLinks = function () {
        var _this = this;
        var /** @type {?} */ inst = this.service.getInstance(this.id);
        var /** @type {?} */ correctedCurrentPage = this.outOfBoundCorrection(inst);
        if (correctedCurrentPage !== inst.currentPage) {
            setTimeout(function () {
                _this.setCurrent(correctedCurrentPage);
                _this.pages = _this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, _this.maxSize);
            });
        }
        else {
            this.pages = this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, this.maxSize);
        }
    };
    /**
     * Checks that the instance.currentPage property is within bounds for the current page range.
     * If not, return a correct value for currentPage, or the current value if OK.
     * @param {?} instance
     * @return {?}
     */
    PaginationControlsDirective.prototype.outOfBoundCorrection = function (instance) {
        var /** @type {?} */ totalPages = Math.ceil(instance.totalItems / instance.itemsPerPage);
        if (totalPages < instance.currentPage && 0 < totalPages) {
            return totalPages;
        }
        else if (instance.currentPage < 1) {
            return 1;
        }
        return instance.currentPage;
    };
    /**
     * Returns an array of Page objects to use in the pagination controls.
     * @param {?} currentPage
     * @param {?} itemsPerPage
     * @param {?} totalItems
     * @param {?} paginationRange
     * @return {?}
     */
    PaginationControlsDirective.prototype.createPageArray = function (currentPage, itemsPerPage, totalItems, paginationRange) {
        // paginationRange could be a string if passed from attribute, so cast to number.
        paginationRange = +paginationRange;
        var /** @type {?} */ pages = [];
        var /** @type {?} */ totalPages = Math.ceil(totalItems / itemsPerPage);
        var /** @type {?} */ halfWay = Math.ceil(paginationRange / 2);
        var /** @type {?} */ isStart = currentPage <= halfWay;
        var /** @type {?} */ isEnd = totalPages - halfWay < currentPage;
        var /** @type {?} */ isMiddle = !isStart && !isEnd;
        var /** @type {?} */ ellipsesNeeded = paginationRange < totalPages;
        var /** @type {?} */ i = 1;
        while (i <= totalPages && i <= paginationRange) {
            var /** @type {?} */ label = void 0;
            var /** @type {?} */ pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
            var /** @type {?} */ openingEllipsesNeeded = (i === 2 && (isMiddle || isEnd));
            var /** @type {?} */ closingEllipsesNeeded = (i === paginationRange - 1 && (isMiddle || isStart));
            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                label = '...';
            }
            else {
                label = pageNumber;
            }
            pages.push({
                label: label,
                value: pageNumber,
            });
            i++;
        }
        return pages;
    };
    /**
     * Given the position in the sequence of pagination links [i],
     * figure out what page number corresponds to that position.
     * @param {?} i
     * @param {?} currentPage
     * @param {?} paginationRange
     * @param {?} totalPages
     * @return {?}
     */
    PaginationControlsDirective.prototype.calculatePageNumber = function (i, currentPage, paginationRange, totalPages) {
        var /** @type {?} */ halfWay = Math.ceil(paginationRange / 2);
        if (i === paginationRange) {
            return totalPages;
        }
        else if (i === 1) {
            return i;
        }
        else if (paginationRange < totalPages) {
            if (totalPages - halfWay < currentPage) {
                return totalPages - paginationRange + i;
            }
            else if (halfWay < currentPage) {
                return currentPage - halfWay + i;
            }
            else {
                return i;
            }
        }
        else {
            return i;
        }
    };
    return PaginationControlsDirective;
}());
PaginationControlsDirective.decorators = [
    { type: Directive, args: [{
                selector: 'pagination-template,[pagination-template]',
                exportAs: 'paginationApi',
            },] },
];
/**
 * @nocollapse
 */
PaginationControlsDirective.ctorParameters = function () { return [
    { type: PaginationService, },
    { type: ChangeDetectorRef, },
]; };
PaginationControlsDirective.propDecorators = {
    'id': [{ type: Input },],
    'maxSize': [{ type: Input },],
    'pageChange': [{ type: Output },],
};
/* tslint:disable */
var LARGE_NUMBER = Number.MAX_SAFE_INTEGER;
var PaginatePipe = (function () {
    /**
     * @param {?} service
     */
    function PaginatePipe(service) {
        this.service = service;
        this.state = {};
    }
    /**
     * @param {?} collection
     * @param {?} args
     * @return {?}
     */
    PaginatePipe.prototype.transform = function (collection, args) {
        // When an observable is passed through the AsyncPipe, it will output
        // `null` until the subscription resolves. In this case, we want to
        // use the cached data from the `state` object to prevent the NgFor
        // from flashing empty until the real values arrive.
        if (args instanceof Array) {
            // compatible with angular2 before beta16
            args = args[0];
        }
        if (!(collection instanceof Array)) {
            var /** @type {?} */ _id = args.id || this.service.defaultId;
            if (this.state[_id]) {
                return this.state[_id].slice;
            }
            else {
                return collection;
            }
        }
        var /** @type {?} */ serverSideMode = args.totalItems && args.totalItems !== collection.length;
        var /** @type {?} */ instance = this.createInstance(collection, args);
        var /** @type {?} */ id = instance.id;
        var /** @type {?} */ start, /** @type {?} */ end;
        var /** @type {?} */ perPage = instance.itemsPerPage;
        this.service.register(instance);
        if (!serverSideMode && collection instanceof Array) {
            perPage = +perPage || LARGE_NUMBER;
            start = (instance.currentPage - 1) * perPage;
            end = start + perPage;
            var /** @type {?} */ isIdentical = this.stateIsIdentical(id, collection, start, end);
            if (isIdentical) {
                return this.state[id].slice;
            }
            else {
                var /** @type {?} */ slice = collection.slice(start, end);
                this.saveState(id, collection, slice, start, end);
                this.service.change.emit(id);
                return slice;
            }
        }
        // save the state for server-side collection to avoid null
        // flash as new data loads.
        this.saveState(id, collection, collection, start, end);
        return collection;
    };
    /**
     * Create an PaginationInstance object, using defaults for any optional properties not supplied.
     * @param {?} collection
     * @param {?} args
     * @return {?}
     */
    PaginatePipe.prototype.createInstance = function (collection, args) {
        var /** @type {?} */ config = args;
        this.checkConfig(config);
        return {
            id: config.id || this.service.defaultId(),
            itemsPerPage: config.itemsPerPage || 0,
            currentPage: config.currentPage || 1,
            totalItems: config.totalItems || collection.length
        };
    };
    /**
     * Ensure the argument passed to the filter contains the required properties.
     * @param {?} config
     * @return {?}
     */
    PaginatePipe.prototype.checkConfig = function (config) {
        var /** @type {?} */ required = ['itemsPerPage', 'currentPage'];
        var /** @type {?} */ missing = required.filter(function (prop) { return !(prop in config); });
        if (0 < missing.length) {
            throw new Error("PaginatePipe: Argument is missing the following required properties: " + missing.join(', '));
        }
    };
    /**
     * To avoid returning a brand new array each time the pipe is run, we store the state of the sliced
     * array for a given id. This means that the next time the pipe is run on this collection & id, we just
     * need to check that the collection, start and end points are all identical, and if so, return the
     * last sliced array.
     * @param {?} id
     * @param {?} collection
     * @param {?} slice
     * @param {?} start
     * @param {?} end
     * @return {?}
     */
    PaginatePipe.prototype.saveState = function (id, collection, slice, start, end) {
        this.state[id] = {
            collection: collection,
            size: collection.length,
            slice: slice,
            start: start,
            end: end
        };
    };
    /**
     * For a given id, returns true if the collection, size, start and end values are identical.
     * @param {?} id
     * @param {?} collection
     * @param {?} start
     * @param {?} end
     * @return {?}
     */
    PaginatePipe.prototype.stateIsIdentical = function (id, collection, start, end) {
        var /** @type {?} */ state$$1 = this.state[id];
        if (!state$$1) {
            return false;
        }
        var /** @type {?} */ isMetaDataIdentical = state$$1.size === collection.length &&
            state$$1.start === start &&
            state$$1.end === end;
        if (!isMetaDataIdentical) {
            return false;
        }
        return state$$1.slice.every(function (element, index) { return element === collection[start + index]; });
    };
    return PaginatePipe;
}());
PaginatePipe.decorators = [
    { type: Pipe, args: [{
                name: 'paginate',
                pure: false
            },] },
];
/**
 * @nocollapse
 */
PaginatePipe.ctorParameters = function () { return [
    { type: PaginationService, },
]; };
var XpoPaginationModule = (function () {
    function XpoPaginationModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoPaginationModule.forRoot = function () {
        return {
            ngModule: XpoPaginationModule,
        };
    };
    return XpoPaginationModule;
}());
XpoPaginationModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                providers: [PaginationService],
                exports: [XpoPagination, PaginatePipe, PaginationControlsDirective],
                declarations: [XpoPagination, PaginatePipe, PaginationControlsDirective],
            },] },
];
/**
 * @nocollapse
 */
XpoPaginationModule.ctorParameters = function () { return []; };
var PopoverActivationMode = {};
PopoverActivationMode.Hover = 0;
PopoverActivationMode.Click = 1;
PopoverActivationMode.Manual = 2;
PopoverActivationMode[PopoverActivationMode.Hover] = "Hover";
PopoverActivationMode[PopoverActivationMode.Click] = "Click";
PopoverActivationMode[PopoverActivationMode.Manual] = "Manual";
var PopoverPosition = {};
PopoverPosition.Top = 0;
PopoverPosition.Right = 1;
PopoverPosition.Bottom = 2;
PopoverPosition.Left = 3;
PopoverPosition[PopoverPosition.Top] = "Top";
PopoverPosition[PopoverPosition.Right] = "Right";
PopoverPosition[PopoverPosition.Bottom] = "Bottom";
PopoverPosition[PopoverPosition.Left] = "Left";
/**
 * <xpo-popover> displays a box containing a text label in response to a user event (i.e. hover, click, manual).
 */
var XpoPopOver = (function () {
    /**
     * @param {?} _elementRef
     */
    function XpoPopOver(_elementRef) {
        this._elementRef = _elementRef;
        this._isClosing = false;
        /**
         * Whether or not the popover is visible.
         */
        this.visible = new Subject();
        /**
         * The position of the popover: Top, Right, Bottom, Left.
         */
        this.position = PopoverPosition.Bottom;
        /**
         * The activation mode of the popover: Hover, Click, or Manual.
         */
        this.activationMode = PopoverActivationMode.Hover;
        this.contentClass = new BehaviorSubject('popover-content popover-bottom');
    }
    /**
     * @return {?}
     */
    XpoPopOver.prototype.ngOnInit = function () {
        var /** @type {?} */ self = this;
        this.visible
            .debounceTime(100)
            .distinctUntilChanged()
            .subscribe(function (val) {
            self._isClosing = false;
            var /** @type {?} */ positionClass;
            switch (self.position) {
                case PopoverPosition.Top:
                    positionClass = 'popover-top';
                    break;
                case PopoverPosition.Left:
                    positionClass = 'popover-left';
                    break;
                case PopoverPosition.Right:
                    positionClass = 'popover-right';
                    break;
                default:
                    positionClass = 'popover-bottom';
                    break;
            }
            if (val) {
                self.contentClass.next('popover-content popover-content-open ' + positionClass);
            }
            else {
                self.contentClass.next('popover-content ' + positionClass);
            }
        });
        this.updateContentClass(false);
    };
    /**
     * Opens the popover.
     * @return {?}
     */
    XpoPopOver.prototype.open = function () {
        this.updateContentClass(true);
    };
    /**
     * Closes the popover.
     * @return {?}
     */
    XpoPopOver.prototype.close = function () {
        this._isClosing = true;
        this.updateContentClass(false);
    };
    /**
     * Toggles the popover open/close.
     * @return {?}
     */
    XpoPopOver.prototype.toggle = function () {
        this.updateContentClass(!this.visible);
    };
    /**
     * Over hover handler.
     * @return {?}
     */
    XpoPopOver.prototype.over = function () {
        if (this.activationMode == PopoverActivationMode.Hover) {
            this.updateContentClass(true);
        }
    };
    /**
     * Leave hover handler.
     * @return {?}
     */
    XpoPopOver.prototype.leave = function () {
        if (this.activationMode == PopoverActivationMode.Hover) {
            this.updateContentClass(false);
        }
    };
    /**
     * Click handler.
     * @param {?} targetElement
     * @return {?}
     */
    XpoPopOver.prototype.onClick = function (targetElement) {
        if (this.activationMode == PopoverActivationMode.Click) {
            var /** @type {?} */ clickedInside = this._elementRef.nativeElement.contains(targetElement);
            if (clickedInside) {
                this.updateContentClass(true);
            }
            else {
                this.updateContentClass(false);
            }
        }
    };
    /**
     * @param {?} visible
     * @return {?}
     */
    XpoPopOver.prototype.updateContentClass = function (visible) {
        if (this._isClosing && visible) {
            return;
        }
        this.visible.next(visible);
    };
    return XpoPopOver;
}());
XpoPopOver.decorators = [
    { type: Component, args: [{ selector: 'xpo-popover',
                host: {},
                template: "<div (mouseover)=\"over()\" (mouseleave)=\"leave()\" class=\"popover-wrapper\"> <div class=\"popover-target\"> <ng-content select=\"[target]\"></ng-content> </div> <div [ngClass]=\"contentClass | async\"> <ng-content select=\"[title]\"></ng-content> <ng-content select=\"[body]\"></ng-content> </div> </div>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host a{text-decoration:none}:host .popover-target{padding:15px 0;font-size:24px;color:#e44444;line-height:36px;text-align:center;text-decoration:none}:host .popover-wrapper{display:inline-block;margin-top:1.5rem;position:relative}:host .popover-content{visibility:hidden;width:150px;width:auto;padding:1.5rem;position:absolute;left:-75px;transform:translate(0,10px);opacity:0;background-color:#bfbfbf;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}:host .popover-content::before{position:absolute;top:-8px;right:calc(50% - 10px);content:\"\";border-color:transparent transparent #bfbfbf transparent;border-style:solid;border-width:0 10px 10px 10px;z-index:-1;transition-duration:.3s;transition-property:transform}:host .popover-content-open{visibility:visible;width:150px;transform:translate(0,-5px);opacity:1;z-index:10;transition:all .5s cubic-bezier(.75,-.02,.2,.97)}:host .popover-message{text-align:center} /*# sourceMappingURL=popover.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoPopOver.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
XpoPopOver.propDecorators = {
    'position': [{ type: Input },],
    'activationMode': [{ type: Input },],
    'onClick': [{ type: HostListener, args: ['document:click', ['$event.target'],] },],
};
var XpoPopOverExample = (function () {
    function XpoPopOverExample() {
    }
    Object.defineProperty(XpoPopOverExample.prototype, "activationMode", {
        /**
         * @return {?}
         */
        get: function () {
            return PopoverActivationMode.Click;
        },
        enumerable: true,
        configurable: true
    });
    return XpoPopOverExample;
}());
XpoPopOverExample.decorators = [
    { type: Component, args: [{ selector: 'xpo-popover-example',
                template: "\n  <xpo-popover [activationMode]=\"activationMode\">\n      <div target>\n          <button>Target</button>\n      </div>\n      <div title>\n          Some header text\n      </div>\n      <div body>\n          Body text\n      </div>\n  </xpo-popover>\n  ",
            },] },
];
/**
 * @nocollapse
 */
XpoPopOverExample.ctorParameters = function () { return []; };
var XpoPopOverModule = (function () {
    function XpoPopOverModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoPopOverModule.forRoot = function () {
        return {
            ngModule: XpoPopOverModule,
        };
    };
    return XpoPopOverModule;
}());
XpoPopOverModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XpoPopOver, XpoPopOverExample],
                declarations: [XpoPopOver, XpoPopOverExample],
            },] },
];
/**
 * @nocollapse
 */
XpoPopOverModule.ctorParameters = function () { return []; };
/**
 * <xpo-progress-bar> displays a horizontal progress-bar for indicating progress and activity.
 */
var XpoProgressBar = (function () {
    function XpoProgressBar() {
        /**
         * Color of the progress bar.
         */
        this.color = 'primary';
        this._value = 0;
        this._bufferValue = 0;
        /**
         * Mode of the progress bar.
         *
         * Input must be one of these values: determinate, indeterminate, buffer, query, defaults to
         * 'determinate'.
         * Mirrored to mode attribute.
         */
        this.mode = 'determinate';
    }
    Object.defineProperty(XpoProgressBar.prototype, "value", {
        /**
         * Value of the progressbar. Defaults to zero. Mirrored to aria-valuenow.
         * @return {?}
         */
        get: function () { return this._value; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this._value = clamp(v || 0); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoProgressBar.prototype, "bufferValue", {
        /**
         * Buffer value of the progress bar. Defaults to zero.
         * @return {?}
         */
        get: function () { return this._bufferValue; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this._bufferValue = clamp(v || 0); },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the current transform value for the progress bar's primary indicator.
     * @return {?}
     */
    XpoProgressBar.prototype._primaryTransform = function () {
        var /** @type {?} */ scale = this.value / 100;
        return { transform: "scaleX(" + scale + ")" };
    };
    /**
     * Gets the current transform value for the progress bar's buffer indicator.  Only used if the
     * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
     * @return {?}
     */
    XpoProgressBar.prototype._bufferTransform = function () {
        if (this.mode == 'buffer') {
            var /** @type {?} */ scale = this.bufferValue / 100;
            return { transform: "scaleX(" + scale + ")" };
        }
    };
    return XpoProgressBar;
}());
XpoProgressBar.decorators = [
    { type: Component, args: [{ selector: 'xpo-progress-bar, xpo-progress-bar',
                host: {
                    'role': 'progressbar',
                    'aria-valuemin': '0',
                    'aria-valuemax': '100',
                    '[class.xpo-primary]': 'color == "primary"',
                    '[class.xpo-accent]': 'color == "accent"',
                    '[class.xpo-warn]': 'color == "warn"',
                    '[class.xpo-progress-bar]': 'true',
                },
                template: "<!-- The background div is named as such because it appears below the other divs and is not sized based on values. --> <div class=\"xpo-progress-bar-background xpo-progress-bar-element\"></div> <div class=\"xpo-progress-bar-buffer xpo-progress-bar-element\" [ngStyle]=\"_bufferTransform()\"></div> <div class=\"xpo-progress-bar-primary xpo-progress-bar-fill xpo-progress-bar-element\" [ngStyle]=\"_primaryTransform()\"></div> <div class=\"xpo-progress-bar-secondary xpo-progress-bar-fill xpo-progress-bar-element\"></div>",
                styles: ["@charset \"UTF-8\";@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:block;width:100%;height:5px;overflow:hidden;position:relative;transform:translateZ(0);transition:opacity 250ms linear}:host .xpo-progress-bar-element,:host .xpo-progress-bar-fill::after{width:100%;height:100%;position:absolute}:host .xpo-progress-bar-background{display:none;background-image:url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20version%3D%271.1%27%20xmlns%3D%27…27%20cy%3D%271%27%20r%3D%271%27%20fill%3D%27%23c5cae9%27%2F%3E%3C%2Fsvg%3E\");background-repeat:repeat-x;background-size:10px 4px}:host .xpo-progress-bar-buffer{transform-origin:top left;background-color:#dfdfdf;transition:transform 250ms ease,stroke .3s cubic-bezier(.35,0,.25,1)}:host .xpo-progress-bar-secondary{display:none}:host .xpo-progress-bar-fill{transform-origin:top left;animation:none;transition:transform 250ms ease,stroke .3s cubic-bezier(.35,0,.25,1)}:host .xpo-progress-bar-fill::after{display:inline-block;left:0;content:\"\";background-color:#80d8ff;animation:none}:host[mode=query]{transform:rotateZ(180deg)}:host[mode=indeterminate] .xpo-progress-bar-fill,:host[mode=query] .xpo-progress-bar-fill{transition:none}:host[mode=indeterminate] .xpo-progress-bar-primary,:host[mode=query] .xpo-progress-bar-primary{left:-145.166611%;animation:xpo-progress-bar-primary-indeterminate-translate 2s infinite linear}:host[mode=indeterminate] .xpo-progress-bar-primary.xpo-progress-bar-fill::after,:host[mode=query] .xpo-progress-bar-primary.xpo-progress-bar-fill::after{animation:xpo-progress-bar-primary-indeterminate-scale 2s infinite linear}:host[mode=indeterminate] .xpo-progress-bar-secondary,:host[mode=query] .xpo-progress-bar-secondary{display:block;left:-54.888891%;animation:xpo-progress-bar-secondary-indeterminate-translate 2s infinite linear}:host[mode=indeterminate] .xpo-progress-bar-secondary.xpo-progress-bar-fill::after,:host[mode=query] .xpo-progress-bar-secondary.xpo-progress-bar-fill::after{animation:xpo-progress-bar-secondary-indeterminate-scale 2s infinite linear}:host[mode=buffer] .xpo-progress-bar-background{display:block;animation:xpo-progress-bar-background-scroll 250ms infinite linear}:host-context([dir=rtl]){transform:rotateY(180deg)}@keyframes xpo-progress-bar-primary-indeterminate-translate{0%{transform:translateX(0)}20%{transform:translateX(0);animation-timing-function:cubic-bezier(.5,0,.70173,.49582)}59.15%{transform:translateX(83.67142%);animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635)}100%{transform:translateX(200.61106%)}}@keyframes xpo-progress-bar-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{transform:scaleX(.08);animation-timing-function:cubic-bezier(.33473,.12482,.78584,1)}69.15%{transform:scaleX(.66148);animation-timing-function:cubic-bezier(.06,.11,.6,1)}100%{transform:scaleX(.08)}}@keyframes xpo-progress-bar-secondary-indeterminate-translate{0%{transform:translateX(0);animation-timing-function:cubic-bezier(.15,0,.51506,.40969)}25%{transform:translateX(37.65191%);animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371)}48.35%{transform:translateX(84.38617%);animation-timing-function:cubic-bezier(.4,.62704,.6,.90203)}100%{transform:translateX(160.27778%)}}@keyframes xpo-progress-bar-secondary-indeterminate-scale{0%{transform:scaleX(.08);animation-timing-function:cubic-bezier(.15,0,.51506,.40969)}19.15%{transform:scaleX(.4571);animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371)}44.15%{transform:scaleX(.72796);animation-timing-function:cubic-bezier(.4,.62704,.6,.90203)}100%{transform:scaleX(.08)}}@keyframes xpo-progress-bar-background-scroll{to{transform:translateX(-10px)}} /*# sourceMappingURL=progress-bar.css.map */ "],
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoProgressBar.ctorParameters = function () { return []; };
XpoProgressBar.propDecorators = {
    'color': [{ type: Input },],
    'value': [{ type: Input }, { type: HostBinding, args: ['attr.aria-valuenow',] },],
    'bufferValue': [{ type: Input },],
    'mode': [{ type: Input }, { type: HostBinding, args: ['attr.mode',] },],
};
/**
 * Clamps a value to be between two numbers, by default 0 and 100.
 * @param {?} v
 * @param {?=} min
 * @param {?=} max
 * @return {?}
 */
function clamp(v, min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 100; }
    return Math.max(min, Math.min(max, v));
}
var XpoProgressBarModule = (function () {
    function XpoProgressBarModule() {
    }
    return XpoProgressBarModule;
}());
XpoProgressBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, XpoCommonModule],
                exports: [XpoProgressBar, XpoCommonModule],
                declarations: [XpoProgressBar],
            },] },
];
/**
 * @nocollapse
 */
XpoProgressBarModule.ctorParameters = function () { return []; };
/**
 * A single degree in radians.
 */
var DEGREE_IN_RADIANS = Math.PI / 180;
/**
 * Duration of the indeterminate animation.
 */
var DURATION_INDETERMINATE = 667;
/**
 * Duration of the indeterminate animation.
 */
var DURATION_DETERMINATE = 225;
/**
 * Start animation value of the indeterminate animation
 */
var startIndeterminate = 3;
/**
 * End animation value of the indeterminate animation
 */
var endIndeterminate = 80;
/**
 * Maximum angle for the arc. The angle can't be exactly 360, because the arc becomes hidden.
 */
var MAX_ANGLE = 359.99 / 100;
/**
 * Whether the user's browser supports requestAnimationFrame.
 */
var HAS_RAF = typeof requestAnimationFrame !== 'undefined';
/**
 * Default stroke width as a percentage of the viewBox.
 */
var PROGRESS_SPINNER_STROKE_WIDTH = 10;
/**
 * Directive whose purpose is to add the xpo- CSS styling to this selector.
 * \@docs-private
 */
var XpoProgressSpinnerCssMatStyler = (function () {
    function XpoProgressSpinnerCssMatStyler() {
    }
    return XpoProgressSpinnerCssMatStyler;
}());
XpoProgressSpinnerCssMatStyler.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-progress-spinner',
                host: {
                    '[class.xpo-progress-spinner]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoProgressSpinnerCssMatStyler.ctorParameters = function () { return []; };
/**
 * <xpo-progress-spinner> and <xpo-spinner> display circular indicators of progress and activity.
 */
var XpoProgressSpinner = (function () {
    /**
     * @param {?} _ngZone
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function XpoProgressSpinner(_ngZone, _elementRef, _renderer) {
        this._ngZone = _ngZone;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /**
         * The id of the last requested animation.
         */
        this._lastAnimationId = 0;
        this._mode = 'determinate';
        this._color = 'primary';
        /**
         * Stroke width of the progress spinner. By default uses 10px as stroke width.
         */
        this.strokeWidth = PROGRESS_SPINNER_STROKE_WIDTH;
    }
    Object.defineProperty(XpoProgressSpinner.prototype, "_ariaValueMin", {
        /**
         * Values for aria max and min are only defined as numbers when in a determinate mode.  We do this
         * because voiceover does not report the progress indicator as indeterminate if the aria min
         * and/or max value are number values.
         * @return {?}
         */
        get: function () {
            return this.mode == 'determinate' ? 0 : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoProgressSpinner.prototype, "_ariaValueMax", {
        /**
         * @return {?}
         */
        get: function () {
            return this.mode == 'determinate' ? 100 : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoProgressSpinner.prototype, "interdeterminateInterval", {
        /**
         * \@docs-private
         * @return {?}
         */
        get: function () {
            return this._interdeterminateInterval;
        },
        /**
         * \@docs-private
         * @param {?} interval
         * @return {?}
         */
        set: function (interval) {
            clearInterval(this._interdeterminateInterval);
            this._interdeterminateInterval = interval;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clean up any animations that were running.
     * @return {?}
     */
    XpoProgressSpinner.prototype.ngOnDestroy = function () {
        this._cleanupIndeterminateAnimation();
    };
    Object.defineProperty(XpoProgressSpinner.prototype, "color", {
        /**
         * The color of the progress-spinner. Can be primary, accent, or warn.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                this._renderer.removeClass(this._elementRef.nativeElement, "xpo-" + this._color);
                this._renderer.addClass(this._elementRef.nativeElement, "xpo-" + value);
                this._color = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoProgressSpinner.prototype, "value", {
        /**
         * Value of the progress circle. It is bound to the host as the attribute aria-valuenow.
         * @return {?}
         */
        get: function () {
            if (this.mode == 'determinate') {
                return this._value;
            }
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            if (v != null && this.mode == 'determinate') {
                var /** @type {?} */ newValue = clamp$1(v);
                this._animateCircle(this.value || 0, newValue);
                this._value = newValue;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoProgressSpinner.prototype, "mode", {
        /**
         * Mode of the progress circle
         *
         * Input must be one of the values from ProgressMode, defaults to 'determinate'.
         * mode is bound to the host as the attribute host.
         * @return {?}
         */
        get: function () {
            return this._mode;
        },
        /**
         * @param {?} mode
         * @return {?}
         */
        set: function (mode) {
            if (mode !== this._mode) {
                if (mode === 'indeterminate') {
                    this._startIndeterminateAnimation();
                }
                else {
                    this._cleanupIndeterminateAnimation();
                    this._animateCircle(0, this._value);
                }
                this._mode = mode;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Animates the circle from one percentage value to another.
     *
     * @param {?} animateFrom The percentage of the circle filled starting the animation.
     * @param {?} animateTo The percentage of the circle filled ending the animation.
     * @param {?=} ease The easing function to manage the pace of change in the animation.
     * @param {?=} duration The length of time to show the animation, in milliseconds.
     * @param {?=} rotation The starting angle of the circle fill, with 0° represented at the top center
     *    of the circle.
     * @return {?}
     */
    XpoProgressSpinner.prototype._animateCircle = function (animateFrom, animateTo, ease, duration, rotation) {
        var _this = this;
        if (ease === void 0) { ease = linearEase; }
        if (duration === void 0) { duration = DURATION_DETERMINATE; }
        if (rotation === void 0) { rotation = 0; }
        var /** @type {?} */ id = ++this._lastAnimationId;
        var /** @type {?} */ startTime = Date.now();
        var /** @type {?} */ changeInValue = animateTo - animateFrom;
        // No need to animate it if the values are the same
        if (animateTo === animateFrom) {
            this._renderArc(animateTo, rotation);
        }
        else {
            var /** @type {?} */ animation_1 = function () {
                // If there is no requestAnimationFrame, skip ahead to the end of the animation.
                var /** @type {?} */ elapsedTime = HAS_RAF ?
                    Math.max(0, Math.min(Date.now() - startTime, duration)) :
                    duration;
                _this._renderArc(ease(elapsedTime, animateFrom, changeInValue, duration), rotation);
                // Prevent overlapping animations by checking if a new animation has been called for and
                // if the animation has lasted longer than the animation duration.
                if (id === _this._lastAnimationId && elapsedTime < duration) {
                    requestAnimationFrame(animation_1);
                }
            };
            // Run the animation outside of Angular's zone, in order to avoid
            // hitting ZoneJS and change detection on each frame.
            this._ngZone.runOutsideAngular(animation_1);
        }
    };
    /**
     * Starts the indeterminate animation interval, if it is not already running.
     * @return {?}
     */
    XpoProgressSpinner.prototype._startIndeterminateAnimation = function () {
        var _this = this;
        var /** @type {?} */ rotationStartPoint = 0;
        var /** @type {?} */ start = startIndeterminate;
        var /** @type {?} */ end = endIndeterminate;
        var /** @type {?} */ duration = DURATION_INDETERMINATE;
        var /** @type {?} */ animate$$1 = function () {
            _this._animateCircle(start, end, materialEase, duration, rotationStartPoint);
            // Prevent rotation from reaching Number.MAX_SAFE_INTEGER.
            rotationStartPoint = (rotationStartPoint + end) % 100;
            var /** @type {?} */ temp = start;
            start = -end;
            end = -temp;
        };
        if (!this.interdeterminateInterval) {
            this._ngZone.runOutsideAngular(function () {
                _this.interdeterminateInterval = setInterval(animate$$1, duration + 50, 0, false);
                animate$$1();
            });
        }
    };
    /**
     * Removes interval, ending the animation.
     * @return {?}
     */
    XpoProgressSpinner.prototype._cleanupIndeterminateAnimation = function () {
        this.interdeterminateInterval = null;
    };
    /**
     * Renders the arc onto the SVG element. Proxies `getArc` while setting the proper
     * DOM attribute on the `<path>`.
     * @param {?} currentValue
     * @param {?=} rotation
     * @return {?}
     */
    XpoProgressSpinner.prototype._renderArc = function (currentValue, rotation) {
        if (rotation === void 0) { rotation = 0; }
        if (this._path) {
            var /** @type {?} */ svgArc = getSvgArc(currentValue, rotation, this.strokeWidth);
            this._renderer.setAttribute(this._path.nativeElement, 'd', svgArc);
        }
    };
    return XpoProgressSpinner;
}());
XpoProgressSpinner.decorators = [
    { type: Component, args: [{ selector: 'xpo-progress-spinner',
                host: {
                    'role': 'progressbar',
                    '[attr.aria-valuemin]': '_ariaValueMin',
                    '[attr.aria-valuemax]': '_ariaValueMax',
                },
                template: "<!-- preserveAspectRatio of xMidYMid meet as the center of the viewport is the circle's center. The center of the circle will remain at the center of the xpo-progress-spinner element containing the SVG. --> <svg viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid meet\"> <path #path [style.strokeWidth]=\"strokeWidth\"></path> </svg>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:block;width:100px;height:100px;overflow:hidden}:host svg{width:100%;height:100%;transform-origin:center}:host path{transition:stroke .3s cubic-bezier(.35,0,.25,1);fill:transparent}:host[mode=indeterminate] svg{animation-duration:5.25s,2.887s;animation-iteration-count:infinite;animation-name:xpo-progress-spinner-sporadic-rotate,xpo-progress-spinner-linear-rotate;animation-timing-function:cubic-bezier(.35,0,.25,1),linear;transition:none}@keyframes xpo-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes xpo-progress-spinner-sporadic-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}100%{transform:rotate(1080deg)}} /*# sourceMappingURL=progress-spinner.css.map */ "],
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoProgressSpinner.ctorParameters = function () { return [
    { type: NgZone, },
    { type: ElementRef, },
    { type: Renderer2, },
]; };
XpoProgressSpinner.propDecorators = {
    '_path': [{ type: ViewChild, args: ['path',] },],
    'strokeWidth': [{ type: Input },],
    'color': [{ type: Input },],
    'value': [{ type: Input }, { type: HostBinding, args: ['attr.aria-valuenow',] },],
    'mode': [{ type: HostBinding, args: ['attr.mode',] }, { type: Input },],
};
/**
 * <xpo-spinner> component.
 *
 * This is a component definition to be used as a convenience reference to create an
 * indeterminate <xpo-progress-spinner> instance.
 */
var XpoSpinner = (function (_super) {
    __extends(XpoSpinner, _super);
    /**
     * @param {?} elementRef
     * @param {?} ngZone
     * @param {?} renderer
     */
    function XpoSpinner(elementRef, ngZone, renderer) {
        var _this = _super.call(this, ngZone, elementRef, renderer) || this;
        _this.mode = 'indeterminate';
        return _this;
    }
    /**
     * @return {?}
     */
    XpoSpinner.prototype.ngOnDestroy = function () {
        // The `ngOnDestroy` from `XpoProgressSpinner` should be called explicitly, because
        // in certain cases Angular won't call it (e.g. when using AoT and in unit tests).
        _super.prototype.ngOnDestroy.call(this);
    };
    return XpoSpinner;
}(XpoProgressSpinner));
XpoSpinner.decorators = [
    { type: Component, args: [{ selector: 'xpo-spinner',
                host: {
                    'role': 'progressbar',
                    'mode': 'indeterminate',
                    '[class.xpo-spinner]': 'true',
                },
                template: "<!-- preserveAspectRatio of xMidYMid meet as the center of the viewport is the circle's center. The center of the circle will remain at the center of the xpo-progress-spinner element containing the SVG. --> <svg viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid meet\"> <path #path [style.strokeWidth]=\"strokeWidth\"></path> </svg>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:block;width:100px;height:100px;overflow:hidden}:host svg{width:100%;height:100%;transform-origin:center}:host path{transition:stroke .3s cubic-bezier(.35,0,.25,1);fill:transparent}:host[mode=indeterminate] svg{animation-duration:5.25s,2.887s;animation-iteration-count:infinite;animation-name:xpo-progress-spinner-sporadic-rotate,xpo-progress-spinner-linear-rotate;animation-timing-function:cubic-bezier(.35,0,.25,1),linear;transition:none}@keyframes xpo-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes xpo-progress-spinner-sporadic-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}100%{transform:rotate(1080deg)}} /*# sourceMappingURL=progress-spinner.css.map */ "],
            },] },
];
/**
 * @nocollapse
 */
XpoSpinner.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: NgZone, },
    { type: Renderer2, },
]; };
/**
 * Clamps a value to be between 0 and 100.
 * @param {?} v
 * @return {?}
 */
function clamp$1(v) {
    return Math.max(0, Math.min(100, v));
}
/**
 * Converts Polar coordinates to Cartesian.
 * @param {?} radius
 * @param {?} pathRadius
 * @param {?} angleInDegrees
 * @return {?}
 */
function polarToCartesian(radius, pathRadius, angleInDegrees) {
    var /** @type {?} */ angleInRadians = (angleInDegrees - 90) * DEGREE_IN_RADIANS;
    return (radius + (pathRadius * Math.cos(angleInRadians))) +
        ',' + (radius + (pathRadius * Math.sin(angleInRadians)));
}
/**
 * Easing function for linear animation.
 * @param {?} currentTime
 * @param {?} startValue
 * @param {?} changeInValue
 * @param {?} duration
 * @return {?}
 */
function linearEase(currentTime, startValue, changeInValue, duration) {
    return changeInValue * currentTime / duration + startValue;
}
/**
 * Easing function to match XPO Viper indeterminate animation.
 * @param {?} currentTime
 * @param {?} startValue
 * @param {?} changeInValue
 * @param {?} duration
 * @return {?}
 */
function materialEase(currentTime, startValue, changeInValue, duration) {
    var /** @type {?} */ time = currentTime / duration;
    var /** @type {?} */ timeCubed = Math.pow(time, 3);
    var /** @type {?} */ timeQuad = Math.pow(time, 4);
    var /** @type {?} */ timeQuint = Math.pow(time, 5);
    return startValue + changeInValue * ((6 * timeQuint) + (-15 * timeQuad) + (10 * timeCubed));
}
/**
 * Determines the path value to define the arc.  Converting percentage values to to polar
 * coordinates on the circle, and then to cartesian coordinates in the viewport.
 *
 * @param {?} currentValue The current percentage value of the progress circle, the percentage of the
 *    circle to fill.
 * @param {?} rotation The starting point of the circle with 0 being the 0 degree point.
 * @param {?} strokeWidth Stroke width of the progress spinner arc.
 * @return {?} A string for an SVG path representing a circle filled from the starting point to the
 *    percentage value provided.
 */
function getSvgArc(currentValue, rotation, strokeWidth) {
    var /** @type {?} */ startPoint = rotation || 0;
    var /** @type {?} */ radius = 50;
    var /** @type {?} */ pathRadius = radius - strokeWidth;
    var /** @type {?} */ startAngle = startPoint * MAX_ANGLE;
    var /** @type {?} */ endAngle = currentValue * MAX_ANGLE;
    var /** @type {?} */ start = polarToCartesian(radius, pathRadius, startAngle);
    var /** @type {?} */ end = polarToCartesian(radius, pathRadius, endAngle + startAngle);
    var /** @type {?} */ arcSweep = endAngle < 0 ? 0 : 1;
    var /** @type {?} */ largeArcFlag;
    if (endAngle < 0) {
        largeArcFlag = endAngle >= -180 ? 0 : 1;
    }
    else {
        largeArcFlag = endAngle <= 180 ? 0 : 1;
    }
    return "M" + start + "A" + pathRadius + "," + pathRadius + " 0 " + largeArcFlag + "," + arcSweep + " " + end;
}
var XpoProgressSpinnerModule = (function () {
    function XpoProgressSpinnerModule() {
    }
    return XpoProgressSpinnerModule;
}());
XpoProgressSpinnerModule.decorators = [
    { type: NgModule, args: [{
                imports: [XpoCommonModule],
                exports: [
                    XpoProgressSpinner,
                    XpoSpinner,
                    XpoCommonModule,
                    XpoProgressSpinnerCssMatStyler,
                ],
                declarations: [
                    XpoProgressSpinner,
                    XpoSpinner,
                    XpoProgressSpinnerCssMatStyler,
                ],
            },] },
];
/**
 * @nocollapse
 */
XpoProgressSpinnerModule.ctorParameters = function () { return []; };
/* tslint:disable */
/**
 * Provider Expression that allows xpo-radio-group to register as a ControlValueAccessor. This
 * allows it to support [(ngModel)] and ngControl.
 * \@docs-private
 */
var XPO_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return XpoRadioGroup; }),
    multi: true
};
var _uniqueIdCounter$2 = 0;
/**
 * Change event object emitted by XpoRadio and XpoRadioGroup.
 */
var XpoRadioChange = (function () {
    function XpoRadioChange() {
    }
    return XpoRadioChange;
}());
/**
 * A group of radio buttons. May contain one or more `<xpo-radio-button>` elements.
 */
var XpoRadioGroup = (function () {
    function XpoRadioGroup() {
        /**
         * Selected value for group. Should equal the value of the selected radio button if there *is*
         * a corresponding radio button with a matching value. If there is *not* such a corresponding
         * radio button, this value persists to be applied in case a new radio button is added with a
         * matching value.
         */
        this._value = null;
        /**
         * The HTML name attribute applied to radio buttons in this group.
         */
        this._name = "xpo-radio-group-" + _uniqueIdCounter$2++;
        /**
         * Disables all individual radio buttons assigned to this group.
         */
        this._disabled = false;
        /**
         * The currently selected radio button. Should match value.
         */
        this._selected = null;
        /**
         * Whether the `value` has been set to its initial value.
         */
        this._isInitialized = false;
        /**
         * Child radio buttons.
         */
        this._radios = null;
        this.radioLayout = 'vertical';
        /**
         * Event emitted when the group value changes.
         * Change events are only emitted when the value changes due to user interaction with
         * a radio button (the same behavior as `<input type-"radio">`).
         */
        this.change = new EventEmitter();
        /**
         * The method to be called in order to update ngModel
         */
        this._controlValueAccessorChangeFn = function (value) { };
        /**
         * onTouch function registered via registerOnTouch (ControlValueAccessor).
         * \@docs-private
         */
        this.onTouched = function () { };
    }
    Object.defineProperty(XpoRadioGroup.prototype, "name", {
        /**
         * Name of the radio button group. All radio buttons inside this group will use this name.
         * @return {?}
         */
        get: function () { return this._name; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._name = value;
            this._updateRadioButtonNames();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoRadioGroup.prototype, "disabled", {
        /**
         * Whether the radio button is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            // The presence of *any* disabled value makes the component disabled, *except* for false.
            this._disabled = (value != null && value !== false) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoRadioGroup.prototype, "value", {
        /**
         * Value of the radio button.
         * @return {?}
         */
        get: function () { return this._value; },
        /**
         * @param {?} newValue
         * @return {?}
         */
        set: function (newValue) {
            if (this._value != newValue) {
                // Set this before proceeding to ensure no circular loop occurs with selection.
                this._value = newValue;
                this._updateSelectedRadioFromValue();
                this._checkSelectedRadioButton();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoRadioGroup.prototype._checkSelectedRadioButton = function () {
        if (this.selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    };
    Object.defineProperty(XpoRadioGroup.prototype, "selected", {
        /**
         * Whether the radio button is selected.
         * @return {?}
         */
        get: function () { return this._selected; },
        /**
         * @param {?} selected
         * @return {?}
         */
        set: function (selected) {
            this._selected = selected;
            this.value = selected ? selected.value : null;
            this._checkSelectedRadioButton();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Initialize properties once content children are available.
     * This allows us to propagate relevant attributes to associated buttons.
     * @return {?}
     */
    XpoRadioGroup.prototype.ngAfterContentInit = function () {
        // Mark this component as initialized in AfterContentInit because the initial value can
        // possibly be set by NgModel on XpoRadioGroup, and it is possible that the OnInit of the
        // NgModel occurs *after* the OnInit of the XpoRadioGroup.
        this._isInitialized = true;
    };
    /**
     * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
     * radio buttons upon their blur.
     * @return {?}
     */
    XpoRadioGroup.prototype._touch = function () {
        if (this.onTouched) {
            this.onTouched();
        }
    };
    /**
     * @return {?}
     */
    XpoRadioGroup.prototype._updateRadioButtonNames = function () {
        var _this = this;
        if (this._radios) {
            this._radios.forEach(function (radio) {
                radio.name = _this.name;
            });
        }
    };
    /**
     * Updates the `selected` radio button from the internal _value state.
     * @return {?}
     */
    XpoRadioGroup.prototype._updateSelectedRadioFromValue = function () {
        var _this = this;
        // If the value already matches the selected radio, do nothing.
        var /** @type {?} */ isAlreadySelected = this._selected != null && this._selected.value == this._value;
        if (this._radios != null && !isAlreadySelected) {
            this._selected = null;
            this._radios.forEach(function (radio) {
                radio.checked = _this.value == radio.value;
                if (radio.checked) {
                    _this._selected = radio;
                }
            });
        }
    };
    /**
     * Dispatch change event with current selection and group value.
     * @return {?}
     */
    XpoRadioGroup.prototype._emitChangeEvent = function () {
        if (this._isInitialized) {
            var /** @type {?} */ event = new XpoRadioChange();
            event.source = this._selected;
            event.value = this._value;
            this.change.emit(event);
        }
    };
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param {?} value
     * @return {?}
     */
    XpoRadioGroup.prototype.writeValue = function (value) {
        this.value = value;
    };
    /**
     * Registers a callback to be triggered when the model value changes.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be registered.
     * @return {?}
     */
    XpoRadioGroup.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * Registers a callback to be triggered when the control is touched.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be registered.
     * @return {?}
     */
    XpoRadioGroup.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
     * @param {?} isDisabled Whether the control should be disabled.
     * @return {?}
     */
    XpoRadioGroup.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return XpoRadioGroup;
}());
XpoRadioGroup.decorators = [
    { type: Component, args: [{
                selector: 'xpo-radio-group',
                template: "<xpo-form-group class=\"xpo-fieldset\" [labelPosition]=\"labelPosition\"> <div class=\"input-wrapper radio-layout--{{radioLayout}}\"> <ng-content></ng-content> </div> <div *ngIf=\"label\" class=\"xpo-legend\">{{ label }}</div> </xpo-form-group> ",
                styles: [":host .radio-layout--vertical{display:flex;flex-direction:column}:host .radio-layout--vertical ::ng-deep .xpo-radio-button{margin-top:15px}:host .radio-layout--vertical ::ng-deep .xpo-radio-button:first-of-type{margin-top:0}:host .radio-layout--horizontal{display:flex}:host .radio-layout--horizontal ::ng-deep .xpo-radio-button{margin-left:15px}:host .radio-layout--horizontal ::ng-deep .xpo-radio-button:first-of-type{margin-left:0} /*# sourceMappingURL=radio-group.css.map */ "],
                providers: [XPO_RADIO_GROUP_CONTROL_VALUE_ACCESSOR],
                host: {
                    'role': 'radiogroup',
                    '[class.xpo-radio-group]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoRadioGroup.ctorParameters = function () { return []; };
XpoRadioGroup.propDecorators = {
    '_radios': [{ type: ContentChildren, args: [forwardRef(function () { return XpoRadioButton; }),] },],
    'name': [{ type: Input },],
    'disabled': [{ type: Input },],
    'value': [{ type: Input },],
    'selected': [{ type: Input },],
    'label': [{ type: Input },],
    'labelPosition': [{ type: Input },],
    'radioLayout': [{ type: Input },],
    'change': [{ type: Output },],
};
/**
 * A radio-button. May be inside of a radio-group
 */
var XpoRadioButton = (function () {
    /**
     * @param {?} radioGroup
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} radioDispatcher
     */
    function XpoRadioButton(radioGroup, _elementRef, _renderer, radioDispatcher) {
        var _this = this;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.radioDispatcher = radioDispatcher;
        /**
         * Whether this radio is checked.
         */
        this._checked = false;
        /**
         * Value assigned to this radio.
         */
        this._value = null;
        /**
         * The unique ID for the radio button.
         */
        this.id = "xpo-radio-" + _uniqueIdCounter$2++;
        /**
         * Event emitted when the checked state of this radio button changes.
         * Change events are only emitted when the value changes due to user interaction with
         * the radio button (the same behavior as `<input type-"radio">`).
         */
        this.change = new EventEmitter();
        this.radioGroup = radioGroup;
        radioDispatcher.listen(function (id, name) {
            if (id != _this.id && name == _this.name) {
                _this.checked = false;
            }
        });
    }
    Object.defineProperty(XpoRadioButton.prototype, "inputId", {
        /**
         * ID of the native input element inside `<xpo-radio-button>`
         * @return {?}
         */
        get: function () {
            return this.id + "-input";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoRadioButton.prototype, "checked", {
        /**
         * Whether this radio button is checked.
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        /**
         * @param {?} newCheckedState
         * @return {?}
         */
        set: function (newCheckedState) {
            if (this._checked != newCheckedState) {
                this._checked = newCheckedState;
                if (newCheckedState && this.radioGroup && this.radioGroup.value != this.value) {
                    this.radioGroup.selected = this;
                }
                else if (!newCheckedState && this.radioGroup && this.radioGroup.value == this.value) {
                    // When unchecking the selected radio button, update the selected radio
                    // property on the group.
                    this.radioGroup.selected = null;
                }
                if (newCheckedState) {
                    // Notify all radio buttons with the same name to un-check.
                    this.radioDispatcher.notify(this.id, this.name);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoRadioButton.prototype, "disabled", {
        /**
         * Whether the radio button is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled || (this.radioGroup != null && this.radioGroup.disabled);
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            // The presence of *any* disabled value makes the component disabled, *except* for false.
            this._disabled = (value != null && value !== false) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoRadioButton.prototype, "value", {
        /**
         * The value of this radio button.
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value != value) {
                this._value = value;
                if (this.radioGroup != null) {
                    if (!this.checked) {
                        // Update checked when the value changed to match the radio group's value
                        this.checked = this.radioGroup.value == value;
                    }
                    if (this.checked) {
                        this.radioGroup.selected = this;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoRadioButton.prototype, "labelPosition", {
        /**
         * Whether the label should appear after or before the radio button. Defaults to 'after'
         * @return {?}
         */
        get: function () {
            return this._labelPosition || 'right';
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._labelPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoRadioButton.prototype.ngOnInit = function () {
        if (this.radioGroup) {
            // If the radio is inside a radio group, determine if it should be checked
            this.checked = this.radioGroup.value === this._value;
            // Copy name from parent radio group
            this.name = this.radioGroup.name;
        }
    };
    /**
     * Used to append the 'checked' attribute to the input element
     * @return {?}
     */
    XpoRadioButton.prototype._checkedAttr = function () {
        if (this._checked)
            return ''; // display checked attribute
        else
            return null; // dont display checked attribue
    };
    /**
     * Dispatch change event with current value.
     * @return {?}
     */
    XpoRadioButton.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new XpoRadioChange();
        event.source = this;
        event.value = this._value;
        this.change.emit(event);
    };
    /**
     * We use a hidden native input field to handle changes to focus state via keyboard navigation,
     * with visual rendering done separately. The native element is kept in sync with the overall
     * state of the component.
     * @return {?}
     */
    XpoRadioButton.prototype._onInputFocus = function () {
        this._isFocused = true;
    };
    /**
     * Focuses the radio button.
     * @return {?}
     */
    XpoRadioButton.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._inputElement.nativeElement, 'focus');
        this._onInputFocus();
    };
    /**
     * @return {?}
     */
    XpoRadioButton.prototype._onInputBlur = function () {
        this._isFocused = false;
        if (this.radioGroup) {
            this.radioGroup._touch();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoRadioButton.prototype._onInputClick = function (event) {
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `radio-button` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
    };
    /**
     * Triggered when the radio button received a click or the input recognized any change.
     * Clicking on a label element, will trigger a change event on the associated input.
     * @param {?} event
     * @return {?}
     */
    XpoRadioButton.prototype._onInputChange = function (event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the `change` output.
        event.stopPropagation();
        var /** @type {?} */ groupValueChanged = this.radioGroup && this.value != this.radioGroup.value;
        this.checked = true;
        this._emitChangeEvent();
        if (this.radioGroup) {
            this.radioGroup._controlValueAccessorChangeFn(this.value);
            this.radioGroup._touch();
            if (groupValueChanged) {
                this.radioGroup._emitChangeEvent();
            }
        }
    };
    /**
     * @return {?}
     */
    XpoRadioButton.prototype._getInputElement = function () {
        return this._inputElement.nativeElement;
    };
    return XpoRadioButton;
}());
XpoRadioButton.decorators = [
    { type: Component, args: [{ selector: 'xpo-radio-button',
                template: "<label class=\"xpo-radio__wrapper\"> <div class=\"xpo-radio__inner\"> <input [attr.for]=\"inputId\" #input class=\"xpo-radio-button__input cdk-visually-hidden\" type=\"radio\" [id]=\"inputId\" [disabled]=\"disabled\" [name]=\"name\" [checked]=\"checked\" [attr.checked]=\"_checkedAttr()\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onInputChange($event)\" (focus)=\"_onInputFocus()\" (blur)=\"_onInputBlur()\" (click)=\"_onInputClick($event)\"> <span></span> </div> <span class=\"xpo-radio__label-text\"> <ng-content></ng-content> </span> </label>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex}:host:first-of-type{margin-top:0}:host.xpo-radio-button__label--left .xpo-radio__label-text{order:-1;padding-right:15px}:host .xpo-radio__wrapper{display:flex;flex-basis:100%}:host .xpo-radio__label-text{align-self:center;flex:1;cursor:pointer}:host .xpo-radio__inner{display:block;align-self:flex-end;position:relative}:host .xpo-radio__inner input{position:relative;outline:0;cursor:pointer;opacity:0;border:0;z-index:1;-webkit-appearance:none;-moz-appearance:none}:host .xpo-radio__inner input:hover+span{border:1px solid #858585}:host .xpo-radio__inner input:focus+span{box-shadow:0 0 2px 1px #80d8ff}:host .xpo-radio__inner input:checked+span{border-color:#858585}:host .xpo-radio__inner input:checked+span::before{display:block;content:\" \";border-radius:50%;background:#333}:host .xpo-radio__inner input:disabled{cursor:not-allowed}:host .xpo-radio__inner input:disabled+span{border:1px solid #dfdfdf}:host .xpo-radio__inner span{display:block;padding-top:0;position:absolute;top:0;left:0;cursor:pointer;border:1px solid #bdbdbd;border-radius:50%}:host-context(.xpo-internal).xpo-radio-button__label--right .xpo-radio__label-text{padding-left:10px}:host-context(.xpo-internal) .xpo-radio__inner{width:16px;height:16px}:host-context(.xpo-internal) .xpo-radio__inner input{width:16px;height:16px}:host-context(.xpo-internal) .xpo-radio__inner input:checked+span::before{width:8px;height:8px;margin-top:3px}:host-context(.xpo-internal) .xpo-radio__inner span{width:16px;height:16px;padding-left:3px}:host-context(.xpo-external).xpo-radio-button__label--right .xpo-radio__label-text{padding-left:15px}:host-context(.xpo-external) .xpo-radio__label-text{font-size:1rem}:host-context(.xpo-external) .xpo-radio__inner{width:24px;height:24px}:host-context(.xpo-external) .xpo-radio__inner input{width:24px;height:24px}:host-context(.xpo-external) .xpo-radio__inner input:checked+span::before{width:12px;height:12px;margin-top:5px}:host-context(.xpo-external) .xpo-radio__inner span{width:24px;height:24px;padding-left:5px} /*# sourceMappingURL=radio.css.map */ "],
                host: {
                    'class': 'xpo-radio-button',
                    '[attr.id]': 'id',
                    '[class.xpo-radio-button--checked]': 'checked',
                    '[class.xpo-radio-button--disabled]': 'disabled',
                    '[class.xpo-radio-button__label--left]': 'labelPosition == "left"',
                    '[class.xpo-radio-button__label--right]': 'labelPosition == "right"',
                },
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoRadioButton.ctorParameters = function () { return [
    { type: XpoRadioGroup, decorators: [{ type: Optional },] },
    { type: ElementRef, },
    { type: Renderer, },
    { type: UniqueSelectionDispatcher, },
]; };
XpoRadioButton.propDecorators = {
    '_inputElement': [{ type: ViewChild, args: ['input',] },],
    'id': [{ type: Input },],
    'checked': [{ type: Input },],
    'disabled': [{ type: Input },],
    'name': [{ type: Input },],
    'ariaLabel': [{ type: Input, args: ['aria-label',] },],
    'ariaLabelledby': [{ type: Input, args: ['aria-labelledby',] },],
    'value': [{ type: Input },],
    'labelPosition': [{ type: Input },],
    'change': [{ type: Output },],
};
var XpoRadioModule = (function () {
    function XpoRadioModule() {
    }
    return XpoRadioModule;
}());
XpoRadioModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, XpoFormModule],
                exports: [XpoRadioGroup, XpoRadioButton],
                providers: [
                    {
                        provide: UniqueSelectionDispatcher,
                        deps: [[new Optional(), new SkipSelf(), UniqueSelectionDispatcher]],
                        useFactory: UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY,
                    },
                    {
                        provide: ViewportRuler,
                        deps: [[new Optional(), new SkipSelf(), ViewportRuler], ScrollDispatcher],
                        useFactory: VIEWPORT_RULER_PROVIDER_FACTORY,
                    },
                ],
                declarations: [XpoRadioGroup, XpoRadioButton],
            },] },
];
/**
 * @nocollapse
 */
XpoRadioModule.ctorParameters = function () { return []; };
/**
 * <xpo-section> shows text in a preformatted manner.
 */
var XPOSection = (function () {
    function XPOSection() {
    }
    Object.defineProperty(XPOSection.prototype, "helper", {
        /**
         * Helper object
         * @return {?}
         */
        get: function () { return this.helperObj; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.helperObj = value; },
        enumerable: true,
        configurable: true
    });
    return XPOSection;
}());
XPOSection.decorators = [
    { type: Component, args: [{ selector: 'xpo-section',
                host: {},
                template: "<section> <span *ngIf=\"helperObj\"> {{ helperObj.value }} </span> <ng-content></ng-content> </section>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0} /*# sourceMappingURL=section.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XPOSection.ctorParameters = function () { return []; };
XPOSection.propDecorators = {
    'helper': [{ type: Input },],
};
var XpoSectionModule = (function () {
    function XpoSectionModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoSectionModule.forRoot = function () {
        return {
            ngModule: XpoSectionModule,
        };
    };
    return XpoSectionModule;
}());
XpoSectionModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                exports: [XPOSection],
                declarations: [XPOSection],
            },] },
];
/**
 * @nocollapse
 */
XpoSectionModule.ctorParameters = function () { return []; };
/**
 * This animation transforms the select's overlay panel on and off the page.
 *
 * When the panel is attached to the DOM, it expands its width by the amount of padding, scales it
 * up to 100% on the Y axis, fades in its border, and translates slightly up and to the
 * side to ensure the option text correctly overlaps the trigger text.
 *
 * When the panel is removed from the DOM, it simply fades out linearly.
 */
var transformPanel = trigger('transformPanel', [
    state('showing', style({
        opacity: 1,
        minWidth: '100%',
        transform: 'scaleY(1)',
    })),
    state('showing-multiple', style({
        opacity: 1,
        minWidth: '100%',
        transform: 'scaleY(1)',
    })),
    transition('void => *', [
        style({
            opacity: 0,
            minWidth: '100%',
            transform: 'scaleY(0)',
        }),
        animate('150ms cubic-bezier(0.25, 0.8, 0.25, 1)'),
    ]),
    transition('* => void', [
        animate('250ms 100ms linear', style({ opacity: 0 })),
    ]),
]);
/**
 * This animation fades in the background color and text content of the
 * select's options. It is time delayed to occur 100ms after the overlay
 * panel has transformed in.
 */
var fadeInContent = trigger('fadeInContent', [
    state('showing', style({ opacity: 1 })),
    transition('void => showing', [
        style({ opacity: 0 }),
        animate('150ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
    ]),
]);
/**
 * Returns an exception to be thrown when attempting to change a s
 * elect's `multiple` option after initialization.
 * \@docs-private
 * @return {?}
 */
function getXpoSelectDynamicMultipleError() {
    return Error('Cannot change `multiple` mode of select after initialization.');
}
/**
 * Returns an exception to be thrown when attempting to assign a non-array value to a select
 * in `multiple` mode. Note that `undefined` and `null` are still valid values to allow for
 * resetting the value.
 * \@docs-private
 * @return {?}
 */
function getXpoSelectNonArrayValueError() {
    return Error('Cannot assign truthy non-array value to select in `multiple` mode.');
}
/* tslint:disable */
/**
 * The fixed height of every option element.
 */
var SELECT_ITEM_HEIGHT = 34;
/**
 * The max height of the select's overlay panel
 */
var SELECT_PANEL_MAX_HEIGHT = 256;
/**
 * The max number of options visible at once in the select panel.
 */
var SELECT_MAX_OPTIONS_DISPLAYED = 5;
/**
 * The fixed height of the select's trigger element.
 */
var SELECT_TRIGGER_HEIGHT = 30;
/**
 * Must adjust for the difference in height between the option and the trigger,
 * so the text will align on the y axis.
 */
var SELECT_OPTION_HEIGHT_ADJUSTMENT = 0;
/**
 * The panel's padding on the x-axis
 */
var SELECT_PANEL_PADDING_X = 16;
/**
 * The panel's padding on the y-axis. This padding indicates there are more
 * options available if you scroll.
 */
var SELECT_PANEL_PADDING_Y = 16;
/**
 * The select panel will only "fit" inside the viewport if it is positioned at
 * this value or more away from the viewport boundary.
 */
var SELECT_PANEL_VIEWPORT_PADDING = 8;
/**
 * this range for apha numeric keys
 */
var TIME_TO_RESET_SEARCH_STRING = 1000;
var ALPHANUMERIC_RANGE_START = 48;
var ALPHANUMERIC_RANGE_END = 90;
var NUMERIC_KEYPAD_RANGE_START = 96;
var NUMERIC_KEYPAD_RANGE_END = 105;
var nextUniqueId$2 = 0;
/**
 * Change event object that is emitted when the select value has changed.
 */
var XpoSelectChange = (function () {
    /**
     * @param {?} source
     * @param {?} value
     */
    function XpoSelectChange(source, value) {
        this.source = source;
        this.value = value;
    }
    return XpoSelectChange;
}());
/**
 * \@docs-private
 */
var XpoSelectBase = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function XpoSelectBase(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
    }
    return XpoSelectBase;
}());
var _XpoSelectMixinBase = mixinDisabled(XpoSelectBase);
var XpoSelectErrorDirective = (function () {
    function XpoSelectErrorDirective() {
    }
    return XpoSelectErrorDirective;
}());
XpoSelectErrorDirective.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-select-error',
                host: {
                    '[class.xpo-input-error]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoSelectErrorDirective.ctorParameters = function () { return []; };
/**
 * <xpo-select> is a preformatted form control for selecting a value from a set of options, similar to the native <select> element.
 */
var XpoSelect = (function (_super) {
    __extends(XpoSelect, _super);
    /**
     * @param {?} _viewportRuler
     * @param {?} _changeDetectorRef
     * @param {?} renderer
     * @param {?} elementRef
     * @param {?} _dir
     * @param {?} _parentForm
     * @param {?} _parentFormGroup
     * @param {?} _control
     * @param {?} tabIndex
     */
    function XpoSelect(_viewportRuler, _changeDetectorRef, renderer, elementRef, _dir, _parentForm, _parentFormGroup, _control, tabIndex) {
        var _this = _super.call(this, renderer, elementRef) || this;
        _this._viewportRuler = _viewportRuler;
        _this._changeDetectorRef = _changeDetectorRef;
        _this._dir = _dir;
        _this._parentForm = _parentForm;
        _this._parentFormGroup = _parentFormGroup;
        _this._control = _control;
        _this._labelPosition = 'animate';
        /**
         * Variables used for invisibe search on select options
         */
        _this._previousKeypressTime = null;
        _this._keyPressTime = null;
        _this._searchString = '';
        /**
         * Whether or not the overlay panel is open.
         */
        _this._panelOpen = false;
        /**
         * Whether filling out the select is required in the form.
         */
        _this._required = false;
        /**
         * The scroll position of the overlay panel, calculated to center the selected option.
         */
        _this._scrollTop = 0;
        /**
         * Whether the component is in multiple selection mode.
         */
        _this._multiple = false;
        _this._id = _this._uid;
        _this._isError = false;
        /**
         * View -> model callback called when value changes
         */
        _this._onChange = function () { };
        /**
         * View -> model callback called when select has been touched
         */
        _this._onTouched = function () { };
        /**
         * The IDs of child options to be passed to the aria-owns attribute.
         */
        _this._optionIds = '';
        /**
         * The value of the select panel's transform-origin property.
         */
        _this._transformOrigin = 'top';
        /**
         * Whether the panel's animation is done.
         */
        _this._panelDoneAnimating = false;
        /**
         * The y-offset of the overlay panel in relation to the trigger's top start corner.
         * This must be adjusted to align the selected option text over the trigger text.
         * when the panel opens. Will change based on the y-position of the selected option.
         */
        _this._offsetY = 7;
        /**
         * This position config ensures that the top "start" corner of the overlay
         * is aligned with with the top "start" of the origin by default (overlapping
         * the trigger completely). If the panel cannot fit below the trigger, it
         * will fall back to a position above the trigger.
         */
        _this._positions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        /**
         * Aria label of the select. If not specified, the placeholder will be used as label.
         */
        _this.ariaLabel = '';
        /**
         * Input that can be used to specify the `aria-labelledby` attribute.
         */
        _this.ariaLabelledby = '';
        /**
         * Event emitted when the select has been opened.
         */
        _this.onOpen = new EventEmitter();
        /**
         * Event emitted when the select has been closed.
         */
        _this.onClose = new EventEmitter();
        /**
         * Event emitted when the selected value has been changed by the user.
         */
        _this.change = new EventEmitter();
        if (_this._control) {
            _this._control.valueAccessor = _this;
        }
        _this._tabIndex = parseInt(tabIndex) || 0;
        return _this;
    }
    Object.defineProperty(XpoSelect.prototype, "id", {
        /**
         * Unique id of the element.
         * @return {?}
         */
        get: function () { return this._id; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._id = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "placeholder", {
        /**
         * Placeholder to be shown if no value has been selected.
         * @return {?}
         */
        get: function () { return this._placeholder; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var _this = this;
            this._placeholder = value;
            // Must wait to record the trigger width to ensure placeholder width is included.
            Promise.resolve(null).then(function () { return _this._setTriggerWidth(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "required", {
        /**
         * Whether the component is required.
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._required = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "multiple", {
        /**
         * Whether the user should be allowed to select multiple options.
         * @return {?}
         */
        get: function () { return this._multiple; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._selectionModel) {
                throw getXpoSelectDynamicMultipleError();
            }
            this._multiple = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "tabIndex", {
        /**
         * Tab index for the select element.
         * @return {?}
         */
        get: function () { return this.disabled ? -1 : this._tabIndex; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (typeof value !== 'undefined') {
                this._tabIndex = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "optionSelectionChanges", {
        /**
         * Combined stream of all of the child options' change events.
         * @return {?}
         */
        get: function () {
            return merge.apply(void 0, this.options.map(function (option) { return option.onSelectionChange; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "labelPosition", {
        /**
         * @return {?}
         */
        get: function () { return this._labelPosition; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._labelPosition = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "label", {
        /**
         * @return {?}
         */
        get: function () { return this._label; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this._label = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "_uid", {
        /**
         * @return {?}
         */
        get: function () { return this._cachedUid = this._cachedUid || "xpo-select-" + nextUniqueId$2++; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoSelect.prototype.ngOnInit = function () {
        this._selectionModel = new SelectionModel(this.multiple, undefined, false);
    };
    /**
     * @return {?}
     */
    XpoSelect.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._initKeyManager();
        this._changeSubscription = startWith$1.call(this.options.changes, null).subscribe(function () {
            _this._resetOptions();
            if (_this._control) {
                // Defer setting the value in order to avoid the "Expression
                // has changed after it was checked" errors from Angular.
                Promise.resolve(null).then(function () { return _this._setSelectionByValue(_this._control.value); });
            }
        });
    };
    /**
     * @return {?}
     */
    XpoSelect.prototype.ngOnDestroy = function () {
        this._dropSubscriptions();
        if (this._changeSubscription) {
            this._changeSubscription.unsubscribe();
        }
        if (this._tabSubscription) {
            this._tabSubscription.unsubscribe();
        }
    };
    /**
     * Toggles the overlay panel open or closed.
     * @return {?}
     */
    XpoSelect.prototype.toggle = function () {
        this.panelOpen ? this.close() : this.open();
    };
    /**
     * Opens the overlay panel.
     * @return {?}
     */
    XpoSelect.prototype.open = function () {
        if (this.disabled || !this.options.length) {
            return;
        }
        if (!this._triggerWidth) {
            this._setTriggerWidth();
        }
        this._calculateOverlayPosition();
        this._panelOpen = true;
    };
    /**
     * Closes the overlay panel and focuses the host element.
     * @return {?}
     */
    XpoSelect.prototype.close = function () {
        if (this._panelOpen) {
            this._panelOpen = false;
            this.focus();
        }
    };
    /**
     * Sets the select's value. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param {?} value New value to be written to the model.
     * @return {?}
     */
    XpoSelect.prototype.writeValue = function (value) {
        if (this.options) {
            this._setSelectionByValue(value);
        }
    };
    /**
     * Saves a callback function to be invoked when the select's value
     * changes from user input. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param {?} fn Callback to be triggered when the value changes.
     * @return {?}
     */
    XpoSelect.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    /**
     * Saves a callback function to be invoked when the select is blurred
     * by the user. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param {?} fn Callback to be triggered when the component has been touched.
     * @return {?}
     */
    XpoSelect.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    /**
     * Disables the select. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param {?} isDisabled Sets whether the component is disabled.
     * @return {?}
     */
    XpoSelect.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    Object.defineProperty(XpoSelect.prototype, "panelOpen", {
        /**
         * Whether or not the overlay panel is open.
         * @return {?}
         */
        get: function () {
            return this._panelOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "selected", {
        /**
         * The currently selected option.
         * @return {?}
         */
        get: function () {
            return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSelect.prototype, "triggerValue", {
        /**
         * The value displayed in the trigger.
         * @return {?}
         */
        get: function () {
            if (this._multiple) {
                var /** @type {?} */ selectedOptions = this._selectionModel.selected.map(function (option) { return option.viewValue; });
                if (this._isRtl()) {
                    selectedOptions.reverse();
                }
                // TODO(crisbeto): delimiter should be configurable for proper localization.
                return selectedOptions.join(', ');
            }
            return this._selectionModel.selected[0].viewValue;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Whether the element is in RTL mode.
     * @return {?}
     */
    XpoSelect.prototype._isRtl = function () {
        return this._dir ? this._dir.value === 'rtl' : false;
    };
    /**
     * Sets the width of the trigger element. This is necessary to match
     * the overlay width to the trigger width.
     * @return {?}
     */
    XpoSelect.prototype._setTriggerWidth = function () {
        this._triggerWidth = this._getTriggerRect().width;
    };
    /**
     * Handles the keyboard interactions of a closed select.
     * @param {?} event
     * @return {?}
     */
    XpoSelect.prototype._handleClosedKeydown = function (event) {
        if (!this.disabled) {
            if (event.keyCode === ENTER || event.keyCode === SPACE) {
                event.preventDefault(); // prevents the page from scrolling down when pressing space
                this.open();
            }
            else if (event.keyCode === UP_ARROW || event.keyCode === DOWN_ARROW) {
                this._handleArrowKey(event);
            }
        }
    };
    /**
     * Handles keypresses inside the panel.
     * @param {?} event
     * @return {?}
     */
    XpoSelect.prototype._handlePanelKeydown = function (event) {
        if (event.keyCode === HOME || event.keyCode === END) {
            event.preventDefault();
            event.keyCode === HOME ? this._keyManager.setFirstItemActive() :
                this._keyManager.setLastItemActive();
        }
        else {
            this._keyManager.onKeydown(event);
        }
    };
    /**
     * Handles invisible search on keypress inside the panel.
     * @param {?} event
     * @return {?}
     */
    XpoSelect.prototype._search = function (event) {
        var _this = this;
        /** Handles invisible search on keypress inside the panel. */
        if ((event.keyCode >= ALPHANUMERIC_RANGE_START && event.keyCode <= ALPHANUMERIC_RANGE_END) ||
            (event.keyCode >= NUMERIC_KEYPAD_RANGE_START && event.keyCode <= NUMERIC_KEYPAD_RANGE_END)) {
            this._previousKeypressTime = this._previousKeypressTime ? this._keyPressTime : new Date().getTime();
            this._keyPressTime = new Date().getTime();
            var /** @type {?} */ timeDifference = this._keyPressTime - this._previousKeypressTime; // msec
            if (timeDifference >= TIME_TO_RESET_SEARCH_STRING) {
                this._searchString = '';
            }
            this._searchString = "" + this._searchString + event.key;
            var /** @type {?} */ filteredList = this.options.toArray().filter(function (item) { return item.viewValue.toLowerCase().indexOf(_this._searchString.toLowerCase()) === 0; });
            if (filteredList.length !== 0) {
                this._keyManager.setActiveItem(this.options.toArray().indexOf(filteredList[0]));
            }
        }
        else {
            this._keyManager.onKeydown(event);
        }
    };
    /**
     * When the panel element is finished transforming in (though not fading in), it
     * emits an event and focuses an option if the panel is open.
     * @return {?}
     */
    XpoSelect.prototype._onPanelDone = function () {
        if (this.panelOpen) {
            this._focusCorrectOption();
            this.onOpen.emit();
        }
        else {
            this.onClose.emit();
            this._panelDoneAnimating = false;
            this.overlayDir.offsetX = 0;
        }
    };
    /**
     * When the panel content is done fading in, the _panelDoneAnimating property is
     * set so the proper class can be added to the panel.
     * @return {?}
     */
    XpoSelect.prototype._onFadeInDone = function () {
        this._panelDoneAnimating = this.panelOpen;
    };
    /**
     * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
     * "blur" to the panel when it opens, causing a false positive.
     * @return {?}
     */
    XpoSelect.prototype._onBlur = function () {
        if (!this.panelOpen) {
            this.isFocused = false;
            this._onTouched();
        }
    };
    /**
     * @return {?}
     */
    XpoSelect.prototype._onFocus = function () {
        if (!this.isFocused) {
            this.isFocused = true;
        }
    };
    /**
     * Callback that is invoked when the overlay panel has been attached.
     * @return {?}
     */
    XpoSelect.prototype._onAttached = function () {
        this._setScrollTop();
    };
    /**
     * @return {?}
     */
    XpoSelect.prototype._setErrorMessages = function () {
        this._isError = true;
    };
    /**
     * Whether the select is in an error state.
     * @return {?}
     */
    XpoSelect.prototype._isErrorState = function () {
        var /** @type {?} */ isInvalid = this._control && this._control.invalid;
        var /** @type {?} */ isTouched = this._control && this._control.touched;
        var /** @type {?} */ isSubmitted = (this._parentFormGroup && this._parentFormGroup.submitted) ||
            (this._parentForm && this._parentForm.submitted);
        if (!!(isInvalid && (isTouched || isSubmitted))) {
            this._setErrorMessages();
        }
        return !!(isInvalid && (isTouched || isSubmitted));
    };
    /**
     * Sets the scroll position of the scroll container. This must be called after
     * the overlay pane is attached or the scroll container element will not yet be
     * present in the DOM.
     * @return {?}
     */
    XpoSelect.prototype._setScrollTop = function () {
        var /** @type {?} */ scrollContainer = this.overlayDir.overlayRef.overlayElement.querySelector('.xpo-select-panel'); /** @type {?} */
        ((scrollContainer)).scrollTop = this._scrollTop;
    };
    /**
     * Sets the selected option based on a value. If no option can be
     * found with the designated value, the select trigger is cleared.
     * @param {?} value
     * @param {?=} isUserInput
     * @return {?}
     */
    XpoSelect.prototype._setSelectionByValue = function (value, isUserInput) {
        var _this = this;
        if (isUserInput === void 0) { isUserInput = false; }
        var /** @type {?} */ isArray = Array.isArray(value);
        if (this.multiple && value && !isArray) {
            throw getXpoSelectNonArrayValueError();
        }
        this._clearSelection();
        if (isArray) {
            value.forEach(function (currentValue) { return _this._selectValue(currentValue, isUserInput); });
            this._sortValues();
        }
        else {
            this._selectValue(value, isUserInput);
        }
        this._setValueWidth();
        this._changeDetectorRef.markForCheck();
    };
    /**
     * Finds and selects and option based on its value.
     * @param {?} value
     * @param {?=} isUserInput
     * @return {?} Option that has the corresponding value.
     */
    XpoSelect.prototype._selectValue = function (value, isUserInput) {
        if (isUserInput === void 0) { isUserInput = false; }
        var /** @type {?} */ optionsArray = this.options.toArray();
        var /** @type {?} */ correspondingOption = optionsArray.find(function (option) {
            return option.value != null && option.value === value;
        });
        if (correspondingOption) {
            isUserInput ? correspondingOption._selectViaInteraction() : correspondingOption.select();
            this._selectionModel.select(correspondingOption);
            this._keyManager.setActiveItem(optionsArray.indexOf(correspondingOption));
        }
        return correspondingOption;
    };
    /**
     * Clears the select trigger and deselects every option in the list.
     * @param {?=} skip Option that should not be deselected.
     * @return {?}
     */
    XpoSelect.prototype._clearSelection = function (skip) {
        this._selectionModel.clear();
        this.options.forEach(function (option) {
            if (option !== skip) {
                option.deselect();
            }
        });
    };
    /**
     * @return {?}
     */
    XpoSelect.prototype._getTriggerRect = function () {
        return this.trigger.nativeElement.getBoundingClientRect();
    };
    /**
     * Sets up a key manager to listen to keyboard events on the overlay panel.
     * @return {?}
     */
    XpoSelect.prototype._initKeyManager = function () {
        var _this = this;
        this._keyManager = new FocusKeyManager(this.options);
        this._tabSubscription = this._keyManager.tabOut.subscribe(function () { return _this.close(); });
    };
    /**
     * Drops current option subscriptions and IDs and resets from scratch.
     * @return {?}
     */
    XpoSelect.prototype._resetOptions = function () {
        this._dropSubscriptions();
        this._listenToOptions();
        this._setOptionIds();
        this._setOptionMultiple();
    };
    /**
     * Listens to user-generated selection events on each option.
     * @return {?}
     */
    XpoSelect.prototype._listenToOptions = function () {
        var _this = this;
        this._optionSubscription = filter$1.call(this.optionSelectionChanges, function (event) { return event.isUserInput; }).subscribe(function (event) {
            _this._onSelect(event.source);
            _this._setValueWidth();
            if (!_this.multiple) {
                _this.close();
            }
        });
    };
    /**
     * Invoked when an option is clicked.
     * @param {?} option
     * @return {?}
     */
    XpoSelect.prototype._onSelect = function (option) {
        var /** @type {?} */ wasSelected = this._selectionModel.isSelected(option);
        if (this.multiple) {
            this._selectionModel.toggle(option);
            wasSelected ? option.deselect() : option.select();
            this._sortValues();
        }
        else {
            this._clearSelection(option.value == null ? undefined : option);
            if (option.value == null) {
                this._propagateChanges(option.value);
            }
            else {
                this._selectionModel.select(option);
            }
        }
        if (wasSelected !== this._selectionModel.isSelected(option)) {
            this._propagateChanges();
        }
    };
    /**
     * Sorts the model values, ensuring that they keep the same
     * order that they have in the panel.
     * @return {?}
     */
    XpoSelect.prototype._sortValues = function () {
        var _this = this;
        if (this._multiple) {
            this._selectionModel.clear();
            this.options.forEach(function (option) {
                if (option.selected) {
                    _this._selectionModel.select(option);
                }
            });
        }
    };
    /**
     * Unsubscribes from all option subscriptions.
     * @return {?}
     */
    XpoSelect.prototype._dropSubscriptions = function () {
        if (this._optionSubscription) {
            this._optionSubscription.unsubscribe();
            this._optionSubscription = null;
        }
    };
    /**
     * Emits change event to set the model value.
     * @param {?=} fallbackValue
     * @return {?}
     */
    XpoSelect.prototype._propagateChanges = function (fallbackValue) {
        var /** @type {?} */ valueToEmit = null;
        if (Array.isArray(this.selected)) {
            valueToEmit = this.selected.map(function (option) { return option.value; });
        }
        else {
            valueToEmit = this.selected ? this.selected.value : fallbackValue;
        }
        this._onChange(valueToEmit);
        this.change.emit(new XpoSelectChange(this, valueToEmit));
    };
    /**
     * Records option IDs to pass to the aria-owns property.
     * @return {?}
     */
    XpoSelect.prototype._setOptionIds = function () {
        this._optionIds = this.options.map(function (option) { return option.id; }).join(' ');
    };
    /**
     * Sets the `multiple` property on each option. The promise is necessary
     * in order to avoid Angular errors when modifying the property after init.
     * @return {?}
     */
    XpoSelect.prototype._setOptionMultiple = function () {
        var _this = this;
        if (this.multiple) {
            Promise.resolve(null).then(function () {
                _this.options.forEach(function (option) { return option.multiple = _this.multiple; });
            });
        }
    };
    /**
     * Must set the width of the selected option's value programmatically
     * because it is absolutely positioned and otherwise will not clip
     * overflow. The selection arrow is 9px wide, add 4px of padding = 13
     * @return {?}
     */
    XpoSelect.prototype._setValueWidth = function () {
        this._selectedValueWidth = this._triggerWidth;
    };
    /**
     * Focuses the selected item. If no option is selected, it will focus
     * the first item instead.
     * @return {?}
     */
    XpoSelect.prototype._focusCorrectOption = function () {
        if (this._selectionModel.isEmpty()) {
            this._keyManager.setFirstItemActive();
        }
        else {
            this._keyManager.setActiveItem(/** @type {?} */ ((this._getOptionIndex(this._selectionModel.selected[0]))));
        }
    };
    /**
     * Focuses the select element.
     * @return {?}
     */
    XpoSelect.prototype.focus = function () {
        this._elementRef.nativeElement.focus();
    };
    /**
     * Gets the index of the provided option in the option list.
     * @param {?} option
     * @return {?}
     */
    XpoSelect.prototype._getOptionIndex = function (option) {
        return this.options.reduce(function (result, current, index) {
            return result === undefined ? (option === current ? index : undefined) : result;
        }, undefined);
    };
    /**
     * Calculates the scroll position and x- and y-offsets of the overlay panel.
     * @return {?}
     */
    XpoSelect.prototype._calculateOverlayPosition = function () {
        var /** @type {?} */ items = this._getItemCount();
        var /** @type {?} */ panelHeight = Math.min(items * SELECT_ITEM_HEIGHT, SELECT_PANEL_MAX_HEIGHT);
        var /** @type {?} */ scrollContainerHeight = items * SELECT_ITEM_HEIGHT;
        // The farthest the panel can be scrolled before it hits the bottom
        var /** @type {?} */ maxScroll = scrollContainerHeight - panelHeight;
        if (this._selectionModel.hasValue()) {
            var /** @type {?} */ selectedOptionOffset = ((this._getOptionIndex(this._selectionModel.selected[0])));
            selectedOptionOffset += this._getLabelCountBeforeOption(selectedOptionOffset);
            // We must maintain a scroll buffer so the selected option will be scrolled to the
            // center of the overlay panel rather than the top.
            var /** @type {?} */ scrollBuffer = panelHeight / 2;
            this._scrollTop = this._calculateOverlayScroll(selectedOptionOffset, scrollBuffer, maxScroll);
        }
        else {
            // If no option is selected, the panel centers on the first option. In this case,
            // we must only adjust for the height difference between the option element
            // and the trigger element, then multiply it by -1 to ensure the panel moves
            // in the correct direction up the page.
        }
        this._checkOverlayWithinViewport(maxScroll);
    };
    /**
     * Calculates the scroll position of the select's overlay panel.
     *
     * Attempts to center the selected option in the panel. If the option is
     * too high or too low in the panel to be scrolled to the center, it clamps the
     * scroll position to the min or max scroll positions respectively.
     * @param {?} selectedIndex
     * @param {?} scrollBuffer
     * @param {?} maxScroll
     * @return {?}
     */
    XpoSelect.prototype._calculateOverlayScroll = function (selectedIndex, scrollBuffer, maxScroll) {
        var /** @type {?} */ optionOffsetFromScrollTop = SELECT_ITEM_HEIGHT * selectedIndex;
        var /** @type {?} */ halfOptionHeight = SELECT_ITEM_HEIGHT / 2;
        // Starts at the optionOffsetFromScrollTop, which scrolls the option to the top of the
        // scroll container, then subtracts the scroll buffer to scroll the option down to
        // the center of the overlay panel. Half the option height must be re-added to the
        // scrollTop so the option is centered based on its middle, not its top edge.
        var /** @type {?} */ optimalScrollPosition = optionOffsetFromScrollTop - scrollBuffer + halfOptionHeight;
        return clampValue(0, optimalScrollPosition, maxScroll);
    };
    /**
     * Determines the CSS `opacity` of the placeholder element.
     * @return {?}
     */
    XpoSelect.prototype._getPlaceholderOpacity = function () {
        return this._selectionModel.isEmpty() ? '1' : '0';
    };
    Object.defineProperty(XpoSelect.prototype, "_ariaLabel", {
        /**
         * Returns the aria-label of the select component.
         * @return {?}
         */
        get: function () {
            // If an ariaLabelledby value has been set, the select should not overwrite the
            // `aria-labelledby` value by setting the ariaLabel to the placeholder.
            return this.ariaLabelledby ? null : this.ariaLabel || this.placeholder;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calculates the y-offset of the select's overlay panel in relation to the
     * top start corner of the trigger. It has to be adjusted in order for the
     * selected option to be aligned over the trigger when the panel opens.
     * @param {?} selectedIndex
     * @param {?} scrollBuffer
     * @param {?} maxScroll
     * @return {?}
     */
    XpoSelect.prototype._calculateOverlayOffsetY = function (selectedIndex, scrollBuffer, maxScroll) {
        var /** @type {?} */ optionOffsetFromPanelTop;
        if (this._scrollTop === 0) {
            optionOffsetFromPanelTop = selectedIndex * SELECT_ITEM_HEIGHT;
        }
        else if (this._scrollTop === maxScroll) {
            var /** @type {?} */ firstDisplayedIndex = this._getItemCount() - SELECT_MAX_OPTIONS_DISPLAYED;
            var /** @type {?} */ selectedDisplayIndex = selectedIndex - firstDisplayedIndex;
            // Because the panel height is longer than the height of the options alone,
            // there is always extra padding at the top or bottom of the panel. When
            // scrolled to the very bottom, this padding is at the top of the panel and
            // must be added to the offset.
            optionOffsetFromPanelTop =
                selectedDisplayIndex * SELECT_ITEM_HEIGHT + SELECT_PANEL_PADDING_Y;
        }
        else {
            // If the option was scrolled to the middle of the panel using a scroll buffer,
            // its offset will be the scroll buffer minus the half height that was added to
            // center it.
            optionOffsetFromPanelTop = scrollBuffer - SELECT_ITEM_HEIGHT / 2;
        }
        // The final offset is the option's offset from the top, adjusted for the height
        // difference, multiplied by -1 to ensure that the overlay moves in the correct
        // direction up the page.
        return optionOffsetFromPanelTop * -1 - SELECT_OPTION_HEIGHT_ADJUSTMENT;
    };
    /**
     * Checks that the attempted overlay position will fit within the viewport.
     * If it will not fit, tries to adjust the scroll position and the associated
     * y-offset so the panel can open fully on-screen. If it still won't fit,
     * sets the offset back to 0 to allow the fallback position to take over.
     * @param {?} maxScroll
     * @return {?}
     */
    XpoSelect.prototype._checkOverlayWithinViewport = function (maxScroll) {
        var /** @type {?} */ viewportRect = this._viewportRuler.getViewportRect();
        var /** @type {?} */ triggerRect = this._getTriggerRect();
        var /** @type {?} */ topSpaceAvailable = triggerRect.top - SELECT_PANEL_VIEWPORT_PADDING;
        var /** @type {?} */ bottomSpaceAvailable = viewportRect.height - triggerRect.bottom - SELECT_PANEL_VIEWPORT_PADDING;
        var /** @type {?} */ totalPanelHeight = Math.min(this._getItemCount() * SELECT_ITEM_HEIGHT, SELECT_PANEL_MAX_HEIGHT);
        var /** @type {?} */ panelHeightBottom = totalPanelHeight - triggerRect.height;
        if (panelHeightBottom > bottomSpaceAvailable) {
            this._adjustPanelUp(panelHeightBottom, bottomSpaceAvailable);
        }
        else {
            this._transformOrigin = this._getOriginBasedOnOption();
        }
    };
    /**
     * Adjusts the overlay panel up to fit in the viewport.
     * @param {?} panelHeightBottom
     * @param {?} bottomSpaceAvailable
     * @return {?}
     */
    XpoSelect.prototype._adjustPanelUp = function (panelHeightBottom, bottomSpaceAvailable) {
        var /** @type {?} */ distanceBelowViewport = panelHeightBottom - bottomSpaceAvailable;
        // Scrolls the panel up by the distance it was extending past the boundary, then
        // adjusts the offset by that amount to move the panel up into the viewport.
        this._scrollTop -= distanceBelowViewport;
        this._transformOrigin = this._getOriginBasedOnOption();
        // If the panel is scrolled to the very top, it won't be able to fit the panel
        // by scrolling, so set the offset to 0 to allow the fallback position to take
        // effect.
        if (this._scrollTop <= 0) {
            this._scrollTop = 0;
            this._transformOrigin = "50% bottom 0px";
        }
    };
    /**
     * Adjusts the overlay panel down to fit in the viewport.
     * @param {?} panelHeightTop
     * @param {?} topSpaceAvailable
     * @param {?} maxScroll
     * @return {?}
     */
    XpoSelect.prototype._adjustPanelDown = function (panelHeightTop, topSpaceAvailable, maxScroll) {
        var /** @type {?} */ distanceAboveViewport = panelHeightTop - topSpaceAvailable;
        // Scrolls the panel down by the distance it was extending past the boundary, then
        // adjusts the offset by that amount to move the panel down into the viewport.
        this._scrollTop += distanceAboveViewport;
        this._transformOrigin = this._getOriginBasedOnOption();
        // If the panel is scrolled to the very bottom, it won't be able to fit the
        // panel by scrolling, so set the offset to 0 to allow the fallback position
        // to take effect.
        if (this._scrollTop >= maxScroll) {
            this._scrollTop = maxScroll;
            this._transformOrigin = "50% top 0px";
            return;
        }
    };
    /**
     * Sets the transform origin point based on the selected option.
     * @return {?}
     */
    XpoSelect.prototype._getOriginBasedOnOption = function () {
        var /** @type {?} */ originY = (SELECT_OPTION_HEIGHT_ADJUSTMENT + SELECT_ITEM_HEIGHT) / 2;
        return "50% " + originY + "px 0px";
    };
    /**
     * Handles the user pressing the arrow keys on a closed select.
     * @param {?} event
     * @return {?}
     */
    XpoSelect.prototype._handleArrowKey = function (event) {
        if (this._multiple) {
            event.preventDefault();
            this.open();
        }
        else {
            var /** @type {?} */ prevActiveItem = this._keyManager.activeItem;
            // Cycle though the select options even when the select is closed,
            // matching the behavior of the native select element.
            // TODO(crisbeto): native selects also cycle through the options with left/right arrows,
            // however the key manager only supports up/down at the moment.
            this._keyManager.onKeydown(event);
            var /** @type {?} */ currentActiveItem = (this._keyManager.activeItem);
            if (currentActiveItem !== prevActiveItem) {
                this._clearSelection();
                this._setSelectionByValue(currentActiveItem.value, true);
                this._propagateChanges();
            }
        }
    };
    /**
     * Calculates the amount of items in the select. This includes options and group labels.
     * @return {?}
     */
    XpoSelect.prototype._getItemCount = function () {
        return this.options.length + this.optionGroups.length;
    };
    /**
     * Calculates the amount of option group labels that precede the specified option.
     * Useful when positioning the panel, because the labels will offset the index of the
     * currently-selected option.
     * @param {?} optionIndex
     * @return {?}
     */
    XpoSelect.prototype._getLabelCountBeforeOption = function (optionIndex) {
        if (this.optionGroups.length) {
            var /** @type {?} */ options = this.options.toArray();
            var /** @type {?} */ groups = this.optionGroups.toArray();
            var /** @type {?} */ groupCounter = 0;
            for (var /** @type {?} */ i = 0; i < optionIndex + 1; i++) {
                if (options[i].group && options[i].group === groups[groupCounter]) {
                    groupCounter++;
                }
            }
            return groupCounter;
        }
        return 0;
    };
    return XpoSelect;
}(_XpoSelectMixinBase));
XpoSelect.decorators = [
    { type: Component, args: [{ selector: 'xpo-select',
                template: "<xpo-form-group [labelPosition]=\"labelPosition\"> <div class=\"xpo-select-trigger\" cdk-overlay-origin (click)=\"toggle()\" [attr.id]=\"id\" [class.xpo-focused]=\"isFocused\" [class.xpo-empty]=\"_selectionModel.isEmpty() && !placeholder\" #origin=\"cdkOverlayOrigin\" #trigger> <span class=\"xpo-select-placeholder\" [style.opacity]=\"_getPlaceholderOpacity()\" [style.width.px]=\"_selectedValueWidth\"> {{ placeholder }} </span> <span class=\"xpo-select-value\" *ngIf=\"_selectionModel.hasValue()\"> <span class=\"xpo-select-value-text\">{{ triggerValue }}</span> </span> <span class=\"xpo-select-arrow\"></span> <span class=\"xpo-select-underline\"> <span class=\"xpo-input-ripple\"></span> </span> </div> <label for=\"{{id}}\" (click)=\"toggle()\"> {{ label }} </label> <!-- This is displayed when someone tries to submit without choosing a value and the required has been set--> <span *ngIf=\"_isErrorState()\" class=\"xpo-select-error\">Required Field</span> <!-- End of error thrown --> </xpo-form-group> <ng-template cdk-connected-overlay hasBackdrop backdropClass=\"cdk-overlay-transparent-backdrop\" [origin]=\"origin\" [open]=\"panelOpen\" [positions]=\"_positions\" [minWidth]=\"_triggerWidth\" [offsetY]=\"_offsetY\" (backdropClick)=\"close()\" (attach)=\"_onAttached()\" (detach)=\"close()\"> <div class=\"xpo-select-panel\" [@transformPanel]=\"multiple ? 'showing-multiple' : 'showing'\" (@transformPanel.done)=\"_onPanelDone()\" [style.transformOrigin]=\"_transformOrigin\" [class.xpo-select-panel-done-animating]=\"_panelDoneAnimating\" [ngClass]=\"panelClass\" (keydown)=\"_search($event)\"> <div class=\"xpo-select-content\" [@fadeInContent]=\"'showing'\" (@fadeInContent.done)=\"_onFadeInDone()\"> <ng-content></ng-content> </div> </div> </ng-template> <!-- Other label positions --> <!-- <xpo-form-group class=\"xpo-form-group xpo-form-group__label--left\" labelposition=\"left\"> <xpo-select class=\"xpo-select\" id=\"selectLeft\" name=\"noteType\" placeholder=\"\"> <div class=\"xpo-select-trigger\"> <span class=\"xpo-select-placeholder ng-trigger ng-trigger-transformPlaceholder\" style=\"opacity: 1;\"> </span> <span class=\"xpo-select-arrow\"></span> <span class=\"xpo-select-underline\"> <span class=\"xpo-input-ripple\"></span> </span> </div> </xpo-select> <label for=\"selectLeft\">Draft interrogation</label> </xpo-form-group> --> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:block;outline:0}:host.xpo-focused:not([aria-disabled=true]) .xpo-input-ripple{opacity:1}:host.ng-invalid:not(.ng-untouched):not([aria-disabled=true]) .xpo-select-underline .xpo-input-ripple{opacity:1;background-color:#d50000}:host.xpo-error .xpo-select-underline,:host.xpo-error label{color:#d50000;border-color:#d50000}:host.xpo-select-invalid .xpo-select-underline{border-color:#d50000}:host.xpo-select-invalid label{color:#d50000}.xpo-select-trigger{position:relative;cursor:pointer}[aria-disabled=true] .xpo-select-trigger{cursor:default;user-select:none}.xpo-select-placeholder{flex-grow:1;padding:0 2px;position:absolute;transform-origin:left top}[dir=rtl] .xpo-select-placeholder{transform-origin:right top}.xpo-select-value{max-width:100%;position:absolute}[dir=rtl] .xpo-select-value{right:0;left:auto}.xpo-select-value-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.xpo-select-arrow{width:0;height:0;margin:0 4px;position:absolute;right:0}.xpo-select-underline{width:100%;height:1px;position:absolute;border-top:1px solid #bdbdbd}[aria-disabled=true] .xpo-select-underline{background-image:linear-gradient(to right,rgba(0,0,0,.26) 0,rgba(0,0,0,.26) 33%,transparent 0);background-repeat:repeat-x;background-size:4px 1px;border-top:none;background-color:transparent;background-position:0 bottom}.xpo-input-ripple{width:100%;height:1px;position:absolute;top:-1px;transform-origin:top;opacity:0;background-color:#0091ea;z-index:1;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.xpo-select-panel{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);max-width:280px;min-width:112px;overflow:auto;-webkit-overflow-scrolling:touch;min-width:100%;max-height:256px;margin-top:-5px;padding-top:0;padding-bottom:0;background-color:#fff}:host-context(.xpo-internal) .xpo-select-trigger{height:17px}:host-context(.xpo-internal) .xpo-select-placeholder{bottom:1px;line-height:17px}:host-context(.xpo-internal) .xpo-select-value{height:17px;bottom:2px}:host-context(.xpo-internal) .xpo-select-value-text{line-height:17px}:host-context(.xpo-internal) .xpo-select-arrow{top:25%;border-top:5px solid;border-right:5px solid transparent;border-left:5px solid transparent}:host-context(.xpo-internal) .xpo-select-underline{top:17px}:host-context(.xpo-external) .xpo-select-trigger{height:27px}:host-context(.xpo-external) .xpo-select-placeholder{bottom:7px;font-size:1.1667rem;line-height:27px}:host-context(.xpo-external) .xpo-select-value{height:27px;bottom:7px;font-size:1.1667rem}:host-context(.xpo-external) .xpo-select-value-text{line-height:27px}:host-context(.xpo-external) .xpo-select-arrow{top:15%;border-top:6px solid;border-right:6px solid transparent;border-left:6px solid transparent}:host-context(.xpo-external) .xpo-select-underline{top:27px} /*# sourceMappingURL=select.css.map */ "],
                inputs: ['color', 'disabled'],
                host: {
                    'role': 'listbox',
                    '[id]': 'id',
                    '[attr.tabindex]': 'tabIndex',
                    '[attr.aria-label]': '_ariaLabel',
                    '[attr.aria-labelledby]': 'ariaLabelledby',
                    '[attr.aria-required]': 'required.toString()',
                    '[attr.aria-disabled]': 'disabled.toString()',
                    '[attr.aria-invalid]': '_control?.invalid || "false"',
                    '[class.xpo-select-invalid]': '_isErrorState()',
                    '[attr.aria-owns]': '_optionIds',
                    '[class.xpo-select-disabled]': 'disabled',
                    'class': 'xpo-select',
                    '[class.xpo-focused]': 'isFocused',
                    '(keydown)': '_handleClosedKeydown($event)',
                    '(focus)': '_onFocus()',
                    '(blur)': '_onBlur()',
                },
                animations: [
                    transformPanel,
                    fadeInContent
                ],
                exportAs: 'xpoSelect',
            },] },
];
/**
 * @nocollapse
 */
XpoSelect.ctorParameters = function () { return [
    { type: ViewportRuler, },
    { type: ChangeDetectorRef, },
    { type: Renderer2, },
    { type: ElementRef, },
    { type: Directionality, decorators: [{ type: Optional },] },
    { type: NgForm, decorators: [{ type: Optional },] },
    { type: FormGroupDirective, decorators: [{ type: Optional },] },
    { type: NgControl, decorators: [{ type: Self }, { type: Optional },] },
    { type: undefined, decorators: [{ type: Attribute, args: ['tabindex',] },] },
]; };
XpoSelect.propDecorators = {
    'trigger': [{ type: ViewChild, args: ['trigger',] },],
    'overlayDir': [{ type: ViewChild, args: [ConnectedOverlayDirective,] },],
    'options': [{ type: ContentChildren, args: [XpoOption, { descendants: true },] },],
    'optionGroups': [{ type: ContentChildren, args: [XpoOptgroup,] },],
    '_errorChildren': [{ type: ContentChildren, args: [XpoSelectErrorDirective,] },],
    'id': [{ type: Input },],
    'panelClass': [{ type: Input },],
    'placeholder': [{ type: Input },],
    'required': [{ type: Input },],
    'multiple': [{ type: Input },],
    'tabIndex': [{ type: Input },],
    'ariaLabel': [{ type: Input, args: ['aria-label',] },],
    'ariaLabelledby': [{ type: Input, args: ['aria-labelledby',] },],
    'labelPosition': [{ type: Input },],
    'label': [{ type: Input },],
    'onOpen': [{ type: Output },],
    'onClose': [{ type: Output },],
    'change': [{ type: Output },],
};
/**
 * Clamps a value n between min and max values.
 * @param {?} min
 * @param {?} n
 * @param {?} max
 * @return {?}
 */
function clampValue(min, n, max) {
    return Math.min(Math.max(min, n), max);
}
var XpoSelectModule = (function () {
    function XpoSelectModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoSelectModule.forRoot = function () {
        return {
            ngModule: XpoSelectModule,
        };
    };
    return XpoSelectModule;
}());
XpoSelectModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, OverlayModule, XpoOptionModule, XpoCommonModule, XpoFormModule],
                exports: [XpoSelect, XpoSelectErrorDirective, XpoOptionModule, XpoCommonModule],
                declarations: [XpoSelect, XpoSelectErrorDirective],
            },] },
];
/**
 * @nocollapse
 */
XpoSelectModule.ctorParameters = function () { return []; };
/** XpoConfigService -
   *  This is the import for the service
   */
/**
 * Visually, a 30px separation between tick marks looks best. This is very subjective but it is
 * the default separation we chose.
 */
var MIN_AUTO_TICK_SEPARATION = 30;
/**
 * The thumb gap size for a disabled slider.
 */
var DISABLED_THUMB_GAP = 7;
/**
 * The thumb gap size for a non-active slider at its minimum value.
 */
var MIN_VALUE_NONACTIVE_THUMB_GAP = 7;
/**
 * The thumb gap size for an active slider at its minimum value.
 */
var MIN_VALUE_ACTIVE_THUMB_GAP = 10;
/**
 * Provider Expression that allows xpo-slider to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)] and [formControl].
 */
var XPO_SLIDER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return XpoSlider; }),
    multi: true,
};
/**
 * A simple change event emitted by the XpoSlider component.
 */
var XpoSliderChange = (function () {
    function XpoSliderChange() {
    }
    return XpoSliderChange;
}());
var XpoSliderBase = (function () {
    function XpoSliderBase() {
    }
    return XpoSliderBase;
}());
var _XpoSliderMixinBase = mixinDisabled(XpoSliderBase);
/**
 * <xpo-slider> allows users to select from a range of values by moving the slider thumb. It is similar in
 * behavior to the native `<input type="range">` element.
 */
var XpoSlider = (function (_super) {
    __extends(XpoSlider, _super);
    /**
     * @param {?} renderer
     * @param {?} _elementRef
     * @param {?} _focusOriginMonitor
     * @param {?} _dir
     */
    function XpoSlider(renderer, _elementRef, _focusOriginMonitor, _dir) {
        var _this = _super.call(this) || this;
        _this._elementRef = _elementRef;
        _this._focusOriginMonitor = _focusOriginMonitor;
        _this._dir = _dir;
        _this._invert = false;
        _this._max = 100;
        _this._min = 0;
        _this._step = 1;
        _this._thumbLabel = false;
        _this._tickInterval = 0;
        _this._value = null;
        _this._vertical = false;
        _this.color = 'accent';
        /**
         * Event emitted when the slider value has changed.
         */
        _this.change = new EventEmitter();
        /**
         * Event emitted when the slider thumb moves.
         */
        _this.input = new EventEmitter();
        /**
         * onTouch function registered via registerOnTouch (ControlValueAccessor).
         */
        _this.onTouched = function () { };
        _this._percent = 0;
        /**
         * Whether or not the thumb is sliding.
         * Used to determine if there should be a transition for the thumb and fill track.
         */
        _this._isSliding = false;
        /**
         * Whether or not the slider is active (clicked or sliding).
         * Used to shrink and grow the thumb as according to the Material Design spec.
         */
        _this._isActive = false;
        /**
         * The size of a tick interval as a percentage of the size of the track.
         */
        _this._tickIntervalPercent = 0;
        /**
         * A renderer to handle updating the slider's thumb and fill track.
         */
        _this._renderer = null;
        /**
         * The dimensions of the slider.
         */
        _this._sliderDimensions = null;
        _this._controlValueAccessorChangeFn = function () { };
        /**
         * The last value for which a change event was emitted.
         */
        _this._lastChangeValue = null;
        /**
         * The last value for which an input event was emitted.
         */
        _this._lastInputValue = null;
        _this._focusOriginMonitor.monitor(_this._elementRef.nativeElement, renderer, true)
            .subscribe(function (origin) { return _this._isActive = !!origin && origin !== 'keyboard'; });
        _this._renderer = new SliderRenderer(_this._elementRef);
        return _this;
    }
    Object.defineProperty(XpoSlider.prototype, "invert", {
        /**
         * Whether the slider is inverted.
         * @return {?}
         */
        get: function () { return this._invert; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._invert = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "max", {
        /**
         * The maximum value that the slider can have.
         * @return {?}
         */
        get: function () {
            return this._max;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._max = coerceNumberProperty(v, this._max);
            this._percent = this._calculatePercentage(this._value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "min", {
        /**
         * The minimum value that the slider can have.
         * @return {?}
         */
        get: function () {
            return this._min;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._min = coerceNumberProperty(v, this._min);
            // If the value wasn't explicitly set by the user, set it to the min.
            if (this._value === null) {
                this.value = this._min;
            }
            this._percent = this._calculatePercentage(this._value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "step", {
        /**
         * The values at which the thumb will snap.
         * @return {?}
         */
        get: function () { return this._step; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._step = coerceNumberProperty(v, this._step);
            if (this._step % 1 !== 0) {
                this._roundLabelTo = this._step.toString().split('.').pop().length;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "thumbLabel", {
        /**
         * Whether or not to show the thumb label.
         * @return {?}
         */
        get: function () { return this._thumbLabel; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._thumbLabel = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_thumbLabelDeprecated", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this._thumbLabel; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._thumbLabel = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "tickInterval", {
        /**
         * How often to show ticks. Relative to the step so that a tick always appears on a step.
         * Ex: Tick interval of 4 with a step of 3 will draw a tick every 4 steps (every 12 values).
         * @return {?}
         */
        get: function () { return this._tickInterval; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === 'auto') {
                this._tickInterval = 'auto';
            }
            else if (typeof value === 'number' || typeof value === 'string') {
                this._tickInterval = coerceNumberProperty(value, /** @type {?} */ (this._tickInterval));
            }
            else {
                this._tickInterval = 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_tickIntervalDeprecated", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.tickInterval; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.tickInterval = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "value", {
        /**
         * Value of the slider.
         * @return {?}
         */
        get: function () {
            // If the value needs to be read and it is still uninitialized, initialize it to the min.
            if (this._value === null) {
                this.value = this._min;
            }
            return this._value;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._value = coerceNumberProperty(v, this._value);
            this._percent = this._calculatePercentage(this._value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "vertical", {
        /**
         * Whether the slider is vertical.
         * @return {?}
         */
        get: function () { return this._vertical; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._vertical = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "displayValue", {
        /**
         * The value to be used for display purposes.
         * @return {?}
         */
        get: function () {
            // Note that this could be improved further by rounding something like 0.999 to 1 or
            // 0.899 to 0.9, however it is very performance sensitive, because it gets called on
            // every change detection cycle.
            if (this._roundLabelTo && this.value % 1 !== 0) {
                return this.value.toFixed(this._roundLabelTo);
            }
            return this.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "percent", {
        /**
         * The percentage of the slider that coincides with the value.
         * @return {?}
         */
        get: function () { return this._clamp(this._percent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_invertAxis", {
        /**
         * Whether the axis of the slider is inverted.
         * (i.e. whether moving the thumb in the positive x or y direction decreases the slider's value).
         * @return {?}
         */
        get: function () {
            // Standard non-inverted mode for a vertical slider should be dragging the thumb from bottom to
            // top. However from a y-axis standpoint this is inverted.
            return this.vertical ? !this.invert : this.invert;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_isMinValue", {
        /**
         * Whether the slider is at its minimum value.
         * @return {?}
         */
        get: function () {
            return this.percent === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_thumbGap", {
        /**
         * The amount of space to leave between the slider thumb and the track fill & track background
         * elements.
         * @return {?}
         */
        get: function () {
            if (this.disabled) {
                return DISABLED_THUMB_GAP;
            }
            if (this._isMinValue && !this.thumbLabel) {
                return this._isActive ? MIN_VALUE_ACTIVE_THUMB_GAP : MIN_VALUE_NONACTIVE_THUMB_GAP;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_trackBackgroundStyles", {
        /**
         * CSS styles for the track background element.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            var /** @type {?} */ sign = this._invertMouseCoords ? '-' : '';
            return {
                transform: "translate" + axis + "(" + sign + this._thumbGap + "px) scale" + axis + "(" + (1 - this.percent) + ")",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_trackFillStyles", {
        /**
         * CSS styles for the track fill element.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            var /** @type {?} */ sign = this._invertMouseCoords ? '' : '-';
            return {
                transform: "translate" + axis + "(" + sign + this._thumbGap + "px) scale" + axis + "(" + this.percent + ")",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_ticksContainerStyles", {
        /**
         * CSS styles for the ticks container element.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            // For a horizontal slider in RTL languages we push the ticks container off the left edge
            // instead of the right edge to avoid causing a horizontal scrollbar to appear.
            var /** @type {?} */ sign = !this.vertical && this._direction == 'rtl' ? '' : '-';
            var /** @type {?} */ offset = this._tickIntervalPercent / 2 * 100;
            return {
                transform: "translate" + axis + "(" + sign + offset + "%)",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_ticksStyles", {
        /**
         * CSS styles for the ticks element.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ tickSize = this._tickIntervalPercent * 100;
            var /** @type {?} */ backgroundSize = this.vertical ? "2px " + tickSize + "%" : tickSize + "% 2px";
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            // Depending on the direction we pushed the ticks container, push the ticks the opposite
            // direction to re-center them but clip off the end edge. In RTL languages we need to flip the
            // ticks 180 degrees so we're really cutting off the end edge abd not the start.
            var /** @type {?} */ sign = !this.vertical && this._direction == 'rtl' ? '-' : '';
            var /** @type {?} */ rotate = !this.vertical && this._direction == 'rtl' ? ' rotate(180deg)' : '';
            var /** @type {?} */ styles = {
                backgroundSize: backgroundSize,
                // Without translateZ ticks sometimes jitter as the slider moves on Chrome & Firefox.
                transform: "translateZ(0) translate" + axis + "(" + sign + tickSize / 2 + "%)" + rotate,
            };
            if (this._isMinValue && this._thumbGap) {
                var /** @type {?} */ side = this.vertical ?
                    (this._invertAxis ? 'Bottom' : 'Top') :
                    (this._invertAxis ? 'Right' : 'Left');
                styles["padding" + side] = this._thumbGap + "px";
            }
            return styles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_thumbContainerStyles", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            // For a horizontal slider in RTL languages we push the thumb container off the left edge
            // instead of the right edge to avoid causing a horizontal scrollbar to appear.
            var /** @type {?} */ invertOffset = (this._direction == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
            var /** @type {?} */ offset = (invertOffset ? this.percent : 1 - this.percent) * 100;
            return {
                transform: "translate" + axis + "(-" + offset + "%)",
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_invertMouseCoords", {
        /**
         * Whether mouse events should be converted to a slider position by calculating their distance
         * from the right or bottom edge of the slider as opposed to the top or left.
         * @return {?}
         */
        get: function () {
            return (this._direction == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlider.prototype, "_direction", {
        /**
         * The language direction for this slider element.
         * @return {?}
         */
        get: function () {
            return (this._dir && this._dir.value == 'rtl') ? 'rtl' : 'ltr';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoSlider.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._elementRef.nativeElement);
    };
    /**
     * @return {?}
     */
    XpoSlider.prototype._onMouseenter = function () {
        if (this.disabled) {
            return;
        }
        // We save the dimensions of the slider here so we can use them to update the spacing of the
        // ticks and determine where on the slider click and slide events happen.
        this._sliderDimensions = this._renderer.getSliderDimensions();
        this._updateTickIntervalPercent();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoSlider.prototype._onClick = function (event) {
        if (this.disabled) {
            return;
        }
        this._isSliding = false;
        this._renderer.addFocus();
        this._updateValueFromPosition({ x: event.clientX, y: event.clientY });
        /* Emits a change and input event if the value changed. */
        this._emitInputEvent();
        this._emitValueIfChanged();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoSlider.prototype._onSlide = function (event) {
        if (this.disabled) {
            return;
        }
        // Prevent the slide from selecting anything else.
        event.preventDefault();
        this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
        // Native range elements always emit `input` events when the value changed while sliding.
        this._emitInputEvent();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoSlider.prototype._onSlideStart = function (event) {
        if (this.disabled) {
            return;
        }
        // Simulate mouseenter in case this is a mobile device.
        this._onMouseenter();
        event.preventDefault();
        this._isSliding = true;
        this._renderer.addFocus();
        this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
    };
    /**
     * @return {?}
     */
    XpoSlider.prototype._onSlideEnd = function () {
        this._isSliding = false;
        this._emitValueIfChanged();
    };
    /**
     * @return {?}
     */
    XpoSlider.prototype._onFocus = function () {
        // We save the dimensions of the slider here so we can use them to update the spacing of the
        // ticks and determine where on the slider click and slide events happen.
        this._sliderDimensions = this._renderer.getSliderDimensions();
        this._updateTickIntervalPercent();
    };
    /**
     * @return {?}
     */
    XpoSlider.prototype._onBlur = function () {
        this.onTouched();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoSlider.prototype._onKeydown = function (event) {
        if (this.disabled) {
            return;
        }
        switch (event.keyCode) {
            case PAGE_UP:
                this._increment(10);
                break;
            case PAGE_DOWN:
                this._increment(-10);
                break;
            case END:
                this.value = this.max;
                break;
            case HOME:
                this.value = this.min;
                break;
            case LEFT_ARROW:
                // NOTE: For a sighted user it would make more sense that when they press an arrow key on an
                // inverted slider the thumb moves in that direction. However for a blind user, nothing
                // about the slider indicates that it is inverted. They will expect left to be decrement,
                // regardless of how it appears on the screen. For speakers ofRTL languages, they probably
                // expect left to mean increment. Therefore we flip the meaning of the side arrow keys for
                // RTL. For inverted sliders we prefer a good a11y experience to having it "look right" for
                // sighted users, therefore we do not swap the meaning.
                this._increment(this._direction == 'rtl' ? 1 : -1);
                break;
            case UP_ARROW:
                this._increment(1);
                break;
            case RIGHT_ARROW:
                // See comment on LEFT_ARROW about the conditions under which we flip the meaning.
                this._increment(this._direction == 'rtl' ? -1 : 1);
                break;
            case DOWN_ARROW:
                this._increment(-1);
                break;
            default:
                // Return if the key is not one that we explicitly handle to avoid calling preventDefault on
                // it.
                return;
        }
        this._isSliding = true;
        event.preventDefault();
    };
    /**
     * @return {?}
     */
    XpoSlider.prototype._onKeyup = function () {
        this._isSliding = false;
    };
    /**
     * Increments the slider by the given number of steps (negative number decrements).
     * @param {?} numSteps
     * @return {?}
     */
    XpoSlider.prototype._increment = function (numSteps) {
        this.value = this._clamp(this.value + this.step * numSteps, this.min, this.max);
        this._emitInputEvent();
        this._emitValueIfChanged();
    };
    /**
     * Calculate the new value from the new physical location. The value will always be snapped.
     * @param {?} pos
     * @return {?}
     */
    XpoSlider.prototype._updateValueFromPosition = function (pos) {
        if (!this._sliderDimensions) {
            return;
        }
        var /** @type {?} */ offset = this.vertical ? this._sliderDimensions.top : this._sliderDimensions.left;
        var /** @type {?} */ size = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
        var /** @type {?} */ posComponent = this.vertical ? pos.y : pos.x;
        // The exact value is calculated from the event and used to find the closest snap value.
        var /** @type {?} */ percent = this._clamp((posComponent - offset) / size);
        if (this._invertMouseCoords) {
            percent = 1 - percent;
        }
        var /** @type {?} */ exactValue = this._calculateValue(percent);
        // This calculation finds the closest step by finding the closest whole number divisible by the
        // step relative to the min.
        var /** @type {?} */ closestValue = Math.round((exactValue - this.min) / this.step) * this.step + this.min;
        // The value needs to snap to the min and max.
        this.value = this._clamp(closestValue, this.min, this.max);
    };
    /**
     * Emits a change event if the current value is different from the last emitted value.
     * @return {?}
     */
    XpoSlider.prototype._emitValueIfChanged = function () {
        if (this.value != this._lastChangeValue) {
            var /** @type {?} */ event = this._createChangeEvent();
            this._lastChangeValue = this.value;
            this._controlValueAccessorChangeFn(this.value);
            this.change.emit(event);
        }
    };
    /**
     * Emits an input event when the current value is different from the last emitted value.
     * @return {?}
     */
    XpoSlider.prototype._emitInputEvent = function () {
        if (this.value != this._lastInputValue) {
            var /** @type {?} */ event = this._createChangeEvent();
            this._lastInputValue = this.value;
            this.input.emit(event);
        }
    };
    /**
     * Updates the amount of space between ticks as a percentage of the width of the slider.
     * @return {?}
     */
    XpoSlider.prototype._updateTickIntervalPercent = function () {
        if (!this.tickInterval) {
            return;
        }
        if (this.tickInterval == 'auto') {
            var /** @type {?} */ trackSize = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
            var /** @type {?} */ pixelsPerStep = trackSize * this.step / (this.max - this.min);
            var /** @type {?} */ stepsPerTick = Math.ceil(MIN_AUTO_TICK_SEPARATION / pixelsPerStep);
            var /** @type {?} */ pixelsPerTick = stepsPerTick * this.step;
            this._tickIntervalPercent = pixelsPerTick / trackSize;
        }
        else {
            this._tickIntervalPercent = this.tickInterval * this.step / (this.max - this.min);
        }
    };
    /**
     * Creates a slider change object from the specified value.
     * @param {?=} value
     * @return {?}
     */
    XpoSlider.prototype._createChangeEvent = function (value) {
        if (value === void 0) { value = this.value; }
        var /** @type {?} */ event = new XpoSliderChange();
        event.source = this;
        event.value = value;
        return event;
    };
    /**
     * Calculates the percentage of the slider that a value is.
     * @param {?} value
     * @return {?}
     */
    XpoSlider.prototype._calculatePercentage = function (value) {
        return (value - this.min) / (this.max - this.min);
    };
    /**
     * Calculates the value a percentage of the slider corresponds to.
     * @param {?} percentage
     * @return {?}
     */
    XpoSlider.prototype._calculateValue = function (percentage) {
        return this.min + percentage * (this.max - this.min);
    };
    /**
     * Return a number between two numbers.
     * @param {?} value
     * @param {?=} min
     * @param {?=} max
     * @return {?}
     */
    XpoSlider.prototype._clamp = function (value, min, max) {
        if (min === void 0) { min = 0; }
        if (max === void 0) { max = 1; }
        return Math.max(min, Math.min(value, max));
    };
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param {?} value
     * @return {?}
     */
    XpoSlider.prototype.writeValue = function (value) {
        this.value = value;
    };
    /**
     * Registers a callback to eb triggered when the value has changed.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be registered.
     * @return {?}
     */
    XpoSlider.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * Registers a callback to be triggered when the component is touched.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be registered.
     * @return {?}
     */
    XpoSlider.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Sets whether the component should be disabled.
     * Implemented as part of ControlValueAccessor.
     * @param {?} isDisabled
     * @return {?}
     */
    XpoSlider.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return XpoSlider;
}(_XpoSliderMixinBase));
XpoSlider.decorators = [
    { type: Component, args: [{ selector: 'xpo-slider',
                providers: [XPO_SLIDER_VALUE_ACCESSOR],
                host: {
                    '(focus)': '_onFocus()',
                    '(blur)': '_onBlur()',
                    '(click)': '_onClick($event)',
                    '(keydown)': '_onKeydown($event)',
                    '(keyup)': '_onKeyup()',
                    '(mouseenter)': '_onMouseenter()',
                    '(slide)': '_onSlide($event)',
                    '(slideend)': '_onSlideEnd()',
                    '(slidestart)': '_onSlideStart($event)',
                    'class': 'xpo-slider',
                    'role': 'slider',
                    'tabindex': '0',
                    '[attr.aria-disabled]': 'disabled',
                    '[attr.aria-valuemax]': 'max',
                    '[attr.aria-valuemin]': 'min',
                    '[attr.aria-valuenow]': 'value',
                    '[class.xpo-primary]': 'color == "primary"',
                    '[class.xpo-accent]': 'color != "primary" && color != "warn"',
                    '[class.xpo-warn]': 'color == "warn"',
                    '[class.xpo-slider-disabled]': 'disabled',
                    '[class.xpo-slider-has-ticks]': 'tickInterval',
                    '[class.xpo-slider-horizontal]': '!vertical',
                    '[class.xpo-slider-axis-inverted]': '_invertAxis',
                    '[class.xpo-slider-sliding]': '_isSliding',
                    '[class.xpo-slider-thumb-label-showing]': 'thumbLabel',
                    '[class.xpo-slider-vertical]': 'vertical',
                    '[class.xpo-slider-min-value]': '_isMinValue',
                    '[class.xpo-slider-hide-last-tick]': 'disabled || _isMinValue && _thumbGap && _invertAxis',
                },
                template: "<div class=\"xpo-slider-wrapper\"> <div class=\"xpo-slider-track-wrapper\"> <div class=\"xpo-slider-track-background\" [ngStyle]=\"_trackBackgroundStyles\"></div> <div class=\"xpo-slider-track-fill\" [ngStyle]=\"_trackFillStyles\"></div> </div> <div class=\"xpo-slider-ticks-container\" [ngStyle]=\"_ticksContainerStyles\"> <div class=\"xpo-slider-ticks\" [ngStyle]=\"_ticksStyles\"></div> </div> <div class=\"xpo-slider-thumb-container\" [ngStyle]=\"_thumbContainerStyles\"> <div class=\"xpo-slider-focus-ring\"></div> <div class=\"xpo-slider-thumb\"></div> <div class=\"xpo-slider-thumb-label\"> <span class=\"xpo-slider-thumb-label-text\">{{displayValue}}</span> </div> </div> </div>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}.xpo-accent .xpo-slider-thumb,.xpo-accent .xpo-slider-thumb-label,.xpo-accent .xpo-slider-track-fill{background-color:#ffd740}.xpo-slider-track-background{background-color:rgba(0,0,0,.26)}.xpo-slider{display:inline-block;vertical-align:middle;box-sizing:border-box;padding:8px;position:relative;outline:0}.xpo-slider-wrapper{position:absolute}.xpo-slider-track-wrapper{overflow:hidden;position:absolute;top:0;left:0}.xpo-slider-track-fill{position:absolute;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.xpo-slider-track-background{position:absolute;transform-origin:100% 100%;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.xpo-slider-ticks-container{overflow:hidden;position:absolute;top:0;left:0}.xpo-slider-ticks{box-sizing:border-box;opacity:0;background-clip:content-box;background-repeat:repeat;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.xpo-slider-thumb-container{position:absolute;z-index:1;transition:transform .4s cubic-bezier(.25,.8,.25,1)}.xpo-slider-focus-ring{width:30px;height:30px;position:absolute;transform:scale(0);opacity:0;border-radius:50%;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),opacity .4s cubic-bezier(.25,.8,.25,1)}.cdk-keyboard-focused .xpo-slider-focus-ring{transform:scale(1);opacity:1}.xpo-slider:not(.xpo-slider-disabled) .xpo-slider-thumb,.xpo-slider:not(.xpo-slider-disabled) .xpo-slider-thumb-label{cursor:-webkit-grab;cursor:grab}.xpo-slider-sliding:not(.xpo-slider-disabled) .xpo-slider-thumb,.xpo-slider-sliding:not(.xpo-slider-disabled) .xpo-slider-thumb-label,.xpo-slider:not(.xpo-slider-disabled) .xpo-slider-thumb-label:active,.xpo-slider:not(.xpo-slider-disabled) .xpo-slider-thumb:active{cursor:-webkit-grabbing;cursor:grabbing}.xpo-slider-thumb{box-sizing:border-box;width:20px;height:20px;position:absolute;right:-10px;bottom:-10px;transform:scale(.7);border:3px solid transparent;border-radius:50%;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),border-color .4s cubic-bezier(.25,.8,.25,1)}.xpo-slider-thumb-label{display:none;align-items:center;justify-content:center;width:28px;height:28px;position:absolute;border-radius:50%;transition:transform .4s cubic-bezier(.25,.8,.25,1),border-radius .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.xpo-slider-thumb-label-text{font-size:12px;font-weight:700;opacity:0;z-index:1;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.xpo-slider-sliding .xpo-slider-thumb-container,.xpo-slider-sliding .xpo-slider-track-background,.xpo-slider-sliding .xpo-slider-track-fill{transition-duration:0s}.xpo-slider-has-ticks .xpo-slider-wrapper::after{position:absolute;content:\"\";opacity:0;border-style:solid;border-width:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.xpo-slider-has-ticks.cdk-focused:not(.xpo-slider-hide-last-tick) .xpo-slider-wrapper::after,.xpo-slider-has-ticks:hover:not(.xpo-slider-hide-last-tick) .xpo-slider-wrapper::after{opacity:1}.xpo-slider-has-ticks.cdk-focused:not(.xpo-slider-disabled) .xpo-slider-ticks,.xpo-slider-has-ticks:hover:not(.xpo-slider-disabled) .xpo-slider-ticks{opacity:1}.xpo-slider-thumb-label-showing .xpo-slider-focus-ring{transform:scale(0);opacity:0}.xpo-slider-thumb-label-showing .xpo-slider-thumb-label{display:flex}.xpo-slider-axis-inverted .xpo-slider-track-fill{transform-origin:100% 100%}.xpo-slider-axis-inverted .xpo-slider-track-background{transform-origin:0 0}.cdk-focused.xpo-slider-thumb-label-showing .xpo-slider-thumb{transform:scale(0)}.cdk-focused .xpo-slider-thumb-label{border-radius:50% 50% 0}.cdk-focused .xpo-slider-thumb-label-text{opacity:1}.cdk-mouse-focused .xpo-slider-thumb,.cdk-program-focused .xpo-slider-thumb,.cdk-touch-focused .xpo-slider-thumb{transform:scale(1);border-width:2px}.xpo-slider-disabled .xpo-slider-focus-ring{transform:scale(0);opacity:0}.xpo-slider-disabled .xpo-slider-thumb{transform:scale(.5);border-width:4px}.xpo-slider-disabled .xpo-slider-thumb-label{display:none}.xpo-slider-horizontal{min-width:128px;height:48px}.xpo-slider-horizontal .xpo-slider-wrapper{height:2px;top:23px;right:8px;left:8px}.xpo-slider-horizontal .xpo-slider-wrapper::after{height:2px;top:0;right:0;border-left-width:2px}.xpo-slider-horizontal .xpo-slider-track-wrapper{width:100%;height:2px}.xpo-slider-horizontal .xpo-slider-track-fill{width:100%;height:2px;transform:scaleX(0)}.xpo-slider-horizontal .xpo-slider-track-background{width:100%;height:2px;transform:scaleX(1)}.xpo-slider-horizontal .xpo-slider-ticks-container{width:100%;height:2px}.xpo-slider-horizontal .xpo-slider-ticks{width:100%;height:2px}.xpo-slider-horizontal .xpo-slider-thumb-container{width:100%;height:0;top:50%}.xpo-slider-horizontal .xpo-slider-focus-ring{top:-15px;right:-15px}.xpo-slider-horizontal .xpo-slider-thumb-label{top:-40px;right:-14px;transform:translateY(26px) scale(.01) rotate(45deg)}.xpo-slider-horizontal .xpo-slider-thumb-label-text{transform:rotate(-45deg)}.xpo-slider-horizontal.cdk-focused .xpo-slider-thumb-label{transform:rotate(45deg)}.xpo-slider-vertical{width:48px;min-height:128px}.xpo-slider-vertical .xpo-slider-wrapper{width:2px;top:8px;bottom:8px;left:23px}.xpo-slider-vertical .xpo-slider-wrapper::after{width:2px;bottom:0;left:0;border-top-width:2px}.xpo-slider-vertical .xpo-slider-track-wrapper{width:2px;height:100%}.xpo-slider-vertical .xpo-slider-track-fill{width:2px;height:100%;transform:scaleY(0)}.xpo-slider-vertical .xpo-slider-track-background{width:2px;height:100%;transform:scaleY(1)}.xpo-slider-vertical .xpo-slider-ticks-container{width:2px;height:100%}.xpo-slider-vertical .xpo-slider-focus-ring{bottom:-15px;left:-15px}.xpo-slider-vertical .xpo-slider-ticks{width:2px;height:100%}.xpo-slider-vertical .xpo-slider-thumb-container{width:0;height:100%;left:50%}.xpo-slider-vertical .xpo-slider-thumb-label{bottom:-14px;left:-40px;transform:translateX(26px) scale(.01) rotate(-45deg)}.xpo-slider-vertical .xpo-slider-thumb-label-text{transform:rotate(45deg)}.xpo-slider-vertical.cdk-focused .xpo-slider-thumb-label{transform:rotate(-45deg)}[dir=rtl] .xpo-slider-wrapper::after{right:auto;left:0}[dir=rtl] .xpo-slider-horizontal .xpo-slider-track-fill{transform-origin:100% 100%}[dir=rtl] .xpo-slider-horizontal .xpo-slider-track-background{transform-origin:0 0}[dir=rtl] .xpo-slider-horizontal.xpo-slider-axis-inverted .xpo-slider-track-fill{transform-origin:0 0}[dir=rtl] .xpo-slider-horizontal.xpo-slider-axis-inverted .xpo-slider-track-background{transform-origin:100% 100%} /*# sourceMappingURL=slider.css.map */ "],
                inputs: ['disabled'],
                encapsulation: ViewEncapsulation.None,
            },] },
];
/**
 * @nocollapse
 */
XpoSlider.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: ElementRef, },
    { type: FocusOriginMonitor, },
    { type: Dir, decorators: [{ type: Optional },] },
]; };
XpoSlider.propDecorators = {
    'invert': [{ type: Input },],
    'max': [{ type: Input },],
    'min': [{ type: Input },],
    'step': [{ type: Input },],
    'thumbLabel': [{ type: Input },],
    '_thumbLabelDeprecated': [{ type: Input, args: ['thumb-label',] },],
    'tickInterval': [{ type: Input },],
    '_tickIntervalDeprecated': [{ type: Input, args: ['tick-interval',] },],
    'value': [{ type: Input },],
    'vertical': [{ type: Input },],
    'color': [{ type: Input },],
    'change': [{ type: Output },],
    'input': [{ type: Output },],
};
/**
 * Renderer class in order to keep all dom manipulation in one place and outside of the main class.
 * \@docs-private
 */
var SliderRenderer = (function () {
    /**
     * @param {?} elementRef
     */
    function SliderRenderer(elementRef) {
        this._sliderElement = elementRef.nativeElement;
    }
    /**
     * Get the bounding client rect of the slider track element.
     * The track is used rather than the native element to ignore the extra space that the thumb can
     * take up.
     * @return {?}
     */
    SliderRenderer.prototype.getSliderDimensions = function () {
        var /** @type {?} */ wrapperElement = this._sliderElement.querySelector('.xpo-slider-wrapper');
        return wrapperElement.getBoundingClientRect();
    };
    /**
     * Focuses the native element.
     * Currently only used to allow a blur event to fire but will be used with keyboard input later.
     * @return {?}
     */
    SliderRenderer.prototype.addFocus = function () {
        this._sliderElement.focus();
    };
    return SliderRenderer;
}());
var XpoSliderModule = (function () {
    function XpoSliderModule() {
    }
    return XpoSliderModule;
}());
XpoSliderModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule, XpoCommonModule, StyleModule, RtlModule],
                exports: [XpoSlider, XpoCommonModule],
                declarations: [XpoSlider],
                providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig }],
            },] },
];
/**
 * @nocollapse
 */
XpoSliderModule.ctorParameters = function () { return []; };
var XPO_SLIDE_TOGGLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return XpoSlideToggle; }),
    multi: true,
};
var XpoSlideToggleChange = (function () {
    function XpoSlideToggleChange() {
    }
    return XpoSlideToggleChange;
}());
// Increasing integer for generating unique ids for slide-toggle components.
var nextId$2 = 0;
/**
 * <xpo-slidetoggle> is an on/off form control that can be toggled via clicking or dragging.
 */
var XpoSlideToggle = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _focusOriginMonitor
     */
    function XpoSlideToggle(_elementRef, _renderer, _focusOriginMonitor) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._focusOriginMonitor = _focusOriginMonitor;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._uniqueId = "xpo-slide-toggle-" + ++nextId$2;
        this._checked = false;
        this._isMousedown = false;
        this._slideRenderer = null;
        this._disabled = false;
        this._required = false;
        this._disableRipple = false;
        /**
         * Name value will be applied to the input element if present
         */
        this.name = null;
        /**
         * A unique id for the slide-toggle input. If none is supplied, it will be auto-generated.
         */
        this.id = this._uniqueId;
        /**
         * Used to specify the tabIndex value for the underlying input element.
         */
        this.tabIndex = 0;
        /**
         * Whether the label should appear after or before the slide-toggle. Defaults to 'after'
         */
        this.labelPosition = 'right';
        /**
         * Used to set the aria-label attribute on the underlying input element.
         */
        this.ariaLabel = null;
        /**
         * Used to set the aria-labelledby attribute on the underlying input element.
         */
        this.ariaLabelledby = null;
        this._change = new EventEmitter();
        /**
         * An event will be dispatched each time the slide-toggle changes its value.
         */
        this.change = this._change.asObservable();
    }
    Object.defineProperty(XpoSlideToggle.prototype, "disabled", {
        /**
         * Whether the slide-toggle is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlideToggle.prototype, "required", {
        /**
         * Whether the slide-toggle is required.
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._required = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlideToggle.prototype, "checked", {
        /**
         * Whether the slide-toggle is checked.
         * @return {?}
         */
        get: function () { return !!this._checked; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this.checked !== !!value) {
                this._checked = value;
                this.onChange(this._checked);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoSlideToggle.prototype, "inputId", {
        /**
         * Returns the unique id for the visual hidden input.
         * @return {?}
         */
        get: function () { return (this.id || this._uniqueId) + "-input"; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoSlideToggle.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._slideRenderer = new SlideToggleRenderer(this._elementRef);
        this._focusOriginMonitor
            .monitor(this._inputElement.nativeElement, this._renderer, false)
            .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
    };
    /**
     * @return {?}
     */
    XpoSlideToggle.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._inputElement.nativeElement);
    };
    /**
     * The onChangeEvent method will be also called on click.
     * This is because everything for the slide-toggle is wrapped inside of a label,
     * which triggers a onChange event on click.
     * @param {?} event
     * @return {?}
     */
    XpoSlideToggle.prototype._onChangeEvent = function (event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the component's `change` output.
        event.stopPropagation();
        // Once a drag is currently in progress, we do not want to toggle the slide-toggle on a click.
        if (!this.disabled && !this._slideRenderer.dragging) {
            this.toggle();
            // Emit our custom change event if the native input emitted one.
            // It is important to only emit it, if the native input triggered one, because
            // we don't want to trigger a change event, when the `checked` variable changes for example.
            this._emitChangeEvent();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoSlideToggle.prototype._onInputClick = function (event) {
        this.onTouched();
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `slide-toggle` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
    };
    /**
     * @return {?}
     */
    XpoSlideToggle.prototype._setMousedown = function () {
        var _this = this;
        // We only *show* the focus style when focus has come to the button via the keyboard.
        // The Material Design spec is silent on this topic, and without doing this, the
        // button continues to look :active after clicking.
        // @see http://marcysutton.com/button-focus-hell/
        this._isMousedown = true;
        setTimeout(function () { return _this._isMousedown = false; }, 100);
    };
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} value
     * @return {?}
     */
    XpoSlideToggle.prototype.writeValue = function (value) {
        this.checked = value;
    };
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn
     * @return {?}
     */
    XpoSlideToggle.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn
     * @return {?}
     */
    XpoSlideToggle.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Implemented as a part of ControlValueAccessor.
     * @param {?} isDisabled
     * @return {?}
     */
    XpoSlideToggle.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * Focuses the slide-toggle.
     * @return {?}
     */
    XpoSlideToggle.prototype.focus = function () {
        this._focusOriginMonitor.focusVia(this._inputElement.nativeElement, this._renderer, 'keyboard');
    };
    /**
     * Toggles the checked state of the slide-toggle.
     * @return {?}
     */
    XpoSlideToggle.prototype.toggle = function () {
        this.checked = !this.checked;
    };
    /**
     * Function is called whenever the focus changes for the input element.
     * @param {?} focusOrigin
     * @return {?}
     */
    XpoSlideToggle.prototype._onInputFocusChange = function (focusOrigin) {
        if (!focusOrigin) {
            this.onTouched();
        }
    };
    /**
     * Emits the change event to the `change` output EventEmitter
     * @return {?}
     */
    XpoSlideToggle.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new XpoSlideToggleChange();
        event.source = this;
        event.checked = this.checked;
        this._change.emit(event);
    };
    /**
     * @return {?}
     */
    XpoSlideToggle.prototype._onDragStart = function () {
        if (!this.disabled) {
            this._slideRenderer.startThumbDrag(this.checked);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoSlideToggle.prototype._onDrag = function (event) {
        if (this._slideRenderer.dragging) {
            this._slideRenderer.updateThumbPosition(event.deltaX);
        }
    };
    /**
     * @return {?}
     */
    XpoSlideToggle.prototype._onDragEnd = function () {
        var _this = this;
        if (this._slideRenderer.dragging) {
            var /** @type {?} */ _previousChecked = this.checked;
            this.checked = this._slideRenderer.dragPercentage > 50;
            if (_previousChecked !== this.checked) {
                this._emitChangeEvent();
            }
            // The drag should be stopped outside of the current event handler, because otherwise the
            // click event will be fired before and will revert the drag change.
            setTimeout(function () { return _this._slideRenderer.stopThumbDrag(); });
        }
    };
    return XpoSlideToggle;
}());
XpoSlideToggle.decorators = [
    { type: Component, args: [{ selector: 'xpo-slidetoggle',
                host: {
                    '[class.xpo-slide-toggle]': 'true',
                    '[class.xpo-slide-toggle--checked]': 'checked',
                    '[class.xpo-slide-toggle--disabled]': 'disabled',
                    '[class.xpo-slide-toggle__label--left]': 'labelPosition == "left"',
                    '(mousedown)': '_setMousedown()',
                },
                template: "<label class=\"xpo-slide-toggle__label\" #label> <div class=\"xpo-slide-toggle__bar\"> <input #input class=\"xpo-slide-toggle__input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [tabIndex]=\"tabIndex\" [checked]=\"checked\" [disabled]=\"disabled\" [attr.name]=\"name\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onChangeEvent($event)\" (click)=\"_onInputClick($event)\"> <div class=\"xpo-slide-toggle__thumb-wrapper\" (slidestart)=\"_onDragStart()\" (slide)=\"_onDrag($event)\" (slideend)=\"_onDragEnd()\"> <div class=\"xpo-slide-toggle__thumb\"></div> </div> </div> <span class=\"xpo-slide-toggle__content\"> <ng-content></ng-content> </span> </label>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host .cdk-visually-hidden{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);text-transform:none;border:0}:host.xpo-slide-toggle{display:inline-block;height:24px;margin-top:15px;outline:0;line-height:24px;white-space:nowrap}:host.xpo-slide-toggle:first-child{margin-top:0}:host.xpo-slide-toggle.xpo-slide-toggle--checked .xpo-slide-toggle__thumb-wrapper{transform:translate3d(18px,0,0)}:host.xpo-slide-toggle.xpo-slide-toggle--disabled .xpo-slide-toggle-label,:host.xpo-slide-toggle.xpo-slide-toggle--disabled .xpo-slide-toggle__thumb-wrapper{cursor:default}:host.xpo-slide-toggle.xpo-slide-toggle--checked:not(.xpo-slide-toggle--disabled) .xpo-slide-toggle__bar{background-color:#00c853}:host .xpo-slide-toggle__label{display:flex;flex-direction:row;align-items:center;flex:1;cursor:pointer}:host .xpo-slide-toggle__label--left .xpo-slide-toggle__label{order:1}:host .xpo-slide-toggle__label--left .xpo-slide-toggle__bar{order:2}:host .xpo-slide-toggle__bar,:host [dir=rtl] .xpo-slide-toggle__label--left .xpo-slide-toggle__bar{margin-right:8px;margin-left:0}:host .xpo-slide-toggle__label--left .xpo-slide-toggle__bar,:host [dir=rtl] .xpo-slide-toggle__bar{margin-right:0;margin-left:8px}:host .xpo-slide-toggle__thumb-wrapper{width:24px;height:24px;position:absolute;top:-4px;left:-1px;transform:translate3d(0,0,0);z-index:1;transition:all 80ms linear;transition-property:transform}:host .xpo-slide-toggle__thumb-wrapper.xpo-slide-toggle--dragging{transition-duration:0s}:host .xpo-slide-toggle__thumb{width:24px;height:24px;border:1px solid #bdbdbd;border-radius:50%;background-color:#fff}@media screen and (-ms-high-contrast:active){:host .xpo-slide-toggle__thumb{border:solid 1px #000;background:#fff}}:host .xpo-slide-toggle__bar{width:40px;height:16px;position:relative;border-radius:12px;background-color:#9e9e9e}@media screen and (-ms-high-contrast:active){:host .xpo-slide-toggle__bar{background:#fff}}:host .xpo-slide-toggle__input{bottom:0;left:12px}:host .xpo-slide-toggle__input:focus+.xpo-slide-toggle__thumb-wrapper .xpo-slide-toggle__thumb{box-shadow:0 0 2px 2px rgba(128,216,255,.7)}:host .xpo-slide-toggle__bar,:host .xpo-slide-toggle__thumb{transition:all 80ms linear;transition-delay:50ms;transition-property:background-color} /*# sourceMappingURL=slidetoggle.css.map */ "],
                providers: [XPO_SLIDE_TOGGLE_VALUE_ACCESSOR],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoSlideToggle.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
    { type: FocusOriginMonitor, },
]; };
XpoSlideToggle.propDecorators = {
    'name': [{ type: Input },],
    'id': [{ type: Input },],
    'tabIndex': [{ type: Input },],
    'labelPosition': [{ type: Input },],
    'ariaLabel': [{ type: Input, args: ['aria-label',] },],
    'ariaLabelledby': [{ type: Input, args: ['aria-labelledby',] },],
    'disabled': [{ type: Input },],
    'required': [{ type: Input },],
    'checked': [{ type: Input },],
    'change': [{ type: Output },],
    '_inputElement': [{ type: ViewChild, args: ['input',] },],
};
/**
 * Renderer for the Slide Toggle component, which separates DOM modification in its own class
 */
var SlideToggleRenderer = (function () {
    /**
     * @param {?} _elementRef
     */
    function SlideToggleRenderer(_elementRef) {
        this._elementRef = _elementRef;
        /**
         * Whether the thumb is currently being dragged.
         */
        this.dragging = false;
        this._thumbEl = _elementRef.nativeElement.querySelector('.xpo-slide-toggle__thumb-wrapper');
        this._thumbBarEl = _elementRef.nativeElement.querySelector('.xpo-slide-toggle__bar');
    }
    /**
     * Initializes the drag of the slide-toggle.
     * @param {?} checked
     * @return {?}
     */
    SlideToggleRenderer.prototype.startThumbDrag = function (checked) {
        if (this.dragging) {
            return;
        }
        this._thumbBarWidth = (this._thumbBarEl.clientWidth - this._thumbEl.clientWidth) - 2;
        this._thumbEl.classList.add('xpo-slide-toggle--dragging');
        this._previousChecked = checked;
        this.dragging = true;
    };
    /**
     * Resets the current drag and returns the new checked value.
     * @return {?}
     */
    SlideToggleRenderer.prototype.stopThumbDrag = function () {
        if (!this.dragging) {
            return;
        }
        this.dragging = false;
        this._thumbEl.classList.remove('xpo-slide-toggle--dragging');
        // Reset the transform because the component will take care of the thumb position after drag.
        applyCssTransform(this._thumbEl, '');
        return this.dragPercentage > 50;
    };
    /**
     * Updates the thumb containers position from the specified distance.
     * @param {?} distance
     * @return {?}
     */
    SlideToggleRenderer.prototype.updateThumbPosition = function (distance) {
        this.dragPercentage = this._getDragPercentage(distance);
        // Calculate the moved distance based on the thumb bar width.
        var /** @type {?} */ dragX = (this.dragPercentage / 100) * this._thumbBarWidth;
        applyCssTransform(this._thumbEl, "translate3d(" + dragX + "px, 0, 0)");
    };
    /**
     * Retrieves the percentage of thumb from the moved distance. Percentage as fraction of 100.
     * @param {?} distance
     * @return {?}
     */
    SlideToggleRenderer.prototype._getDragPercentage = function (distance) {
        var /** @type {?} */ percentage = (distance / this._thumbBarWidth) * 100;
        // When the toggle was initially checked, then we have to start the drag at the end.
        if (this._previousChecked) {
            percentage += 100;
        }
        return Math.max(0, Math.min(percentage, 100));
    };
    return SlideToggleRenderer;
}());
var XpoSlideToggleGroup = (function () {
    function XpoSlideToggleGroup() {
    }
    return XpoSlideToggleGroup;
}());
XpoSlideToggleGroup.decorators = [
    { type: Component, args: [{ selector: 'xpo-slidetoggle-group',
                template: "<xpo-form-group class=\"xpo-fieldset\" [labelPosition]=\"labelPosition\"> <div class=\"input-wrapper\"> <ng-content></ng-content> </div> <div *ngIf=\"label\" class=\"xpo-legend\">{{ label }}</div> </xpo-form-group>",
                styles: [" /*# sourceMappingURL=slidetoggle-group.css.map */ "],
            },] },
];
/**
 * @nocollapse
 */
XpoSlideToggleGroup.ctorParameters = function () { return []; };
XpoSlideToggleGroup.propDecorators = {
    'labelPosition': [{ type: Input },],
    'label': [{ type: Input },],
};
/* tslint:disable */
var XpoSlideToggleModule = (function () {
    function XpoSlideToggleModule() {
    }
    return XpoSlideToggleModule;
}());
XpoSlideToggleModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule, XpoFormModule],
                exports: [XpoSlideToggle, XpoSlideToggleGroup],
                declarations: [XpoSlideToggle, XpoSlideToggleGroup],
                providers: [
                    {
                        provide: FocusOriginMonitor,
                        deps: [[new Optional(), new SkipSelf(), FocusOriginMonitor], NgZone],
                        useFactory: FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY
                    },
                ],
            },] },
];
/**
 * @nocollapse
 */
XpoSlideToggleModule.ctorParameters = function () { return []; };
/**
 * Reference to a snack bar dispatched from the snack bar service.
 */
var XpoSnackBarRef = (function () {
    /**
     * @param {?} containerInstance
     * @param {?} _overlayRef
     */
    function XpoSnackBarRef(containerInstance, _overlayRef) {
        var _this = this;
        this._overlayRef = _overlayRef;
        /**
         * Subject for notifying the user that the snack bar has closed.
         */
        this._afterClosed = new Subject();
        /**
         * Subject for notifying the user that the snack bar has opened and appeared.
         */
        this._afterOpened = new Subject();
        /**
         * Subject for notifying the user that the snack bar action was called.
         */
        this._onAction = new Subject();
        this.containerInstance = containerInstance;
        // Dismiss snackbar on action.
        this.onAction().subscribe(function () { return _this.dismiss(); });
        containerInstance._onExit().subscribe(function () { return _this._finishDismiss(); });
    }
    /**
     * Dismisses the snack bar.
     * @return {?}
     */
    XpoSnackBarRef.prototype.dismiss = function () {
        if (!this._afterClosed.closed) {
            this.containerInstance.exit();
        }
        clearTimeout(this._durationTimeoutId);
    };
    /**
     * Marks the snackbar action clicked.
     * @return {?}
     */
    XpoSnackBarRef.prototype.closeWithAction = function () {
        if (!this._onAction.closed) {
            this._onAction.next();
            this._onAction.complete();
        }
    };
    /**
     * Dismisses the snack bar after some duration
     * @param {?} duration
     * @return {?}
     */
    XpoSnackBarRef.prototype._dismissAfter = function (duration) {
        var _this = this;
        this._durationTimeoutId = setTimeout(function () { return _this.dismiss(); }, duration);
    };
    /**
     * Marks the snackbar as opened
     * @return {?}
     */
    XpoSnackBarRef.prototype._open = function () {
        if (!this._afterOpened.closed) {
            this._afterOpened.next();
            this._afterOpened.complete();
        }
    };
    /**
     * Cleans up the DOM after closing.
     * @return {?}
     */
    XpoSnackBarRef.prototype._finishDismiss = function () {
        this._overlayRef.dispose();
        this._afterClosed.next();
        this._afterClosed.complete();
    };
    /**
     * Gets an observable that is notified when the snack bar is finished closing.
     * @return {?}
     */
    XpoSnackBarRef.prototype.afterDismissed = function () {
        return this._afterClosed.asObservable();
    };
    /**
     * Gets an observable that is notified when the snack bar has opened and appeared.
     * @return {?}
     */
    XpoSnackBarRef.prototype.afterOpened = function () {
        return this.containerInstance._onEnter();
    };
    /**
     * Gets an observable that is notified when the snack bar action is called.
     * @return {?}
     */
    XpoSnackBarRef.prototype.onAction = function () {
        return this._onAction.asObservable();
    };
    return XpoSnackBarRef;
}());
var XPO_SNACK_BAR_DATA = new InjectionToken('XpoSnackBarData');
/**
 * Configuration used when opening a snack-bar.
 */
var XpoSnackBarConfig = (function () {
    function XpoSnackBarConfig() {
        /**
         * The politeness level for the XpoAriaLiveAnnouncer announcement.
         */
        this.politeness = 'assertive';
        /**
         * Message to be announced by the XpoAriaLiveAnnouncer
         */
        this.announcementMessage = '';
        /**
         * Status bar color
         */
        this.status = 'success';
        /**
         * The length of time in milliseconds to wait before automatically dismissing the snack bar.
         */
        this.duration = 0;
        /**
         * Text layout direction for the snack bar.
         */
        this.direction = 'ltr';
        /**
         * Data being injected into the child component.
         */
        this.data = null;
    }
    return XpoSnackBarConfig;
}());
/* tslint:disable */
/**
 * <xpo-simple-snackbar> is a component used to open as the default snack bar, matching material spec.
 * This should only be used internally by the snack bar service.
 */
var SimpleSnackBar = (function () {
    /**
     * @param {?} snackBarRef
     * @param {?} data
     */
    function SimpleSnackBar(snackBarRef, data) {
        this.snackBarRef = snackBarRef;
        this.data = data;
    }
    Object.defineProperty(SimpleSnackBar.prototype, "isError", {
        /**
         * apply class to host if status = error
         * @return {?}
         */
        get: function () { return this.data.status === 'error'; },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * Performs the action on the snack bar.
     * @return {?}
     */
    SimpleSnackBar.prototype.action = function () {
        this.snackBarRef.closeWithAction();
    };
    Object.defineProperty(SimpleSnackBar.prototype, "hasAction", {
        /**
         * If the action button should be shown.
         * @return {?}
         */
        get: function () {
            return !!this.action;
        },
        enumerable: true,
        configurable: true
    });
    return SimpleSnackBar;
}());
SimpleSnackBar.decorators = [
    { type: Component, args: [{ selector: 'simple-snack-bar',
                template: "<div class=\"xpo-snack-bar__status\"></div> <div class=\"xpo-snack-bar__content-wrapper\"> <span>{{data.message}}</span> <button xpo-btn *ngIf=\"hasAction\" (click)=\"action()\">{{data.action}}</button> </div>",
                styles: [":host{display:flex;flex-direction:column;height:60px;font-size:1.167rem;font-weight:700}:host.xpo-snack-bar--error .xpo-snack-bar__status{background-color:#d50000}.xpo-snack-bar__status{width:100%;height:8px;background-color:#66bb6a}.xpo-snack-bar__content-wrapper{display:flex;align-items:center;justify-content:center;height:100%}.xpo-simple-snackbar-action{flex-shrink:0;margin-left:48px;color:inherit;line-height:1;background:0 0;font-family:inherit;font-size:inherit;font-weight:600} /*# sourceMappingURL=simple-snack-bar.css.map */ "],
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
SimpleSnackBar.ctorParameters = function () { return [
    { type: XpoSnackBarRef, },
    { type: undefined, decorators: [{ type: Inject, args: [XPO_SNACK_BAR_DATA,] },] },
]; };
SimpleSnackBar.propDecorators = {
    'isError': [{ type: HostBinding, args: ['class.xpo-snack-bar--error',] },],
};
/**
 * Custom injector to be used when providing custom
 * injection tokens to components inside a portal.
 * \@docs-private
 */
var PortalInjector = (function () {
    /**
     * @param {?} _parentInjector
     * @param {?} _customTokens
     */
    function PortalInjector(_parentInjector, _customTokens) {
        this._parentInjector = _parentInjector;
        this._customTokens = _customTokens;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    PortalInjector.prototype.get = function (token, notFoundValue) {
        var /** @type {?} */ value = this._customTokens.get(token);
        if (typeof value !== 'undefined') {
            return value;
        }
        return this._parentInjector.get(token, notFoundValue);
    };
    return PortalInjector;
}());
// TODO(jelbourn): we can't use constants from animation.ts here because you can't use
// a text interpolation in anything that is analyzed statically with ngc (for AoT compile).
var SHOW_ANIMATION = '225ms cubic-bezier(0.4,0.0,1,1)';
var HIDE_ANIMATION = '195ms cubic-bezier(0.0,0.0,0.2,1)';
/**
 * Internal component that wraps user-provided snack bar content.
 * \@docs-private
 */
var XpoSnackBarContainer = (function (_super) {
    __extends(XpoSnackBarContainer, _super);
    /**
     * @param {?} _ngZone
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function XpoSnackBarContainer(_ngZone, _renderer, _elementRef) {
        var _this = _super.call(this) || this;
        _this._ngZone = _ngZone;
        _this._renderer = _renderer;
        _this._elementRef = _elementRef;
        /**
         * Subject for notifying that the snack bar has exited from view.
         */
        _this.onExit = new Subject();
        /**
         * Subject for notifying that the snack bar has finished entering the view.
         */
        _this.onEnter = new Subject();
        /**
         * The state of the snack bar animations.
         */
        _this.animationState = 'initial';
        return _this;
    }
    /**
     * Attach a component portal as content to this snack bar container.
     * @template T
     * @param {?} portal
     * @return {?}
     */
    XpoSnackBarContainer.prototype.attachComponentPortal = function (portal) {
        if (this._portalHost.hasAttached()) {
            throw Error('Attempting to attach snack bar content after content is already attached');
        }
        if (this.snackBarConfig.extraClasses) {
            // Not the most efficient way of adding classes, but the renderer doesn't allow us
            // to pass in an array or a space-separated list.
            for (var _i = 0, _a = this.snackBarConfig.extraClasses; _i < _a.length; _i++) {
                var cssClass = _a[_i];
                this._renderer.addClass(this._elementRef.nativeElement, cssClass);
            }
        }
        return this._portalHost.attachComponentPortal(portal);
    };
    /**
     * Attach a template portal as content to this snack bar container.
     * @return {?}
     */
    XpoSnackBarContainer.prototype.attachTemplatePortal = function () {
        throw Error('Not yet implemented');
    };
    /**
     * Handle end of animations, updating the state of the snackbar.
     * @param {?} event
     * @return {?}
     */
    XpoSnackBarContainer.prototype.onAnimationEnd = function (event) {
        if (event.toState === 'void' || event.toState === 'complete') {
            this._completeExit();
        }
        if (event.toState === 'visible') {
            // Note: we shouldn't use `this` inside the zone callback,
            // because it can cause a memory leak.
            var /** @type {?} */ onEnter_1 = this.onEnter;
            this._ngZone.run(function () {
                onEnter_1.next();
                onEnter_1.complete();
            });
        }
    };
    /**
     * Begin animation of snack bar entrance into view.
     * @return {?}
     */
    XpoSnackBarContainer.prototype.enter = function () {
        this.animationState = 'visible';
    };
    /**
     * Returns an observable resolving when the enter animation completes.
     * @return {?}
     */
    XpoSnackBarContainer.prototype._onEnter = function () {
        this.animationState = 'visible';
        return this.onEnter.asObservable();
    };
    /**
     * Begin animation of the snack bar exiting from view.
     * @return {?}
     */
    XpoSnackBarContainer.prototype.exit = function () {
        this.animationState = 'complete';
        return this._onExit();
    };
    /**
     * Returns an observable that completes after the closing animation is done.
     * @return {?}
     */
    XpoSnackBarContainer.prototype._onExit = function () {
        return this.onExit.asObservable();
    };
    /**
     * Makes sure the exit callbacks have been invoked when the element is destroyed.
     * @return {?}
     */
    XpoSnackBarContainer.prototype.ngOnDestroy = function () {
        this._completeExit();
    };
    /**
     * Waits for the zone to settle before removing the element. Helps prevent
     * errors where we end up removing an element which is in the middle of an animation.
     * @return {?}
     */
    XpoSnackBarContainer.prototype._completeExit = function () {
        // Note: we shouldn't use `this` inside the zone callback,
        // because it can cause a memory leak.
        var /** @type {?} */ onExit = this.onExit;
        first$1.call(this._ngZone.onMicrotaskEmpty).subscribe(function () {
            onExit.next();
            onExit.complete();
        });
    };
    return XpoSnackBarContainer;
}(BasePortalHost));
XpoSnackBarContainer.decorators = [
    { type: Component, args: [{ selector: 'snack-bar-container',
                template: "<ng-template cdkPortalHost></ng-template>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{box-shadow:0 2px 5px 0 rgba(0,0,0,.13);display:block;box-sizing:content-box;width:600px;transform:translateY(100%);background:#fff} /*# sourceMappingURL=snack-bar-container.css.map */ "],
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    'role': 'alert',
                    '[@state]': 'animationState',
                    '(@state.done)': 'onAnimationEnd($event)',
                },
                animations: [
                    trigger('state', [
                        state('void', style({ transform: 'translateY(100%)' })),
                        state('initial', style({ transform: 'translateY(100%)' })),
                        state('visible', style({ transform: 'translateY(0%)' })),
                        state('complete', style({ transform: 'translateY(100%)' })),
                        transition('visible => complete', animate(HIDE_ANIMATION)),
                        transition('initial => visible, void => visible', animate(SHOW_ANIMATION)),
                    ]),
                ],
            },] },
];
/**
 * @nocollapse
 */
XpoSnackBarContainer.ctorParameters = function () { return [
    { type: NgZone, },
    { type: Renderer2, },
    { type: ElementRef, },
]; };
XpoSnackBarContainer.propDecorators = {
    '_portalHost': [{ type: ViewChild, args: [PortalHostDirective,] },],
};
/**
 * Service to dispatch Material Design snack bar messages.
 */
var XpoSnackBar = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _live
     * @param {?} _injector
     * @param {?} _parentSnackBar
     */
    function XpoSnackBar(_overlay, _live, _injector, _parentSnackBar) {
        this._overlay = _overlay;
        this._live = _live;
        this._injector = _injector;
        this._parentSnackBar = _parentSnackBar;
        /**
         * Reference to the current snack bar in the view *at this level* (in the Angular injector tree).
         * If there is a parent snack-bar service, all operations should delegate to that parent
         * via `_openedSnackBarRef`.
         */
        this._snackBarRefAtThisLevel = null;
    }
    Object.defineProperty(XpoSnackBar.prototype, "_openedSnackBarRef", {
        /**
         * Reference to the currently opened snackbar at *any* level.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ parent = this._parentSnackBar;
            return parent ? parent._openedSnackBarRef : this._snackBarRefAtThisLevel;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._parentSnackBar) {
                this._parentSnackBar._openedSnackBarRef = value;
            }
            else {
                this._snackBarRefAtThisLevel = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates and dispatches a snack bar with a custom component for the content, removing any
     * currently opened snack bars.
     *
     * @template T
     * @param {?} component Component to be instantiated.
     * @param {?=} config Extra configuration for the snack bar.
     * @return {?}
     */
    XpoSnackBar.prototype.openFromComponent = function (component, config) {
        var _this = this;
        var /** @type {?} */ _config = _applyConfigDefaults$1(config);
        var /** @type {?} */ snackBarRef = this._attach(component, _config);
        // When the snackbar is dismissed, clear the reference to it.
        snackBarRef.afterDismissed().subscribe(function () {
            // Clear the snackbar ref if it hasn't already been replaced by a newer snackbar.
            if (_this._openedSnackBarRef == snackBarRef) {
                _this._openedSnackBarRef = null;
            }
        });
        if (this._openedSnackBarRef) {
            // If a snack bar is already in view, dismiss it and enter the
            // new snack bar after exit animation is complete.
            this._openedSnackBarRef.afterDismissed().subscribe(function () {
                snackBarRef.containerInstance.enter();
            });
            this._openedSnackBarRef.dismiss();
        }
        else {
            // If no snack bar is in view, enter the new snack bar.
            snackBarRef.containerInstance.enter();
        }
        // If a dismiss timeout is provided, set up dismiss based on after the snackbar is opened.
        if (_config.duration && _config.duration > 0) {
            snackBarRef.afterOpened().subscribe(function () { return snackBarRef._dismissAfter(/** @type {?} */ ((((_config)).duration))); });
        }
        if (_config.announcementMessage) {
            this._live.announce(_config.announcementMessage, _config.politeness);
        }
        this._openedSnackBarRef = snackBarRef;
        return this._openedSnackBarRef;
    };
    /**
     * Opens a snackbar with a message and an optional action.
     * @param {?} message The message to show in the snackbar.
     * @param {?=} action The label for the snackbar action.
     * @param {?=} config Additional configuration options for the snackbar.
     * @return {?}
     */
    XpoSnackBar.prototype.open = function (message, action, config) {
        if (action === void 0) { action = ''; }
        var /** @type {?} */ _config = _applyConfigDefaults$1(config);
        // Since the user doesn't have access to the component, we can
        // override the data to pass in our own message and action.
        _config.data = { message: message, action: action };
        _config.announcementMessage = message;
        return this.openFromComponent(SimpleSnackBar, _config);
    };
    /**
     * Dismisses the currently-visible snack bar.
     * @return {?}
     */
    XpoSnackBar.prototype.dismiss = function () {
        if (this._openedSnackBarRef) {
            this._openedSnackBarRef.dismiss();
        }
    };
    /**
     * Attaches the snack bar container component to the overlay.
     * @param {?} overlayRef
     * @param {?} config
     * @return {?}
     */
    XpoSnackBar.prototype._attachSnackBarContainer = function (overlayRef, config) {
        var /** @type {?} */ containerPortal = new ComponentPortal(XpoSnackBarContainer, config.viewContainerRef);
        var /** @type {?} */ containerRef = overlayRef.attach(containerPortal);
        containerRef.instance.snackBarConfig = config;
        return containerRef.instance;
    };
    /**
     * Places a new component as the content of the snack bar container.
     * @template T
     * @param {?} component
     * @param {?} config
     * @return {?}
     */
    XpoSnackBar.prototype._attach = function (component, config) {
        var /** @type {?} */ overlayRef = this._createOverlay(config);
        var /** @type {?} */ container = this._attachSnackBarContainer(overlayRef, config);
        var /** @type {?} */ snackBarRef = new XpoSnackBarRef(container, overlayRef);
        var /** @type {?} */ injector = this._createInjector(config, snackBarRef);
        var /** @type {?} */ portal = new ComponentPortal(component, undefined, injector);
        var /** @type {?} */ contentRef = container.attachComponentPortal(portal);
        // We can't pass this via the injector, because the injector is created earlier.
        snackBarRef.instance = contentRef.instance;
        return snackBarRef;
    };
    /**
     * Creates a new overlay and places it in the correct location.
     * @param {?} config The user-specified snack bar config.
     * @return {?}
     */
    XpoSnackBar.prototype._createOverlay = function (config) {
        var /** @type {?} */ state$$1 = new OverlayState();
        state$$1.direction = config.direction;
        state$$1.positionStrategy = this._overlay.position().global().centerHorizontally().bottom('0');
        return this._overlay.create(state$$1);
    };
    /**
     * Creates an injector to be used inside of a snack bar component.
     * @template T
     * @param {?} config Config that was used to create the snack bar.
     * @param {?} snackBarRef Reference to the snack bar.
     * @return {?}
     */
    XpoSnackBar.prototype._createInjector = function (config, snackBarRef) {
        var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
        var /** @type {?} */ injectionTokens = new WeakMap();
        injectionTokens.set(XpoSnackBarRef, snackBarRef);
        injectionTokens.set(XPO_SNACK_BAR_DATA, config.data);
        return new PortalInjector(userInjector || this._injector, injectionTokens);
    };
    return XpoSnackBar;
}());
XpoSnackBar.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
XpoSnackBar.ctorParameters = function () { return [
    { type: Overlay, },
    { type: LiveAnnouncer, },
    { type: Injector, },
    { type: XpoSnackBar, decorators: [{ type: Optional }, { type: SkipSelf },] },
]; };
/**
 * Applies default options to the snackbar config.
 * @param {?=} config The configuration to which the defaults will be applied.
 * @return {?} The new configuration object with defaults applied.
 */
function _applyConfigDefaults$1(config) {
    return extendObject(new XpoSnackBarConfig(), config);
}
var XpoSnackBarModule = (function () {
    function XpoSnackBarModule() {
    }
    return XpoSnackBarModule;
}());
XpoSnackBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    OverlayModule,
                    PortalModule,
                    CommonModule,
                    XpoButtonModule,
                ],
                exports: [XpoSnackBarContainer],
                declarations: [XpoSnackBarContainer, SimpleSnackBar],
                entryComponents: [XpoSnackBarContainer, SimpleSnackBar],
                providers: [XpoSnackBar, LIVE_ANNOUNCER_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
XpoSnackBarModule.ctorParameters = function () { return []; };
/**
 * The ink-bar is used to display and animate the line underneath the current active tab label.
 * \@docs-private
 */
var XpoInkBar = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _ngZone
     */
    function XpoInkBar(_renderer, _elementRef, _ngZone) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
    }
    /**
     * Calculates the styles from the provided element in order to align the ink-bar to that element.
     * Shows the ink bar if previously set as hidden.
     * @param {?} element
     * @return {?}
     */
    XpoInkBar.prototype.alignToElement = function (element) {
        var _this = this;
        this.show();
        this._ngZone.runOutsideAngular(function () {
            requestAnimationFrame(function () {
                _this._renderer.setStyle(_this._elementRef.nativeElement, 'left', _this._getLeftPosition(element));
                _this._renderer.setStyle(_this._elementRef.nativeElement, 'width', _this._getElementWidth(element));
            });
        });
    };
    /**
     * Shows the ink bar.
     * @return {?}
     */
    XpoInkBar.prototype.show = function () {
        this._renderer.setStyle(this._elementRef.nativeElement, 'visibility', 'visible');
    };
    /**
     * Hides the ink bar.
     * @return {?}
     */
    XpoInkBar.prototype.hide = function () {
        this._renderer.setStyle(this._elementRef.nativeElement, 'visibility', 'hidden');
    };
    /**
     * Generates the pixel distance from the left based on the provided element in string format.
     * @param {?} element
     * @return {?}
     */
    XpoInkBar.prototype._getLeftPosition = function (element) {
        return element ? element.offsetLeft + 'px' : '0';
    };
    /**
     * Generates the pixel width from the provided element in string format.
     * @param {?} element
     * @return {?}
     */
    XpoInkBar.prototype._getElementWidth = function (element) {
        return element ? element.offsetWidth + 'px' : '0';
    };
    return XpoInkBar;
}());
XpoInkBar.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-ink-bar',
                host: {
                    '[class.xpo-ink-bar]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoInkBar.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: ElementRef, },
    { type: NgZone, },
]; };
/**
 * [xpo-tab-label] is used to flag tab labels for use with the portal directive
 */
var XpoTabLabel = (function (_super) {
    __extends(XpoTabLabel, _super);
    /**
     * @param {?} templateRef
     * @param {?} viewContainerRef
     */
    function XpoTabLabel(templateRef, viewContainerRef) {
        return _super.call(this, templateRef, viewContainerRef) || this;
    }
    return XpoTabLabel;
}(TemplatePortalDirective));
XpoTabLabel.decorators = [
    { type: Directive, args: [{
                selector: '[xpo-tab-label]',
            },] },
];
/**
 * @nocollapse
 */
XpoTabLabel.ctorParameters = function () { return [
    { type: TemplateRef, },
    { type: ViewContainerRef, },
]; };
/**
 *  <xpo-tab> organize content into separate views where only one view can be visible at a time. Each tab's label is shown in the tab header and the active tab's label is designated with the animated ink bar. When the list of tab labels exceeds the width of the header, pagination controls appear to let the user scroll left and right across the labels.
 */
var XpoTab = (function () {
    /**
     * @param {?} _viewContainerRef
     */
    function XpoTab(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        /**
         * The plain text label for the tab, used when there is no template label.
         */
        this.textLabel = '';
        /**
         * The portal that will be the hosted content of the tab
         */
        this._contentPortal = null;
        /**
         * The relatively indexed position where 0 represents the center, negative is left, and positive
         * represents the right.
         */
        this.position = null;
        /**
         * The initial relatively index origin of the tab if it was created and selected after there
         * was already a selected tab. Provides context of what position the tab should originate from.
         */
        this.origin = null;
        this._disabled = false;
    }
    Object.defineProperty(XpoTab.prototype, "content", {
        /**
         * @return {?}
         */
        get: function () { return this._contentPortal; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTab.prototype, "disabled", {
        /**
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * Whether the tab is disabled
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoTab.prototype.ngOnInit = function () {
        this._contentPortal = new TemplatePortal(this._content, this._viewContainerRef);
    };
    return XpoTab;
}());
XpoTab.decorators = [
    { type: Component, args: [{ selector: 'xpo-tab',
                template: "<!-- Create a template for the content of the <xpo-tab> so that we can grab a reference to this TemplateRef and use it in a Portal to render the tab content in the appropriate place in the tab-group. --> <ng-template> <ng-content></ng-content> </ng-template>",
            },] },
];
/**
 * @nocollapse
 */
XpoTab.ctorParameters = function () { return [
    { type: ViewContainerRef, },
]; };
XpoTab.propDecorators = {
    'templateLabel': [{ type: ContentChild, args: [XpoTabLabel,] },],
    '_content': [{ type: ViewChild, args: [TemplateRef,] },],
    'textLabel': [{ type: Input, args: ['label',] },],
    'disabled': [{ type: Input },],
};
/**
 * Wrapper for the contents of a tab.
 * \@docs-private
 */
var XpoTabBody = (function () {
    /**
     * @param {?} _dir
     * @param {?} _elementRef
     */
    function XpoTabBody(_dir, _elementRef) {
        this._dir = _dir;
        this._elementRef = _elementRef;
        /**
         * Event emitted when the tab begins to animate towards the center as the active tab.
         */
        this.onCentering = new EventEmitter();
        /**
         * Event emitted when the tab completes its animation towards the center.
         */
        this.onCentered = new EventEmitter(true);
    }
    Object.defineProperty(XpoTabBody.prototype, "position", {
        /**
         * @param {?} position
         * @return {?}
         */
        set: function (position) {
            if (position < 0) {
                this._position = this._getLayoutDirection() == 'ltr' ? 'left' : 'right';
            }
            else if (position > 0) {
                this._position = this._getLayoutDirection() == 'ltr' ? 'right' : 'left';
            }
            else {
                this._position = 'center';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTabBody.prototype, "origin", {
        /**
         * The origin position from which this tab should appear when it is centered into view.
         * @param {?} origin
         * @return {?}
         */
        set: function (origin) {
            if (origin == null) {
                return;
            }
            var /** @type {?} */ dir = this._getLayoutDirection();
            if ((dir == 'ltr' && origin <= 0) || (dir == 'rtl' && origin > 0)) {
                this._origin = 'left';
            }
            else {
                this._origin = 'right';
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * After initialized, check if the content is centered and has an origin. If so, set the
     * special position states that transition the tab from the left or right before centering.
     * @return {?}
     */
    XpoTabBody.prototype.ngOnInit = function () {
        if (this._position == 'center' && this._origin) {
            this._position = this._origin == 'left' ? 'left-origin-center' : 'right-origin-center';
        }
    };
    /**
     * After the view has been set, check if the tab content is set to the center and attach the
     * content if it is not already attached.
     * @return {?}
     */
    XpoTabBody.prototype.ngAfterViewChecked = function () {
        if (this._isCenterPosition(this._position) && !this._portalHost.hasAttached()) {
            this._portalHost.attach(this._content);
        }
    };
    /**
     * The text direction of the containing app.
     * @return {?}
     */
    XpoTabBody.prototype._getLayoutDirection = function () {
        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
    };
    /**
     * Whether the provided position state is considered center, regardless of origin.
     * @param {?} position
     * @return {?}
     */
    XpoTabBody.prototype._isCenterPosition = function (position) {
        return position == 'center' ||
            position == 'left-origin-center' ||
            position == 'right-origin-center';
    };
    return XpoTabBody;
}());
XpoTabBody.decorators = [
    { type: Component, args: [{ selector: 'xpo-tab-body',
                template: "<div class=\"xpo-tab-body-content\" #content> <ng-template cdkPortalHost></ng-template> </div>",
                styles: [".xpo-tab-body-content{height:100%}.xpo-tab-group-dynamic-height .xpo-tab-body-content{overflow:hidden} /*# sourceMappingURL=tab-body.css.map */ "],
                host: {
                    '[class.xpo-tab-body]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoTabBody.ctorParameters = function () { return [
    { type: Dir, decorators: [{ type: Optional },] },
    { type: ElementRef, },
]; };
XpoTabBody.propDecorators = {
    '_portalHost': [{ type: ViewChild, args: [PortalHostDirective,] },],
    'onCentering': [{ type: Output },],
    'onCentered': [{ type: Output },],
    '_content': [{ type: Input, args: ['content',] },],
    'position': [{ type: Input, args: ['position',] },],
    'origin': [{ type: Input, args: ['origin',] },],
};
/**
 * Used to generate unique ID's for each tab component
 */
var nextId$3 = 0;
/**
 * A simple change event emitted on focus or selection changes.
 */
var XpoTabChangeEvent = (function () {
    function XpoTabChangeEvent() {
    }
    return XpoTabChangeEvent;
}());
/**
 * <xpo-tab-group> supports basic tab pairs (label + content) and includes
 * animated ink-bar, keyboard navigation, and screen reader.
 */
var XpoTabGroup = (function () {
    /**
     * @param {?} _renderer
     */
    function XpoTabGroup(_renderer) {
        this._renderer = _renderer;
        /**
         * Whether this component has been initialized.
         */
        this._isInitialized = false;
        /**
         * The tab index that should be selected after the content has been checked.
         */
        this._indexToSelect = 0;
        /**
         * Snapshot of the height of the tab body wrapper before another tab is activated.
         */
        this._tabBodyWrapperHeight = null;
        /**
         * Whether the tab group should grow to the size of the active tab
         */
        this._dynamicHeight = false;
        this._disableRipple = true;
        this._selectedIndex = null;
        /**
         * Position of the tab header.
         */
        this.headerPosition = 'above';
        /**
         * Event emitted when focus has changed within a tab group.
         */
        this.focusChange = new EventEmitter();
        /**
         * Event emitted when the tab selection has changed.
         */
        this.selectChange = new EventEmitter(true);
        this._groupId = nextId$3++;
    }
    Object.defineProperty(XpoTabGroup.prototype, "dynamicHeight", {
        /**
         * @return {?}
         */
        get: function () { return this._dynamicHeight; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._dynamicHeight = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTabGroup.prototype, "_dynamicHeightDeprecated", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this._dynamicHeight; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._dynamicHeight = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTabGroup.prototype, "disableRipple", {
        /**
         * Whether ripples for the tab-group should be disabled or not.
         * @return {?}
         */
        get: function () { return this._disableRipple; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disableRipple = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTabGroup.prototype, "selectedIndex", {
        /**
         * @return {?}
         */
        get: function () { return this._selectedIndex; },
        /**
         * The index of the active tab.
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._indexToSelect = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTabGroup.prototype, "selectedIndexChange", {
        /**
         * Output to enable support for two-way binding on `[(selectedIndex)]`
         * @return {?}
         */
        get: function () {
            return this.selectChange.map(function (event) { return event.index; });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * After the content is checked, this component knows what tabs have been defined
     * and what the selected index should be. This is where we can know exactly what position
     * each tab should be in according to the new selected index, and additionally we know how
     * a new selected tab should transition in (from the left or right).
     * @return {?}
     */
    XpoTabGroup.prototype.ngAfterContentChecked = function () {
        var _this = this;
        // Clamp the next selected index to the bounds of 0 and the tabs length. Note the `|| 0`, which
        // ensures that values like NaN can't get through and which would otherwise throw the
        // component into an infinite loop (since Math.max(NaN, 0) === NaN).
        this._indexToSelect =
            Math.min(this._tabs.length - 1, Math.max(this._indexToSelect || 0, 0));
        // If there is a change in selected index, emit a change event. Should not trigger if
        // the selected index has not yet been initialized.
        if (this._selectedIndex != this._indexToSelect && this._selectedIndex != null) {
            this.selectChange.emit(this._createChangeEvent(this._indexToSelect));
        }
        // Setup the position for each tab and optionally setup an origin on the next selected tab.
        this._tabs.forEach(function (tab, index) {
            tab.position = index - _this._indexToSelect;
            // If there is already a selected tab, then set up an origin for the next selected tab
            // if it doesn't have one already.
            if (_this._selectedIndex != null && tab.position == 0 && !tab.origin) {
                tab.origin = _this._indexToSelect - _this._selectedIndex;
            }
        });
        this._selectedIndex = this._indexToSelect;
    };
    /**
     * Waits one frame for the view to update, then updates the ink bar
     * Note: This must be run outside of the zone or it will create an infinite change detection loop.
     * @return {?}
     */
    XpoTabGroup.prototype.ngAfterViewChecked = function () {
        this._isInitialized = true;
    };
    /**
     * @param {?} index
     * @return {?}
     */
    XpoTabGroup.prototype._focusChanged = function (index) {
        this.focusChange.emit(this._createChangeEvent(index));
    };
    /**
     * @param {?} index
     * @return {?}
     */
    XpoTabGroup.prototype._createChangeEvent = function (index) {
        var /** @type {?} */ event = new XpoTabChangeEvent();
        event.index = index;
        if (this._tabs && this._tabs.length) {
            event.tab = this._tabs.toArray()[index];
        }
        return event;
    };
    /**
     * Returns a unique id for each tab label element
     * @param {?} i
     * @return {?}
     */
    XpoTabGroup.prototype._getTabLabelId = function (i) {
        return "xpo-tab-label-" + this._groupId + "-" + i;
    };
    /**
     * Returns a unique id for each tab content element
     * @param {?} i
     * @return {?}
     */
    XpoTabGroup.prototype._getTabContentId = function (i) {
        return "xpo-tab-content-" + this._groupId + "-" + i;
    };
    /**
     * Sets the height of the body wrapper to the height of the activating tab if dynamic
     * height property is true.
     * @param {?} tabHeight
     * @return {?}
     */
    XpoTabGroup.prototype._setTabBodyWrapperHeight = function (tabHeight) {
        if (!this._dynamicHeight || !this._tabBodyWrapperHeight) {
            return;
        }
        this._renderer.setStyle(this._tabBodyWrapper.nativeElement, 'height', this._tabBodyWrapperHeight + 'px');
        // This conditional forces the browser to paint the height so that
        // the animation to the new height can have an origin.
        if (this._tabBodyWrapper.nativeElement.offsetHeight) {
            this._renderer.setStyle(this._tabBodyWrapper.nativeElement, 'height', tabHeight + 'px');
        }
    };
    /**
     * Removes the height of the tab body wrapper.
     * @return {?}
     */
    XpoTabGroup.prototype._removeTabBodyWrapperHeight = function () {
        this._tabBodyWrapperHeight = this._tabBodyWrapper.nativeElement.clientHeight;
        this._renderer.setStyle(this._tabBodyWrapper.nativeElement, 'height', '');
    };
    return XpoTabGroup;
}());
XpoTabGroup.decorators = [
    { type: Component, args: [{ selector: 'xpo-tab-group',
                template: "<xpo-tab-header #tabHeader [selectedIndex]=\"selectedIndex\" (indexFocused)=\"_focusChanged($event)\" (selectFocusedIndex)=\"selectedIndex = $event\"> <div class=\"xpo-tab-label\" role=\"tab\" xpo-tab-label-wrapper *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabLabelId(i)\" [tabIndex]=\"selectedIndex == i ? 0 : -1\" [attr.aria-controls]=\"_getTabContentId(i)\" [attr.aria-selected]=\"selectedIndex == i\" [class.xpo-tab-label-active]=\"selectedIndex == i\" [disabled]=\"tab.disabled\" (click)=\"tabHeader.focusIndex = selectedIndex = i\"> <!-- If there is a label template, use it. --> <ng-template [ngIf]=\"tab.templateLabel\"> <ng-template [cdkPortalHost]=\"tab.templateLabel\"></ng-template> </ng-template> <!-- If there is not a label template, fall back to the text label. --> <ng-template [ngIf]=\"!tab.templateLabel\">{{tab.textLabel}}</ng-template> </div> </xpo-tab-header> <div class=\"xpo-tab-body-wrapper\" #tabBodyWrapper> <xpo-tab-body role=\"tabpanel\" *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabContentId(i)\" [attr.aria-labelledby]=\"_getTabLabelId(i)\" [class.xpo-tab-body-active]=\"selectedIndex == i\" [content]=\"tab.content\" [position]=\"tab.position\" [origin]=\"tab.origin\" (onCentered)=\"_removeTabBodyWrapperHeight()\" (onCentering)=\"_setTabBodyWrapperHeight($event)\"> </xpo-tab-body> </div>",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host-context(.xpo-internal) /deep/ .xpo-tab-label{text-transform:uppercase}:host-context(.xpo-internal) /deep/ .xpo-tab-link{height:44px;font-size:12px;font-weight:400;color:#9e9e9e;line-height:44px;text-transform:uppercase}:host-context(.xpo-internal) /deep/ .xpo-ink-bar{background-color:#0091ea}:host-context(.xpo-external) /deep/ .xpo-tab-label{font-size:14px}:host-context(.xpo-external) /deep/ .xpo-ink-bar{background-color:#d50000}:host{display:flex;flex-direction:column;height:100%}:host.xpo-tab-group-inverted-header{flex-direction:column-reverse}.xpo-tab-label{box-sizing:border-box;height:48px;padding:0 15px;cursor:pointer;font-weight:700;color:#858585;line-height:48px;text-align:center;position:relative}.xpo-tab-label:focus{outline:0;opacity:1}.xpo-tab-label.xpo-tab-label-active,.xpo-tab-label:hover{color:#333}.xpo-tab-label.xpo-tab-disabled{color:#bdbdbd}@media (max-width:600px){.xpo-tab-label{min-width:72px}}:host[xpo-stretch-tabs] .xpo-tab-label{flex-grow:1;flex-basis:0}:host[inverted] .xpo-tab-header{background-color:#424242}:host[inverted] .xpo-tab-label{color:#dfdfdf}:host[inverted] .xpo-tab-label.xpo-tab-label-active,:host[inverted] .xpo-tab-label:hover{color:#f5f5f5}:host[inverted] .xpo-tab-label.xpo-tab-disabled{color:#9e9e9e}.xpo-tab-body-wrapper{display:flex;overflow:hidden;position:relative;transition:height .5s cubic-bezier(.35,0,.25,1)}.xpo-tab-body{position:absolute;top:0;right:0;bottom:0;left:0;display:none;overflow:hidden}.xpo-tab-body.xpo-tab-body-active{display:block;flex-grow:1;overflow-x:hidden;overflow-y:auto;position:relative;z-index:1}:host.xpo-tab-group-dynamic-height .xpo-tab-body.xpo-tab-body-active{overflow-y:hidden}.xpo-tab-disabled{cursor:default;pointer-events:none} /*# sourceMappingURL=tab-group.css.map */ "],
                host: {
                    '[class.xpo-tab-group]': 'true',
                    '[class.xpo-tab-group-dynamic-height]': 'dynamicHeight',
                    '[class.xpo-tab-group-inverted-header]': 'headerPosition === "below"',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoTabGroup.ctorParameters = function () { return [
    { type: Renderer2, },
]; };
XpoTabGroup.propDecorators = {
    '_tabs': [{ type: ContentChildren, args: [XpoTab,] },],
    '_tabBodyWrapper': [{ type: ViewChild, args: ['tabBodyWrapper',] },],
    'dynamicHeight': [{ type: Input },],
    '_dynamicHeightDeprecated': [{ type: Input, args: ['xpo-dynamic-height',] },],
    'disableRipple': [{ type: Input },],
    'selectedIndex': [{ type: Input },],
    'headerPosition': [{ type: Input },],
    'selectedIndexChange': [{ type: Output },],
    'focusChange': [{ type: Output },],
    'selectChange': [{ type: Output },],
};
/**
 * Used in the `xpo-tab-group` view to display tab labels.
 * \@docs-private
 */
var XpoTabLabelWrapper = (function () {
    /**
     * @param {?} elementRef
     */
    function XpoTabLabelWrapper(elementRef) {
        this.elementRef = elementRef;
        /**
         * Whether the tab label is disabled.
         */
        this._disabled = false;
    }
    Object.defineProperty(XpoTabLabelWrapper.prototype, "disabled", {
        /**
         * Whether the element is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets focus on the wrapper element
     * @return {?}
     */
    XpoTabLabelWrapper.prototype.focus = function () {
        this.elementRef.nativeElement.focus();
    };
    /**
     * @return {?}
     */
    XpoTabLabelWrapper.prototype.getOffsetLeft = function () {
        return this.elementRef.nativeElement.offsetLeft;
    };
    /**
     * @return {?}
     */
    XpoTabLabelWrapper.prototype.getOffsetWidth = function () {
        return this.elementRef.nativeElement.offsetWidth;
    };
    return XpoTabLabelWrapper;
}());
XpoTabLabelWrapper.decorators = [
    { type: Directive, args: [{
                selector: '[xpo-tab-label-wrapper]',
                host: {
                    '[class.xpo-tab-disabled]': 'disabled',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoTabLabelWrapper.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
XpoTabLabelWrapper.propDecorators = {
    'disabled': [{ type: Input },],
};
/* tslint:disable */
/**
 * The distance in pixels that will be overshot when scrolling a tab label into view. This helps
 * provide a small affordance to the label next to it.
 */
var EXAGGERATED_OVERSCROLL = 60;
/**
 * The header of the tab group which displays a list of all the tabs in the tab group. Includes
 * an ink bar that follows the currently selected tab. When the tabs list's width exceeds the
 * width of the header container, then arrows will be displayed to allow the user to scroll
 * left and right across the header.
 * \@docs-private
 */
var XpoTabHeader = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _ngZone
     * @param {?} _dir
     */
    function XpoTabHeader(_elementRef, _ngZone, _dir) {
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
        this._dir = _dir;
        /**
         * The tab index that is focused.
         */
        this._focusIndex = 0;
        /**
         * The distance in pixels that the tab labels should be translated to the left.
         */
        this._scrollDistance = 0;
        /**
         * Whether the header should scroll to the selected index after the view has been checked.
         */
        this._selectedIndexChanged = false;
        /**
         * Combines listeners that will re-align the ink bar whenever they're invoked.
         */
        this._realignInkBar = null;
        /**
         * Whether the controls for pagination should be displayed
         */
        this._showPaginationControls = false;
        /**
         * Whether the tab list can be scrolled more towards the end of the tab label list.
         */
        this._disableScrollAfter = true;
        /**
         * Whether the tab list can be scrolled more towards the beginning of the tab label list.
         */
        this._disableScrollBefore = true;
        this._selectedIndex = 0;
        /**
         * Event emitted when the option is selected.
         */
        this.selectFocusedIndex = new EventEmitter();
        /**
         * Event emitted when a label is focused.
         */
        this.indexFocused = new EventEmitter();
    }
    Object.defineProperty(XpoTabHeader.prototype, "selectedIndex", {
        /**
         * The index of the active tab.
         * @return {?}
         */
        get: function () { return this._selectedIndex; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selectedIndexChanged = this._selectedIndex != value;
            this._selectedIndex = value;
            this._focusIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoTabHeader.prototype.ngAfterContentChecked = function () {
        // If the number of tab labels have changed, check if scrolling should be enabled
        if (this._tabLabelCount != this._labelWrappers.length) {
            this._updatePagination();
            this._tabLabelCount = this._labelWrappers.length;
        }
        // If the selected index has changed, scroll to the label and check if the scrolling controls
        // should be disabled.
        if (this._selectedIndexChanged) {
            this._scrollToLabel(this._selectedIndex);
            this._checkScrollingControls();
            this._alignInkBarToSelectedTab();
            this._selectedIndexChanged = false;
        }
        // If the scroll distance has been changed (tab selected, focused, scroll controls activated),
        // then translate the header to reflect this.
        if (this._scrollDistanceChanged) {
            this._updateTabScrollPosition();
            this._scrollDistanceChanged = false;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    XpoTabHeader.prototype._handleKeydown = function (event) {
        switch (event.keyCode) {
            case RIGHT_ARROW:
                this._focusNextTab();
                break;
            case LEFT_ARROW:
                this._focusPreviousTab();
                break;
            case ENTER:
                this.selectFocusedIndex.emit(this.focusIndex);
                break;
        }
    };
    /**
     * Aligns the ink bar to the selected tab on load.
     * @return {?}
     */
    XpoTabHeader.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._realignInkBar = this._ngZone.runOutsideAngular(function () {
            var /** @type {?} */ dirChange = _this._dir ? _this._dir.dirChange : Observable.of(null);
            var /** @type {?} */ resize = typeof window !== 'undefined' ?
                Observable.fromEvent(window, 'resize').auditTime(10) :
                Observable.of(null);
            return Observable.merge(dirChange, resize).startWith(null).subscribe(function () {
                _this._updatePagination();
                _this._alignInkBarToSelectedTab();
            });
        });
    };
    /**
     * @return {?}
     */
    XpoTabHeader.prototype.ngOnDestroy = function () {
        if (this._realignInkBar) {
            this._realignInkBar.unsubscribe();
            this._realignInkBar = null;
        }
    };
    /**
     * Callback for when the MutationObserver detects that the content has changed.
     * @return {?}
     */
    XpoTabHeader.prototype._onContentChanges = function () {
        this._updatePagination();
        this._alignInkBarToSelectedTab();
    };
    /**
     * Updating the view whether pagination should be enabled or not
     * @return {?}
     */
    XpoTabHeader.prototype._updatePagination = function () {
        this._checkPaginationEnabled();
        this._checkScrollingControls();
        this._updateTabScrollPosition();
    };
    Object.defineProperty(XpoTabHeader.prototype, "focusIndex", {
        /**
         * Tracks which element has focus; used for keyboard navigation
         * @return {?}
         */
        get: function () { return this._focusIndex; },
        /**
         * When the focus index is set, we must manually send focus to the correct label
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (!this._isValidIndex(value) || this._focusIndex == value) {
                return;
            }
            this._focusIndex = value;
            this.indexFocused.emit(value);
            this._setTabFocus(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
     * providing a valid index and return true.
     * @param {?} index
     * @return {?}
     */
    XpoTabHeader.prototype._isValidIndex = function (index) {
        if (!this._labelWrappers) {
            return true;
        }
        var /** @type {?} */ tab = this._labelWrappers ? this._labelWrappers.toArray()[index] : null;
        return tab && !tab.disabled;
    };
    /**
     * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
     * scrolling is enabled.
     * @param {?} tabIndex
     * @return {?}
     */
    XpoTabHeader.prototype._setTabFocus = function (tabIndex) {
        if (this._showPaginationControls) {
            this._scrollToLabel(tabIndex);
        }
        if (this._labelWrappers && this._labelWrappers.length) {
            this._labelWrappers.toArray()[tabIndex].focus();
            // Do not let the browser manage scrolling to focus the element, this will be handled
            // by using translation. In LTR, the scroll left should be 0. In RTL, the scroll width
            // should be the full width minus the offset width.
            var /** @type {?} */ containerEl = this._tabListContainer.nativeElement;
            var /** @type {?} */ dir = this._getLayoutDirection();
            if (dir == 'ltr') {
                containerEl.scrollLeft = 0;
            }
            else {
                containerEl.scrollLeft = containerEl.scrollWidth - containerEl.offsetWidth;
            }
        }
    };
    /**
     * Moves the focus towards the beginning or the end of the list depending on the offset provided.
     * Valid offsets are 1 and -1.
     * @param {?} offset
     * @return {?}
     */
    XpoTabHeader.prototype._moveFocus = function (offset) {
        if (this._labelWrappers) {
            var /** @type {?} */ tabs = this._labelWrappers.toArray();
            for (var /** @type {?} */ i = this.focusIndex + offset; i < tabs.length && i >= 0; i += offset) {
                if (this._isValidIndex(i)) {
                    this.focusIndex = i;
                    return;
                }
            }
        }
    };
    /**
     * Increment the focus index by 1 until a valid tab is found.
     * @return {?}
     */
    XpoTabHeader.prototype._focusNextTab = function () {
        this._moveFocus(this._getLayoutDirection() == 'ltr' ? 1 : -1);
    };
    /**
     * Decrement the focus index by 1 until a valid tab is found.
     * @return {?}
     */
    XpoTabHeader.prototype._focusPreviousTab = function () {
        this._moveFocus(this._getLayoutDirection() == 'ltr' ? -1 : 1);
    };
    /**
     * The layout direction of the containing app.
     * @return {?}
     */
    XpoTabHeader.prototype._getLayoutDirection = function () {
        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
    };
    /**
     * Performs the CSS transformation on the tab list that will cause the list to scroll.
     * @return {?}
     */
    XpoTabHeader.prototype._updateTabScrollPosition = function () {
        var /** @type {?} */ translateX = this.scrollDistance + 'px';
        if (this._getLayoutDirection() == 'ltr') {
            translateX = '-' + translateX;
        }
        applyCssTransform(this._tabList.nativeElement, "translate3d(" + translateX + ", 0, 0)");
    };
    Object.defineProperty(XpoTabHeader.prototype, "scrollDistance", {
        /**
         * @return {?}
         */
        get: function () { return this._scrollDistance; },
        /**
         * Sets the distance in pixels that the tab header should be transformed in the X-axis.
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._scrollDistance = Math.max(0, Math.min(this._getMaxScrollDistance(), v));
            // Mark that the scroll distance has changed so that after the view is checked, the CSS
            // transformation can move the header.
            this._scrollDistanceChanged = true;
            this._checkScrollingControls();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
     * the end of the list, respectively). The distance to scroll is computed to be a third of the
     * length of the tab list view window.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @param {?} scrollDir
     * @return {?}
     */
    XpoTabHeader.prototype._scrollHeader = function (scrollDir) {
        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
        // Move the scroll distance one-third the length of the tab list's viewport.
        this.scrollDistance += (scrollDir == 'before' ? -1 : 1) * viewLength / 3;
    };
    /**
     * Moves the tab list such that the desired tab label (marked by index) is moved into view.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @param {?} labelIndex
     * @return {?}
     */
    XpoTabHeader.prototype._scrollToLabel = function (labelIndex) {
        var /** @type {?} */ selectedLabel = this._labelWrappers
            ? this._labelWrappers.toArray()[labelIndex]
            : null;
        if (!selectedLabel) {
            return;
        }
        // The view length is the visible width of the tab labels.
        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
        var /** @type {?} */ labelBeforePos, /** @type {?} */ labelAfterPos;
        if (this._getLayoutDirection() == 'ltr') {
            labelBeforePos = selectedLabel.getOffsetLeft();
            labelAfterPos = labelBeforePos + selectedLabel.getOffsetWidth();
        }
        else {
            labelAfterPos = this._tabList.nativeElement.offsetWidth - selectedLabel.getOffsetLeft();
            labelBeforePos = labelAfterPos - selectedLabel.getOffsetWidth();
        }
        var /** @type {?} */ beforeVisiblePos = this.scrollDistance;
        var /** @type {?} */ afterVisiblePos = this.scrollDistance + viewLength;
        if (labelBeforePos < beforeVisiblePos) {
            // Scroll header to move label to the before direction
            this.scrollDistance -= beforeVisiblePos - labelBeforePos + EXAGGERATED_OVERSCROLL;
        }
        else if (labelAfterPos > afterVisiblePos) {
            // Scroll header to move label to the after direction
            this.scrollDistance += labelAfterPos - afterVisiblePos + EXAGGERATED_OVERSCROLL;
        }
    };
    /**
     * Evaluate whether the pagination controls should be displayed. If the scroll width of the
     * tab list is wider than the size of the header container, then the pagination controls should
     * be shown.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @return {?}
     */
    XpoTabHeader.prototype._checkPaginationEnabled = function () {
        this._showPaginationControls =
            this._tabList.nativeElement.scrollWidth > this._elementRef.nativeElement.offsetWidth;
        if (!this._showPaginationControls) {
            this.scrollDistance = 0;
        }
    };
    /**
     * Evaluate whether the before and after controls should be enabled or disabled.
     * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
     * before button. If the header is at the end of the list (scroll distance is equal to the
     * maximum distance we can scroll), then disable the after button.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @return {?}
     */
    XpoTabHeader.prototype._checkScrollingControls = function () {
        // Check if the pagination arrows should be activated.
        this._disableScrollBefore = this.scrollDistance == 0;
        this._disableScrollAfter = this.scrollDistance == this._getMaxScrollDistance();
    };
    /**
     * Determines what is the maximum length in pixels that can be set for the scroll distance. This
     * is equal to the difference in width between the tab list container and tab header container.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @return {?}
     */
    XpoTabHeader.prototype._getMaxScrollDistance = function () {
        var /** @type {?} */ lengthOfTabList = this._tabList.nativeElement.scrollWidth;
        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
        return lengthOfTabList - viewLength;
    };
    /**
     * Tells the ink-bar to align itself to the current label wrapper
     * @return {?}
     */
    XpoTabHeader.prototype._alignInkBarToSelectedTab = function () {
        var /** @type {?} */ selectedLabelWrapper = this._labelWrappers && this._labelWrappers.length
            ? this._labelWrappers.toArray()[this.selectedIndex].elementRef.nativeElement
            : null;
        this._inkBar.alignToElement(selectedLabelWrapper);
    };
    return XpoTabHeader;
}());
XpoTabHeader.decorators = [
    { type: Component, args: [{ selector: 'xpo-tab-header',
                template: "<div class=\"xpo-tab-header-pagination xpo-tab-header-pagination-before xpo-elevation-z4\" aria-hidden=\"true\" [class.xpo-tab-header-pagination-disabled]=\"_disableScrollBefore\" (click)=\"_scrollHeader('before')\"> <div class=\"xpo-tab-header-pagination-chevron\"></div> </div> <div class=\"xpo-tab-label-container\" #tabListContainer (keydown)=\"_handleKeydown($event)\"> <div class=\"xpo-tab-list\" #tabList role=\"tablist\" (cdkObserveContent)=\"_onContentChanges()\"> <div class=\"xpo-tab-labels\"> <ng-content></ng-content> </div> <xpo-ink-bar></xpo-ink-bar> </div> </div> <div class=\"xpo-tab-header-pagination xpo-tab-header-pagination-after xpo-elevation-z4\" aria-hidden=\"true\" [class.xpo-tab-header-pagination-disabled]=\"_disableScrollAfter\" (click)=\"_scrollHeader('after')\"> <div class=\"xpo-tab-header-pagination-chevron\"></div> </div>",
                styles: [":host-context(.xpo-internal) /deep/ .xpo-tab-label{text-transform:uppercase}:host-context(.xpo-internal) /deep/ .xpo-tab-link{height:44px;font-size:12px;font-weight:400;color:#9e9e9e;line-height:44px;text-transform:uppercase}:host-context(.xpo-internal) /deep/ .xpo-ink-bar{background-color:#0091ea}:host-context(.xpo-external) /deep/ .xpo-tab-label{font-size:14px}:host-context(.xpo-external) /deep/ .xpo-ink-bar{background-color:#d50000}.xpo-tab-header{flex-shrink:0;overflow:hidden;position:relative;display:flex}.xpo-tab-label{box-sizing:border-box;height:48px;padding:0 15px;cursor:pointer;font-weight:700;color:#858585;line-height:48px;text-align:center;position:relative}.xpo-tab-label:focus{outline:0;opacity:1}.xpo-tab-label.xpo-tab-label-active,.xpo-tab-label:hover{color:#333}@media (max-width:600px){.xpo-tab-label{min-width:72px}}.xpo-ink-bar{height:3px;position:absolute;bottom:0;transition:.5s cubic-bezier(.35,0,.25,1)}.xpo-tab-header-pagination{display:none;align-items:center;justify-content:center;min-width:32px;position:relative;cursor:pointer;z-index:2}.xpo-tab-header-pagination-controls-enabled .xpo-tab-header-pagination{display:flex}.xpo-tab-header-pagination-before,.xpo-tab-header-rtl .xpo-tab-header-pagination-after{padding-left:4px}.xpo-tab-header-pagination-before .xpo-tab-header-pagination-chevron,.xpo-tab-header-rtl .xpo-tab-header-pagination-after .xpo-tab-header-pagination-chevron{transform:rotate(-135deg)}.xpo-tab-header-pagination-after,.xpo-tab-header-rtl .xpo-tab-header-pagination-before{padding-right:4px}.xpo-tab-header-pagination-after .xpo-tab-header-pagination-chevron,.xpo-tab-header-rtl .xpo-tab-header-pagination-before .xpo-tab-header-pagination-chevron{transform:rotate(45deg)}.xpo-tab-header-pagination-chevron{width:8px;height:8px;content:\"\";border-style:solid;border-width:2px 2px 0 0}.xpo-tab-header-pagination-disabled{cursor:default;box-shadow:none}.xpo-tab-header-pagination-disabled .xpo-tab-header-pagination-chevron{border-color:#ccc}.xpo-tab-label-container{display:flex;flex-grow:1;overflow:hidden;z-index:1}.xpo-tab-list{flex-grow:1;position:relative;transition:transform .5s cubic-bezier(.35,0,.25,1)}.xpo-tab-labels{display:flex} /*# sourceMappingURL=tab-header.css.map */ "],
                host: {
                    'class': 'xpo-tab-header',
                    '[class.xpo-tab-header-pagination-controls-enabled]': '_showPaginationControls',
                    '[class.xpo-tab-header-rtl]': "_getLayoutDirection() == 'rtl'",
                }
            },] },
];
/**
 * @nocollapse
 */
XpoTabHeader.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: NgZone, },
    { type: Dir, decorators: [{ type: Optional },] },
]; };
XpoTabHeader.propDecorators = {
    '_labelWrappers': [{ type: ContentChildren, args: [XpoTabLabelWrapper,] },],
    '_inkBar': [{ type: ViewChild, args: [XpoInkBar,] },],
    '_tabListContainer': [{ type: ViewChild, args: ['tabListContainer',] },],
    '_tabList': [{ type: ViewChild, args: ['tabList',] },],
    'selectedIndex': [{ type: Input },],
    'selectFocusedIndex': [{ type: Output },],
    'indexFocused': [{ type: Output },],
};
/* tslint:disable */
/**
 * Navigation component matching the styles of the tab group header.
 * Provides anchored navigation with animated ink bar.
 */
var XpoTabNavBar = (function () {
    /**
     * @param {?} _dir
     * @param {?} _ngZone
     */
    function XpoTabNavBar(_dir, _ngZone) {
        this._dir = _dir;
        this._ngZone = _ngZone;
        /**
         * Combines listeners that will re-align the ink bar whenever they're invoked.
         */
        this._realignInkBar = null;
    }
    /**
     * Notifies the component that the active link has been changed.
     * @param {?} element
     * @return {?}
     */
    XpoTabNavBar.prototype.updateActiveLink = function (element) {
        this._activeLinkChanged = this._activeLinkElement != element;
        this._activeLinkElement = element;
    };
    /**
     * @return {?}
     */
    XpoTabNavBar.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._realignInkBar = this._ngZone.runOutsideAngular(function () {
            var /** @type {?} */ dirChange = _this._dir ? _this._dir.dirChange : Observable.of(null);
            var /** @type {?} */ resize = typeof window !== 'undefined' ?
                Observable.fromEvent(window, 'resize').auditTime(10) :
                Observable.of(null);
            return Observable.merge(dirChange, resize).subscribe(function () { return _this._alignInkBar(); });
        });
    };
    /**
     * Checks if the active link has been changed and, if so, will update the ink bar.
     * @return {?}
     */
    XpoTabNavBar.prototype.ngAfterContentChecked = function () {
        if (this._activeLinkChanged) {
            this._alignInkBar();
            this._activeLinkChanged = false;
        }
    };
    /**
     * @return {?}
     */
    XpoTabNavBar.prototype.ngOnDestroy = function () {
        if (this._realignInkBar) {
            this._realignInkBar.unsubscribe();
            this._realignInkBar = null;
        }
    };
    /**
     * Aligns the ink bar to the active link.
     * @return {?}
     */
    XpoTabNavBar.prototype._alignInkBar = function () {
        if (this._activeLinkElement) {
            this._inkBar.alignToElement(this._activeLinkElement.nativeElement);
        }
    };
    return XpoTabNavBar;
}());
XpoTabNavBar.decorators = [
    { type: Component, args: [{ selector: '[xpo-tab-nav-bar]',
                template: "<div class=\"xpo-tab-links\"> <ng-content></ng-content> <xpo-ink-bar></xpo-ink-bar> </div>",
                styles: [":host-context(.xpo-internal) /deep/ .xpo-tab-label{text-transform:uppercase}:host-context(.xpo-internal) /deep/ .xpo-tab-link{height:44px;font-size:12px;font-weight:400;color:#9e9e9e;line-height:44px;text-transform:uppercase}:host-context(.xpo-internal) /deep/ .xpo-ink-bar{background-color:#0091ea}:host-context(.xpo-external) /deep/ .xpo-tab-label{font-size:14px}:host-context(.xpo-external) /deep/ .xpo-ink-bar{background-color:#d50000}:host{flex-shrink:0;overflow:hidden;position:relative}:host /deep/ .xpo-tab-links{position:relative}:host /deep/ .xpo-tab-link{box-sizing:border-box;height:48px;padding:0 15px;cursor:pointer;font-weight:700;color:#858585;line-height:48px;text-align:center;display:inline-block;vertical-align:top;overflow:hidden;position:relative;text-decoration:none}:host /deep/ .xpo-tab-link:focus{outline:0;opacity:1}:host /deep/ .xpo-tab-link.xpo-tab-label-active,:host /deep/ .xpo-tab-link:hover{color:#333}:host /deep/ .xpo-ink-bar{height:3px;position:absolute;bottom:0;transition:.5s cubic-bezier(.35,0,.25,1)}@media (max-width:600px){:host /deep/ .xpo-tab-link{min-width:72px}} /*# sourceMappingURL=tab-nav-bar.css.map */ "],
            },] },
];
/**
 * @nocollapse
 */
XpoTabNavBar.ctorParameters = function () { return [
    { type: Dir, decorators: [{ type: Optional },] },
    { type: NgZone, },
]; };
XpoTabNavBar.propDecorators = {
    '_inkBar': [{ type: ViewChild, args: [XpoInkBar,] },],
};
/**
 * Link inside of a `xpo-tab-nav-bar`.
 */
var XpoTabLink = (function () {
    /**
     * @param {?} _xpoTabNavBar
     * @param {?} _elementRef
     */
    function XpoTabLink(_xpoTabNavBar, _elementRef) {
        this._xpoTabNavBar = _xpoTabNavBar;
        this._elementRef = _elementRef;
        this._isActive = false;
    }
    Object.defineProperty(XpoTabLink.prototype, "active", {
        /**
         * Whether the link is active.
         * @return {?}
         */
        get: function () { return this._isActive; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._isActive = value;
            if (value) {
                this._xpoTabNavBar.updateActiveLink(this._elementRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    return XpoTabLink;
}());
XpoTabLink.decorators = [
    { type: Directive, args: [{
                selector: '[xpo-tab-link]',
                host: {
                    'class': 'xpo-tab-link',
                    '[class.xpo-tab-label-active]': 'active'
                }
            },] },
];
/**
 * @nocollapse
 */
XpoTabLink.ctorParameters = function () { return [
    { type: XpoTabNavBar, },
    { type: ElementRef, },
]; };
XpoTabLink.propDecorators = {
    'active': [{ type: Input },],
};
var XpoTabsModule = (function () {
    function XpoTabsModule() {
    }
    return XpoTabsModule;
}());
XpoTabsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    PortalModule,
                    ObserveContentModule,
                    ScrollDispatchModule,
                ],
                // Don't export all components because some are only to be used internally.
                exports: [
                    XpoTabGroup,
                    XpoTabLabel,
                    XpoTab,
                    XpoTabNavBar,
                    XpoTabLink,
                ],
                declarations: [
                    XpoTabGroup,
                    XpoTabLabel,
                    XpoTab,
                    XpoInkBar,
                    XpoTabLabelWrapper,
                    XpoTabNavBar,
                    XpoTabLink,
                    XpoTabBody,
                    XpoTabHeader,
                ],
                providers: [VIEWPORT_RULER_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
XpoTabsModule.ctorParameters = function () { return []; };
/**
 * <xpo-toolbar-row> wraps a row of content within the <xpo-toolbar> component. Each toolbar row is a 'display: flex' container.
 */
var XpoToolbarRow = (function () {
    function XpoToolbarRow() {
    }
    return XpoToolbarRow;
}());
XpoToolbarRow.decorators = [
    { type: Directive, args: [{
                selector: 'xpo-toolbar-row',
                host: {
                    '[class.xpo-toolbar-row]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
XpoToolbarRow.ctorParameters = function () { return []; };
/**
 * <xpo-toolbar is a container for headers, titles, or actions.
 */
var XpoToolbar = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function XpoToolbar(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
    }
    Object.defineProperty(XpoToolbar.prototype, "color", {
        /**
         * The color of the toolbar. Can be primary, accent, or warn.
         * @return {?}
         */
        get: function () {
            return this._color;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateColor(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newColor
     * @return {?}
     */
    XpoToolbar.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    XpoToolbar.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            var /** @type {?} */ element = this._elementRef.nativeElement;
            if (isAdd) {
                this._renderer.addClass(element, "xpo-" + color);
            }
            else {
                this._renderer.removeClass(element, "xpo-" + color);
            }
        }
    };
    return XpoToolbar;
}());
XpoToolbar.decorators = [
    { type: Component, args: [{ selector: 'xpo-toolbar',
                template: "<div class=\"xpo-toolbar-layout\"> <xpo-toolbar-row> <ng-content></ng-content> </xpo-toolbar-row> <ng-content select=\"xpo-toolbar-row\"></ng-content> </div>",
                styles: [".xpo-toolbar{display:flex;flex-direction:column;box-sizing:border-box;width:100%;padding:0 16px}.xpo-toolbar .xpo-toolbar-row{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;width:100%;white-space:nowrap}.xpo-toolbar{min-height:64px}.xpo-toolbar-row{height:64px}@media (max-width:600px){.xpo-toolbar{min-height:56px}.xpo-toolbar-row{height:56px}} /*# sourceMappingURL=toolbar.css.map */ "],
                host: {
                    '[class.xpo-toolbar]': 'true',
                    'role': 'toolbar',
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
            },] },
];
/**
 * @nocollapse
 */
XpoToolbar.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
XpoToolbar.propDecorators = {
    'color': [{ type: Input },],
};
var XpoToolbarModule = (function () {
    function XpoToolbarModule() {
    }
    return XpoToolbarModule;
}());
XpoToolbarModule.decorators = [
    { type: NgModule, args: [{
                imports: [XpoCommonModule],
                exports: [XpoToolbar, XpoToolbarRow, XpoCommonModule],
                declarations: [XpoToolbar, XpoToolbarRow],
            },] },
];
/**
 * @nocollapse
 */
XpoToolbarModule.ctorParameters = function () { return []; };
/**
 * Time in ms to delay before changing the tooltip visibility to hidden
 */
var TOUCHEND_HIDE_DELAY = 1500;
/**
 * Time in ms to throttle repositioning after scroll events.
 */
var SCROLL_THROTTLE_MS = 20;
/**
 * CSS class that will be attached to the overlay panel.
 */
var TOOLTIP_PANEL_CLASS = 'xpo-tooltip-panel';
/**
 * Creates an error to be thrown if the user supplied an invalid tooltip position.
 * @param {?} position
 * @return {?}
 */
function getXpoTooltipInvalidPositionError(position) {
    return Error("Tooltip position \"" + position + "\" is invalid.");
}
/**
 * Injection token that determines the scroll handling while a tooltip is visible.
 */
var XPO_TOOLTIP_SCROLL_STRATEGY = new InjectionToken('xpo-tooltip-scroll-strategy');
/**
 * \@docs-private
 * @param {?} overlay
 * @return {?}
 */
function XPO_TOOLTIP_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
    return function () { return overlay.scrollStrategies.reposition({ scrollThrottle: SCROLL_THROTTLE_MS }); };
}
/**
 * \@docs-private
 */
var XPO_TOOLTIP_SCROLL_STRATEGY_PROVIDER = {
    provide: XPO_TOOLTIP_SCROLL_STRATEGY,
    deps: [Overlay],
    useFactory: XPO_TOOLTIP_SCROLL_STRATEGY_PROVIDER_FACTORY,
};
/**
 * Directive that attaches a xpoerial design tooltip to the host element. Animates the showing and
 * hiding of a tooltip provided position (defaults to below the element).
 *
 * https://material.google.com/components/tooltips.html
 */
var XpoTooltip = (function () {
    /**
     * @param {?} renderer
     * @param {?} _overlay
     * @param {?} _elementRef
     * @param {?} _scrollDispatcher
     * @param {?} _viewContainerRef
     * @param {?} _ngZone
     * @param {?} _platform
     * @param {?} _ariaDescriber
     * @param {?} _scrollStrategy
     * @param {?} _dir
     */
    function XpoTooltip(renderer, _overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, _platform, _ariaDescriber, _scrollStrategy, _dir) {
        var _this = this;
        this._overlay = _overlay;
        this._elementRef = _elementRef;
        this._scrollDispatcher = _scrollDispatcher;
        this._viewContainerRef = _viewContainerRef;
        this._ngZone = _ngZone;
        this._platform = _platform;
        this._ariaDescriber = _ariaDescriber;
        this._scrollStrategy = _scrollStrategy;
        this._dir = _dir;
        this._position = 'below';
        this._disabled = false;
        /**
         * The default delay in ms before showing the tooltip after show is called
         */
        this.showDelay = 0;
        /**
         * The default delay in ms before hiding the tooltip after hide is called
         */
        this.hideDelay = 0;
        this._message = '';
        // The mouse events shouldn't be bound on iOS devices, because
        // they can prevent the first tap from firing its click event.
        if (!_platform.IOS) {
            this._enterListener =
                renderer.listen(_elementRef.nativeElement, 'mouseenter', function () { return _this.show(); });
            this._leaveListener =
                renderer.listen(_elementRef.nativeElement, 'mouseleave', function () { return _this.hide(); });
        }
    }
    Object.defineProperty(XpoTooltip.prototype, "position", {
        /**
         * Allows the user to define the position of the tooltip relative to the parent element
         * @return {?}
         */
        get: function () { return this._position; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value !== this._position) {
                this._position = value;
                // TODO(andrewjs): When the overlay's position can be dynamically changed, do not destroy
                // the tooltip.
                if (this._tooltipInstance) {
                    this._disposeTooltip();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTooltip.prototype, "disabled", {
        /**
         * Disables the display of the tooltip.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
            // If tooltip is disabled, hide immediately.
            if (this._disabled) {
                this.hide(0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTooltip.prototype, "_positionDeprecated", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this._position; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._position = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTooltip.prototype, "message", {
        /**
         * The message to be displayed in the tooltip
         * @return {?}
         */
        get: function () { return this._message; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this._message);
            // If the message is not a string (e.g. number), convert it to a string and trim it.
            this._message = value != null ? ("" + value).trim() : '';
            this._updateTooltipMessage();
            this._ariaDescriber.describe(this._elementRef.nativeElement, this.message);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(XpoTooltip.prototype, "tooltipClass", {
        /**
         * Classes to be passed to the tooltip. Supports the same syntax as `ngClass`.
         * @return {?}
         */
        get: function () { return this._tooltipClass; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._tooltipClass = value;
            if (this._tooltipInstance) {
                this._setTooltipClass(this._tooltipClass);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Dispose the tooltip when destroyed.
     * @return {?}
     */
    XpoTooltip.prototype.ngOnDestroy = function () {
        if (this._tooltipInstance) {
            this._disposeTooltip();
        }
        // Clean up the event listeners set in the constructor
        if (!this._platform.IOS) {
            this._enterListener();
            this._leaveListener();
        }
        this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this.message);
    };
    /**
     * Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input
     * @param {?=} delay
     * @return {?}
     */
    XpoTooltip.prototype.show = function (delay$$1) {
        if (delay$$1 === void 0) { delay$$1 = this.showDelay; }
        if (this.disabled || !this.message) {
            return;
        }
        if (!this._tooltipInstance) {
            this._createTooltip();
        }
        this._setTooltipClass(this._tooltipClass);
        this._updateTooltipMessage(); /** @type {?} */
        ((this._tooltipInstance)).show(this._position, delay$$1);
    };
    /**
     * Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input
     * @param {?=} delay
     * @return {?}
     */
    XpoTooltip.prototype.hide = function (delay$$1) {
        if (delay$$1 === void 0) { delay$$1 = this.hideDelay; }
        if (this._tooltipInstance) {
            this._tooltipInstance.hide(delay$$1);
        }
    };
    /**
     * Shows/hides the tooltip
     * @return {?}
     */
    XpoTooltip.prototype.toggle = function () {
        this._isTooltipVisible() ? this.hide() : this.show();
    };
    /**
     * Returns true if the tooltip is currently visible to the user
     * @return {?}
     */
    XpoTooltip.prototype._isTooltipVisible = function () {
        return !!this._tooltipInstance && this._tooltipInstance.isVisible();
    };
    /**
     * Handles the keydown events on the host element.
     * @param {?} e
     * @return {?}
     */
    XpoTooltip.prototype._handleKeydown = function (e) {
        if (this._isTooltipVisible() && e.keyCode === ESCAPE) {
            e.stopPropagation();
            this.hide(0);
        }
    };
    /**
     * Create the tooltip to display
     * @return {?}
     */
    XpoTooltip.prototype._createTooltip = function () {
        var _this = this;
        var /** @type {?} */ overlayRef = this._createOverlay();
        var /** @type {?} */ portal = new ComponentPortal(TooltipComponent, this._viewContainerRef);
        this._tooltipInstance = overlayRef.attach(portal).instance; /** @type {?} */
        ((
        // Dispose the overlay when finished the shown tooltip.
        this._tooltipInstance)).afterHidden().subscribe(function () {
            // Check first if the tooltip has already been removed through this components destroy.
            if (_this._tooltipInstance) {
                _this._disposeTooltip();
            }
        });
    };
    /**
     * Create the overlay config and position strategy
     * @return {?}
     */
    XpoTooltip.prototype._createOverlay = function () {
        var _this = this;
        var /** @type {?} */ origin = this._getOrigin();
        var /** @type {?} */ overlay = this._getOverlayPosition();
        // Create connected position strategy that listens for scroll events to reposition.
        var /** @type {?} */ strategy = this._overlay
            .position()
            .connectedTo(this._elementRef, origin.main, overlay.main)
            .withFallbackPosition(origin.fallback, overlay.fallback);
        strategy.withScrollableContainers(this._scrollDispatcher.getScrollContainers(this._elementRef));
        strategy.onPositionChange.subscribe(function (change) {
            if (_this._tooltipInstance) {
                if (change.scrollableViewProperties.isOverlayClipped && _this._tooltipInstance.isVisible()) {
                    // After position changes occur and the overlay is clipped by
                    // a parent scrollable then close the tooltip.
                    _this.hide(0);
                }
                else {
                    // Otherwise recalculate the origin based on the new position.
                    _this._tooltipInstance._setTransformOrigin(change.connectionPair);
                }
            }
        });
        var /** @type {?} */ config = new OverlayConfig({
            direction: this._dir ? this._dir.value : 'ltr',
            positionStrategy: strategy,
            panelClass: TOOLTIP_PANEL_CLASS,
            scrollStrategy: this._scrollStrategy(),
        });
        this._overlayRef = this._overlay.create(config);
        return this._overlayRef;
    };
    /**
     * Disposes the current tooltip and the overlay it is attached to
     * @return {?}
     */
    XpoTooltip.prototype._disposeTooltip = function () {
        if (this._overlayRef) {
            this._overlayRef.dispose();
            this._overlayRef = null;
        }
        this._tooltipInstance = null;
    };
    /**
     * Returns the origin position and a fallback position based on the user's position preference.
     * The fallback position is the inverse of the origin (e.g. 'below' -> 'above').
     * @return {?}
     */
    XpoTooltip.prototype._getOrigin = function () {
        var /** @type {?} */ isDirectionLtr = !this._dir || this._dir.value == 'ltr';
        var /** @type {?} */ position;
        if (this.position == 'above' || this.position == 'below') {
            position = { originX: 'center', originY: this.position == 'above' ? 'top' : 'bottom' };
        }
        else if (this.position == 'left' ||
            this.position == 'before' && isDirectionLtr ||
            this.position == 'after' && !isDirectionLtr) {
            position = { originX: 'start', originY: 'center' };
        }
        else if (this.position == 'right' ||
            this.position == 'after' && isDirectionLtr ||
            this.position == 'before' && !isDirectionLtr) {
            position = { originX: 'end', originY: 'center' };
        }
        else {
            throw getXpoTooltipInvalidPositionError(this.position);
        }
        var _a = this._invertPosition(position.originX, position.originY), x = _a.x, y = _a.y;
        return {
            main: position,
            fallback: { originX: x, originY: y },
        };
    };
    /**
     * Returns the overlay position and a fallback position based on the user's preference
     * @return {?}
     */
    XpoTooltip.prototype._getOverlayPosition = function () {
        var /** @type {?} */ isLtr = !this._dir || this._dir.value == 'ltr';
        var /** @type {?} */ position;
        if (this.position == 'above') {
            position = { overlayX: 'center', overlayY: 'bottom' };
        }
        else if (this.position == 'below') {
            position = { overlayX: 'center', overlayY: 'top' };
        }
        else if (this.position == 'left' ||
            this.position == 'before' && isLtr ||
            this.position == 'after' && !isLtr) {
            position = { overlayX: 'end', overlayY: 'center' };
        }
        else if (this.position == 'right' ||
            this.position == 'after' && isLtr ||
            this.position == 'before' && !isLtr) {
            position = { overlayX: 'start', overlayY: 'center' };
        }
        else {
            throw getXpoTooltipInvalidPositionError(this.position);
        }
        var _a = this._invertPosition(position.overlayX, position.overlayY), x = _a.x, y = _a.y;
        return {
            main: position,
            fallback: { overlayX: x, overlayY: y },
        };
    };
    /**
     * Updates the tooltip message and repositions the overlay according to the new message length
     * @return {?}
     */
    XpoTooltip.prototype._updateTooltipMessage = function () {
        var _this = this;
        // Must wait for the message to be painted to the tooltip so that the overlay can properly
        // calculate the correct positioning based on the size of the text.
        if (this._tooltipInstance) {
            this._tooltipInstance.message = this.message;
            this._tooltipInstance._markForCheck();
            first$1.call(this._ngZone.onMicrotaskEmpty.asObservable()).subscribe(function () {
                if (_this._tooltipInstance) {
                    ((_this._overlayRef)).updatePosition();
                }
            });
        }
    };
    /**
     * Updates the tooltip class
     * @param {?} tooltipClass
     * @return {?}
     */
    XpoTooltip.prototype._setTooltipClass = function (tooltipClass) {
        if (this._tooltipInstance) {
            this._tooltipInstance.tooltipClass = tooltipClass;
            this._tooltipInstance._markForCheck();
        }
    };
    /**
     * Inverts an overlay position.
     * @param {?} x
     * @param {?} y
     * @return {?}
     */
    XpoTooltip.prototype._invertPosition = function (x, y) {
        if (this.position === 'above' || this.position === 'below') {
            if (y === 'top') {
                y = 'bottom';
            }
            else if (y === 'bottom') {
                y = 'top';
            }
        }
        else {
            if (x === 'end') {
                x = 'start';
            }
            else if (x === 'start') {
                x = 'end';
            }
        }
        return { x: x, y: y };
    };
    return XpoTooltip;
}());
XpoTooltip.decorators = [
    { type: Directive, args: [{
                selector: '[xpo-tooltip], [xpoTooltip]',
                host: {
                    '(longpress)': 'show()',
                    '(focus)': 'show()',
                    '(blur)': 'hide(0)',
                    '(keydown)': '_handleKeydown($event)',
                    '(touchend)': 'hide(' + TOUCHEND_HIDE_DELAY + ')',
                },
                exportAs: 'xpoTooltip',
            },] },
];
/**
 * @nocollapse
 */
XpoTooltip.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: Overlay, },
    { type: ElementRef, },
    { type: ScrollDispatcher, },
    { type: ViewContainerRef, },
    { type: NgZone, },
    { type: Platform, },
    { type: AriaDescriber, },
    { type: undefined, decorators: [{ type: Inject, args: [XPO_TOOLTIP_SCROLL_STRATEGY,] },] },
    { type: Directionality, decorators: [{ type: Optional },] },
]; };
XpoTooltip.propDecorators = {
    'position': [{ type: Input, args: ['xpoTooltipPosition',] },],
    'disabled': [{ type: Input, args: ['xpoTooltipDisabled',] },],
    '_positionDeprecated': [{ type: Input, args: ['tooltip-position',] },],
    'showDelay': [{ type: Input, args: ['xpoTooltipShowDelay',] },],
    'hideDelay': [{ type: Input, args: ['xpoTooltipHideDelay',] },],
    'message': [{ type: Input, args: ['xpoTooltip',] },],
    'tooltipClass': [{ type: Input, args: ['xpoTooltipClass',] },],
};
/**
 * Internal component that wraps the tooltip's content.
 * \@docs-private
 */
var TooltipComponent = (function () {
    /**
     * @param {?} _changeDetectorRef
     */
    function TooltipComponent(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        /**
         * Property watched by the animation framework to show or hide the tooltip
         */
        this._visibility = 'initial';
        /**
         * Whether interactions on the page should close the tooltip
         */
        this._closeOnInteraction = false;
        /**
         * The transform origin used in the animation for showing and hiding the tooltip
         */
        this._transformOrigin = 'bottom';
        /**
         * Subject for notifying that the tooltip has been hidden from the view
         */
        this._onHide = new Subject();
    }
    /**
     * Shows the tooltip with an animation originating from the provided origin
     * @param {?} position Position of the tooltip.
     * @param {?} delay Amount of milliseconds to the delay showing the tooltip.
     * @return {?}
     */
    TooltipComponent.prototype.show = function (position, delay$$1) {
        var _this = this;
        // Cancel the delayed hide if it is scheduled
        if (this._hideTimeoutId) {
            clearTimeout(this._hideTimeoutId);
        }
        // Body interactions should cancel the tooltip if there is a delay in showing.
        this._closeOnInteraction = true;
        this._position = position;
        this._showTimeoutId = setTimeout(function () {
            _this._visibility = 'visible';
            // Mark for check so if any parent component has set the
            // ChangeDetectionStrategy to OnPush it will be checked anyways
            _this._markForCheck();
        }, delay$$1);
    };
    /**
     * Begins the animation to hide the tooltip after the provided delay in ms.
     * @param {?} delay Amount of milliseconds to delay showing the tooltip.
     * @return {?}
     */
    TooltipComponent.prototype.hide = function (delay$$1) {
        var _this = this;
        // Cancel the delayed show if it is scheduled
        if (this._showTimeoutId) {
            clearTimeout(this._showTimeoutId);
        }
        this._hideTimeoutId = setTimeout(function () {
            _this._visibility = 'hidden';
            // Mark for check so if any parent component has set the
            // ChangeDetectionStrategy to OnPush it will be checked anyways
            _this._markForCheck();
        }, delay$$1);
    };
    /**
     * Returns an observable that notifies when the tooltip has been hidden from view.
     * @return {?}
     */
    TooltipComponent.prototype.afterHidden = function () {
        return this._onHide.asObservable();
    };
    /**
     * Whether the tooltip is being displayed.
     * @return {?}
     */
    TooltipComponent.prototype.isVisible = function () {
        return this._visibility === 'visible';
    };
    /**
     * Sets the tooltip transform origin according to the position of the tooltip overlay.
     * @param {?} overlayPosition
     * @return {?}
     */
    TooltipComponent.prototype._setTransformOrigin = function (overlayPosition) {
        var /** @type {?} */ axis = (this._position === 'above' || this._position === 'below') ? 'Y' : 'X';
        var /** @type {?} */ position = axis == 'X' ? overlayPosition.overlayX : overlayPosition.overlayY;
        if (position === 'top' || position === 'bottom') {
            this._transformOrigin = position;
        }
        else if (position === 'start') {
            this._transformOrigin = 'left';
        }
        else if (position === 'end') {
            this._transformOrigin = 'right';
        }
        else {
            throw getXpoTooltipInvalidPositionError(this._position);
        }
    };
    /**
     * @return {?}
     */
    TooltipComponent.prototype._animationStart = function () {
        this._closeOnInteraction = false;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TooltipComponent.prototype._animationDone = function (event) {
        var _this = this;
        var /** @type {?} */ toState = (event.toState);
        if (toState === 'hidden' && !this.isVisible()) {
            this._onHide.next();
        }
        if (toState === 'visible' || toState === 'hidden') {
            // Note: as of Angular 4.3, the animations module seems to fire the `start` callback before
            // the end if animations are disabled. Make this call async to ensure that it still fires
            // at the appropriate time.
            Promise.resolve().then(function () { return _this._closeOnInteraction = true; });
        }
    };
    /**
     * Interactions on the HTML body should close the tooltip immediately as defined in the
     * material design spec.
     * https://material.google.com/components/tooltips.html#tooltips-interaction
     * @return {?}
     */
    TooltipComponent.prototype._handleBodyInteraction = function () {
        if (this._closeOnInteraction) {
            this.hide(0);
        }
    };
    /**
     * Marks that the tooltip needs to be checked in the next change detection run.
     * Mainly used for rendering the initial text before positioning a tooltip, which
     * can be problematic in components with OnPush change detection.
     * @return {?}
     */
    TooltipComponent.prototype._markForCheck = function () {
        this._changeDetectorRef.markForCheck();
    };
    return TooltipComponent;
}());
TooltipComponent.decorators = [
    { type: Component, args: [{ selector: 'xpo-tooltip-component',
                template: "<div class=\"mat-tooltip\" [ngClass]=\"tooltipClass\" [style.transform-origin]=\"_transformOrigin\" [@state]=\"_visibility\" (@state.start)=\"_animationStart()\" (@state.done)=\"_animationDone($event)\"> {{message}} </div> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}::ng-deep .xpo-tooltip-panel{pointer-events:none!important}::ng-deep .mat-tooltip{display:block;padding:5px 7px;position:relative;color:#fff;background-color:#212121}.xpo-tooltip{max-width:250px;margin:14px;padding-right:8px;padding-left:8px;color:#fff;border-radius:2px} /*# sourceMappingURL=tooltip.css.map */ "],
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [
                    trigger('state', [
                        state('initial, void, hidden', style({ transform: 'scale(0)' })),
                        state('visible', style({ transform: 'scale(1)' })),
                        transition('* => visible', animate('150ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
                        transition('* => hidden', animate('150ms cubic-bezier(0.4, 0.0, 1, 1)')),
                    ]),
                ],
                host: {
                    // Forces the element to have a layout in IE and Edge. This fixes issues where the element
                    // won't be rendered if the animations are disabled or there is no web animations polyfill.
                    '[style.zoom]': '_visibility === "visible" ? 1 : null',
                    '(body:click)': 'this._handleBodyInteraction()',
                    'aria-hidden': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
TooltipComponent.ctorParameters = function () { return [
    { type: ChangeDetectorRef, },
]; };
var XpoTooltipModule = (function () {
    function XpoTooltipModule() {
    }
    return XpoTooltipModule;
}());
XpoTooltipModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    OverlayModule,
                    PlatformModule,
                    A11yModule,
                ],
                exports: [XpoTooltip, TooltipComponent],
                declarations: [XpoTooltip, TooltipComponent],
                entryComponents: [TooltipComponent],
                providers: [XPO_TOOLTIP_SCROLL_STRATEGY_PROVIDER, ARIA_DESCRIBER_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
XpoTooltipModule.ctorParameters = function () { return []; };
/* tslint:disable */
var uid = 0;
/**
 * <xpo-upload> is a file upload form control.
 */
var XpoUpload = (function () {
    function XpoUpload() {
        /**
         * The string displayed inside the upload form control.
         */
        this.placeholder = 'Choose a file...';
        /**
         * Label displayed next to form control
         */
        this.label = '';
        /**
         * The MIME types that the upload form control allows.
         */
        this.accept = '*';
        /**
         * The id attribute of the form control that is required to allow multiple upload controls on a single view.  It is set to a random number by default.
         */
        this.id = 'xpo-upload-' + uid++;
    }
    Object.defineProperty(XpoUpload.prototype, "multiple", {
        /**
         * Whether or not the upload form control allows multiple files.
         * @return {?}
         */
        get: function () {
            return this._multiple;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._multiple = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    XpoUpload.prototype.onFileSelect = function () {
        var /** @type {?} */ inputElement = this.inputElementRef.nativeElement;
        var /** @type {?} */ fileCount = inputElement.files.length;
        var /** @type {?} */ formData = new FormData();
        if (fileCount > 0) {
            if (fileCount === 1) {
                this.placeholder = inputElement.files.item(0).name;
            }
            else {
                this.placeholder = fileCount + ' files selected';
            }
            for (var /** @type {?} */ i = 0; i < fileCount; i++) {
                formData.append('file[]', inputElement.files.item(i));
            }
            // to handle an upload without page refresh:
            // this.http
            // .post('https://api,xpo.url', formData);
            // subscribe to observable to listen for response
        }
    };
    return XpoUpload;
}());
XpoUpload.decorators = [
    { type: Component, args: [{ selector: 'xpo-upload',
                template: "<xpo-form-group [labelPosition]=\"labelPosition\" class=\"xpo-form-group__upload\"> <input type=\"file\" class=\"upload__input\" [attr.name]=\"id\" [attr.id]=\"id\" [multiple]=\"multiple\" [accept]=\"accept\" #fileInput /> <button class=\"upload__filename\" tabindex=\"-1\"> {{ placeholder }} </button> <label class=\"upload__label\" [attr.for]=\"id\"> {{ label }} </label> <ng-content></ng-content> </xpo-form-group> ",
                styles: ["@keyframes fade-in{from{opacity:.2}to{opacity:1}}@keyframes spin-it{from{transform:rotate(0)}to{transform:rotate(359deg)}}.cf:after,.cf:before,.clearfix:after,.clearfix:before{display:table;content:\" \"}.cf:after,.clearfix:after{clear:both}.sr-only{width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;position:absolute;clip:rect(0 0 0 0);border:0}:host{display:flex}:host ::ng-deep .xpo-form-group{width:100%;overflow:hidden}.upload__input{position:absolute;top:0;right:0;cursor:pointer;font-size:60px;opacity:0}.upload__input:focus~.upload__filename{border-bottom-color:#0091ea}.upload__input:focus~.upload__label{color:#0091ea}.upload__filename{display:inline-block;flex:1;padding:6px 0;color:#858585;text-align:left;border:none;border-bottom:1px solid #dfdfdf}.upload__filename:hover{color:#1c1e1c}:host-context(.xpo-internal) .upload__input+.upload__filename{padding-bottom:3px}:host-context(.xpo-external) .upload__input+.upload__filename{padding-bottom:10px;font-size:1.1667rem} /*# sourceMappingURL=upload.css.map */ "],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            },] },
];
/**
 * @nocollapse
 */
XpoUpload.ctorParameters = function () { return []; };
XpoUpload.propDecorators = {
    'multiple': [{ type: Input },],
    'placeholder': [{ type: Input },],
    'label': [{ type: Input },],
    'labelPosition': [{ type: Input },],
    'accept': [{ type: Input },],
    'id': [{ type: Input },],
    'inputElementRef': [{ type: ViewChild, args: ['fileInput',] },],
};
var XpoUploadModule = (function () {
    function XpoUploadModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    XpoUploadModule.forRoot = function () {
        return {
            ngModule: XpoUploadModule,
        };
    };
    return XpoUploadModule;
}());
XpoUploadModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    XpoFormModule
                ],
                exports: [XpoUpload],
                declarations: [XpoUpload],
            },] },
];
/**
 * @nocollapse
 */
XpoUploadModule.ctorParameters = function () { return []; };
/* tslint:disable */
var packageModules = [
    OverlayModule,
    PortalModule,
    RtlModule,
    StyleModule,
    A11yModule,
    PlatformModule,
    XpoCoreModule,
    ObserveContentModule,
    XpoActionBarModule,
    XpoExampleModule,
    XpoBreadCrumbModule,
    XpoButtonModule,
    XpoButtonToggleModule,
    XpoExternalAppModule,
    XpoFooterModule,
    XpoHeaderModule,
    XpoHeaderExtModule,
    XpoHeaderIntModule,
    XpoImgModule,
    XpoInternalAppModule,
    XpoMainModule,
    XpoMenuBarModule,
    XpoIconModule,
    XpoAddressModule,
    XpoAutocompleteModule,
    XpoBadgeModule,
    XpoInputModule,
    XpoFormModule,
    XpoCardModule,
    XpoCheckBoxModule,
    XpoChipsModule,
    XpoConfirmDialogModule,
    XpoContentModule,
    XpoDatepickerModule,
    XpoDialogModule,
    XpoHttpErrorModule,
    XpoLoaderModule,
    XpoMenuModule,
    XpoMeterModule,
    XpoPaginationModule,
    XpoPopOverModule,
    XpoProgressBarModule,
    XpoProgressSpinnerModule,
    XpoRadioModule,
    XpoSectionModule,
    XpoSelectModule,
    XpoSliderModule,
    XpoSlideToggleModule,
    XpoSnackBarModule,
    XpoTabsModule,
    XpoToolbarModule,
    XpoTooltipModule,
    XpoUploadModule
];
/**
 * @deprecated
 */
var XpoCommonLibrary = (function () {
    function XpoCommonLibrary() {
    }
    return XpoCommonLibrary;
}());
XpoCommonLibrary.decorators = [
    { type: NgModule, args: [{
                imports: packageModules,
                exports: packageModules,
            },] },
];
/**
 * @nocollapse
 */
XpoCommonLibrary.ctorParameters = function () { return []; };
/**
 * @module
 * @description
 * Entry point for all public APIs of xpo-builder.
 */
/* tslint:disable */
/* tslint:enable */
/**
 * Generated bundle index. Do not edit.
 */
export { ObserveContentModule, ObserveContent, XpoOptionModule, XpoOption, XpoOptionSelectionChange, XpoError, Dir$1 as Dir, Directionality, BidiModule, Portal, BasePortalHost, ComponentPortal, TemplatePortal, PortalHostDirective, TemplatePortalDirective, PortalModule, DomPortalHost, GestureConfig, LiveAnnouncer, LIVE_ANNOUNCER_ELEMENT_TOKEN, LIVE_ANNOUNCER_PROVIDER, InteractivityChecker, isFakeMousedownFromScreenReader, A11yModule, UniqueSelectionDispatcher, UNIQUE_SELECTION_DISPATCHER_PROVIDER, XpoLineModule, XpoLine, XpoLineSetter, coerceBooleanProperty, coerceNumberProperty, XpoCommonModule, XpoCoreModule, PlatformModule, Platform, getSupportedInputTypes, OVERLAY_PROVIDERS, OverlayModule, Overlay, OverlayContainer, FullscreenOverlayContainer, OverlayRef, OverlayState, ConnectedOverlayDirective, OverlayOrigin, ViewportRuler, GlobalPositionStrategy, ConnectedPositionStrategy, ConnectionPositionPair, ScrollableViewProperties, ConnectedOverlayPositionChange, Scrollable, ScrollDispatcher, ScrollStrategyOptions, RepositionScrollStrategy, CloseScrollStrategy, NoopScrollStrategy, BlockScrollStrategy, ScrollDispatchModule, OverlayConfig, XpoRipple, XPO_RIPPLE_GLOBAL_OPTIONS, RippleRef, RippleState, RIPPLE_FADE_IN_DURATION, RIPPLE_FADE_OUT_DURATION, XpoRippleModule, SelectionModel, SelectionChange, FocusTrap, FocusTrapFactory, FocusTrapDeprecatedDirective, FocusTrapDirective, StyleModule, TOUCH_BUFFER_MS, FocusOriginMonitor, CdkMonitorFocus, FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY, FOCUS_ORIGIN_MONITOR_PROVIDER, applyCssTransform, UP_ARROW, DOWN_ARROW, RIGHT_ARROW, LEFT_ARROW, PAGE_UP, PAGE_DOWN, HOME, END, ENTER, SPACE, TAB, ESCAPE, BACKSPACE, DELETE, AnimationCurves, AnimationDurations, XpoSelectionModule, XpoPseudoCheckbox, NativeDateModule, XpoNativeDateModule, DateAdapter, XPO_DATE_FORMATS, NativeDateAdapter, XPO_NATIVE_DATE_FORMATS, XpoMenuingModule, XpoMenuEntry, XpoMenuResolver, RxChain, FinallyBrand, CatchBrand, DoBrand, MapBrand, FilterBrand, ShareBrand, FirstBrand, SwitchMapBrand, StartWithBrand, DebounceTimeBrand, AuditTimeBrand, TakeUntilBrand, DelayBrand, finallyOperator, catchOperator, doOperator, map$1 as map, filter$1 as filter, share$1 as share, first$1 as first, switchMap$1 as switchMap, startWith$1 as startWith, debounceTime$1 as debounceTime, auditTime$1 as auditTime, takeUntil$1 as takeUntil, delay$1 as delay, XpoConfigService, XpoPermissionService, XpoCommonLibrary, XpoActionBarModule, XpoActionBar, XpoExampleModule, XPOExample, XpoBreadCrumbModule, XpoBreadCrumb, BreadCrumbService, XpoButtonModule, XpoButtonCssMatStyler, XpoRaisedButtonCssMatStyler, XpoIconButtonCssMatStyler, XpoFabCssMatStyler, XpoMiniFabCssMatStyler, XpoButtonBase, _XpoButtonMixinBase, XpoButton, XpoAnchor, XpoButtonToggleModule, XPO_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR, XpoButtonToggleChange, XpoButtonToggleGroup, XpoButtonToggleGroupMultiple, XpoButtonToggle, XpoExternalAppModule, XpoExternalApp, XpoFooterModule, XpoFooter, XpoFooterMenu, XpoHeaderModule, XpoHeader, XpoHeaderMenu, XpoHeaderSubMenu, XpoHeaderExtModule, XpoHeaderExt, XpoHeaderExtCol, XpoHeaderExtRow, XpoHeaderIntModule, XpoHeaderInt, XpoHeaderIntCol, XpoHeaderIntRow, XpoImgModule, XpoImg, XpoInternalAppModule, XpoInternalApp, XpoMainModule, XpoMain, XpoMenuBarModule, XpoMenuBar, XpoIconModule, XpoIcon, XpoAddressModule, XPOAddress, XpoAutocompleteModule, XpoAutocomplete, AUTOCOMPLETE_OPTION_HEIGHT, AUTOCOMPLETE_PANEL_HEIGHT, XPO_AUTOCOMPLETE_VALUE_ACCESSOR, XpoAutocompleteTrigger, XpoBadgeModule, XpoBadge, XpoInputModule, XpoTextareaAutosize, XpoPlaceholder, XpoHint, XpoErrorDirective, XpoPrefix, XpoSuffix, XpoInputDirective, XpoInputContainer, getXpoInputContainerPlaceholderConflictError, getXpoInputContainerUnsupportedTypeError, getXpoInputContainerDuplicatedHintError, getXpoInputContainerMissingXpoInputError, XpoFormModule, XpoFormGroup, XpoForm, XpoCardModule, XpoCard, XpoCardTitleGroup, XpoCardHeader, CardActionsDirective, CardAvatarDirective, CardContentDirective, CardFooterDirective, CardImageDirective, CardLgImageDirective, CardXpoImageDirective, CardSmImageDirective, CardHeaderSubtitleDirective, CardHeaderTitleDirective, CardXlImageDirective, CardHeaderActionsDirective, XpoCheckBoxModule, XPO_CHECKBOX_CONTROL_VALUE_ACCESSOR, TransitionCheckState, XpoCheckboxChange, XpoCheckBox, XpoCheckboxGroup, XpoChipsModule, XpoChipList, XpoChip, XpoConfirmDialogModule, XpoConfirmDialog, XpoContentModule, XpoContent, XpoDatepickerModule, XpoCalendar, XpoCalendarCell, XpoCalendarBody, XpoDatepickerContent, XpoDatepicker, XPO_DATEPICKER_VALUE_ACCESSOR, XPO_DATEPICKER_VALIDATORS, XpoDatepickerInput, XpoDatepickerIntl, XpoDatepickerToggle, XpoMonthView, XpoYearView, XpoDialogModule, XPO_DIALOG_DATA, XpoDialog, throwXpoDialogContentAlreadyAttachedError, XpoDialogContainer, XpoDialogClose, XpoDialogHeaderActions, XpoDialogHeaderTitle, XpoDialogContent, XpoDialogActions, XpoDialogConfig, XpoDialogHeader, XpoDialogRef, XpoHttpErrorModule, XpoHttpError, XpoLoaderModule, XpoLoader, XpoMenuModule, fadeInItems, transformMenu, XpoMenu, XpoMenuItem, XpoMenuTrigger, XpoMeterModule, XpoMeter, XpoPagination, PaginationService, PaginationControlsDirective, PaginatePipe, XpoPaginationModule, XpoPopOverModule, XpoPopOver, XpoPopOverExample, PopoverActivationMode, XpoProgressBarModule, XpoProgressBar, XpoProgressSpinnerModule, PROGRESS_SPINNER_STROKE_WIDTH, XpoProgressSpinnerCssMatStyler, XpoProgressSpinner, XpoSpinner, XpoRadioModule, XPO_RADIO_GROUP_CONTROL_VALUE_ACCESSOR, XpoRadioChange, XpoRadioGroup, XpoRadioButton, XpoSectionModule, XPOSection, XpoSelectModule, fadeInContent, transformPanel, SELECT_ITEM_HEIGHT, SELECT_PANEL_MAX_HEIGHT, SELECT_MAX_OPTIONS_DISPLAYED, SELECT_TRIGGER_HEIGHT, SELECT_OPTION_HEIGHT_ADJUSTMENT, SELECT_PANEL_PADDING_X, SELECT_PANEL_PADDING_Y, SELECT_PANEL_VIEWPORT_PADDING, TIME_TO_RESET_SEARCH_STRING, ALPHANUMERIC_RANGE_START, ALPHANUMERIC_RANGE_END, NUMERIC_KEYPAD_RANGE_START, NUMERIC_KEYPAD_RANGE_END, XpoSelectChange, XpoSelectBase, _XpoSelectMixinBase, XpoSelectErrorDirective, XpoSelect, XpoSliderModule, XPO_SLIDER_VALUE_ACCESSOR, XpoSliderChange, XpoSliderBase, _XpoSliderMixinBase, XpoSlider, SliderRenderer, XpoSlideToggleModule, XPO_SLIDE_TOGGLE_VALUE_ACCESSOR, XpoSlideToggleChange, XpoSlideToggle, XpoSlideToggleGroup, XpoSnackBarModule, XpoSnackBar, SHOW_ANIMATION, HIDE_ANIMATION, XpoSnackBarContainer, XPO_SNACK_BAR_DATA, XpoSnackBarConfig, XpoSnackBarRef, SimpleSnackBar, XpoTabsModule, XpoInkBar, XpoTabBody, XpoTabHeader, XpoTabLabelWrapper, XpoTab, XpoTabLabel, XpoTabChangeEvent, XpoTabGroup, XpoToolbarModule, XpoToolbarRow, XpoToolbar, XpoTooltipModule, TOUCHEND_HIDE_DELAY, SCROLL_THROTTLE_MS, TOOLTIP_PANEL_CLASS, getXpoTooltipInvalidPositionError, XPO_TOOLTIP_SCROLL_STRATEGY, XPO_TOOLTIP_SCROLL_STRATEGY_PROVIDER_FACTORY, XPO_TOOLTIP_SCROLL_STRATEGY_PROVIDER, XpoTooltip, TooltipComponent, XpoUploadModule, XpoUpload, XpoActionBarColumn as ɵx, XpoActionBarRow as ɵw, ARIA_DESCRIBER_PROVIDER as ɵv, ARIA_DESCRIBER_PROVIDER_FACTORY as ɵu, AriaDescriber as ɵt, LIVE_ANNOUNCER_PROVIDER_FACTORY as ɵm, DIR_DOCUMENT as ɵe, mixinDisabled as ɵr, UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY as ɵn, XpoMutationObserverFactory as ɵa, XpoOptgroup as ɵd, XpoOptgroupBase as ɵb, _XpoOptgroupMixinBase as ɵc, OVERLAY_CONTAINER_PROVIDER as ɵg, OVERLAY_CONTAINER_PROVIDER_FACTORY as ɵf, OverlayPositionBuilder as ɵq, VIEWPORT_RULER_PROVIDER as ɵi, VIEWPORT_RULER_PROVIDER_FACTORY as ɵh, SCROLL_DISPATCHER_PROVIDER as ɵk, SCROLL_DISPATCHER_PROVIDER_FACTORY as ɵj, RippleRenderer as ɵl, Dir as ɵo, RtlModule as ɵp, DEFAULT_STYLES as ɵba, DEFAULT_TEMPLATE as ɵz, XpoTabLink as ɵbc, XpoTabNavBar as ɵbb };



//////////////////
// WEBPACK FOOTER
// /ng-app/node_modules/@xpo/common/@xpo/xpo-common.es5.js
// module id = ../../../../@xpo/common/@xpo/xpo-common.es5.js
// module chunks = vendor